
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7d0e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7d0e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fRJfg", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $b8cee6fe3ee0ad74$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $b8cee6fe3ee0ad74$var$global; // eslint-disable-line no-undef

});

parcelRegister("fdFIW", function(module, exports) {
var $b1486f6a52d4b2e1$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $b1486f6a52d4b2e1$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("8csIg", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("as1c7"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("as1c7", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("e88d0", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");

var $6OFbT = parcelRequire("6OFbT");

var $5eEKu = parcelRequire("5eEKu");

var $4ELbO = parcelRequire("4ELbO");

var $bKCrG = parcelRequire("bKCrG");
var $a4982e23007349fb$var$PROTOTYPE = 'prototype';
var $a4982e23007349fb$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a4982e23007349fb$var$$export.F;
    var IS_GLOBAL = type & $a4982e23007349fb$var$$export.G;
    var IS_STATIC = type & $a4982e23007349fb$var$$export.S;
    var IS_PROTO = type & $a4982e23007349fb$var$$export.P;
    var IS_BIND = type & $a4982e23007349fb$var$$export.B;
    var target = IS_GLOBAL ? $fRJfg : IS_STATIC ? $fRJfg[name] || ($fRJfg[name] = {}) : ($fRJfg[name] || {})[$a4982e23007349fb$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $6OFbT : $6OFbT[name] || ($6OFbT[name] = {});
    var expProto = exports[$a4982e23007349fb$var$PROTOTYPE] || (exports[$a4982e23007349fb$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $bKCrG(out, $fRJfg) : IS_PROTO && typeof out == 'function' ? $bKCrG(Function.call, out) : out;
        // extend global
        if (target) $4ELbO(target, key, out, type & $a4982e23007349fb$var$$export.U);
        // export
        if (exports[key] != out) $5eEKu(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$fRJfg.core = $6OFbT;
// type bitmap
$a4982e23007349fb$var$$export.F = 1; // forced
$a4982e23007349fb$var$$export.G = 2; // global
$a4982e23007349fb$var$$export.S = 4; // static
$a4982e23007349fb$var$$export.P = 8; // proto
$a4982e23007349fb$var$$export.B = 16; // bind
$a4982e23007349fb$var$$export.W = 32; // wrap
$a4982e23007349fb$var$$export.U = 64; // safe
$a4982e23007349fb$var$$export.R = 128; // real proto method for `library`
module.exports = $a4982e23007349fb$var$$export;

});
parcelRegister("6OFbT", function(module, exports) {
var $4f675d37c2042929$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $4f675d37c2042929$var$core; // eslint-disable-line no-undef

});

parcelRegister("5eEKu", function(module, exports) {

var $hjnWf = parcelRequire("hjnWf");

var $3PFaa = parcelRequire("3PFaa");

module.exports = (parcelRequire("8csIg")) ? function(object, key, value) {
    return $hjnWf.f(object, key, $3PFaa(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("hjnWf", function(module, exports) {

$parcel$export(module.exports, "f", () => $c9a6c7b8df7a4999$export$2d1720544b23b823, (v) => $c9a6c7b8df7a4999$export$2d1720544b23b823 = v);
var $c9a6c7b8df7a4999$export$2d1720544b23b823;

var $cYx5q = parcelRequire("cYx5q");

var $6g3mu = parcelRequire("6g3mu");

var $h0Sfn = parcelRequire("h0Sfn");
var $c9a6c7b8df7a4999$var$dP = Object.defineProperty;

$c9a6c7b8df7a4999$export$2d1720544b23b823 = (parcelRequire("8csIg")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $cYx5q(O);
    P = $h0Sfn(P, true);
    $cYx5q(Attributes);
    if ($6g3mu) try {
        return $c9a6c7b8df7a4999$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("cYx5q", function(module, exports) {

var $a8jEg = parcelRequire("a8jEg");
module.exports = function(it) {
    if (!$a8jEg(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("a8jEg", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("6g3mu", function(module, exports) {



module.exports = !(parcelRequire("8csIg")) && !(parcelRequire("as1c7"))(function() {
    return Object.defineProperty((parcelRequire("87sFj"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("87sFj", function(module, exports) {

var $a8jEg = parcelRequire("a8jEg");

var $fRJfg = parcelRequire("fRJfg");
var $5e9536873d66f7c6$require$document = $fRJfg.document;
// typeof document.createElement is 'object' in old IE
var $5e9536873d66f7c6$var$is = $a8jEg($5e9536873d66f7c6$require$document) && $a8jEg($5e9536873d66f7c6$require$document.createElement);
module.exports = function(it) {
    return $5e9536873d66f7c6$var$is ? $5e9536873d66f7c6$require$document.createElement(it) : {};
};

});


parcelRegister("h0Sfn", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $a8jEg = parcelRequire("a8jEg");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$a8jEg(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$a8jEg(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$a8jEg(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$a8jEg(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("3PFaa", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("4ELbO", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");

var $5eEKu = parcelRequire("5eEKu");

var $fdFIW = parcelRequire("fdFIW");

var $363f80b4446d1f46$var$SRC = (parcelRequire("5DFYi"))('src');

var $9nyNe = parcelRequire("9nyNe");
var $363f80b4446d1f46$var$TO_STRING = 'toString';
var $363f80b4446d1f46$var$TPL = ('' + $9nyNe).split($363f80b4446d1f46$var$TO_STRING);

(parcelRequire("6OFbT")).inspectSource = function(it) {
    return $9nyNe.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $fdFIW(val, 'name') || $5eEKu(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $fdFIW(val, $363f80b4446d1f46$var$SRC) || $5eEKu(val, $363f80b4446d1f46$var$SRC, O[key] ? '' + O[key] : $363f80b4446d1f46$var$TPL.join(String(key)));
    if (O === $fRJfg) O[key] = val;
    else if (!safe) {
        delete O[key];
        $5eEKu(O, key, val);
    } else if (O[key]) O[key] = val;
    else $5eEKu(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $363f80b4446d1f46$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$363f80b4446d1f46$var$SRC] || $9nyNe.call(this);
});

});
parcelRegister("5DFYi", function(module, exports) {
var $41b126ee4501092b$var$id = 0;
var $41b126ee4501092b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$41b126ee4501092b$var$id + $41b126ee4501092b$var$px).toString(36));
};

});

parcelRegister("9nyNe", function(module, exports) {

module.exports = (parcelRequire("lXpxg"))('native-function-to-string', Function.toString);

});
parcelRegister("lXpxg", function(module, exports) {

var $6OFbT = parcelRequire("6OFbT");

var $fRJfg = parcelRequire("fRJfg");
var $ffc2ea7975288e5f$var$SHARED = '__core-js_shared__';
var $ffc2ea7975288e5f$var$store = $fRJfg[$ffc2ea7975288e5f$var$SHARED] || ($fRJfg[$ffc2ea7975288e5f$var$SHARED] = {});

(module.exports = function(key, value) {
    return $ffc2ea7975288e5f$var$store[key] || ($ffc2ea7975288e5f$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $6OFbT.version,
    mode: (parcelRequire("8N1Ra")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("8N1Ra", function(module, exports) {
module.exports = false;

});




parcelRegister("bKCrG", function(module, exports) {
// optional / simple context binding

var $3fVrL = parcelRequire("3fVrL");
module.exports = function(fn, that, length) {
    $3fVrL(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("3fVrL", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("7jOVX", function(module, exports) {

var $hjnWf = parcelRequire("hjnWf");
var $5541d127027a2cff$require$def = $hjnWf.f;

var $fdFIW = parcelRequire("fdFIW");

var $5541d127027a2cff$var$TAG = (parcelRequire("fjK8l"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$fdFIW(it = stat ? it : it.prototype, $5541d127027a2cff$var$TAG)) $5541d127027a2cff$require$def(it, $5541d127027a2cff$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("fjK8l", function(module, exports) {

var $b26c6a8211fcc82d$var$store = (parcelRequire("lXpxg"))('wks');

var $5DFYi = parcelRequire("5DFYi");

var $fRJfg = parcelRequire("fRJfg");
var $b26c6a8211fcc82d$require$Symbol = $fRJfg.Symbol;
var $b26c6a8211fcc82d$var$USE_SYMBOL = typeof $b26c6a8211fcc82d$require$Symbol == 'function';
var $b26c6a8211fcc82d$var$$exports = module.exports = function(name) {
    return $b26c6a8211fcc82d$var$store[name] || ($b26c6a8211fcc82d$var$store[name] = $b26c6a8211fcc82d$var$USE_SYMBOL && $b26c6a8211fcc82d$require$Symbol[name] || ($b26c6a8211fcc82d$var$USE_SYMBOL ? $b26c6a8211fcc82d$require$Symbol : $5DFYi)('Symbol.' + name));
};
$b26c6a8211fcc82d$var$$exports.store = $b26c6a8211fcc82d$var$store;

});


parcelRegister("afVtj", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");

var $6OFbT = parcelRequire("6OFbT");

var $8N1Ra = parcelRequire("8N1Ra");

var $gXnT8 = parcelRequire("gXnT8");

var $hjnWf = parcelRequire("hjnWf");
var $7777e2cafb4dea61$require$defineProperty = $hjnWf.f;
module.exports = function(name) {
    var $Symbol = $6OFbT.Symbol || ($6OFbT.Symbol = $8N1Ra ? {} : $fRJfg.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $7777e2cafb4dea61$require$defineProperty($Symbol, name, {
        value: $gXnT8.f(name)
    });
};

});
parcelRegister("gXnT8", function(module, exports) {

$parcel$export(module.exports, "f", () => $c584afc438ab1a71$export$2d1720544b23b823, (v) => $c584afc438ab1a71$export$2d1720544b23b823 = v);
var $c584afc438ab1a71$export$2d1720544b23b823;

$c584afc438ab1a71$export$2d1720544b23b823 = (parcelRequire("fjK8l"));

});


parcelRegister("3yrVW", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $gyczm = parcelRequire("gyczm");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $gyczm(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("gyczm", function(module, exports) {
var $c0c9924cdbb97275$var$toString = {}.toString;
module.exports = function(it) {
    return $c0c9924cdbb97275$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("6zju3", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $h1IuT = parcelRequire("h1IuT");

var $6oAU6 = parcelRequire("6oAU6");

var $79CKs = parcelRequire("79CKs");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $h1IuT($this);
        var length = $6oAU6(O.length);
        var index = $79CKs(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("h1IuT", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $3yrVW = parcelRequire("3yrVW");

var $iedom = parcelRequire("iedom");
module.exports = function(it) {
    return $3yrVW($iedom(it));
};

});
parcelRegister("iedom", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("6oAU6", function(module, exports) {
// 7.1.15 ToLength

var $8KZEi = parcelRequire("8KZEi");
var $4a819c4abaf54486$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $4a819c4abaf54486$var$min($8KZEi(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("8KZEi", function(module, exports) {
// 7.1.4 ToInteger
var $660270c8146f8dae$var$ceil = Math.ceil;
var $660270c8146f8dae$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $660270c8146f8dae$var$floor : $660270c8146f8dae$var$ceil)(it);
};

});


parcelRegister("79CKs", function(module, exports) {

var $8KZEi = parcelRequire("8KZEi");
var $53576e43ebc2d331$var$max = Math.max;
var $53576e43ebc2d331$var$min = Math.min;
module.exports = function(index, length) {
    index = $8KZEi(index);
    return index < 0 ? $53576e43ebc2d331$var$max(index + length, 0) : $53576e43ebc2d331$var$min(index, length);
};

});


parcelRegister("9JDyl", function(module, exports) {

var $7166ff6be4a41657$var$shared = (parcelRequire("lXpxg"))('keys');

var $5DFYi = parcelRequire("5DFYi");
module.exports = function(key) {
    return $7166ff6be4a41657$var$shared[key] || ($7166ff6be4a41657$var$shared[key] = $5DFYi(key));
};

});

parcelRegister("9FDaI", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});

parcelRegister("jHwil", function(module, exports) {

$parcel$export(module.exports, "f", () => $e57b1595c747b67f$export$2d1720544b23b823, (v) => $e57b1595c747b67f$export$2d1720544b23b823 = v);
var $e57b1595c747b67f$export$2d1720544b23b823;
$e57b1595c747b67f$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("k2l0Y", function(module, exports) {
// 7.2.2 IsArray(argument)

var $gyczm = parcelRequire("gyczm");
module.exports = Array.isArray || function isArray(arg) {
    return $gyczm(arg) == 'Array';
};

});

parcelRegister("60LZ2", function(module, exports) {
// 7.1.13 ToObject(argument)

var $iedom = parcelRequire("iedom");
module.exports = function(it) {
    return Object($iedom(it));
};

});

parcelRegister("9lrow", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $cYx5q = parcelRequire("cYx5q");

var $2Ss6l = parcelRequire("2Ss6l");

var $9FDaI = parcelRequire("9FDaI");

var $6cdb532f62512838$var$IE_PROTO = (parcelRequire("9JDyl"))('IE_PROTO');
var $6cdb532f62512838$var$Empty = function() {};
var $6cdb532f62512838$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6cdb532f62512838$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("87sFj"))('iframe');
    var i = $9FDaI.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("fWBj0")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $6cdb532f62512838$var$createDict = iframeDocument.F;
    while(i--)delete $6cdb532f62512838$var$createDict[$6cdb532f62512838$var$PROTOTYPE][$9FDaI[i]];
    return $6cdb532f62512838$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6cdb532f62512838$var$Empty[$6cdb532f62512838$var$PROTOTYPE] = $cYx5q(O);
        result = new $6cdb532f62512838$var$Empty();
        $6cdb532f62512838$var$Empty[$6cdb532f62512838$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6cdb532f62512838$var$IE_PROTO] = O;
    } else result = $6cdb532f62512838$var$createDict();
    return Properties === undefined ? result : $2Ss6l(result, Properties);
};

});
parcelRegister("2Ss6l", function(module, exports) {

var $hjnWf = parcelRequire("hjnWf");

var $cYx5q = parcelRequire("cYx5q");

var $gHcyI = parcelRequire("gHcyI");

module.exports = (parcelRequire("8csIg")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $cYx5q(O);
    var keys = $gHcyI(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$hjnWf.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("gHcyI", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $gojI8 = parcelRequire("gojI8");

var $9FDaI = parcelRequire("9FDaI");
module.exports = Object.keys || function keys(O) {
    return $gojI8(O, $9FDaI);
};

});
parcelRegister("gojI8", function(module, exports) {

var $fdFIW = parcelRequire("fdFIW");

var $h1IuT = parcelRequire("h1IuT");

var $beee2d6972fa4e6b$var$arrayIndexOf = (parcelRequire("6zju3"))(false);

var $beee2d6972fa4e6b$var$IE_PROTO = (parcelRequire("9JDyl"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $h1IuT(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $beee2d6972fa4e6b$var$IE_PROTO) $fdFIW(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($fdFIW(O, key = names[i++])) ~$beee2d6972fa4e6b$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});



parcelRegister("fWBj0", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");
var $b9b935e52efb50c2$require$document = $fRJfg.document;
module.exports = $b9b935e52efb50c2$require$document && $b9b935e52efb50c2$require$document.documentElement;

});


parcelRegister("linom", function(module, exports) {

$parcel$export(module.exports, "f", () => $f80d6c917414f800$export$2d1720544b23b823, (v) => $f80d6c917414f800$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $f80d6c917414f800$export$2d1720544b23b823;

var $h1IuT = parcelRequire("h1IuT");

var $1UujU = parcelRequire("1UujU");
var $f80d6c917414f800$require$gOPN = $1UujU.f;
var $f80d6c917414f800$var$toString = {}.toString;
var $f80d6c917414f800$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $f80d6c917414f800$var$getWindowNames = function(it) {
    try {
        return $f80d6c917414f800$require$gOPN(it);
    } catch (e) {
        return $f80d6c917414f800$var$windowNames.slice();
    }
};
$f80d6c917414f800$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $f80d6c917414f800$var$windowNames && $f80d6c917414f800$var$toString.call(it) == '[object Window]' ? $f80d6c917414f800$var$getWindowNames(it) : $f80d6c917414f800$require$gOPN($h1IuT(it));
};

});
parcelRegister("1UujU", function(module, exports) {

$parcel$export(module.exports, "f", () => $16428a5aa3e77c26$export$2d1720544b23b823, (v) => $16428a5aa3e77c26$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $16428a5aa3e77c26$export$2d1720544b23b823;

var $gojI8 = parcelRequire("gojI8");

var $16428a5aa3e77c26$var$hiddenKeys = (parcelRequire("9FDaI")).concat('length', 'prototype');
$16428a5aa3e77c26$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $gojI8(O, $16428a5aa3e77c26$var$hiddenKeys);
};

});


parcelRegister("6Vt7w", function(module, exports) {

$parcel$export(module.exports, "f", () => $50aea7a822119f27$export$2d1720544b23b823, (v) => $50aea7a822119f27$export$2d1720544b23b823 = v);
var $50aea7a822119f27$export$2d1720544b23b823;

var $jHwil = parcelRequire("jHwil");

var $3PFaa = parcelRequire("3PFaa");

var $h1IuT = parcelRequire("h1IuT");

var $h0Sfn = parcelRequire("h0Sfn");

var $fdFIW = parcelRequire("fdFIW");

var $6g3mu = parcelRequire("6g3mu");
var $50aea7a822119f27$var$gOPD = Object.getOwnPropertyDescriptor;

$50aea7a822119f27$export$2d1720544b23b823 = (parcelRequire("8csIg")) ? $50aea7a822119f27$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $h1IuT(O);
    P = $h0Sfn(P, true);
    if ($6g3mu) try {
        return $50aea7a822119f27$var$gOPD(O, P);
    } catch (e) {}
    if ($fdFIW(O, P)) return $3PFaa(!$jHwil.f.call(O, P), O[P]);
};

});

parcelRegister("4jrsJ", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $e88d0 = parcelRequire("e88d0");

var $6OFbT = parcelRequire("6OFbT");

var $as1c7 = parcelRequire("as1c7");
module.exports = function(KEY, exec) {
    var fn = ($6OFbT.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $e88d0($e88d0.S + $e88d0.F * $as1c7(function() {
        fn(1);
    }), 'Object', exp);
};

});

parcelRegister("eojdB", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $fdFIW = parcelRequire("fdFIW");

var $60LZ2 = parcelRequire("60LZ2");

var $a7a236f58eeb7f86$var$IE_PROTO = (parcelRequire("9JDyl"))('IE_PROTO');
var $a7a236f58eeb7f86$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $60LZ2(O);
    if ($fdFIW(O, $a7a236f58eeb7f86$var$IE_PROTO)) return O[$a7a236f58eeb7f86$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $a7a236f58eeb7f86$var$ObjectProto : null;
};

});

parcelRegister("iTgBc", function(module, exports) {
'use strict';

var $8csIg = parcelRequire("8csIg");

var $gHcyI = parcelRequire("gHcyI");

var $87NIy = parcelRequire("87NIy");

var $jHwil = parcelRequire("jHwil");

var $60LZ2 = parcelRequire("60LZ2");

var $3yrVW = parcelRequire("3yrVW");
var $dc0a3d3f6517d36c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$dc0a3d3f6517d36c$var$$assign || (parcelRequire("as1c7"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $dc0a3d3f6517d36c$var$$assign({}, A)[S] != 7 || Object.keys($dc0a3d3f6517d36c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $60LZ2(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $87NIy.f;
    var isEnum = $jHwil.f;
    while(aLen > index){
        var S = $3yrVW(arguments[index++]);
        var keys = getSymbols ? $gHcyI(S).concat(getSymbols(S)) : $gHcyI(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$8csIg || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $dc0a3d3f6517d36c$var$$assign;

});
parcelRegister("87NIy", function(module, exports) {

$parcel$export(module.exports, "f", () => $5ea58b10fd7ccae1$export$2d1720544b23b823, (v) => $5ea58b10fd7ccae1$export$2d1720544b23b823 = v);
var $5ea58b10fd7ccae1$export$2d1720544b23b823;
$5ea58b10fd7ccae1$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("3N3vf", function(module, exports) {
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

});

parcelRegister("c6KGM", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $a8jEg = parcelRequire("a8jEg");

var $cYx5q = parcelRequire("cYx5q");
var $8d0a4307ca2350dd$var$check = function(O, proto) {
    $cYx5q(O);
    if (!$a8jEg(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bKCrG"))(Function.call, (parcelRequire("6Vt7w")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $8d0a4307ca2350dd$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $8d0a4307ca2350dd$var$check
};

});

parcelRegister("gTUcM", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $gyczm = parcelRequire("gyczm");

var $c4dd618f76984ca4$var$TAG = (parcelRequire("fjK8l"))('toStringTag');
// ES3 wrong here
var $c4dd618f76984ca4$var$ARG = $gyczm(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $c4dd618f76984ca4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $c4dd618f76984ca4$var$tryGet(O = Object(it), $c4dd618f76984ca4$var$TAG)) == 'string' ? T : $c4dd618f76984ca4$var$ARG ? $gyczm(O) : (B = $gyczm(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("ladkF", function(module, exports) {
'use strict';

var $3fVrL = parcelRequire("3fVrL");

var $a8jEg = parcelRequire("a8jEg");

var $k69pM = parcelRequire("k69pM");
var $f684dfa7f4fdadfb$var$arraySlice = [].slice;
var $f684dfa7f4fdadfb$var$factories = {};
var $f684dfa7f4fdadfb$var$construct = function(F, len, args) {
    if (!(len in $f684dfa7f4fdadfb$var$factories)) {
        for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
        // eslint-disable-next-line no-new-func
        $f684dfa7f4fdadfb$var$factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return $f684dfa7f4fdadfb$var$factories[len](F, args);
};
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var fn = $3fVrL(this);
    var partArgs = $f684dfa7f4fdadfb$var$arraySlice.call(arguments, 1);
    var bound = function() {
        var args = partArgs.concat($f684dfa7f4fdadfb$var$arraySlice.call(arguments));
        return this instanceof bound ? $f684dfa7f4fdadfb$var$construct(fn, args.length, args) : $k69pM(fn, args, that);
    };
    if ($a8jEg(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
};

});
parcelRegister("k69pM", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("glTQQ", function(module, exports) {

var $e88d0 = parcelRequire("e88d0");

var $iedom = parcelRequire("iedom");

var $as1c7 = parcelRequire("as1c7");

var $dWWlA = parcelRequire("dWWlA");
var $be79ee6679650e99$var$space = '[' + $dWWlA + ']';
var $be79ee6679650e99$var$non = '\u200b\u0085';
var $be79ee6679650e99$var$ltrim = RegExp('^' + $be79ee6679650e99$var$space + $be79ee6679650e99$var$space + '*');
var $be79ee6679650e99$var$rtrim = RegExp($be79ee6679650e99$var$space + $be79ee6679650e99$var$space + '*$');
var $be79ee6679650e99$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $as1c7(function() {
        return !!$dWWlA[KEY]() || $be79ee6679650e99$var$non[KEY]() != $be79ee6679650e99$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($be79ee6679650e99$var$trim) : $dWWlA[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $e88d0($e88d0.P + $e88d0.F * FORCE, 'String', exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $be79ee6679650e99$var$trim = $be79ee6679650e99$var$exporter.trim = function(string, TYPE) {
    string = String($iedom(string));
    if (TYPE & 1) string = string.replace($be79ee6679650e99$var$ltrim, '');
    if (TYPE & 2) string = string.replace($be79ee6679650e99$var$rtrim, '');
    return string;
};
module.exports = $be79ee6679650e99$var$exporter;

});
parcelRegister("dWWlA", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("1uiiY", function(module, exports) {
'use strict';

var $8KZEi = parcelRequire("8KZEi");

var $iedom = parcelRequire("iedom");
module.exports = function repeat(count) {
    var str = String($iedom(this));
    var res = '';
    var n = $8KZEi(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) res += str;
    return res;
};

});

parcelRegister("fOCrm", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $a8jEg = parcelRequire("a8jEg");
var $b83957faf675af05$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$a8jEg(it) && isFinite(it) && $b83957faf675af05$var$floor(it) === it;
};

});

parcelRegister("lTkrp", function(module, exports) {
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -0.00000001 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

});

parcelRegister("jE34f", function(module, exports) {
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

});

parcelRegister("6JdnZ", function(module, exports) {
// 20.2.2.16 Math.fround(x)

var $jE34f = parcelRequire("jE34f");
var $4e61543b28b845fe$var$pow = Math.pow;
var $4e61543b28b845fe$var$EPSILON = $4e61543b28b845fe$var$pow(2, -52);
var $4e61543b28b845fe$var$EPSILON32 = $4e61543b28b845fe$var$pow(2, -23);
var $4e61543b28b845fe$var$MAX32 = $4e61543b28b845fe$var$pow(2, 127) * (2 - $4e61543b28b845fe$var$EPSILON32);
var $4e61543b28b845fe$var$MIN32 = $4e61543b28b845fe$var$pow(2, -126);
var $4e61543b28b845fe$var$roundTiesToEven = function(n) {
    return n + 1 / $4e61543b28b845fe$var$EPSILON - 1 / $4e61543b28b845fe$var$EPSILON;
};
module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = $jE34f(x);
    var a, result;
    if ($abs < $4e61543b28b845fe$var$MIN32) return $sign * $4e61543b28b845fe$var$roundTiesToEven($abs / $4e61543b28b845fe$var$MIN32 / $4e61543b28b845fe$var$EPSILON32) * $4e61543b28b845fe$var$MIN32 * $4e61543b28b845fe$var$EPSILON32;
    a = (1 + $4e61543b28b845fe$var$EPSILON32 / $4e61543b28b845fe$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $4e61543b28b845fe$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};

});

parcelRegister("2TsAR", function(module, exports) {

var $8KZEi = parcelRequire("8KZEi");

var $iedom = parcelRequire("iedom");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($iedom(that));
        var i = $8KZEi(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("k0W9G", function(module, exports) {
'use strict';

var $8N1Ra = parcelRequire("8N1Ra");

var $e88d0 = parcelRequire("e88d0");

var $4ELbO = parcelRequire("4ELbO");

var $5eEKu = parcelRequire("5eEKu");

var $eKE8G = parcelRequire("eKE8G");

var $eyH2O = parcelRequire("eyH2O");

var $7jOVX = parcelRequire("7jOVX");

var $eojdB = parcelRequire("eojdB");

var $e920eb23ed5f2beb$var$ITERATOR = (parcelRequire("fjK8l"))('iterator');
var $e920eb23ed5f2beb$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $e920eb23ed5f2beb$var$FF_ITERATOR = '@@iterator';
var $e920eb23ed5f2beb$var$KEYS = 'keys';
var $e920eb23ed5f2beb$var$VALUES = 'values';
var $e920eb23ed5f2beb$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $eyH2O(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$e920eb23ed5f2beb$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $e920eb23ed5f2beb$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $e920eb23ed5f2beb$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $e920eb23ed5f2beb$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$e920eb23ed5f2beb$var$ITERATOR] || proto[$e920eb23ed5f2beb$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $eojdB($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $7jOVX(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$8N1Ra && typeof IteratorPrototype[$e920eb23ed5f2beb$var$ITERATOR] != 'function') $5eEKu(IteratorPrototype, $e920eb23ed5f2beb$var$ITERATOR, $e920eb23ed5f2beb$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $e920eb23ed5f2beb$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$8N1Ra || FORCED) && ($e920eb23ed5f2beb$var$BUGGY || VALUES_BUG || !proto[$e920eb23ed5f2beb$var$ITERATOR])) $5eEKu(proto, $e920eb23ed5f2beb$var$ITERATOR, $default);
    // Plug for library
    $eKE8G[NAME] = $default;
    $eKE8G[TAG] = $e920eb23ed5f2beb$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($e920eb23ed5f2beb$var$VALUES),
            keys: IS_SET ? $default : getMethod($e920eb23ed5f2beb$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $4ELbO(proto, key, methods[key]);
        } else $e88d0($e88d0.P + $e88d0.F * ($e920eb23ed5f2beb$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("eKE8G", function(module, exports) {
module.exports = {};

});

parcelRegister("eyH2O", function(module, exports) {
'use strict';

var $9lrow = parcelRequire("9lrow");

var $3PFaa = parcelRequire("3PFaa");

var $7jOVX = parcelRequire("7jOVX");
var $a995a1606da75300$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("5eEKu"))($a995a1606da75300$var$IteratorPrototype, (parcelRequire("fjK8l"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $9lrow($a995a1606da75300$var$IteratorPrototype, {
        next: $3PFaa(1, next)
    });
    $7jOVX(Constructor, NAME + ' Iterator');
};

});


parcelRegister("gmWLF", function(module, exports) {

var $beac4980f27a407f$var$MATCH = (parcelRequire("fjK8l"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$beac4980f27a407f$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("lQyYn", function(module, exports) {

var $e88d0 = parcelRequire("e88d0");

var $as1c7 = parcelRequire("as1c7");

var $iedom = parcelRequire("iedom");
var $fe799527a2246d1f$var$quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var $fe799527a2246d1f$var$createHTML = function(string, tag, attribute, value) {
    var S = String($iedom(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace($fe799527a2246d1f$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec) {
    var O = {};
    O[NAME] = exec($fe799527a2246d1f$var$createHTML);
    $e88d0($e88d0.P + $e88d0.F * $as1c7(function() {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
};

});

parcelRegister("aYJHn", function(module, exports) {
'use strict';

var $cYx5q = parcelRequire("cYx5q");

var $h0Sfn = parcelRequire("h0Sfn");
var $7fe2f4cbf1635d20$var$NUMBER = 'number';
module.exports = function(hint) {
    if (hint !== 'string' && hint !== $7fe2f4cbf1635d20$var$NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return $h0Sfn($cYx5q(this), hint != $7fe2f4cbf1635d20$var$NUMBER);
};

});

parcelRegister("7cwkx", function(module, exports) {
// check on default Array iterator

var $eKE8G = parcelRequire("eKE8G");

var $53e2bb88de6e7559$var$ITERATOR = (parcelRequire("fjK8l"))('iterator');
var $53e2bb88de6e7559$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($eKE8G.Array === it || $53e2bb88de6e7559$var$ArrayProto[$53e2bb88de6e7559$var$ITERATOR] === it);
};

});

parcelRegister("cNTiY", function(module, exports) {

var $gTUcM = parcelRequire("gTUcM");

var $9524f61313a8bf26$var$ITERATOR = (parcelRequire("fjK8l"))('iterator');

var $eKE8G = parcelRequire("eKE8G");

module.exports = (parcelRequire("6OFbT")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$9524f61313a8bf26$var$ITERATOR] || it['@@iterator'] || $eKE8G[$gTUcM(it)];
};

});

parcelRegister("6W0vs", function(module, exports) {

var $50c88d6cc7b3f59a$var$ITERATOR = (parcelRequire("fjK8l"))('iterator');
var $50c88d6cc7b3f59a$var$SAFE_CLOSING = false;
try {
    var $50c88d6cc7b3f59a$var$riter = [
        7
    ][$50c88d6cc7b3f59a$var$ITERATOR]();
    $50c88d6cc7b3f59a$var$riter['return'] = function() {
        $50c88d6cc7b3f59a$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($50c88d6cc7b3f59a$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$50c88d6cc7b3f59a$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$50c88d6cc7b3f59a$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$50c88d6cc7b3f59a$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("7BiMX", function(module, exports) {
'use strict';

var $as1c7 = parcelRequire("as1c7");
module.exports = function(method, arg) {
    return !!method && $as1c7(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("mgfCC", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $bKCrG = parcelRequire("bKCrG");

var $3yrVW = parcelRequire("3yrVW");

var $60LZ2 = parcelRequire("60LZ2");

var $6oAU6 = parcelRequire("6oAU6");

var $7zU3P = parcelRequire("7zU3P");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $7zU3P;
    return function($this, callbackfn, that) {
        var O = $60LZ2($this);
        var self = $3yrVW(O);
        var f = $bKCrG(callbackfn, that, 3);
        var length = $6oAU6(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("7zU3P", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $9znzq = parcelRequire("9znzq");
module.exports = function(original, length) {
    return new ($9znzq(original))(length);
};

});
parcelRegister("9znzq", function(module, exports) {

var $a8jEg = parcelRequire("a8jEg");

var $k2l0Y = parcelRequire("k2l0Y");

var $6f79aa821943d1e9$var$SPECIES = (parcelRequire("fjK8l"))('species');
module.exports = function(original) {
    var C;
    if ($k2l0Y(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $k2l0Y(C.prototype))) C = undefined;
        if ($a8jEg(C)) {
            C = C[$6f79aa821943d1e9$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});



parcelRegister("1bFtr", function(module, exports) {
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';

var $60LZ2 = parcelRequire("60LZ2");

var $79CKs = parcelRequire("79CKs");

var $6oAU6 = parcelRequire("6oAU6");
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $60LZ2(this);
    var len = $6oAU6(O.length);
    var to = $79CKs(target, len);
    var from = $79CKs(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : $79CKs(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else delete O[to];
        to += inc;
        from += inc;
    }
    return O;
};

});

parcelRegister("lwTuI", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $fac7a22884ce0412$var$UNSCOPABLES = (parcelRequire("fjK8l"))('unscopables');
var $fac7a22884ce0412$var$ArrayProto = Array.prototype;

if ($fac7a22884ce0412$var$ArrayProto[$fac7a22884ce0412$var$UNSCOPABLES] == undefined) (parcelRequire("5eEKu"))($fac7a22884ce0412$var$ArrayProto, $fac7a22884ce0412$var$UNSCOPABLES, {});
module.exports = function(key) {
    $fac7a22884ce0412$var$ArrayProto[$fac7a22884ce0412$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("5Y7zp", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $60LZ2 = parcelRequire("60LZ2");

var $79CKs = parcelRequire("79CKs");

var $6oAU6 = parcelRequire("6oAU6");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $60LZ2(this);
    var length = $6oAU6(O.length);
    var aLen = arguments.length;
    var index = $79CKs(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $79CKs(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});

parcelRegister("dQX1C", function(module, exports) {
'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $hjnWf = parcelRequire("hjnWf");

var $8csIg = parcelRequire("8csIg");

var $a15dead3dcc62b22$var$SPECIES = (parcelRequire("fjK8l"))('species');
module.exports = function(KEY) {
    var C = $fRJfg[KEY];
    if ($8csIg && C && !C[$a15dead3dcc62b22$var$SPECIES]) $hjnWf.f(C, $a15dead3dcc62b22$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("2jMtE", function(module, exports) {
'use strict';

var $lwTuI = parcelRequire("lwTuI");

var $1gUOu = parcelRequire("1gUOu");

var $eKE8G = parcelRequire("eKE8G");

var $h1IuT = parcelRequire("h1IuT");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("k0W9G"))(Array, 'Array', function(iterated, kind) {
    this._t = $h1IuT(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1gUOu(1);
    }
    if (kind == 'keys') return $1gUOu(0, index);
    if (kind == 'values') return $1gUOu(0, O[index]);
    return $1gUOu(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$eKE8G.Arguments = $eKE8G.Array;
$lwTuI('keys');
$lwTuI('values');
$lwTuI('entries');

});
parcelRegister("1gUOu", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});


parcelRegister("cYtFt", function(module, exports) {
'use strict';

var $cYx5q = parcelRequire("cYx5q");
module.exports = function() {
    var that = $cYx5q(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("7MkNY", function(module, exports) {
'use strict';
parcelRequire("dwwSd");

var $4ELbO = parcelRequire("4ELbO");

var $5eEKu = parcelRequire("5eEKu");

var $as1c7 = parcelRequire("as1c7");

var $iedom = parcelRequire("iedom");

var $fjK8l = parcelRequire("fjK8l");

var $2F0oV = parcelRequire("2F0oV");
var $5a9d2790307308e3$var$SPECIES = $fjK8l('species');
var $5a9d2790307308e3$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$as1c7(function() {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    return ''.replace(re, '$<a>') !== '7';
});
var $5a9d2790307308e3$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();
module.exports = function(KEY, length, exec) {
    var SYMBOL = $fjK8l(KEY);
    var DELEGATES_TO_SYMBOL = !$as1c7(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !$as1c7(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        re.exec = function() {
            execCalled = true;
            return null;
        };
        if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$5a9d2790307308e3$var$SPECIES] = function() {
                return re;
            };
        }
        re[SYMBOL]('');
        return !execCalled;
    }) : undefined;
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !$5a9d2790307308e3$var$REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !$5a9d2790307308e3$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var fns = exec($iedom, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === $2F0oV) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        var strfn = fns[0];
        var rxfn = fns[1];
        $4ELbO(String.prototype, KEY, strfn);
        $5eEKu(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
            return rxfn.call(string, this, arg);
        } : function(string) {
            return rxfn.call(string, this);
        });
    }
};

});
parcelRegister("dwwSd", function(module, exports) {
'use strict';

var $2F0oV = parcelRequire("2F0oV");

(parcelRequire("e88d0"))({
    target: 'RegExp',
    proto: true,
    forced: $2F0oV !== /./.exec
}, {
    exec: $2F0oV
});

});
parcelRegister("2F0oV", function(module, exports) {
'use strict';

var $cYtFt = parcelRequire("cYtFt");
var $1effb8bacb3fd91b$var$nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var $1effb8bacb3fd91b$var$nativeReplace = String.prototype.replace;
var $1effb8bacb3fd91b$var$patchedExec = $1effb8bacb3fd91b$var$nativeExec;
var $1effb8bacb3fd91b$var$LAST_INDEX = 'lastIndex';
var $1effb8bacb3fd91b$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    $1effb8bacb3fd91b$var$nativeExec.call(re1, 'a');
    $1effb8bacb3fd91b$var$nativeExec.call(re2, 'a');
    return re1[$1effb8bacb3fd91b$var$LAST_INDEX] !== 0 || re2[$1effb8bacb3fd91b$var$LAST_INDEX] !== 0;
}();
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $1effb8bacb3fd91b$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $1effb8bacb3fd91b$var$PATCH = $1effb8bacb3fd91b$var$UPDATES_LAST_INDEX_WRONG || $1effb8bacb3fd91b$var$NPCG_INCLUDED;
if ($1effb8bacb3fd91b$var$PATCH) $1effb8bacb3fd91b$var$patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    if ($1effb8bacb3fd91b$var$NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', $cYtFt.call(re));
    if ($1effb8bacb3fd91b$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re[$1effb8bacb3fd91b$var$LAST_INDEX];
    match = $1effb8bacb3fd91b$var$nativeExec.call(re, str);
    if ($1effb8bacb3fd91b$var$UPDATES_LAST_INDEX_WRONG && match) re[$1effb8bacb3fd91b$var$LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    if ($1effb8bacb3fd91b$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    // eslint-disable-next-line no-loop-func
    $1effb8bacb3fd91b$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    return match;
};
module.exports = $1effb8bacb3fd91b$var$patchedExec;

});



parcelRegister("jHqVA", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $cYx5q = parcelRequire("cYx5q");

var $3fVrL = parcelRequire("3fVrL");

var $e576ebcae7fefcf2$var$SPECIES = (parcelRequire("fjK8l"))('species');
module.exports = function(O, D) {
    var C = $cYx5q(O).constructor;
    var S;
    return C === undefined || (S = $cYx5q(C)[$e576ebcae7fefcf2$var$SPECIES]) == undefined ? D : $3fVrL(S);
};

});

parcelRegister("2gG2X", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("4LikV", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");

var $bFqCF = parcelRequire("bFqCF");
var $3779c673bf0f065d$require$macrotask = $bFqCF.set;
var $3779c673bf0f065d$var$Observer = $fRJfg.MutationObserver || $fRJfg.WebKitMutationObserver;
var $3779c673bf0f065d$var$process = $fRJfg.process;
var $3779c673bf0f065d$var$Promise = $fRJfg.Promise;

var $3779c673bf0f065d$var$isNode = (parcelRequire("gyczm"))($3779c673bf0f065d$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($3779c673bf0f065d$var$isNode && (parent = $3779c673bf0f065d$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($3779c673bf0f065d$var$isNode) notify = function() {
        $3779c673bf0f065d$var$process.nextTick(flush);
    };
    else if ($3779c673bf0f065d$var$Observer && !($fRJfg.navigator && $fRJfg.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $3779c673bf0f065d$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($3779c673bf0f065d$var$Promise && $3779c673bf0f065d$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $3779c673bf0f065d$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $3779c673bf0f065d$require$macrotask.call($fRJfg, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});
parcelRegister("bFqCF", function(module, exports) {

var $bKCrG = parcelRequire("bKCrG");

var $k69pM = parcelRequire("k69pM");

var $fWBj0 = parcelRequire("fWBj0");

var $87sFj = parcelRequire("87sFj");

var $fRJfg = parcelRequire("fRJfg");
var $87e82cc591a70cce$var$process = $fRJfg.process;
var $87e82cc591a70cce$var$setTask = $fRJfg.setImmediate;
var $87e82cc591a70cce$var$clearTask = $fRJfg.clearImmediate;
var $87e82cc591a70cce$var$MessageChannel = $fRJfg.MessageChannel;
var $87e82cc591a70cce$var$Dispatch = $fRJfg.Dispatch;
var $87e82cc591a70cce$var$counter = 0;
var $87e82cc591a70cce$var$queue = {};
var $87e82cc591a70cce$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $87e82cc591a70cce$var$defer, $87e82cc591a70cce$var$channel, $87e82cc591a70cce$var$port;
var $87e82cc591a70cce$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($87e82cc591a70cce$var$queue.hasOwnProperty(id)) {
        var fn = $87e82cc591a70cce$var$queue[id];
        delete $87e82cc591a70cce$var$queue[id];
        fn();
    }
};
var $87e82cc591a70cce$var$listener = function(event) {
    $87e82cc591a70cce$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$87e82cc591a70cce$var$setTask || !$87e82cc591a70cce$var$clearTask) {
    $87e82cc591a70cce$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $87e82cc591a70cce$var$queue[++$87e82cc591a70cce$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $k69pM(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $87e82cc591a70cce$var$defer($87e82cc591a70cce$var$counter);
        return $87e82cc591a70cce$var$counter;
    };
    $87e82cc591a70cce$var$clearTask = function clearImmediate(id) {
        delete $87e82cc591a70cce$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("gyczm"))($87e82cc591a70cce$var$process) == 'process') $87e82cc591a70cce$var$defer = function(id) {
        $87e82cc591a70cce$var$process.nextTick($bKCrG($87e82cc591a70cce$var$run, id, 1));
    };
    else if ($87e82cc591a70cce$var$Dispatch && $87e82cc591a70cce$var$Dispatch.now) $87e82cc591a70cce$var$defer = function(id) {
        $87e82cc591a70cce$var$Dispatch.now($bKCrG($87e82cc591a70cce$var$run, id, 1));
    };
    else if ($87e82cc591a70cce$var$MessageChannel) {
        $87e82cc591a70cce$var$channel = new $87e82cc591a70cce$var$MessageChannel();
        $87e82cc591a70cce$var$port = $87e82cc591a70cce$var$channel.port2;
        $87e82cc591a70cce$var$channel.port1.onmessage = $87e82cc591a70cce$var$listener;
        $87e82cc591a70cce$var$defer = $bKCrG($87e82cc591a70cce$var$port.postMessage, $87e82cc591a70cce$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($fRJfg.addEventListener && typeof postMessage == 'function' && !$fRJfg.importScripts) {
        $87e82cc591a70cce$var$defer = function(id) {
            $fRJfg.postMessage(id + '', '*');
        };
        $fRJfg.addEventListener('message', $87e82cc591a70cce$var$listener, false);
    // IE8-
    } else if ($87e82cc591a70cce$var$ONREADYSTATECHANGE in $87sFj('script')) $87e82cc591a70cce$var$defer = function(id) {
        $fWBj0.appendChild($87sFj('script'))[$87e82cc591a70cce$var$ONREADYSTATECHANGE] = function() {
            $fWBj0.removeChild(this);
            $87e82cc591a70cce$var$run.call(id);
        };
    };
    else $87e82cc591a70cce$var$defer = function(id) {
        setTimeout($bKCrG($87e82cc591a70cce$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $87e82cc591a70cce$var$setTask,
    clear: $87e82cc591a70cce$var$clearTask
};

});


parcelRegister("j7N7T", function(module, exports) {

var $4ELbO = parcelRequire("4ELbO");
module.exports = function(target, src, safe) {
    for(var key in src)$4ELbO(target, key, src[key], safe);
    return target;
};

});

parcelRegister("hGsNI", function(module, exports) {
'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $e88d0 = parcelRequire("e88d0");

var $4ELbO = parcelRequire("4ELbO");

var $j7N7T = parcelRequire("j7N7T");

var $nFBKj = parcelRequire("nFBKj");

var $k17JG = parcelRequire("k17JG");

var $2gG2X = parcelRequire("2gG2X");

var $a8jEg = parcelRequire("a8jEg");

var $as1c7 = parcelRequire("as1c7");

var $6W0vs = parcelRequire("6W0vs");

var $7jOVX = parcelRequire("7jOVX");

var $kNhgM = parcelRequire("kNhgM");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $fRJfg[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $4ELbO(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$a8jEg(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$a8jEg(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$a8jEg(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$as1c7(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $j7N7T(C.prototype, methods);
        $nFBKj.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $as1c7(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $6W0vs(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $as1c7(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $2gG2X(target, C, NAME);
                var that = $kNhgM(new Base(), target, C);
                if (iterable != undefined) $k17JG(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $7jOVX(C, NAME);
    O[NAME] = C;
    $e88d0($e88d0.G + $e88d0.W + $e88d0.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("nFBKj", function(module, exports) {

var $04726c8a82aa42fa$var$META = (parcelRequire("5DFYi"))('meta');

var $a8jEg = parcelRequire("a8jEg");

var $fdFIW = parcelRequire("fdFIW");

var $hjnWf = parcelRequire("hjnWf");
var $04726c8a82aa42fa$require$setDesc = $hjnWf.f;
var $04726c8a82aa42fa$var$id = 0;
var $04726c8a82aa42fa$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $04726c8a82aa42fa$var$FREEZE = !(parcelRequire("as1c7"))(function() {
    return $04726c8a82aa42fa$var$isExtensible(Object.preventExtensions({}));
});
var $04726c8a82aa42fa$var$setMeta = function(it) {
    $04726c8a82aa42fa$require$setDesc(it, $04726c8a82aa42fa$var$META, {
        value: {
            i: 'O' + ++$04726c8a82aa42fa$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $04726c8a82aa42fa$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$a8jEg(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$fdFIW(it, $04726c8a82aa42fa$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$04726c8a82aa42fa$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $04726c8a82aa42fa$var$setMeta(it);
    // return object ID
    }
    return it[$04726c8a82aa42fa$var$META].i;
};
var $04726c8a82aa42fa$var$getWeak = function(it, create) {
    if (!$fdFIW(it, $04726c8a82aa42fa$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$04726c8a82aa42fa$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $04726c8a82aa42fa$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$04726c8a82aa42fa$var$META].w;
};
// add metadata on freeze-family methods calling
var $04726c8a82aa42fa$var$onFreeze = function(it) {
    if ($04726c8a82aa42fa$var$FREEZE && $04726c8a82aa42fa$var$meta.NEED && $04726c8a82aa42fa$var$isExtensible(it) && !$fdFIW(it, $04726c8a82aa42fa$var$META)) $04726c8a82aa42fa$var$setMeta(it);
    return it;
};
var $04726c8a82aa42fa$var$meta = module.exports = {
    KEY: $04726c8a82aa42fa$var$META,
    NEED: false,
    fastKey: $04726c8a82aa42fa$var$fastKey,
    getWeak: $04726c8a82aa42fa$var$getWeak,
    onFreeze: $04726c8a82aa42fa$var$onFreeze
};

});

parcelRegister("k17JG", function(module, exports) {

var $bKCrG = parcelRequire("bKCrG");

var $iUAhO = parcelRequire("iUAhO");

var $7cwkx = parcelRequire("7cwkx");

var $cYx5q = parcelRequire("cYx5q");

var $6oAU6 = parcelRequire("6oAU6");

var $cNTiY = parcelRequire("cNTiY");
var $e929e6ce2cfab8c7$var$BREAK = {};
var $e929e6ce2cfab8c7$var$RETURN = {};
var $e929e6ce2cfab8c7$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $cNTiY(iterable);
    var f = $bKCrG(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($7cwkx(iterFn)) for(length = $6oAU6(iterable.length); length > index; index++){
        result = entries ? f($cYx5q(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $e929e6ce2cfab8c7$var$BREAK || result === $e929e6ce2cfab8c7$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $iUAhO(iterator, f, step.value, entries);
        if (result === $e929e6ce2cfab8c7$var$BREAK || result === $e929e6ce2cfab8c7$var$RETURN) return result;
    }
};
$e929e6ce2cfab8c7$var$exports.BREAK = $e929e6ce2cfab8c7$var$BREAK;
$e929e6ce2cfab8c7$var$exports.RETURN = $e929e6ce2cfab8c7$var$RETURN;

});
parcelRegister("iUAhO", function(module, exports) {
// call something on iterator step with safe closing on error

var $cYx5q = parcelRequire("cYx5q");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($cYx5q(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $cYx5q(ret.call(iterator));
        throw e;
    }
};

});


parcelRegister("kNhgM", function(module, exports) {

var $a8jEg = parcelRequire("a8jEg");

var $c6KGM = parcelRequire("c6KGM");
var $f235c79e85db5e04$require$setPrototypeOf = $c6KGM.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $a8jEg(P) && $f235c79e85db5e04$require$setPrototypeOf) $f235c79e85db5e04$require$setPrototypeOf(that, P);
    return that;
};

});


parcelRegister("fEM2o", function(module, exports) {
'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $b65fdab1928a65ae$var$each = (parcelRequire("mgfCC"))(0);

var $4ELbO = parcelRequire("4ELbO");

var $nFBKj = parcelRequire("nFBKj");

var $iTgBc = parcelRequire("iTgBc");

var $bd8zE = parcelRequire("bd8zE");

var $a8jEg = parcelRequire("a8jEg");

var $j26DO = parcelRequire("j26DO");

var $j26DO = parcelRequire("j26DO");
var $b65fdab1928a65ae$var$IS_IE11 = !$fRJfg.ActiveXObject && 'ActiveXObject' in $fRJfg;
var $b65fdab1928a65ae$var$WEAK_MAP = 'WeakMap';
var $b65fdab1928a65ae$var$getWeak = $nFBKj.getWeak;
var $b65fdab1928a65ae$var$isExtensible = Object.isExtensible;
var $b65fdab1928a65ae$var$uncaughtFrozenStore = $bd8zE.ufstore;
var $b65fdab1928a65ae$var$InternalMap;
var $b65fdab1928a65ae$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $b65fdab1928a65ae$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($a8jEg(key)) {
            var data = $b65fdab1928a65ae$var$getWeak(key);
            if (data === true) return $b65fdab1928a65ae$var$uncaughtFrozenStore($j26DO(this, $b65fdab1928a65ae$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $bd8zE.def($j26DO(this, $b65fdab1928a65ae$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $b65fdab1928a65ae$var$$WeakMap = module.exports = (parcelRequire("hGsNI"))($b65fdab1928a65ae$var$WEAK_MAP, $b65fdab1928a65ae$var$wrapper, $b65fdab1928a65ae$var$methods, $bd8zE, true, true);
// IE11 WeakMap frozen keys fix
if ($j26DO && $b65fdab1928a65ae$var$IS_IE11) {
    $b65fdab1928a65ae$var$InternalMap = $bd8zE.getConstructor($b65fdab1928a65ae$var$wrapper, $b65fdab1928a65ae$var$WEAK_MAP);
    $iTgBc($b65fdab1928a65ae$var$InternalMap.prototype, $b65fdab1928a65ae$var$methods);
    $nFBKj.NEED = true;
    $b65fdab1928a65ae$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $b65fdab1928a65ae$var$$WeakMap.prototype;
        var method = proto[key];
        $4ELbO(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($a8jEg(a) && !$b65fdab1928a65ae$var$isExtensible(a)) {
                if (!this._f) this._f = new $b65fdab1928a65ae$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}

});
parcelRegister("bd8zE", function(module, exports) {
'use strict';

var $j7N7T = parcelRequire("j7N7T");

var $nFBKj = parcelRequire("nFBKj");
var $82978f397ac1cb67$require$getWeak = $nFBKj.getWeak;

var $cYx5q = parcelRequire("cYx5q");

var $a8jEg = parcelRequire("a8jEg");

var $2gG2X = parcelRequire("2gG2X");

var $k17JG = parcelRequire("k17JG");

var $mgfCC = parcelRequire("mgfCC");

var $fdFIW = parcelRequire("fdFIW");

var $j26DO = parcelRequire("j26DO");
var $82978f397ac1cb67$var$arrayFind = $mgfCC(5);
var $82978f397ac1cb67$var$arrayFindIndex = $mgfCC(6);
var $82978f397ac1cb67$var$id = 0;
// fallback for uncaught frozen keys
var $82978f397ac1cb67$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $82978f397ac1cb67$var$UncaughtFrozenStore());
};
var $82978f397ac1cb67$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $82978f397ac1cb67$var$findUncaughtFrozen = function(store, key) {
    return $82978f397ac1cb67$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$82978f397ac1cb67$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $82978f397ac1cb67$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$82978f397ac1cb67$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $82978f397ac1cb67$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $82978f397ac1cb67$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $2gG2X(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $82978f397ac1cb67$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $k17JG(iterable, IS_MAP, that[ADDER], that);
        });
        $j7N7T(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$a8jEg(key)) return false;
                var data = $82978f397ac1cb67$require$getWeak(key);
                if (data === true) return $82978f397ac1cb67$var$uncaughtFrozenStore($j26DO(this, NAME))['delete'](key);
                return data && $fdFIW(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$a8jEg(key)) return false;
                var data = $82978f397ac1cb67$require$getWeak(key);
                if (data === true) return $82978f397ac1cb67$var$uncaughtFrozenStore($j26DO(this, NAME)).has(key);
                return data && $fdFIW(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $82978f397ac1cb67$require$getWeak($cYx5q(key), true);
        if (data === true) $82978f397ac1cb67$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $82978f397ac1cb67$var$uncaughtFrozenStore
};

});
parcelRegister("j26DO", function(module, exports) {

var $a8jEg = parcelRequire("a8jEg");
module.exports = function(it, TYPE) {
    if (!$a8jEg(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};

});



parcelRegister("4mWd7", function(module, exports) {

var $fRJfg = parcelRequire("fRJfg");

var $5eEKu = parcelRequire("5eEKu");

var $5DFYi = parcelRequire("5DFYi");
var $32e65eee332c100d$var$TYPED = $5DFYi('typed_array');
var $32e65eee332c100d$var$VIEW = $5DFYi('view');
var $32e65eee332c100d$var$ABV = !!($fRJfg.ArrayBuffer && $fRJfg.DataView);
var $32e65eee332c100d$var$CONSTR = $32e65eee332c100d$var$ABV;
var $32e65eee332c100d$var$i = 0;
var $32e65eee332c100d$var$l = 9;
var $32e65eee332c100d$var$Typed;
var $32e65eee332c100d$var$TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
while($32e65eee332c100d$var$i < $32e65eee332c100d$var$l)if ($32e65eee332c100d$var$Typed = $fRJfg[$32e65eee332c100d$var$TypedArrayConstructors[$32e65eee332c100d$var$i++]]) {
    $5eEKu($32e65eee332c100d$var$Typed.prototype, $32e65eee332c100d$var$TYPED, true);
    $5eEKu($32e65eee332c100d$var$Typed.prototype, $32e65eee332c100d$var$VIEW, true);
} else $32e65eee332c100d$var$CONSTR = false;
module.exports = {
    ABV: $32e65eee332c100d$var$ABV,
    CONSTR: $32e65eee332c100d$var$CONSTR,
    TYPED: $32e65eee332c100d$var$TYPED,
    VIEW: $32e65eee332c100d$var$VIEW
};

});

parcelRegister("hjcH4", function(module, exports) {
'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $8csIg = parcelRequire("8csIg");

var $8N1Ra = parcelRequire("8N1Ra");

var $4mWd7 = parcelRequire("4mWd7");

var $5eEKu = parcelRequire("5eEKu");

var $j7N7T = parcelRequire("j7N7T");

var $as1c7 = parcelRequire("as1c7");

var $2gG2X = parcelRequire("2gG2X");

var $8KZEi = parcelRequire("8KZEi");

var $6oAU6 = parcelRequire("6oAU6");

var $b8nlA = parcelRequire("b8nlA");

var $1UujU = parcelRequire("1UujU");
var $c99e0eb453c76414$require$gOPN = $1UujU.f;

var $hjnWf = parcelRequire("hjnWf");
var $c99e0eb453c76414$require$dP = $hjnWf.f;

var $5Y7zp = parcelRequire("5Y7zp");

var $7jOVX = parcelRequire("7jOVX");
var $c99e0eb453c76414$var$ARRAY_BUFFER = 'ArrayBuffer';
var $c99e0eb453c76414$var$DATA_VIEW = 'DataView';
var $c99e0eb453c76414$var$PROTOTYPE = 'prototype';
var $c99e0eb453c76414$var$WRONG_LENGTH = 'Wrong length!';
var $c99e0eb453c76414$var$WRONG_INDEX = 'Wrong index!';
var $c99e0eb453c76414$var$$ArrayBuffer = $fRJfg[$c99e0eb453c76414$var$ARRAY_BUFFER];
var $c99e0eb453c76414$var$$DataView = $fRJfg[$c99e0eb453c76414$var$DATA_VIEW];
var $c99e0eb453c76414$var$Math = $fRJfg.Math;
var $c99e0eb453c76414$var$RangeError = $fRJfg.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var $c99e0eb453c76414$var$Infinity1 = $fRJfg.Infinity;
var $c99e0eb453c76414$var$BaseBuffer = $c99e0eb453c76414$var$$ArrayBuffer;
var $c99e0eb453c76414$var$abs = $c99e0eb453c76414$var$Math.abs;
var $c99e0eb453c76414$var$pow = $c99e0eb453c76414$var$Math.pow;
var $c99e0eb453c76414$var$floor = $c99e0eb453c76414$var$Math.floor;
var $c99e0eb453c76414$var$log = $c99e0eb453c76414$var$Math.log;
var $c99e0eb453c76414$var$LN2 = $c99e0eb453c76414$var$Math.LN2;
var $c99e0eb453c76414$var$BUFFER = 'buffer';
var $c99e0eb453c76414$var$BYTE_LENGTH = 'byteLength';
var $c99e0eb453c76414$var$BYTE_OFFSET = 'byteOffset';
var $c99e0eb453c76414$var$$BUFFER = $8csIg ? '_b' : $c99e0eb453c76414$var$BUFFER;
var $c99e0eb453c76414$var$$LENGTH = $8csIg ? '_l' : $c99e0eb453c76414$var$BYTE_LENGTH;
var $c99e0eb453c76414$var$$OFFSET = $8csIg ? '_o' : $c99e0eb453c76414$var$BYTE_OFFSET;
// IEEE754 conversions based on https://github.com/feross/ieee754
function $c99e0eb453c76414$var$packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? $c99e0eb453c76414$var$pow(2, -24) - $c99e0eb453c76414$var$pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = $c99e0eb453c76414$var$abs(value);
    // eslint-disable-next-line no-self-compare
    if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
    } else {
        e = $c99e0eb453c76414$var$floor($c99e0eb453c76414$var$log(value) / $c99e0eb453c76414$var$LN2);
        if (value * (c = $c99e0eb453c76414$var$pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * $c99e0eb453c76414$var$pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * $c99e0eb453c76414$var$pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * $c99e0eb453c76414$var$pow(2, eBias - 1) * $c99e0eb453c76414$var$pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
    buffer[--i] |= s * 128;
    return buffer;
}
function $c99e0eb453c76414$var$unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;
    for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : s ? -Infinity : Infinity;
    else {
        m = m + $c99e0eb453c76414$var$pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * $c99e0eb453c76414$var$pow(2, e - mLen);
}
function $c99e0eb453c76414$var$unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function $c99e0eb453c76414$var$packI8(it) {
    return [
        it & 0xff
    ];
}
function $c99e0eb453c76414$var$packI16(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff
    ];
}
function $c99e0eb453c76414$var$packI32(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff,
        it >> 16 & 0xff,
        it >> 24 & 0xff
    ];
}
function $c99e0eb453c76414$var$packF64(it) {
    return $c99e0eb453c76414$var$packIEEE754(it, 52, 8);
}
function $c99e0eb453c76414$var$packF32(it) {
    return $c99e0eb453c76414$var$packIEEE754(it, 23, 4);
}
function $c99e0eb453c76414$var$addGetter(C, key, internal) {
    $c99e0eb453c76414$require$dP(C[$c99e0eb453c76414$var$PROTOTYPE], key, {
        get: function() {
            return this[internal];
        }
    });
}
function $c99e0eb453c76414$var$get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $b8nlA(numIndex);
    if (intIndex + bytes > view[$c99e0eb453c76414$var$$LENGTH]) throw $c99e0eb453c76414$var$RangeError($c99e0eb453c76414$var$WRONG_INDEX);
    var store = view[$c99e0eb453c76414$var$$BUFFER]._b;
    var start = intIndex + view[$c99e0eb453c76414$var$$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
}
function $c99e0eb453c76414$var$set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $b8nlA(numIndex);
    if (intIndex + bytes > view[$c99e0eb453c76414$var$$LENGTH]) throw $c99e0eb453c76414$var$RangeError($c99e0eb453c76414$var$WRONG_INDEX);
    var store = view[$c99e0eb453c76414$var$$BUFFER]._b;
    var start = intIndex + view[$c99e0eb453c76414$var$$OFFSET];
    var pack = conversion(+value);
    for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}
if (!$4mWd7.ABV) {
    $c99e0eb453c76414$var$$ArrayBuffer = function ArrayBuffer(length) {
        $2gG2X(this, $c99e0eb453c76414$var$$ArrayBuffer, $c99e0eb453c76414$var$ARRAY_BUFFER);
        var byteLength = $b8nlA(length);
        this._b = $5Y7zp.call(new Array(byteLength), 0);
        this[$c99e0eb453c76414$var$$LENGTH] = byteLength;
    };
    $c99e0eb453c76414$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $2gG2X(this, $c99e0eb453c76414$var$$DataView, $c99e0eb453c76414$var$DATA_VIEW);
        $2gG2X(buffer, $c99e0eb453c76414$var$$ArrayBuffer, $c99e0eb453c76414$var$DATA_VIEW);
        var bufferLength = buffer[$c99e0eb453c76414$var$$LENGTH];
        var offset = $8KZEi(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $c99e0eb453c76414$var$RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : $6oAU6(byteLength);
        if (offset + byteLength > bufferLength) throw $c99e0eb453c76414$var$RangeError($c99e0eb453c76414$var$WRONG_LENGTH);
        this[$c99e0eb453c76414$var$$BUFFER] = buffer;
        this[$c99e0eb453c76414$var$$OFFSET] = offset;
        this[$c99e0eb453c76414$var$$LENGTH] = byteLength;
    };
    if ($8csIg) {
        $c99e0eb453c76414$var$addGetter($c99e0eb453c76414$var$$ArrayBuffer, $c99e0eb453c76414$var$BYTE_LENGTH, '_l');
        $c99e0eb453c76414$var$addGetter($c99e0eb453c76414$var$$DataView, $c99e0eb453c76414$var$BUFFER, '_b');
        $c99e0eb453c76414$var$addGetter($c99e0eb453c76414$var$$DataView, $c99e0eb453c76414$var$BYTE_LENGTH, '_l');
        $c99e0eb453c76414$var$addGetter($c99e0eb453c76414$var$$DataView, $c99e0eb453c76414$var$BYTE_OFFSET, '_o');
    }
    $j7N7T($c99e0eb453c76414$var$$DataView[$c99e0eb453c76414$var$PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
            return $c99e0eb453c76414$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $c99e0eb453c76414$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $c99e0eb453c76414$var$get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $c99e0eb453c76414$var$get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $c99e0eb453c76414$var$unpackI32($c99e0eb453c76414$var$get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $c99e0eb453c76414$var$unpackI32($c99e0eb453c76414$var$get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $c99e0eb453c76414$var$unpackIEEE754($c99e0eb453c76414$var$get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $c99e0eb453c76414$var$unpackIEEE754($c99e0eb453c76414$var$get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
            $c99e0eb453c76414$var$set(this, 1, byteOffset, $c99e0eb453c76414$var$packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $c99e0eb453c76414$var$set(this, 1, byteOffset, $c99e0eb453c76414$var$packI8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 2, byteOffset, $c99e0eb453c76414$var$packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 2, byteOffset, $c99e0eb453c76414$var$packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 4, byteOffset, $c99e0eb453c76414$var$packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 4, byteOffset, $c99e0eb453c76414$var$packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 4, byteOffset, $c99e0eb453c76414$var$packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $c99e0eb453c76414$var$set(this, 8, byteOffset, $c99e0eb453c76414$var$packF64, value, arguments[2]);
        }
    });
} else {
    if (!$as1c7(function() {
        $c99e0eb453c76414$var$$ArrayBuffer(1);
    }) || !$as1c7(function() {
        new $c99e0eb453c76414$var$$ArrayBuffer(-1); // eslint-disable-line no-new
    }) || $as1c7(function() {
        new $c99e0eb453c76414$var$$ArrayBuffer(); // eslint-disable-line no-new
        new $c99e0eb453c76414$var$$ArrayBuffer(1.5); // eslint-disable-line no-new
        new $c99e0eb453c76414$var$$ArrayBuffer(NaN); // eslint-disable-line no-new
        return $c99e0eb453c76414$var$$ArrayBuffer.name != $c99e0eb453c76414$var$ARRAY_BUFFER;
    })) {
        $c99e0eb453c76414$var$$ArrayBuffer = function ArrayBuffer(length) {
            $2gG2X(this, $c99e0eb453c76414$var$$ArrayBuffer);
            return new $c99e0eb453c76414$var$BaseBuffer($b8nlA(length));
        };
        var $c99e0eb453c76414$var$ArrayBufferProto = $c99e0eb453c76414$var$$ArrayBuffer[$c99e0eb453c76414$var$PROTOTYPE] = $c99e0eb453c76414$var$BaseBuffer[$c99e0eb453c76414$var$PROTOTYPE];
        for(var $c99e0eb453c76414$var$keys = $c99e0eb453c76414$require$gOPN($c99e0eb453c76414$var$BaseBuffer), $c99e0eb453c76414$var$j = 0, $c99e0eb453c76414$var$key; $c99e0eb453c76414$var$keys.length > $c99e0eb453c76414$var$j;)if (!(($c99e0eb453c76414$var$key = $c99e0eb453c76414$var$keys[$c99e0eb453c76414$var$j++]) in $c99e0eb453c76414$var$$ArrayBuffer)) $5eEKu($c99e0eb453c76414$var$$ArrayBuffer, $c99e0eb453c76414$var$key, $c99e0eb453c76414$var$BaseBuffer[$c99e0eb453c76414$var$key]);
        if (!$8N1Ra) $c99e0eb453c76414$var$ArrayBufferProto.constructor = $c99e0eb453c76414$var$$ArrayBuffer;
    }
    // iOS Safari 7.x bug
    var $c99e0eb453c76414$var$view = new $c99e0eb453c76414$var$$DataView(new $c99e0eb453c76414$var$$ArrayBuffer(2));
    var $c99e0eb453c76414$var$$setInt8 = $c99e0eb453c76414$var$$DataView[$c99e0eb453c76414$var$PROTOTYPE].setInt8;
    $c99e0eb453c76414$var$view.setInt8(0, 2147483648);
    $c99e0eb453c76414$var$view.setInt8(1, 2147483649);
    if ($c99e0eb453c76414$var$view.getInt8(0) || !$c99e0eb453c76414$var$view.getInt8(1)) $j7N7T($c99e0eb453c76414$var$$DataView[$c99e0eb453c76414$var$PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
            $c99e0eb453c76414$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $c99e0eb453c76414$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        }
    }, true);
}
$7jOVX($c99e0eb453c76414$var$$ArrayBuffer, $c99e0eb453c76414$var$ARRAY_BUFFER);
$7jOVX($c99e0eb453c76414$var$$DataView, $c99e0eb453c76414$var$DATA_VIEW);
$5eEKu($c99e0eb453c76414$var$$DataView[$c99e0eb453c76414$var$PROTOTYPE], $4mWd7.VIEW, true);
module.exports[$c99e0eb453c76414$var$ARRAY_BUFFER] = $c99e0eb453c76414$var$$ArrayBuffer;
module.exports[$c99e0eb453c76414$var$DATA_VIEW] = $c99e0eb453c76414$var$$DataView;

});
parcelRegister("b8nlA", function(module, exports) {
// https://tc39.github.io/ecma262/#sec-toindex

var $8KZEi = parcelRequire("8KZEi");

var $6oAU6 = parcelRequire("6oAU6");
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = $8KZEi(it);
    var length = $6oAU6(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
};

});


parcelRegister("6pwKG", function(module, exports) {
'use strict';







































if ((parcelRequire("8csIg"))) {
    var $4aae7bbc53c565fa$var$LIBRARY = (parcelRequire("8N1Ra"));
    var $4aae7bbc53c565fa$var$global = (parcelRequire("fRJfg"));
    var $4aae7bbc53c565fa$var$fails = (parcelRequire("as1c7"));
    var $4aae7bbc53c565fa$var$$export = (parcelRequire("e88d0"));
    var $4aae7bbc53c565fa$var$$typed = (parcelRequire("4mWd7"));
    var $4aae7bbc53c565fa$var$$buffer = (parcelRequire("hjcH4"));
    var $4aae7bbc53c565fa$var$ctx = (parcelRequire("bKCrG"));
    var $4aae7bbc53c565fa$var$anInstance = (parcelRequire("2gG2X"));
    var $4aae7bbc53c565fa$var$propertyDesc = (parcelRequire("3PFaa"));
    var $4aae7bbc53c565fa$var$hide = (parcelRequire("5eEKu"));
    var $4aae7bbc53c565fa$var$redefineAll = (parcelRequire("j7N7T"));
    var $4aae7bbc53c565fa$var$toInteger = (parcelRequire("8KZEi"));
    var $4aae7bbc53c565fa$var$toLength = (parcelRequire("6oAU6"));
    var $4aae7bbc53c565fa$var$toIndex = (parcelRequire("b8nlA"));
    var $4aae7bbc53c565fa$var$toAbsoluteIndex = (parcelRequire("79CKs"));
    var $4aae7bbc53c565fa$var$toPrimitive = (parcelRequire("h0Sfn"));
    var $4aae7bbc53c565fa$var$has = (parcelRequire("fdFIW"));
    var $4aae7bbc53c565fa$var$classof = (parcelRequire("gTUcM"));
    var $4aae7bbc53c565fa$var$isObject = (parcelRequire("a8jEg"));
    var $4aae7bbc53c565fa$var$toObject = (parcelRequire("60LZ2"));
    var $4aae7bbc53c565fa$var$isArrayIter = (parcelRequire("7cwkx"));
    var $4aae7bbc53c565fa$var$create = (parcelRequire("9lrow"));
    var $4aae7bbc53c565fa$var$getPrototypeOf = (parcelRequire("eojdB"));
    var $4aae7bbc53c565fa$var$gOPN = (parcelRequire("1UujU")).f;
    var $4aae7bbc53c565fa$var$getIterFn = (parcelRequire("cNTiY"));
    var $4aae7bbc53c565fa$var$uid = (parcelRequire("5DFYi"));
    var $4aae7bbc53c565fa$var$wks = (parcelRequire("fjK8l"));
    var $4aae7bbc53c565fa$var$createArrayMethod = (parcelRequire("mgfCC"));
    var $4aae7bbc53c565fa$var$createArrayIncludes = (parcelRequire("6zju3"));
    var $4aae7bbc53c565fa$var$speciesConstructor = (parcelRequire("jHqVA"));
    var $4aae7bbc53c565fa$var$ArrayIterators = (parcelRequire("2jMtE"));
    var $4aae7bbc53c565fa$var$Iterators = (parcelRequire("eKE8G"));
    var $4aae7bbc53c565fa$var$$iterDetect = (parcelRequire("6W0vs"));
    var $4aae7bbc53c565fa$var$setSpecies = (parcelRequire("dQX1C"));
    var $4aae7bbc53c565fa$var$arrayFill = (parcelRequire("5Y7zp"));
    var $4aae7bbc53c565fa$var$arrayCopyWithin = (parcelRequire("1bFtr"));
    var $4aae7bbc53c565fa$var$$DP = (parcelRequire("hjnWf"));
    var $4aae7bbc53c565fa$var$$GOPD = (parcelRequire("6Vt7w"));
    var $4aae7bbc53c565fa$var$dP = $4aae7bbc53c565fa$var$$DP.f;
    var $4aae7bbc53c565fa$var$gOPD = $4aae7bbc53c565fa$var$$GOPD.f;
    var $4aae7bbc53c565fa$var$RangeError = $4aae7bbc53c565fa$var$global.RangeError;
    var $4aae7bbc53c565fa$var$TypeError = $4aae7bbc53c565fa$var$global.TypeError;
    var $4aae7bbc53c565fa$var$Uint8Array = $4aae7bbc53c565fa$var$global.Uint8Array;
    var $4aae7bbc53c565fa$var$ARRAY_BUFFER = 'ArrayBuffer';
    var $4aae7bbc53c565fa$var$SHARED_BUFFER = 'Shared' + $4aae7bbc53c565fa$var$ARRAY_BUFFER;
    var $4aae7bbc53c565fa$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var $4aae7bbc53c565fa$var$PROTOTYPE = 'prototype';
    var $4aae7bbc53c565fa$var$ArrayProto = Array[$4aae7bbc53c565fa$var$PROTOTYPE];
    var $4aae7bbc53c565fa$var$$ArrayBuffer = $4aae7bbc53c565fa$var$$buffer.ArrayBuffer;
    var $4aae7bbc53c565fa$var$$DataView = $4aae7bbc53c565fa$var$$buffer.DataView;
    var $4aae7bbc53c565fa$var$arrayForEach = $4aae7bbc53c565fa$var$createArrayMethod(0);
    var $4aae7bbc53c565fa$var$arrayFilter = $4aae7bbc53c565fa$var$createArrayMethod(2);
    var $4aae7bbc53c565fa$var$arraySome = $4aae7bbc53c565fa$var$createArrayMethod(3);
    var $4aae7bbc53c565fa$var$arrayEvery = $4aae7bbc53c565fa$var$createArrayMethod(4);
    var $4aae7bbc53c565fa$var$arrayFind = $4aae7bbc53c565fa$var$createArrayMethod(5);
    var $4aae7bbc53c565fa$var$arrayFindIndex = $4aae7bbc53c565fa$var$createArrayMethod(6);
    var $4aae7bbc53c565fa$var$arrayIncludes = $4aae7bbc53c565fa$var$createArrayIncludes(true);
    var $4aae7bbc53c565fa$var$arrayIndexOf = $4aae7bbc53c565fa$var$createArrayIncludes(false);
    var $4aae7bbc53c565fa$var$arrayValues = $4aae7bbc53c565fa$var$ArrayIterators.values;
    var $4aae7bbc53c565fa$var$arrayKeys = $4aae7bbc53c565fa$var$ArrayIterators.keys;
    var $4aae7bbc53c565fa$var$arrayEntries = $4aae7bbc53c565fa$var$ArrayIterators.entries;
    var $4aae7bbc53c565fa$var$arrayLastIndexOf = $4aae7bbc53c565fa$var$ArrayProto.lastIndexOf;
    var $4aae7bbc53c565fa$var$arrayReduce = $4aae7bbc53c565fa$var$ArrayProto.reduce;
    var $4aae7bbc53c565fa$var$arrayReduceRight = $4aae7bbc53c565fa$var$ArrayProto.reduceRight;
    var $4aae7bbc53c565fa$var$arrayJoin = $4aae7bbc53c565fa$var$ArrayProto.join;
    var $4aae7bbc53c565fa$var$arraySort = $4aae7bbc53c565fa$var$ArrayProto.sort;
    var $4aae7bbc53c565fa$var$arraySlice = $4aae7bbc53c565fa$var$ArrayProto.slice;
    var $4aae7bbc53c565fa$var$arrayToString = $4aae7bbc53c565fa$var$ArrayProto.toString;
    var $4aae7bbc53c565fa$var$arrayToLocaleString = $4aae7bbc53c565fa$var$ArrayProto.toLocaleString;
    var $4aae7bbc53c565fa$var$ITERATOR = $4aae7bbc53c565fa$var$wks('iterator');
    var $4aae7bbc53c565fa$var$TAG = $4aae7bbc53c565fa$var$wks('toStringTag');
    var $4aae7bbc53c565fa$var$TYPED_CONSTRUCTOR = $4aae7bbc53c565fa$var$uid('typed_constructor');
    var $4aae7bbc53c565fa$var$DEF_CONSTRUCTOR = $4aae7bbc53c565fa$var$uid('def_constructor');
    var $4aae7bbc53c565fa$var$ALL_CONSTRUCTORS = $4aae7bbc53c565fa$var$$typed.CONSTR;
    var $4aae7bbc53c565fa$var$TYPED_ARRAY = $4aae7bbc53c565fa$var$$typed.TYPED;
    var $4aae7bbc53c565fa$var$VIEW = $4aae7bbc53c565fa$var$$typed.VIEW;
    var $4aae7bbc53c565fa$var$WRONG_LENGTH = 'Wrong length!';
    var $4aae7bbc53c565fa$var$$map = $4aae7bbc53c565fa$var$createArrayMethod(1, function(O, length) {
        return $4aae7bbc53c565fa$var$allocate($4aae7bbc53c565fa$var$speciesConstructor(O, O[$4aae7bbc53c565fa$var$DEF_CONSTRUCTOR]), length);
    });
    var $4aae7bbc53c565fa$var$LITTLE_ENDIAN = $4aae7bbc53c565fa$var$fails(function() {
        // eslint-disable-next-line no-undef
        return new $4aae7bbc53c565fa$var$Uint8Array(new Uint16Array([
            1
        ]).buffer)[0] === 1;
    });
    var $4aae7bbc53c565fa$var$FORCED_SET = !!$4aae7bbc53c565fa$var$Uint8Array && !!$4aae7bbc53c565fa$var$Uint8Array[$4aae7bbc53c565fa$var$PROTOTYPE].set && $4aae7bbc53c565fa$var$fails(function() {
        new $4aae7bbc53c565fa$var$Uint8Array(1).set({});
    });
    var $4aae7bbc53c565fa$var$toOffset = function(it, BYTES) {
        var offset = $4aae7bbc53c565fa$var$toInteger(it);
        if (offset < 0 || offset % BYTES) throw $4aae7bbc53c565fa$var$RangeError('Wrong offset!');
        return offset;
    };
    var $4aae7bbc53c565fa$var$validate = function(it) {
        if ($4aae7bbc53c565fa$var$isObject(it) && $4aae7bbc53c565fa$var$TYPED_ARRAY in it) return it;
        throw $4aae7bbc53c565fa$var$TypeError(it + ' is not a typed array!');
    };
    var $4aae7bbc53c565fa$var$allocate = function(C, length) {
        if (!($4aae7bbc53c565fa$var$isObject(C) && $4aae7bbc53c565fa$var$TYPED_CONSTRUCTOR in C)) throw $4aae7bbc53c565fa$var$TypeError('It is not a typed array constructor!');
        return new C(length);
    };
    var $4aae7bbc53c565fa$var$speciesFromList = function(O, list) {
        return $4aae7bbc53c565fa$var$fromList($4aae7bbc53c565fa$var$speciesConstructor(O, O[$4aae7bbc53c565fa$var$DEF_CONSTRUCTOR]), list);
    };
    var $4aae7bbc53c565fa$var$fromList = function(C, list) {
        var index = 0;
        var length = list.length;
        var result = $4aae7bbc53c565fa$var$allocate(C, length);
        while(length > index)result[index] = list[index++];
        return result;
    };
    var $4aae7bbc53c565fa$var$addGetter = function(it, key, internal) {
        $4aae7bbc53c565fa$var$dP(it, key, {
            get: function() {
                return this._d[internal];
            }
        });
    };
    var $4aae7bbc53c565fa$var$$from = function from(source /* , mapfn, thisArg */ ) {
        var O = $4aae7bbc53c565fa$var$toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = $4aae7bbc53c565fa$var$getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !$4aae7bbc53c565fa$var$isArrayIter(iterFn)) {
            for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++)values.push(step.value);
            O = values;
        }
        if (mapping && aLen > 2) mapfn = $4aae7bbc53c565fa$var$ctx(mapfn, arguments[2], 2);
        for(i = 0, length = $4aae7bbc53c565fa$var$toLength(O.length), result = $4aae7bbc53c565fa$var$allocate(this, length); length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
        return result;
    };
    var $4aae7bbc53c565fa$var$$of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = $4aae7bbc53c565fa$var$allocate(this, length);
        while(length > index)result[index] = arguments[index++];
        return result;
    };
    // iOS Safari 6.x fails here
    var $4aae7bbc53c565fa$var$TO_LOCALE_BUG = !!$4aae7bbc53c565fa$var$Uint8Array && $4aae7bbc53c565fa$var$fails(function() {
        $4aae7bbc53c565fa$var$arrayToLocaleString.call(new $4aae7bbc53c565fa$var$Uint8Array(1));
    });
    var $4aae7bbc53c565fa$var$$toLocaleString = function toLocaleString() {
        return $4aae7bbc53c565fa$var$arrayToLocaleString.apply($4aae7bbc53c565fa$var$TO_LOCALE_BUG ? $4aae7bbc53c565fa$var$arraySlice.call($4aae7bbc53c565fa$var$validate(this)) : $4aae7bbc53c565fa$var$validate(this), arguments);
    };
    var $4aae7bbc53c565fa$var$proto = {
        copyWithin: function copyWithin(target, start /* , end */ ) {
            return $4aae7bbc53c565fa$var$arrayCopyWithin.call($4aae7bbc53c565fa$var$validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$arrayEvery($4aae7bbc53c565fa$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value /* , start, end */ ) {
            return $4aae7bbc53c565fa$var$arrayFill.apply($4aae7bbc53c565fa$var$validate(this), arguments);
        },
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$speciesFromList(this, $4aae7bbc53c565fa$var$arrayFilter($4aae7bbc53c565fa$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$arrayFind($4aae7bbc53c565fa$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$arrayFindIndex($4aae7bbc53c565fa$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn /* , thisArg */ ) {
            $4aae7bbc53c565fa$var$arrayForEach($4aae7bbc53c565fa$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement /* , fromIndex */ ) {
            return $4aae7bbc53c565fa$var$arrayIndexOf($4aae7bbc53c565fa$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement /* , fromIndex */ ) {
            return $4aae7bbc53c565fa$var$arrayIncludes($4aae7bbc53c565fa$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
            return $4aae7bbc53c565fa$var$arrayJoin.apply($4aae7bbc53c565fa$var$validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */ ) {
            return $4aae7bbc53c565fa$var$arrayLastIndexOf.apply($4aae7bbc53c565fa$var$validate(this), arguments);
        },
        map: function map(mapfn /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$$map($4aae7bbc53c565fa$var$validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $4aae7bbc53c565fa$var$arrayReduce.apply($4aae7bbc53c565fa$var$validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
            return $4aae7bbc53c565fa$var$arrayReduceRight.apply($4aae7bbc53c565fa$var$validate(this), arguments);
        },
        reverse: function reverse() {
            var that = this;
            var length = $4aae7bbc53c565fa$var$validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while(index < middle){
                value = that[index];
                that[index++] = that[--length];
                that[length] = value;
            }
            return that;
        },
        some: function some(callbackfn /* , thisArg */ ) {
            return $4aae7bbc53c565fa$var$arraySome($4aae7bbc53c565fa$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
            return $4aae7bbc53c565fa$var$arraySort.call($4aae7bbc53c565fa$var$validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
            var O = $4aae7bbc53c565fa$var$validate(this);
            var length = O.length;
            var $begin = $4aae7bbc53c565fa$var$toAbsoluteIndex(begin, length);
            return new ($4aae7bbc53c565fa$var$speciesConstructor(O, O[$4aae7bbc53c565fa$var$DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, $4aae7bbc53c565fa$var$toLength((end === undefined ? length : $4aae7bbc53c565fa$var$toAbsoluteIndex(end, length)) - $begin));
        }
    };
    var $4aae7bbc53c565fa$var$$slice = function slice(start, end) {
        return $4aae7bbc53c565fa$var$speciesFromList(this, $4aae7bbc53c565fa$var$arraySlice.call($4aae7bbc53c565fa$var$validate(this), start, end));
    };
    var $4aae7bbc53c565fa$var$$set = function set(arrayLike /* , offset */ ) {
        $4aae7bbc53c565fa$var$validate(this);
        var offset = $4aae7bbc53c565fa$var$toOffset(arguments[1], 1);
        var length = this.length;
        var src = $4aae7bbc53c565fa$var$toObject(arrayLike);
        var len = $4aae7bbc53c565fa$var$toLength(src.length);
        var index = 0;
        if (len + offset > length) throw $4aae7bbc53c565fa$var$RangeError($4aae7bbc53c565fa$var$WRONG_LENGTH);
        while(index < len)this[offset + index] = src[index++];
    };
    var $4aae7bbc53c565fa$var$$iterators = {
        entries: function entries() {
            return $4aae7bbc53c565fa$var$arrayEntries.call($4aae7bbc53c565fa$var$validate(this));
        },
        keys: function keys() {
            return $4aae7bbc53c565fa$var$arrayKeys.call($4aae7bbc53c565fa$var$validate(this));
        },
        values: function values() {
            return $4aae7bbc53c565fa$var$arrayValues.call($4aae7bbc53c565fa$var$validate(this));
        }
    };
    var $4aae7bbc53c565fa$var$isTAIndex = function(target, key) {
        return $4aae7bbc53c565fa$var$isObject(target) && target[$4aae7bbc53c565fa$var$TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };
    var $4aae7bbc53c565fa$var$$getDesc = function getOwnPropertyDescriptor(target, key) {
        return $4aae7bbc53c565fa$var$isTAIndex(target, key = $4aae7bbc53c565fa$var$toPrimitive(key, true)) ? $4aae7bbc53c565fa$var$propertyDesc(2, target[key]) : $4aae7bbc53c565fa$var$gOPD(target, key);
    };
    var $4aae7bbc53c565fa$var$$setDesc = function defineProperty(target, key, desc) {
        if ($4aae7bbc53c565fa$var$isTAIndex(target, key = $4aae7bbc53c565fa$var$toPrimitive(key, true)) && $4aae7bbc53c565fa$var$isObject(desc) && $4aae7bbc53c565fa$var$has(desc, 'value') && !$4aae7bbc53c565fa$var$has(desc, 'get') && !$4aae7bbc53c565fa$var$has(desc, 'set') && !desc.configurable && (!$4aae7bbc53c565fa$var$has(desc, 'writable') || desc.writable) && (!$4aae7bbc53c565fa$var$has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
        }
        return $4aae7bbc53c565fa$var$dP(target, key, desc);
    };
    if (!$4aae7bbc53c565fa$var$ALL_CONSTRUCTORS) {
        $4aae7bbc53c565fa$var$$GOPD.f = $4aae7bbc53c565fa$var$$getDesc;
        $4aae7bbc53c565fa$var$$DP.f = $4aae7bbc53c565fa$var$$setDesc;
    }
    $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.S + $4aae7bbc53c565fa$var$$export.F * !$4aae7bbc53c565fa$var$ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $4aae7bbc53c565fa$var$$getDesc,
        defineProperty: $4aae7bbc53c565fa$var$$setDesc
    });
    if ($4aae7bbc53c565fa$var$fails(function() {
        $4aae7bbc53c565fa$var$arrayToString.call({});
    })) $4aae7bbc53c565fa$var$arrayToString = $4aae7bbc53c565fa$var$arrayToLocaleString = function toString() {
        return $4aae7bbc53c565fa$var$arrayJoin.call(this);
    };
    var $4aae7bbc53c565fa$var$$TypedArrayPrototype$ = $4aae7bbc53c565fa$var$redefineAll({}, $4aae7bbc53c565fa$var$proto);
    $4aae7bbc53c565fa$var$redefineAll($4aae7bbc53c565fa$var$$TypedArrayPrototype$, $4aae7bbc53c565fa$var$$iterators);
    $4aae7bbc53c565fa$var$hide($4aae7bbc53c565fa$var$$TypedArrayPrototype$, $4aae7bbc53c565fa$var$ITERATOR, $4aae7bbc53c565fa$var$$iterators.values);
    $4aae7bbc53c565fa$var$redefineAll($4aae7bbc53c565fa$var$$TypedArrayPrototype$, {
        slice: $4aae7bbc53c565fa$var$$slice,
        set: $4aae7bbc53c565fa$var$$set,
        constructor: function() {},
        toString: $4aae7bbc53c565fa$var$arrayToString,
        toLocaleString: $4aae7bbc53c565fa$var$$toLocaleString
    });
    $4aae7bbc53c565fa$var$addGetter($4aae7bbc53c565fa$var$$TypedArrayPrototype$, 'buffer', 'b');
    $4aae7bbc53c565fa$var$addGetter($4aae7bbc53c565fa$var$$TypedArrayPrototype$, 'byteOffset', 'o');
    $4aae7bbc53c565fa$var$addGetter($4aae7bbc53c565fa$var$$TypedArrayPrototype$, 'byteLength', 'l');
    $4aae7bbc53c565fa$var$addGetter($4aae7bbc53c565fa$var$$TypedArrayPrototype$, 'length', 'e');
    $4aae7bbc53c565fa$var$dP($4aae7bbc53c565fa$var$$TypedArrayPrototype$, $4aae7bbc53c565fa$var$TAG, {
        get: function() {
            return this[$4aae7bbc53c565fa$var$TYPED_ARRAY];
        }
    });
    // eslint-disable-next-line max-statements
    module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = $4aae7bbc53c565fa$var$global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && $4aae7bbc53c565fa$var$getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$4aae7bbc53c565fa$var$$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[$4aae7bbc53c565fa$var$PROTOTYPE];
        var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, $4aae7bbc53c565fa$var$LITTLE_ENDIAN);
        };
        var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, $4aae7bbc53c565fa$var$LITTLE_ENDIAN);
        };
        var addElement = function(that, index) {
            $4aae7bbc53c565fa$var$dP(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $4aae7bbc53c565fa$var$anInstance(that, TypedArray, NAME, '_d');
                var index = 0;
                var offset = 0;
                var buffer, byteLength, length, klass;
                if (!$4aae7bbc53c565fa$var$isObject(data)) {
                    length = $4aae7bbc53c565fa$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $4aae7bbc53c565fa$var$$ArrayBuffer(byteLength);
                } else if (data instanceof $4aae7bbc53c565fa$var$$ArrayBuffer || (klass = $4aae7bbc53c565fa$var$classof(data)) == $4aae7bbc53c565fa$var$ARRAY_BUFFER || klass == $4aae7bbc53c565fa$var$SHARED_BUFFER) {
                    buffer = data;
                    offset = $4aae7bbc53c565fa$var$toOffset($offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $4aae7bbc53c565fa$var$RangeError($4aae7bbc53c565fa$var$WRONG_LENGTH);
                        byteLength = $len - offset;
                        if (byteLength < 0) throw $4aae7bbc53c565fa$var$RangeError($4aae7bbc53c565fa$var$WRONG_LENGTH);
                    } else {
                        byteLength = $4aae7bbc53c565fa$var$toLength($length) * BYTES;
                        if (byteLength + offset > $len) throw $4aae7bbc53c565fa$var$RangeError($4aae7bbc53c565fa$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($4aae7bbc53c565fa$var$TYPED_ARRAY in data) return $4aae7bbc53c565fa$var$fromList(TypedArray, data);
                else return $4aae7bbc53c565fa$var$$from.call(TypedArray, data);
                $4aae7bbc53c565fa$var$hide(that, '_d', {
                    b: buffer,
                    o: offset,
                    l: byteLength,
                    e: length,
                    v: new $4aae7bbc53c565fa$var$$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[$4aae7bbc53c565fa$var$PROTOTYPE] = $4aae7bbc53c565fa$var$create($4aae7bbc53c565fa$var$$TypedArrayPrototype$);
            $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!$4aae7bbc53c565fa$var$fails(function() {
            TypedArray(1);
        }) || !$4aae7bbc53c565fa$var$fails(function() {
            new TypedArray(-1); // eslint-disable-line no-new
        }) || !$4aae7bbc53c565fa$var$$iterDetect(function(iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $4aae7bbc53c565fa$var$anInstance(that, TypedArray, NAME);
                var klass;
                // `ws` module bug, temporarily remove validation length for Uint8Array
                // https://github.com/websockets/ws/pull/645
                if (!$4aae7bbc53c565fa$var$isObject(data)) return new Base($4aae7bbc53c565fa$var$toIndex(data));
                if (data instanceof $4aae7bbc53c565fa$var$$ArrayBuffer || (klass = $4aae7bbc53c565fa$var$classof(data)) == $4aae7bbc53c565fa$var$ARRAY_BUFFER || klass == $4aae7bbc53c565fa$var$SHARED_BUFFER) return $length !== undefined ? new Base(data, $4aae7bbc53c565fa$var$toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, $4aae7bbc53c565fa$var$toOffset($offset, BYTES)) : new Base(data);
                if ($4aae7bbc53c565fa$var$TYPED_ARRAY in data) return $4aae7bbc53c565fa$var$fromList(TypedArray, data);
                return $4aae7bbc53c565fa$var$$from.call(TypedArray, data);
            });
            $4aae7bbc53c565fa$var$arrayForEach(TAC !== Function.prototype ? $4aae7bbc53c565fa$var$gOPN(Base).concat($4aae7bbc53c565fa$var$gOPN(TAC)) : $4aae7bbc53c565fa$var$gOPN(Base), function(key) {
                if (!(key in TypedArray)) $4aae7bbc53c565fa$var$hide(TypedArray, key, Base[key]);
            });
            TypedArray[$4aae7bbc53c565fa$var$PROTOTYPE] = TypedArrayPrototype;
            if (!$4aae7bbc53c565fa$var$LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[$4aae7bbc53c565fa$var$ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $4aae7bbc53c565fa$var$$iterators.values;
        $4aae7bbc53c565fa$var$hide(TypedArray, $4aae7bbc53c565fa$var$TYPED_CONSTRUCTOR, true);
        $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, $4aae7bbc53c565fa$var$TYPED_ARRAY, NAME);
        $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, $4aae7bbc53c565fa$var$VIEW, true);
        $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, $4aae7bbc53c565fa$var$DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[$4aae7bbc53c565fa$var$TAG] != NAME : !($4aae7bbc53c565fa$var$TAG in TypedArrayPrototype)) $4aae7bbc53c565fa$var$dP(TypedArrayPrototype, $4aae7bbc53c565fa$var$TAG, {
            get: function() {
                return NAME;
            }
        });
        O[NAME] = TypedArray;
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.G + $4aae7bbc53c565fa$var$$export.W + $4aae7bbc53c565fa$var$$export.F * (TypedArray != Base), O);
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
        });
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.S + $4aae7bbc53c565fa$var$$export.F * $4aae7bbc53c565fa$var$fails(function() {
            Base.of.call(TypedArray, 1);
        }), NAME, {
            from: $4aae7bbc53c565fa$var$$from,
            of: $4aae7bbc53c565fa$var$$of
        });
        if (!($4aae7bbc53c565fa$var$BYTES_PER_ELEMENT in TypedArrayPrototype)) $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, $4aae7bbc53c565fa$var$BYTES_PER_ELEMENT, BYTES);
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.P, NAME, $4aae7bbc53c565fa$var$proto);
        $4aae7bbc53c565fa$var$setSpecies(NAME);
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.P + $4aae7bbc53c565fa$var$$export.F * $4aae7bbc53c565fa$var$FORCED_SET, NAME, {
            set: $4aae7bbc53c565fa$var$$set
        });
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.P + $4aae7bbc53c565fa$var$$export.F * !CORRECT_ITER_NAME, NAME, $4aae7bbc53c565fa$var$$iterators);
        if (!$4aae7bbc53c565fa$var$LIBRARY && TypedArrayPrototype.toString != $4aae7bbc53c565fa$var$arrayToString) TypedArrayPrototype.toString = $4aae7bbc53c565fa$var$arrayToString;
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.P + $4aae7bbc53c565fa$var$$export.F * $4aae7bbc53c565fa$var$fails(function() {
            new TypedArray(1).slice();
        }), NAME, {
            slice: $4aae7bbc53c565fa$var$$slice
        });
        $4aae7bbc53c565fa$var$$export($4aae7bbc53c565fa$var$$export.P + $4aae7bbc53c565fa$var$$export.F * ($4aae7bbc53c565fa$var$fails(function() {
            return [
                1,
                2
            ].toLocaleString() != new TypedArray([
                1,
                2
            ]).toLocaleString();
        }) || !$4aae7bbc53c565fa$var$fails(function() {
            TypedArrayPrototype.toLocaleString.call([
                1,
                2
            ]);
        })), NAME, {
            toLocaleString: $4aae7bbc53c565fa$var$$toLocaleString
        });
        $4aae7bbc53c565fa$var$Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!$4aae7bbc53c565fa$var$LIBRARY && !CORRECT_ITER_NAME) $4aae7bbc53c565fa$var$hide(TypedArrayPrototype, $4aae7bbc53c565fa$var$ITERATOR, $iterator);
    };
} else module.exports = function() {};

});

parcelRegister("6Gb4O", function(module, exports) {
// all object keys, includes non-enumerable and symbols

var $1UujU = parcelRequire("1UujU");

var $87NIy = parcelRequire("87NIy");

var $cYx5q = parcelRequire("cYx5q");

var $fRJfg = parcelRequire("fRJfg");
var $4dcf41e7e75230aa$require$Reflect = $fRJfg.Reflect;
module.exports = $4dcf41e7e75230aa$require$Reflect && $4dcf41e7e75230aa$require$Reflect.ownKeys || function ownKeys(it) {
    var keys = $1UujU.f($cYx5q(it));
    var getSymbols = $87NIy.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

});

parcelRegister("1BSkJ", function(module, exports) {

var $8csIg = parcelRequire("8csIg");

var $gHcyI = parcelRequire("gHcyI");

var $h1IuT = parcelRequire("h1IuT");

var $jHwil = parcelRequire("jHwil");
var $12c364a0c92f55c6$require$isEnum = $jHwil.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $h1IuT(it);
        var keys = $gHcyI(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$8csIg || $12c364a0c92f55c6$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("2V8Oi", function(module, exports) {
'use strict';



// Forced replacement prototype accessors methods
module.exports = (parcelRequire("8N1Ra")) || !(parcelRequire("as1c7"))(function() {
    var K = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call
    __defineSetter__.call(null, K, function() {});
    delete (parcelRequire("fRJfg"))[K];
});

});

parcelRegister("8qrPW", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $gTUcM = parcelRequire("gTUcM");

var $lDFri = parcelRequire("lDFri");
module.exports = function(NAME) {
    return function toJSON() {
        if ($gTUcM(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return $lDFri(this);
    };
};

});
parcelRegister("lDFri", function(module, exports) {

var $k17JG = parcelRequire("k17JG");
module.exports = function(iter, ITERATOR) {
    var result = [];
    $k17JG(iter, false, result.push, result, ITERATOR);
    return result;
};

});


parcelRegister("kM8Jz", function(module, exports) {
'use strict';

var $e88d0 = parcelRequire("e88d0");
module.exports = function(COLLECTION) {
    $e88d0($e88d0.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});

parcelRegister("aWhSb", function(module, exports) {
'use strict';

var $e88d0 = parcelRequire("e88d0");

var $3fVrL = parcelRequire("3fVrL");

var $bKCrG = parcelRequire("bKCrG");

var $k17JG = parcelRequire("k17JG");
module.exports = function(COLLECTION) {
    $e88d0($e88d0.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $3fVrL(this);
            mapping = mapFn !== undefined;
            if (mapping) $3fVrL(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $bKCrG(mapFn, arguments[2], 2);
                $k17JG(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $k17JG(source, false, A.push, A);
            return new this(A);
        }
    });
};

});

parcelRegister("kvqJ5", function(module, exports) {
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 || x != x || inLow != inLow || inHigh != inHigh || outLow != outLow || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

});

parcelRegister("1JDbu", function(module, exports) {
module.exports = function(regExp, replace) {
    var replacer = replace === Object(replace) ? function(part) {
        return replace[part];
    } : replace;
    return function(it) {
        return String(it).replace(regExp, replacer);
    };
};

});

parcelRegister("lfkdM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f77aaf397ca6b7e6$export$ffb0004e005737fa, (v) => $f77aaf397ca6b7e6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $f77aaf397ca6b7e6$export$34b9dba7ce09269b, (v) => $f77aaf397ca6b7e6$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $f77aaf397ca6b7e6$export$25062201e9e25d76, (v) => $f77aaf397ca6b7e6$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f77aaf397ca6b7e6$export$ffb0004e005737fa;
var $f77aaf397ca6b7e6$export$34b9dba7ce09269b;
var $f77aaf397ca6b7e6$export$25062201e9e25d76;
'use strict';

var $bNh2M = parcelRequire("bNh2M");
var $f77aaf397ca6b7e6$var$k = Symbol.for("react.element"), $f77aaf397ca6b7e6$var$l = Symbol.for("react.fragment"), $f77aaf397ca6b7e6$var$m = Object.prototype.hasOwnProperty, $f77aaf397ca6b7e6$var$n = $bNh2M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $f77aaf397ca6b7e6$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f77aaf397ca6b7e6$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$f77aaf397ca6b7e6$var$m.call(a, b) && !$f77aaf397ca6b7e6$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $f77aaf397ca6b7e6$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $f77aaf397ca6b7e6$var$n.current
    };
}
$f77aaf397ca6b7e6$export$ffb0004e005737fa = $f77aaf397ca6b7e6$var$l;
$f77aaf397ca6b7e6$export$34b9dba7ce09269b = $f77aaf397ca6b7e6$var$q;
$f77aaf397ca6b7e6$export$25062201e9e25d76 = $f77aaf397ca6b7e6$var$q;

});
parcelRegister("bNh2M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aIrcY"));

});
parcelRegister("aIrcY", function(module, exports) {

$parcel$export(module.exports, "Children", () => $7cd31e6f98445534$export$dca3b0875bd9a954, (v) => $7cd31e6f98445534$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7cd31e6f98445534$export$16fa2f45be04daa8, (v) => $7cd31e6f98445534$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7cd31e6f98445534$export$ffb0004e005737fa, (v) => $7cd31e6f98445534$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7cd31e6f98445534$export$e2c29f18771995cb, (v) => $7cd31e6f98445534$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7cd31e6f98445534$export$221d75b3f55bb0bd, (v) => $7cd31e6f98445534$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7cd31e6f98445534$export$5f8d39834fd61797, (v) => $7cd31e6f98445534$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7cd31e6f98445534$export$74bf444e3cd11ea5, (v) => $7cd31e6f98445534$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7cd31e6f98445534$export$ae55be85d98224ed, (v) => $7cd31e6f98445534$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $7cd31e6f98445534$export$3ba232387fd5d6dd, (v) => $7cd31e6f98445534$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $7cd31e6f98445534$export$e530037191fcd5d7, (v) => $7cd31e6f98445534$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7cd31e6f98445534$export$fd42f52fd3ae1109, (v) => $7cd31e6f98445534$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7cd31e6f98445534$export$c8a8987d4410bf2d, (v) => $7cd31e6f98445534$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7cd31e6f98445534$export$d38cd72104c1f0e9, (v) => $7cd31e6f98445534$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7cd31e6f98445534$export$7d1e3a5e95ceca43, (v) => $7cd31e6f98445534$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7cd31e6f98445534$export$257a8862b851cb5b, (v) => $7cd31e6f98445534$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7cd31e6f98445534$export$a8257692ac88316c, (v) => $7cd31e6f98445534$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7cd31e6f98445534$export$488013bae63b21da, (v) => $7cd31e6f98445534$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7cd31e6f98445534$export$7c73462e0d25e514, (v) => $7cd31e6f98445534$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $7cd31e6f98445534$export$7568632d0d33d16d, (v) => $7cd31e6f98445534$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $7cd31e6f98445534$export$88948ce120ea2619, (v) => $7cd31e6f98445534$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $7cd31e6f98445534$export$35808ee640e87ca7, (v) => $7cd31e6f98445534$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7cd31e6f98445534$export$fae74005e78b1a27, (v) => $7cd31e6f98445534$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7cd31e6f98445534$export$dc8fbce3eb94dc1e, (v) => $7cd31e6f98445534$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $7cd31e6f98445534$export$6a7bc4e911dc01cf, (v) => $7cd31e6f98445534$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $7cd31e6f98445534$export$6d9c69b0de29b591, (v) => $7cd31e6f98445534$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $7cd31e6f98445534$export$f680877a34711e37, (v) => $7cd31e6f98445534$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7cd31e6f98445534$export$d5a552a76deda3c2, (v) => $7cd31e6f98445534$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $7cd31e6f98445534$export$aaabe4eda9ed9969, (v) => $7cd31e6f98445534$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7cd31e6f98445534$export$e5c5a5f917a5871c, (v) => $7cd31e6f98445534$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7cd31e6f98445534$export$1538c33de8887b59, (v) => $7cd31e6f98445534$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7cd31e6f98445534$export$13e3392192263954, (v) => $7cd31e6f98445534$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7cd31e6f98445534$export$b8f5890fc79d6aca, (v) => $7cd31e6f98445534$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7cd31e6f98445534$export$60241385465d0a34, (v) => $7cd31e6f98445534$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $7cd31e6f98445534$export$306c0aa65ff9ec16, (v) => $7cd31e6f98445534$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $7cd31e6f98445534$export$7b286972b8d8ccbf, (v) => $7cd31e6f98445534$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $7cd31e6f98445534$export$83d89fbfd8236492, (v) => $7cd31e6f98445534$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cd31e6f98445534$export$dca3b0875bd9a954;
var $7cd31e6f98445534$export$16fa2f45be04daa8;
var $7cd31e6f98445534$export$ffb0004e005737fa;
var $7cd31e6f98445534$export$e2c29f18771995cb;
var $7cd31e6f98445534$export$221d75b3f55bb0bd;
var $7cd31e6f98445534$export$5f8d39834fd61797;
var $7cd31e6f98445534$export$74bf444e3cd11ea5;
var $7cd31e6f98445534$export$ae55be85d98224ed;
var $7cd31e6f98445534$export$3ba232387fd5d6dd;
var $7cd31e6f98445534$export$e530037191fcd5d7;
var $7cd31e6f98445534$export$fd42f52fd3ae1109;
var $7cd31e6f98445534$export$c8a8987d4410bf2d;
var $7cd31e6f98445534$export$d38cd72104c1f0e9;
var $7cd31e6f98445534$export$7d1e3a5e95ceca43;
var $7cd31e6f98445534$export$257a8862b851cb5b;
var $7cd31e6f98445534$export$a8257692ac88316c;
var $7cd31e6f98445534$export$488013bae63b21da;
var $7cd31e6f98445534$export$7c73462e0d25e514;
var $7cd31e6f98445534$export$7568632d0d33d16d;
var $7cd31e6f98445534$export$88948ce120ea2619;
var $7cd31e6f98445534$export$35808ee640e87ca7;
var $7cd31e6f98445534$export$fae74005e78b1a27;
var $7cd31e6f98445534$export$dc8fbce3eb94dc1e;
var $7cd31e6f98445534$export$6a7bc4e911dc01cf;
var $7cd31e6f98445534$export$6d9c69b0de29b591;
var $7cd31e6f98445534$export$f680877a34711e37;
var $7cd31e6f98445534$export$d5a552a76deda3c2;
var $7cd31e6f98445534$export$aaabe4eda9ed9969;
var $7cd31e6f98445534$export$e5c5a5f917a5871c;
var $7cd31e6f98445534$export$1538c33de8887b59;
var $7cd31e6f98445534$export$13e3392192263954;
var $7cd31e6f98445534$export$b8f5890fc79d6aca;
var $7cd31e6f98445534$export$60241385465d0a34;
var $7cd31e6f98445534$export$306c0aa65ff9ec16;
var $7cd31e6f98445534$export$7b286972b8d8ccbf;
var $7cd31e6f98445534$export$83d89fbfd8236492;
'use strict';
var $7cd31e6f98445534$var$l = Symbol.for("react.element"), $7cd31e6f98445534$var$n = Symbol.for("react.portal"), $7cd31e6f98445534$var$p = Symbol.for("react.fragment"), $7cd31e6f98445534$var$q = Symbol.for("react.strict_mode"), $7cd31e6f98445534$var$r = Symbol.for("react.profiler"), $7cd31e6f98445534$var$t = Symbol.for("react.provider"), $7cd31e6f98445534$var$u = Symbol.for("react.context"), $7cd31e6f98445534$var$v = Symbol.for("react.forward_ref"), $7cd31e6f98445534$var$w = Symbol.for("react.suspense"), $7cd31e6f98445534$var$x = Symbol.for("react.memo"), $7cd31e6f98445534$var$y = Symbol.for("react.lazy"), $7cd31e6f98445534$var$z = Symbol.iterator;
function $7cd31e6f98445534$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7cd31e6f98445534$var$z && a[$7cd31e6f98445534$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7cd31e6f98445534$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7cd31e6f98445534$var$C = Object.assign, $7cd31e6f98445534$var$D = {};
function $7cd31e6f98445534$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cd31e6f98445534$var$D;
    this.updater = e || $7cd31e6f98445534$var$B;
}
$7cd31e6f98445534$var$E.prototype.isReactComponent = {};
$7cd31e6f98445534$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7cd31e6f98445534$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7cd31e6f98445534$var$F() {}
$7cd31e6f98445534$var$F.prototype = $7cd31e6f98445534$var$E.prototype;
function $7cd31e6f98445534$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cd31e6f98445534$var$D;
    this.updater = e || $7cd31e6f98445534$var$B;
}
var $7cd31e6f98445534$var$H = $7cd31e6f98445534$var$G.prototype = new $7cd31e6f98445534$var$F;
$7cd31e6f98445534$var$H.constructor = $7cd31e6f98445534$var$G;
$7cd31e6f98445534$var$C($7cd31e6f98445534$var$H, $7cd31e6f98445534$var$E.prototype);
$7cd31e6f98445534$var$H.isPureReactComponent = !0;
var $7cd31e6f98445534$var$I = Array.isArray, $7cd31e6f98445534$var$J = Object.prototype.hasOwnProperty, $7cd31e6f98445534$var$K = {
    current: null
}, $7cd31e6f98445534$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7cd31e6f98445534$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7cd31e6f98445534$var$J.call(b, d) && !$7cd31e6f98445534$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7cd31e6f98445534$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7cd31e6f98445534$var$K.current
    };
}
function $7cd31e6f98445534$var$N(a, b) {
    return {
        $$typeof: $7cd31e6f98445534$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7cd31e6f98445534$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7cd31e6f98445534$var$l;
}
function $7cd31e6f98445534$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7cd31e6f98445534$var$P = /\/+/g;
function $7cd31e6f98445534$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7cd31e6f98445534$var$escape("" + a.key) : b.toString(36);
}
function $7cd31e6f98445534$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7cd31e6f98445534$var$l:
                case $7cd31e6f98445534$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7cd31e6f98445534$var$Q(h, 0) : d, $7cd31e6f98445534$var$I(c) ? (e = "", null != a && (e = a.replace($7cd31e6f98445534$var$P, "$&/") + "/"), $7cd31e6f98445534$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7cd31e6f98445534$var$O(c) && (c = $7cd31e6f98445534$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7cd31e6f98445534$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7cd31e6f98445534$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7cd31e6f98445534$var$Q(k, g);
        h += $7cd31e6f98445534$var$R(k, b, e, f, c);
    }
    else if (f = $7cd31e6f98445534$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7cd31e6f98445534$var$Q(k, g++), h += $7cd31e6f98445534$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7cd31e6f98445534$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7cd31e6f98445534$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7cd31e6f98445534$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7cd31e6f98445534$var$U = {
    current: null
}, $7cd31e6f98445534$var$V = {
    transition: null
}, $7cd31e6f98445534$var$W = {
    ReactCurrentDispatcher: $7cd31e6f98445534$var$U,
    ReactCurrentBatchConfig: $7cd31e6f98445534$var$V,
    ReactCurrentOwner: $7cd31e6f98445534$var$K
};
function $7cd31e6f98445534$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7cd31e6f98445534$export$dca3b0875bd9a954 = {
    map: $7cd31e6f98445534$var$S,
    forEach: function(a, b, e) {
        $7cd31e6f98445534$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7cd31e6f98445534$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7cd31e6f98445534$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7cd31e6f98445534$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7cd31e6f98445534$export$16fa2f45be04daa8 = $7cd31e6f98445534$var$E;
$7cd31e6f98445534$export$ffb0004e005737fa = $7cd31e6f98445534$var$p;
$7cd31e6f98445534$export$e2c29f18771995cb = $7cd31e6f98445534$var$r;
$7cd31e6f98445534$export$221d75b3f55bb0bd = $7cd31e6f98445534$var$G;
$7cd31e6f98445534$export$5f8d39834fd61797 = $7cd31e6f98445534$var$q;
$7cd31e6f98445534$export$74bf444e3cd11ea5 = $7cd31e6f98445534$var$w;
$7cd31e6f98445534$export$ae55be85d98224ed = $7cd31e6f98445534$var$W;
$7cd31e6f98445534$export$3ba232387fd5d6dd = $7cd31e6f98445534$var$X;
$7cd31e6f98445534$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7cd31e6f98445534$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7cd31e6f98445534$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7cd31e6f98445534$var$J.call(b, f) && !$7cd31e6f98445534$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7cd31e6f98445534$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7cd31e6f98445534$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7cd31e6f98445534$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7cd31e6f98445534$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7cd31e6f98445534$export$c8a8987d4410bf2d = $7cd31e6f98445534$var$M;
$7cd31e6f98445534$export$d38cd72104c1f0e9 = function(a) {
    var b = $7cd31e6f98445534$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7cd31e6f98445534$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7cd31e6f98445534$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7cd31e6f98445534$var$v,
        render: a
    };
};
$7cd31e6f98445534$export$a8257692ac88316c = $7cd31e6f98445534$var$O;
$7cd31e6f98445534$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7cd31e6f98445534$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7cd31e6f98445534$var$T
    };
};
$7cd31e6f98445534$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7cd31e6f98445534$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7cd31e6f98445534$export$7568632d0d33d16d = function(a) {
    var b = $7cd31e6f98445534$var$V.transition;
    $7cd31e6f98445534$var$V.transition = {};
    try {
        a();
    } finally{
        $7cd31e6f98445534$var$V.transition = b;
    }
};
$7cd31e6f98445534$export$88948ce120ea2619 = $7cd31e6f98445534$var$X;
$7cd31e6f98445534$export$35808ee640e87ca7 = function(a, b) {
    return $7cd31e6f98445534$var$U.current.useCallback(a, b);
};
$7cd31e6f98445534$export$fae74005e78b1a27 = function(a) {
    return $7cd31e6f98445534$var$U.current.useContext(a);
};
$7cd31e6f98445534$export$dc8fbce3eb94dc1e = function() {};
$7cd31e6f98445534$export$6a7bc4e911dc01cf = function(a) {
    return $7cd31e6f98445534$var$U.current.useDeferredValue(a);
};
$7cd31e6f98445534$export$6d9c69b0de29b591 = function(a, b) {
    return $7cd31e6f98445534$var$U.current.useEffect(a, b);
};
$7cd31e6f98445534$export$f680877a34711e37 = function() {
    return $7cd31e6f98445534$var$U.current.useId();
};
$7cd31e6f98445534$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7cd31e6f98445534$var$U.current.useImperativeHandle(a, b, e);
};
$7cd31e6f98445534$export$aaabe4eda9ed9969 = function(a, b) {
    return $7cd31e6f98445534$var$U.current.useInsertionEffect(a, b);
};
$7cd31e6f98445534$export$e5c5a5f917a5871c = function(a, b) {
    return $7cd31e6f98445534$var$U.current.useLayoutEffect(a, b);
};
$7cd31e6f98445534$export$1538c33de8887b59 = function(a, b) {
    return $7cd31e6f98445534$var$U.current.useMemo(a, b);
};
$7cd31e6f98445534$export$13e3392192263954 = function(a, b, e) {
    return $7cd31e6f98445534$var$U.current.useReducer(a, b, e);
};
$7cd31e6f98445534$export$b8f5890fc79d6aca = function(a) {
    return $7cd31e6f98445534$var$U.current.useRef(a);
};
$7cd31e6f98445534$export$60241385465d0a34 = function(a) {
    return $7cd31e6f98445534$var$U.current.useState(a);
};
$7cd31e6f98445534$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7cd31e6f98445534$var$U.current.useSyncExternalStore(a, b, e);
};
$7cd31e6f98445534$export$7b286972b8d8ccbf = function() {
    return $7cd31e6f98445534$var$U.current.useTransition();
};
$7cd31e6f98445534$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("4JlCC", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $371c230a09dd78be$export$ae55be85d98224ed, (v) => $371c230a09dd78be$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $371c230a09dd78be$export$d39a5bbd09211389, (v) => $371c230a09dd78be$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $371c230a09dd78be$export$882461b6382ed46c, (v) => $371c230a09dd78be$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $371c230a09dd78be$export$466bfc07425424d5, (v) => $371c230a09dd78be$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $371c230a09dd78be$export$cd75ccfd720a3cd4, (v) => $371c230a09dd78be$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $371c230a09dd78be$export$fa8d919ba61d84db, (v) => $371c230a09dd78be$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $371c230a09dd78be$export$757ceba2d55c277e, (v) => $371c230a09dd78be$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $371c230a09dd78be$export$b3890eb0ae9dca99, (v) => $371c230a09dd78be$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $371c230a09dd78be$export$502457920280e6be, (v) => $371c230a09dd78be$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $371c230a09dd78be$export$c78a37762a8d58e1, (v) => $371c230a09dd78be$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $371c230a09dd78be$export$dc54d992c10e8a18, (v) => $371c230a09dd78be$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $371c230a09dd78be$export$83d89fbfd8236492, (v) => $371c230a09dd78be$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $371c230a09dd78be$export$ae55be85d98224ed;
var $371c230a09dd78be$export$d39a5bbd09211389;
var $371c230a09dd78be$export$882461b6382ed46c;
var $371c230a09dd78be$export$466bfc07425424d5;
var $371c230a09dd78be$export$cd75ccfd720a3cd4;
var $371c230a09dd78be$export$fa8d919ba61d84db;
var $371c230a09dd78be$export$757ceba2d55c277e;
var $371c230a09dd78be$export$b3890eb0ae9dca99;
var $371c230a09dd78be$export$502457920280e6be;
var $371c230a09dd78be$export$c78a37762a8d58e1;
var $371c230a09dd78be$export$dc54d992c10e8a18;
var $371c230a09dd78be$export$83d89fbfd8236492;
'use strict';

var $bNh2M = parcelRequire("bNh2M");

var $hOwrP = parcelRequire("hOwrP");
function $371c230a09dd78be$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $371c230a09dd78be$var$da = new Set, $371c230a09dd78be$var$ea = {};
function $371c230a09dd78be$var$fa(a, b) {
    $371c230a09dd78be$var$ha(a, b);
    $371c230a09dd78be$var$ha(a + "Capture", b);
}
function $371c230a09dd78be$var$ha(a, b) {
    $371c230a09dd78be$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$371c230a09dd78be$var$da.add(b[a]);
}
var $371c230a09dd78be$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $371c230a09dd78be$var$ja = Object.prototype.hasOwnProperty, $371c230a09dd78be$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $371c230a09dd78be$var$la = {}, $371c230a09dd78be$var$ma = {};
function $371c230a09dd78be$var$oa(a) {
    if ($371c230a09dd78be$var$ja.call($371c230a09dd78be$var$ma, a)) return !0;
    if ($371c230a09dd78be$var$ja.call($371c230a09dd78be$var$la, a)) return !1;
    if ($371c230a09dd78be$var$ka.test(a)) return $371c230a09dd78be$var$ma[a] = !0;
    $371c230a09dd78be$var$la[a] = !0;
    return !1;
}
function $371c230a09dd78be$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $371c230a09dd78be$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $371c230a09dd78be$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $371c230a09dd78be$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $371c230a09dd78be$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $371c230a09dd78be$var$z[b] = new $371c230a09dd78be$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $371c230a09dd78be$var$ra = /[\-:]([a-z])/g;
function $371c230a09dd78be$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($371c230a09dd78be$var$ra, $371c230a09dd78be$var$sa);
    $371c230a09dd78be$var$z[b] = new $371c230a09dd78be$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($371c230a09dd78be$var$ra, $371c230a09dd78be$var$sa);
    $371c230a09dd78be$var$z[b] = new $371c230a09dd78be$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($371c230a09dd78be$var$ra, $371c230a09dd78be$var$sa);
    $371c230a09dd78be$var$z[b] = new $371c230a09dd78be$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$371c230a09dd78be$var$z.xlinkHref = new $371c230a09dd78be$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $371c230a09dd78be$var$z[a] = new $371c230a09dd78be$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $371c230a09dd78be$var$ta(a, b, c, d) {
    var e = $371c230a09dd78be$var$z.hasOwnProperty(b) ? $371c230a09dd78be$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $371c230a09dd78be$var$qa(b, c, e, d) && (c = null), d || null === e ? $371c230a09dd78be$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $371c230a09dd78be$var$ua = $bNh2M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $371c230a09dd78be$var$va = Symbol.for("react.element"), $371c230a09dd78be$var$wa = Symbol.for("react.portal"), $371c230a09dd78be$var$ya = Symbol.for("react.fragment"), $371c230a09dd78be$var$za = Symbol.for("react.strict_mode"), $371c230a09dd78be$var$Aa = Symbol.for("react.profiler"), $371c230a09dd78be$var$Ba = Symbol.for("react.provider"), $371c230a09dd78be$var$Ca = Symbol.for("react.context"), $371c230a09dd78be$var$Da = Symbol.for("react.forward_ref"), $371c230a09dd78be$var$Ea = Symbol.for("react.suspense"), $371c230a09dd78be$var$Fa = Symbol.for("react.suspense_list"), $371c230a09dd78be$var$Ga = Symbol.for("react.memo"), $371c230a09dd78be$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $371c230a09dd78be$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $371c230a09dd78be$var$Ja = Symbol.iterator;
function $371c230a09dd78be$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $371c230a09dd78be$var$Ja && a[$371c230a09dd78be$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $371c230a09dd78be$var$A = Object.assign, $371c230a09dd78be$var$La;
function $371c230a09dd78be$var$Ma(a) {
    if (void 0 === $371c230a09dd78be$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $371c230a09dd78be$var$La = b && b[1] || "";
    }
    return "\n" + $371c230a09dd78be$var$La + a;
}
var $371c230a09dd78be$var$Na = !1;
function $371c230a09dd78be$var$Oa(a, b) {
    if (!a || $371c230a09dd78be$var$Na) return "";
    $371c230a09dd78be$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $371c230a09dd78be$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $371c230a09dd78be$var$Ma(a) : "";
}
function $371c230a09dd78be$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $371c230a09dd78be$var$Ma(a.type);
        case 16:
            return $371c230a09dd78be$var$Ma("Lazy");
        case 13:
            return $371c230a09dd78be$var$Ma("Suspense");
        case 19:
            return $371c230a09dd78be$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $371c230a09dd78be$var$Oa(a.type, !1), a;
        case 11:
            return a = $371c230a09dd78be$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $371c230a09dd78be$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $371c230a09dd78be$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $371c230a09dd78be$var$ya:
            return "Fragment";
        case $371c230a09dd78be$var$wa:
            return "Portal";
        case $371c230a09dd78be$var$Aa:
            return "Profiler";
        case $371c230a09dd78be$var$za:
            return "StrictMode";
        case $371c230a09dd78be$var$Ea:
            return "Suspense";
        case $371c230a09dd78be$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $371c230a09dd78be$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $371c230a09dd78be$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $371c230a09dd78be$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $371c230a09dd78be$var$Ga:
            return b = a.displayName || null, null !== b ? b : $371c230a09dd78be$var$Qa(a.type) || "Memo";
        case $371c230a09dd78be$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $371c230a09dd78be$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $371c230a09dd78be$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $371c230a09dd78be$var$Qa(b);
        case 8:
            return b === $371c230a09dd78be$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $371c230a09dd78be$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $371c230a09dd78be$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $371c230a09dd78be$var$Ua(a) {
    var b = $371c230a09dd78be$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $371c230a09dd78be$var$Va(a) {
    a._valueTracker || (a._valueTracker = $371c230a09dd78be$var$Ua(a));
}
function $371c230a09dd78be$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $371c230a09dd78be$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $371c230a09dd78be$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $371c230a09dd78be$var$Ya(a, b) {
    var c = b.checked;
    return $371c230a09dd78be$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $371c230a09dd78be$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $371c230a09dd78be$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $371c230a09dd78be$var$ab(a, b) {
    b = b.checked;
    null != b && $371c230a09dd78be$var$ta(a, "checked", b, !1);
}
function $371c230a09dd78be$var$bb(a, b) {
    $371c230a09dd78be$var$ab(a, b);
    var c = $371c230a09dd78be$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $371c230a09dd78be$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $371c230a09dd78be$var$cb(a, b.type, $371c230a09dd78be$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $371c230a09dd78be$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $371c230a09dd78be$var$cb(a, b, c) {
    if ("number" !== b || $371c230a09dd78be$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $371c230a09dd78be$var$eb = Array.isArray;
function $371c230a09dd78be$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $371c230a09dd78be$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $371c230a09dd78be$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($371c230a09dd78be$var$p(91));
    return $371c230a09dd78be$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $371c230a09dd78be$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($371c230a09dd78be$var$p(92));
            if ($371c230a09dd78be$var$eb(c)) {
                if (1 < c.length) throw Error($371c230a09dd78be$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $371c230a09dd78be$var$Sa(c)
    };
}
function $371c230a09dd78be$var$ib(a, b) {
    var c = $371c230a09dd78be$var$Sa(b.value), d = $371c230a09dd78be$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $371c230a09dd78be$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $371c230a09dd78be$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $371c230a09dd78be$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $371c230a09dd78be$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $371c230a09dd78be$var$mb, $371c230a09dd78be$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $371c230a09dd78be$var$mb = $371c230a09dd78be$var$mb || document.createElement("div");
        $371c230a09dd78be$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $371c230a09dd78be$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $371c230a09dd78be$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $371c230a09dd78be$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $371c230a09dd78be$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($371c230a09dd78be$var$pb).forEach(function(a) {
    $371c230a09dd78be$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $371c230a09dd78be$var$pb[b] = $371c230a09dd78be$var$pb[a];
    });
});
function $371c230a09dd78be$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $371c230a09dd78be$var$pb.hasOwnProperty(a) && $371c230a09dd78be$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $371c230a09dd78be$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $371c230a09dd78be$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $371c230a09dd78be$var$tb = $371c230a09dd78be$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $371c230a09dd78be$var$ub(a, b) {
    if (b) {
        if ($371c230a09dd78be$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($371c230a09dd78be$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($371c230a09dd78be$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($371c230a09dd78be$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($371c230a09dd78be$var$p(62));
    }
}
function $371c230a09dd78be$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $371c230a09dd78be$var$wb = null;
function $371c230a09dd78be$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $371c230a09dd78be$var$yb = null, $371c230a09dd78be$var$zb = null, $371c230a09dd78be$var$Ab = null;
function $371c230a09dd78be$var$Bb(a) {
    if (a = $371c230a09dd78be$var$Cb(a)) {
        if ("function" !== typeof $371c230a09dd78be$var$yb) throw Error($371c230a09dd78be$var$p(280));
        var b = a.stateNode;
        b && (b = $371c230a09dd78be$var$Db(b), $371c230a09dd78be$var$yb(a.stateNode, a.type, b));
    }
}
function $371c230a09dd78be$var$Eb(a) {
    $371c230a09dd78be$var$zb ? $371c230a09dd78be$var$Ab ? $371c230a09dd78be$var$Ab.push(a) : $371c230a09dd78be$var$Ab = [
        a
    ] : $371c230a09dd78be$var$zb = a;
}
function $371c230a09dd78be$var$Fb() {
    if ($371c230a09dd78be$var$zb) {
        var a = $371c230a09dd78be$var$zb, b = $371c230a09dd78be$var$Ab;
        $371c230a09dd78be$var$Ab = $371c230a09dd78be$var$zb = null;
        $371c230a09dd78be$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$371c230a09dd78be$var$Bb(b[a]);
    }
}
function $371c230a09dd78be$var$Gb(a, b) {
    return a(b);
}
function $371c230a09dd78be$var$Hb() {}
var $371c230a09dd78be$var$Ib = !1;
function $371c230a09dd78be$var$Jb(a, b, c) {
    if ($371c230a09dd78be$var$Ib) return a(b, c);
    $371c230a09dd78be$var$Ib = !0;
    try {
        return $371c230a09dd78be$var$Gb(a, b, c);
    } finally{
        if ($371c230a09dd78be$var$Ib = !1, null !== $371c230a09dd78be$var$zb || null !== $371c230a09dd78be$var$Ab) $371c230a09dd78be$var$Hb(), $371c230a09dd78be$var$Fb();
    }
}
function $371c230a09dd78be$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $371c230a09dd78be$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($371c230a09dd78be$var$p(231, b, typeof c));
    return c;
}
var $371c230a09dd78be$var$Lb = !1;
if ($371c230a09dd78be$var$ia) try {
    var $371c230a09dd78be$var$Mb = {};
    Object.defineProperty($371c230a09dd78be$var$Mb, "passive", {
        get: function() {
            $371c230a09dd78be$var$Lb = !0;
        }
    });
    window.addEventListener("test", $371c230a09dd78be$var$Mb, $371c230a09dd78be$var$Mb);
    window.removeEventListener("test", $371c230a09dd78be$var$Mb, $371c230a09dd78be$var$Mb);
} catch (a) {
    $371c230a09dd78be$var$Lb = !1;
}
function $371c230a09dd78be$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $371c230a09dd78be$var$Ob = !1, $371c230a09dd78be$var$Pb = null, $371c230a09dd78be$var$Qb = !1, $371c230a09dd78be$var$Rb = null, $371c230a09dd78be$var$Sb = {
    onError: function(a) {
        $371c230a09dd78be$var$Ob = !0;
        $371c230a09dd78be$var$Pb = a;
    }
};
function $371c230a09dd78be$var$Tb(a, b, c, d, e, f, g, h, k) {
    $371c230a09dd78be$var$Ob = !1;
    $371c230a09dd78be$var$Pb = null;
    $371c230a09dd78be$var$Nb.apply($371c230a09dd78be$var$Sb, arguments);
}
function $371c230a09dd78be$var$Ub(a, b, c, d, e, f, g, h, k) {
    $371c230a09dd78be$var$Tb.apply(this, arguments);
    if ($371c230a09dd78be$var$Ob) {
        if ($371c230a09dd78be$var$Ob) {
            var l = $371c230a09dd78be$var$Pb;
            $371c230a09dd78be$var$Ob = !1;
            $371c230a09dd78be$var$Pb = null;
        } else throw Error($371c230a09dd78be$var$p(198));
        $371c230a09dd78be$var$Qb || ($371c230a09dd78be$var$Qb = !0, $371c230a09dd78be$var$Rb = l);
    }
}
function $371c230a09dd78be$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $371c230a09dd78be$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $371c230a09dd78be$var$Xb(a) {
    if ($371c230a09dd78be$var$Vb(a) !== a) throw Error($371c230a09dd78be$var$p(188));
}
function $371c230a09dd78be$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $371c230a09dd78be$var$Vb(a);
        if (null === b) throw Error($371c230a09dd78be$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $371c230a09dd78be$var$Xb(e), a;
                if (f === d) return $371c230a09dd78be$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($371c230a09dd78be$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($371c230a09dd78be$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($371c230a09dd78be$var$p(190));
    }
    if (3 !== c.tag) throw Error($371c230a09dd78be$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $371c230a09dd78be$var$Zb(a) {
    a = $371c230a09dd78be$var$Yb(a);
    return null !== a ? $371c230a09dd78be$var$$b(a) : null;
}
function $371c230a09dd78be$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $371c230a09dd78be$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $371c230a09dd78be$var$ac = $hOwrP.unstable_scheduleCallback, $371c230a09dd78be$var$bc = $hOwrP.unstable_cancelCallback, $371c230a09dd78be$var$cc = $hOwrP.unstable_shouldYield, $371c230a09dd78be$var$dc = $hOwrP.unstable_requestPaint, $371c230a09dd78be$var$B = $hOwrP.unstable_now, $371c230a09dd78be$var$ec = $hOwrP.unstable_getCurrentPriorityLevel, $371c230a09dd78be$var$fc = $hOwrP.unstable_ImmediatePriority, $371c230a09dd78be$var$gc = $hOwrP.unstable_UserBlockingPriority, $371c230a09dd78be$var$hc = $hOwrP.unstable_NormalPriority, $371c230a09dd78be$var$ic = $hOwrP.unstable_LowPriority, $371c230a09dd78be$var$jc = $hOwrP.unstable_IdlePriority, $371c230a09dd78be$var$kc = null, $371c230a09dd78be$var$lc = null;
function $371c230a09dd78be$var$mc(a) {
    if ($371c230a09dd78be$var$lc && "function" === typeof $371c230a09dd78be$var$lc.onCommitFiberRoot) try {
        $371c230a09dd78be$var$lc.onCommitFiberRoot($371c230a09dd78be$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $371c230a09dd78be$var$oc = Math.clz32 ? Math.clz32 : $371c230a09dd78be$var$nc, $371c230a09dd78be$var$pc = Math.log, $371c230a09dd78be$var$qc = Math.LN2;
function $371c230a09dd78be$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($371c230a09dd78be$var$pc(a) / $371c230a09dd78be$var$qc | 0) | 0;
}
var $371c230a09dd78be$var$rc = 64, $371c230a09dd78be$var$sc = 4194304;
function $371c230a09dd78be$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $371c230a09dd78be$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $371c230a09dd78be$var$tc(h) : (f &= g, 0 !== f && (d = $371c230a09dd78be$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $371c230a09dd78be$var$tc(g) : 0 !== f && (d = $371c230a09dd78be$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $371c230a09dd78be$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $371c230a09dd78be$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $371c230a09dd78be$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $371c230a09dd78be$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $371c230a09dd78be$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $371c230a09dd78be$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $371c230a09dd78be$var$yc() {
    var a = $371c230a09dd78be$var$rc;
    $371c230a09dd78be$var$rc <<= 1;
    0 === ($371c230a09dd78be$var$rc & 4194240) && ($371c230a09dd78be$var$rc = 64);
    return a;
}
function $371c230a09dd78be$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $371c230a09dd78be$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $371c230a09dd78be$var$oc(b);
    a[b] = c;
}
function $371c230a09dd78be$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $371c230a09dd78be$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $371c230a09dd78be$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $371c230a09dd78be$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $371c230a09dd78be$var$C = 0;
function $371c230a09dd78be$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $371c230a09dd78be$var$Ec, $371c230a09dd78be$var$Fc, $371c230a09dd78be$var$Gc, $371c230a09dd78be$var$Hc, $371c230a09dd78be$var$Ic, $371c230a09dd78be$var$Jc = !1, $371c230a09dd78be$var$Kc = [], $371c230a09dd78be$var$Lc = null, $371c230a09dd78be$var$Mc = null, $371c230a09dd78be$var$Nc = null, $371c230a09dd78be$var$Oc = new Map, $371c230a09dd78be$var$Pc = new Map, $371c230a09dd78be$var$Qc = [], $371c230a09dd78be$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $371c230a09dd78be$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $371c230a09dd78be$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $371c230a09dd78be$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $371c230a09dd78be$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $371c230a09dd78be$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $371c230a09dd78be$var$Pc.delete(b.pointerId);
    }
}
function $371c230a09dd78be$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $371c230a09dd78be$var$Cb(b), null !== b && $371c230a09dd78be$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $371c230a09dd78be$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $371c230a09dd78be$var$Lc = $371c230a09dd78be$var$Tc($371c230a09dd78be$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $371c230a09dd78be$var$Mc = $371c230a09dd78be$var$Tc($371c230a09dd78be$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $371c230a09dd78be$var$Nc = $371c230a09dd78be$var$Tc($371c230a09dd78be$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $371c230a09dd78be$var$Oc.set(f, $371c230a09dd78be$var$Tc($371c230a09dd78be$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $371c230a09dd78be$var$Pc.set(f, $371c230a09dd78be$var$Tc($371c230a09dd78be$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $371c230a09dd78be$var$Vc(a) {
    var b = $371c230a09dd78be$var$Wc(a.target);
    if (null !== b) {
        var c = $371c230a09dd78be$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $371c230a09dd78be$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $371c230a09dd78be$var$Ic(a.priority, function() {
                        $371c230a09dd78be$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $371c230a09dd78be$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $371c230a09dd78be$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $371c230a09dd78be$var$wb = d;
            c.target.dispatchEvent(d);
            $371c230a09dd78be$var$wb = null;
        } else return b = $371c230a09dd78be$var$Cb(c), null !== b && $371c230a09dd78be$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $371c230a09dd78be$var$Zc(a, b, c) {
    $371c230a09dd78be$var$Xc(a) && c.delete(b);
}
function $371c230a09dd78be$var$$c() {
    $371c230a09dd78be$var$Jc = !1;
    null !== $371c230a09dd78be$var$Lc && $371c230a09dd78be$var$Xc($371c230a09dd78be$var$Lc) && ($371c230a09dd78be$var$Lc = null);
    null !== $371c230a09dd78be$var$Mc && $371c230a09dd78be$var$Xc($371c230a09dd78be$var$Mc) && ($371c230a09dd78be$var$Mc = null);
    null !== $371c230a09dd78be$var$Nc && $371c230a09dd78be$var$Xc($371c230a09dd78be$var$Nc) && ($371c230a09dd78be$var$Nc = null);
    $371c230a09dd78be$var$Oc.forEach($371c230a09dd78be$var$Zc);
    $371c230a09dd78be$var$Pc.forEach($371c230a09dd78be$var$Zc);
}
function $371c230a09dd78be$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $371c230a09dd78be$var$Jc || ($371c230a09dd78be$var$Jc = !0, $hOwrP.unstable_scheduleCallback($hOwrP.unstable_NormalPriority, $371c230a09dd78be$var$$c)));
}
function $371c230a09dd78be$var$bd(a) {
    function b(b) {
        return $371c230a09dd78be$var$ad(b, a);
    }
    if (0 < $371c230a09dd78be$var$Kc.length) {
        $371c230a09dd78be$var$ad($371c230a09dd78be$var$Kc[0], a);
        for(var c = 1; c < $371c230a09dd78be$var$Kc.length; c++){
            var d = $371c230a09dd78be$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $371c230a09dd78be$var$Lc && $371c230a09dd78be$var$ad($371c230a09dd78be$var$Lc, a);
    null !== $371c230a09dd78be$var$Mc && $371c230a09dd78be$var$ad($371c230a09dd78be$var$Mc, a);
    null !== $371c230a09dd78be$var$Nc && $371c230a09dd78be$var$ad($371c230a09dd78be$var$Nc, a);
    $371c230a09dd78be$var$Oc.forEach(b);
    $371c230a09dd78be$var$Pc.forEach(b);
    for(c = 0; c < $371c230a09dd78be$var$Qc.length; c++)d = $371c230a09dd78be$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $371c230a09dd78be$var$Qc.length && (c = $371c230a09dd78be$var$Qc[0], null === c.blockedOn);)$371c230a09dd78be$var$Vc(c), null === c.blockedOn && $371c230a09dd78be$var$Qc.shift();
}
var $371c230a09dd78be$var$cd = $371c230a09dd78be$var$ua.ReactCurrentBatchConfig, $371c230a09dd78be$var$dd = !0;
function $371c230a09dd78be$var$ed(a, b, c, d) {
    var e = $371c230a09dd78be$var$C, f = $371c230a09dd78be$var$cd.transition;
    $371c230a09dd78be$var$cd.transition = null;
    try {
        $371c230a09dd78be$var$C = 1, $371c230a09dd78be$var$fd(a, b, c, d);
    } finally{
        $371c230a09dd78be$var$C = e, $371c230a09dd78be$var$cd.transition = f;
    }
}
function $371c230a09dd78be$var$gd(a, b, c, d) {
    var e = $371c230a09dd78be$var$C, f = $371c230a09dd78be$var$cd.transition;
    $371c230a09dd78be$var$cd.transition = null;
    try {
        $371c230a09dd78be$var$C = 4, $371c230a09dd78be$var$fd(a, b, c, d);
    } finally{
        $371c230a09dd78be$var$C = e, $371c230a09dd78be$var$cd.transition = f;
    }
}
function $371c230a09dd78be$var$fd(a, b, c, d) {
    if ($371c230a09dd78be$var$dd) {
        var e = $371c230a09dd78be$var$Yc(a, b, c, d);
        if (null === e) $371c230a09dd78be$var$hd(a, b, d, $371c230a09dd78be$var$id, c), $371c230a09dd78be$var$Sc(a, d);
        else if ($371c230a09dd78be$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($371c230a09dd78be$var$Sc(a, d), b & 4 && -1 < $371c230a09dd78be$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $371c230a09dd78be$var$Cb(e);
                null !== f && $371c230a09dd78be$var$Ec(f);
                f = $371c230a09dd78be$var$Yc(a, b, c, d);
                null === f && $371c230a09dd78be$var$hd(a, b, d, $371c230a09dd78be$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $371c230a09dd78be$var$hd(a, b, d, null, c);
    }
}
var $371c230a09dd78be$var$id = null;
function $371c230a09dd78be$var$Yc(a, b, c, d) {
    $371c230a09dd78be$var$id = null;
    a = $371c230a09dd78be$var$xb(d);
    a = $371c230a09dd78be$var$Wc(a);
    if (null !== a) {
        if (b = $371c230a09dd78be$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $371c230a09dd78be$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $371c230a09dd78be$var$id = a;
    return null;
}
function $371c230a09dd78be$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($371c230a09dd78be$var$ec()){
                case $371c230a09dd78be$var$fc:
                    return 1;
                case $371c230a09dd78be$var$gc:
                    return 4;
                case $371c230a09dd78be$var$hc:
                case $371c230a09dd78be$var$ic:
                    return 16;
                case $371c230a09dd78be$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $371c230a09dd78be$var$kd = null, $371c230a09dd78be$var$ld = null, $371c230a09dd78be$var$md = null;
function $371c230a09dd78be$var$nd() {
    if ($371c230a09dd78be$var$md) return $371c230a09dd78be$var$md;
    var a, b = $371c230a09dd78be$var$ld, c = b.length, d, e = "value" in $371c230a09dd78be$var$kd ? $371c230a09dd78be$var$kd.value : $371c230a09dd78be$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $371c230a09dd78be$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $371c230a09dd78be$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $371c230a09dd78be$var$pd() {
    return !0;
}
function $371c230a09dd78be$var$qd() {
    return !1;
}
function $371c230a09dd78be$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $371c230a09dd78be$var$pd : $371c230a09dd78be$var$qd;
        this.isPropagationStopped = $371c230a09dd78be$var$qd;
        return this;
    }
    $371c230a09dd78be$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $371c230a09dd78be$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $371c230a09dd78be$var$pd);
        },
        persist: function() {},
        isPersistent: $371c230a09dd78be$var$pd
    });
    return b;
}
var $371c230a09dd78be$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $371c230a09dd78be$var$td = $371c230a09dd78be$var$rd($371c230a09dd78be$var$sd), $371c230a09dd78be$var$ud = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$sd, {
    view: 0,
    detail: 0
}), $371c230a09dd78be$var$vd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$ud), $371c230a09dd78be$var$wd, $371c230a09dd78be$var$xd, $371c230a09dd78be$var$yd, $371c230a09dd78be$var$Ad = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $371c230a09dd78be$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $371c230a09dd78be$var$yd && ($371c230a09dd78be$var$yd && "mousemove" === a.type ? ($371c230a09dd78be$var$wd = a.screenX - $371c230a09dd78be$var$yd.screenX, $371c230a09dd78be$var$xd = a.screenY - $371c230a09dd78be$var$yd.screenY) : $371c230a09dd78be$var$xd = $371c230a09dd78be$var$wd = 0, $371c230a09dd78be$var$yd = a);
        return $371c230a09dd78be$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $371c230a09dd78be$var$xd;
    }
}), $371c230a09dd78be$var$Bd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Ad), $371c230a09dd78be$var$Cd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$Ad, {
    dataTransfer: 0
}), $371c230a09dd78be$var$Dd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Cd), $371c230a09dd78be$var$Ed = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$ud, {
    relatedTarget: 0
}), $371c230a09dd78be$var$Fd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Ed), $371c230a09dd78be$var$Gd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $371c230a09dd78be$var$Hd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Gd), $371c230a09dd78be$var$Id = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $371c230a09dd78be$var$Jd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Id), $371c230a09dd78be$var$Kd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$sd, {
    data: 0
}), $371c230a09dd78be$var$Ld = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Kd), $371c230a09dd78be$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $371c230a09dd78be$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $371c230a09dd78be$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $371c230a09dd78be$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $371c230a09dd78be$var$Od[a]) ? !!b[a] : !1;
}
function $371c230a09dd78be$var$zd() {
    return $371c230a09dd78be$var$Pd;
}
var $371c230a09dd78be$var$Qd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $371c230a09dd78be$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $371c230a09dd78be$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $371c230a09dd78be$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $371c230a09dd78be$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $371c230a09dd78be$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $371c230a09dd78be$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $371c230a09dd78be$var$Rd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Qd), $371c230a09dd78be$var$Sd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $371c230a09dd78be$var$Td = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Sd), $371c230a09dd78be$var$Ud = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $371c230a09dd78be$var$zd
}), $371c230a09dd78be$var$Vd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Ud), $371c230a09dd78be$var$Wd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $371c230a09dd78be$var$Xd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Wd), $371c230a09dd78be$var$Yd = $371c230a09dd78be$var$A({}, $371c230a09dd78be$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $371c230a09dd78be$var$Zd = $371c230a09dd78be$var$rd($371c230a09dd78be$var$Yd), $371c230a09dd78be$var$$d = [
    9,
    13,
    27,
    32
], $371c230a09dd78be$var$ae = $371c230a09dd78be$var$ia && "CompositionEvent" in window, $371c230a09dd78be$var$be = null;
$371c230a09dd78be$var$ia && "documentMode" in document && ($371c230a09dd78be$var$be = document.documentMode);
var $371c230a09dd78be$var$ce = $371c230a09dd78be$var$ia && "TextEvent" in window && !$371c230a09dd78be$var$be, $371c230a09dd78be$var$de = $371c230a09dd78be$var$ia && (!$371c230a09dd78be$var$ae || $371c230a09dd78be$var$be && 8 < $371c230a09dd78be$var$be && 11 >= $371c230a09dd78be$var$be), $371c230a09dd78be$var$ee = String.fromCharCode(32), $371c230a09dd78be$var$fe = !1;
function $371c230a09dd78be$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $371c230a09dd78be$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $371c230a09dd78be$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $371c230a09dd78be$var$ie = !1;
function $371c230a09dd78be$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $371c230a09dd78be$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $371c230a09dd78be$var$fe = !0;
            return $371c230a09dd78be$var$ee;
        case "textInput":
            return a = b.data, a === $371c230a09dd78be$var$ee && $371c230a09dd78be$var$fe ? null : a;
        default:
            return null;
    }
}
function $371c230a09dd78be$var$ke(a, b) {
    if ($371c230a09dd78be$var$ie) return "compositionend" === a || !$371c230a09dd78be$var$ae && $371c230a09dd78be$var$ge(a, b) ? (a = $371c230a09dd78be$var$nd(), $371c230a09dd78be$var$md = $371c230a09dd78be$var$ld = $371c230a09dd78be$var$kd = null, $371c230a09dd78be$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $371c230a09dd78be$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $371c230a09dd78be$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $371c230a09dd78be$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$371c230a09dd78be$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $371c230a09dd78be$var$ne(a, b, c, d) {
    $371c230a09dd78be$var$Eb(d);
    b = $371c230a09dd78be$var$oe(b, "onChange");
    0 < b.length && (c = new $371c230a09dd78be$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $371c230a09dd78be$var$pe = null, $371c230a09dd78be$var$qe = null;
function $371c230a09dd78be$var$re(a) {
    $371c230a09dd78be$var$se(a, 0);
}
function $371c230a09dd78be$var$te(a) {
    var b = $371c230a09dd78be$var$ue(a);
    if ($371c230a09dd78be$var$Wa(b)) return a;
}
function $371c230a09dd78be$var$ve(a, b) {
    if ("change" === a) return b;
}
var $371c230a09dd78be$var$we = !1;
if ($371c230a09dd78be$var$ia) {
    var $371c230a09dd78be$var$xe;
    if ($371c230a09dd78be$var$ia) {
        var $371c230a09dd78be$var$ye = "oninput" in document;
        if (!$371c230a09dd78be$var$ye) {
            var $371c230a09dd78be$var$ze = document.createElement("div");
            $371c230a09dd78be$var$ze.setAttribute("oninput", "return;");
            $371c230a09dd78be$var$ye = "function" === typeof $371c230a09dd78be$var$ze.oninput;
        }
        $371c230a09dd78be$var$xe = $371c230a09dd78be$var$ye;
    } else $371c230a09dd78be$var$xe = !1;
    $371c230a09dd78be$var$we = $371c230a09dd78be$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $371c230a09dd78be$var$Ae() {
    $371c230a09dd78be$var$pe && ($371c230a09dd78be$var$pe.detachEvent("onpropertychange", $371c230a09dd78be$var$Be), $371c230a09dd78be$var$qe = $371c230a09dd78be$var$pe = null);
}
function $371c230a09dd78be$var$Be(a) {
    if ("value" === a.propertyName && $371c230a09dd78be$var$te($371c230a09dd78be$var$qe)) {
        var b = [];
        $371c230a09dd78be$var$ne(b, $371c230a09dd78be$var$qe, a, $371c230a09dd78be$var$xb(a));
        $371c230a09dd78be$var$Jb($371c230a09dd78be$var$re, b);
    }
}
function $371c230a09dd78be$var$Ce(a, b, c) {
    "focusin" === a ? ($371c230a09dd78be$var$Ae(), $371c230a09dd78be$var$pe = b, $371c230a09dd78be$var$qe = c, $371c230a09dd78be$var$pe.attachEvent("onpropertychange", $371c230a09dd78be$var$Be)) : "focusout" === a && $371c230a09dd78be$var$Ae();
}
function $371c230a09dd78be$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $371c230a09dd78be$var$te($371c230a09dd78be$var$qe);
}
function $371c230a09dd78be$var$Ee(a, b) {
    if ("click" === a) return $371c230a09dd78be$var$te(b);
}
function $371c230a09dd78be$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $371c230a09dd78be$var$te(b);
}
function $371c230a09dd78be$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $371c230a09dd78be$var$He = "function" === typeof Object.is ? Object.is : $371c230a09dd78be$var$Ge;
function $371c230a09dd78be$var$Ie(a, b) {
    if ($371c230a09dd78be$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$371c230a09dd78be$var$ja.call(b, e) || !$371c230a09dd78be$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $371c230a09dd78be$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $371c230a09dd78be$var$Ke(a, b) {
    var c = $371c230a09dd78be$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $371c230a09dd78be$var$Je(c);
    }
}
function $371c230a09dd78be$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $371c230a09dd78be$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $371c230a09dd78be$var$Me() {
    for(var a = window, b = $371c230a09dd78be$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $371c230a09dd78be$var$Xa(a.document);
    }
    return b;
}
function $371c230a09dd78be$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $371c230a09dd78be$var$Oe(a) {
    var b = $371c230a09dd78be$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $371c230a09dd78be$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $371c230a09dd78be$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $371c230a09dd78be$var$Ke(c, f);
                var g = $371c230a09dd78be$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $371c230a09dd78be$var$Pe = $371c230a09dd78be$var$ia && "documentMode" in document && 11 >= document.documentMode, $371c230a09dd78be$var$Qe = null, $371c230a09dd78be$var$Re = null, $371c230a09dd78be$var$Se = null, $371c230a09dd78be$var$Te = !1;
function $371c230a09dd78be$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $371c230a09dd78be$var$Te || null == $371c230a09dd78be$var$Qe || $371c230a09dd78be$var$Qe !== $371c230a09dd78be$var$Xa(d) || (d = $371c230a09dd78be$var$Qe, "selectionStart" in d && $371c230a09dd78be$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $371c230a09dd78be$var$Se && $371c230a09dd78be$var$Ie($371c230a09dd78be$var$Se, d) || ($371c230a09dd78be$var$Se = d, d = $371c230a09dd78be$var$oe($371c230a09dd78be$var$Re, "onSelect"), 0 < d.length && (b = new $371c230a09dd78be$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $371c230a09dd78be$var$Qe)));
}
function $371c230a09dd78be$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $371c230a09dd78be$var$We = {
    animationend: $371c230a09dd78be$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $371c230a09dd78be$var$Ve("Animation", "AnimationIteration"),
    animationstart: $371c230a09dd78be$var$Ve("Animation", "AnimationStart"),
    transitionend: $371c230a09dd78be$var$Ve("Transition", "TransitionEnd")
}, $371c230a09dd78be$var$Xe = {}, $371c230a09dd78be$var$Ye = {};
$371c230a09dd78be$var$ia && ($371c230a09dd78be$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $371c230a09dd78be$var$We.animationend.animation, delete $371c230a09dd78be$var$We.animationiteration.animation, delete $371c230a09dd78be$var$We.animationstart.animation), "TransitionEvent" in window || delete $371c230a09dd78be$var$We.transitionend.transition);
function $371c230a09dd78be$var$Ze(a) {
    if ($371c230a09dd78be$var$Xe[a]) return $371c230a09dd78be$var$Xe[a];
    if (!$371c230a09dd78be$var$We[a]) return a;
    var b = $371c230a09dd78be$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $371c230a09dd78be$var$Ye) return $371c230a09dd78be$var$Xe[a] = b[c];
    return a;
}
var $371c230a09dd78be$var$$e = $371c230a09dd78be$var$Ze("animationend"), $371c230a09dd78be$var$af = $371c230a09dd78be$var$Ze("animationiteration"), $371c230a09dd78be$var$bf = $371c230a09dd78be$var$Ze("animationstart"), $371c230a09dd78be$var$cf = $371c230a09dd78be$var$Ze("transitionend"), $371c230a09dd78be$var$df = new Map, $371c230a09dd78be$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $371c230a09dd78be$var$ff(a, b) {
    $371c230a09dd78be$var$df.set(a, b);
    $371c230a09dd78be$var$fa(b, [
        a
    ]);
}
for(var $371c230a09dd78be$var$gf = 0; $371c230a09dd78be$var$gf < $371c230a09dd78be$var$ef.length; $371c230a09dd78be$var$gf++){
    var $371c230a09dd78be$var$hf = $371c230a09dd78be$var$ef[$371c230a09dd78be$var$gf], $371c230a09dd78be$var$jf = $371c230a09dd78be$var$hf.toLowerCase(), $371c230a09dd78be$var$kf = $371c230a09dd78be$var$hf[0].toUpperCase() + $371c230a09dd78be$var$hf.slice(1);
    $371c230a09dd78be$var$ff($371c230a09dd78be$var$jf, "on" + $371c230a09dd78be$var$kf);
}
$371c230a09dd78be$var$ff($371c230a09dd78be$var$$e, "onAnimationEnd");
$371c230a09dd78be$var$ff($371c230a09dd78be$var$af, "onAnimationIteration");
$371c230a09dd78be$var$ff($371c230a09dd78be$var$bf, "onAnimationStart");
$371c230a09dd78be$var$ff("dblclick", "onDoubleClick");
$371c230a09dd78be$var$ff("focusin", "onFocus");
$371c230a09dd78be$var$ff("focusout", "onBlur");
$371c230a09dd78be$var$ff($371c230a09dd78be$var$cf, "onTransitionEnd");
$371c230a09dd78be$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$371c230a09dd78be$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$371c230a09dd78be$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$371c230a09dd78be$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$371c230a09dd78be$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$371c230a09dd78be$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$371c230a09dd78be$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$371c230a09dd78be$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$371c230a09dd78be$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$371c230a09dd78be$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $371c230a09dd78be$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $371c230a09dd78be$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($371c230a09dd78be$var$lf));
function $371c230a09dd78be$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $371c230a09dd78be$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $371c230a09dd78be$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $371c230a09dd78be$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $371c230a09dd78be$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($371c230a09dd78be$var$Qb) throw a = $371c230a09dd78be$var$Rb, $371c230a09dd78be$var$Qb = !1, $371c230a09dd78be$var$Rb = null, a;
}
function $371c230a09dd78be$var$D(a, b) {
    var c = b[$371c230a09dd78be$var$of];
    void 0 === c && (c = b[$371c230a09dd78be$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($371c230a09dd78be$var$pf(b, a, 2, !1), c.add(d));
}
function $371c230a09dd78be$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $371c230a09dd78be$var$pf(c, a, d, b);
}
var $371c230a09dd78be$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $371c230a09dd78be$var$sf(a) {
    if (!a[$371c230a09dd78be$var$rf]) {
        a[$371c230a09dd78be$var$rf] = !0;
        $371c230a09dd78be$var$da.forEach(function(b) {
            "selectionchange" !== b && ($371c230a09dd78be$var$mf.has(b) || $371c230a09dd78be$var$qf(b, !1, a), $371c230a09dd78be$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$371c230a09dd78be$var$rf] || (b[$371c230a09dd78be$var$rf] = !0, $371c230a09dd78be$var$qf("selectionchange", !1, b));
    }
}
function $371c230a09dd78be$var$pf(a, b, c, d) {
    switch($371c230a09dd78be$var$jd(b)){
        case 1:
            var e = $371c230a09dd78be$var$ed;
            break;
        case 4:
            e = $371c230a09dd78be$var$gd;
            break;
        default:
            e = $371c230a09dd78be$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$371c230a09dd78be$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $371c230a09dd78be$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $371c230a09dd78be$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $371c230a09dd78be$var$Jb(function() {
        var d = f, e = $371c230a09dd78be$var$xb(c), g = [];
        a: {
            var h = $371c230a09dd78be$var$df.get(a);
            if (void 0 !== h) {
                var k = $371c230a09dd78be$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $371c230a09dd78be$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $371c230a09dd78be$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $371c230a09dd78be$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $371c230a09dd78be$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $371c230a09dd78be$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $371c230a09dd78be$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $371c230a09dd78be$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $371c230a09dd78be$var$Vd;
                        break;
                    case $371c230a09dd78be$var$$e:
                    case $371c230a09dd78be$var$af:
                    case $371c230a09dd78be$var$bf:
                        k = $371c230a09dd78be$var$Hd;
                        break;
                    case $371c230a09dd78be$var$cf:
                        k = $371c230a09dd78be$var$Xd;
                        break;
                    case "scroll":
                        k = $371c230a09dd78be$var$vd;
                        break;
                    case "wheel":
                        k = $371c230a09dd78be$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $371c230a09dd78be$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $371c230a09dd78be$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $371c230a09dd78be$var$Kb(w, x), null != F && t.push($371c230a09dd78be$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $371c230a09dd78be$var$wb && (n = c.relatedTarget || c.fromElement) && ($371c230a09dd78be$var$Wc(n) || n[$371c230a09dd78be$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $371c230a09dd78be$var$Wc(n) : null, null !== n && (J = $371c230a09dd78be$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $371c230a09dd78be$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $371c230a09dd78be$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $371c230a09dd78be$var$ue(k);
                        u = null == n ? h : $371c230a09dd78be$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $371c230a09dd78be$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $371c230a09dd78be$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $371c230a09dd78be$var$vf(F))u++;
                            for(; 0 < w - u;)t = $371c230a09dd78be$var$vf(t), w--;
                            for(; 0 < u - w;)x = $371c230a09dd78be$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $371c230a09dd78be$var$vf(t);
                                x = $371c230a09dd78be$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $371c230a09dd78be$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $371c230a09dd78be$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $371c230a09dd78be$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $371c230a09dd78be$var$ve;
                else if ($371c230a09dd78be$var$me(h)) {
                    if ($371c230a09dd78be$var$we) na = $371c230a09dd78be$var$Fe;
                    else {
                        na = $371c230a09dd78be$var$De;
                        var xa = $371c230a09dd78be$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $371c230a09dd78be$var$Ee);
                if (na && (na = na(a, d))) {
                    $371c230a09dd78be$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $371c230a09dd78be$var$cb(h, "number", h.value);
            }
            xa = d ? $371c230a09dd78be$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($371c230a09dd78be$var$me(xa) || "true" === xa.contentEditable) $371c230a09dd78be$var$Qe = xa, $371c230a09dd78be$var$Re = d, $371c230a09dd78be$var$Se = null;
                    break;
                case "focusout":
                    $371c230a09dd78be$var$Se = $371c230a09dd78be$var$Re = $371c230a09dd78be$var$Qe = null;
                    break;
                case "mousedown":
                    $371c230a09dd78be$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $371c230a09dd78be$var$Te = !1;
                    $371c230a09dd78be$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($371c230a09dd78be$var$Pe) break;
                case "keydown":
                case "keyup":
                    $371c230a09dd78be$var$Ue(g, c, e);
            }
            var $a;
            if ($371c230a09dd78be$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $371c230a09dd78be$var$ie ? $371c230a09dd78be$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($371c230a09dd78be$var$de && "ko" !== c.locale && ($371c230a09dd78be$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $371c230a09dd78be$var$ie && ($a = $371c230a09dd78be$var$nd()) : ($371c230a09dd78be$var$kd = e, $371c230a09dd78be$var$ld = "value" in $371c230a09dd78be$var$kd ? $371c230a09dd78be$var$kd.value : $371c230a09dd78be$var$kd.textContent, $371c230a09dd78be$var$ie = !0)), xa = $371c230a09dd78be$var$oe(d, ba), 0 < xa.length && (ba = new $371c230a09dd78be$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $371c230a09dd78be$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $371c230a09dd78be$var$ce ? $371c230a09dd78be$var$je(a, c) : $371c230a09dd78be$var$ke(a, c)) d = $371c230a09dd78be$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $371c230a09dd78be$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $371c230a09dd78be$var$se(g, b);
    });
}
function $371c230a09dd78be$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $371c230a09dd78be$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $371c230a09dd78be$var$Kb(a, c), null != f && d.unshift($371c230a09dd78be$var$tf(a, f, e)), f = $371c230a09dd78be$var$Kb(a, b), null != f && d.push($371c230a09dd78be$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $371c230a09dd78be$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $371c230a09dd78be$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $371c230a09dd78be$var$Kb(c, f), null != k && g.unshift($371c230a09dd78be$var$tf(c, k, h))) : e || (k = $371c230a09dd78be$var$Kb(c, f), null != k && g.push($371c230a09dd78be$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $371c230a09dd78be$var$xf = /\r\n?/g, $371c230a09dd78be$var$yf = /\u0000|\uFFFD/g;
function $371c230a09dd78be$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($371c230a09dd78be$var$xf, "\n").replace($371c230a09dd78be$var$yf, "");
}
function $371c230a09dd78be$var$Af(a, b, c) {
    b = $371c230a09dd78be$var$zf(b);
    if ($371c230a09dd78be$var$zf(a) !== b && c) throw Error($371c230a09dd78be$var$p(425));
}
function $371c230a09dd78be$var$Bf() {}
var $371c230a09dd78be$var$Cf = null, $371c230a09dd78be$var$Df = null;
function $371c230a09dd78be$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $371c230a09dd78be$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $371c230a09dd78be$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $371c230a09dd78be$var$Hf = "function" === typeof Promise ? Promise : void 0, $371c230a09dd78be$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $371c230a09dd78be$var$Hf ? function(a) {
    return $371c230a09dd78be$var$Hf.resolve(null).then(a).catch($371c230a09dd78be$var$If);
} : $371c230a09dd78be$var$Ff;
function $371c230a09dd78be$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $371c230a09dd78be$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $371c230a09dd78be$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $371c230a09dd78be$var$bd(b);
}
function $371c230a09dd78be$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $371c230a09dd78be$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $371c230a09dd78be$var$Nf = Math.random().toString(36).slice(2), $371c230a09dd78be$var$Of = "__reactFiber$" + $371c230a09dd78be$var$Nf, $371c230a09dd78be$var$Pf = "__reactProps$" + $371c230a09dd78be$var$Nf, $371c230a09dd78be$var$uf = "__reactContainer$" + $371c230a09dd78be$var$Nf, $371c230a09dd78be$var$of = "__reactEvents$" + $371c230a09dd78be$var$Nf, $371c230a09dd78be$var$Qf = "__reactListeners$" + $371c230a09dd78be$var$Nf, $371c230a09dd78be$var$Rf = "__reactHandles$" + $371c230a09dd78be$var$Nf;
function $371c230a09dd78be$var$Wc(a) {
    var b = a[$371c230a09dd78be$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$371c230a09dd78be$var$uf] || c[$371c230a09dd78be$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $371c230a09dd78be$var$Mf(a); null !== a;){
                if (c = a[$371c230a09dd78be$var$Of]) return c;
                a = $371c230a09dd78be$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $371c230a09dd78be$var$Cb(a) {
    a = a[$371c230a09dd78be$var$Of] || a[$371c230a09dd78be$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $371c230a09dd78be$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($371c230a09dd78be$var$p(33));
}
function $371c230a09dd78be$var$Db(a) {
    return a[$371c230a09dd78be$var$Pf] || null;
}
var $371c230a09dd78be$var$Sf = [], $371c230a09dd78be$var$Tf = -1;
function $371c230a09dd78be$var$Uf(a) {
    return {
        current: a
    };
}
function $371c230a09dd78be$var$E(a) {
    0 > $371c230a09dd78be$var$Tf || (a.current = $371c230a09dd78be$var$Sf[$371c230a09dd78be$var$Tf], $371c230a09dd78be$var$Sf[$371c230a09dd78be$var$Tf] = null, $371c230a09dd78be$var$Tf--);
}
function $371c230a09dd78be$var$G(a, b) {
    $371c230a09dd78be$var$Tf++;
    $371c230a09dd78be$var$Sf[$371c230a09dd78be$var$Tf] = a.current;
    a.current = b;
}
var $371c230a09dd78be$var$Vf = {}, $371c230a09dd78be$var$H = $371c230a09dd78be$var$Uf($371c230a09dd78be$var$Vf), $371c230a09dd78be$var$Wf = $371c230a09dd78be$var$Uf(!1), $371c230a09dd78be$var$Xf = $371c230a09dd78be$var$Vf;
function $371c230a09dd78be$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $371c230a09dd78be$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $371c230a09dd78be$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $371c230a09dd78be$var$$f() {
    $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf);
    $371c230a09dd78be$var$E($371c230a09dd78be$var$H);
}
function $371c230a09dd78be$var$ag(a, b, c) {
    if ($371c230a09dd78be$var$H.current !== $371c230a09dd78be$var$Vf) throw Error($371c230a09dd78be$var$p(168));
    $371c230a09dd78be$var$G($371c230a09dd78be$var$H, b);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$Wf, c);
}
function $371c230a09dd78be$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($371c230a09dd78be$var$p(108, $371c230a09dd78be$var$Ra(a) || "Unknown", e));
    return $371c230a09dd78be$var$A({}, c, d);
}
function $371c230a09dd78be$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $371c230a09dd78be$var$Vf;
    $371c230a09dd78be$var$Xf = $371c230a09dd78be$var$H.current;
    $371c230a09dd78be$var$G($371c230a09dd78be$var$H, a);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$Wf, $371c230a09dd78be$var$Wf.current);
    return !0;
}
function $371c230a09dd78be$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($371c230a09dd78be$var$p(169));
    c ? (a = $371c230a09dd78be$var$bg(a, b, $371c230a09dd78be$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf), $371c230a09dd78be$var$E($371c230a09dd78be$var$H), $371c230a09dd78be$var$G($371c230a09dd78be$var$H, a)) : $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$Wf, c);
}
var $371c230a09dd78be$var$eg = null, $371c230a09dd78be$var$fg = !1, $371c230a09dd78be$var$gg = !1;
function $371c230a09dd78be$var$hg(a) {
    null === $371c230a09dd78be$var$eg ? $371c230a09dd78be$var$eg = [
        a
    ] : $371c230a09dd78be$var$eg.push(a);
}
function $371c230a09dd78be$var$ig(a) {
    $371c230a09dd78be$var$fg = !0;
    $371c230a09dd78be$var$hg(a);
}
function $371c230a09dd78be$var$jg() {
    if (!$371c230a09dd78be$var$gg && null !== $371c230a09dd78be$var$eg) {
        $371c230a09dd78be$var$gg = !0;
        var a = 0, b = $371c230a09dd78be$var$C;
        try {
            var c = $371c230a09dd78be$var$eg;
            for($371c230a09dd78be$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $371c230a09dd78be$var$eg = null;
            $371c230a09dd78be$var$fg = !1;
        } catch (e) {
            throw null !== $371c230a09dd78be$var$eg && ($371c230a09dd78be$var$eg = $371c230a09dd78be$var$eg.slice(a + 1)), $371c230a09dd78be$var$ac($371c230a09dd78be$var$fc, $371c230a09dd78be$var$jg), e;
        } finally{
            $371c230a09dd78be$var$C = b, $371c230a09dd78be$var$gg = !1;
        }
    }
    return null;
}
var $371c230a09dd78be$var$kg = [], $371c230a09dd78be$var$lg = 0, $371c230a09dd78be$var$mg = null, $371c230a09dd78be$var$ng = 0, $371c230a09dd78be$var$og = [], $371c230a09dd78be$var$pg = 0, $371c230a09dd78be$var$qg = null, $371c230a09dd78be$var$rg = 1, $371c230a09dd78be$var$sg = "";
function $371c230a09dd78be$var$tg(a, b) {
    $371c230a09dd78be$var$kg[$371c230a09dd78be$var$lg++] = $371c230a09dd78be$var$ng;
    $371c230a09dd78be$var$kg[$371c230a09dd78be$var$lg++] = $371c230a09dd78be$var$mg;
    $371c230a09dd78be$var$mg = a;
    $371c230a09dd78be$var$ng = b;
}
function $371c230a09dd78be$var$ug(a, b, c) {
    $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$rg;
    $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$sg;
    $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$qg;
    $371c230a09dd78be$var$qg = a;
    var d = $371c230a09dd78be$var$rg;
    a = $371c230a09dd78be$var$sg;
    var e = 32 - $371c230a09dd78be$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $371c230a09dd78be$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $371c230a09dd78be$var$rg = 1 << 32 - $371c230a09dd78be$var$oc(b) + e | c << e | d;
        $371c230a09dd78be$var$sg = f + a;
    } else $371c230a09dd78be$var$rg = 1 << f | c << e | d, $371c230a09dd78be$var$sg = a;
}
function $371c230a09dd78be$var$vg(a) {
    null !== a.return && ($371c230a09dd78be$var$tg(a, 1), $371c230a09dd78be$var$ug(a, 1, 0));
}
function $371c230a09dd78be$var$wg(a) {
    for(; a === $371c230a09dd78be$var$mg;)$371c230a09dd78be$var$mg = $371c230a09dd78be$var$kg[--$371c230a09dd78be$var$lg], $371c230a09dd78be$var$kg[$371c230a09dd78be$var$lg] = null, $371c230a09dd78be$var$ng = $371c230a09dd78be$var$kg[--$371c230a09dd78be$var$lg], $371c230a09dd78be$var$kg[$371c230a09dd78be$var$lg] = null;
    for(; a === $371c230a09dd78be$var$qg;)$371c230a09dd78be$var$qg = $371c230a09dd78be$var$og[--$371c230a09dd78be$var$pg], $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg] = null, $371c230a09dd78be$var$sg = $371c230a09dd78be$var$og[--$371c230a09dd78be$var$pg], $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg] = null, $371c230a09dd78be$var$rg = $371c230a09dd78be$var$og[--$371c230a09dd78be$var$pg], $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg] = null;
}
var $371c230a09dd78be$var$xg = null, $371c230a09dd78be$var$yg = null, $371c230a09dd78be$var$I = !1, $371c230a09dd78be$var$zg = null;
function $371c230a09dd78be$var$Ag(a, b) {
    var c = $371c230a09dd78be$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $371c230a09dd78be$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $371c230a09dd78be$var$xg = a, $371c230a09dd78be$var$yg = $371c230a09dd78be$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $371c230a09dd78be$var$xg = a, $371c230a09dd78be$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $371c230a09dd78be$var$qg ? {
                id: $371c230a09dd78be$var$rg,
                overflow: $371c230a09dd78be$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $371c230a09dd78be$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $371c230a09dd78be$var$xg = a, $371c230a09dd78be$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $371c230a09dd78be$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $371c230a09dd78be$var$Eg(a) {
    if ($371c230a09dd78be$var$I) {
        var b = $371c230a09dd78be$var$yg;
        if (b) {
            var c = b;
            if (!$371c230a09dd78be$var$Cg(a, b)) {
                if ($371c230a09dd78be$var$Dg(a)) throw Error($371c230a09dd78be$var$p(418));
                b = $371c230a09dd78be$var$Lf(c.nextSibling);
                var d = $371c230a09dd78be$var$xg;
                b && $371c230a09dd78be$var$Cg(a, b) ? $371c230a09dd78be$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $371c230a09dd78be$var$I = !1, $371c230a09dd78be$var$xg = a);
            }
        } else {
            if ($371c230a09dd78be$var$Dg(a)) throw Error($371c230a09dd78be$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $371c230a09dd78be$var$I = !1;
            $371c230a09dd78be$var$xg = a;
        }
    }
}
function $371c230a09dd78be$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $371c230a09dd78be$var$xg = a;
}
function $371c230a09dd78be$var$Gg(a) {
    if (a !== $371c230a09dd78be$var$xg) return !1;
    if (!$371c230a09dd78be$var$I) return $371c230a09dd78be$var$Fg(a), $371c230a09dd78be$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$371c230a09dd78be$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $371c230a09dd78be$var$yg)) {
        if ($371c230a09dd78be$var$Dg(a)) throw $371c230a09dd78be$var$Hg(), Error($371c230a09dd78be$var$p(418));
        for(; b;)$371c230a09dd78be$var$Ag(a, b), b = $371c230a09dd78be$var$Lf(b.nextSibling);
    }
    $371c230a09dd78be$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($371c230a09dd78be$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $371c230a09dd78be$var$yg = $371c230a09dd78be$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $371c230a09dd78be$var$yg = null;
        }
    } else $371c230a09dd78be$var$yg = $371c230a09dd78be$var$xg ? $371c230a09dd78be$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $371c230a09dd78be$var$Hg() {
    for(var a = $371c230a09dd78be$var$yg; a;)a = $371c230a09dd78be$var$Lf(a.nextSibling);
}
function $371c230a09dd78be$var$Ig() {
    $371c230a09dd78be$var$yg = $371c230a09dd78be$var$xg = null;
    $371c230a09dd78be$var$I = !1;
}
function $371c230a09dd78be$var$Jg(a) {
    null === $371c230a09dd78be$var$zg ? $371c230a09dd78be$var$zg = [
        a
    ] : $371c230a09dd78be$var$zg.push(a);
}
var $371c230a09dd78be$var$Kg = $371c230a09dd78be$var$ua.ReactCurrentBatchConfig;
function $371c230a09dd78be$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($371c230a09dd78be$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($371c230a09dd78be$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($371c230a09dd78be$var$p(284));
        if (!c._owner) throw Error($371c230a09dd78be$var$p(290, a));
    }
    return a;
}
function $371c230a09dd78be$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($371c230a09dd78be$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $371c230a09dd78be$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $371c230a09dd78be$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $371c230a09dd78be$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $371c230a09dd78be$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $371c230a09dd78be$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $371c230a09dd78be$var$Ha && $371c230a09dd78be$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $371c230a09dd78be$var$Lg(a, b, c), d.return = a, d;
        d = $371c230a09dd78be$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $371c230a09dd78be$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $371c230a09dd78be$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $371c230a09dd78be$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $371c230a09dd78be$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $371c230a09dd78be$var$va:
                    return c = $371c230a09dd78be$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $371c230a09dd78be$var$Lg(a, null, b), c.return = a, c;
                case $371c230a09dd78be$var$wa:
                    return b = $371c230a09dd78be$var$Sg(b, a.mode, c), b.return = a, b;
                case $371c230a09dd78be$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($371c230a09dd78be$var$eb(b) || $371c230a09dd78be$var$Ka(b)) return b = $371c230a09dd78be$var$Tg(b, a.mode, c, null), b.return = a, b;
            $371c230a09dd78be$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $371c230a09dd78be$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $371c230a09dd78be$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $371c230a09dd78be$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($371c230a09dd78be$var$eb(c) || $371c230a09dd78be$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $371c230a09dd78be$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $371c230a09dd78be$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $371c230a09dd78be$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $371c230a09dd78be$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($371c230a09dd78be$var$eb(d) || $371c230a09dd78be$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $371c230a09dd78be$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $371c230a09dd78be$var$Ka(h);
        if ("function" !== typeof l) throw Error($371c230a09dd78be$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($371c230a09dd78be$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $371c230a09dd78be$var$I && $371c230a09dd78be$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $371c230a09dd78be$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $371c230a09dd78be$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $371c230a09dd78be$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $371c230a09dd78be$var$Ha && $371c230a09dd78be$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $371c230a09dd78be$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $371c230a09dd78be$var$ya ? (d = $371c230a09dd78be$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $371c230a09dd78be$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $371c230a09dd78be$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $371c230a09dd78be$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $371c230a09dd78be$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $371c230a09dd78be$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($371c230a09dd78be$var$eb(f)) return n(a, d, f, h);
            if ($371c230a09dd78be$var$Ka(f)) return t(a, d, f, h);
            $371c230a09dd78be$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $371c230a09dd78be$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $371c230a09dd78be$var$Ug = $371c230a09dd78be$var$Og(!0), $371c230a09dd78be$var$Vg = $371c230a09dd78be$var$Og(!1), $371c230a09dd78be$var$Wg = $371c230a09dd78be$var$Uf(null), $371c230a09dd78be$var$Xg = null, $371c230a09dd78be$var$Yg = null, $371c230a09dd78be$var$Zg = null;
function $371c230a09dd78be$var$$g() {
    $371c230a09dd78be$var$Zg = $371c230a09dd78be$var$Yg = $371c230a09dd78be$var$Xg = null;
}
function $371c230a09dd78be$var$ah(a) {
    var b = $371c230a09dd78be$var$Wg.current;
    $371c230a09dd78be$var$E($371c230a09dd78be$var$Wg);
    a._currentValue = b;
}
function $371c230a09dd78be$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $371c230a09dd78be$var$ch(a, b) {
    $371c230a09dd78be$var$Xg = a;
    $371c230a09dd78be$var$Zg = $371c230a09dd78be$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($371c230a09dd78be$var$dh = !0), a.firstContext = null);
}
function $371c230a09dd78be$var$eh(a) {
    var b = a._currentValue;
    if ($371c230a09dd78be$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $371c230a09dd78be$var$Yg) {
            if (null === $371c230a09dd78be$var$Xg) throw Error($371c230a09dd78be$var$p(308));
            $371c230a09dd78be$var$Yg = a;
            $371c230a09dd78be$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $371c230a09dd78be$var$Yg = $371c230a09dd78be$var$Yg.next = a;
    }
    return b;
}
var $371c230a09dd78be$var$fh = null;
function $371c230a09dd78be$var$gh(a) {
    null === $371c230a09dd78be$var$fh ? $371c230a09dd78be$var$fh = [
        a
    ] : $371c230a09dd78be$var$fh.push(a);
}
function $371c230a09dd78be$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $371c230a09dd78be$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $371c230a09dd78be$var$ih(a, d);
}
function $371c230a09dd78be$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $371c230a09dd78be$var$jh = !1;
function $371c230a09dd78be$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $371c230a09dd78be$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $371c230a09dd78be$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $371c230a09dd78be$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($371c230a09dd78be$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $371c230a09dd78be$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $371c230a09dd78be$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $371c230a09dd78be$var$ih(a, c);
}
function $371c230a09dd78be$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $371c230a09dd78be$var$Cc(a, c);
    }
}
function $371c230a09dd78be$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $371c230a09dd78be$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $371c230a09dd78be$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $371c230a09dd78be$var$A({}, q, r);
                            break a;
                        case 2:
                            $371c230a09dd78be$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $371c230a09dd78be$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $371c230a09dd78be$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($371c230a09dd78be$var$p(191, e));
            e.call(d);
        }
    }
}
var $371c230a09dd78be$var$th = {}, $371c230a09dd78be$var$uh = $371c230a09dd78be$var$Uf($371c230a09dd78be$var$th), $371c230a09dd78be$var$vh = $371c230a09dd78be$var$Uf($371c230a09dd78be$var$th), $371c230a09dd78be$var$wh = $371c230a09dd78be$var$Uf($371c230a09dd78be$var$th);
function $371c230a09dd78be$var$xh(a) {
    if (a === $371c230a09dd78be$var$th) throw Error($371c230a09dd78be$var$p(174));
    return a;
}
function $371c230a09dd78be$var$yh(a, b) {
    $371c230a09dd78be$var$G($371c230a09dd78be$var$wh, b);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$vh, a);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$uh, $371c230a09dd78be$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $371c230a09dd78be$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $371c230a09dd78be$var$lb(b, a);
    }
    $371c230a09dd78be$var$E($371c230a09dd78be$var$uh);
    $371c230a09dd78be$var$G($371c230a09dd78be$var$uh, b);
}
function $371c230a09dd78be$var$zh() {
    $371c230a09dd78be$var$E($371c230a09dd78be$var$uh);
    $371c230a09dd78be$var$E($371c230a09dd78be$var$vh);
    $371c230a09dd78be$var$E($371c230a09dd78be$var$wh);
}
function $371c230a09dd78be$var$Ah(a) {
    $371c230a09dd78be$var$xh($371c230a09dd78be$var$wh.current);
    var b = $371c230a09dd78be$var$xh($371c230a09dd78be$var$uh.current);
    var c = $371c230a09dd78be$var$lb(b, a.type);
    b !== c && ($371c230a09dd78be$var$G($371c230a09dd78be$var$vh, a), $371c230a09dd78be$var$G($371c230a09dd78be$var$uh, c));
}
function $371c230a09dd78be$var$Bh(a) {
    $371c230a09dd78be$var$vh.current === a && ($371c230a09dd78be$var$E($371c230a09dd78be$var$uh), $371c230a09dd78be$var$E($371c230a09dd78be$var$vh));
}
var $371c230a09dd78be$var$L = $371c230a09dd78be$var$Uf(0);
function $371c230a09dd78be$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $371c230a09dd78be$var$Dh = [];
function $371c230a09dd78be$var$Eh() {
    for(var a = 0; a < $371c230a09dd78be$var$Dh.length; a++)$371c230a09dd78be$var$Dh[a]._workInProgressVersionPrimary = null;
    $371c230a09dd78be$var$Dh.length = 0;
}
var $371c230a09dd78be$var$Fh = $371c230a09dd78be$var$ua.ReactCurrentDispatcher, $371c230a09dd78be$var$Gh = $371c230a09dd78be$var$ua.ReactCurrentBatchConfig, $371c230a09dd78be$var$Hh = 0, $371c230a09dd78be$var$M = null, $371c230a09dd78be$var$N = null, $371c230a09dd78be$var$O = null, $371c230a09dd78be$var$Ih = !1, $371c230a09dd78be$var$Jh = !1, $371c230a09dd78be$var$Kh = 0, $371c230a09dd78be$var$Lh = 0;
function $371c230a09dd78be$var$P() {
    throw Error($371c230a09dd78be$var$p(321));
}
function $371c230a09dd78be$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$371c230a09dd78be$var$He(a[c], b[c])) return !1;
    return !0;
}
function $371c230a09dd78be$var$Nh(a, b, c, d, e, f) {
    $371c230a09dd78be$var$Hh = f;
    $371c230a09dd78be$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $371c230a09dd78be$var$Fh.current = null === a || null === a.memoizedState ? $371c230a09dd78be$var$Oh : $371c230a09dd78be$var$Ph;
    a = c(d, e);
    if ($371c230a09dd78be$var$Jh) {
        f = 0;
        do {
            $371c230a09dd78be$var$Jh = !1;
            $371c230a09dd78be$var$Kh = 0;
            if (25 <= f) throw Error($371c230a09dd78be$var$p(301));
            f += 1;
            $371c230a09dd78be$var$O = $371c230a09dd78be$var$N = null;
            b.updateQueue = null;
            $371c230a09dd78be$var$Fh.current = $371c230a09dd78be$var$Qh;
            a = c(d, e);
        }while ($371c230a09dd78be$var$Jh);
    }
    $371c230a09dd78be$var$Fh.current = $371c230a09dd78be$var$Rh;
    b = null !== $371c230a09dd78be$var$N && null !== $371c230a09dd78be$var$N.next;
    $371c230a09dd78be$var$Hh = 0;
    $371c230a09dd78be$var$O = $371c230a09dd78be$var$N = $371c230a09dd78be$var$M = null;
    $371c230a09dd78be$var$Ih = !1;
    if (b) throw Error($371c230a09dd78be$var$p(300));
    return a;
}
function $371c230a09dd78be$var$Sh() {
    var a = 0 !== $371c230a09dd78be$var$Kh;
    $371c230a09dd78be$var$Kh = 0;
    return a;
}
function $371c230a09dd78be$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $371c230a09dd78be$var$O ? $371c230a09dd78be$var$M.memoizedState = $371c230a09dd78be$var$O = a : $371c230a09dd78be$var$O = $371c230a09dd78be$var$O.next = a;
    return $371c230a09dd78be$var$O;
}
function $371c230a09dd78be$var$Uh() {
    if (null === $371c230a09dd78be$var$N) {
        var a = $371c230a09dd78be$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $371c230a09dd78be$var$N.next;
    var b = null === $371c230a09dd78be$var$O ? $371c230a09dd78be$var$M.memoizedState : $371c230a09dd78be$var$O.next;
    if (null !== b) $371c230a09dd78be$var$O = b, $371c230a09dd78be$var$N = a;
    else {
        if (null === a) throw Error($371c230a09dd78be$var$p(310));
        $371c230a09dd78be$var$N = a;
        a = {
            memoizedState: $371c230a09dd78be$var$N.memoizedState,
            baseState: $371c230a09dd78be$var$N.baseState,
            baseQueue: $371c230a09dd78be$var$N.baseQueue,
            queue: $371c230a09dd78be$var$N.queue,
            next: null
        };
        null === $371c230a09dd78be$var$O ? $371c230a09dd78be$var$M.memoizedState = $371c230a09dd78be$var$O = a : $371c230a09dd78be$var$O = $371c230a09dd78be$var$O.next = a;
    }
    return $371c230a09dd78be$var$O;
}
function $371c230a09dd78be$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $371c230a09dd78be$var$Wh(a) {
    var b = $371c230a09dd78be$var$Uh(), c = b.queue;
    if (null === c) throw Error($371c230a09dd78be$var$p(311));
    c.lastRenderedReducer = a;
    var d = $371c230a09dd78be$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($371c230a09dd78be$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $371c230a09dd78be$var$M.lanes |= m;
                $371c230a09dd78be$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $371c230a09dd78be$var$He(d, b.memoizedState) || ($371c230a09dd78be$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $371c230a09dd78be$var$M.lanes |= f, $371c230a09dd78be$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $371c230a09dd78be$var$Xh(a) {
    var b = $371c230a09dd78be$var$Uh(), c = b.queue;
    if (null === c) throw Error($371c230a09dd78be$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $371c230a09dd78be$var$He(f, b.memoizedState) || ($371c230a09dd78be$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $371c230a09dd78be$var$Yh() {}
function $371c230a09dd78be$var$Zh(a, b) {
    var c = $371c230a09dd78be$var$M, d = $371c230a09dd78be$var$Uh(), e = b(), f = !$371c230a09dd78be$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $371c230a09dd78be$var$dh = !0);
    d = d.queue;
    $371c230a09dd78be$var$$h($371c230a09dd78be$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $371c230a09dd78be$var$O && $371c230a09dd78be$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $371c230a09dd78be$var$bi(9, $371c230a09dd78be$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $371c230a09dd78be$var$Q) throw Error($371c230a09dd78be$var$p(349));
        0 !== ($371c230a09dd78be$var$Hh & 30) || $371c230a09dd78be$var$di(c, b, e);
    }
    return e;
}
function $371c230a09dd78be$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $371c230a09dd78be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $371c230a09dd78be$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $371c230a09dd78be$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $371c230a09dd78be$var$ei(b) && $371c230a09dd78be$var$fi(a);
}
function $371c230a09dd78be$var$ai(a, b, c) {
    return c(function() {
        $371c230a09dd78be$var$ei(b) && $371c230a09dd78be$var$fi(a);
    });
}
function $371c230a09dd78be$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$371c230a09dd78be$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $371c230a09dd78be$var$fi(a) {
    var b = $371c230a09dd78be$var$ih(a, 1);
    null !== b && $371c230a09dd78be$var$gi(b, a, 1, -1);
}
function $371c230a09dd78be$var$hi(a) {
    var b = $371c230a09dd78be$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $371c230a09dd78be$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $371c230a09dd78be$var$ii.bind(null, $371c230a09dd78be$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $371c230a09dd78be$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $371c230a09dd78be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $371c230a09dd78be$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $371c230a09dd78be$var$ji() {
    return $371c230a09dd78be$var$Uh().memoizedState;
}
function $371c230a09dd78be$var$ki(a, b, c, d) {
    var e = $371c230a09dd78be$var$Th();
    $371c230a09dd78be$var$M.flags |= a;
    e.memoizedState = $371c230a09dd78be$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $371c230a09dd78be$var$li(a, b, c, d) {
    var e = $371c230a09dd78be$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $371c230a09dd78be$var$N) {
        var g = $371c230a09dd78be$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $371c230a09dd78be$var$Mh(d, g.deps)) {
            e.memoizedState = $371c230a09dd78be$var$bi(b, c, f, d);
            return;
        }
    }
    $371c230a09dd78be$var$M.flags |= a;
    e.memoizedState = $371c230a09dd78be$var$bi(1 | b, c, f, d);
}
function $371c230a09dd78be$var$mi(a, b) {
    return $371c230a09dd78be$var$ki(8390656, 8, a, b);
}
function $371c230a09dd78be$var$$h(a, b) {
    return $371c230a09dd78be$var$li(2048, 8, a, b);
}
function $371c230a09dd78be$var$ni(a, b) {
    return $371c230a09dd78be$var$li(4, 2, a, b);
}
function $371c230a09dd78be$var$oi(a, b) {
    return $371c230a09dd78be$var$li(4, 4, a, b);
}
function $371c230a09dd78be$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $371c230a09dd78be$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $371c230a09dd78be$var$li(4, 4, $371c230a09dd78be$var$pi.bind(null, b, a), c);
}
function $371c230a09dd78be$var$ri() {}
function $371c230a09dd78be$var$si(a, b) {
    var c = $371c230a09dd78be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $371c230a09dd78be$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $371c230a09dd78be$var$ti(a, b) {
    var c = $371c230a09dd78be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $371c230a09dd78be$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $371c230a09dd78be$var$ui(a, b, c) {
    if (0 === ($371c230a09dd78be$var$Hh & 21)) return a.baseState && (a.baseState = !1, $371c230a09dd78be$var$dh = !0), a.memoizedState = c;
    $371c230a09dd78be$var$He(c, b) || (c = $371c230a09dd78be$var$yc(), $371c230a09dd78be$var$M.lanes |= c, $371c230a09dd78be$var$rh |= c, a.baseState = !0);
    return b;
}
function $371c230a09dd78be$var$vi(a, b) {
    var c = $371c230a09dd78be$var$C;
    $371c230a09dd78be$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $371c230a09dd78be$var$Gh.transition;
    $371c230a09dd78be$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $371c230a09dd78be$var$C = c, $371c230a09dd78be$var$Gh.transition = d;
    }
}
function $371c230a09dd78be$var$wi() {
    return $371c230a09dd78be$var$Uh().memoizedState;
}
function $371c230a09dd78be$var$xi(a, b, c) {
    var d = $371c230a09dd78be$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($371c230a09dd78be$var$zi(a)) $371c230a09dd78be$var$Ai(b, c);
    else if (c = $371c230a09dd78be$var$hh(a, b, c, d), null !== c) {
        var e = $371c230a09dd78be$var$R();
        $371c230a09dd78be$var$gi(c, a, d, e);
        $371c230a09dd78be$var$Bi(c, b, d);
    }
}
function $371c230a09dd78be$var$ii(a, b, c) {
    var d = $371c230a09dd78be$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($371c230a09dd78be$var$zi(a)) $371c230a09dd78be$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($371c230a09dd78be$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $371c230a09dd78be$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $371c230a09dd78be$var$hh(a, b, e, d);
        null !== c && (e = $371c230a09dd78be$var$R(), $371c230a09dd78be$var$gi(c, a, d, e), $371c230a09dd78be$var$Bi(c, b, d));
    }
}
function $371c230a09dd78be$var$zi(a) {
    var b = a.alternate;
    return a === $371c230a09dd78be$var$M || null !== b && b === $371c230a09dd78be$var$M;
}
function $371c230a09dd78be$var$Ai(a, b) {
    $371c230a09dd78be$var$Jh = $371c230a09dd78be$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $371c230a09dd78be$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $371c230a09dd78be$var$Cc(a, c);
    }
}
var $371c230a09dd78be$var$Rh = {
    readContext: $371c230a09dd78be$var$eh,
    useCallback: $371c230a09dd78be$var$P,
    useContext: $371c230a09dd78be$var$P,
    useEffect: $371c230a09dd78be$var$P,
    useImperativeHandle: $371c230a09dd78be$var$P,
    useInsertionEffect: $371c230a09dd78be$var$P,
    useLayoutEffect: $371c230a09dd78be$var$P,
    useMemo: $371c230a09dd78be$var$P,
    useReducer: $371c230a09dd78be$var$P,
    useRef: $371c230a09dd78be$var$P,
    useState: $371c230a09dd78be$var$P,
    useDebugValue: $371c230a09dd78be$var$P,
    useDeferredValue: $371c230a09dd78be$var$P,
    useTransition: $371c230a09dd78be$var$P,
    useMutableSource: $371c230a09dd78be$var$P,
    useSyncExternalStore: $371c230a09dd78be$var$P,
    useId: $371c230a09dd78be$var$P,
    unstable_isNewReconciler: !1
}, $371c230a09dd78be$var$Oh = {
    readContext: $371c230a09dd78be$var$eh,
    useCallback: function(a, b) {
        $371c230a09dd78be$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $371c230a09dd78be$var$eh,
    useEffect: $371c230a09dd78be$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $371c230a09dd78be$var$ki(4194308, 4, $371c230a09dd78be$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $371c230a09dd78be$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $371c230a09dd78be$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $371c230a09dd78be$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $371c230a09dd78be$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $371c230a09dd78be$var$xi.bind(null, $371c230a09dd78be$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $371c230a09dd78be$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $371c230a09dd78be$var$hi,
    useDebugValue: $371c230a09dd78be$var$ri,
    useDeferredValue: function(a) {
        return $371c230a09dd78be$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $371c230a09dd78be$var$hi(!1), b = a[0];
        a = $371c230a09dd78be$var$vi.bind(null, a[1]);
        $371c230a09dd78be$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $371c230a09dd78be$var$M, e = $371c230a09dd78be$var$Th();
        if ($371c230a09dd78be$var$I) {
            if (void 0 === c) throw Error($371c230a09dd78be$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $371c230a09dd78be$var$Q) throw Error($371c230a09dd78be$var$p(349));
            0 !== ($371c230a09dd78be$var$Hh & 30) || $371c230a09dd78be$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $371c230a09dd78be$var$mi($371c230a09dd78be$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $371c230a09dd78be$var$bi(9, $371c230a09dd78be$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $371c230a09dd78be$var$Th(), b = $371c230a09dd78be$var$Q.identifierPrefix;
        if ($371c230a09dd78be$var$I) {
            var c = $371c230a09dd78be$var$sg;
            var d = $371c230a09dd78be$var$rg;
            c = (d & ~(1 << 32 - $371c230a09dd78be$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $371c230a09dd78be$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $371c230a09dd78be$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $371c230a09dd78be$var$Ph = {
    readContext: $371c230a09dd78be$var$eh,
    useCallback: $371c230a09dd78be$var$si,
    useContext: $371c230a09dd78be$var$eh,
    useEffect: $371c230a09dd78be$var$$h,
    useImperativeHandle: $371c230a09dd78be$var$qi,
    useInsertionEffect: $371c230a09dd78be$var$ni,
    useLayoutEffect: $371c230a09dd78be$var$oi,
    useMemo: $371c230a09dd78be$var$ti,
    useReducer: $371c230a09dd78be$var$Wh,
    useRef: $371c230a09dd78be$var$ji,
    useState: function() {
        return $371c230a09dd78be$var$Wh($371c230a09dd78be$var$Vh);
    },
    useDebugValue: $371c230a09dd78be$var$ri,
    useDeferredValue: function(a) {
        var b = $371c230a09dd78be$var$Uh();
        return $371c230a09dd78be$var$ui(b, $371c230a09dd78be$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $371c230a09dd78be$var$Wh($371c230a09dd78be$var$Vh)[0], b = $371c230a09dd78be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $371c230a09dd78be$var$Yh,
    useSyncExternalStore: $371c230a09dd78be$var$Zh,
    useId: $371c230a09dd78be$var$wi,
    unstable_isNewReconciler: !1
}, $371c230a09dd78be$var$Qh = {
    readContext: $371c230a09dd78be$var$eh,
    useCallback: $371c230a09dd78be$var$si,
    useContext: $371c230a09dd78be$var$eh,
    useEffect: $371c230a09dd78be$var$$h,
    useImperativeHandle: $371c230a09dd78be$var$qi,
    useInsertionEffect: $371c230a09dd78be$var$ni,
    useLayoutEffect: $371c230a09dd78be$var$oi,
    useMemo: $371c230a09dd78be$var$ti,
    useReducer: $371c230a09dd78be$var$Xh,
    useRef: $371c230a09dd78be$var$ji,
    useState: function() {
        return $371c230a09dd78be$var$Xh($371c230a09dd78be$var$Vh);
    },
    useDebugValue: $371c230a09dd78be$var$ri,
    useDeferredValue: function(a) {
        var b = $371c230a09dd78be$var$Uh();
        return null === $371c230a09dd78be$var$N ? b.memoizedState = a : $371c230a09dd78be$var$ui(b, $371c230a09dd78be$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $371c230a09dd78be$var$Xh($371c230a09dd78be$var$Vh)[0], b = $371c230a09dd78be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $371c230a09dd78be$var$Yh,
    useSyncExternalStore: $371c230a09dd78be$var$Zh,
    useId: $371c230a09dd78be$var$wi,
    unstable_isNewReconciler: !1
};
function $371c230a09dd78be$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $371c230a09dd78be$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $371c230a09dd78be$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $371c230a09dd78be$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $371c230a09dd78be$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $371c230a09dd78be$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $371c230a09dd78be$var$R(), e = $371c230a09dd78be$var$yi(a), f = $371c230a09dd78be$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $371c230a09dd78be$var$nh(a, f, e);
        null !== b && ($371c230a09dd78be$var$gi(b, a, e, d), $371c230a09dd78be$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $371c230a09dd78be$var$R(), e = $371c230a09dd78be$var$yi(a), f = $371c230a09dd78be$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $371c230a09dd78be$var$nh(a, f, e);
        null !== b && ($371c230a09dd78be$var$gi(b, a, e, d), $371c230a09dd78be$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $371c230a09dd78be$var$R(), d = $371c230a09dd78be$var$yi(a), e = $371c230a09dd78be$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $371c230a09dd78be$var$nh(a, e, d);
        null !== b && ($371c230a09dd78be$var$gi(b, a, d, c), $371c230a09dd78be$var$oh(b, a, d));
    }
};
function $371c230a09dd78be$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$371c230a09dd78be$var$Ie(c, d) || !$371c230a09dd78be$var$Ie(e, f) : !0;
}
function $371c230a09dd78be$var$Gi(a, b, c) {
    var d = !1, e = $371c230a09dd78be$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $371c230a09dd78be$var$eh(f) : (e = $371c230a09dd78be$var$Zf(b) ? $371c230a09dd78be$var$Xf : $371c230a09dd78be$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $371c230a09dd78be$var$Yf(a, e) : $371c230a09dd78be$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $371c230a09dd78be$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $371c230a09dd78be$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $371c230a09dd78be$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $371c230a09dd78be$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $371c230a09dd78be$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $371c230a09dd78be$var$eh(f) : (f = $371c230a09dd78be$var$Zf(b) ? $371c230a09dd78be$var$Xf : $371c230a09dd78be$var$H.current, e.context = $371c230a09dd78be$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($371c230a09dd78be$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $371c230a09dd78be$var$Ei.enqueueReplaceState(e, e.state, null), $371c230a09dd78be$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $371c230a09dd78be$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $371c230a09dd78be$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $371c230a09dd78be$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $371c230a09dd78be$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $371c230a09dd78be$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $371c230a09dd78be$var$Ni(a, b, c) {
    c = $371c230a09dd78be$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $371c230a09dd78be$var$Oi || ($371c230a09dd78be$var$Oi = !0, $371c230a09dd78be$var$Pi = d);
        $371c230a09dd78be$var$Li(a, b);
    };
    return c;
}
function $371c230a09dd78be$var$Qi(a, b, c) {
    c = $371c230a09dd78be$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $371c230a09dd78be$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $371c230a09dd78be$var$Li(a, b);
        "function" !== typeof d && (null === $371c230a09dd78be$var$Ri ? $371c230a09dd78be$var$Ri = new Set([
            this
        ]) : $371c230a09dd78be$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $371c230a09dd78be$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $371c230a09dd78be$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $371c230a09dd78be$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $371c230a09dd78be$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $371c230a09dd78be$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $371c230a09dd78be$var$mh(-1, 1), b.tag = 2, $371c230a09dd78be$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $371c230a09dd78be$var$Wi = $371c230a09dd78be$var$ua.ReactCurrentOwner, $371c230a09dd78be$var$dh = !1;
function $371c230a09dd78be$var$Xi(a, b, c, d) {
    b.child = null === a ? $371c230a09dd78be$var$Vg(b, null, c, d) : $371c230a09dd78be$var$Ug(b, a.child, c, d);
}
function $371c230a09dd78be$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $371c230a09dd78be$var$ch(b, e);
    d = $371c230a09dd78be$var$Nh(a, b, c, d, f, e);
    c = $371c230a09dd78be$var$Sh();
    if (null !== a && !$371c230a09dd78be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $371c230a09dd78be$var$Zi(a, b, e);
    $371c230a09dd78be$var$I && c && $371c230a09dd78be$var$vg(b);
    b.flags |= 1;
    $371c230a09dd78be$var$Xi(a, b, d, e);
    return b.child;
}
function $371c230a09dd78be$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$371c230a09dd78be$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $371c230a09dd78be$var$bj(a, b, f, d, e);
        a = $371c230a09dd78be$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $371c230a09dd78be$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $371c230a09dd78be$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $371c230a09dd78be$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $371c230a09dd78be$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($371c230a09dd78be$var$Ie(f, d) && a.ref === b.ref) {
            if ($371c230a09dd78be$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($371c230a09dd78be$var$dh = !0);
            else return b.lanes = a.lanes, $371c230a09dd78be$var$Zi(a, b, e);
        }
    }
    return $371c230a09dd78be$var$cj(a, b, c, d, e);
}
function $371c230a09dd78be$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $371c230a09dd78be$var$G($371c230a09dd78be$var$ej, $371c230a09dd78be$var$fj), $371c230a09dd78be$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $371c230a09dd78be$var$G($371c230a09dd78be$var$ej, $371c230a09dd78be$var$fj), $371c230a09dd78be$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $371c230a09dd78be$var$G($371c230a09dd78be$var$ej, $371c230a09dd78be$var$fj);
            $371c230a09dd78be$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $371c230a09dd78be$var$G($371c230a09dd78be$var$ej, $371c230a09dd78be$var$fj), $371c230a09dd78be$var$fj |= d;
    $371c230a09dd78be$var$Xi(a, b, e, c);
    return b.child;
}
function $371c230a09dd78be$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $371c230a09dd78be$var$cj(a, b, c, d, e) {
    var f = $371c230a09dd78be$var$Zf(c) ? $371c230a09dd78be$var$Xf : $371c230a09dd78be$var$H.current;
    f = $371c230a09dd78be$var$Yf(b, f);
    $371c230a09dd78be$var$ch(b, e);
    c = $371c230a09dd78be$var$Nh(a, b, c, d, f, e);
    d = $371c230a09dd78be$var$Sh();
    if (null !== a && !$371c230a09dd78be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $371c230a09dd78be$var$Zi(a, b, e);
    $371c230a09dd78be$var$I && d && $371c230a09dd78be$var$vg(b);
    b.flags |= 1;
    $371c230a09dd78be$var$Xi(a, b, c, e);
    return b.child;
}
function $371c230a09dd78be$var$hj(a, b, c, d, e) {
    if ($371c230a09dd78be$var$Zf(c)) {
        var f = !0;
        $371c230a09dd78be$var$cg(b);
    } else f = !1;
    $371c230a09dd78be$var$ch(b, e);
    if (null === b.stateNode) $371c230a09dd78be$var$ij(a, b), $371c230a09dd78be$var$Gi(b, c, d), $371c230a09dd78be$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $371c230a09dd78be$var$eh(l) : (l = $371c230a09dd78be$var$Zf(c) ? $371c230a09dd78be$var$Xf : $371c230a09dd78be$var$H.current, l = $371c230a09dd78be$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $371c230a09dd78be$var$Hi(b, g, d, l);
        $371c230a09dd78be$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $371c230a09dd78be$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $371c230a09dd78be$var$Wf.current || $371c230a09dd78be$var$jh ? ("function" === typeof m && ($371c230a09dd78be$var$Di(b, c, m, d), k = b.memoizedState), (h = $371c230a09dd78be$var$jh || $371c230a09dd78be$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $371c230a09dd78be$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $371c230a09dd78be$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $371c230a09dd78be$var$eh(k) : (k = $371c230a09dd78be$var$Zf(c) ? $371c230a09dd78be$var$Xf : $371c230a09dd78be$var$H.current, k = $371c230a09dd78be$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $371c230a09dd78be$var$Hi(b, g, d, k);
        $371c230a09dd78be$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $371c230a09dd78be$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $371c230a09dd78be$var$Wf.current || $371c230a09dd78be$var$jh ? ("function" === typeof y && ($371c230a09dd78be$var$Di(b, c, y, d), n = b.memoizedState), (l = $371c230a09dd78be$var$jh || $371c230a09dd78be$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $371c230a09dd78be$var$jj(a, b, c, d, f, e);
}
function $371c230a09dd78be$var$jj(a, b, c, d, e, f) {
    $371c230a09dd78be$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $371c230a09dd78be$var$dg(b, c, !1), $371c230a09dd78be$var$Zi(a, b, f);
    d = b.stateNode;
    $371c230a09dd78be$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $371c230a09dd78be$var$Ug(b, a.child, null, f), b.child = $371c230a09dd78be$var$Ug(b, null, h, f)) : $371c230a09dd78be$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $371c230a09dd78be$var$dg(b, c, !0);
    return b.child;
}
function $371c230a09dd78be$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $371c230a09dd78be$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $371c230a09dd78be$var$ag(a, b.context, !1);
    $371c230a09dd78be$var$yh(a, b.containerInfo);
}
function $371c230a09dd78be$var$lj(a, b, c, d, e) {
    $371c230a09dd78be$var$Ig();
    $371c230a09dd78be$var$Jg(e);
    b.flags |= 256;
    $371c230a09dd78be$var$Xi(a, b, c, d);
    return b.child;
}
var $371c230a09dd78be$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $371c230a09dd78be$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $371c230a09dd78be$var$oj(a, b, c) {
    var d = b.pendingProps, e = $371c230a09dd78be$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $371c230a09dd78be$var$G($371c230a09dd78be$var$L, e & 1);
    if (null === a) {
        $371c230a09dd78be$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $371c230a09dd78be$var$pj(g, d, 0, null), a = $371c230a09dd78be$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $371c230a09dd78be$var$nj(c), b.memoizedState = $371c230a09dd78be$var$mj, a) : $371c230a09dd78be$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $371c230a09dd78be$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $371c230a09dd78be$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $371c230a09dd78be$var$Pg(h, f) : (f = $371c230a09dd78be$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $371c230a09dd78be$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $371c230a09dd78be$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $371c230a09dd78be$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $371c230a09dd78be$var$qj(a, b) {
    b = $371c230a09dd78be$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $371c230a09dd78be$var$sj(a, b, c, d) {
    null !== d && $371c230a09dd78be$var$Jg(d);
    $371c230a09dd78be$var$Ug(b, a.child, null, c);
    a = $371c230a09dd78be$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $371c230a09dd78be$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $371c230a09dd78be$var$Ki(Error($371c230a09dd78be$var$p(422))), $371c230a09dd78be$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $371c230a09dd78be$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $371c230a09dd78be$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $371c230a09dd78be$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $371c230a09dd78be$var$nj(g);
        b.memoizedState = $371c230a09dd78be$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $371c230a09dd78be$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($371c230a09dd78be$var$p(419));
        d = $371c230a09dd78be$var$Ki(f, d, void 0);
        return $371c230a09dd78be$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($371c230a09dd78be$var$dh || h) {
        d = $371c230a09dd78be$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $371c230a09dd78be$var$ih(a, e), $371c230a09dd78be$var$gi(d, a, e, -1));
        }
        $371c230a09dd78be$var$tj();
        d = $371c230a09dd78be$var$Ki(Error($371c230a09dd78be$var$p(421)));
        return $371c230a09dd78be$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $371c230a09dd78be$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $371c230a09dd78be$var$yg = $371c230a09dd78be$var$Lf(e.nextSibling);
    $371c230a09dd78be$var$xg = b;
    $371c230a09dd78be$var$I = !0;
    $371c230a09dd78be$var$zg = null;
    null !== a && ($371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$rg, $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$sg, $371c230a09dd78be$var$og[$371c230a09dd78be$var$pg++] = $371c230a09dd78be$var$qg, $371c230a09dd78be$var$rg = a.id, $371c230a09dd78be$var$sg = a.overflow, $371c230a09dd78be$var$qg = b);
    b = $371c230a09dd78be$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $371c230a09dd78be$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $371c230a09dd78be$var$bh(a.return, b, c);
}
function $371c230a09dd78be$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $371c230a09dd78be$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $371c230a09dd78be$var$Xi(a, b, d.children, c);
    d = $371c230a09dd78be$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $371c230a09dd78be$var$vj(a, c, b);
            else if (19 === a.tag) $371c230a09dd78be$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $371c230a09dd78be$var$G($371c230a09dd78be$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $371c230a09dd78be$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $371c230a09dd78be$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $371c230a09dd78be$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $371c230a09dd78be$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $371c230a09dd78be$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $371c230a09dd78be$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $371c230a09dd78be$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $371c230a09dd78be$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($371c230a09dd78be$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $371c230a09dd78be$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $371c230a09dd78be$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $371c230a09dd78be$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $371c230a09dd78be$var$kj(b);
            $371c230a09dd78be$var$Ig();
            break;
        case 5:
            $371c230a09dd78be$var$Ah(b);
            break;
        case 1:
            $371c230a09dd78be$var$Zf(b.type) && $371c230a09dd78be$var$cg(b);
            break;
        case 4:
            $371c230a09dd78be$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $371c230a09dd78be$var$G($371c230a09dd78be$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $371c230a09dd78be$var$G($371c230a09dd78be$var$L, $371c230a09dd78be$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $371c230a09dd78be$var$oj(a, b, c);
                $371c230a09dd78be$var$G($371c230a09dd78be$var$L, $371c230a09dd78be$var$L.current & 1);
                a = $371c230a09dd78be$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $371c230a09dd78be$var$G($371c230a09dd78be$var$L, $371c230a09dd78be$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $371c230a09dd78be$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $371c230a09dd78be$var$G($371c230a09dd78be$var$L, $371c230a09dd78be$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $371c230a09dd78be$var$dj(a, b, c);
    }
    return $371c230a09dd78be$var$Zi(a, b, c);
}
var $371c230a09dd78be$var$zj, $371c230a09dd78be$var$Aj, $371c230a09dd78be$var$Bj, $371c230a09dd78be$var$Cj;
$371c230a09dd78be$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$371c230a09dd78be$var$Aj = function() {};
$371c230a09dd78be$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $371c230a09dd78be$var$xh($371c230a09dd78be$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $371c230a09dd78be$var$Ya(a, e);
                d = $371c230a09dd78be$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $371c230a09dd78be$var$A({}, e, {
                    value: void 0
                });
                d = $371c230a09dd78be$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $371c230a09dd78be$var$gb(a, e);
                d = $371c230a09dd78be$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $371c230a09dd78be$var$Bf);
        }
        $371c230a09dd78be$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($371c230a09dd78be$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($371c230a09dd78be$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $371c230a09dd78be$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$371c230a09dd78be$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $371c230a09dd78be$var$Dj(a, b) {
    if (!$371c230a09dd78be$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $371c230a09dd78be$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $371c230a09dd78be$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $371c230a09dd78be$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $371c230a09dd78be$var$S(b), null;
        case 1:
            return $371c230a09dd78be$var$Zf(b.type) && $371c230a09dd78be$var$$f(), $371c230a09dd78be$var$S(b), null;
        case 3:
            d = b.stateNode;
            $371c230a09dd78be$var$zh();
            $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf);
            $371c230a09dd78be$var$E($371c230a09dd78be$var$H);
            $371c230a09dd78be$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $371c230a09dd78be$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $371c230a09dd78be$var$zg && ($371c230a09dd78be$var$Fj($371c230a09dd78be$var$zg), $371c230a09dd78be$var$zg = null));
            $371c230a09dd78be$var$Aj(a, b);
            $371c230a09dd78be$var$S(b);
            return null;
        case 5:
            $371c230a09dd78be$var$Bh(b);
            var e = $371c230a09dd78be$var$xh($371c230a09dd78be$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $371c230a09dd78be$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($371c230a09dd78be$var$p(166));
                    $371c230a09dd78be$var$S(b);
                    return null;
                }
                a = $371c230a09dd78be$var$xh($371c230a09dd78be$var$uh.current);
                if ($371c230a09dd78be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$371c230a09dd78be$var$Of] = b;
                    d[$371c230a09dd78be$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $371c230a09dd78be$var$D("cancel", d);
                            $371c230a09dd78be$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $371c230a09dd78be$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $371c230a09dd78be$var$lf.length; e++)$371c230a09dd78be$var$D($371c230a09dd78be$var$lf[e], d);
                            break;
                        case "source":
                            $371c230a09dd78be$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $371c230a09dd78be$var$D("error", d);
                            $371c230a09dd78be$var$D("load", d);
                            break;
                        case "details":
                            $371c230a09dd78be$var$D("toggle", d);
                            break;
                        case "input":
                            $371c230a09dd78be$var$Za(d, f);
                            $371c230a09dd78be$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $371c230a09dd78be$var$D("invalid", d);
                            break;
                        case "textarea":
                            $371c230a09dd78be$var$hb(d, f), $371c230a09dd78be$var$D("invalid", d);
                    }
                    $371c230a09dd78be$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $371c230a09dd78be$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $371c230a09dd78be$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $371c230a09dd78be$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $371c230a09dd78be$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $371c230a09dd78be$var$Va(d);
                            $371c230a09dd78be$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $371c230a09dd78be$var$Va(d);
                            $371c230a09dd78be$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $371c230a09dd78be$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $371c230a09dd78be$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$371c230a09dd78be$var$Of] = b;
                    a[$371c230a09dd78be$var$Pf] = d;
                    $371c230a09dd78be$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $371c230a09dd78be$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $371c230a09dd78be$var$D("cancel", a);
                                $371c230a09dd78be$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $371c230a09dd78be$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $371c230a09dd78be$var$lf.length; e++)$371c230a09dd78be$var$D($371c230a09dd78be$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $371c230a09dd78be$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $371c230a09dd78be$var$D("error", a);
                                $371c230a09dd78be$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $371c230a09dd78be$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $371c230a09dd78be$var$Za(a, d);
                                e = $371c230a09dd78be$var$Ya(a, d);
                                $371c230a09dd78be$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $371c230a09dd78be$var$A({}, d, {
                                    value: void 0
                                });
                                $371c230a09dd78be$var$D("invalid", a);
                                break;
                            case "textarea":
                                $371c230a09dd78be$var$hb(a, d);
                                e = $371c230a09dd78be$var$gb(a, d);
                                $371c230a09dd78be$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $371c230a09dd78be$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $371c230a09dd78be$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $371c230a09dd78be$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $371c230a09dd78be$var$ob(a, k) : "number" === typeof k && $371c230a09dd78be$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($371c230a09dd78be$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $371c230a09dd78be$var$D("scroll", a) : null != k && $371c230a09dd78be$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $371c230a09dd78be$var$Va(a);
                                $371c230a09dd78be$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $371c230a09dd78be$var$Va(a);
                                $371c230a09dd78be$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $371c230a09dd78be$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $371c230a09dd78be$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $371c230a09dd78be$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $371c230a09dd78be$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $371c230a09dd78be$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $371c230a09dd78be$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($371c230a09dd78be$var$p(166));
                c = $371c230a09dd78be$var$xh($371c230a09dd78be$var$wh.current);
                $371c230a09dd78be$var$xh($371c230a09dd78be$var$uh.current);
                if ($371c230a09dd78be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$371c230a09dd78be$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $371c230a09dd78be$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $371c230a09dd78be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $371c230a09dd78be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$371c230a09dd78be$var$Of] = b, b.stateNode = d;
            }
            $371c230a09dd78be$var$S(b);
            return null;
        case 13:
            $371c230a09dd78be$var$E($371c230a09dd78be$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($371c230a09dd78be$var$I && null !== $371c230a09dd78be$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $371c230a09dd78be$var$Hg(), $371c230a09dd78be$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $371c230a09dd78be$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($371c230a09dd78be$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($371c230a09dd78be$var$p(317));
                        f[$371c230a09dd78be$var$Of] = b;
                    } else $371c230a09dd78be$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $371c230a09dd78be$var$S(b);
                    f = !1;
                } else null !== $371c230a09dd78be$var$zg && ($371c230a09dd78be$var$Fj($371c230a09dd78be$var$zg), $371c230a09dd78be$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($371c230a09dd78be$var$L.current & 1) ? 0 === $371c230a09dd78be$var$T && ($371c230a09dd78be$var$T = 3) : $371c230a09dd78be$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $371c230a09dd78be$var$S(b);
            return null;
        case 4:
            return $371c230a09dd78be$var$zh(), $371c230a09dd78be$var$Aj(a, b), null === a && $371c230a09dd78be$var$sf(b.stateNode.containerInfo), $371c230a09dd78be$var$S(b), null;
        case 10:
            return $371c230a09dd78be$var$ah(b.type._context), $371c230a09dd78be$var$S(b), null;
        case 17:
            return $371c230a09dd78be$var$Zf(b.type) && $371c230a09dd78be$var$$f(), $371c230a09dd78be$var$S(b), null;
        case 19:
            $371c230a09dd78be$var$E($371c230a09dd78be$var$L);
            f = b.memoizedState;
            if (null === f) return $371c230a09dd78be$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $371c230a09dd78be$var$Dj(f, !1);
                else {
                    if (0 !== $371c230a09dd78be$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $371c230a09dd78be$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $371c230a09dd78be$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $371c230a09dd78be$var$G($371c230a09dd78be$var$L, $371c230a09dd78be$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $371c230a09dd78be$var$B() > $371c230a09dd78be$var$Gj && (b.flags |= 128, d = !0, $371c230a09dd78be$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $371c230a09dd78be$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $371c230a09dd78be$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$371c230a09dd78be$var$I) return $371c230a09dd78be$var$S(b), null;
                    } else 2 * $371c230a09dd78be$var$B() - f.renderingStartTime > $371c230a09dd78be$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $371c230a09dd78be$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $371c230a09dd78be$var$B(), b.sibling = null, c = $371c230a09dd78be$var$L.current, $371c230a09dd78be$var$G($371c230a09dd78be$var$L, d ? c & 1 | 2 : c & 1), b;
            $371c230a09dd78be$var$S(b);
            return null;
        case 22:
        case 23:
            return $371c230a09dd78be$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($371c230a09dd78be$var$fj & 1073741824) && ($371c230a09dd78be$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $371c230a09dd78be$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($371c230a09dd78be$var$p(156, b.tag));
}
function $371c230a09dd78be$var$Ij(a, b) {
    $371c230a09dd78be$var$wg(b);
    switch(b.tag){
        case 1:
            return $371c230a09dd78be$var$Zf(b.type) && $371c230a09dd78be$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $371c230a09dd78be$var$zh(), $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf), $371c230a09dd78be$var$E($371c230a09dd78be$var$H), $371c230a09dd78be$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $371c230a09dd78be$var$Bh(b), null;
        case 13:
            $371c230a09dd78be$var$E($371c230a09dd78be$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($371c230a09dd78be$var$p(340));
                $371c230a09dd78be$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $371c230a09dd78be$var$E($371c230a09dd78be$var$L), null;
        case 4:
            return $371c230a09dd78be$var$zh(), null;
        case 10:
            return $371c230a09dd78be$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $371c230a09dd78be$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $371c230a09dd78be$var$Jj = !1, $371c230a09dd78be$var$U = !1, $371c230a09dd78be$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $371c230a09dd78be$var$V = null;
function $371c230a09dd78be$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $371c230a09dd78be$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $371c230a09dd78be$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $371c230a09dd78be$var$W(a, b, d);
    }
}
var $371c230a09dd78be$var$Nj = !1;
function $371c230a09dd78be$var$Oj(a, b) {
    $371c230a09dd78be$var$Cf = $371c230a09dd78be$var$dd;
    a = $371c230a09dd78be$var$Me();
    if ($371c230a09dd78be$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $371c230a09dd78be$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $371c230a09dd78be$var$dd = !1;
    for($371c230a09dd78be$var$V = b; null !== $371c230a09dd78be$var$V;)if (b = $371c230a09dd78be$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $371c230a09dd78be$var$V = a;
    else for(; null !== $371c230a09dd78be$var$V;){
        b = $371c230a09dd78be$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $371c230a09dd78be$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($371c230a09dd78be$var$p(163));
            }
        } catch (F) {
            $371c230a09dd78be$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $371c230a09dd78be$var$V = a;
            break;
        }
        $371c230a09dd78be$var$V = b.return;
    }
    n = $371c230a09dd78be$var$Nj;
    $371c230a09dd78be$var$Nj = !1;
    return n;
}
function $371c230a09dd78be$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $371c230a09dd78be$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $371c230a09dd78be$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $371c230a09dd78be$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $371c230a09dd78be$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $371c230a09dd78be$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$371c230a09dd78be$var$Of], delete b[$371c230a09dd78be$var$Pf], delete b[$371c230a09dd78be$var$of], delete b[$371c230a09dd78be$var$Qf], delete b[$371c230a09dd78be$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $371c230a09dd78be$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $371c230a09dd78be$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $371c230a09dd78be$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $371c230a09dd78be$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $371c230a09dd78be$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($371c230a09dd78be$var$Vj(a, b, c), a = a.sibling; null !== a;)$371c230a09dd78be$var$Vj(a, b, c), a = a.sibling;
}
function $371c230a09dd78be$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($371c230a09dd78be$var$Wj(a, b, c), a = a.sibling; null !== a;)$371c230a09dd78be$var$Wj(a, b, c), a = a.sibling;
}
var $371c230a09dd78be$var$X = null, $371c230a09dd78be$var$Xj = !1;
function $371c230a09dd78be$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$371c230a09dd78be$var$Zj(a, b, c), c = c.sibling;
}
function $371c230a09dd78be$var$Zj(a, b, c) {
    if ($371c230a09dd78be$var$lc && "function" === typeof $371c230a09dd78be$var$lc.onCommitFiberUnmount) try {
        $371c230a09dd78be$var$lc.onCommitFiberUnmount($371c230a09dd78be$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $371c230a09dd78be$var$U || $371c230a09dd78be$var$Lj(c, b);
        case 6:
            var d = $371c230a09dd78be$var$X, e = $371c230a09dd78be$var$Xj;
            $371c230a09dd78be$var$X = null;
            $371c230a09dd78be$var$Yj(a, b, c);
            $371c230a09dd78be$var$X = d;
            $371c230a09dd78be$var$Xj = e;
            null !== $371c230a09dd78be$var$X && ($371c230a09dd78be$var$Xj ? (a = $371c230a09dd78be$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $371c230a09dd78be$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $371c230a09dd78be$var$X && ($371c230a09dd78be$var$Xj ? (a = $371c230a09dd78be$var$X, c = c.stateNode, 8 === a.nodeType ? $371c230a09dd78be$var$Kf(a.parentNode, c) : 1 === a.nodeType && $371c230a09dd78be$var$Kf(a, c), $371c230a09dd78be$var$bd(a)) : $371c230a09dd78be$var$Kf($371c230a09dd78be$var$X, c.stateNode));
            break;
        case 4:
            d = $371c230a09dd78be$var$X;
            e = $371c230a09dd78be$var$Xj;
            $371c230a09dd78be$var$X = c.stateNode.containerInfo;
            $371c230a09dd78be$var$Xj = !0;
            $371c230a09dd78be$var$Yj(a, b, c);
            $371c230a09dd78be$var$X = d;
            $371c230a09dd78be$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$371c230a09dd78be$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $371c230a09dd78be$var$Mj(c, b, g) : 0 !== (f & 4) && $371c230a09dd78be$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $371c230a09dd78be$var$Yj(a, b, c);
            break;
        case 1:
            if (!$371c230a09dd78be$var$U && ($371c230a09dd78be$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $371c230a09dd78be$var$W(c, b, h);
            }
            $371c230a09dd78be$var$Yj(a, b, c);
            break;
        case 21:
            $371c230a09dd78be$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($371c230a09dd78be$var$U = (d = $371c230a09dd78be$var$U) || null !== c.memoizedState, $371c230a09dd78be$var$Yj(a, b, c), $371c230a09dd78be$var$U = d) : $371c230a09dd78be$var$Yj(a, b, c);
            break;
        default:
            $371c230a09dd78be$var$Yj(a, b, c);
    }
}
function $371c230a09dd78be$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $371c230a09dd78be$var$Kj);
        b.forEach(function(b) {
            var d = $371c230a09dd78be$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $371c230a09dd78be$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $371c230a09dd78be$var$X = h.stateNode;
                        $371c230a09dd78be$var$Xj = !1;
                        break a;
                    case 3:
                        $371c230a09dd78be$var$X = h.stateNode.containerInfo;
                        $371c230a09dd78be$var$Xj = !0;
                        break a;
                    case 4:
                        $371c230a09dd78be$var$X = h.stateNode.containerInfo;
                        $371c230a09dd78be$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $371c230a09dd78be$var$X) throw Error($371c230a09dd78be$var$p(160));
            $371c230a09dd78be$var$Zj(f, g, e);
            $371c230a09dd78be$var$X = null;
            $371c230a09dd78be$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $371c230a09dd78be$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$371c230a09dd78be$var$dk(b, a), b = b.sibling;
}
function $371c230a09dd78be$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            if (d & 4) {
                try {
                    $371c230a09dd78be$var$Pj(3, a, a.return), $371c230a09dd78be$var$Qj(3, a);
                } catch (t) {
                    $371c230a09dd78be$var$W(a, a.return, t);
                }
                try {
                    $371c230a09dd78be$var$Pj(5, a, a.return);
                } catch (t) {
                    $371c230a09dd78be$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            d & 512 && null !== c && $371c230a09dd78be$var$Lj(c, c.return);
            break;
        case 5:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            d & 512 && null !== c && $371c230a09dd78be$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $371c230a09dd78be$var$ob(e, "");
                } catch (t) {
                    $371c230a09dd78be$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $371c230a09dd78be$var$ab(e, f);
                    $371c230a09dd78be$var$vb(h, g);
                    var l = $371c230a09dd78be$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $371c230a09dd78be$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $371c230a09dd78be$var$nb(e, q) : "children" === m ? $371c230a09dd78be$var$ob(e, q) : $371c230a09dd78be$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $371c230a09dd78be$var$bb(e, f);
                            break;
                        case "textarea":
                            $371c230a09dd78be$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $371c230a09dd78be$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $371c230a09dd78be$var$fb(e, !!f.multiple, f.defaultValue, !0) : $371c230a09dd78be$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$371c230a09dd78be$var$Pf] = f;
                } catch (t) {
                    $371c230a09dd78be$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($371c230a09dd78be$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $371c230a09dd78be$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $371c230a09dd78be$var$bd(b.containerInfo);
            } catch (t) {
                $371c230a09dd78be$var$W(a, a.return, t);
            }
            break;
        case 4:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            break;
        case 13:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($371c230a09dd78be$var$fk = $371c230a09dd78be$var$B()));
            d & 4 && $371c230a09dd78be$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($371c230a09dd78be$var$U = (l = $371c230a09dd78be$var$U) || m, $371c230a09dd78be$var$ck(b, a), $371c230a09dd78be$var$U = l) : $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($371c230a09dd78be$var$V = a, m = a.child; null !== m;){
                    for(q = $371c230a09dd78be$var$V = m; null !== $371c230a09dd78be$var$V;){
                        r = $371c230a09dd78be$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $371c230a09dd78be$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $371c230a09dd78be$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $371c230a09dd78be$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $371c230a09dd78be$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $371c230a09dd78be$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $371c230a09dd78be$var$V = y) : $371c230a09dd78be$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $371c230a09dd78be$var$rb("display", g));
                            } catch (t) {
                                $371c230a09dd78be$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $371c230a09dd78be$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $371c230a09dd78be$var$ck(b, a);
            $371c230a09dd78be$var$ek(a);
            d & 4 && $371c230a09dd78be$var$ak(a);
            break;
        case 21:
            break;
        default:
            $371c230a09dd78be$var$ck(b, a), $371c230a09dd78be$var$ek(a);
    }
}
function $371c230a09dd78be$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($371c230a09dd78be$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($371c230a09dd78be$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($371c230a09dd78be$var$ob(e, ""), d.flags &= -33);
                    var f = $371c230a09dd78be$var$Uj(a);
                    $371c230a09dd78be$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $371c230a09dd78be$var$Uj(a);
                    $371c230a09dd78be$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($371c230a09dd78be$var$p(161));
            }
        } catch (k) {
            $371c230a09dd78be$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $371c230a09dd78be$var$hk(a, b, c) {
    $371c230a09dd78be$var$V = a;
    $371c230a09dd78be$var$ik(a, b, c);
}
function $371c230a09dd78be$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $371c230a09dd78be$var$V;){
        var e = $371c230a09dd78be$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $371c230a09dd78be$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $371c230a09dd78be$var$U;
                h = $371c230a09dd78be$var$Jj;
                var l = $371c230a09dd78be$var$U;
                $371c230a09dd78be$var$Jj = g;
                if (($371c230a09dd78be$var$U = k) && !l) for($371c230a09dd78be$var$V = e; null !== $371c230a09dd78be$var$V;)g = $371c230a09dd78be$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $371c230a09dd78be$var$jk(e) : null !== k ? (k.return = g, $371c230a09dd78be$var$V = k) : $371c230a09dd78be$var$jk(e);
                for(; null !== f;)$371c230a09dd78be$var$V = f, $371c230a09dd78be$var$ik(f, b, c), f = f.sibling;
                $371c230a09dd78be$var$V = e;
                $371c230a09dd78be$var$Jj = h;
                $371c230a09dd78be$var$U = l;
            }
            $371c230a09dd78be$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $371c230a09dd78be$var$V = f) : $371c230a09dd78be$var$kk(a, b, c);
    }
}
function $371c230a09dd78be$var$kk(a) {
    for(; null !== $371c230a09dd78be$var$V;){
        var b = $371c230a09dd78be$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $371c230a09dd78be$var$U || $371c230a09dd78be$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$371c230a09dd78be$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $371c230a09dd78be$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $371c230a09dd78be$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $371c230a09dd78be$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $371c230a09dd78be$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($371c230a09dd78be$var$p(163));
                }
                $371c230a09dd78be$var$U || b.flags & 512 && $371c230a09dd78be$var$Rj(b);
            } catch (r) {
                $371c230a09dd78be$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $371c230a09dd78be$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $371c230a09dd78be$var$V = c;
            break;
        }
        $371c230a09dd78be$var$V = b.return;
    }
}
function $371c230a09dd78be$var$gk(a) {
    for(; null !== $371c230a09dd78be$var$V;){
        var b = $371c230a09dd78be$var$V;
        if (b === a) {
            $371c230a09dd78be$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $371c230a09dd78be$var$V = c;
            break;
        }
        $371c230a09dd78be$var$V = b.return;
    }
}
function $371c230a09dd78be$var$jk(a) {
    for(; null !== $371c230a09dd78be$var$V;){
        var b = $371c230a09dd78be$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $371c230a09dd78be$var$Qj(4, b);
                    } catch (k) {
                        $371c230a09dd78be$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $371c230a09dd78be$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $371c230a09dd78be$var$Rj(b);
                    } catch (k) {
                        $371c230a09dd78be$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $371c230a09dd78be$var$Rj(b);
                    } catch (k) {
                        $371c230a09dd78be$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $371c230a09dd78be$var$W(b, b.return, k);
        }
        if (b === a) {
            $371c230a09dd78be$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $371c230a09dd78be$var$V = h;
            break;
        }
        $371c230a09dd78be$var$V = b.return;
    }
}
var $371c230a09dd78be$var$lk = Math.ceil, $371c230a09dd78be$var$mk = $371c230a09dd78be$var$ua.ReactCurrentDispatcher, $371c230a09dd78be$var$nk = $371c230a09dd78be$var$ua.ReactCurrentOwner, $371c230a09dd78be$var$ok = $371c230a09dd78be$var$ua.ReactCurrentBatchConfig, $371c230a09dd78be$var$K = 0, $371c230a09dd78be$var$Q = null, $371c230a09dd78be$var$Y = null, $371c230a09dd78be$var$Z = 0, $371c230a09dd78be$var$fj = 0, $371c230a09dd78be$var$ej = $371c230a09dd78be$var$Uf(0), $371c230a09dd78be$var$T = 0, $371c230a09dd78be$var$pk = null, $371c230a09dd78be$var$rh = 0, $371c230a09dd78be$var$qk = 0, $371c230a09dd78be$var$rk = 0, $371c230a09dd78be$var$sk = null, $371c230a09dd78be$var$tk = null, $371c230a09dd78be$var$fk = 0, $371c230a09dd78be$var$Gj = Infinity, $371c230a09dd78be$var$uk = null, $371c230a09dd78be$var$Oi = !1, $371c230a09dd78be$var$Pi = null, $371c230a09dd78be$var$Ri = null, $371c230a09dd78be$var$vk = !1, $371c230a09dd78be$var$wk = null, $371c230a09dd78be$var$xk = 0, $371c230a09dd78be$var$yk = 0, $371c230a09dd78be$var$zk = null, $371c230a09dd78be$var$Ak = -1, $371c230a09dd78be$var$Bk = 0;
function $371c230a09dd78be$var$R() {
    return 0 !== ($371c230a09dd78be$var$K & 6) ? $371c230a09dd78be$var$B() : -1 !== $371c230a09dd78be$var$Ak ? $371c230a09dd78be$var$Ak : $371c230a09dd78be$var$Ak = $371c230a09dd78be$var$B();
}
function $371c230a09dd78be$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($371c230a09dd78be$var$K & 2) && 0 !== $371c230a09dd78be$var$Z) return $371c230a09dd78be$var$Z & -$371c230a09dd78be$var$Z;
    if (null !== $371c230a09dd78be$var$Kg.transition) return 0 === $371c230a09dd78be$var$Bk && ($371c230a09dd78be$var$Bk = $371c230a09dd78be$var$yc()), $371c230a09dd78be$var$Bk;
    a = $371c230a09dd78be$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $371c230a09dd78be$var$jd(a.type);
    return a;
}
function $371c230a09dd78be$var$gi(a, b, c, d) {
    if (50 < $371c230a09dd78be$var$yk) throw $371c230a09dd78be$var$yk = 0, $371c230a09dd78be$var$zk = null, Error($371c230a09dd78be$var$p(185));
    $371c230a09dd78be$var$Ac(a, c, d);
    if (0 === ($371c230a09dd78be$var$K & 2) || a !== $371c230a09dd78be$var$Q) a === $371c230a09dd78be$var$Q && (0 === ($371c230a09dd78be$var$K & 2) && ($371c230a09dd78be$var$qk |= c), 4 === $371c230a09dd78be$var$T && $371c230a09dd78be$var$Ck(a, $371c230a09dd78be$var$Z)), $371c230a09dd78be$var$Dk(a, d), 1 === c && 0 === $371c230a09dd78be$var$K && 0 === (b.mode & 1) && ($371c230a09dd78be$var$Gj = $371c230a09dd78be$var$B() + 500, $371c230a09dd78be$var$fg && $371c230a09dd78be$var$jg());
}
function $371c230a09dd78be$var$Dk(a, b) {
    var c = a.callbackNode;
    $371c230a09dd78be$var$wc(a, b);
    var d = $371c230a09dd78be$var$uc(a, a === $371c230a09dd78be$var$Q ? $371c230a09dd78be$var$Z : 0);
    if (0 === d) null !== c && $371c230a09dd78be$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $371c230a09dd78be$var$bc(c);
        if (1 === b) 0 === a.tag ? $371c230a09dd78be$var$ig($371c230a09dd78be$var$Ek.bind(null, a)) : $371c230a09dd78be$var$hg($371c230a09dd78be$var$Ek.bind(null, a)), $371c230a09dd78be$var$Jf(function() {
            0 === ($371c230a09dd78be$var$K & 6) && $371c230a09dd78be$var$jg();
        }), c = null;
        else {
            switch($371c230a09dd78be$var$Dc(d)){
                case 1:
                    c = $371c230a09dd78be$var$fc;
                    break;
                case 4:
                    c = $371c230a09dd78be$var$gc;
                    break;
                case 16:
                    c = $371c230a09dd78be$var$hc;
                    break;
                case 536870912:
                    c = $371c230a09dd78be$var$jc;
                    break;
                default:
                    c = $371c230a09dd78be$var$hc;
            }
            c = $371c230a09dd78be$var$Fk(c, $371c230a09dd78be$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $371c230a09dd78be$var$Gk(a, b) {
    $371c230a09dd78be$var$Ak = -1;
    $371c230a09dd78be$var$Bk = 0;
    if (0 !== ($371c230a09dd78be$var$K & 6)) throw Error($371c230a09dd78be$var$p(327));
    var c = a.callbackNode;
    if ($371c230a09dd78be$var$Hk() && a.callbackNode !== c) return null;
    var d = $371c230a09dd78be$var$uc(a, a === $371c230a09dd78be$var$Q ? $371c230a09dd78be$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $371c230a09dd78be$var$Ik(a, d);
    else {
        b = d;
        var e = $371c230a09dd78be$var$K;
        $371c230a09dd78be$var$K |= 2;
        var f = $371c230a09dd78be$var$Jk();
        if ($371c230a09dd78be$var$Q !== a || $371c230a09dd78be$var$Z !== b) $371c230a09dd78be$var$uk = null, $371c230a09dd78be$var$Gj = $371c230a09dd78be$var$B() + 500, $371c230a09dd78be$var$Kk(a, b);
        for(;;)try {
            $371c230a09dd78be$var$Lk();
            break;
        } catch (h) {
            $371c230a09dd78be$var$Mk(a, h);
        }
        $371c230a09dd78be$var$$g();
        $371c230a09dd78be$var$mk.current = f;
        $371c230a09dd78be$var$K = e;
        null !== $371c230a09dd78be$var$Y ? b = 0 : ($371c230a09dd78be$var$Q = null, $371c230a09dd78be$var$Z = 0, b = $371c230a09dd78be$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $371c230a09dd78be$var$xc(a), 0 !== e && (d = e, b = $371c230a09dd78be$var$Nk(a, e)));
        if (1 === b) throw c = $371c230a09dd78be$var$pk, $371c230a09dd78be$var$Kk(a, 0), $371c230a09dd78be$var$Ck(a, d), $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B()), c;
        if (6 === b) $371c230a09dd78be$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$371c230a09dd78be$var$Ok(e) && (b = $371c230a09dd78be$var$Ik(a, d), 2 === b && (f = $371c230a09dd78be$var$xc(a), 0 !== f && (d = f, b = $371c230a09dd78be$var$Nk(a, f))), 1 === b)) throw c = $371c230a09dd78be$var$pk, $371c230a09dd78be$var$Kk(a, 0), $371c230a09dd78be$var$Ck(a, d), $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($371c230a09dd78be$var$p(345));
                case 2:
                    $371c230a09dd78be$var$Pk(a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk);
                    break;
                case 3:
                    $371c230a09dd78be$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $371c230a09dd78be$var$fk + 500 - $371c230a09dd78be$var$B(), 10 < b)) {
                        if (0 !== $371c230a09dd78be$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $371c230a09dd78be$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $371c230a09dd78be$var$Ff($371c230a09dd78be$var$Pk.bind(null, a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk), b);
                        break;
                    }
                    $371c230a09dd78be$var$Pk(a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk);
                    break;
                case 4:
                    $371c230a09dd78be$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $371c230a09dd78be$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $371c230a09dd78be$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $371c230a09dd78be$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $371c230a09dd78be$var$Ff($371c230a09dd78be$var$Pk.bind(null, a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk), d);
                        break;
                    }
                    $371c230a09dd78be$var$Pk(a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk);
                    break;
                case 5:
                    $371c230a09dd78be$var$Pk(a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk);
                    break;
                default:
                    throw Error($371c230a09dd78be$var$p(329));
            }
        }
    }
    $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B());
    return a.callbackNode === c ? $371c230a09dd78be$var$Gk.bind(null, a) : null;
}
function $371c230a09dd78be$var$Nk(a, b) {
    var c = $371c230a09dd78be$var$sk;
    a.current.memoizedState.isDehydrated && ($371c230a09dd78be$var$Kk(a, b).flags |= 256);
    a = $371c230a09dd78be$var$Ik(a, b);
    2 !== a && (b = $371c230a09dd78be$var$tk, $371c230a09dd78be$var$tk = c, null !== b && $371c230a09dd78be$var$Fj(b));
    return a;
}
function $371c230a09dd78be$var$Fj(a) {
    null === $371c230a09dd78be$var$tk ? $371c230a09dd78be$var$tk = a : $371c230a09dd78be$var$tk.push.apply($371c230a09dd78be$var$tk, a);
}
function $371c230a09dd78be$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$371c230a09dd78be$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $371c230a09dd78be$var$Ck(a, b) {
    b &= ~$371c230a09dd78be$var$rk;
    b &= ~$371c230a09dd78be$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $371c230a09dd78be$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $371c230a09dd78be$var$Ek(a) {
    if (0 !== ($371c230a09dd78be$var$K & 6)) throw Error($371c230a09dd78be$var$p(327));
    $371c230a09dd78be$var$Hk();
    var b = $371c230a09dd78be$var$uc(a, 0);
    if (0 === (b & 1)) return $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B()), null;
    var c = $371c230a09dd78be$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $371c230a09dd78be$var$xc(a);
        0 !== d && (b = d, c = $371c230a09dd78be$var$Nk(a, d));
    }
    if (1 === c) throw c = $371c230a09dd78be$var$pk, $371c230a09dd78be$var$Kk(a, 0), $371c230a09dd78be$var$Ck(a, b), $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B()), c;
    if (6 === c) throw Error($371c230a09dd78be$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $371c230a09dd78be$var$Pk(a, $371c230a09dd78be$var$tk, $371c230a09dd78be$var$uk);
    $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B());
    return null;
}
function $371c230a09dd78be$var$Qk(a, b) {
    var c = $371c230a09dd78be$var$K;
    $371c230a09dd78be$var$K |= 1;
    try {
        return a(b);
    } finally{
        $371c230a09dd78be$var$K = c, 0 === $371c230a09dd78be$var$K && ($371c230a09dd78be$var$Gj = $371c230a09dd78be$var$B() + 500, $371c230a09dd78be$var$fg && $371c230a09dd78be$var$jg());
    }
}
function $371c230a09dd78be$var$Rk(a) {
    null !== $371c230a09dd78be$var$wk && 0 === $371c230a09dd78be$var$wk.tag && 0 === ($371c230a09dd78be$var$K & 6) && $371c230a09dd78be$var$Hk();
    var b = $371c230a09dd78be$var$K;
    $371c230a09dd78be$var$K |= 1;
    var c = $371c230a09dd78be$var$ok.transition, d = $371c230a09dd78be$var$C;
    try {
        if ($371c230a09dd78be$var$ok.transition = null, $371c230a09dd78be$var$C = 1, a) return a();
    } finally{
        $371c230a09dd78be$var$C = d, $371c230a09dd78be$var$ok.transition = c, $371c230a09dd78be$var$K = b, 0 === ($371c230a09dd78be$var$K & 6) && $371c230a09dd78be$var$jg();
    }
}
function $371c230a09dd78be$var$Hj() {
    $371c230a09dd78be$var$fj = $371c230a09dd78be$var$ej.current;
    $371c230a09dd78be$var$E($371c230a09dd78be$var$ej);
}
function $371c230a09dd78be$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $371c230a09dd78be$var$Gf(c));
    if (null !== $371c230a09dd78be$var$Y) for(c = $371c230a09dd78be$var$Y.return; null !== c;){
        var d = c;
        $371c230a09dd78be$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $371c230a09dd78be$var$$f();
                break;
            case 3:
                $371c230a09dd78be$var$zh();
                $371c230a09dd78be$var$E($371c230a09dd78be$var$Wf);
                $371c230a09dd78be$var$E($371c230a09dd78be$var$H);
                $371c230a09dd78be$var$Eh();
                break;
            case 5:
                $371c230a09dd78be$var$Bh(d);
                break;
            case 4:
                $371c230a09dd78be$var$zh();
                break;
            case 13:
                $371c230a09dd78be$var$E($371c230a09dd78be$var$L);
                break;
            case 19:
                $371c230a09dd78be$var$E($371c230a09dd78be$var$L);
                break;
            case 10:
                $371c230a09dd78be$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $371c230a09dd78be$var$Hj();
        }
        c = c.return;
    }
    $371c230a09dd78be$var$Q = a;
    $371c230a09dd78be$var$Y = a = $371c230a09dd78be$var$Pg(a.current, null);
    $371c230a09dd78be$var$Z = $371c230a09dd78be$var$fj = b;
    $371c230a09dd78be$var$T = 0;
    $371c230a09dd78be$var$pk = null;
    $371c230a09dd78be$var$rk = $371c230a09dd78be$var$qk = $371c230a09dd78be$var$rh = 0;
    $371c230a09dd78be$var$tk = $371c230a09dd78be$var$sk = null;
    if (null !== $371c230a09dd78be$var$fh) {
        for(b = 0; b < $371c230a09dd78be$var$fh.length; b++)if (c = $371c230a09dd78be$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $371c230a09dd78be$var$fh = null;
    }
    return a;
}
function $371c230a09dd78be$var$Mk(a, b) {
    do {
        var c = $371c230a09dd78be$var$Y;
        try {
            $371c230a09dd78be$var$$g();
            $371c230a09dd78be$var$Fh.current = $371c230a09dd78be$var$Rh;
            if ($371c230a09dd78be$var$Ih) {
                for(var d = $371c230a09dd78be$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $371c230a09dd78be$var$Ih = !1;
            }
            $371c230a09dd78be$var$Hh = 0;
            $371c230a09dd78be$var$O = $371c230a09dd78be$var$N = $371c230a09dd78be$var$M = null;
            $371c230a09dd78be$var$Jh = !1;
            $371c230a09dd78be$var$Kh = 0;
            $371c230a09dd78be$var$nk.current = null;
            if (null === c || null === c.return) {
                $371c230a09dd78be$var$T = 1;
                $371c230a09dd78be$var$pk = b;
                $371c230a09dd78be$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $371c230a09dd78be$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $371c230a09dd78be$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $371c230a09dd78be$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $371c230a09dd78be$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $371c230a09dd78be$var$Si(f, l, b);
                            $371c230a09dd78be$var$tj();
                            break a;
                        }
                        k = Error($371c230a09dd78be$var$p(426));
                    }
                } else if ($371c230a09dd78be$var$I && h.mode & 1) {
                    var J = $371c230a09dd78be$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $371c230a09dd78be$var$Vi(J, g, h, f, b);
                        $371c230a09dd78be$var$Jg($371c230a09dd78be$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $371c230a09dd78be$var$Ji(k, h);
                4 !== $371c230a09dd78be$var$T && ($371c230a09dd78be$var$T = 2);
                null === $371c230a09dd78be$var$sk ? $371c230a09dd78be$var$sk = [
                    f
                ] : $371c230a09dd78be$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $371c230a09dd78be$var$Ni(f, k, b);
                            $371c230a09dd78be$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $371c230a09dd78be$var$Ri || !$371c230a09dd78be$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $371c230a09dd78be$var$Qi(f, h, b);
                                $371c230a09dd78be$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $371c230a09dd78be$var$Sk(c);
        } catch (na) {
            b = na;
            $371c230a09dd78be$var$Y === c && null !== c && ($371c230a09dd78be$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $371c230a09dd78be$var$Jk() {
    var a = $371c230a09dd78be$var$mk.current;
    $371c230a09dd78be$var$mk.current = $371c230a09dd78be$var$Rh;
    return null === a ? $371c230a09dd78be$var$Rh : a;
}
function $371c230a09dd78be$var$tj() {
    if (0 === $371c230a09dd78be$var$T || 3 === $371c230a09dd78be$var$T || 2 === $371c230a09dd78be$var$T) $371c230a09dd78be$var$T = 4;
    null === $371c230a09dd78be$var$Q || 0 === ($371c230a09dd78be$var$rh & 268435455) && 0 === ($371c230a09dd78be$var$qk & 268435455) || $371c230a09dd78be$var$Ck($371c230a09dd78be$var$Q, $371c230a09dd78be$var$Z);
}
function $371c230a09dd78be$var$Ik(a, b) {
    var c = $371c230a09dd78be$var$K;
    $371c230a09dd78be$var$K |= 2;
    var d = $371c230a09dd78be$var$Jk();
    if ($371c230a09dd78be$var$Q !== a || $371c230a09dd78be$var$Z !== b) $371c230a09dd78be$var$uk = null, $371c230a09dd78be$var$Kk(a, b);
    for(;;)try {
        $371c230a09dd78be$var$Tk();
        break;
    } catch (e) {
        $371c230a09dd78be$var$Mk(a, e);
    }
    $371c230a09dd78be$var$$g();
    $371c230a09dd78be$var$K = c;
    $371c230a09dd78be$var$mk.current = d;
    if (null !== $371c230a09dd78be$var$Y) throw Error($371c230a09dd78be$var$p(261));
    $371c230a09dd78be$var$Q = null;
    $371c230a09dd78be$var$Z = 0;
    return $371c230a09dd78be$var$T;
}
function $371c230a09dd78be$var$Tk() {
    for(; null !== $371c230a09dd78be$var$Y;)$371c230a09dd78be$var$Uk($371c230a09dd78be$var$Y);
}
function $371c230a09dd78be$var$Lk() {
    for(; null !== $371c230a09dd78be$var$Y && !$371c230a09dd78be$var$cc();)$371c230a09dd78be$var$Uk($371c230a09dd78be$var$Y);
}
function $371c230a09dd78be$var$Uk(a) {
    var b = $371c230a09dd78be$var$Vk(a.alternate, a, $371c230a09dd78be$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $371c230a09dd78be$var$Sk(a) : $371c230a09dd78be$var$Y = b;
    $371c230a09dd78be$var$nk.current = null;
}
function $371c230a09dd78be$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $371c230a09dd78be$var$Ej(c, b, $371c230a09dd78be$var$fj), null !== c) {
                $371c230a09dd78be$var$Y = c;
                return;
            }
        } else {
            c = $371c230a09dd78be$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $371c230a09dd78be$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $371c230a09dd78be$var$T = 6;
                $371c230a09dd78be$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $371c230a09dd78be$var$Y = b;
            return;
        }
        $371c230a09dd78be$var$Y = b = a;
    }while (null !== b);
    0 === $371c230a09dd78be$var$T && ($371c230a09dd78be$var$T = 5);
}
function $371c230a09dd78be$var$Pk(a, b, c) {
    var d = $371c230a09dd78be$var$C, e = $371c230a09dd78be$var$ok.transition;
    try {
        $371c230a09dd78be$var$ok.transition = null, $371c230a09dd78be$var$C = 1, $371c230a09dd78be$var$Wk(a, b, c, d);
    } finally{
        $371c230a09dd78be$var$ok.transition = e, $371c230a09dd78be$var$C = d;
    }
    return null;
}
function $371c230a09dd78be$var$Wk(a, b, c, d) {
    do $371c230a09dd78be$var$Hk();
    while (null !== $371c230a09dd78be$var$wk);
    if (0 !== ($371c230a09dd78be$var$K & 6)) throw Error($371c230a09dd78be$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($371c230a09dd78be$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $371c230a09dd78be$var$Bc(a, f);
    a === $371c230a09dd78be$var$Q && ($371c230a09dd78be$var$Y = $371c230a09dd78be$var$Q = null, $371c230a09dd78be$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $371c230a09dd78be$var$vk || ($371c230a09dd78be$var$vk = !0, $371c230a09dd78be$var$Fk($371c230a09dd78be$var$hc, function() {
        $371c230a09dd78be$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $371c230a09dd78be$var$ok.transition;
        $371c230a09dd78be$var$ok.transition = null;
        var g = $371c230a09dd78be$var$C;
        $371c230a09dd78be$var$C = 1;
        var h = $371c230a09dd78be$var$K;
        $371c230a09dd78be$var$K |= 4;
        $371c230a09dd78be$var$nk.current = null;
        $371c230a09dd78be$var$Oj(a, c);
        $371c230a09dd78be$var$dk(c, a);
        $371c230a09dd78be$var$Oe($371c230a09dd78be$var$Df);
        $371c230a09dd78be$var$dd = !!$371c230a09dd78be$var$Cf;
        $371c230a09dd78be$var$Df = $371c230a09dd78be$var$Cf = null;
        a.current = c;
        $371c230a09dd78be$var$hk(c, a, e);
        $371c230a09dd78be$var$dc();
        $371c230a09dd78be$var$K = h;
        $371c230a09dd78be$var$C = g;
        $371c230a09dd78be$var$ok.transition = f;
    } else a.current = c;
    $371c230a09dd78be$var$vk && ($371c230a09dd78be$var$vk = !1, $371c230a09dd78be$var$wk = a, $371c230a09dd78be$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($371c230a09dd78be$var$Ri = null);
    $371c230a09dd78be$var$mc(c.stateNode, d);
    $371c230a09dd78be$var$Dk(a, $371c230a09dd78be$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($371c230a09dd78be$var$Oi) throw $371c230a09dd78be$var$Oi = !1, a = $371c230a09dd78be$var$Pi, $371c230a09dd78be$var$Pi = null, a;
    0 !== ($371c230a09dd78be$var$xk & 1) && 0 !== a.tag && $371c230a09dd78be$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $371c230a09dd78be$var$zk ? $371c230a09dd78be$var$yk++ : ($371c230a09dd78be$var$yk = 0, $371c230a09dd78be$var$zk = a) : $371c230a09dd78be$var$yk = 0;
    $371c230a09dd78be$var$jg();
    return null;
}
function $371c230a09dd78be$var$Hk() {
    if (null !== $371c230a09dd78be$var$wk) {
        var a = $371c230a09dd78be$var$Dc($371c230a09dd78be$var$xk), b = $371c230a09dd78be$var$ok.transition, c = $371c230a09dd78be$var$C;
        try {
            $371c230a09dd78be$var$ok.transition = null;
            $371c230a09dd78be$var$C = 16 > a ? 16 : a;
            if (null === $371c230a09dd78be$var$wk) var d = !1;
            else {
                a = $371c230a09dd78be$var$wk;
                $371c230a09dd78be$var$wk = null;
                $371c230a09dd78be$var$xk = 0;
                if (0 !== ($371c230a09dd78be$var$K & 6)) throw Error($371c230a09dd78be$var$p(331));
                var e = $371c230a09dd78be$var$K;
                $371c230a09dd78be$var$K |= 4;
                for($371c230a09dd78be$var$V = a.current; null !== $371c230a09dd78be$var$V;){
                    var f = $371c230a09dd78be$var$V, g = f.child;
                    if (0 !== ($371c230a09dd78be$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($371c230a09dd78be$var$V = l; null !== $371c230a09dd78be$var$V;){
                                    var m = $371c230a09dd78be$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $371c230a09dd78be$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $371c230a09dd78be$var$V = q;
                                    else for(; null !== $371c230a09dd78be$var$V;){
                                        m = $371c230a09dd78be$var$V;
                                        var r = m.sibling, y = m.return;
                                        $371c230a09dd78be$var$Sj(m);
                                        if (m === l) {
                                            $371c230a09dd78be$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $371c230a09dd78be$var$V = r;
                                            break;
                                        }
                                        $371c230a09dd78be$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $371c230a09dd78be$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $371c230a09dd78be$var$V = g;
                    else b: for(; null !== $371c230a09dd78be$var$V;){
                        f = $371c230a09dd78be$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $371c230a09dd78be$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $371c230a09dd78be$var$V = x;
                            break b;
                        }
                        $371c230a09dd78be$var$V = f.return;
                    }
                }
                var w = a.current;
                for($371c230a09dd78be$var$V = w; null !== $371c230a09dd78be$var$V;){
                    g = $371c230a09dd78be$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $371c230a09dd78be$var$V = u;
                    else b: for(g = w; null !== $371c230a09dd78be$var$V;){
                        h = $371c230a09dd78be$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $371c230a09dd78be$var$Qj(9, h);
                            }
                        } catch (na) {
                            $371c230a09dd78be$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $371c230a09dd78be$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $371c230a09dd78be$var$V = F;
                            break b;
                        }
                        $371c230a09dd78be$var$V = h.return;
                    }
                }
                $371c230a09dd78be$var$K = e;
                $371c230a09dd78be$var$jg();
                if ($371c230a09dd78be$var$lc && "function" === typeof $371c230a09dd78be$var$lc.onPostCommitFiberRoot) try {
                    $371c230a09dd78be$var$lc.onPostCommitFiberRoot($371c230a09dd78be$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $371c230a09dd78be$var$C = c, $371c230a09dd78be$var$ok.transition = b;
        }
    }
    return !1;
}
function $371c230a09dd78be$var$Xk(a, b, c) {
    b = $371c230a09dd78be$var$Ji(c, b);
    b = $371c230a09dd78be$var$Ni(a, b, 1);
    a = $371c230a09dd78be$var$nh(a, b, 1);
    b = $371c230a09dd78be$var$R();
    null !== a && ($371c230a09dd78be$var$Ac(a, 1, b), $371c230a09dd78be$var$Dk(a, b));
}
function $371c230a09dd78be$var$W(a, b, c) {
    if (3 === a.tag) $371c230a09dd78be$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $371c230a09dd78be$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $371c230a09dd78be$var$Ri || !$371c230a09dd78be$var$Ri.has(d))) {
                a = $371c230a09dd78be$var$Ji(c, a);
                a = $371c230a09dd78be$var$Qi(b, a, 1);
                b = $371c230a09dd78be$var$nh(b, a, 1);
                a = $371c230a09dd78be$var$R();
                null !== b && ($371c230a09dd78be$var$Ac(b, 1, a), $371c230a09dd78be$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $371c230a09dd78be$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $371c230a09dd78be$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $371c230a09dd78be$var$Q === a && ($371c230a09dd78be$var$Z & c) === c && (4 === $371c230a09dd78be$var$T || 3 === $371c230a09dd78be$var$T && ($371c230a09dd78be$var$Z & 130023424) === $371c230a09dd78be$var$Z && 500 > $371c230a09dd78be$var$B() - $371c230a09dd78be$var$fk ? $371c230a09dd78be$var$Kk(a, 0) : $371c230a09dd78be$var$rk |= c);
    $371c230a09dd78be$var$Dk(a, b);
}
function $371c230a09dd78be$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $371c230a09dd78be$var$sc, $371c230a09dd78be$var$sc <<= 1, 0 === ($371c230a09dd78be$var$sc & 130023424) && ($371c230a09dd78be$var$sc = 4194304)));
    var c = $371c230a09dd78be$var$R();
    a = $371c230a09dd78be$var$ih(a, b);
    null !== a && ($371c230a09dd78be$var$Ac(a, b, c), $371c230a09dd78be$var$Dk(a, c));
}
function $371c230a09dd78be$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $371c230a09dd78be$var$Yk(a, c);
}
function $371c230a09dd78be$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($371c230a09dd78be$var$p(314));
    }
    null !== d && d.delete(b);
    $371c230a09dd78be$var$Yk(a, c);
}
var $371c230a09dd78be$var$Vk;
$371c230a09dd78be$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $371c230a09dd78be$var$Wf.current) $371c230a09dd78be$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $371c230a09dd78be$var$dh = !1, $371c230a09dd78be$var$yj(a, b, c);
            $371c230a09dd78be$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $371c230a09dd78be$var$dh = !1, $371c230a09dd78be$var$I && 0 !== (b.flags & 1048576) && $371c230a09dd78be$var$ug(b, $371c230a09dd78be$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $371c230a09dd78be$var$ij(a, b);
            a = b.pendingProps;
            var e = $371c230a09dd78be$var$Yf(b, $371c230a09dd78be$var$H.current);
            $371c230a09dd78be$var$ch(b, c);
            e = $371c230a09dd78be$var$Nh(null, b, d, a, e, c);
            var f = $371c230a09dd78be$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $371c230a09dd78be$var$Zf(d) ? (f = !0, $371c230a09dd78be$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $371c230a09dd78be$var$kh(b), e.updater = $371c230a09dd78be$var$Ei, b.stateNode = e, e._reactInternals = b, $371c230a09dd78be$var$Ii(b, d, a, c), b = $371c230a09dd78be$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $371c230a09dd78be$var$I && f && $371c230a09dd78be$var$vg(b), $371c230a09dd78be$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $371c230a09dd78be$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $371c230a09dd78be$var$Zk(d);
                a = $371c230a09dd78be$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $371c230a09dd78be$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $371c230a09dd78be$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $371c230a09dd78be$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $371c230a09dd78be$var$$i(null, b, d, $371c230a09dd78be$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($371c230a09dd78be$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $371c230a09dd78be$var$Ci(d, e), $371c230a09dd78be$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $371c230a09dd78be$var$Ci(d, e), $371c230a09dd78be$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $371c230a09dd78be$var$kj(b);
                if (null === a) throw Error($371c230a09dd78be$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $371c230a09dd78be$var$lh(a, b);
                $371c230a09dd78be$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $371c230a09dd78be$var$Ji(Error($371c230a09dd78be$var$p(423)), b);
                        b = $371c230a09dd78be$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $371c230a09dd78be$var$Ji(Error($371c230a09dd78be$var$p(424)), b);
                        b = $371c230a09dd78be$var$lj(a, b, d, c, e);
                        break a;
                    } else for($371c230a09dd78be$var$yg = $371c230a09dd78be$var$Lf(b.stateNode.containerInfo.firstChild), $371c230a09dd78be$var$xg = b, $371c230a09dd78be$var$I = !0, $371c230a09dd78be$var$zg = null, c = $371c230a09dd78be$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $371c230a09dd78be$var$Ig();
                    if (d === e) {
                        b = $371c230a09dd78be$var$Zi(a, b, c);
                        break a;
                    }
                    $371c230a09dd78be$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $371c230a09dd78be$var$Ah(b), null === a && $371c230a09dd78be$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $371c230a09dd78be$var$Ef(d, e) ? g = null : null !== f && $371c230a09dd78be$var$Ef(d, f) && (b.flags |= 32), $371c230a09dd78be$var$gj(a, b), $371c230a09dd78be$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $371c230a09dd78be$var$Eg(b), null;
        case 13:
            return $371c230a09dd78be$var$oj(a, b, c);
        case 4:
            return $371c230a09dd78be$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $371c230a09dd78be$var$Ug(b, null, d, c) : $371c230a09dd78be$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $371c230a09dd78be$var$Ci(d, e), $371c230a09dd78be$var$Yi(a, b, d, e, c);
        case 7:
            return $371c230a09dd78be$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $371c230a09dd78be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $371c230a09dd78be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $371c230a09dd78be$var$G($371c230a09dd78be$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($371c230a09dd78be$var$He(f.value, g)) {
                        if (f.children === e.children && !$371c230a09dd78be$var$Wf.current) {
                            b = $371c230a09dd78be$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $371c230a09dd78be$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $371c230a09dd78be$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($371c230a09dd78be$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $371c230a09dd78be$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $371c230a09dd78be$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $371c230a09dd78be$var$ch(b, c), e = $371c230a09dd78be$var$eh(e), d = d(e), b.flags |= 1, $371c230a09dd78be$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $371c230a09dd78be$var$Ci(d, b.pendingProps), e = $371c230a09dd78be$var$Ci(d.type, e), $371c230a09dd78be$var$$i(a, b, d, e, c);
        case 15:
            return $371c230a09dd78be$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $371c230a09dd78be$var$Ci(d, e), $371c230a09dd78be$var$ij(a, b), b.tag = 1, $371c230a09dd78be$var$Zf(d) ? (a = !0, $371c230a09dd78be$var$cg(b)) : a = !1, $371c230a09dd78be$var$ch(b, c), $371c230a09dd78be$var$Gi(b, d, e), $371c230a09dd78be$var$Ii(b, d, e, c), $371c230a09dd78be$var$jj(null, b, d, !0, a, c);
        case 19:
            return $371c230a09dd78be$var$xj(a, b, c);
        case 22:
            return $371c230a09dd78be$var$dj(a, b, c);
    }
    throw Error($371c230a09dd78be$var$p(156, b.tag));
};
function $371c230a09dd78be$var$Fk(a, b) {
    return $371c230a09dd78be$var$ac(a, b);
}
function $371c230a09dd78be$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $371c230a09dd78be$var$Bg(a, b, c, d) {
    return new $371c230a09dd78be$var$$k(a, b, c, d);
}
function $371c230a09dd78be$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $371c230a09dd78be$var$Zk(a) {
    if ("function" === typeof a) return $371c230a09dd78be$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $371c230a09dd78be$var$Da) return 11;
        if (a === $371c230a09dd78be$var$Ga) return 14;
    }
    return 2;
}
function $371c230a09dd78be$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $371c230a09dd78be$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $371c230a09dd78be$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $371c230a09dd78be$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $371c230a09dd78be$var$ya:
            return $371c230a09dd78be$var$Tg(c.children, e, f, b);
        case $371c230a09dd78be$var$za:
            g = 8;
            e |= 8;
            break;
        case $371c230a09dd78be$var$Aa:
            return a = $371c230a09dd78be$var$Bg(12, c, b, e | 2), a.elementType = $371c230a09dd78be$var$Aa, a.lanes = f, a;
        case $371c230a09dd78be$var$Ea:
            return a = $371c230a09dd78be$var$Bg(13, c, b, e), a.elementType = $371c230a09dd78be$var$Ea, a.lanes = f, a;
        case $371c230a09dd78be$var$Fa:
            return a = $371c230a09dd78be$var$Bg(19, c, b, e), a.elementType = $371c230a09dd78be$var$Fa, a.lanes = f, a;
        case $371c230a09dd78be$var$Ia:
            return $371c230a09dd78be$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $371c230a09dd78be$var$Ba:
                    g = 10;
                    break a;
                case $371c230a09dd78be$var$Ca:
                    g = 9;
                    break a;
                case $371c230a09dd78be$var$Da:
                    g = 11;
                    break a;
                case $371c230a09dd78be$var$Ga:
                    g = 14;
                    break a;
                case $371c230a09dd78be$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($371c230a09dd78be$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $371c230a09dd78be$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $371c230a09dd78be$var$Tg(a, b, c, d) {
    a = $371c230a09dd78be$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $371c230a09dd78be$var$pj(a, b, c, d) {
    a = $371c230a09dd78be$var$Bg(22, a, d, b);
    a.elementType = $371c230a09dd78be$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $371c230a09dd78be$var$Qg(a, b, c) {
    a = $371c230a09dd78be$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $371c230a09dd78be$var$Sg(a, b, c) {
    b = $371c230a09dd78be$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $371c230a09dd78be$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $371c230a09dd78be$var$zc(0);
    this.expirationTimes = $371c230a09dd78be$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $371c230a09dd78be$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $371c230a09dd78be$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $371c230a09dd78be$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $371c230a09dd78be$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $371c230a09dd78be$var$kh(f);
    return a;
}
function $371c230a09dd78be$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $371c230a09dd78be$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $371c230a09dd78be$var$dl(a) {
    if (!a) return $371c230a09dd78be$var$Vf;
    a = a._reactInternals;
    a: {
        if ($371c230a09dd78be$var$Vb(a) !== a || 1 !== a.tag) throw Error($371c230a09dd78be$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($371c230a09dd78be$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($371c230a09dd78be$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($371c230a09dd78be$var$Zf(c)) return $371c230a09dd78be$var$bg(a, c, b);
    }
    return b;
}
function $371c230a09dd78be$var$el(a, b, c, d, e, f, g, h, k) {
    a = $371c230a09dd78be$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $371c230a09dd78be$var$dl(null);
    c = a.current;
    d = $371c230a09dd78be$var$R();
    e = $371c230a09dd78be$var$yi(c);
    f = $371c230a09dd78be$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $371c230a09dd78be$var$nh(c, f, e);
    a.current.lanes = e;
    $371c230a09dd78be$var$Ac(a, e, d);
    $371c230a09dd78be$var$Dk(a, d);
    return a;
}
function $371c230a09dd78be$var$fl(a, b, c, d) {
    var e = b.current, f = $371c230a09dd78be$var$R(), g = $371c230a09dd78be$var$yi(e);
    c = $371c230a09dd78be$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $371c230a09dd78be$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $371c230a09dd78be$var$nh(e, b, g);
    null !== a && ($371c230a09dd78be$var$gi(a, e, g, f), $371c230a09dd78be$var$oh(a, e, g));
    return g;
}
function $371c230a09dd78be$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $371c230a09dd78be$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $371c230a09dd78be$var$il(a, b) {
    $371c230a09dd78be$var$hl(a, b);
    (a = a.alternate) && $371c230a09dd78be$var$hl(a, b);
}
function $371c230a09dd78be$var$jl() {
    return null;
}
var $371c230a09dd78be$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $371c230a09dd78be$var$ll(a) {
    this._internalRoot = a;
}
$371c230a09dd78be$var$ml.prototype.render = $371c230a09dd78be$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($371c230a09dd78be$var$p(409));
    $371c230a09dd78be$var$fl(a, b, null, null);
};
$371c230a09dd78be$var$ml.prototype.unmount = $371c230a09dd78be$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $371c230a09dd78be$var$Rk(function() {
            $371c230a09dd78be$var$fl(null, a, null, null);
        });
        b[$371c230a09dd78be$var$uf] = null;
    }
};
function $371c230a09dd78be$var$ml(a) {
    this._internalRoot = a;
}
$371c230a09dd78be$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $371c230a09dd78be$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $371c230a09dd78be$var$Qc.length && 0 !== b && b < $371c230a09dd78be$var$Qc[c].priority; c++);
        $371c230a09dd78be$var$Qc.splice(c, 0, a);
        0 === c && $371c230a09dd78be$var$Vc(a);
    }
};
function $371c230a09dd78be$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $371c230a09dd78be$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $371c230a09dd78be$var$pl() {}
function $371c230a09dd78be$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $371c230a09dd78be$var$gl(g);
                f.call(a);
            };
        }
        var g = $371c230a09dd78be$var$el(b, d, a, 0, null, !1, !1, "", $371c230a09dd78be$var$pl);
        a._reactRootContainer = g;
        a[$371c230a09dd78be$var$uf] = g.current;
        $371c230a09dd78be$var$sf(8 === a.nodeType ? a.parentNode : a);
        $371c230a09dd78be$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $371c230a09dd78be$var$gl(k);
            h.call(a);
        };
    }
    var k = $371c230a09dd78be$var$bl(a, 0, !1, null, null, !1, !1, "", $371c230a09dd78be$var$pl);
    a._reactRootContainer = k;
    a[$371c230a09dd78be$var$uf] = k.current;
    $371c230a09dd78be$var$sf(8 === a.nodeType ? a.parentNode : a);
    $371c230a09dd78be$var$Rk(function() {
        $371c230a09dd78be$var$fl(b, k, c, d);
    });
    return k;
}
function $371c230a09dd78be$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $371c230a09dd78be$var$gl(g);
                h.call(a);
            };
        }
        $371c230a09dd78be$var$fl(b, g, a, e);
    } else g = $371c230a09dd78be$var$ql(c, b, a, e, d);
    return $371c230a09dd78be$var$gl(g);
}
$371c230a09dd78be$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $371c230a09dd78be$var$tc(b.pendingLanes);
                0 !== c && ($371c230a09dd78be$var$Cc(b, c | 1), $371c230a09dd78be$var$Dk(b, $371c230a09dd78be$var$B()), 0 === ($371c230a09dd78be$var$K & 6) && ($371c230a09dd78be$var$Gj = $371c230a09dd78be$var$B() + 500, $371c230a09dd78be$var$jg()));
            }
            break;
        case 13:
            $371c230a09dd78be$var$Rk(function() {
                var b = $371c230a09dd78be$var$ih(a, 1);
                if (null !== b) {
                    var c = $371c230a09dd78be$var$R();
                    $371c230a09dd78be$var$gi(b, a, 1, c);
                }
            }), $371c230a09dd78be$var$il(a, 1);
    }
};
$371c230a09dd78be$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $371c230a09dd78be$var$ih(a, 134217728);
        if (null !== b) {
            var c = $371c230a09dd78be$var$R();
            $371c230a09dd78be$var$gi(b, a, 134217728, c);
        }
        $371c230a09dd78be$var$il(a, 134217728);
    }
};
$371c230a09dd78be$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $371c230a09dd78be$var$yi(a), c = $371c230a09dd78be$var$ih(a, b);
        if (null !== c) {
            var d = $371c230a09dd78be$var$R();
            $371c230a09dd78be$var$gi(c, a, b, d);
        }
        $371c230a09dd78be$var$il(a, b);
    }
};
$371c230a09dd78be$var$Hc = function() {
    return $371c230a09dd78be$var$C;
};
$371c230a09dd78be$var$Ic = function(a, b) {
    var c = $371c230a09dd78be$var$C;
    try {
        return $371c230a09dd78be$var$C = a, b();
    } finally{
        $371c230a09dd78be$var$C = c;
    }
};
$371c230a09dd78be$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $371c230a09dd78be$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $371c230a09dd78be$var$Db(d);
                        if (!e) throw Error($371c230a09dd78be$var$p(90));
                        $371c230a09dd78be$var$Wa(d);
                        $371c230a09dd78be$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $371c230a09dd78be$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $371c230a09dd78be$var$fb(a, !!c.multiple, b, !1);
    }
};
$371c230a09dd78be$var$Gb = $371c230a09dd78be$var$Qk;
$371c230a09dd78be$var$Hb = $371c230a09dd78be$var$Rk;
var $371c230a09dd78be$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $371c230a09dd78be$var$Cb,
        $371c230a09dd78be$var$ue,
        $371c230a09dd78be$var$Db,
        $371c230a09dd78be$var$Eb,
        $371c230a09dd78be$var$Fb,
        $371c230a09dd78be$var$Qk
    ]
}, $371c230a09dd78be$var$tl = {
    findFiberByHostInstance: $371c230a09dd78be$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $371c230a09dd78be$var$ul = {
    bundleType: $371c230a09dd78be$var$tl.bundleType,
    version: $371c230a09dd78be$var$tl.version,
    rendererPackageName: $371c230a09dd78be$var$tl.rendererPackageName,
    rendererConfig: $371c230a09dd78be$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $371c230a09dd78be$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $371c230a09dd78be$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $371c230a09dd78be$var$tl.findFiberByHostInstance || $371c230a09dd78be$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $371c230a09dd78be$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$371c230a09dd78be$var$vl.isDisabled && $371c230a09dd78be$var$vl.supportsFiber) try {
        $371c230a09dd78be$var$kc = $371c230a09dd78be$var$vl.inject($371c230a09dd78be$var$ul), $371c230a09dd78be$var$lc = $371c230a09dd78be$var$vl;
    } catch (a) {}
}
$371c230a09dd78be$export$ae55be85d98224ed = $371c230a09dd78be$var$sl;
$371c230a09dd78be$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$371c230a09dd78be$var$nl(b)) throw Error($371c230a09dd78be$var$p(200));
    return $371c230a09dd78be$var$cl(a, b, null, c);
};
$371c230a09dd78be$export$882461b6382ed46c = function(a, b) {
    if (!$371c230a09dd78be$var$nl(a)) throw Error($371c230a09dd78be$var$p(299));
    var c = !1, d = "", e = $371c230a09dd78be$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $371c230a09dd78be$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$371c230a09dd78be$var$uf] = b.current;
    $371c230a09dd78be$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $371c230a09dd78be$var$ll(b);
};
$371c230a09dd78be$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($371c230a09dd78be$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($371c230a09dd78be$var$p(268, a));
    }
    a = $371c230a09dd78be$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$371c230a09dd78be$export$cd75ccfd720a3cd4 = function(a) {
    return $371c230a09dd78be$var$Rk(a);
};
$371c230a09dd78be$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$371c230a09dd78be$var$ol(b)) throw Error($371c230a09dd78be$var$p(200));
    return $371c230a09dd78be$var$rl(null, a, b, !0, c);
};
$371c230a09dd78be$export$757ceba2d55c277e = function(a, b, c) {
    if (!$371c230a09dd78be$var$nl(a)) throw Error($371c230a09dd78be$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $371c230a09dd78be$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $371c230a09dd78be$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$371c230a09dd78be$var$uf] = b.current;
    $371c230a09dd78be$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $371c230a09dd78be$var$ml(b);
};
$371c230a09dd78be$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$371c230a09dd78be$var$ol(b)) throw Error($371c230a09dd78be$var$p(200));
    return $371c230a09dd78be$var$rl(null, a, b, !1, c);
};
$371c230a09dd78be$export$502457920280e6be = function(a) {
    if (!$371c230a09dd78be$var$ol(a)) throw Error($371c230a09dd78be$var$p(40));
    return a._reactRootContainer ? ($371c230a09dd78be$var$Rk(function() {
        $371c230a09dd78be$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$371c230a09dd78be$var$uf] = null;
        });
    }), !0) : !1;
};
$371c230a09dd78be$export$c78a37762a8d58e1 = $371c230a09dd78be$var$Qk;
$371c230a09dd78be$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$371c230a09dd78be$var$ol(c)) throw Error($371c230a09dd78be$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($371c230a09dd78be$var$p(38));
    return $371c230a09dd78be$var$rl(a, b, c, !1, d);
};
$371c230a09dd78be$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("hOwrP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lj1Wj"));

});
parcelRegister("lj1Wj", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $f82ce07f2d154558$export$c4744153514ff05d, (v) => $f82ce07f2d154558$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $f82ce07f2d154558$export$3e506c1ccc9cc1a7, (v) => $f82ce07f2d154558$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $f82ce07f2d154558$export$e26fe2ed2fa76875, (v) => $f82ce07f2d154558$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $f82ce07f2d154558$export$502329bbf4b505b1, (v) => $f82ce07f2d154558$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $f82ce07f2d154558$export$6e3807111c4874c4, (v) => $f82ce07f2d154558$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $f82ce07f2d154558$export$c27134553091fb3a, (v) => $f82ce07f2d154558$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $f82ce07f2d154558$export$33ee1acdc04fd2a2, (v) => $f82ce07f2d154558$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $f82ce07f2d154558$export$b00a404bbd5edef2, (v) => $f82ce07f2d154558$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $f82ce07f2d154558$export$8352ce38b91d0c62, (v) => $f82ce07f2d154558$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $f82ce07f2d154558$export$d66a1c1c77bd778b, (v) => $f82ce07f2d154558$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $f82ce07f2d154558$export$d3dfb8e4810cb555, (v) => $f82ce07f2d154558$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $f82ce07f2d154558$export$839f9183b0465a69, (v) => $f82ce07f2d154558$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $f82ce07f2d154558$export$72fdf0e06517287b, (v) => $f82ce07f2d154558$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $f82ce07f2d154558$export$4b844e58a3e414b4, (v) => $f82ce07f2d154558$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $f82ce07f2d154558$export$816d2913ae6b83b1, (v) => $f82ce07f2d154558$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $f82ce07f2d154558$export$61bcfe829111a1d0, (v) => $f82ce07f2d154558$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $f82ce07f2d154558$export$7ee8c9beb337bc3f, (v) => $f82ce07f2d154558$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $f82ce07f2d154558$export$b5836b71941fa3ed, (v) => $f82ce07f2d154558$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $f82ce07f2d154558$export$cf845f2c119da08a, (v) => $f82ce07f2d154558$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f82ce07f2d154558$export$c4744153514ff05d;
var $f82ce07f2d154558$export$3e506c1ccc9cc1a7;
var $f82ce07f2d154558$export$e26fe2ed2fa76875;
var $f82ce07f2d154558$export$502329bbf4b505b1;
var $f82ce07f2d154558$export$6e3807111c4874c4;
var $f82ce07f2d154558$export$c27134553091fb3a;
var $f82ce07f2d154558$export$33ee1acdc04fd2a2;
var $f82ce07f2d154558$export$b00a404bbd5edef2;
var $f82ce07f2d154558$export$8352ce38b91d0c62;
var $f82ce07f2d154558$export$d66a1c1c77bd778b;
var $f82ce07f2d154558$export$d3dfb8e4810cb555;
var $f82ce07f2d154558$export$839f9183b0465a69;
var $f82ce07f2d154558$export$72fdf0e06517287b;
var $f82ce07f2d154558$export$4b844e58a3e414b4;
var $f82ce07f2d154558$export$816d2913ae6b83b1;
var $f82ce07f2d154558$export$61bcfe829111a1d0;
var $f82ce07f2d154558$export$7ee8c9beb337bc3f;
var $f82ce07f2d154558$export$b5836b71941fa3ed;
var $f82ce07f2d154558$export$cf845f2c119da08a;
'use strict';
function $f82ce07f2d154558$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f82ce07f2d154558$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f82ce07f2d154558$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f82ce07f2d154558$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f82ce07f2d154558$var$g(C, c)) n < e && 0 > $f82ce07f2d154558$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f82ce07f2d154558$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f82ce07f2d154558$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f82ce07f2d154558$var$l = performance;
    $f82ce07f2d154558$export$c4744153514ff05d = function() {
        return $f82ce07f2d154558$var$l.now();
    };
} else {
    var $f82ce07f2d154558$var$p = Date, $f82ce07f2d154558$var$q = $f82ce07f2d154558$var$p.now();
    $f82ce07f2d154558$export$c4744153514ff05d = function() {
        return $f82ce07f2d154558$var$p.now() - $f82ce07f2d154558$var$q;
    };
}
var $f82ce07f2d154558$var$r = [], $f82ce07f2d154558$var$t = [], $f82ce07f2d154558$var$u = 1, $f82ce07f2d154558$var$v = null, $f82ce07f2d154558$var$y = 3, $f82ce07f2d154558$var$z = !1, $f82ce07f2d154558$var$A = !1, $f82ce07f2d154558$var$B = !1, $f82ce07f2d154558$var$D = "function" === typeof setTimeout ? setTimeout : null, $f82ce07f2d154558$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f82ce07f2d154558$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f82ce07f2d154558$var$G(a) {
    for(var b = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$t); null !== b;){
        if (null === b.callback) $f82ce07f2d154558$var$k($f82ce07f2d154558$var$t);
        else if (b.startTime <= a) $f82ce07f2d154558$var$k($f82ce07f2d154558$var$t), b.sortIndex = b.expirationTime, $f82ce07f2d154558$var$f($f82ce07f2d154558$var$r, b);
        else break;
        b = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$t);
    }
}
function $f82ce07f2d154558$var$H(a) {
    $f82ce07f2d154558$var$B = !1;
    $f82ce07f2d154558$var$G(a);
    if (!$f82ce07f2d154558$var$A) {
        if (null !== $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r)) $f82ce07f2d154558$var$A = !0, $f82ce07f2d154558$var$I($f82ce07f2d154558$var$J);
        else {
            var b = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$t);
            null !== b && $f82ce07f2d154558$var$K($f82ce07f2d154558$var$H, b.startTime - a);
        }
    }
}
function $f82ce07f2d154558$var$J(a, b) {
    $f82ce07f2d154558$var$A = !1;
    $f82ce07f2d154558$var$B && ($f82ce07f2d154558$var$B = !1, $f82ce07f2d154558$var$E($f82ce07f2d154558$var$L), $f82ce07f2d154558$var$L = -1);
    $f82ce07f2d154558$var$z = !0;
    var c = $f82ce07f2d154558$var$y;
    try {
        $f82ce07f2d154558$var$G(b);
        for($f82ce07f2d154558$var$v = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r); null !== $f82ce07f2d154558$var$v && (!($f82ce07f2d154558$var$v.expirationTime > b) || a && !$f82ce07f2d154558$var$M());){
            var d = $f82ce07f2d154558$var$v.callback;
            if ("function" === typeof d) {
                $f82ce07f2d154558$var$v.callback = null;
                $f82ce07f2d154558$var$y = $f82ce07f2d154558$var$v.priorityLevel;
                var e = d($f82ce07f2d154558$var$v.expirationTime <= b);
                b = $f82ce07f2d154558$export$c4744153514ff05d();
                "function" === typeof e ? $f82ce07f2d154558$var$v.callback = e : $f82ce07f2d154558$var$v === $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r) && $f82ce07f2d154558$var$k($f82ce07f2d154558$var$r);
                $f82ce07f2d154558$var$G(b);
            } else $f82ce07f2d154558$var$k($f82ce07f2d154558$var$r);
            $f82ce07f2d154558$var$v = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r);
        }
        if (null !== $f82ce07f2d154558$var$v) var w = !0;
        else {
            var m = $f82ce07f2d154558$var$h($f82ce07f2d154558$var$t);
            null !== m && $f82ce07f2d154558$var$K($f82ce07f2d154558$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f82ce07f2d154558$var$v = null, $f82ce07f2d154558$var$y = c, $f82ce07f2d154558$var$z = !1;
    }
}
var $f82ce07f2d154558$var$N = !1, $f82ce07f2d154558$var$O = null, $f82ce07f2d154558$var$L = -1, $f82ce07f2d154558$var$P = 5, $f82ce07f2d154558$var$Q = -1;
function $f82ce07f2d154558$var$M() {
    return $f82ce07f2d154558$export$c4744153514ff05d() - $f82ce07f2d154558$var$Q < $f82ce07f2d154558$var$P ? !1 : !0;
}
function $f82ce07f2d154558$var$R() {
    if (null !== $f82ce07f2d154558$var$O) {
        var a = $f82ce07f2d154558$export$c4744153514ff05d();
        $f82ce07f2d154558$var$Q = a;
        var b = !0;
        try {
            b = $f82ce07f2d154558$var$O(!0, a);
        } finally{
            b ? $f82ce07f2d154558$var$S() : ($f82ce07f2d154558$var$N = !1, $f82ce07f2d154558$var$O = null);
        }
    } else $f82ce07f2d154558$var$N = !1;
}
var $f82ce07f2d154558$var$S;
if ("function" === typeof $f82ce07f2d154558$var$F) $f82ce07f2d154558$var$S = function() {
    $f82ce07f2d154558$var$F($f82ce07f2d154558$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f82ce07f2d154558$var$T = new MessageChannel, $f82ce07f2d154558$var$U = $f82ce07f2d154558$var$T.port2;
    $f82ce07f2d154558$var$T.port1.onmessage = $f82ce07f2d154558$var$R;
    $f82ce07f2d154558$var$S = function() {
        $f82ce07f2d154558$var$U.postMessage(null);
    };
} else $f82ce07f2d154558$var$S = function() {
    $f82ce07f2d154558$var$D($f82ce07f2d154558$var$R, 0);
};
function $f82ce07f2d154558$var$I(a) {
    $f82ce07f2d154558$var$O = a;
    $f82ce07f2d154558$var$N || ($f82ce07f2d154558$var$N = !0, $f82ce07f2d154558$var$S());
}
function $f82ce07f2d154558$var$K(a, b) {
    $f82ce07f2d154558$var$L = $f82ce07f2d154558$var$D(function() {
        a($f82ce07f2d154558$export$c4744153514ff05d());
    }, b);
}
$f82ce07f2d154558$export$3e506c1ccc9cc1a7 = 5;
$f82ce07f2d154558$export$e26fe2ed2fa76875 = 1;
$f82ce07f2d154558$export$502329bbf4b505b1 = 4;
$f82ce07f2d154558$export$6e3807111c4874c4 = 3;
$f82ce07f2d154558$export$c27134553091fb3a = null;
$f82ce07f2d154558$export$33ee1acdc04fd2a2 = 2;
$f82ce07f2d154558$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f82ce07f2d154558$export$8352ce38b91d0c62 = function() {
    $f82ce07f2d154558$var$A || $f82ce07f2d154558$var$z || ($f82ce07f2d154558$var$A = !0, $f82ce07f2d154558$var$I($f82ce07f2d154558$var$J));
};
$f82ce07f2d154558$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f82ce07f2d154558$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f82ce07f2d154558$export$d3dfb8e4810cb555 = function() {
    return $f82ce07f2d154558$var$y;
};
$f82ce07f2d154558$export$839f9183b0465a69 = function() {
    return $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r);
};
$f82ce07f2d154558$export$72fdf0e06517287b = function(a) {
    switch($f82ce07f2d154558$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f82ce07f2d154558$var$y;
    }
    var c = $f82ce07f2d154558$var$y;
    $f82ce07f2d154558$var$y = b;
    try {
        return a();
    } finally{
        $f82ce07f2d154558$var$y = c;
    }
};
$f82ce07f2d154558$export$4b844e58a3e414b4 = function() {};
$f82ce07f2d154558$export$816d2913ae6b83b1 = function() {};
$f82ce07f2d154558$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f82ce07f2d154558$var$y;
    $f82ce07f2d154558$var$y = a;
    try {
        return b();
    } finally{
        $f82ce07f2d154558$var$y = c;
    }
};
$f82ce07f2d154558$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f82ce07f2d154558$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f82ce07f2d154558$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f82ce07f2d154558$var$f($f82ce07f2d154558$var$t, a), null === $f82ce07f2d154558$var$h($f82ce07f2d154558$var$r) && a === $f82ce07f2d154558$var$h($f82ce07f2d154558$var$t) && ($f82ce07f2d154558$var$B ? ($f82ce07f2d154558$var$E($f82ce07f2d154558$var$L), $f82ce07f2d154558$var$L = -1) : $f82ce07f2d154558$var$B = !0, $f82ce07f2d154558$var$K($f82ce07f2d154558$var$H, c - d))) : (a.sortIndex = e, $f82ce07f2d154558$var$f($f82ce07f2d154558$var$r, a), $f82ce07f2d154558$var$A || $f82ce07f2d154558$var$z || ($f82ce07f2d154558$var$A = !0, $f82ce07f2d154558$var$I($f82ce07f2d154558$var$J)));
    return a;
};
$f82ce07f2d154558$export$b5836b71941fa3ed = $f82ce07f2d154558$var$M;
$f82ce07f2d154558$export$cf845f2c119da08a = function(a) {
    var b = $f82ce07f2d154558$var$y;
    return function() {
        var c = $f82ce07f2d154558$var$y;
        $f82ce07f2d154558$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f82ce07f2d154558$var$y = c;
        }
    };
};

});



parcelRegister("eloFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71628d5883e1375$export$2e2bcd8739ae039);
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version {version}, {date}
 *
 * http://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ var $a71628d5883e1375$var$keys = Object.keys;
var $a71628d5883e1375$var$isArray = Array.isArray;
var $a71628d5883e1375$var$_global = typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
function $a71628d5883e1375$var$extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    $a71628d5883e1375$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $a71628d5883e1375$var$getProto = Object.getPrototypeOf;
var $a71628d5883e1375$var$_hasOwn = {}.hasOwnProperty;
function $a71628d5883e1375$var$hasOwn(obj, prop) {
    return $a71628d5883e1375$var$_hasOwn.call(obj, prop);
}
function $a71628d5883e1375$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($a71628d5883e1375$var$getProto(proto));
    $a71628d5883e1375$var$keys(extension).forEach(function(key) {
        $a71628d5883e1375$var$setProp(proto, key, extension[key]);
    });
}
var $a71628d5883e1375$var$defineProperty = Object.defineProperty;
function $a71628d5883e1375$var$setProp(obj, prop, functionOrGetSet, options) {
    $a71628d5883e1375$var$defineProperty(obj, prop, $a71628d5883e1375$var$extend(functionOrGetSet && $a71628d5883e1375$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $a71628d5883e1375$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $a71628d5883e1375$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $a71628d5883e1375$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $a71628d5883e1375$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $a71628d5883e1375$var$getPropertyDescriptor(obj, prop) {
    var pd = $a71628d5883e1375$var$getOwnPropertyDescriptor(obj, prop), proto;
    return pd || (proto = $a71628d5883e1375$var$getProto(obj)) && $a71628d5883e1375$var$getPropertyDescriptor(proto, prop);
}
var $a71628d5883e1375$var$_slice = [].slice;
function $a71628d5883e1375$var$slice(args, start, end) {
    return $a71628d5883e1375$var$_slice.call(args, start, end);
}
function $a71628d5883e1375$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $a71628d5883e1375$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $a71628d5883e1375$var$asap(fn) {
    if ($a71628d5883e1375$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
/** Generate an object (hash map) based on given array.
 * @param extractor Function taking an array item and its index and returning an array of 2 items ([key, value]) to
 *        instert on the resulting object for each item in the array. If this function returns a falsy value, the
 *        current item wont affect the resulting object.
 */ function $a71628d5883e1375$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $a71628d5883e1375$var$trycatcher(fn, reject) {
    return function() {
        try {
            fn.apply(this, arguments);
        } catch (e) {
            reject(e);
        }
    };
}
function $a71628d5883e1375$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $a71628d5883e1375$var$getByKeyPath(obj, keyPath) {
    // http://www.w3.org/TR/IndexedDB/#steps-for-extracting-a-key-from-a-value-using-a-key-path
    if ($a71628d5883e1375$var$hasOwn(obj, keyPath)) return obj[keyPath]; // This line is moved from last to first for optimization purpose.
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $a71628d5883e1375$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj === undefined ? undefined : $a71628d5883e1375$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $a71628d5883e1375$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $a71628d5883e1375$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$a71628d5883e1375$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) delete obj[currentKeyPath];
                else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj) innerObj = obj[currentKeyPath] = {};
                $a71628d5883e1375$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) delete obj[keyPath];
        else obj[keyPath] = value;
    }
}
function $a71628d5883e1375$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $a71628d5883e1375$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $a71628d5883e1375$var$setByKeyPath(obj, kp, undefined);
    });
}
function $a71628d5883e1375$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($a71628d5883e1375$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $a71628d5883e1375$var$concat = [].concat;
function $a71628d5883e1375$var$flatten(a) {
    return $a71628d5883e1375$var$concat.apply([], a);
}
//https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
var $a71628d5883e1375$var$intrinsicTypes = "Boolean,String,Date,RegExp,Blob,File,FileList,ArrayBuffer,DataView,Uint8ClampedArray,ImageData,Map,Set".split(',').concat($a71628d5883e1375$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $a71628d5883e1375$var$_global[t];
}).map(function(t) {
    return $a71628d5883e1375$var$_global[t];
});
function $a71628d5883e1375$var$deepClone(any) {
    if (!any || typeof any !== 'object') return any;
    var rv;
    if ($a71628d5883e1375$var$isArray(any)) {
        rv = [];
        for(var i = 0, l = any.length; i < l; ++i)rv.push($a71628d5883e1375$var$deepClone(any[i]));
    } else if ($a71628d5883e1375$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        rv = any.constructor ? Object.create(any.constructor.prototype) : {};
        for(var prop in any)if ($a71628d5883e1375$var$hasOwn(any, prop)) rv[prop] = $a71628d5883e1375$var$deepClone(any[prop]);
    }
    return rv;
}
function $a71628d5883e1375$var$getObjectDiff(a, b, rv, prfx) {
    // Compares objects a and b and produces a diff object.
    rv = rv || {};
    prfx = prfx || '';
    $a71628d5883e1375$var$keys(a).forEach(function(prop) {
        if (!$a71628d5883e1375$var$hasOwn(b, prop)) rv[prfx + prop] = undefined; // Property removed
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp && // Now compare constructors are same (not equal because wont work in Safari)
            '' + ap.constructor === '' + bp.constructor) // Same type of object but its properties may have changed
            $a71628d5883e1375$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
            else if (ap !== bp) rv[prfx + prop] = b[prop]; // Primitive value changed
        }
    });
    $a71628d5883e1375$var$keys(b).forEach(function(prop) {
        if (!$a71628d5883e1375$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop]; // Property added
    });
    return rv;
}
// If first argument is iterable or array-like, return it as an array
var $a71628d5883e1375$var$iteratorSymbol = typeof Symbol !== 'undefined' && Symbol.iterator;
var $a71628d5883e1375$var$getIteratorOf = $a71628d5883e1375$var$iteratorSymbol ? function(x) {
    var i;
    return x != null && (i = x[$a71628d5883e1375$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $a71628d5883e1375$var$NO_CHAR_ARRAY = {};
// Takes one or several arguments and returns an array based on the following criteras:
// * If several arguments provided, return arguments converted to an array in a way that
//   still allows javascript engine to optimize the code.
// * If single argument is an array, return a clone of it.
// * If this-pointer equals NO_CHAR_ARRAY, don't accept strings as valid iterables as a special
//   case to the two bullets below.
// * If single argument is an iterable, convert it to an array and return the resulting array.
// * If single argument is array-like (has length of type number), convert it to an array.
function $a71628d5883e1375$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($a71628d5883e1375$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $a71628d5883e1375$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $a71628d5883e1375$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
// By default, debug will be true only if platform is a web platform and its page is served from localhost.
// When debug = true, error's stacks will contain asyncronic long stacks.
var $a71628d5883e1375$var$debug = typeof location !== 'undefined' && // By default, use debug mode if served from localhost.
/^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $a71628d5883e1375$var$setDebug(value, filter) {
    $a71628d5883e1375$var$debug = value;
    $a71628d5883e1375$var$libraryFilter = filter;
}
var $a71628d5883e1375$var$libraryFilter = function() {
    return true;
};
var $a71628d5883e1375$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $a71628d5883e1375$var$getErrorWithStack() {
    "use strict";
    if ($a71628d5883e1375$var$NEEDS_THROW_FOR_STACK) try {
        // Doing something naughty in strict mode here to trigger a specific error
        // that can be explicitely ignored in debugger's exception settings.
        // If we'd just throw new Error() here, IE's debugger's exception settings
        // will just consider it as "exception thrown by javascript code" which is
        // something you wouldn't want it to ignore.
        $a71628d5883e1375$var$getErrorWithStack.arguments;
        throw new Error(); // Fallback if above line don't throw.
    } catch (e) {
        return e;
    }
    return new Error();
}
function $a71628d5883e1375$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split('\n').length;
    return stack.split('\n').slice(numIgnoredFrames).filter($a71628d5883e1375$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join('');
}
function $a71628d5883e1375$var$deprecated(what, fn) {
    return function() {
        console.warn(what + " is deprecated. See https://github.com/dfahlander/Dexie.js/wiki/Deprecations. " + $a71628d5883e1375$var$prettyStack($a71628d5883e1375$var$getErrorWithStack(), 1));
        return fn.apply(this, arguments);
    };
}
var $a71628d5883e1375$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $a71628d5883e1375$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $a71628d5883e1375$var$errorList = $a71628d5883e1375$var$dexieErrorNames.concat($a71628d5883e1375$var$idbDomErrorNames);
var $a71628d5883e1375$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed"
};
//
// DexieError - base class of all out exceptions.
//
function $a71628d5883e1375$var$DexieError(name, msg) {
    // Reason we don't use ES6 classes is because:
    // 1. It bloats transpiled code and increases size of minified code.
    // 2. It doesn't give us much in this case.
    // 3. It would require sub classes to call super(), which
    //    is not needed when deriving from Error.
    this._e = $a71628d5883e1375$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$a71628d5883e1375$var$derive($a71628d5883e1375$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $a71628d5883e1375$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $a71628d5883e1375$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + failures.map(function(f) {
        return f.toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }) // Only unique error strings
    .join('\n');
}
//
// ModifyError - thrown in Collection.modify()
// Specific constructor because it contains members failures and failedKeys.
//
function $a71628d5883e1375$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $a71628d5883e1375$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
}
$a71628d5883e1375$var$derive($a71628d5883e1375$var$ModifyError).from($a71628d5883e1375$var$DexieError);
function $a71628d5883e1375$var$BulkError(msg, failures) {
    this._e = $a71628d5883e1375$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = failures;
    this.message = $a71628d5883e1375$var$getMultiErrorMessage(msg, failures);
}
$a71628d5883e1375$var$derive($a71628d5883e1375$var$BulkError).from($a71628d5883e1375$var$DexieError);
//
//
// Dynamically generate error names and exception classes based
// on the names in errorList.
//
//
// Map of {ErrorName -> ErrorName + "Error"}
var $a71628d5883e1375$var$errnames = $a71628d5883e1375$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
// Need an alias for DexieError because we're gonna create subclasses with the same name.
var $a71628d5883e1375$var$BaseException = $a71628d5883e1375$var$DexieError;
// Map of {ErrorName -> exception constructor}
var $a71628d5883e1375$var$exceptions = $a71628d5883e1375$var$errorList.reduce(function(obj, name) {
    // Let the name be "DexieError" because this name may
    // be shown in call stack and when debugging. DexieError is
    // the most true name because it derives from DexieError,
    // and we cannot change Function.name programatically without
    // dynamically create a Function object, which would be considered
    // 'eval-evil'.
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $a71628d5883e1375$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $a71628d5883e1375$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = msgOrInner;
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $a71628d5883e1375$var$derive(DexieError).from($a71628d5883e1375$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
// Use ECMASCRIPT standard exceptions where applicable:
$a71628d5883e1375$var$exceptions.Syntax = SyntaxError;
$a71628d5883e1375$var$exceptions.Type = TypeError;
$a71628d5883e1375$var$exceptions.Range = RangeError;
var $a71628d5883e1375$var$exceptionMap = $a71628d5883e1375$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $a71628d5883e1375$var$exceptions[name];
    return obj;
}, {});
function $a71628d5883e1375$var$mapError(domError, message) {
    if (!domError || domError instanceof $a71628d5883e1375$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$a71628d5883e1375$var$exceptionMap[domError.name]) return domError;
    var rv = new $a71628d5883e1375$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) // Derive stack from inner exception if it has a stack
    $a71628d5883e1375$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $a71628d5883e1375$var$fullNameExceptions = $a71628d5883e1375$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $a71628d5883e1375$var$exceptions[name];
    return obj;
}, {});
$a71628d5883e1375$var$fullNameExceptions.ModifyError = $a71628d5883e1375$var$ModifyError;
$a71628d5883e1375$var$fullNameExceptions.DexieError = $a71628d5883e1375$var$DexieError;
$a71628d5883e1375$var$fullNameExceptions.BulkError = $a71628d5883e1375$var$BulkError;
function $a71628d5883e1375$var$nop() {}
function $a71628d5883e1375$var$mirror(val) {
    return val;
}
function $a71628d5883e1375$var$pureFunctionChain(f1, f2) {
    // Enables chained events that takes ONE argument and returns it to the next function in chain.
    // This pattern is used in the hook("reading") event.
    if (f1 == null || f1 === $a71628d5883e1375$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $a71628d5883e1375$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $a71628d5883e1375$var$hookCreatingChain(f1, f2) {
    // Enables chained events that takes several arguments and may modify first argument by making a modification and then returning the same instance.
    // This pattern is used in the hook("creating") event.
    if (f1 === $a71628d5883e1375$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror; // In case event listener has set this.onerror
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $a71628d5883e1375$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $a71628d5883e1375$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $a71628d5883e1375$var$hookDeletingChain(f1, f2) {
    if (f1 === $a71628d5883e1375$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror; // In case event listener has set this.onerror
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $a71628d5883e1375$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $a71628d5883e1375$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $a71628d5883e1375$var$hookUpdatingChain(f1, f2) {
    if (f1 === $a71628d5883e1375$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $a71628d5883e1375$var$extend(modifications, res); // If f1 returns new modifications, extend caller's modifications with the result before calling next in chain.
        var onsuccess = this.onsuccess, onerror = this.onerror; // In case event listener has set this.onerror
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $a71628d5883e1375$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $a71628d5883e1375$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $a71628d5883e1375$var$extend(res, res2);
    };
}
function $a71628d5883e1375$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $a71628d5883e1375$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $a71628d5883e1375$var$promisableChain(f1, f2) {
    if (f1 === $a71628d5883e1375$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
/*
 * Copyright (c) 2014-2017 David Fahlander
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/LICENSE-2.0
 */ //
// Promise and Zone (PSD) for Dexie library
//
// I started out writing this Promise class by copying promise-light (https://github.com/taylorhakes/promise-light) by
// https://github.com/taylorhakes - an A+ and ECMASCRIPT 6 compliant Promise implementation.
//
// In previous versions this was fixed by not calling setTimeout when knowing that the resolve() or reject() came from another
// tick. In Dexie v1.4.0, I've rewritten the Promise class entirely. Just some fragments of promise-light is left. I use
// another strategy now that simplifies everything a lot: to always execute callbacks in a new micro-task, but have an own micro-task
// engine that is indexedDB compliant across all browsers.
// Promise class has also been optimized a lot with inspiration from bluebird - to avoid closures as much as possible.
// Also with inspiration from bluebird, asyncronic stacks in debug mode.
//
// Specific non-standard features of this Promise class:
// * Custom zone support (a.k.a. PSD) with ability to keep zones also when using native promises as well as
//   native async / await.
// * Promise.follow() method built upon the custom zone engine, that allows user to track all promises created from current stack frame
//   and below + all promises that those promises creates or awaits.
// * Detect any unhandled promise in a PSD-scope (PSD.onunhandled). 
//
// David Fahlander, https://github.com/dfahlander
//
// Just a pointer that only this module knows about.
// Used in Promise constructor to emulate a private constructor.
var $a71628d5883e1375$var$INTERNAL = {};
// Async stacks (long stacks) must not grow infinitely.
var $a71628d5883e1375$var$LONG_STACKS_CLIP_LIMIT = 100;
var $a71628d5883e1375$var$MAX_LONG_STACKS = 20;
var $a71628d5883e1375$var$ZONE_ECHO_LIMIT = 7;
var $a71628d5883e1375$var$nativePromiseInstanceAndProto = function() {
    try {
        // Be able to patch native async functions
        return new Function("let F=async ()=>{},p=F();return [p,Object.getPrototypeOf(p),Promise.resolve(),F.constructor];")();
    } catch (e) {
        var P = $a71628d5883e1375$var$_global.Promise;
        return P ? [
            P.resolve(),
            P.prototype,
            P.resolve()
        ] : [];
    }
}();
var $a71628d5883e1375$var$resolvedNativePromise = $a71628d5883e1375$var$nativePromiseInstanceAndProto[0];
var $a71628d5883e1375$var$nativePromiseProto = $a71628d5883e1375$var$nativePromiseInstanceAndProto[1];
var $a71628d5883e1375$var$resolvedGlobalPromise = $a71628d5883e1375$var$nativePromiseInstanceAndProto[2];
var $a71628d5883e1375$var$nativePromiseThen = $a71628d5883e1375$var$nativePromiseProto && $a71628d5883e1375$var$nativePromiseProto.then;
var $a71628d5883e1375$var$NativePromise = $a71628d5883e1375$var$resolvedNativePromise && $a71628d5883e1375$var$resolvedNativePromise.constructor;
var $a71628d5883e1375$var$AsyncFunction = $a71628d5883e1375$var$nativePromiseInstanceAndProto[3];
var $a71628d5883e1375$var$patchGlobalPromise = !!$a71628d5883e1375$var$resolvedGlobalPromise;
var $a71628d5883e1375$var$stack_being_generated = false;
/* The default function used only for the very first promise in a promise chain.
   As soon as then promise is resolved or rejected, all next tasks will be executed in micro ticks
   emulated in this module. For indexedDB compatibility, this means that every method needs to
   execute at least one promise before doing an indexedDB operation. Dexie will always call
   db.ready().then() for every operation to make sure the indexedDB event is started in an
   indexedDB-compatible emulated micro task loop.
*/ var $a71628d5883e1375$var$schedulePhysicalTick = $a71628d5883e1375$var$resolvedGlobalPromise ? function() {
    $a71628d5883e1375$var$resolvedGlobalPromise.then($a71628d5883e1375$var$physicalTick);
} : $a71628d5883e1375$var$_global.setImmediate ? // setImmediate supported. Those modern platforms also supports Function.bind().
setImmediate.bind(null, $a71628d5883e1375$var$physicalTick) : $a71628d5883e1375$var$_global.MutationObserver ? // MutationObserver supported
function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $a71628d5883e1375$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute('i', '1');
} : // No support for setImmediate or MutationObserver. No worry, setTimeout is only called
// once time. Every tick that follows will be our emulated micro tick.
// Could have uses setTimeout.bind(null, 0, physicalTick) if it wasnt for that FF13 and below has a bug 
function() {
    setTimeout($a71628d5883e1375$var$physicalTick, 0);
};
// Configurable through Promise.scheduler.
// Don't export because it would be unsafe to let unknown
// code call it unless they do try..catch within their callback.
// This function can be retrieved through getter of Promise.scheduler though,
// but users must not do Promise.scheduler = myFuncThatThrowsException
var $a71628d5883e1375$var$asap$1 = function(callback, args) {
    $a71628d5883e1375$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($a71628d5883e1375$var$needsNewPhysicalTick) {
        $a71628d5883e1375$var$schedulePhysicalTick();
        $a71628d5883e1375$var$needsNewPhysicalTick = false;
    }
};
var $a71628d5883e1375$var$isOutsideMicroTick = true;
var $a71628d5883e1375$var$needsNewPhysicalTick = true;
var $a71628d5883e1375$var$unhandledErrors = [];
var $a71628d5883e1375$var$rejectingErrors = [];
var $a71628d5883e1375$var$currentFulfiller = null;
var $a71628d5883e1375$var$rejectionMapper = $a71628d5883e1375$var$mirror; // Remove in next major when removing error mapping of DOMErrors and DOMExceptions
var $a71628d5883e1375$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $a71628d5883e1375$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $a71628d5883e1375$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $a71628d5883e1375$var$PSD = $a71628d5883e1375$var$globalPSD;
var $a71628d5883e1375$var$microtickQueue = []; // Callbacks to call in this or next physical tick.
var $a71628d5883e1375$var$numScheduledCalls = 0; // Number of listener-calls left to do in this physical tick.
var $a71628d5883e1375$var$tickFinalizers = []; // Finalizers to call when there are no more async calls scheduled within current physical tick.
function $a71628d5883e1375$var$Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this.onuncatched = $a71628d5883e1375$var$nop; // Deprecate in next major. Not needed. Better to use global error handler.
    // A library may set `promise._lib = true;` after promise is created to make resolve() or reject()
    // execute the microtask engine implicitely within the call to resolve() or reject().
    // To remain A+ compliant, a library must only set `_lib=true` if it can guarantee that the stack
    // only contains library code when calling resolve() or reject().
    // RULE OF THUMB: ONLY set _lib = true for promises explicitely resolving/rejecting directly from
    // global scope (event handler, timer etc)!
    this._lib = false;
    // Current async scope
    var psd = this._PSD = $a71628d5883e1375$var$PSD;
    if ($a71628d5883e1375$var$debug) {
        this._stackHolder = $a71628d5883e1375$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0; // Number of previous promises (for long stacks)
    }
    if (typeof fn !== 'function') {
        if (fn !== $a71628d5883e1375$var$INTERNAL) throw new TypeError('Not a function');
        // Private constructor (INTERNAL, state, value).
        // Used internally by Promise.resolve() and Promise.reject().
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $a71628d5883e1375$var$handleRejection(this, this._value); // Map error, set stack and addPossiblyUnhandledError().
        return;
    }
    this._state = null; // null (=pending), false (=rejected) or true (=resolved)
    this._value = null; // error or result
    ++psd.ref; // Refcounting current scope
    $a71628d5883e1375$var$executePromiseTask(this, fn);
}
// Prepare a property descriptor to put onto Promise.prototype.then
var $a71628d5883e1375$var$thenProp = {
    get: function() {
        var psd = $a71628d5883e1375$var$PSD, microTaskId = $a71628d5883e1375$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $a71628d5883e1375$var$PSD || microTaskId !== $a71628d5883e1375$var$totalEchoes);
            if (possibleAwait) $a71628d5883e1375$var$decrementExpectedAwaits();
            var rv = new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                $a71628d5883e1375$var$propagateToListener(_this, new $a71628d5883e1375$var$Listener($a71628d5883e1375$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait), $a71628d5883e1375$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait), resolve, reject, psd));
            });
            $a71628d5883e1375$var$debug && $a71628d5883e1375$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $a71628d5883e1375$var$INTERNAL; // For idempotense, see setter below.
        return then;
    },
    // Be idempotent and allow another framework (such as zone.js or another instance of a Dexie.Promise module) to replace Promise.prototype.then
    // and when that framework wants to restore the original property, we must identify that and restore the original property descriptor.
    set: function(value) {
        $a71628d5883e1375$var$setProp(this, 'then', value && value.prototype === $a71628d5883e1375$var$INTERNAL ? $a71628d5883e1375$var$thenProp : {
            get: function() {
                return value; // Getter returning provided value (behaves like value is just changed)
            },
            set: $a71628d5883e1375$var$thenProp.set // Keep a setter that is prepared to restore original.
        });
    }
};
$a71628d5883e1375$var$props($a71628d5883e1375$var$Promise.prototype, {
    then: $a71628d5883e1375$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        // A little tinier version of then() that don't have to create a resulting promise.
        $a71628d5883e1375$var$propagateToListener(this, new $a71628d5883e1375$var$Listener(null, null, onFulfilled, onRejected, $a71628d5883e1375$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        // First argument is the Error type to catch
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            // Catching errors by its constructor type (similar to java / c++ / c#)
            // Sample: promise.catch(TypeError, function (e) { ... });
            return err instanceof type ? handler(err) : $a71628d5883e1375$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            // Catching errors by the error.name property. Makes sense for indexedDB where error type
            // is always DOMError but where e.name tells the actual error type.
            // Sample: promise.catch('ConstraintError', function (e) { ... });
            return err && err.name === type ? handler(err) : $a71628d5883e1375$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $a71628d5883e1375$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $a71628d5883e1375$var$stack_being_generated = true;
                var stacks = $a71628d5883e1375$var$getStack(this, [], $a71628d5883e1375$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack; // Stack may be updated on reject.
                return stack;
            } finally{
                $a71628d5883e1375$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $a71628d5883e1375$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $a71628d5883e1375$var$setProp($a71628d5883e1375$var$Promise.prototype, Symbol.toStringTag, 'Promise');
// Now that Promise.prototype is defined, we have all it takes to set globalPSD.env.
// Environment globals snapshotted on leaving global zone
$a71628d5883e1375$var$globalPSD.env = $a71628d5883e1375$var$snapShot();
function $a71628d5883e1375$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
// Promise Static Properties
$a71628d5883e1375$var$props($a71628d5883e1375$var$Promise, {
    all: function() {
        var values = $a71628d5883e1375$var$getArrayOf.apply(null, arguments) // Supports iterables, implicit arguments and array-like.
        .map($a71628d5883e1375$var$onPossibleParallellAsync); // Handle parallell async/awaits 
        return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $a71628d5883e1375$var$Promise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $a71628d5883e1375$var$Promise) return value;
        if (value && typeof value.then === 'function') return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $a71628d5883e1375$var$Promise($a71628d5883e1375$var$INTERNAL, true, value);
        $a71628d5883e1375$var$linkToPreviousPromise(rv, $a71628d5883e1375$var$currentFulfiller);
        return rv;
    },
    reject: $a71628d5883e1375$var$PromiseReject,
    race: function() {
        var values = $a71628d5883e1375$var$getArrayOf.apply(null, arguments).map($a71628d5883e1375$var$onPossibleParallellAsync);
        return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            values.map(function(value) {
                return $a71628d5883e1375$var$Promise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $a71628d5883e1375$var$PSD;
        },
        set: function(value) {
            return $a71628d5883e1375$var$PSD = value;
        }
    },
    //totalEchoes: {get: ()=>totalEchoes},
    //task: {get: ()=>task},
    newPSD: $a71628d5883e1375$var$newScope,
    usePSD: $a71628d5883e1375$var$usePSD,
    scheduler: {
        get: function() {
            return $a71628d5883e1375$var$asap$1;
        },
        set: function(value) {
            $a71628d5883e1375$var$asap$1 = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $a71628d5883e1375$var$rejectionMapper;
        },
        set: function(value) {
            $a71628d5883e1375$var$rejectionMapper = value;
        } // Map reject failures
    },
    follow: function(fn, zoneProps) {
        return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            return $a71628d5883e1375$var$newScope(function(resolve, reject) {
                var psd = $a71628d5883e1375$var$PSD;
                psd.unhandleds = []; // For unhandled standard- or 3rd party Promises. Checked at psd.finalize()
                psd.onunhandled = reject; // Triggered directly on unhandled promises of this library.
                psd.finalize = $a71628d5883e1375$var$callBoth(function() {
                    var _this = this;
                    // Unhandled standard or 3rd part promises are put in PSD.unhandleds and
                    // examined upon scope completion while unhandled rejections in this Promise
                    // will trigger directly through psd.onunhandled
                    $a71628d5883e1375$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
/**
* Take a potentially misbehaving resolver function and make sure
* onFulfilled and onRejected are only called once.
*
* Makes no guarantees about asynchrony.
*/ function $a71628d5883e1375$var$executePromiseTask(promise, fn) {
    // Promise Resolution Procedure:
    // https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    try {
        fn(function(value) {
            if (promise._state !== null) return; // Already settled
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $a71628d5883e1375$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $a71628d5883e1375$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $a71628d5883e1375$var$Promise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $a71628d5883e1375$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $a71628d5883e1375$var$endMicroTickScope();
        }, $a71628d5883e1375$var$handleRejection.bind(null, promise)); // If Function.bind is not supported. Exception is handled in catch below
    } catch (ex) {
        $a71628d5883e1375$var$handleRejection(promise, ex);
    }
}
function $a71628d5883e1375$var$handleRejection(promise, reason) {
    $a71628d5883e1375$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $a71628d5883e1375$var$beginMicroTickScope();
    reason = $a71628d5883e1375$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $a71628d5883e1375$var$debug && reason !== null && typeof reason === 'object' && !reason._promise && $a71628d5883e1375$var$tryCatch(function() {
        var origProp = $a71628d5883e1375$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $a71628d5883e1375$var$setProp(reason, "stack", {
            get: function() {
                return $a71628d5883e1375$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    // Add the failure to a list of possibly uncaught errors
    $a71628d5883e1375$var$addPossiblyUnhandledError(promise);
    $a71628d5883e1375$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $a71628d5883e1375$var$endMicroTickScope();
}
function $a71628d5883e1375$var$propagateAllListeners(promise) {
    //debug && linkToPreviousPromise(promise);
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$a71628d5883e1375$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize(); // if psd.ref reaches zero, call psd.finalize();
    if ($a71628d5883e1375$var$numScheduledCalls === 0) {
        // If numScheduledCalls is 0, it means that our stack is not in a callback of a scheduled call,
        // and that no deferreds where listening to this rejection or success.
        // Since there is a risk that our stack can contain application code that may
        // do stuff after this code is finished that may generate new calls, we cannot
        // call finalizers here.
        ++$a71628d5883e1375$var$numScheduledCalls;
        $a71628d5883e1375$var$asap$1(function() {
            if (--$a71628d5883e1375$var$numScheduledCalls === 0) $a71628d5883e1375$var$finalizePhysicalTick(); // Will detect unhandled errors
        }, []);
    }
}
function $a71628d5883e1375$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) // This Listener doesnt have a listener for the event being triggered (onFulfilled or onReject) so lets forward the event to any eventual listeners on the Promise instance returned by then() or catch()
    return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$a71628d5883e1375$var$numScheduledCalls;
    $a71628d5883e1375$var$asap$1($a71628d5883e1375$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $a71628d5883e1375$var$callListener(cb, promise, listener) {
    try {
        // Set static variable currentFulfiller to the promise that is being fullfilled,
        // so that we connect the chain of promises (for long stacks support)
        $a71628d5883e1375$var$currentFulfiller = promise;
        // Call callback and resolve our listener with it's return value.
        var ret, value = promise._value;
        if (promise._state) // cb is onResolved
        ret = cb(value);
        else {
            // cb is onRejected
            if ($a71628d5883e1375$var$rejectingErrors.length) $a71628d5883e1375$var$rejectingErrors = [];
            ret = cb(value);
            if ($a71628d5883e1375$var$rejectingErrors.indexOf(value) === -1) $a71628d5883e1375$var$markErrorAsHandled(promise); // Callback didnt do Promise.reject(err) nor reject(err) onto another promise.
        }
        listener.resolve(ret);
    } catch (e) {
        // Exception thrown in callback. Reject our listener.
        listener.reject(e);
    } finally{
        // Restore env and currentFulfiller.
        $a71628d5883e1375$var$currentFulfiller = null;
        if (--$a71628d5883e1375$var$numScheduledCalls === 0) $a71628d5883e1375$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $a71628d5883e1375$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $a71628d5883e1375$var$prettyStack(failure, 0);
        } else {
            errorName = failure; // If error is undefined or null, show that.
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($a71628d5883e1375$var$debug) {
        stack = $a71628d5883e1375$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $a71628d5883e1375$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $a71628d5883e1375$var$linkToPreviousPromise(promise, prev) {
    // Support long stacks by linking to previous completed promise.
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $a71628d5883e1375$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
/* The callback to schedule with setImmediate() or setTimeout().
   It runs a virtual microtick and executes any callback registered in microtickQueue.
 */ function $a71628d5883e1375$var$physicalTick() {
    $a71628d5883e1375$var$beginMicroTickScope() && $a71628d5883e1375$var$endMicroTickScope();
}
function $a71628d5883e1375$var$beginMicroTickScope() {
    var wasRootExec = $a71628d5883e1375$var$isOutsideMicroTick;
    $a71628d5883e1375$var$isOutsideMicroTick = false;
    $a71628d5883e1375$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
/* Executes micro-ticks without doing try..catch.
   This can be possible because we only use this internally and
   the registered functions are exception-safe (they do try..catch
   internally before calling any external method). If registering
   functions in the microtickQueue that are not exception-safe, this
   would destroy the framework and make it instable. So we don't export
   our asap method.
*/ function $a71628d5883e1375$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($a71628d5883e1375$var$microtickQueue.length > 0){
        callbacks = $a71628d5883e1375$var$microtickQueue;
        $a71628d5883e1375$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($a71628d5883e1375$var$microtickQueue.length > 0);
    $a71628d5883e1375$var$isOutsideMicroTick = true;
    $a71628d5883e1375$var$needsNewPhysicalTick = true;
}
function $a71628d5883e1375$var$finalizePhysicalTick() {
    var unhandledErrs = $a71628d5883e1375$var$unhandledErrors;
    $a71628d5883e1375$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $a71628d5883e1375$var$tickFinalizers.slice(0); // Clone first because finalizer may remove itself from list.
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $a71628d5883e1375$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $a71628d5883e1375$var$tickFinalizers.splice($a71628d5883e1375$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $a71628d5883e1375$var$tickFinalizers.push(finalizer);
    ++$a71628d5883e1375$var$numScheduledCalls;
    $a71628d5883e1375$var$asap$1(function() {
        if (--$a71628d5883e1375$var$numScheduledCalls === 0) $a71628d5883e1375$var$finalizePhysicalTick();
    }, []);
}
function $a71628d5883e1375$var$addPossiblyUnhandledError(promise) {
    // Only add to unhandledErrors if not already there. The first one to add to this list
    // will be upon the first rejection so that the root cause (first promise in the
    // rejection chain) is the one listed.
    if (!$a71628d5883e1375$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $a71628d5883e1375$var$unhandledErrors.push(promise);
}
function $a71628d5883e1375$var$markErrorAsHandled(promise) {
    // Called when a reject handled is actually being called.
    // Search in unhandledErrors for any promise whos _value is this promise_value (list
    // contains only rejected promises, and only one item per error)
    var i = $a71628d5883e1375$var$unhandledErrors.length;
    while(i)if ($a71628d5883e1375$var$unhandledErrors[--i]._value === promise._value) {
        // Found a promise that failed with this same error object pointer,
        // Remove that since there is a listener that actually takes care of it.
        $a71628d5883e1375$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $a71628d5883e1375$var$PromiseReject(reason) {
    return new $a71628d5883e1375$var$Promise($a71628d5883e1375$var$INTERNAL, false, reason);
}
function $a71628d5883e1375$var$wrap(fn, errorCatcher) {
    var psd = $a71628d5883e1375$var$PSD;
    return function() {
        var wasRootExec = $a71628d5883e1375$var$beginMicroTickScope(), outerScope = $a71628d5883e1375$var$PSD;
        try {
            $a71628d5883e1375$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $a71628d5883e1375$var$switchToZone(outerScope, false);
            if (wasRootExec) $a71628d5883e1375$var$endMicroTickScope();
        }
    };
}
//
// variables used for native await support
//
var $a71628d5883e1375$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
}; // The ongoing macro-task when using zone-echoing.
var $a71628d5883e1375$var$taskCounter = 0; // ID counter for macro tasks.
var $a71628d5883e1375$var$zoneStack = []; // Stack of left zones to restore asynchronically.
var $a71628d5883e1375$var$zoneEchoes = 0; // zoneEchoes is a must in order to persist zones between native await expressions.
var $a71628d5883e1375$var$totalEchoes = 0; // ID counter for micro-tasks. Used to detect possible native await in our Promise.prototype.then.
var $a71628d5883e1375$var$zone_id_counter = 0;
function $a71628d5883e1375$var$newScope(fn, props$$1, a1, a2) {
    var parent = $a71628d5883e1375$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$a71628d5883e1375$var$zone_id_counter;
    // Prepare for promise patching (done in usePSD):
    var globalEnv = $a71628d5883e1375$var$globalPSD.env;
    psd.env = $a71628d5883e1375$var$patchGlobalPromise ? {
        Promise: $a71628d5883e1375$var$Promise,
        PromiseProp: {
            value: $a71628d5883e1375$var$Promise,
            configurable: true,
            writable: true
        },
        all: $a71628d5883e1375$var$Promise.all,
        race: $a71628d5883e1375$var$Promise.race,
        resolve: $a71628d5883e1375$var$Promise.resolve,
        reject: $a71628d5883e1375$var$Promise.reject,
        nthen: $a71628d5883e1375$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $a71628d5883e1375$var$getPatchedPromiseThen(globalEnv.gthen, psd) // global then
    } : {};
    if (props$$1) $a71628d5883e1375$var$extend(psd, props$$1);
    // unhandleds and onunhandled should not be specifically set here.
    // Leave them on parent prototype.
    // unhandleds.push(err) will push to parent's prototype
    // onunhandled() will call parents onunhandled (with this scope's this-pointer though!)
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $a71628d5883e1375$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
// Function to call if scopeFunc returns NativePromise
// Also for each NativePromise in the arguments to Promise.all()
function $a71628d5883e1375$var$incrementExpectedAwaits() {
    if (!$a71628d5883e1375$var$task.id) $a71628d5883e1375$var$task.id = ++$a71628d5883e1375$var$taskCounter;
    ++$a71628d5883e1375$var$task.awaits;
    $a71628d5883e1375$var$task.echoes += $a71628d5883e1375$var$ZONE_ECHO_LIMIT;
    return $a71628d5883e1375$var$task.id;
}
// Function to call when 'then' calls back on a native promise where onAwaitExpected() had been called.
// Also call this when a native await calls then method on a promise. In that case, don't supply
// sourceTaskId because we already know it refers to current task.
function $a71628d5883e1375$var$decrementExpectedAwaits(sourceTaskId) {
    if (!$a71628d5883e1375$var$task.awaits || sourceTaskId && sourceTaskId !== $a71628d5883e1375$var$task.id) return;
    if (--$a71628d5883e1375$var$task.awaits === 0) $a71628d5883e1375$var$task.id = 0;
    $a71628d5883e1375$var$task.echoes = $a71628d5883e1375$var$task.awaits * $a71628d5883e1375$var$ZONE_ECHO_LIMIT; // Will reset echoes to 0 if awaits is 0.
}
// Call from Promise.all() and Promise.race()
function $a71628d5883e1375$var$onPossibleParallellAsync(possiblePromise) {
    if ($a71628d5883e1375$var$task.echoes && possiblePromise && possiblePromise.constructor === $a71628d5883e1375$var$NativePromise) {
        $a71628d5883e1375$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $a71628d5883e1375$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $a71628d5883e1375$var$decrementExpectedAwaits();
            return $a71628d5883e1375$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $a71628d5883e1375$var$zoneEnterEcho(targetZone) {
    ++$a71628d5883e1375$var$totalEchoes;
    if (!$a71628d5883e1375$var$task.echoes || --$a71628d5883e1375$var$task.echoes === 0) $a71628d5883e1375$var$task.echoes = $a71628d5883e1375$var$task.id = 0; // Cancel zone echoing.
    $a71628d5883e1375$var$zoneStack.push($a71628d5883e1375$var$PSD);
    $a71628d5883e1375$var$switchToZone(targetZone, true);
}
function $a71628d5883e1375$var$zoneLeaveEcho() {
    var zone = $a71628d5883e1375$var$zoneStack[$a71628d5883e1375$var$zoneStack.length - 1];
    $a71628d5883e1375$var$zoneStack.pop();
    $a71628d5883e1375$var$switchToZone(zone, false);
}
function $a71628d5883e1375$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $a71628d5883e1375$var$PSD;
    if (bEnteringZone ? $a71628d5883e1375$var$task.echoes && (!$a71628d5883e1375$var$zoneEchoes++ || targetZone !== $a71628d5883e1375$var$PSD) : $a71628d5883e1375$var$zoneEchoes && (!--$a71628d5883e1375$var$zoneEchoes || targetZone !== $a71628d5883e1375$var$PSD)) // Enter or leave zone asynchronically as well, so that tasks initiated during current tick
    // will be surrounded by the zone when they are invoked.
    $a71628d5883e1375$var$enqueueNativeMicroTask(bEnteringZone ? $a71628d5883e1375$var$zoneEnterEcho.bind(null, targetZone) : $a71628d5883e1375$var$zoneLeaveEcho);
    if (targetZone === $a71628d5883e1375$var$PSD) return;
    $a71628d5883e1375$var$PSD = targetZone; // The actual zone switch occurs at this line.
    // Snapshot on every leave from global zone.
    if (currentZone === $a71628d5883e1375$var$globalPSD) $a71628d5883e1375$var$globalPSD.env = $a71628d5883e1375$var$snapShot();
    if ($a71628d5883e1375$var$patchGlobalPromise) {
        // Let's patch the global and native Promises (may be same or may be different)
        var GlobalPromise = $a71628d5883e1375$var$globalPSD.env.Promise;
        // Swich environments (may be PSD-zone or the global zone. Both apply.)
        var targetEnv = targetZone.env;
        // Change Promise.prototype.then for native and global Promise (they MAY differ on polyfilled environments, but both can be accessed)
        // Must be done on each zone change because the patched method contains targetZone in its closure.
        $a71628d5883e1375$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            // Leaving or entering global zone. It's time to patch / restore global Promise.
            // Set this Promise to window.Promise so that transiled async functions will work on Firefox, Safari and IE, as well as with Zonejs and angular.
            Object.defineProperty($a71628d5883e1375$var$_global, 'Promise', targetEnv.PromiseProp);
            // Support Promise.all() etc to work indexedDB-safe also when people are including es6-promise as a module (they might
            // not be accessing global.Promise but a local reference to it)
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
        }
    }
}
function $a71628d5883e1375$var$snapShot() {
    var GlobalPromise = $a71628d5883e1375$var$_global.Promise;
    return $a71628d5883e1375$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($a71628d5883e1375$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $a71628d5883e1375$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $a71628d5883e1375$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $a71628d5883e1375$var$PSD;
    try {
        $a71628d5883e1375$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $a71628d5883e1375$var$switchToZone(outerScope, false);
    }
}
function $a71628d5883e1375$var$enqueueNativeMicroTask(job) {
    //
    // Precondition: nativePromiseThen !== undefined
    //
    $a71628d5883e1375$var$nativePromiseThen.call($a71628d5883e1375$var$resolvedNativePromise, job);
}
function $a71628d5883e1375$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $a71628d5883e1375$var$PSD;
        if (possibleAwait) $a71628d5883e1375$var$incrementExpectedAwaits();
        $a71628d5883e1375$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $a71628d5883e1375$var$switchToZone(outerZone, false);
        }
    };
}
function $a71628d5883e1375$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $a71628d5883e1375$var$nativeAwaitCompatibleWrap(onResolved, zone, false), $a71628d5883e1375$var$nativeAwaitCompatibleWrap(onRejected, zone, false));
    };
}
var $a71628d5883e1375$var$UNHANDLEDREJECTION = "unhandledrejection";
function $a71628d5883e1375$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($a71628d5883e1375$var$_global.document && document.createEvent) {
            event = document.createEvent('Event');
            event.initEvent($a71628d5883e1375$var$UNHANDLEDREJECTION, true, true);
            $a71628d5883e1375$var$extend(event, eventData);
        } else if ($a71628d5883e1375$var$_global.CustomEvent) {
            event = new CustomEvent($a71628d5883e1375$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $a71628d5883e1375$var$extend(event, eventData);
        }
        if (event && $a71628d5883e1375$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$a71628d5883e1375$var$_global.PromiseRejectionEvent && $a71628d5883e1375$var$_global.onunhandledrejection) // No native support for PromiseRejectionEvent but user has set window.onunhandledrejection. Manually call it.
            try {
                $a71628d5883e1375$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if (!event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $a71628d5883e1375$var$rejection = $a71628d5883e1375$var$Promise.reject;
function $a71628d5883e1375$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            // Subscribe. If additional arguments than just the subscriber was provided, forward them as well.
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') // Return interface allowing to fire or unsubscribe from event
        return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $a71628d5883e1375$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $a71628d5883e1375$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        // events(this, {reading: [functionChain, nop]});
        $a71628d5883e1375$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($a71628d5883e1375$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') // Rather than approaching event subscription using a functional approach, we here do it in a for-loop where subscriber is executed in its own stack
            // enabling that any exception that occur wont disturb the initiator and also not nescessary be catched and forgotten.
            var context = add(eventName, $a71628d5883e1375$var$mirror, function fire() {
                // Optimazation-safe cloning of arguments into args.
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                // All each subscriber:
                context.subscribers.forEach(function(fn) {
                    $a71628d5883e1375$var$asap(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * Copyright (c) 2014-2017 David Fahlander
 *
 * Version {version}, {date}
 *
 * http://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/LICENSE-2.0
 *
 */ var $a71628d5883e1375$var$DEXIE_VERSION = '{version}';
var $a71628d5883e1375$var$maxString = String.fromCharCode(65535);
var $a71628d5883e1375$var$maxKey = function() {
    try {
        IDBKeyRange.only([
            []
        ]);
        return [
            []
        ];
    } catch (e) {
        return $a71628d5883e1375$var$maxString;
    }
}();
var $a71628d5883e1375$var$minKey = -Infinity;
var $a71628d5883e1375$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $a71628d5883e1375$var$STRING_EXPECTED = "String expected.";
var $a71628d5883e1375$var$connections = [];
var $a71628d5883e1375$var$isIEOrEdge = typeof navigator !== 'undefined' && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $a71628d5883e1375$var$hasIEDeleteObjectStoreBug = $a71628d5883e1375$var$isIEOrEdge;
var $a71628d5883e1375$var$hangsOnDeleteLargeKeyRange = $a71628d5883e1375$var$isIEOrEdge;
var $a71628d5883e1375$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $a71628d5883e1375$var$dbNamesDB; // Global database for backing Dexie.getDatabaseNames() on browser without indexedDB.webkitGetDatabaseNames() 
// Init debug
$a71628d5883e1375$var$setDebug($a71628d5883e1375$var$debug, $a71628d5883e1375$var$dexieStackFrameFilter);
function $a71628d5883e1375$var$Dexie(dbName, options) {
    /// <param name="options" type="Object" optional="true">Specify only if you wich to control which addons that should run on this instance</param>
    var deps = $a71628d5883e1375$var$Dexie.dependencies;
    var opts = $a71628d5883e1375$var$extend({
        // Default Options
        addons: $a71628d5883e1375$var$Dexie.addons,
        autoOpen: true,
        indexedDB: deps.indexedDB,
        IDBKeyRange: deps.IDBKeyRange // Backend IDBKeyRange api. Default to browser env.
    }, options);
    var addons = opts.addons, autoOpen = opts.autoOpen, indexedDB = opts.indexedDB, IDBKeyRange1 = opts.IDBKeyRange;
    var globalSchema = this._dbSchema = {};
    var versions = [];
    var dbStoreNames = [];
    var allTables = {};
    ///<var type="IDBDatabase" />
    var idbdb = null; // Instance of IDBDatabase
    var dbOpenError = null;
    var isBeingOpened = false;
    var onReadyBeingFired = null;
    var openComplete = false;
    var READONLY = "readonly", READWRITE = "readwrite";
    var db = this;
    var dbReadyResolve, dbReadyPromise = new $a71628d5883e1375$var$Promise(function(resolve) {
        dbReadyResolve = resolve;
    }), cancelOpen, openCanceller = new $a71628d5883e1375$var$Promise(function(_, reject) {
        cancelOpen = reject;
    });
    var autoSchema = true;
    var hasNativeGetDatabaseNames = !!$a71628d5883e1375$var$getNativeGetDatabaseNamesFn(indexedDB), hasGetAll;
    function init() {
        // Default subscribers to "versionchange" and "blocked".
        // Can be overridden by custom handlers. If custom handlers return false, these default
        // behaviours will be prevented.
        db.on("versionchange", function(ev) {
            // Default behavior for versionchange event is to close database connection.
            // Caller can override this behavior by doing db.on("versionchange", function(){ return false; });
            // Let's not block the other window from making it's delete() or open() call.
            // NOTE! This event is never fired in IE,Edge or Safari.
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + db.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + db.name + "'. Closing db now to resume the delete request.");
            db.close();
        // In many web applications, it would be recommended to force window.reload()
        // when this event occurs. To do that, subscribe to the versionchange event
        // and call window.location.reload(true) if ev.newVersion > 0 (not a deletion)
        // The reason for this is that your current web app obviously has old schema code that needs
        // to be updated. Another window got a newer version of the app and needs to upgrade DB but
        // your window is blocking it unless we close it here.
        });
        db.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + db.name + "') was blocked");
            else console.warn("Upgrade '" + db.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
    }
    //
    //
    //
    // ------------------------- Versioning Framework---------------------------
    //
    //
    //
    this.version = function(versionNumber) {
        /// <param name="versionNumber" type="Number"></param>
        /// <returns type="Version"></returns>
        if (idbdb || isBeingOpened) throw new $a71628d5883e1375$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new Version(versionNumber);
        versions.push(versionInstance);
        versions.sort(lowerVersionFirst);
        // Disable autoschema mode, as at least one version is specified.
        autoSchema = false;
        return versionInstance;
    };
    function Version(versionNumber) {
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
        this.stores({}); // Derive earlier schemas by default.
    }
    $a71628d5883e1375$var$extend(Version.prototype, {
        stores: function(stores) {
            /// <summary>
            ///   Defines the schema for a particular version
            /// </summary>
            /// <param name="stores" type="Object">
            /// Example: <br/>
            ///   {users: "id++,first,last,&amp;username,*email", <br/>
            ///   passwords: "id++,&amp;username"}<br/>
            /// <br/>
            /// Syntax: {Table: "[primaryKey][++],[&amp;][*]index1,[&amp;][*]index2,..."}<br/><br/>
            /// Special characters:<br/>
            ///  "&amp;"  means unique key, <br/>
            ///  "*"  means value is multiEntry, <br/>
            ///  "++" means auto-increment and only applicable for primary key <br/>
            /// </param>
            this._cfg.storesSource = this._cfg.storesSource ? $a71628d5883e1375$var$extend(this._cfg.storesSource, stores) : stores;
            // Derive stores from earlier versions if they are not explicitely specified as null or a new syntax.
            var storesSpec = {};
            versions.forEach(function(version) {
                $a71628d5883e1375$var$extend(storesSpec, version._cfg.storesSource);
            });
            var dbschema = this._cfg.dbschema = {};
            this._parseStoresSpec(storesSpec, dbschema);
            // Update the latest schema to this version
            // Update API
            globalSchema = db._dbSchema = dbschema;
            removeTablesApi([
                allTables,
                db,
                Transaction.prototype
            ]); // Keep Transaction.prototype even though it should be depr.
            setApiOnPlace([
                allTables,
                db,
                Transaction.prototype,
                this._cfg.tables
            ], $a71628d5883e1375$var$keys(dbschema), dbschema);
            dbStoreNames = $a71628d5883e1375$var$keys(dbschema);
            return this;
        },
        upgrade: function(upgradeFunction) {
            this._cfg.contentUpgrade = upgradeFunction;
            return this;
        },
        _parseStoresSpec: function(stores, outSchema) {
            $a71628d5883e1375$var$keys(stores).forEach(function(tableName) {
                if (stores[tableName] !== null) {
                    var instanceTemplate = {};
                    var indexes = parseIndexSyntax(stores[tableName]);
                    var primKey = indexes.shift();
                    if (primKey.multi) throw new $a71628d5883e1375$var$exceptions.Schema("Primary key cannot be multi-valued");
                    if (primKey.keyPath) $a71628d5883e1375$var$setByKeyPath(instanceTemplate, primKey.keyPath, primKey.auto ? 0 : primKey.keyPath);
                    indexes.forEach(function(idx) {
                        if (idx.auto) throw new $a71628d5883e1375$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                        if (!idx.keyPath) throw new $a71628d5883e1375$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                        $a71628d5883e1375$var$setByKeyPath(instanceTemplate, idx.keyPath, idx.compound ? idx.keyPath.map(function() {
                            return "";
                        }) : "");
                    });
                    outSchema[tableName] = new $a71628d5883e1375$var$TableSchema(tableName, primKey, indexes, instanceTemplate);
                }
            });
        }
    });
    function runUpgraders(oldVersion, idbtrans, reject) {
        var trans = db._createTransaction(READWRITE, dbStoreNames, globalSchema);
        trans.create(idbtrans);
        trans._completion.catch(reject);
        var rejectTransaction = trans._reject.bind(trans);
        $a71628d5883e1375$var$newScope(function() {
            $a71628d5883e1375$var$PSD.trans = trans;
            if (oldVersion === 0) {
                // Create tables:
                $a71628d5883e1375$var$keys(globalSchema).forEach(function(tableName) {
                    createTable(idbtrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
                });
                $a71628d5883e1375$var$Promise.follow(function() {
                    return db.on.populate.fire(trans);
                }).catch(rejectTransaction);
            } else updateTablesAndIndexes(oldVersion, trans, idbtrans).catch(rejectTransaction);
        });
    }
    function updateTablesAndIndexes(oldVersion, trans, idbtrans) {
        // Upgrade version to version, step-by-step from oldest to newest version.
        // Each transaction object will contain the table set that was current in that version (but also not-yet-deleted tables from its previous version)
        var queue = [];
        var oldVersionStruct = versions.filter(function(version) {
            return version._cfg.version === oldVersion;
        })[0];
        if (!oldVersionStruct) throw new $a71628d5883e1375$var$exceptions.Upgrade("Dexie specification of currently installed DB version is missing");
        globalSchema = db._dbSchema = oldVersionStruct._cfg.dbschema;
        var anyContentUpgraderHasRun = false;
        var versToRun = versions.filter(function(v) {
            return v._cfg.version > oldVersion;
        });
        versToRun.forEach(function(version) {
            /// <param name="version" type="Version"></param>
            queue.push(function() {
                var oldSchema = globalSchema;
                var newSchema = version._cfg.dbschema;
                adjustToExistingIndexNames(oldSchema, idbtrans);
                adjustToExistingIndexNames(newSchema, idbtrans);
                globalSchema = db._dbSchema = newSchema;
                var diff = getSchemaDiff(oldSchema, newSchema);
                // Add tables           
                diff.add.forEach(function(tuple) {
                    createTable(idbtrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
                });
                // Change tables
                diff.change.forEach(function(change) {
                    if (change.recreate) throw new $a71628d5883e1375$var$exceptions.Upgrade("Not yet support for changing primary key");
                    else {
                        var store = idbtrans.objectStore(change.name);
                        // Add indexes
                        change.add.forEach(function(idx) {
                            addIndex(store, idx);
                        });
                        // Update indexes
                        change.change.forEach(function(idx) {
                            store.deleteIndex(idx.name);
                            addIndex(store, idx);
                        });
                        // Delete indexes
                        change.del.forEach(function(idxName) {
                            store.deleteIndex(idxName);
                        });
                    }
                });
                if (version._cfg.contentUpgrade) {
                    anyContentUpgraderHasRun = true;
                    return $a71628d5883e1375$var$Promise.follow(function() {
                        version._cfg.contentUpgrade(trans);
                    });
                }
            });
            queue.push(function(idbtrans) {
                if (!anyContentUpgraderHasRun || !$a71628d5883e1375$var$hasIEDeleteObjectStoreBug) {
                    var newSchema = version._cfg.dbschema;
                    // Delete old tables
                    deleteRemovedTables(newSchema, idbtrans);
                }
            });
        });
        // Now, create a queue execution engine
        function runQueue() {
            return queue.length ? $a71628d5883e1375$var$Promise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $a71628d5883e1375$var$Promise.resolve();
        }
        return runQueue().then(function() {
            createMissingTables(globalSchema, idbtrans); // At last, make sure to create any missing tables. (Needed by addons that add stores to DB without specifying version)
        });
    }
    function getSchemaDiff(oldSchema, newSchema) {
        var diff = {
            del: [],
            add: [],
            change: [] // Array of {name: tableName, recreate: newDefinition, del: delIndexNames, add: newIndexDefs, change: changedIndexDefs}
        };
        for(var table in oldSchema)if (!newSchema[table]) diff.del.push(table);
        for(table in newSchema){
            var oldDef = oldSchema[table], newDef = newSchema[table];
            if (!oldDef) diff.add.push([
                table,
                newDef
            ]);
            else {
                var change = {
                    name: table,
                    def: newDef,
                    recreate: false,
                    del: [],
                    add: [],
                    change: []
                };
                if (oldDef.primKey.src !== newDef.primKey.src) {
                    // Primary key has changed. Remove and re-add table.
                    change.recreate = true;
                    diff.change.push(change);
                } else {
                    // Same primary key. Just find out what differs:
                    var oldIndexes = oldDef.idxByName;
                    var newIndexes = newDef.idxByName;
                    for(var idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                    for(idxName in newIndexes){
                        var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                        if (!oldIdx) change.add.push(newIdx);
                        else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                    }
                    if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
                }
            }
        }
        return diff;
    }
    function createTable(idbtrans, tableName, primKey, indexes) {
        /// <param name="idbtrans" type="IDBTransaction"></param>
        var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
            keyPath: primKey.keyPath,
            autoIncrement: primKey.auto
        } : {
            autoIncrement: primKey.auto
        });
        indexes.forEach(function(idx) {
            addIndex(store, idx);
        });
        return store;
    }
    function createMissingTables(newSchema, idbtrans) {
        $a71628d5883e1375$var$keys(newSchema).forEach(function(tableName) {
            if (!idbtrans.db.objectStoreNames.contains(tableName)) createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        });
    }
    function deleteRemovedTables(newSchema, idbtrans) {
        for(var i = 0; i < idbtrans.db.objectStoreNames.length; ++i){
            var storeName = idbtrans.db.objectStoreNames[i];
            if (newSchema[storeName] == null) idbtrans.db.deleteObjectStore(storeName);
        }
    }
    function addIndex(store, idx) {
        store.createIndex(idx.name, idx.keyPath, {
            unique: idx.unique,
            multiEntry: idx.multi
        });
    }
    //
    //
    //      Dexie Protected API
    //
    //
    this._allTables = allTables;
    this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
        return new Transaction(mode, storeNames, dbschema, parentTransaction);
    };
    /* Generate a temporary transaction when db operations are done outside a transaction scope.
    */ function tempTransaction(mode, storeNames, fn) {
        if (!openComplete && !$a71628d5883e1375$var$PSD.letThrough) {
            if (!isBeingOpened) {
                if (!autoOpen) return $a71628d5883e1375$var$rejection(new $a71628d5883e1375$var$exceptions.DatabaseClosed());
                db.open().catch($a71628d5883e1375$var$nop); // Open in background. If if fails, it will be catched by the final promise anyway.
            }
            return dbReadyPromise.then(function() {
                return tempTransaction(mode, storeNames, fn);
            });
        } else {
            var trans = db._createTransaction(mode, storeNames, globalSchema);
            try {
                trans.create();
            } catch (ex) {
                return $a71628d5883e1375$var$rejection(ex);
            }
            return trans._promise(mode, function(resolve, reject) {
                return $a71628d5883e1375$var$newScope(function() {
                    $a71628d5883e1375$var$PSD.trans = trans;
                    return fn(resolve, reject, trans);
                });
            }).then(function(result) {
                // Instead of resolving value directly, wait with resolving it until transaction has completed.
                // Otherwise the data would not be in the DB if requesting it in the then() operation.
                // Specifically, to ensure that the following expression will work:
                //
                //   db.friends.put({name: "Arne"}).then(function () {
                //       db.friends.where("name").equals("Arne").count(function(count) {
                //           assert (count === 1);
                //       });
                //   });
                //
                return trans._completion.then(function() {
                    return result;
                });
            }); /*.catch(err => { // Don't do this as of now. If would affect bulk- and modify methods in a way that could be more intuitive. But wait! Maybe change in next major.
                trans._reject(err);
                return rejection(err);
            });*/ 
        }
    }
    this._whenReady = function(fn) {
        return openComplete || $a71628d5883e1375$var$PSD.letThrough ? fn() : new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            if (!isBeingOpened) {
                if (!autoOpen) {
                    reject(new $a71628d5883e1375$var$exceptions.DatabaseClosed());
                    return;
                }
                db.open().catch($a71628d5883e1375$var$nop); // Open in background. If if fails, it will be catched by the final promise anyway.
            }
            dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    //
    //
    //
    //
    //      Dexie API
    //
    //
    //
    this.verno = 0;
    this.open = function() {
        if (isBeingOpened || idbdb) return dbReadyPromise.then(function() {
            return dbOpenError ? $a71628d5883e1375$var$rejection(dbOpenError) : db;
        });
        $a71628d5883e1375$var$debug && (openCanceller._stackHolder = $a71628d5883e1375$var$getErrorWithStack()); // Let stacks point to when open() was called rather than where new Dexie() was called.
        isBeingOpened = true;
        dbOpenError = null;
        openComplete = false;
        // Function pointers to call when the core opening process completes.
        var resolveDbReady = dbReadyResolve, // upgradeTransaction to abort on failure.
        upgradeTransaction = null;
        return $a71628d5883e1375$var$Promise.race([
            openCanceller,
            new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                // Multiply db.verno with 10 will be needed to workaround upgrading bug in IE:
                // IE fails when deleting objectStore after reading from it.
                // A future version of Dexie.js will stopover an intermediate version to workaround this.
                // At that point, we want to be backward compatible. Could have been multiplied with 2, but by using 10, it is easier to map the number to the real version number.
                // If no API, throw!
                if (!indexedDB) throw new $a71628d5883e1375$var$exceptions.MissingAPI("indexedDB API not found. If using IE10+, make sure to run your code on a server URL (not locally). If using old Safari versions, make sure to include indexedDB polyfill.");
                var req = autoSchema ? indexedDB.open(dbName) : indexedDB.open(dbName, Math.round(db.verno * 10));
                if (!req) throw new $a71628d5883e1375$var$exceptions.MissingAPI("IndexedDB API not available"); // May happen in Safari private mode, see https://github.com/dfahlander/Dexie.js/issues/134
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onblocked = $a71628d5883e1375$var$wrap(fireOnBlocked);
                req.onupgradeneeded = $a71628d5883e1375$var$wrap(function(e) {
                    upgradeTransaction = req.transaction;
                    if (autoSchema && !db._allowEmptyDB) {
                        // Caller did not specify a version or schema. Doing that is only acceptable for opening alread existing databases.
                        // If onupgradeneeded is called it means database did not exist. Reject the open() promise and make sure that we
                        // do not create a new database by accident here.
                        req.onerror = $a71628d5883e1375$var$preventDefault; // Prohibit onabort error from firing before we're done!
                        upgradeTransaction.abort(); // Abort transaction (would hope that this would make DB disappear but it doesnt.)
                        // Close database and delete it.
                        req.result.close();
                        var delreq = indexedDB.deleteDatabase(dbName); // The upgrade transaction is atomic, and javascript is single threaded - meaning that there is no risk that we delete someone elses database here!
                        delreq.onsuccess = delreq.onerror = $a71628d5883e1375$var$wrap(function() {
                            reject(new $a71628d5883e1375$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                        });
                    } else {
                        upgradeTransaction.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                        var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion; // Safari 8 fix.
                        runUpgraders(oldVer / 10, upgradeTransaction, reject, req);
                    }
                }, reject);
                req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    // Core opening procedure complete. Now let's just record some stuff.
                    upgradeTransaction = null;
                    idbdb = req.result;
                    $a71628d5883e1375$var$connections.push(db); // Used for emulating versionchange event on IE/Edge/Safari.
                    if (autoSchema) readGlobalSchema();
                    else if (idbdb.objectStoreNames.length > 0) try {
                        adjustToExistingIndexNames(globalSchema, idbdb.transaction($a71628d5883e1375$var$safariMultiStoreFix(idbdb.objectStoreNames), READONLY));
                    } catch (e) {
                    // Safari may bail out if > 1 store names. However, this shouldnt be a showstopper. Issue #120.
                    }
                    idbdb.onversionchange = $a71628d5883e1375$var$wrap(function(ev) {
                        db._vcFired = true; // detect implementations that not support versionchange (IE/Edge/Safari)
                        db.on("versionchange").fire(ev);
                    });
                    if (!hasNativeGetDatabaseNames && dbName !== '__dbnames') $a71628d5883e1375$var$dbNamesDB.dbnames.put({
                        name: dbName
                    }).catch($a71628d5883e1375$var$nop);
                    resolve();
                }, reject);
            })
        ]).then(function() {
            // Before finally resolving the dbReadyPromise and this promise,
            // call and await all on('ready') subscribers:
            // Dexie.vip() makes subscribers able to use the database while being opened.
            // This is a must since these subscribers take part of the opening procedure.
            onReadyBeingFired = [];
            return $a71628d5883e1375$var$Promise.resolve($a71628d5883e1375$var$Dexie.vip(db.on.ready.fire)).then(function fireRemainders() {
                if (onReadyBeingFired.length > 0) {
                    // In case additional subscribers to db.on('ready') were added during the time db.on.ready.fire was executed.
                    var remainders = onReadyBeingFired.reduce($a71628d5883e1375$var$promisableChain, $a71628d5883e1375$var$nop);
                    onReadyBeingFired = [];
                    return $a71628d5883e1375$var$Promise.resolve($a71628d5883e1375$var$Dexie.vip(remainders)).then(fireRemainders);
                }
            });
        }).finally(function() {
            onReadyBeingFired = null;
        }).then(function() {
            // Resolve the db.open() with the db instance.
            isBeingOpened = false;
            return db;
        }).catch(function(err) {
            try {
                // Did we fail within onupgradeneeded? Make sure to abort the upgrade transaction so it doesnt commit.
                upgradeTransaction && upgradeTransaction.abort();
            } catch (e) {}
            isBeingOpened = false; // Set before calling db.close() so that it doesnt reject openCanceller again (leads to unhandled rejection event).
            db.close(); // Closes and resets idbdb, removes connections, resets dbReadyPromise and openCanceller so that a later db.open() is fresh.
            // A call to db.close() may have made on-ready subscribers fail. Use dbOpenError if set, since err could be a follow-up error on that.
            dbOpenError = err; // Record the error. It will be used to reject further promises of db operations.
            return $a71628d5883e1375$var$rejection(dbOpenError);
        }).finally(function() {
            openComplete = true;
            resolveDbReady(); // dbReadyPromise is resolved no matter if open() rejects or resolved. It's just to wake up waiters.
        });
    };
    this.close = function() {
        var idx = $a71628d5883e1375$var$connections.indexOf(db);
        if (idx >= 0) $a71628d5883e1375$var$connections.splice(idx, 1);
        if (idbdb) {
            try {
                idbdb.close();
            } catch (e) {}
            idbdb = null;
        }
        autoOpen = false;
        dbOpenError = new $a71628d5883e1375$var$exceptions.DatabaseClosed();
        if (isBeingOpened) cancelOpen(dbOpenError);
        // Reset dbReadyPromise promise:
        dbReadyPromise = new $a71628d5883e1375$var$Promise(function(resolve) {
            dbReadyResolve = resolve;
        });
        openCanceller = new $a71628d5883e1375$var$Promise(function(_, reject) {
            cancelOpen = reject;
        });
    };
    this.delete = function() {
        var hasArguments = arguments.length > 0;
        return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            if (hasArguments) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (isBeingOpened) dbReadyPromise.then(doDelete);
            else doDelete();
            function doDelete() {
                db.close();
                var req = indexedDB.deleteDatabase(dbName);
                req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    if (!hasNativeGetDatabaseNames) $a71628d5883e1375$var$dbNamesDB.dbnames.delete(dbName).catch($a71628d5883e1375$var$nop);
                    resolve();
                });
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onblocked = fireOnBlocked;
            }
        });
    };
    this.backendDB = function() {
        return idbdb;
    };
    this.isOpen = function() {
        return idbdb !== null;
    };
    this.hasBeenClosed = function() {
        return dbOpenError && dbOpenError instanceof $a71628d5883e1375$var$exceptions.DatabaseClosed;
    };
    this.hasFailed = function() {
        return dbOpenError !== null;
    };
    this.dynamicallyOpened = function() {
        return autoSchema;
    };
    //
    // Properties
    //
    this.name = dbName;
    // db.tables - an array of all Table instances.
    $a71628d5883e1375$var$props(this, {
        tables: {
            get: function() {
                /// <returns type="Array" elementType="Table" />
                return $a71628d5883e1375$var$keys(allTables).map(function(name) {
                    return allTables[name];
                });
            }
        }
    });
    //
    // Events
    //
    this.on = $a71628d5883e1375$var$Events(this, "populate", "blocked", "versionchange", {
        ready: [
            $a71628d5883e1375$var$promisableChain,
            $a71628d5883e1375$var$nop
        ]
    });
    this.on.ready.subscribe = $a71628d5883e1375$var$override(this.on.ready.subscribe, function(subscribe) {
        return function(subscriber, bSticky) {
            $a71628d5883e1375$var$Dexie.vip(function() {
                if (openComplete) {
                    // Database already open. Call subscriber asap.
                    if (!dbOpenError) $a71628d5883e1375$var$Promise.resolve().then(subscriber);
                    // bSticky: Also subscribe to future open sucesses (after close / reopen) 
                    if (bSticky) subscribe(subscriber);
                } else if (onReadyBeingFired) {
                    // db.on('ready') subscribers are currently being executed and have not yet resolved or rejected
                    onReadyBeingFired.push(subscriber);
                    if (bSticky) subscribe(subscriber);
                } else {
                    // Database not yet open. Subscribe to it.
                    subscribe(subscriber);
                    // If bSticky is falsy, make sure to unsubscribe subscriber when fired once.
                    if (!bSticky) subscribe(function unsubscribe() {
                        db.on.ready.unsubscribe(subscriber);
                        db.on.ready.unsubscribe(unsubscribe);
                    });
                }
            });
        };
    });
    this.transaction = function() {
        /// <summary>
        ///
        /// </summary>
        /// <param name="mode" type="String">"r" for readonly, or "rw" for readwrite</param>
        /// <param name="tableInstances">Table instance, Array of Table instances, String or String Array of object stores to include in the transaction</param>
        /// <param name="scopeFunc" type="Function">Function to execute with transaction</param>
        var args = extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
        // Let table arguments be all arguments between mode and last argument.
        var i = arguments.length;
        if (i < 2) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Too few arguments");
        // Prevent optimzation killer (https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments)
        // and clone arguments except the first one into local var 'args'.
        var args = new Array(i - 1);
        while(--i)args[i - 1] = arguments[i];
        // Let scopeFunc be the last argument and pop it so that args now only contain the table arguments.
        scopeFunc = args.pop();
        var tables = $a71628d5883e1375$var$flatten(args); // Support using array as middle argument, or a mix of arrays and non-arrays.
        return [
            mode,
            tables,
            scopeFunc
        ];
    }
    this._transaction = function(mode, tables, scopeFunc) {
        var parentTransaction = $a71628d5883e1375$var$PSD.trans;
        // Check if parent transactions is bound to this db instance, and if caller wants to reuse it
        if (!parentTransaction || parentTransaction.db !== db || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', ''); // Ok. Will change arguments[0] as well but we wont touch arguments henceforth.
        try {
            //
            // Get storeNames from arguments. Either through given table instances, or through given table names.
            //
            var storeNames = tables.map(function(table) {
                var storeName = table instanceof Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            //
            // Resolve mode. Allow shortcuts "r" and "rw".
            //
            if (mode == "r" || mode == READONLY) mode = READONLY;
            else if (mode == "rw" || mode == READWRITE) mode = READWRITE;
            else throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                // Basic checks
                if (parentTransaction.mode === READONLY && mode === READWRITE) {
                    if (onlyIfCompatible) // Spawn new transaction instead.
                    parentTransaction = null;
                    else throw new $a71628d5883e1375$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) // Spawn new transaction instead.
                        parentTransaction = null;
                        else throw new $a71628d5883e1375$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) // '?' mode should not keep using an inactive transaction.
                parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $a71628d5883e1375$var$rejection(e);
        }
        // If this is a sub-transaction, lock the parent and then launch the sub-transaction.
        return parentTransaction ? parentTransaction._promise(mode, enterTransactionScope, "lock") : $a71628d5883e1375$var$PSD.trans ? // no parent transaction despite PSD.trans exists. Make sure also
        // that the zone we create is not a sub-zone of current, because
        // Promise.follow() should not wait for it if so.
        $a71628d5883e1375$var$usePSD($a71628d5883e1375$var$PSD.transless, function() {
            return db._whenReady(enterTransactionScope);
        }) : db._whenReady(enterTransactionScope);
        function enterTransactionScope() {
            return $a71628d5883e1375$var$Promise.resolve().then(function() {
                // Keep a pointer to last non-transactional PSD to use if someone calls Dexie.ignoreTransaction().
                var transless = $a71628d5883e1375$var$PSD.transless || $a71628d5883e1375$var$PSD;
                // Our transaction.
                //return new Promise((resolve, reject) => {
                var trans = db._createTransaction(mode, storeNames, globalSchema, parentTransaction);
                // Let the transaction instance be part of a Promise-specific data (PSD) value.
                var zoneProps = {
                    trans: trans,
                    transless: transless
                };
                if (parentTransaction) // Emulate transaction commit awareness for inner transaction (must 'commit' when the inner transaction has no more operations ongoing)
                trans.idbtrans = parentTransaction.idbtrans;
                else trans.create(); // Create the backend transaction so that complete() or error() will trigger even if no operation is made upon it.
                // Support for native async await.
                if (scopeFunc.constructor === $a71628d5883e1375$var$AsyncFunction) $a71628d5883e1375$var$incrementExpectedAwaits();
                var returnValue;
                var promiseFollowed = $a71628d5883e1375$var$Promise.follow(function() {
                    // Finally, call the scope function with our table and transaction arguments.
                    returnValue = scopeFunc.call(trans, trans);
                    if (returnValue) {
                        if (returnValue.constructor === $a71628d5883e1375$var$NativePromise) {
                            var decrementor = $a71628d5883e1375$var$decrementExpectedAwaits.bind(null, null);
                            returnValue.then(decrementor, decrementor);
                        } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') // scopeFunc returned an iterator with throw-support. Handle yield as await.
                        returnValue = $a71628d5883e1375$var$awaitIterator(returnValue);
                    }
                }, zoneProps);
                return (returnValue && typeof returnValue.then === 'function' ? // Promise returned. User uses promise-style transactions.
                $a71628d5883e1375$var$Promise.resolve(returnValue).then(function(x) {
                    return trans.active ? x // Transaction still active. Continue.
                     : $a71628d5883e1375$var$rejection(new $a71628d5883e1375$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
                }) : promiseFollowed.then(function() {
                    return returnValue;
                })).then(function(x) {
                    // sub transactions don't react to idbtrans.oncomplete. We must trigger a completion:
                    if (parentTransaction) trans._resolve();
                    // wait for trans._completion
                    // (if root transaction, this means 'complete' event. If sub-transaction, we've just fired it ourselves)
                    return trans._completion.then(function() {
                        return x;
                    });
                }).catch(function(e) {
                    trans._reject(e); // Yes, above then-handler were maybe not called because of an unhandled rejection in scopeFunc!
                    return $a71628d5883e1375$var$rejection(e);
                });
            });
        }
    };
    this.table = function(tableName) {
        /// <returns type="Table"></returns>
        if (!$a71628d5883e1375$var$hasOwn(allTables, tableName)) throw new $a71628d5883e1375$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return allTables[tableName];
    };
    //
    //
    //
    // Table Class
    //
    //
    //
    function Table(name, tableSchema, optionalTrans) {
        /// <param name="name" type="String"></param>
        this.name = name;
        this.schema = tableSchema;
        this._tx = optionalTrans;
        this.hook = allTables[name] ? allTables[name].hook : $a71628d5883e1375$var$Events(null, {
            "creating": [
                $a71628d5883e1375$var$hookCreatingChain,
                $a71628d5883e1375$var$nop
            ],
            "reading": [
                $a71628d5883e1375$var$pureFunctionChain,
                $a71628d5883e1375$var$mirror
            ],
            "updating": [
                $a71628d5883e1375$var$hookUpdatingChain,
                $a71628d5883e1375$var$nop
            ],
            "deleting": [
                $a71628d5883e1375$var$hookDeletingChain,
                $a71628d5883e1375$var$nop
            ]
        });
    }
    function BulkErrorHandlerCatchAll(errorList, done, supportHooks) {
        return (supportHooks ? $a71628d5883e1375$var$hookedEventRejectHandler : $a71628d5883e1375$var$eventRejectHandler)(function(e) {
            errorList.push(e);
            done && done();
        });
    }
    function bulkDelete(idbstore, trans, keysOrTuples, hasDeleteHook, deletingHook) {
        // If hasDeleteHook, keysOrTuples must be an array of tuples: [[key1, value2],[key2,value2],...],
        // else keysOrTuples must be just an array of keys: [key1, key2, ...].
        return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            var len = keysOrTuples.length, lastItem = len - 1;
            if (len === 0) return resolve();
            if (!hasDeleteHook) for(var i = 0; i < len; ++i){
                var req = idbstore.delete(keysOrTuples[i]);
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                if (i === lastItem) req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    return resolve();
                });
            }
            else {
                var hookCtx, errorHandler = $a71628d5883e1375$var$hookedEventRejectHandler(reject), successHandler = $a71628d5883e1375$var$hookedEventSuccessHandler(null);
                $a71628d5883e1375$var$tryCatch(function() {
                    for(var i = 0; i < len; ++i){
                        hookCtx = {
                            onsuccess: null,
                            onerror: null
                        };
                        var tuple = keysOrTuples[i];
                        deletingHook.call(hookCtx, tuple[0], tuple[1], trans);
                        var req = idbstore.delete(tuple[0]);
                        req._hookCtx = hookCtx;
                        req.onerror = errorHandler;
                        if (i === lastItem) req.onsuccess = $a71628d5883e1375$var$hookedEventSuccessHandler(resolve);
                        else req.onsuccess = successHandler;
                    }
                }, function(err) {
                    hookCtx.onerror && hookCtx.onerror(err);
                    throw err;
                });
            }
        });
    }
    $a71628d5883e1375$var$props(Table.prototype, {
        //
        // Table Protected Methods
        //
        _trans: function getTransaction(mode, fn, writeLocked) {
            var trans = this._tx || $a71628d5883e1375$var$PSD.trans;
            return trans && trans.db === db ? trans === $a71628d5883e1375$var$PSD.trans ? trans._promise(mode, fn, writeLocked) : $a71628d5883e1375$var$newScope(function() {
                return trans._promise(mode, fn, writeLocked);
            }, {
                trans: trans,
                transless: $a71628d5883e1375$var$PSD.transless || $a71628d5883e1375$var$PSD
            }) : tempTransaction(mode, [
                this.name
            ], fn);
        },
        _idbstore: function getIDBObjectStore(mode, fn, writeLocked) {
            var tableName = this.name;
            function supplyIdbStore(resolve, reject, trans) {
                if (trans.storeNames.indexOf(tableName) === -1) throw new $a71628d5883e1375$var$exceptions.NotFound("Table" + tableName + " not part of transaction");
                return fn(resolve, reject, trans.idbtrans.objectStore(tableName), trans);
            }
            return this._trans(mode, supplyIdbStore, writeLocked);
        },
        //
        // Table Public Methods
        //
        get: function(keyOrCrit, cb) {
            if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
            var self1 = this;
            return this._idbstore(READONLY, function(resolve, reject, idbstore) {
                var req = idbstore.get(keyOrCrit);
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    resolve(self1.hook.reading.fire(req.result));
                }, reject);
            }).then(cb);
        },
        where: function(indexOrCrit) {
            if (typeof indexOrCrit === 'string') return new WhereClause(this, indexOrCrit);
            if ($a71628d5883e1375$var$isArray(indexOrCrit)) return new WhereClause(this, "[" + indexOrCrit.join('+') + "]");
            // indexOrCrit is an object map of {[keyPath]:value} 
            var keyPaths = $a71628d5883e1375$var$keys(indexOrCrit);
            if (keyPaths.length === 1) // Only one critera. This was the easy case:
            return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
            // Multiple criterias.
            // Let's try finding a compound index that matches all keyPaths in
            // arbritary order:
            var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
                return ix.compound && keyPaths.every(function(keyPath) {
                    return ix.keyPath.indexOf(keyPath) >= 0;
                }) && ix.keyPath.every(function(keyPath) {
                    return keyPaths.indexOf(keyPath) >= 0;
                });
            })[0];
            if (compoundIndex && $a71628d5883e1375$var$maxKey !== $a71628d5883e1375$var$maxString) // Cool! We found such compound index
            // and this browser supports compound indexes (maxKey !== maxString)!
            return this.where(compoundIndex.name).equals(compoundIndex.keyPath.map(function(kp) {
                return indexOrCrit[kp];
            }));
            if (!compoundIndex) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join('+') + "]"));
            // Ok, now let's fallback to finding at least one matching index
            // and filter the rest.
            var idxByName = this.schema.idxByName;
            var simpleIndex = keyPaths.reduce(function(r, keyPath) {
                return [
                    r[0] || idxByName[keyPath],
                    r[0] || !idxByName[keyPath] ? combine(r[1], function(x) {
                        return '' + $a71628d5883e1375$var$getByKeyPath(x, keyPath) == '' + indexOrCrit[keyPath];
                    }) : r[1]
                ];
            }, [
                null,
                null
            ]);
            var idx = simpleIndex[0];
            return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(simpleIndex[1]) : compoundIndex ? this.filter(simpleIndex[1]) : this.where(keyPaths).equals(''); // No index at all. Fail lazily.
        },
        count: function(cb) {
            return this.toCollection().count(cb);
        },
        offset: function(offset) {
            return this.toCollection().offset(offset);
        },
        limit: function(numRows) {
            return this.toCollection().limit(numRows);
        },
        reverse: function() {
            return this.toCollection().reverse();
        },
        filter: function(filterFunction) {
            return this.toCollection().and(filterFunction);
        },
        each: function(fn) {
            return this.toCollection().each(fn);
        },
        toArray: function(cb) {
            return this.toCollection().toArray(cb);
        },
        orderBy: function(index) {
            return new Collection(new WhereClause(this, $a71628d5883e1375$var$isArray(index) ? "[" + index.join('+') + "]" : index));
        },
        toCollection: function() {
            return new Collection(new WhereClause(this));
        },
        mapToClass: function(constructor, structure) {
            /// <summary>
            ///     Map table to a javascript constructor function. Objects returned from the database will be instances of this class, making
            ///     it possible to the instanceOf operator as well as extending the class using constructor.prototype.method = function(){...}.
            /// </summary>
            /// <param name="constructor">Constructor function representing the class.</param>
            /// <param name="structure" optional="true">Helps IDE code completion by knowing the members that objects contain and not just the indexes. Also
            /// know what type each member has. Example: {name: String, emailAddresses: [String], password}</param>
            this.schema.mappedClass = constructor;
            var instanceTemplate = Object.create(constructor.prototype);
            if (structure) // structure and instanceTemplate is for IDE code competion only while constructor.prototype is for actual inheritance.
            $a71628d5883e1375$var$applyStructure(instanceTemplate, structure);
            this.schema.instanceTemplate = instanceTemplate;
            // Now, subscribe to the when("reading") event to make all objects that come out from this table inherit from given class
            // no matter which method to use for reading (Table.get() or Table.where(...)... )
            var readHook = function(obj) {
                if (!obj) return obj; // No valid object. (Value is null). Return as is.
                // Create a new object that derives from constructor:
                var res = Object.create(constructor.prototype);
                // Clone members:
                for(var m in obj)if ($a71628d5883e1375$var$hasOwn(obj, m)) try {
                    res[m] = obj[m];
                } catch (_) {}
                return res;
            };
            if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
            this.schema.readHook = readHook;
            this.hook("reading", readHook);
            return constructor;
        },
        defineClass: function(structure) {
            /// <summary>
            ///     Define all members of the class that represents the table. This will help code completion of when objects are read from the database
            ///     as well as making it possible to extend the prototype of the returned constructor function.
            /// </summary>
            /// <param name="structure">Helps IDE code completion by knowing the members that objects contain and not just the indexes. Also
            /// know what type each member has. Example: {name: String, emailAddresses: [String], properties: {shoeSize: Number}}</param>
            return this.mapToClass($a71628d5883e1375$var$Dexie.defineClass(structure), structure);
        },
        bulkDelete: function(keys$$1) {
            if (this.hook.deleting.fire === $a71628d5883e1375$var$nop) return this._idbstore(READWRITE, function(resolve, reject, idbstore, trans) {
                resolve(bulkDelete(idbstore, trans, keys$$1, false, $a71628d5883e1375$var$nop));
            });
            else return this.where(':id').anyOf(keys$$1).delete().then(function() {}); // Resolve with undefined.
        },
        bulkPut: function(objects, keys$$1) {
            var _this = this;
            return this._idbstore(READWRITE, function(resolve, reject, idbstore) {
                if (!idbstore.keyPath && !_this.schema.primKey.auto && !keys$$1) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("bulkPut() with non-inbound keys requires keys array in second argument");
                if (idbstore.keyPath && keys$$1) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
                if (keys$$1 && keys$$1.length !== objects.length) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                if (objects.length === 0) return resolve(); // Caller provided empty list.
                var done = function(result) {
                    if (errorList.length === 0) resolve(result);
                    else reject(new $a71628d5883e1375$var$BulkError(_this.name + ".bulkPut(): " + errorList.length + " of " + numObjs + " operations failed", errorList));
                };
                var req, errorList = [], errorHandler, numObjs = objects.length, table = _this;
                if (_this.hook.creating.fire === $a71628d5883e1375$var$nop && _this.hook.updating.fire === $a71628d5883e1375$var$nop) {
                    //
                    // Standard Bulk (no 'creating' or 'updating' hooks to care about)
                    //
                    errorHandler = BulkErrorHandlerCatchAll(errorList);
                    for(var i = 0, l = objects.length; i < l; ++i){
                        req = keys$$1 ? idbstore.put(objects[i], keys$$1[i]) : idbstore.put(objects[i]);
                        req.onerror = errorHandler;
                    }
                    // Only need to catch success or error on the last operation
                    // according to the IDB spec.
                    req.onerror = BulkErrorHandlerCatchAll(errorList, done);
                    req.onsuccess = $a71628d5883e1375$var$eventSuccessHandler(done);
                } else {
                    var effectiveKeys = keys$$1 || idbstore.keyPath && objects.map(function(o) {
                        return $a71628d5883e1375$var$getByKeyPath(o, idbstore.keyPath);
                    });
                    // Generate map of {[key]: object}
                    var objectLookup = effectiveKeys && $a71628d5883e1375$var$arrayToObject(effectiveKeys, function(key, i) {
                        return key != null && [
                            key,
                            objects[i]
                        ];
                    });
                    var promise = !effectiveKeys ? // Auto-incremented key-less objects only without any keys argument.
                    table.bulkAdd(objects) : // Keys provided. Either as inbound in provided objects, or as a keys argument.
                    // Begin with updating those that exists in DB:
                    table.where(':id').anyOf(effectiveKeys.filter(function(key) {
                        return key != null;
                    })).modify(function() {
                        this.value = objectLookup[this.primKey];
                        objectLookup[this.primKey] = null; // Mark as "don't add this"
                    }).catch($a71628d5883e1375$var$ModifyError, function(e) {
                        errorList = e.failures; // No need to concat here. These are the first errors added.
                    }).then(function() {
                        // Now, let's examine which items didnt exist so we can add them:
                        var objsToAdd = [], keysToAdd = keys$$1 && [];
                        // Iterate backwards. Why? Because if same key was used twice, just add the last one.
                        for(var i = effectiveKeys.length - 1; i >= 0; --i){
                            var key = effectiveKeys[i];
                            if (key == null || objectLookup[key]) {
                                objsToAdd.push(objects[i]);
                                keys$$1 && keysToAdd.push(key);
                                if (key != null) objectLookup[key] = null; // Mark as "dont add again"
                            }
                        }
                        // The items are in reverse order so reverse them before adding.
                        // Could be important in order to get auto-incremented keys the way the caller
                        // would expect. Could have used unshift instead of push()/reverse(),
                        // but: http://jsperf.com/unshift-vs-reverse
                        objsToAdd.reverse();
                        keys$$1 && keysToAdd.reverse();
                        return table.bulkAdd(objsToAdd, keysToAdd);
                    }).then(function(lastAddedKey) {
                        // Resolve with key of the last object in given arguments to bulkPut():
                        var lastEffectiveKey = effectiveKeys[effectiveKeys.length - 1]; // Key was provided.
                        return lastEffectiveKey != null ? lastEffectiveKey : lastAddedKey;
                    });
                    promise.then(done).catch($a71628d5883e1375$var$BulkError, function(e) {
                        // Concat failure from ModifyError and reject using our 'done' method.
                        errorList = errorList.concat(e.failures);
                        done();
                    }).catch(reject);
                }
            }, "locked"); // If called from transaction scope, lock transaction til all steps are done.
        },
        bulkAdd: function(objects, keys$$1) {
            var self1 = this, creatingHook = this.hook.creating.fire;
            return this._idbstore(READWRITE, function(resolve, reject, idbstore, trans) {
                if (!idbstore.keyPath && !self1.schema.primKey.auto && !keys$$1) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("bulkAdd() with non-inbound keys requires keys array in second argument");
                if (idbstore.keyPath && keys$$1) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
                if (keys$$1 && keys$$1.length !== objects.length) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                if (objects.length === 0) return resolve(); // Caller provided empty list.
                function done(result) {
                    if (errorList.length === 0) resolve(result);
                    else reject(new $a71628d5883e1375$var$BulkError(self1.name + ".bulkAdd(): " + errorList.length + " of " + numObjs + " operations failed", errorList));
                }
                var req, errorList = [], errorHandler, successHandler, numObjs = objects.length;
                if (creatingHook !== $a71628d5883e1375$var$nop) {
                    //
                    // There are subscribers to hook('creating')
                    // Must behave as documented.
                    //
                    var keyPath = idbstore.keyPath, hookCtx;
                    errorHandler = BulkErrorHandlerCatchAll(errorList, null, true);
                    successHandler = $a71628d5883e1375$var$hookedEventSuccessHandler(null);
                    $a71628d5883e1375$var$tryCatch(function() {
                        for(var i = 0, l = objects.length; i < l; ++i){
                            hookCtx = {
                                onerror: null,
                                onsuccess: null
                            };
                            var key = keys$$1 && keys$$1[i];
                            var obj = objects[i], effectiveKey = keys$$1 ? key : keyPath ? $a71628d5883e1375$var$getByKeyPath(obj, keyPath) : undefined, keyToUse = creatingHook.call(hookCtx, effectiveKey, obj, trans);
                            if (effectiveKey == null && keyToUse != null) {
                                if (keyPath) {
                                    obj = $a71628d5883e1375$var$deepClone(obj);
                                    $a71628d5883e1375$var$setByKeyPath(obj, keyPath, keyToUse);
                                } else key = keyToUse;
                            }
                            req = key != null ? idbstore.add(obj, key) : idbstore.add(obj);
                            req._hookCtx = hookCtx;
                            if (i < l - 1) {
                                req.onerror = errorHandler;
                                if (hookCtx.onsuccess) req.onsuccess = successHandler;
                            }
                        }
                    }, function(err) {
                        hookCtx.onerror && hookCtx.onerror(err);
                        throw err;
                    });
                    req.onerror = BulkErrorHandlerCatchAll(errorList, done, true);
                    req.onsuccess = $a71628d5883e1375$var$hookedEventSuccessHandler(done);
                } else {
                    //
                    // Standard Bulk (no 'creating' hook to care about)
                    //
                    errorHandler = BulkErrorHandlerCatchAll(errorList);
                    for(var i = 0, l = objects.length; i < l; ++i){
                        req = keys$$1 ? idbstore.add(objects[i], keys$$1[i]) : idbstore.add(objects[i]);
                        req.onerror = errorHandler;
                    }
                    // Only need to catch success or error on the last operation
                    // according to the IDB spec.
                    req.onerror = BulkErrorHandlerCatchAll(errorList, done);
                    req.onsuccess = $a71628d5883e1375$var$eventSuccessHandler(done);
                }
            });
        },
        add: function(obj, key) {
            /// <summary>
            ///   Add an object to the database. In case an object with same primary key already exists, the object will not be added.
            /// </summary>
            /// <param name="obj" type="Object">A javascript object to insert</param>
            /// <param name="key" optional="true">Primary key</param>
            var creatingHook = this.hook.creating.fire;
            return this._idbstore(READWRITE, function(resolve, reject, idbstore, trans) {
                var hookCtx = {
                    onsuccess: null,
                    onerror: null
                };
                if (creatingHook !== $a71628d5883e1375$var$nop) {
                    var effectiveKey = key != null ? key : idbstore.keyPath ? $a71628d5883e1375$var$getByKeyPath(obj, idbstore.keyPath) : undefined;
                    var keyToUse = creatingHook.call(hookCtx, effectiveKey, obj, trans); // Allow subscribers to when("creating") to generate the key.
                    if (effectiveKey == null && keyToUse != null) {
                        if (idbstore.keyPath) $a71628d5883e1375$var$setByKeyPath(obj, idbstore.keyPath, keyToUse);
                        else key = keyToUse;
                    }
                }
                try {
                    var req = key != null ? idbstore.add(obj, key) : idbstore.add(obj);
                    req._hookCtx = hookCtx;
                    req.onerror = $a71628d5883e1375$var$hookedEventRejectHandler(reject);
                    req.onsuccess = $a71628d5883e1375$var$hookedEventSuccessHandler(function(result) {
                        // TODO: Remove these two lines in next major release (2.0?)
                        // It's no good practice to have side effects on provided parameters
                        var keyPath = idbstore.keyPath;
                        if (keyPath) $a71628d5883e1375$var$setByKeyPath(obj, keyPath, result);
                        resolve(result);
                    });
                } catch (e) {
                    if (hookCtx.onerror) hookCtx.onerror(e);
                    throw e;
                }
            });
        },
        put: function(obj, key) {
            var _this = this;
            /// <summary>
            ///   Add an object to the database but in case an object with same primary key alread exists, the existing one will get updated.
            /// </summary>
            /// <param name="obj" type="Object">A javascript object to insert or update</param>
            /// <param name="key" optional="true">Primary key</param>
            var creatingHook = this.hook.creating.fire, updatingHook = this.hook.updating.fire;
            if (creatingHook !== $a71628d5883e1375$var$nop || updatingHook !== $a71628d5883e1375$var$nop) {
                //
                // People listens to when("creating") or when("updating") events!
                // We must know whether the put operation results in an CREATE or UPDATE.
                //
                var keyPath = this.schema.primKey.keyPath;
                var effectiveKey = key !== undefined ? key : keyPath && $a71628d5883e1375$var$getByKeyPath(obj, keyPath);
                if (effectiveKey == null) return this.add(obj);
                // Since key is optional, make sure we get it from obj if not provided
                // Primary key exist. Lock transaction and try modifying existing. If nothing modified, call add().
                // clone obj before this async call. If caller modifies obj the line after put(), the IDB spec requires that it should not affect operation.
                obj = $a71628d5883e1375$var$deepClone(obj);
                return this._trans(READWRITE, function() {
                    return _this.where(":id").equals(effectiveKey).modify(function() {
                        // Replace extisting value with our object
                        // CRUD event firing handled in Collection.modify()
                        this.value = obj;
                    }).then(function(count) {
                        return count === 0 ? _this.add(obj, key) : effectiveKey;
                    });
                }, "locked"); // Lock needed because operation is splitted into modify() and add().
            } else // Use the standard IDB put() method.
            return this._idbstore(READWRITE, function(resolve, reject, idbstore) {
                var req = key !== undefined ? idbstore.put(obj, key) : idbstore.put(obj);
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onsuccess = $a71628d5883e1375$var$wrap(function(ev) {
                    var keyPath = idbstore.keyPath;
                    if (keyPath) $a71628d5883e1375$var$setByKeyPath(obj, keyPath, ev.target.result);
                    resolve(req.result);
                });
            });
        },
        'delete': function(key) {
            /// <param name="key">Primary key of the object to delete</param>
            if (this.hook.deleting.subscribers.length) // People listens to when("deleting") event. Must implement delete using Collection.delete() that will
            // call the CRUD event. Only Collection.delete() will know whether an object was actually deleted.
            return this.where(":id").equals(key).delete();
            else // No one listens. Use standard IDB delete() method.
            return this._idbstore(READWRITE, function(resolve, reject, idbstore) {
                var req = idbstore.delete(key);
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    resolve(req.result);
                });
            });
        },
        clear: function() {
            if (this.hook.deleting.subscribers.length) // People listens to when("deleting") event. Must implement delete using Collection.delete() that will
            // call the CRUD event. Only Collection.delete() will knows which objects that are actually deleted.
            return this.toCollection().delete();
            else return this._idbstore(READWRITE, function(resolve, reject, idbstore) {
                var req = idbstore.clear();
                req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                req.onsuccess = $a71628d5883e1375$var$wrap(function() {
                    resolve(req.result);
                });
            });
        },
        update: function(keyOrObject, modifications) {
            if (typeof modifications !== 'object' || $a71628d5883e1375$var$isArray(modifications)) throw new $a71628d5883e1375$var$exceptions.InvalidArgument("Modifications must be an object.");
            if (typeof keyOrObject === 'object' && !$a71628d5883e1375$var$isArray(keyOrObject)) {
                // object to modify. Also modify given object with the modifications:
                $a71628d5883e1375$var$keys(modifications).forEach(function(keyPath) {
                    $a71628d5883e1375$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                var key = $a71628d5883e1375$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
                if (key === undefined) return $a71628d5883e1375$var$rejection(new $a71628d5883e1375$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
                return this.where(":id").equals(key).modify(modifications);
            } else // key to modify
            return this.where(":id").equals(keyOrObject).modify(modifications);
        }
    });
    //
    //
    //
    // Transaction Class
    //
    //
    //
    function Transaction(mode, storeNames, dbschema, parent) {
        var _this = this;
        /// <summary>
        ///    Transaction class. Represents a database transaction. All operations on db goes through a Transaction.
        /// </summary>
        /// <param name="mode" type="String">Any of "readwrite" or "readonly"</param>
        /// <param name="storeNames" type="Array">Array of table names to operate on</param>
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.idbtrans = null;
        this.on = $a71628d5883e1375$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0; // Just for debugging waitFor()
        this._completion = new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $a71628d5883e1375$var$rejection(e); // Indicate we actually DO NOT catch this error.
        });
    }
    $a71628d5883e1375$var$props(Transaction.prototype, {
        //
        // Transaction Protected Methods (not required by API users, but needed internally and eventually by dexie extensions)
        //
        _lock: function() {
            $a71628d5883e1375$var$assert(!$a71628d5883e1375$var$PSD.global); // Locking and unlocking reuires to be within a PSD scope.
            // Temporary set all requests into a pending queue if they are called before database is ready.
            ++this._reculock; // Recursive read/write lock pattern using PSD (Promise Specific Data) instead of TLS (Thread Local Storage)
            if (this._reculock === 1 && !$a71628d5883e1375$var$PSD.global) $a71628d5883e1375$var$PSD.lockOwnerFor = this;
            return this;
        },
        _unlock: function() {
            $a71628d5883e1375$var$assert(!$a71628d5883e1375$var$PSD.global); // Locking and unlocking reuires to be within a PSD scope.
            if (--this._reculock === 0) {
                if (!$a71628d5883e1375$var$PSD.global) $a71628d5883e1375$var$PSD.lockOwnerFor = null;
                while(this._blockedFuncs.length > 0 && !this._locked()){
                    var fnAndPSD = this._blockedFuncs.shift();
                    try {
                        $a71628d5883e1375$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                    } catch (e) {}
                }
            }
            return this;
        },
        _locked: function() {
            // Checks if any write-lock is applied on this transaction.
            // To simplify the Dexie API for extension implementations, we support recursive locks.
            // This is accomplished by using "Promise Specific Data" (PSD).
            // PSD data is bound to a Promise and any child Promise emitted through then() or resolve( new Promise() ).
            // PSD is local to code executing on top of the call stacks of any of any code executed by Promise():
            //         * callback given to the Promise() constructor  (function (resolve, reject){...})
            //         * callbacks given to then()/catch()/finally() methods (function (value){...})
            // If creating a new independant Promise instance from within a Promise call stack, the new Promise will derive the PSD from the call stack of the parent Promise.
            // Derivation is done so that the inner PSD __proto__ points to the outer PSD.
            // PSD.lockOwnerFor will point to current transaction object if the currently executing PSD scope owns the lock.
            return this._reculock && $a71628d5883e1375$var$PSD.lockOwnerFor !== this;
        },
        create: function(idbtrans) {
            var _this = this;
            if (!this.mode) return this;
            $a71628d5883e1375$var$assert(!this.idbtrans);
            if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
                case "DatabaseClosedError":
                    // Errors where it is no difference whether it was caused by the user operation or an earlier call to db.open()
                    throw new $a71628d5883e1375$var$exceptions.DatabaseClosed(dbOpenError);
                case "MissingAPIError":
                    // Errors where it is no difference whether it was caused by the user operation or an earlier call to db.open()
                    throw new $a71628d5883e1375$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
                default:
                    // Make it clear that the user operation was not what caused the error - the error had occurred earlier on db.open()!
                    throw new $a71628d5883e1375$var$exceptions.OpenFailed(dbOpenError);
            }
            if (!this.active) throw new $a71628d5883e1375$var$exceptions.TransactionInactive();
            $a71628d5883e1375$var$assert(this._completion._state === null);
            idbtrans = this.idbtrans = idbtrans || idbdb.transaction($a71628d5883e1375$var$safariMultiStoreFix(this.storeNames), this.mode);
            idbtrans.onerror = $a71628d5883e1375$var$wrap(function(ev) {
                $a71628d5883e1375$var$preventDefault(ev); // Prohibit default bubbling to window.error
                _this._reject(idbtrans.error);
            });
            idbtrans.onabort = $a71628d5883e1375$var$wrap(function(ev) {
                $a71628d5883e1375$var$preventDefault(ev);
                _this.active && _this._reject(new $a71628d5883e1375$var$exceptions.Abort(idbtrans.error));
                _this.active = false;
                _this.on("abort").fire(ev);
            });
            idbtrans.oncomplete = $a71628d5883e1375$var$wrap(function() {
                _this.active = false;
                _this._resolve();
            });
            return this;
        },
        _promise: function(mode, fn, bWriteLock) {
            var _this = this;
            if (mode === READWRITE && this.mode !== READWRITE) return $a71628d5883e1375$var$rejection(new $a71628d5883e1375$var$exceptions.ReadOnly("Transaction is readonly"));
            if (!this.active) return $a71628d5883e1375$var$rejection(new $a71628d5883e1375$var$exceptions.TransactionInactive());
            if (this._locked()) return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                _this._blockedFuncs.push([
                    function() {
                        _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                    },
                    $a71628d5883e1375$var$PSD
                ]);
            });
            else if (bWriteLock) return $a71628d5883e1375$var$newScope(function() {
                var p = new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                    _this._lock();
                    var rv = fn(resolve, reject, _this);
                    if (rv && rv.then) rv.then(resolve, reject);
                });
                p.finally(function() {
                    return _this._unlock();
                });
                p._lib = true;
                return p;
            });
            else {
                var p = new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                    var rv = fn(resolve, reject, _this);
                    if (rv && rv.then) rv.then(resolve, reject);
                });
                p._lib = true;
                return p;
            }
        },
        _root: function() {
            return this.parent ? this.parent._root() : this;
        },
        waitFor: function(promise) {
            // Always operate on the root transaction (in case this is a sub stransaction)
            var root = this._root();
            // For stability reasons, convert parameter to promise no matter what type is passed to waitFor().
            // (We must be able to call .then() on it.)
            promise = $a71628d5883e1375$var$Promise.resolve(promise);
            if (root._waitingFor) // Already called waitFor(). Wait for both to complete.
            root._waitingFor = root._waitingFor.then(function() {
                return promise;
            });
            else {
                // We're not in waiting state. Start waiting state.
                root._waitingFor = promise;
                root._waitingQueue = [];
                // Start interacting with indexedDB until promise completes:
                var store = root.idbtrans.objectStore(root.storeNames[0]);
                (function spin() {
                    ++root._spinCount; // For debugging only
                    while(root._waitingQueue.length)root._waitingQueue.shift()();
                    if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
                })();
            }
            var currentWaitPromise = root._waitingFor;
            return new $a71628d5883e1375$var$Promise(function(resolve, reject) {
                promise.then(function(res) {
                    return root._waitingQueue.push($a71628d5883e1375$var$wrap(resolve.bind(null, res)));
                }, function(err) {
                    return root._waitingQueue.push($a71628d5883e1375$var$wrap(reject.bind(null, err)));
                }).finally(function() {
                    if (root._waitingFor === currentWaitPromise) // No one added a wait after us. Safe to stop the spinning.
                    root._waitingFor = null;
                });
            });
        },
        //
        // Transaction Public Properties and Methods
        //
        abort: function() {
            this.active && this._reject(new $a71628d5883e1375$var$exceptions.Abort());
            this.active = false;
        },
        tables: {
            get: $a71628d5883e1375$var$deprecated("Transaction.tables", function() {
                return allTables;
            })
        },
        table: function(name) {
            var table = db.table(name); // Don't check that table is part of transaction. It must fail lazily!
            return new Table(name, table.schema, this);
        }
    });
    //
    //
    //
    // WhereClause
    //
    //
    //
    function WhereClause(table, index, orCollection) {
        /// <param name="table" type="Table"></param>
        /// <param name="index" type="String" optional="true"></param>
        /// <param name="orCollection" type="Collection" optional="true"></param>
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
    }
    $a71628d5883e1375$var$props(WhereClause.prototype, function() {
        // WhereClause private methods
        function fail(collectionOrWhereClause, err, T) {
            var collection = collectionOrWhereClause instanceof WhereClause ? new Collection(collectionOrWhereClause) : collectionOrWhereClause;
            collection._ctx.error = T ? new T(err) : new TypeError(err);
            return collection;
        }
        function emptyCollection(whereClause) {
            return new Collection(whereClause, function() {
                return IDBKeyRange1.only("");
            }).limit(0);
        }
        function upperFactory(dir) {
            return dir === "next" ? function(s) {
                return s.toUpperCase();
            } : function(s) {
                return s.toLowerCase();
            };
        }
        function lowerFactory(dir) {
            return dir === "next" ? function(s) {
                return s.toLowerCase();
            } : function(s) {
                return s.toUpperCase();
            };
        }
        function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
            var length = Math.min(key.length, lowerNeedle.length);
            var llp = -1;
            for(var i = 0; i < length; ++i){
                var lwrKeyChar = lowerKey[i];
                if (lwrKeyChar !== lowerNeedle[i]) {
                    if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
                    if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
                    if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
                    return null;
                }
                if (cmp(key[i], lwrKeyChar) < 0) llp = i;
            }
            if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
            if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
            return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
        }
        function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
            /// <param name="needles" type="Array" elementType="String"></param>
            var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
            if (!needles.every(function(s) {
                return typeof s === 'string';
            })) return fail(whereClause, $a71628d5883e1375$var$STRING_EXPECTED);
            function initDirection(dir) {
                upper = upperFactory(dir);
                lower = lowerFactory(dir);
                compare = dir === "next" ? simpleCompare : simpleCompareReverse;
                var needleBounds = needles.map(function(needle) {
                    return {
                        lower: lower(needle),
                        upper: upper(needle)
                    };
                }).sort(function(a, b) {
                    return compare(a.lower, b.lower);
                });
                upperNeedles = needleBounds.map(function(nb) {
                    return nb.upper;
                });
                lowerNeedles = needleBounds.map(function(nb) {
                    return nb.lower;
                });
                direction = dir;
                nextKeySuffix = dir === "next" ? "" : suffix;
            }
            initDirection("next");
            var c = new Collection(whereClause, function() {
                return IDBKeyRange1.bound(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
            });
            c._ondirectionchange = function(direction) {
                // This event onlys occur before filter is called the first time.
                initDirection(direction);
            };
            var firstPossibleNeedle = 0;
            c._addAlgorithm(function(cursor, advance, resolve) {
                /// <param name="cursor" type="IDBCursor"></param>
                /// <param name="advance" type="Function"></param>
                /// <param name="resolve" type="Function"></param>
                var key = cursor.key;
                if (typeof key !== 'string') return false;
                var lowerKey = lower(key);
                if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
                else {
                    var lowestPossibleCasing = null;
                    for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                        var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                        if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                        else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
                    }
                    if (lowestPossibleCasing !== null) advance(function() {
                        cursor.continue(lowestPossibleCasing + nextKeySuffix);
                    });
                    else advance(resolve);
                    return false;
                }
            });
            return c;
        }
        //
        // WhereClause public methods
        //
        return {
            between: function(lower, upper, includeLower, includeUpper) {
                /// <summary>
                ///     Filter out records whose where-field lays between given lower and upper values. Applies to Strings, Numbers and Dates.
                /// </summary>
                /// <param name="lower"></param>
                /// <param name="upper"></param>
                /// <param name="includeLower" optional="true">Whether items that equals lower should be included. Default true.</param>
                /// <param name="includeUpper" optional="true">Whether items that equals upper should be included. Default false.</param>
                /// <returns type="Collection"></returns>
                includeLower = includeLower !== false; // Default to true
                includeUpper = includeUpper === true; // Default to false
                try {
                    if (cmp(lower, upper) > 0 || cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return emptyCollection(this); // Workaround for idiotic W3C Specification that DataError must be thrown if lower > upper. The natural result would be to return an empty collection.
                    return new Collection(this, function() {
                        return IDBKeyRange1.bound(lower, upper, !includeLower, !includeUpper);
                    });
                } catch (e) {
                    return fail(this, $a71628d5883e1375$var$INVALID_KEY_ARGUMENT);
                }
            },
            equals: function(value) {
                return new Collection(this, function() {
                    return IDBKeyRange1.only(value);
                });
            },
            above: function(value) {
                return new Collection(this, function() {
                    return IDBKeyRange1.lowerBound(value, true);
                });
            },
            aboveOrEqual: function(value) {
                return new Collection(this, function() {
                    return IDBKeyRange1.lowerBound(value);
                });
            },
            below: function(value) {
                return new Collection(this, function() {
                    return IDBKeyRange1.upperBound(value, true);
                });
            },
            belowOrEqual: function(value) {
                return new Collection(this, function() {
                    return IDBKeyRange1.upperBound(value);
                });
            },
            startsWith: function(str) {
                /// <param name="str" type="String"></param>
                if (typeof str !== 'string') return fail(this, $a71628d5883e1375$var$STRING_EXPECTED);
                return this.between(str, str + $a71628d5883e1375$var$maxString, true, true);
            },
            startsWithIgnoreCase: function(str) {
                /// <param name="str" type="String"></param>
                if (str === "") return this.startsWith(str);
                return addIgnoreCaseAlgorithm(this, function(x, a) {
                    return x.indexOf(a[0]) === 0;
                }, [
                    str
                ], $a71628d5883e1375$var$maxString);
            },
            equalsIgnoreCase: function(str) {
                /// <param name="str" type="String"></param>
                return addIgnoreCaseAlgorithm(this, function(x, a) {
                    return x === a[0];
                }, [
                    str
                ], "");
            },
            anyOfIgnoreCase: function() {
                var set = $a71628d5883e1375$var$getArrayOf.apply($a71628d5883e1375$var$NO_CHAR_ARRAY, arguments);
                if (set.length === 0) return emptyCollection(this);
                return addIgnoreCaseAlgorithm(this, function(x, a) {
                    return a.indexOf(x) !== -1;
                }, set, "");
            },
            startsWithAnyOfIgnoreCase: function() {
                var set = $a71628d5883e1375$var$getArrayOf.apply($a71628d5883e1375$var$NO_CHAR_ARRAY, arguments);
                if (set.length === 0) return emptyCollection(this);
                return addIgnoreCaseAlgorithm(this, function(x, a) {
                    return a.some(function(n) {
                        return x.indexOf(n) === 0;
                    });
                }, set, $a71628d5883e1375$var$maxString);
            },
            anyOf: function() {
                var set = $a71628d5883e1375$var$getArrayOf.apply($a71628d5883e1375$var$NO_CHAR_ARRAY, arguments);
                var compare = ascending;
                try {
                    set.sort(compare);
                } catch (e) {
                    return fail(this, $a71628d5883e1375$var$INVALID_KEY_ARGUMENT);
                }
                if (set.length === 0) return emptyCollection(this);
                var c = new Collection(this, function() {
                    return IDBKeyRange1.bound(set[0], set[set.length - 1]);
                });
                c._ondirectionchange = function(direction) {
                    compare = direction === "next" ? ascending : descending;
                    set.sort(compare);
                };
                var i = 0;
                c._addAlgorithm(function(cursor, advance, resolve) {
                    var key = cursor.key;
                    while(compare(key, set[i]) > 0){
                        // The cursor has passed beyond this key. Check next.
                        ++i;
                        if (i === set.length) {
                            // There is no next. Stop searching.
                            advance(resolve);
                            return false;
                        }
                    }
                    if (compare(key, set[i]) === 0) // The current cursor value should be included and we should continue a single step in case next item has the same key or possibly our next key in set.
                    return true;
                    else {
                        // cursor.key not yet at set[i]. Forward cursor to the next key to hunt for.
                        advance(function() {
                            cursor.continue(set[i]);
                        });
                        return false;
                    }
                });
                return c;
            },
            notEqual: function(value) {
                return this.inAnyRange([
                    [
                        $a71628d5883e1375$var$minKey,
                        value
                    ],
                    [
                        value,
                        $a71628d5883e1375$var$maxKey
                    ]
                ], {
                    includeLowers: false,
                    includeUppers: false
                });
            },
            noneOf: function() {
                var set = $a71628d5883e1375$var$getArrayOf.apply($a71628d5883e1375$var$NO_CHAR_ARRAY, arguments);
                if (set.length === 0) return new Collection(this); // Return entire collection.
                try {
                    set.sort(ascending);
                } catch (e) {
                    return fail(this, $a71628d5883e1375$var$INVALID_KEY_ARGUMENT);
                }
                // Transform ["a","b","c"] to a set of ranges for between/above/below: [[minKey,"a"], ["a","b"], ["b","c"], ["c",maxKey]]
                var ranges = set.reduce(function(res, val) {
                    return res ? res.concat([
                        [
                            res[res.length - 1][1],
                            val
                        ]
                    ]) : [
                        [
                            $a71628d5883e1375$var$minKey,
                            val
                        ]
                    ];
                }, null);
                ranges.push([
                    set[set.length - 1],
                    $a71628d5883e1375$var$maxKey
                ]);
                return this.inAnyRange(ranges, {
                    includeLowers: false,
                    includeUppers: false
                });
            },
            /** Filter out values withing given set of ranges.
            * Example, give children and elders a rebate of 50%:
            *
            *   db.friends.where('age').inAnyRange([[0,18],[65,Infinity]]).modify({Rebate: 1/2});
            *
            * @param {(string|number|Date|Array)[][]} ranges
            * @param {{includeLowers: boolean, includeUppers: boolean}} options
            */ inAnyRange: function(ranges, options) {
                if (ranges.length === 0) return emptyCollection(this);
                if (!ranges.every(function(range) {
                    return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
                })) return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $a71628d5883e1375$var$exceptions.InvalidArgument);
                var includeLowers = !options || options.includeLowers !== false; // Default to true
                var includeUppers = options && options.includeUppers === true; // Default to false
                function addRange(ranges, newRange) {
                    for(var i = 0, l = ranges.length; i < l; ++i){
                        var range = ranges[i];
                        if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                            range[0] = min(range[0], newRange[0]);
                            range[1] = max(range[1], newRange[1]);
                            break;
                        }
                    }
                    if (i === l) ranges.push(newRange);
                    return ranges;
                }
                var sortDirection = ascending;
                function rangeSorter(a, b) {
                    return sortDirection(a[0], b[0]);
                }
                // Join overlapping ranges
                var set;
                try {
                    set = ranges.reduce(addRange, []);
                    set.sort(rangeSorter);
                } catch (ex) {
                    return fail(this, $a71628d5883e1375$var$INVALID_KEY_ARGUMENT);
                }
                var i = 0;
                var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
                    return ascending(key, set[i][1]) > 0;
                } : function(key) {
                    return ascending(key, set[i][1]) >= 0;
                };
                var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
                    return descending(key, set[i][0]) > 0;
                } : function(key) {
                    return descending(key, set[i][0]) >= 0;
                };
                function keyWithinCurrentRange(key) {
                    return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
                }
                var checkKey = keyIsBeyondCurrentEntry;
                var c = new Collection(this, function() {
                    return IDBKeyRange1.bound(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
                });
                c._ondirectionchange = function(direction) {
                    if (direction === "next") {
                        checkKey = keyIsBeyondCurrentEntry;
                        sortDirection = ascending;
                    } else {
                        checkKey = keyIsBeforeCurrentEntry;
                        sortDirection = descending;
                    }
                    set.sort(rangeSorter);
                };
                c._addAlgorithm(function(cursor, advance, resolve) {
                    var key = cursor.key;
                    while(checkKey(key)){
                        // The cursor has passed beyond this key. Check next.
                        ++i;
                        if (i === set.length) {
                            // There is no next. Stop searching.
                            advance(resolve);
                            return false;
                        }
                    }
                    if (keyWithinCurrentRange(key)) // The current cursor value should be included and we should continue a single step in case next item has the same key or possibly our next key in set.
                    return true;
                    else if (cmp(key, set[i][1]) === 0 || cmp(key, set[i][0]) === 0) // includeUpper or includeLower is false so keyWithinCurrentRange() returns false even though we are at range border.
                    // Continue to next key but don't include this one.
                    return false;
                    else {
                        // cursor.key not yet at set[i]. Forward cursor to the next key to hunt for.
                        advance(function() {
                            if (sortDirection === ascending) cursor.continue(set[i][0]);
                            else cursor.continue(set[i][1]);
                        });
                        return false;
                    }
                });
                return c;
            },
            startsWithAnyOf: function() {
                var set = $a71628d5883e1375$var$getArrayOf.apply($a71628d5883e1375$var$NO_CHAR_ARRAY, arguments);
                if (!set.every(function(s) {
                    return typeof s === 'string';
                })) return fail(this, "startsWithAnyOf() only works with strings");
                if (set.length === 0) return emptyCollection(this);
                return this.inAnyRange(set.map(function(str) {
                    return [
                        str,
                        str + $a71628d5883e1375$var$maxString
                    ];
                }));
            }
        };
    });
    //
    //
    //
    // Collection Class
    //
    //
    //
    function Collection(whereClause, keyRangeGenerator) {
        /// <summary>
        ///
        /// </summary>
        /// <param name="whereClause" type="WhereClause">Where clause instance</param>
        /// <param name="keyRangeGenerator" value="function(){ return IDBKeyRange.bound(0,1);}" optional="true"></param>
        var keyRange = null, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx, table = whereCtx.table;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: table.hook.reading.fire
        };
    }
    function isPlainKeyRange(ctx, ignoreLimitFilter) {
        return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
    }
    $a71628d5883e1375$var$props(Collection.prototype, function() {
        //
        // Collection Private Functions
        //
        function addFilter(ctx, fn) {
            ctx.filter = combine(ctx.filter, fn);
        }
        function addReplayFilter(ctx, factory, isLimitFilter) {
            var curr = ctx.replayFilter;
            ctx.replayFilter = curr ? function() {
                return combine(curr(), factory());
            } : factory;
            ctx.justLimit = isLimitFilter && !curr;
        }
        function addMatchFilter(ctx, fn) {
            ctx.isMatch = combine(ctx.isMatch, fn);
        }
        /** @param ctx {
         *      isPrimKey: boolean,
         *      table: Table,
         *      index: string
         * }
         * @param store IDBObjectStore
         **/ function getIndexOrStore(ctx, store) {
            if (ctx.isPrimKey) return store;
            var indexSpec = ctx.table.schema.idxByName[ctx.index];
            if (!indexSpec) throw new $a71628d5883e1375$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + store.name + " is not indexed");
            return store.index(indexSpec.name);
        }
        /** @param ctx {
         *      isPrimKey: boolean,
         *      table: Table,
         *      index: string,
         *      keysOnly: boolean,
         *      range?: IDBKeyRange,
         *      dir: "next" | "prev"
         * }
         */ function openCursor(ctx, store) {
            var idxOrStore = getIndexOrStore(ctx, store);
            return ctx.keysOnly && 'openKeyCursor' in idxOrStore ? idxOrStore.openKeyCursor(ctx.range || null, ctx.dir + ctx.unique) : idxOrStore.openCursor(ctx.range || null, ctx.dir + ctx.unique);
        }
        function iter(ctx, fn, resolve, reject, idbstore) {
            var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
            if (!ctx.or) iterate(openCursor(ctx, idbstore), combine(ctx.algorithm, filter), fn, resolve, reject, !ctx.keysOnly && ctx.valueMapper);
            else (function() {
                var set = {};
                var resolved = 0;
                function resolveboth() {
                    if (++resolved === 2) resolve(); // Seems like we just support or btwn max 2 expressions, but there are no limit because we do recursion.
                }
                function union(item, cursor, advance) {
                    if (!filter || filter(cursor, advance, resolveboth, reject)) {
                        var primaryKey = cursor.primaryKey;
                        var key = '' + primaryKey;
                        if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                        if (!$a71628d5883e1375$var$hasOwn(set, key)) {
                            set[key] = true;
                            fn(item, cursor, advance);
                        }
                    }
                }
                ctx.or._iterate(union, resolveboth, reject, idbstore);
                iterate(openCursor(ctx, idbstore), ctx.algorithm, union, resolveboth, reject, !ctx.keysOnly && ctx.valueMapper);
            })();
        }
        return {
            //
            // Collection Protected Functions
            //
            _read: function(fn, cb) {
                var ctx = this._ctx;
                return ctx.error ? ctx.table._trans(null, $a71628d5883e1375$var$rejection.bind(null, ctx.error)) : ctx.table._idbstore(READONLY, fn).then(cb);
            },
            _write: function(fn) {
                var ctx = this._ctx;
                return ctx.error ? ctx.table._trans(null, $a71628d5883e1375$var$rejection.bind(null, ctx.error)) : ctx.table._idbstore(READWRITE, fn, "locked"); // When doing write operations on collections, always lock the operation so that upcoming operations gets queued.
            },
            _addAlgorithm: function(fn) {
                var ctx = this._ctx;
                ctx.algorithm = combine(ctx.algorithm, fn);
            },
            _iterate: function(fn, resolve, reject, idbstore) {
                return iter(this._ctx, fn, resolve, reject, idbstore);
            },
            clone: function(props$$1) {
                var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
                if (props$$1) $a71628d5883e1375$var$extend(ctx, props$$1);
                rv._ctx = ctx;
                return rv;
            },
            raw: function() {
                this._ctx.valueMapper = null;
                return this;
            },
            //
            // Collection Public methods
            //
            each: function(fn) {
                var ctx = this._ctx;
                return this._read(function(resolve, reject, idbstore) {
                    iter(ctx, fn, resolve, reject, idbstore);
                });
            },
            count: function(cb) {
                var ctx = this._ctx;
                if (isPlainKeyRange(ctx, true)) // This is a plain key range. We can use the count() method if the index.
                return this._read(function(resolve, reject, idbstore) {
                    var idx = getIndexOrStore(ctx, idbstore);
                    var req = ctx.range ? idx.count(ctx.range) : idx.count();
                    req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                    req.onsuccess = function(e) {
                        resolve(Math.min(e.target.result, ctx.limit));
                    };
                }, cb);
                else {
                    // Algorithms, filters or expressions are applied. Need to count manually.
                    var count = 0;
                    return this._read(function(resolve, reject, idbstore) {
                        iter(ctx, function() {
                            ++count;
                            return false;
                        }, function() {
                            resolve(count);
                        }, reject, idbstore);
                    }, cb);
                }
            },
            sortBy: function(keyPath, cb) {
                /// <param name="keyPath" type="String"></param>
                var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
                function getval(obj, i) {
                    if (i) return getval(obj[parts[i]], i - 1);
                    return obj[lastPart];
                }
                var order = this._ctx.dir === "next" ? 1 : -1;
                function sorter(a, b) {
                    var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
                    return aVal < bVal ? -order : aVal > bVal ? order : 0;
                }
                return this.toArray(function(a) {
                    return a.sort(sorter);
                }).then(cb);
            },
            toArray: function(cb) {
                var ctx = this._ctx;
                return this._read(function(resolve, reject, idbstore) {
                    if (hasGetAll && ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                        // Special optimation if we could use IDBObjectStore.getAll() or
                        // IDBKeyRange.getAll():
                        var readingHook = ctx.table.hook.reading.fire;
                        var idxOrStore = getIndexOrStore(ctx, idbstore);
                        var req = ctx.limit < Infinity ? idxOrStore.getAll(ctx.range, ctx.limit) : idxOrStore.getAll(ctx.range);
                        req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                        req.onsuccess = readingHook === $a71628d5883e1375$var$mirror ? $a71628d5883e1375$var$eventSuccessHandler(resolve) : $a71628d5883e1375$var$eventSuccessHandler(function(res) {
                            try {
                                resolve(res.map(readingHook));
                            } catch (e) {
                                reject(e);
                            }
                        });
                    } else {
                        // Getting array through a cursor.
                        var a = [];
                        iter(ctx, function(item) {
                            a.push(item);
                        }, function arrayComplete() {
                            resolve(a);
                        }, reject, idbstore);
                    }
                }, cb);
            },
            offset: function(offset) {
                var ctx = this._ctx;
                if (offset <= 0) return this;
                ctx.offset += offset; // For count()
                if (isPlainKeyRange(ctx)) addReplayFilter(ctx, function() {
                    var offsetLeft = offset;
                    return function(cursor, advance) {
                        if (offsetLeft === 0) return true;
                        if (offsetLeft === 1) {
                            --offsetLeft;
                            return false;
                        }
                        advance(function() {
                            cursor.advance(offsetLeft);
                            offsetLeft = 0;
                        });
                        return false;
                    };
                });
                else addReplayFilter(ctx, function() {
                    var offsetLeft = offset;
                    return function() {
                        return --offsetLeft < 0;
                    };
                });
                return this;
            },
            limit: function(numRows) {
                this._ctx.limit = Math.min(this._ctx.limit, numRows); // For count()
                addReplayFilter(this._ctx, function() {
                    var rowsLeft = numRows;
                    return function(cursor, advance, resolve) {
                        if (--rowsLeft <= 0) advance(resolve); // Stop after this item has been included
                        return rowsLeft >= 0; // If numRows is already below 0, return false because then 0 was passed to numRows initially. Otherwise we wouldnt come here.
                    };
                }, true);
                return this;
            },
            until: function(filterFunction, bIncludeStopEntry) {
                addFilter(this._ctx, function(cursor, advance, resolve) {
                    if (filterFunction(cursor.value)) {
                        advance(resolve);
                        return bIncludeStopEntry;
                    } else return true;
                });
                return this;
            },
            first: function(cb) {
                return this.limit(1).toArray(function(a) {
                    return a[0];
                }).then(cb);
            },
            last: function(cb) {
                return this.reverse().first(cb);
            },
            filter: function(filterFunction) {
                /// <param name="jsFunctionFilter" type="Function">function(val){return true/false}</param>
                addFilter(this._ctx, function(cursor) {
                    return filterFunction(cursor.value);
                });
                // match filters not used in Dexie.js but can be used by 3rd part libraries to test a
                // collection for a match without querying DB. Used by Dexie.Observable.
                addMatchFilter(this._ctx, filterFunction);
                return this;
            },
            and: function(filterFunction) {
                return this.filter(filterFunction);
            },
            or: function(indexName) {
                return new WhereClause(this._ctx.table, indexName, this);
            },
            reverse: function() {
                this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
                if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
                return this;
            },
            desc: function() {
                return this.reverse();
            },
            eachKey: function(cb) {
                var ctx = this._ctx;
                ctx.keysOnly = !ctx.isMatch;
                return this.each(function(val, cursor) {
                    cb(cursor.key, cursor);
                });
            },
            eachUniqueKey: function(cb) {
                this._ctx.unique = "unique";
                return this.eachKey(cb);
            },
            eachPrimaryKey: function(cb) {
                var ctx = this._ctx;
                ctx.keysOnly = !ctx.isMatch;
                return this.each(function(val, cursor) {
                    cb(cursor.primaryKey, cursor);
                });
            },
            keys: function(cb) {
                var ctx = this._ctx;
                ctx.keysOnly = !ctx.isMatch;
                var a = [];
                return this.each(function(item, cursor) {
                    a.push(cursor.key);
                }).then(function() {
                    return a;
                }).then(cb);
            },
            primaryKeys: function(cb) {
                var ctx = this._ctx;
                if (hasGetAll && ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) // Special optimation if we could use IDBObjectStore.getAllKeys() or
                // IDBKeyRange.getAllKeys():
                return this._read(function(resolve, reject, idbstore) {
                    var idxOrStore = getIndexOrStore(ctx, idbstore);
                    var req = ctx.limit < Infinity ? idxOrStore.getAllKeys(ctx.range, ctx.limit) : idxOrStore.getAllKeys(ctx.range);
                    req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
                    req.onsuccess = $a71628d5883e1375$var$eventSuccessHandler(resolve);
                }).then(cb);
                ctx.keysOnly = !ctx.isMatch;
                var a = [];
                return this.each(function(item, cursor) {
                    a.push(cursor.primaryKey);
                }).then(function() {
                    return a;
                }).then(cb);
            },
            uniqueKeys: function(cb) {
                this._ctx.unique = "unique";
                return this.keys(cb);
            },
            firstKey: function(cb) {
                return this.limit(1).keys(function(a) {
                    return a[0];
                }).then(cb);
            },
            lastKey: function(cb) {
                return this.reverse().firstKey(cb);
            },
            distinct: function() {
                var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
                if (!idx || !idx.multi) return this; // distinct() only makes differencies on multiEntry indexes.
                var set = {};
                addFilter(this._ctx, function(cursor) {
                    var strKey = cursor.primaryKey.toString(); // Converts any Date to String, String to String, Number to String and Array to comma-separated string
                    var found = $a71628d5883e1375$var$hasOwn(set, strKey);
                    set[strKey] = true;
                    return !found;
                });
                return this;
            },
            //
            // Methods that mutate storage
            //
            modify: function(changes) {
                var self1 = this, ctx = this._ctx, hook = ctx.table.hook, updatingHook = hook.updating.fire, deletingHook = hook.deleting.fire;
                return this._write(function(resolve, reject, idbstore, trans) {
                    var modifyer;
                    if (typeof changes === 'function') {
                        // Changes is a function that may update, add or delete propterties or even require a deletion the object itself (delete this.item)
                        if (updatingHook === $a71628d5883e1375$var$nop && deletingHook === $a71628d5883e1375$var$nop) // Noone cares about what is being changed. Just let the modifier function be the given argument as is.
                        modifyer = changes;
                        else // People want to know exactly what is being modified or deleted.
                        // Let modifyer be a proxy function that finds out what changes the caller is actually doing
                        // and call the hooks accordingly!
                        modifyer = function(item) {
                            var origItem = $a71628d5883e1375$var$deepClone(item); // Clone the item first so we can compare laters.
                            if (changes.call(this, item, this) === false) return false; // Call the real modifyer function (If it returns false explicitely, it means it dont want to modify anyting on this object)
                            if (!$a71628d5883e1375$var$hasOwn(this, "value")) // The real modifyer function requests a deletion of the object. Inform the deletingHook that a deletion is taking place.
                            deletingHook.call(this, this.primKey, item, trans);
                            else {
                                // No deletion. Check what was changed
                                var objectDiff = $a71628d5883e1375$var$getObjectDiff(origItem, this.value);
                                var additionalChanges = updatingHook.call(this, objectDiff, this.primKey, origItem, trans);
                                if (additionalChanges) {
                                    // Hook want to apply additional modifications. Make sure to fullfill the will of the hook.
                                    item = this.value;
                                    $a71628d5883e1375$var$keys(additionalChanges).forEach(function(keyPath) {
                                        $a71628d5883e1375$var$setByKeyPath(item, keyPath, additionalChanges[keyPath]); // Adding {keyPath: undefined} means that the keyPath should be deleted. Handled by setByKeyPath
                                    });
                                }
                            }
                        };
                    } else if (updatingHook === $a71628d5883e1375$var$nop) {
                        // changes is a set of {keyPath: value} and no one is listening to the updating hook.
                        var keyPaths = $a71628d5883e1375$var$keys(changes);
                        var numKeys = keyPaths.length;
                        modifyer = function(item) {
                            var anythingModified = false;
                            for(var i = 0; i < numKeys; ++i){
                                var keyPath = keyPaths[i], val = changes[keyPath];
                                if ($a71628d5883e1375$var$getByKeyPath(item, keyPath) !== val) {
                                    $a71628d5883e1375$var$setByKeyPath(item, keyPath, val); // Adding {keyPath: undefined} means that the keyPath should be deleted. Handled by setByKeyPath
                                    anythingModified = true;
                                }
                            }
                            return anythingModified;
                        };
                    } else {
                        // changes is a set of {keyPath: value} and people are listening to the updating hook so we need to call it and
                        // allow it to add additional modifications to make.
                        var origChanges = changes;
                        changes = $a71628d5883e1375$var$shallowClone(origChanges); // Let's work with a clone of the changes keyPath/value set so that we can restore it in case a hook extends it.
                        modifyer = function(item) {
                            var anythingModified = false;
                            var additionalChanges = updatingHook.call(this, changes, this.primKey, $a71628d5883e1375$var$deepClone(item), trans);
                            if (additionalChanges) $a71628d5883e1375$var$extend(changes, additionalChanges);
                            $a71628d5883e1375$var$keys(changes).forEach(function(keyPath) {
                                var val = changes[keyPath];
                                if ($a71628d5883e1375$var$getByKeyPath(item, keyPath) !== val) {
                                    $a71628d5883e1375$var$setByKeyPath(item, keyPath, val);
                                    anythingModified = true;
                                }
                            });
                            if (additionalChanges) changes = $a71628d5883e1375$var$shallowClone(origChanges); // Restore original changes for next iteration
                            return anythingModified;
                        };
                    }
                    var count = 0;
                    var successCount = 0;
                    var iterationComplete = false;
                    var failures = [];
                    var failKeys = [];
                    var currentKey = null;
                    function modifyItem(item, cursor) {
                        currentKey = cursor.primaryKey;
                        var thisContext = {
                            primKey: cursor.primaryKey,
                            value: item,
                            onsuccess: null,
                            onerror: null
                        };
                        function onerror(e) {
                            failures.push(e);
                            failKeys.push(thisContext.primKey);
                            checkFinished();
                            return true; // Catch these errors and let a final rejection decide whether or not to abort entire transaction
                        }
                        if (modifyer.call(thisContext, item, thisContext) !== false) {
                            var bDelete = !$a71628d5883e1375$var$hasOwn(thisContext, "value");
                            ++count;
                            $a71628d5883e1375$var$tryCatch(function() {
                                var req = bDelete ? cursor.delete() : cursor.update(thisContext.value);
                                req._hookCtx = thisContext;
                                req.onerror = $a71628d5883e1375$var$hookedEventRejectHandler(onerror);
                                req.onsuccess = $a71628d5883e1375$var$hookedEventSuccessHandler(function() {
                                    ++successCount;
                                    checkFinished();
                                });
                            }, onerror);
                        } else if (thisContext.onsuccess) // Hook will expect either onerror or onsuccess to always be called!
                        thisContext.onsuccess(thisContext.value);
                    }
                    function doReject(e) {
                        if (e) {
                            failures.push(e);
                            failKeys.push(currentKey);
                        }
                        return reject(new $a71628d5883e1375$var$ModifyError("Error modifying one or more objects", failures, successCount, failKeys));
                    }
                    function checkFinished() {
                        if (iterationComplete && successCount + failures.length === count) {
                            if (failures.length > 0) doReject();
                            else resolve(successCount);
                        }
                    }
                    self1.clone().raw()._iterate(modifyItem, function() {
                        iterationComplete = true;
                        checkFinished();
                    }, doReject, idbstore);
                });
            },
            'delete': function() {
                var _this = this;
                var ctx = this._ctx, range = ctx.range, deletingHook = ctx.table.hook.deleting.fire, hasDeleteHook = deletingHook !== $a71628d5883e1375$var$nop;
                if (!hasDeleteHook && isPlainKeyRange(ctx) && (ctx.isPrimKey && !$a71628d5883e1375$var$hangsOnDeleteLargeKeyRange || !range)) // May use IDBObjectStore.delete(IDBKeyRange) in this case (Issue #208)
                // For chromium, this is the way most optimized version.
                // For IE/Edge, this could hang the indexedDB engine and make operating system instable
                // (https://gist.github.com/dfahlander/5a39328f029de18222cf2125d56c38f7)
                return this._write(function(resolve, reject, idbstore) {
                    // Our API contract is to return a count of deleted items, so we have to count() before delete().
                    var onerror = $a71628d5883e1375$var$eventRejectHandler(reject), countReq = range ? idbstore.count(range) : idbstore.count();
                    countReq.onerror = onerror;
                    countReq.onsuccess = function() {
                        var count = countReq.result;
                        $a71628d5883e1375$var$tryCatch(function() {
                            var delReq = range ? idbstore.delete(range) : idbstore.clear();
                            delReq.onerror = onerror;
                            delReq.onsuccess = function() {
                                return resolve(count);
                            };
                        }, function(err) {
                            return reject(err);
                        });
                    };
                });
                // Default version to use when collection is not a vanilla IDBKeyRange on the primary key.
                // Divide into chunks to not starve RAM.
                // If has delete hook, we will have to collect not just keys but also objects, so it will use
                // more memory and need lower chunk size.
                var CHUNKSIZE = hasDeleteHook ? 2000 : 10000;
                return this._write(function(resolve, reject, idbstore, trans) {
                    var totalCount = 0;
                    // Clone collection and change its table and set a limit of CHUNKSIZE on the cloned Collection instance.
                    var collection = _this.clone({
                        keysOnly: !ctx.isMatch && !hasDeleteHook
                    }) // load just keys (unless filter() or and() or deleteHook has subscribers)
                    .distinct() // In case multiEntry is used, never delete same key twice because resulting count
                    .limit(CHUNKSIZE).raw(); // Don't filter through reading-hooks (like mapped classes etc)
                    var keysOrTuples = [];
                    // We're gonna do things on as many chunks that are needed.
                    // Use recursion of nextChunk function:
                    var nextChunk = function() {
                        return collection.each(hasDeleteHook ? function(val, cursor) {
                            // Somebody subscribes to hook('deleting'). Collect all primary keys and their values,
                            // so that the hook can be called with its values in bulkDelete().
                            keysOrTuples.push([
                                cursor.primaryKey,
                                cursor.value
                            ]);
                        } : function(val, cursor) {
                            // No one subscribes to hook('deleting'). Collect only primary keys:
                            keysOrTuples.push(cursor.primaryKey);
                        }).then(function() {
                            // Chromium deletes faster when doing it in sort order.
                            hasDeleteHook ? keysOrTuples.sort(function(a, b) {
                                return ascending(a[0], b[0]);
                            }) : keysOrTuples.sort(ascending);
                            return bulkDelete(idbstore, trans, keysOrTuples, hasDeleteHook, deletingHook);
                        }).then(function() {
                            var count = keysOrTuples.length;
                            totalCount += count;
                            keysOrTuples = [];
                            return count < CHUNKSIZE ? totalCount : nextChunk();
                        });
                    };
                    resolve(nextChunk());
                });
            }
        };
    });
    //
    //
    //
    // ------------------------- Help functions ---------------------------
    //
    //
    //
    function lowerVersionFirst(a, b) {
        return a._cfg.version - b._cfg.version;
    }
    function setApiOnPlace(objs, tableNames, dbschema) {
        tableNames.forEach(function(tableName) {
            var schema = dbschema[tableName];
            objs.forEach(function(obj) {
                if (!(tableName in obj)) {
                    if (obj === Transaction.prototype || obj instanceof Transaction) // obj is a Transaction prototype (or prototype of a subclass to Transaction)
                    // Make the API a getter that returns this.table(tableName)
                    $a71628d5883e1375$var$setProp(obj, tableName, {
                        get: function() {
                            return this.table(tableName);
                        }
                    });
                    else // Table will not be bound to a transaction (will use Dexie.currentTransaction)
                    obj[tableName] = new Table(tableName, schema);
                }
            });
        });
    }
    function removeTablesApi(objs) {
        objs.forEach(function(obj) {
            for(var key in obj)if (obj[key] instanceof Table) delete obj[key];
        });
    }
    function iterate(req, filter, fn, resolve, reject, valueMapper) {
        // Apply valueMapper (hook('reading') or mappped class)
        var mappedFn = valueMapper ? function(x, c, a) {
            return fn(valueMapper(x), c, a);
        } : fn;
        // Wrap fn with PSD and microtick stuff from Promise.
        var wrappedFn = $a71628d5883e1375$var$wrap(mappedFn, reject);
        if (!req.onerror) req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
        if (filter) req.onsuccess = $a71628d5883e1375$var$trycatcher(function filter_record() {
            var cursor = req.result;
            if (cursor) {
                var c = function() {
                    cursor.continue();
                };
                if (filter(cursor, function(advancer) {
                    c = advancer;
                }, resolve, reject)) wrappedFn(cursor.value, cursor, function(advancer) {
                    c = advancer;
                });
                c();
            } else resolve();
        }, reject);
        else req.onsuccess = $a71628d5883e1375$var$trycatcher(function filter_record() {
            var cursor = req.result;
            if (cursor) {
                var c = function() {
                    cursor.continue();
                };
                wrappedFn(cursor.value, cursor, function(advancer) {
                    c = advancer;
                });
                c();
            } else resolve();
        }, reject);
    }
    function parseIndexSyntax(indexes) {
        /// <param name="indexes" type="String"></param>
        /// <returns type="Array" elementType="IndexSpec"></returns>
        var rv = [];
        indexes.split(',').forEach(function(index) {
            index = index.trim();
            var name = index.replace(/([&*]|\+\+)/g, ""); // Remove "&", "++" and "*"
            // Let keyPath of "[a+b]" be ["a","b"]:
            var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
            rv.push(new $a71628d5883e1375$var$IndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $a71628d5883e1375$var$isArray(keyPath), /\./.test(index)));
        });
        return rv;
    }
    function cmp(key1, key2) {
        return indexedDB.cmp(key1, key2);
    }
    function min(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    function max(a, b) {
        return cmp(a, b) > 0 ? a : b;
    }
    function ascending(a, b) {
        return indexedDB.cmp(a, b);
    }
    function descending(a, b) {
        return indexedDB.cmp(b, a);
    }
    function simpleCompare(a, b) {
        return a < b ? -1 : a === b ? 0 : 1;
    }
    function simpleCompareReverse(a, b) {
        return a > b ? -1 : a === b ? 0 : 1;
    }
    function combine(filter1, filter2) {
        return filter1 ? filter2 ? function() {
            return filter1.apply(this, arguments) && filter2.apply(this, arguments);
        } : filter1 : filter2;
    }
    function readGlobalSchema() {
        db.verno = idbdb.version / 10;
        db._dbSchema = globalSchema = {};
        dbStoreNames = $a71628d5883e1375$var$slice(idbdb.objectStoreNames, 0);
        if (dbStoreNames.length === 0) return; // Database contains no stores.
        var trans = idbdb.transaction($a71628d5883e1375$var$safariMultiStoreFix(dbStoreNames), 'readonly');
        dbStoreNames.forEach(function(storeName) {
            var store = trans.objectStore(storeName), keyPath = store.keyPath, dotted = keyPath && typeof keyPath === 'string' && keyPath.indexOf('.') !== -1;
            var primKey = new $a71628d5883e1375$var$IndexSpec(keyPath, keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== 'string', dotted);
            var indexes = [];
            for(var j = 0; j < store.indexNames.length; ++j){
                var idbindex = store.index(store.indexNames[j]);
                keyPath = idbindex.keyPath;
                dotted = keyPath && typeof keyPath === 'string' && keyPath.indexOf('.') !== -1;
                var index = new $a71628d5883e1375$var$IndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== 'string', dotted);
                indexes.push(index);
            }
            globalSchema[storeName] = new $a71628d5883e1375$var$TableSchema(storeName, primKey, indexes, {});
        });
        setApiOnPlace([
            allTables
        ], $a71628d5883e1375$var$keys(globalSchema), globalSchema);
    }
    function adjustToExistingIndexNames(schema, idbtrans) {
        /// <summary>
        /// Issue #30 Problem with existing db - adjust to existing index names when migrating from non-dexie db
        /// </summary>
        /// <param name="schema" type="Object">Map between name and TableSchema</param>
        /// <param name="idbtrans" type="IDBTransaction"></param>
        var storeNames = idbtrans.db.objectStoreNames;
        for(var i = 0; i < storeNames.length; ++i){
            var storeName = storeNames[i];
            var store = idbtrans.objectStore(storeName);
            hasGetAll = 'getAll' in store;
            for(var j = 0; j < store.indexNames.length; ++j){
                var indexName = store.indexNames[j];
                var keyPath = store.index(indexName).keyPath;
                var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $a71628d5883e1375$var$slice(keyPath).join('+') + "]";
                if (schema[storeName]) {
                    var indexSpec = schema[storeName].idxByName[dexieName];
                    if (indexSpec) indexSpec.name = indexName;
                }
            }
        }
        // Bug with getAll() on Safari ver<604 on Workers only, see discussion following PR #579
        if (/Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $a71628d5883e1375$var$_global.WorkerGlobalScope && $a71628d5883e1375$var$_global instanceof $a71628d5883e1375$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) hasGetAll = false;
    }
    function fireOnBlocked(ev) {
        db.on("blocked").fire(ev);
        // Workaround (not fully*) for missing "versionchange" event in IE,Edge and Safari:
        $a71628d5883e1375$var$connections.filter(function(c) {
            return c.name === db.name && c !== db && !c._vcFired;
        }).map(function(c) {
            return c.on("versionchange").fire(ev);
        });
    }
    $a71628d5883e1375$var$extend(this, {
        Collection: Collection,
        Table: Table,
        Transaction: Transaction,
        Version: Version,
        WhereClause: WhereClause
    });
    init();
    addons.forEach(function(fn) {
        fn(db);
    });
}
function $a71628d5883e1375$var$parseType(type) {
    if (typeof type === 'function') return new type();
    else if ($a71628d5883e1375$var$isArray(type)) return [
        $a71628d5883e1375$var$parseType(type[0])
    ];
    else if (type && typeof type === 'object') {
        var rv = {};
        $a71628d5883e1375$var$applyStructure(rv, type);
        return rv;
    } else return type;
}
function $a71628d5883e1375$var$applyStructure(obj, structure) {
    $a71628d5883e1375$var$keys(structure).forEach(function(member) {
        var value = $a71628d5883e1375$var$parseType(structure[member]);
        obj[member] = value;
    });
    return obj;
}
function $a71628d5883e1375$var$hookedEventSuccessHandler(resolve) {
    // wrap() is needed when calling hooks because the rare scenario of:
    //  * hook does a db operation that fails immediately (IDB throws exception)
    //    For calling db operations on correct transaction, wrap makes sure to set PSD correctly.
    //    wrap() will also execute in a virtual tick.
    //  * If not wrapped in a virtual tick, direct exception will launch a new physical tick.
    //  * If this was the last event in the bulk, the promise will resolve after a physical tick
    //    and the transaction will have committed already.
    // If no hook, the virtual tick will be executed in the reject()/resolve of the final promise,
    // because it is always marked with _lib = true when created using Transaction._promise().
    return $a71628d5883e1375$var$wrap(function(event) {
        var req = event.target, ctx = req._hookCtx, result = ctx.value || req.result, hookSuccessHandler = ctx && ctx.onsuccess;
        hookSuccessHandler && hookSuccessHandler(result);
        resolve && resolve(result);
    }, resolve);
}
function $a71628d5883e1375$var$eventRejectHandler(reject) {
    return $a71628d5883e1375$var$wrap(function(event) {
        $a71628d5883e1375$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $a71628d5883e1375$var$eventSuccessHandler(resolve) {
    return $a71628d5883e1375$var$wrap(function(event) {
        resolve(event.target.result);
    });
}
function $a71628d5883e1375$var$hookedEventRejectHandler(reject) {
    return $a71628d5883e1375$var$wrap(function(event) {
        // See comment on hookedEventSuccessHandler() why wrap() is needed only when supporting hooks.
        var req = event.target, err = req.error, ctx = req._hookCtx, hookErrorHandler = ctx && ctx.onerror;
        hookErrorHandler && hookErrorHandler(err);
        $a71628d5883e1375$var$preventDefault(event);
        reject(err);
        return false;
    });
}
function $a71628d5883e1375$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
function $a71628d5883e1375$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $a71628d5883e1375$var$isArray(value) ? $a71628d5883e1375$var$Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
//
// IndexSpec struct
//
function $a71628d5883e1375$var$IndexSpec(name, keyPath, unique, multi, auto, compound, dotted) {
    /// <param name="name" type="String"></param>
    /// <param name="keyPath" type="String"></param>
    /// <param name="unique" type="Boolean"></param>
    /// <param name="multi" type="Boolean"></param>
    /// <param name="auto" type="Boolean"></param>
    /// <param name="compound" type="Boolean"></param>
    /// <param name="dotted" type="Boolean"></param>
    this.name = name;
    this.keyPath = keyPath;
    this.unique = unique;
    this.multi = multi;
    this.auto = auto;
    this.compound = compound;
    this.dotted = dotted;
    var keyPathSrc = typeof keyPath === 'string' ? keyPath : keyPath && '[' + [].join.call(keyPath, '+') + ']';
    this.src = (unique ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + keyPathSrc;
}
//
// TableSchema struct
//
function $a71628d5883e1375$var$TableSchema(name, primKey, indexes, instanceTemplate) {
    /// <param name="name" type="String"></param>
    /// <param name="primKey" type="IndexSpec"></param>
    /// <param name="indexes" type="Array" elementType="IndexSpec"></param>
    /// <param name="instanceTemplate" type="Object"></param>
    this.name = name;
    this.primKey = primKey || new $a71628d5883e1375$var$IndexSpec();
    this.indexes = indexes || [
        new $a71628d5883e1375$var$IndexSpec()
    ];
    this.instanceTemplate = instanceTemplate;
    this.mappedClass = null;
    this.idxByName = $a71628d5883e1375$var$arrayToObject(indexes, function(index) {
        return [
            index.name,
            index
        ];
    });
}
function $a71628d5883e1375$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
function $a71628d5883e1375$var$getNativeGetDatabaseNamesFn(indexedDB) {
    var fn = indexedDB && (indexedDB.getDatabaseNames || indexedDB.webkitGetDatabaseNames);
    return fn && fn.bind(indexedDB);
}
// Export Error classes
$a71628d5883e1375$var$props($a71628d5883e1375$var$Dexie, $a71628d5883e1375$var$fullNameExceptions); // Dexie.XXXError = class XXXError {...};
//
// Static methods and properties
// 
$a71628d5883e1375$var$props($a71628d5883e1375$var$Dexie, {
    //
    // Static delete() method.
    //
    delete: function(databaseName) {
        var db = new $a71628d5883e1375$var$Dexie(databaseName), promise = db.delete();
        promise.onblocked = function(fn) {
            db.on("blocked", fn);
            return this;
        };
        return promise;
    },
    //
    // Static exists() method.
    //
    exists: function(name) {
        return new $a71628d5883e1375$var$Dexie(name).open().then(function(db) {
            db.close();
            return true;
        }).catch($a71628d5883e1375$var$Dexie.NoSuchDatabaseError, function() {
            return false;
        });
    },
    //
    // Static method for retrieving a list of all existing databases at current host.
    //
    getDatabaseNames: function(cb) {
        var getDatabaseNames = $a71628d5883e1375$var$getNativeGetDatabaseNamesFn($a71628d5883e1375$var$Dexie.dependencies.indexedDB);
        return getDatabaseNames ? new $a71628d5883e1375$var$Promise(function(resolve, reject) {
            var req = getDatabaseNames();
            req.onsuccess = function(event) {
                resolve($a71628d5883e1375$var$slice(event.target.result, 0)); // Converst DOMStringList to Array<String>
            };
            req.onerror = $a71628d5883e1375$var$eventRejectHandler(reject);
        }).then(cb) : $a71628d5883e1375$var$dbNamesDB.dbnames.toCollection().primaryKeys(cb);
    },
    defineClass: function() {
        // Default constructor able to copy given properties into this object.
        function Class(properties) {
            /// <param name="properties" type="Object" optional="true">Properties to initialize object with.
            /// </param>
            if (properties) $a71628d5883e1375$var$extend(this, properties);
        }
        return Class;
    },
    applyStructure: $a71628d5883e1375$var$applyStructure,
    ignoreTransaction: function(scopeFunc) {
        // In case caller is within a transaction but needs to create a separate transaction.
        // Example of usage:
        //
        // Let's say we have a logger function in our app. Other application-logic should be unaware of the
        // logger function and not need to include the 'logentries' table in all transaction it performs.
        // The logging should always be done in a separate transaction and not be dependant on the current
        // running transaction context. Then you could use Dexie.ignoreTransaction() to run code that starts a new transaction.
        //
        //     Dexie.ignoreTransaction(function() {
        //         db.logentries.add(newLogEntry);
        //     });
        //
        // Unless using Dexie.ignoreTransaction(), the above example would try to reuse the current transaction
        // in current Promise-scope.
        //
        // An alternative to Dexie.ignoreTransaction() would be setImmediate() or setTimeout(). The reason we still provide an
        // API for this because
        //  1) The intention of writing the statement could be unclear if using setImmediate() or setTimeout().
        //  2) setTimeout() would wait unnescessary until firing. This is however not the case with setImmediate().
        //  3) setImmediate() is not supported in the ES standard.
        //  4) You might want to keep other PSD state that was set in a parent PSD, such as PSD.letThrough.
        return $a71628d5883e1375$var$PSD.trans ? $a71628d5883e1375$var$usePSD($a71628d5883e1375$var$PSD.transless, scopeFunc) : scopeFunc(); // No need to change scope because there is no ongoing transaction.
    },
    vip: function(fn) {
        // To be used by subscribers to the on('ready') event.
        // This will let caller through to access DB even when it is blocked while the db.ready() subscribers are firing.
        // This would have worked automatically if we were certain that the Provider was using Dexie.Promise for all asyncronic operations. The promise PSD
        // from the provider.connect() call would then be derived all the way to when provider would call localDatabase.applyChanges(). But since
        // the provider more likely is using non-promise async APIs or other thenable implementations, we cannot assume that.
        // Note that this method is only useful for on('ready') subscribers that is returning a Promise from the event. If not using vip()
        // the database could deadlock since it wont open until the returned Promise is resolved, and any non-VIPed operation started by
        // the caller will not resolve until database is opened.
        return $a71628d5883e1375$var$newScope(function() {
            $a71628d5883e1375$var$PSD.letThrough = true; // Make sure we are let through if still blocking db due to onready is firing.
            return fn();
        });
    },
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $a71628d5883e1375$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $a71628d5883e1375$var$Promise.resolve(rv);
                return rv;
            } catch (e) {
                return $a71628d5883e1375$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $a71628d5883e1375$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $a71628d5883e1375$var$Promise.resolve(rv);
            return rv;
        } catch (e) {
            return $a71628d5883e1375$var$rejection(e);
        }
    },
    // Dexie.currentTransaction property
    currentTransaction: {
        get: function() {
            return $a71628d5883e1375$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        // If a function is provided, invoke it and pass the returning value to Transaction.waitFor()
        var promise = $a71628d5883e1375$var$Promise.resolve(typeof promiseOrFunction === 'function' ? $a71628d5883e1375$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000); // Default the timeout to one minute. Caller may specify Infinity if required.       
        // Run given promise on current transaction. If no current transaction, just return a Dexie promise based
        // on given value.
        return $a71628d5883e1375$var$PSD.trans ? $a71628d5883e1375$var$PSD.trans.waitFor(promise) : promise;
    },
    // Export our Promise implementation since it can be handy as a standalone Promise implementation
    Promise: $a71628d5883e1375$var$Promise,
    // Dexie.debug proptery:
    // Dexie.debug = false
    // Dexie.debug = true
    // Dexie.debug = "dexie" - don't hide dexie's stack frames.
    debug: {
        get: function() {
            return $a71628d5883e1375$var$debug;
        },
        set: function(value) {
            $a71628d5883e1375$var$setDebug(value, value === 'dexie' ? function() {
                return true;
            } : $a71628d5883e1375$var$dexieStackFrameFilter);
        }
    },
    // Export our derive/extend/override methodology
    derive: $a71628d5883e1375$var$derive,
    extend: $a71628d5883e1375$var$extend,
    props: $a71628d5883e1375$var$props,
    override: $a71628d5883e1375$var$override,
    // Export our Events() function - can be handy as a toolkit
    Events: $a71628d5883e1375$var$Events,
    // Utilities
    getByKeyPath: $a71628d5883e1375$var$getByKeyPath,
    setByKeyPath: $a71628d5883e1375$var$setByKeyPath,
    delByKeyPath: $a71628d5883e1375$var$delByKeyPath,
    shallowClone: $a71628d5883e1375$var$shallowClone,
    deepClone: $a71628d5883e1375$var$deepClone,
    getObjectDiff: $a71628d5883e1375$var$getObjectDiff,
    asap: $a71628d5883e1375$var$asap,
    maxKey: $a71628d5883e1375$var$maxKey,
    minKey: $a71628d5883e1375$var$minKey,
    // Addon registry
    addons: [],
    // Global DB connection list
    connections: $a71628d5883e1375$var$connections,
    MultiModifyError: $a71628d5883e1375$var$exceptions.Modify,
    errnames: $a71628d5883e1375$var$errnames,
    // Export other static classes
    IndexSpec: $a71628d5883e1375$var$IndexSpec,
    TableSchema: $a71628d5883e1375$var$TableSchema,
    //
    // Dependencies
    //
    // These will automatically work in browsers with indexedDB support, or where an indexedDB polyfill has been included.
    //
    // In node.js, however, these properties must be set "manually" before instansiating a new Dexie().
    // For node.js, you need to require indexeddb-js or similar and then set these deps.
    //
    dependencies: function() {
        try {
            return {
                // Required:
                indexedDB: $a71628d5883e1375$var$_global.indexedDB || $a71628d5883e1375$var$_global.mozIndexedDB || $a71628d5883e1375$var$_global.webkitIndexedDB || $a71628d5883e1375$var$_global.msIndexedDB,
                IDBKeyRange: $a71628d5883e1375$var$_global.IDBKeyRange || $a71628d5883e1375$var$_global.webkitIDBKeyRange
            };
        } catch (e) {
            return {
                indexedDB: null,
                IDBKeyRange: null
            };
        }
    }(),
    // API Version Number: Type Number, make sure to always set a version number that can be comparable correctly. Example: 0.9, 0.91, 0.92, 1.0, 1.01, 1.1, 1.2, 1.21, etc.
    semVer: $a71628d5883e1375$var$DEXIE_VERSION,
    version: $a71628d5883e1375$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    }),
    // https://github.com/dfahlander/Dexie.js/issues/186
    // typescript compiler tsc in mode ts-->es5 & commonJS, will expect require() to return
    // x.default. Workaround: Set Dexie.default = Dexie.
    default: $a71628d5883e1375$var$Dexie,
    // Make it possible to import {Dexie} (non-default import)
    // Reason 1: May switch to that in future.
    // Reason 2: We declare it both default and named exported in d.ts to make it possible
    // to let addons extend the Dexie interface with Typescript 2.1 (works only when explicitely
    // exporting the symbol, not just default exporting)
    Dexie: $a71628d5883e1375$var$Dexie
});
// Map DOMErrors and DOMExceptions to corresponding Dexie errors. May change in Dexie v2.0.
$a71628d5883e1375$var$Promise.rejectionMapper = $a71628d5883e1375$var$mapError;
// Initialize dbNamesDB (won't ever be opened on chromium browsers')
$a71628d5883e1375$var$dbNamesDB = new $a71628d5883e1375$var$Dexie('__dbnames');
$a71628d5883e1375$var$dbNamesDB.version(1).stores({
    dbnames: 'name'
});
(function() {
    // Migrate from Dexie 1.x database names stored in localStorage:
    var DBNAMES = 'Dexie.DatabaseNames';
    try {
        if ($a71628d5883e1375$var$_global.document !== undefined) {
            // Have localStorage and is not executing in a worker. Lets migrate from Dexie 1.x.
            JSON.parse(localStorage.getItem(DBNAMES) || "[]").forEach(function(name) {
                return $a71628d5883e1375$var$dbNamesDB.dbnames.put({
                    name: name
                }).catch($a71628d5883e1375$var$nop);
            });
            localStorage.removeItem(DBNAMES);
        }
    } catch (_e) {}
})();
var $a71628d5883e1375$export$2e2bcd8739ae039 = $a71628d5883e1375$var$Dexie;

});

parcelRegister("qziBq", function(module, exports) {

var $2LX06 = parcelRequire("2LX06");
var $04fdcf7a3248ff46$require$Buffer = $2LX06.Buffer;

var $f2AU3 = parcelRequire("f2AU3");







/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.LinkTarget = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.addLinkAttributes = addLinkAttributes;
                exports.deprecated = deprecated;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _base_factory = __w_pdfjs_require__(135);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
                var SVG_NS = "http://www.w3.org/2000/svg";
                var PixelsPerInch = {
                    CSS: 96.0,
                    PDF: 72.0,
                    get PDF_TO_CSS_UNITS () {
                        return (0, _util.shadow)(this, "PDF_TO_CSS_UNITS", this.CSS / this.PDF);
                    }
                };
                exports.PixelsPerInch = PixelsPerInch;
                var DOMCanvasFactory = /*#__PURE__*/ function(_BaseCanvasFactory) {
                    _inherits(DOMCanvasFactory, _BaseCanvasFactory);
                    var _super = _createSuper(DOMCanvasFactory);
                    function DOMCanvasFactory() {
                        var _this;
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument;
                        _classCallCheck(this, DOMCanvasFactory);
                        _this = _super.call(this);
                        _this._document = ownerDocument;
                        return _this;
                    }
                    _createClass(DOMCanvasFactory, [
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                var canvas = this._document.createElement("canvas");
                                canvas.width = width;
                                canvas.height = height;
                                return canvas;
                            }
                        }
                    ]);
                    return DOMCanvasFactory;
                }(_base_factory.BaseCanvasFactory);
                exports.DOMCanvasFactory = DOMCanvasFactory;
                function fetchData(_x) {
                    return _fetchData.apply(this, arguments);
                }
                function _fetchData() {
                    _fetchData = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(url) {
                        var asTypedArray, response, _args = arguments;
                        return _regenerator["default"].wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    asTypedArray = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                                    if (!isValidFetchUrl(url, document.baseURI)) {
                                        _context.next = 21;
                                        break;
                                    }
                                    _context.next = 4;
                                    return fetch(url);
                                case 4:
                                    response = _context.sent;
                                    if (response.ok) {
                                        _context.next = 7;
                                        break;
                                    }
                                    throw new Error(response.statusText);
                                case 7:
                                    if (!asTypedArray) {
                                        _context.next = 15;
                                        break;
                                    }
                                    _context.t1 = Uint8Array;
                                    _context.next = 11;
                                    return response.arrayBuffer();
                                case 11:
                                    _context.t2 = _context.sent;
                                    _context.t0 = new _context.t1(_context.t2);
                                    _context.next = 20;
                                    break;
                                case 15:
                                    _context.t3 = _util.stringToBytes;
                                    _context.next = 18;
                                    return response.text();
                                case 18:
                                    _context.t4 = _context.sent;
                                    _context.t0 = (0, _context.t3)(_context.t4);
                                case 20:
                                    return _context.abrupt("return", _context.t0);
                                case 21:
                                    return _context.abrupt("return", new Promise(function(resolve, reject) {
                                        var request = new XMLHttpRequest();
                                        request.open("GET", url, true);
                                        if (asTypedArray) request.responseType = "arraybuffer";
                                        request.onreadystatechange = function() {
                                            if (request.readyState !== XMLHttpRequest.DONE) return;
                                            if (request.status === 200 || request.status === 0) {
                                                var data;
                                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                                if (data) {
                                                    resolve(data);
                                                    return;
                                                }
                                            }
                                            reject(new Error(request.statusText));
                                        };
                                        request.send(null);
                                    }));
                                case 22:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return _fetchData.apply(this, arguments);
                }
                var DOMCMapReaderFactory = /*#__PURE__*/ function(_BaseCMapReaderFactor) {
                    _inherits(DOMCMapReaderFactory, _BaseCMapReaderFactor);
                    var _super2 = _createSuper(DOMCMapReaderFactory);
                    function DOMCMapReaderFactory() {
                        _classCallCheck(this, DOMCMapReaderFactory);
                        return _super2.apply(this, arguments);
                    }
                    _createClass(DOMCMapReaderFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                return fetchData(url, this.isCompressed).then(function(data) {
                                    return {
                                        cMapData: data,
                                        compressionType: compressionType
                                    };
                                });
                            }
                        }
                    ]);
                    return DOMCMapReaderFactory;
                }(_base_factory.BaseCMapReaderFactory);
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                var DOMStandardFontDataFactory = /*#__PURE__*/ function(_BaseStandardFontData) {
                    _inherits(DOMStandardFontDataFactory, _BaseStandardFontData);
                    var _super3 = _createSuper(DOMStandardFontDataFactory);
                    function DOMStandardFontDataFactory() {
                        _classCallCheck(this, DOMStandardFontDataFactory);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(DOMStandardFontDataFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                return fetchData(url, true);
                            }
                        }
                    ]);
                    return DOMStandardFontDataFactory;
                }(_base_factory.BaseStandardFontDataFactory);
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                var DOMSVGFactory = /*#__PURE__*/ function(_BaseSVGFactory) {
                    _inherits(DOMSVGFactory, _BaseSVGFactory);
                    var _super4 = _createSuper(DOMSVGFactory);
                    function DOMSVGFactory() {
                        _classCallCheck(this, DOMSVGFactory);
                        return _super4.apply(this, arguments);
                    }
                    _createClass(DOMSVGFactory, [
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                return document.createElementNS(SVG_NS, type);
                            }
                        }
                    ]);
                    return DOMSVGFactory;
                }(_base_factory.BaseSVGFactory);
                exports.DOMSVGFactory = DOMSVGFactory;
                var PageViewport = /*#__PURE__*/ function() {
                    function PageViewport(_ref2) {
                        var viewBox = _ref2.viewBox, scale = _ref2.scale, rotation = _ref2.rotation, _ref2$offsetX = _ref2.offsetX, offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX, _ref2$offsetY = _ref2.offsetY, offsetY = _ref2$offsetY === void 0 ? 0 : _ref2$offsetY, _ref2$dontFlip = _ref2.dontFlip, dontFlip = _ref2$dontFlip === void 0 ? false : _ref2$dontFlip;
                        _classCallCheck(this, PageViewport);
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        var centerX = (viewBox[2] + viewBox[0]) / 2;
                        var centerY = (viewBox[3] + viewBox[1]) / 2;
                        var rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        var offsetCanvasX, offsetCanvasY;
                        var width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = Math.abs(viewBox[3] - viewBox[1]) * scale;
                            height = Math.abs(viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = Math.abs(viewBox[2] - viewBox[0]) * scale;
                            height = Math.abs(viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    _createClass(PageViewport, [
                        {
                            key: "clone",
                            value: function clone() {
                                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$scale = _ref3.scale, scale = _ref3$scale === void 0 ? this.scale : _ref3$scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotation : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? this.offsetX : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? this.offsetY : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                                return new PageViewport({
                                    viewBox: this.viewBox.slice(),
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "convertToViewportPoint",
                            value: function convertToViewportPoint(x, y) {
                                return _util.Util.applyTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        },
                        {
                            key: "convertToViewportRectangle",
                            value: function convertToViewportRectangle(rect) {
                                var topLeft = _util.Util.applyTransform([
                                    rect[0],
                                    rect[1]
                                ], this.transform);
                                var bottomRight = _util.Util.applyTransform([
                                    rect[2],
                                    rect[3]
                                ], this.transform);
                                return [
                                    topLeft[0],
                                    topLeft[1],
                                    bottomRight[0],
                                    bottomRight[1]
                                ];
                            }
                        },
                        {
                            key: "convertToPdfPoint",
                            value: function convertToPdfPoint(x, y) {
                                return _util.Util.applyInverseTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        }
                    ]);
                    return PageViewport;
                }();
                exports.PageViewport = PageViewport;
                var RenderingCancelledException = /*#__PURE__*/ function(_BaseException) {
                    _inherits(RenderingCancelledException, _BaseException);
                    var _super5 = _createSuper(RenderingCancelledException);
                    function RenderingCancelledException(msg, type) {
                        var _this2;
                        _classCallCheck(this, RenderingCancelledException);
                        _this2 = _super5.call(this, msg, "RenderingCancelledException");
                        _this2.type = type;
                        return _this2;
                    }
                    return RenderingCancelledException;
                }(_util.BaseException);
                exports.RenderingCancelledException = RenderingCancelledException;
                var LinkTarget = {
                    NONE: 0,
                    SELF: 1,
                    BLANK: 2,
                    PARENT: 3,
                    TOP: 4
                };
                exports.LinkTarget = LinkTarget;
                function addLinkAttributes(link) {
                    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, url = _ref4.url, target = _ref4.target, rel = _ref4.rel, _ref4$enabled = _ref4.enabled, enabled = _ref4$enabled === void 0 ? true : _ref4$enabled;
                    (0, _util.assert)(url && typeof url === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
                    var urlNullRemoved = (0, _util.removeNullCharacters)(url);
                    if (enabled) link.href = link.title = urlNullRemoved;
                    else {
                        link.href = "";
                        link.title = "Disabled: ".concat(urlNullRemoved);
                        link.onclick = function() {
                            return false;
                        };
                    }
                    var targetStr = "";
                    switch(target){
                        case LinkTarget.NONE:
                            break;
                        case LinkTarget.SELF:
                            targetStr = "_self";
                            break;
                        case LinkTarget.BLANK:
                            targetStr = "_blank";
                            break;
                        case LinkTarget.PARENT:
                            targetStr = "_parent";
                            break;
                        case LinkTarget.TOP:
                            targetStr = "_top";
                            break;
                    }
                    link.target = targetStr;
                    link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
                }
                function isDataScheme(url) {
                    var ii = url.length;
                    var i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url) {
                    var anchor = url.indexOf("#");
                    var query = url.indexOf("?");
                    var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
                    return url.substring(url.lastIndexOf("/", end) + 1, end);
                }
                function getPdfFilenameFromUrl(url) {
                    var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    var splitURI = reURI.exec(url);
                    var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch (ex) {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                var StatTimer = /*#__PURE__*/ function() {
                    function StatTimer() {
                        _classCallCheck(this, StatTimer);
                        this.started = Object.create(null);
                        this.times = [];
                    }
                    _createClass(StatTimer, [
                        {
                            key: "time",
                            value: function time(name) {
                                if (name in this.started) (0, _util.warn)("Timer is already running for ".concat(name));
                                this.started[name] = Date.now();
                            }
                        },
                        {
                            key: "timeEnd",
                            value: function timeEnd(name) {
                                if (!(name in this.started)) (0, _util.warn)("Timer has not been started for ".concat(name));
                                this.times.push({
                                    name: name,
                                    start: this.started[name],
                                    end: Date.now()
                                });
                                delete this.started[name];
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                var outBuf = [];
                                var longest = 0;
                                var _iterator = _createForOfIteratorHelper(this.times), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var time = _step.value;
                                        var name = time.name;
                                        if (name.length > longest) longest = name.length;
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                var _iterator2 = _createForOfIteratorHelper(this.times), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var _time = _step2.value;
                                        var duration = _time.end - _time.start;
                                        outBuf.push("".concat(_time.name.padEnd(longest), " ").concat(duration, "ms\n"));
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return outBuf.join("");
                            }
                        }
                    ]);
                    return StatTimer;
                }();
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        var _ref5 = baseUrl ? new URL(url, baseUrl) : new URL(url), protocol = _ref5.protocol;
                        return protocol === "http:" || protocol === "https:";
                    } catch (ex) {
                        return false;
                    }
                }
                function loadScript(src) {
                    var removeScriptElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    return new Promise(function(resolve, reject) {
                        var script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error("Cannot load script at: ".concat(script.src)));
                        };
                        (document.head || document.documentElement).appendChild(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                var pdfDateStringRegex;
                var PDFDateString = /*#__PURE__*/ function() {
                    function PDFDateString() {
                        _classCallCheck(this, PDFDateString);
                    }
                    _createClass(PDFDateString, null, [
                        {
                            key: "toDateObject",
                            value: function toDateObject(input) {
                                if (!input || !(0, _util.isString)(input)) return null;
                                if (!pdfDateStringRegex) pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                                var matches = pdfDateStringRegex.exec(input);
                                if (!matches) return null;
                                var year = parseInt(matches[1], 10);
                                var month = parseInt(matches[2], 10);
                                month = month >= 1 && month <= 12 ? month - 1 : 0;
                                var day = parseInt(matches[3], 10);
                                day = day >= 1 && day <= 31 ? day : 1;
                                var hour = parseInt(matches[4], 10);
                                hour = hour >= 0 && hour <= 23 ? hour : 0;
                                var minute = parseInt(matches[5], 10);
                                minute = minute >= 0 && minute <= 59 ? minute : 0;
                                var second = parseInt(matches[6], 10);
                                second = second >= 0 && second <= 59 ? second : 0;
                                var universalTimeRelation = matches[7] || "Z";
                                var offsetHour = parseInt(matches[8], 10);
                                offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                                var offsetMinute = parseInt(matches[9], 10) || 0;
                                offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                                if (universalTimeRelation === "-") {
                                    hour += offsetHour;
                                    minute += offsetMinute;
                                } else if (universalTimeRelation === "+") {
                                    hour -= offsetHour;
                                    minute -= offsetMinute;
                                }
                                return new Date(Date.UTC(year, month, day, hour, minute, second));
                            }
                        }
                    ]);
                    return PDFDateString;
                }();
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, _ref6) {
                    var _ref6$scale = _ref6.scale, scale = _ref6$scale === void 0 ? 1 : _ref6$scale, _ref6$rotation = _ref6.rotation, rotation = _ref6$rotation === void 0 ? 0 : _ref6$rotation;
                    var _xfaPage$attributes$s = xfaPage.attributes.style, width = _xfaPage$attributes$s.width, height = _xfaPage$attributes$s.height;
                    var viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
            /***/ },
            /* 2 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                module1.exports = __w_pdfjs_require__(3);
            /***/ },
            /* 3 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                /* module decorator */ module1 = __w_pdfjs_require__.nmd(module1);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var runtime = function(exports) {
                    "use strict";
                    var Op = Object.prototype;
                    var hasOwn = Op.hasOwnProperty;
                    var undefined1;
                    var $Symbol = typeof Symbol === "function" ? Symbol : {};
                    var iteratorSymbol = $Symbol.iterator || "@@iterator";
                    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
                    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
                    function define(obj, key, value) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true
                        });
                        return obj[key];
                    }
                    try {
                        define({}, "");
                    } catch (err) {
                        define = function define(obj, key, value) {
                            return obj[key] = value;
                        };
                    }
                    function wrap(innerFn, outerFn, self1, tryLocsList) {
                        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                        var generator = Object.create(protoGenerator.prototype);
                        var context = new Context(tryLocsList || []);
                        generator._invoke = makeInvokeMethod(innerFn, self1, context);
                        return generator;
                    }
                    exports.wrap = wrap;
                    function tryCatch(fn, obj, arg) {
                        try {
                            return {
                                type: "normal",
                                arg: fn.call(obj, arg)
                            };
                        } catch (err) {
                            return {
                                type: "throw",
                                arg: err
                            };
                        }
                    }
                    var GenStateSuspendedStart = "suspendedStart";
                    var GenStateSuspendedYield = "suspendedYield";
                    var GenStateExecuting = "executing";
                    var GenStateCompleted = "completed";
                    var ContinueSentinel = {};
                    function Generator() {}
                    function GeneratorFunction() {}
                    function GeneratorFunctionPrototype() {}
                    var IteratorPrototype = {};
                    define(IteratorPrototype, iteratorSymbol, function() {
                        return this;
                    });
                    var getProto = Object.getPrototypeOf;
                    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) IteratorPrototype = NativeIteratorPrototype;
                    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
                    GeneratorFunction.prototype = GeneratorFunctionPrototype;
                    define(Gp, "constructor", GeneratorFunctionPrototype);
                    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
                    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
                    function defineIteratorMethods(prototype) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(method) {
                            define(prototype, method, function(arg) {
                                return this._invoke(method, arg);
                            });
                        });
                    }
                    exports.isGeneratorFunction = function(genFun) {
                        var ctor = typeof genFun === "function" && genFun.constructor;
                        return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
                    };
                    exports.mark = function(genFun) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                        else {
                            genFun.__proto__ = GeneratorFunctionPrototype;
                            define(genFun, toStringTagSymbol, "GeneratorFunction");
                        }
                        genFun.prototype = Object.create(Gp);
                        return genFun;
                    };
                    exports.awrap = function(arg) {
                        return {
                            __await: arg
                        };
                    };
                    function AsyncIterator(generator, PromiseImpl) {
                        function invoke(method, arg, resolve, reject) {
                            var record = tryCatch(generator[method], generator, arg);
                            if (record.type === "throw") reject(record.arg);
                            else {
                                var result = record.arg;
                                var value = result.value;
                                if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                                    invoke("next", value, resolve, reject);
                                }, function(err) {
                                    invoke("throw", err, resolve, reject);
                                });
                                return PromiseImpl.resolve(value).then(function(unwrapped) {
                                    result.value = unwrapped;
                                    resolve(result);
                                }, function(error) {
                                    return invoke("throw", error, resolve, reject);
                                });
                            }
                        }
                        var previousPromise;
                        function enqueue(method, arg) {
                            function callInvokeWithMethodAndArg() {
                                return new PromiseImpl(function(resolve, reject) {
                                    invoke(method, arg, resolve, reject);
                                });
                            }
                            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                        }
                        this._invoke = enqueue;
                    }
                    defineIteratorMethods(AsyncIterator.prototype);
                    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
                        return this;
                    });
                    exports.AsyncIterator = AsyncIterator;
                    exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
                        if (PromiseImpl === void 0) PromiseImpl = Promise;
                        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
                        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
                            return result.done ? result.value : iter.next();
                        });
                    };
                    function makeInvokeMethod(innerFn, self1, context) {
                        var state = GenStateSuspendedStart;
                        return function invoke(method, arg) {
                            if (state === GenStateExecuting) throw new Error("Generator is already running");
                            if (state === GenStateCompleted) {
                                if (method === "throw") throw arg;
                                return doneResult();
                            }
                            context.method = method;
                            context.arg = arg;
                            while(true){
                                var delegate = context.delegate;
                                if (delegate) {
                                    var delegateResult = maybeInvokeDelegate(delegate, context);
                                    if (delegateResult) {
                                        if (delegateResult === ContinueSentinel) continue;
                                        return delegateResult;
                                    }
                                }
                                if (context.method === "next") context.sent = context._sent = context.arg;
                                else if (context.method === "throw") {
                                    if (state === GenStateSuspendedStart) {
                                        state = GenStateCompleted;
                                        throw context.arg;
                                    }
                                    context.dispatchException(context.arg);
                                } else if (context.method === "return") context.abrupt("return", context.arg);
                                state = GenStateExecuting;
                                var record = tryCatch(innerFn, self1, context);
                                if (record.type === "normal") {
                                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                                    if (record.arg === ContinueSentinel) continue;
                                    return {
                                        value: record.arg,
                                        done: context.done
                                    };
                                } else if (record.type === "throw") {
                                    state = GenStateCompleted;
                                    context.method = "throw";
                                    context.arg = record.arg;
                                }
                            }
                        };
                    }
                    function maybeInvokeDelegate(delegate, context) {
                        var method = delegate.iterator[context.method];
                        if (method === undefined1) {
                            context.delegate = null;
                            if (context.method === "throw") {
                                if (delegate.iterator["return"]) {
                                    context.method = "return";
                                    context.arg = undefined1;
                                    maybeInvokeDelegate(delegate, context);
                                    if (context.method === "throw") return ContinueSentinel;
                                }
                                context.method = "throw";
                                context.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return ContinueSentinel;
                        }
                        var record = tryCatch(method, delegate.iterator, context.arg);
                        if (record.type === "throw") {
                            context.method = "throw";
                            context.arg = record.arg;
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        var info = record.arg;
                        if (!info) {
                            context.method = "throw";
                            context.arg = new TypeError("iterator result is not an object");
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        if (info.done) {
                            context[delegate.resultName] = info.value;
                            context.next = delegate.nextLoc;
                            if (context.method !== "return") {
                                context.method = "next";
                                context.arg = undefined1;
                            }
                        } else return info;
                        context.delegate = null;
                        return ContinueSentinel;
                    }
                    defineIteratorMethods(Gp);
                    define(Gp, toStringTagSymbol, "Generator");
                    define(Gp, iteratorSymbol, function() {
                        return this;
                    });
                    define(Gp, "toString", function() {
                        return "[object Generator]";
                    });
                    function pushTryEntry(locs) {
                        var entry = {
                            tryLoc: locs[0]
                        };
                        if (1 in locs) entry.catchLoc = locs[1];
                        if (2 in locs) {
                            entry.finallyLoc = locs[2];
                            entry.afterLoc = locs[3];
                        }
                        this.tryEntries.push(entry);
                    }
                    function resetTryEntry(entry) {
                        var record = entry.completion || {};
                        record.type = "normal";
                        delete record.arg;
                        entry.completion = record;
                    }
                    function Context(tryLocsList) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ];
                        tryLocsList.forEach(pushTryEntry, this);
                        this.reset(true);
                    }
                    exports.keys = function(object) {
                        var keys = [];
                        for(var key in object)keys.push(key);
                        keys.reverse();
                        return function next() {
                            while(keys.length){
                                var key = keys.pop();
                                if (key in object) {
                                    next.value = key;
                                    next.done = false;
                                    return next;
                                }
                            }
                            next.done = true;
                            return next;
                        };
                    };
                    function values(iterable) {
                        if (iterable) {
                            var iteratorMethod = iterable[iteratorSymbol];
                            if (iteratorMethod) return iteratorMethod.call(iterable);
                            if (typeof iterable.next === "function") return iterable;
                            if (!isNaN(iterable.length)) {
                                var i = -1, next = function next() {
                                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                    next.value = undefined1;
                                    next.done = true;
                                    return next;
                                };
                                return next.next = next;
                            }
                        }
                        return {
                            next: doneResult
                        };
                    }
                    exports.values = values;
                    function doneResult() {
                        return {
                            value: undefined1,
                            done: true
                        };
                    }
                    Context.prototype = {
                        constructor: Context,
                        reset: function reset(skipTempReset) {
                            this.prev = 0;
                            this.next = 0;
                            this.sent = this._sent = undefined1;
                            this.done = false;
                            this.delegate = null;
                            this.method = "next";
                            this.arg = undefined1;
                            this.tryEntries.forEach(resetTryEntry);
                            if (!skipTempReset) {
                                for(var name in this)if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined1;
                            }
                        },
                        stop: function stop() {
                            this.done = true;
                            var rootEntry = this.tryEntries[0];
                            var rootRecord = rootEntry.completion;
                            if (rootRecord.type === "throw") throw rootRecord.arg;
                            return this.rval;
                        },
                        dispatchException: function dispatchException(exception) {
                            if (this.done) throw exception;
                            var context = this;
                            function handle(loc, caught) {
                                record.type = "throw";
                                record.arg = exception;
                                context.next = loc;
                                if (caught) {
                                    context.method = "next";
                                    context.arg = undefined1;
                                }
                                return !!caught;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                var record = entry.completion;
                                if (entry.tryLoc === "root") return handle("end");
                                if (entry.tryLoc <= this.prev) {
                                    var hasCatch = hasOwn.call(entry, "catchLoc");
                                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                                    if (hasCatch && hasFinally) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else if (hasCatch) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                    } else if (hasFinally) {
                                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else throw new Error("try statement without catch or finally");
                                }
                            }
                        },
                        abrupt: function abrupt(type, arg) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                                    var finallyEntry = entry;
                                    break;
                                }
                            }
                            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) finallyEntry = null;
                            var record = finallyEntry ? finallyEntry.completion : {};
                            record.type = type;
                            record.arg = arg;
                            if (finallyEntry) {
                                this.method = "next";
                                this.next = finallyEntry.finallyLoc;
                                return ContinueSentinel;
                            }
                            return this.complete(record);
                        },
                        complete: function complete(record, afterLoc) {
                            if (record.type === "throw") throw record.arg;
                            if (record.type === "break" || record.type === "continue") this.next = record.arg;
                            else if (record.type === "return") {
                                this.rval = this.arg = record.arg;
                                this.method = "return";
                                this.next = "end";
                            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
                            return ContinueSentinel;
                        },
                        finish: function finish(finallyLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.finallyLoc === finallyLoc) {
                                    this.complete(entry.completion, entry.afterLoc);
                                    resetTryEntry(entry);
                                    return ContinueSentinel;
                                }
                            }
                        },
                        "catch": function _catch(tryLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc === tryLoc) {
                                    var record = entry.completion;
                                    if (record.type === "throw") {
                                        var thrown = record.arg;
                                        resetTryEntry(entry);
                                    }
                                    return thrown;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                            this.delegate = {
                                iterator: values(iterable),
                                resultName: resultName,
                                nextLoc: nextLoc
                            };
                            if (this.method === "next") this.arg = undefined1;
                            return ContinueSentinel;
                        }
                    };
                    return exports;
                }(_typeof(module1) === "object" ? module1.exports : {});
                try {
                    regeneratorRuntime = runtime;
                } catch (accidentalStrictMode) {
                    if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") globalThis.regeneratorRuntime = runtime;
                    else Function("r", "regeneratorRuntime = r")(runtime);
                }
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.UNSUPPORTED_FEATURES = exports.TextRenderingMode = exports.StreamType = exports.RenderingIntentFlag = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.IsLittleEndianCached = exports.IsEvalSupportedCached = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FontType = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMode = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.arrayByteLength = arrayByteLength;
                exports.arraysToBytes = arraysToBytes;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createObjectURL = createObjectURL;
                exports.createPromiseCapability = createPromiseCapability;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.escapeString = escapeString;
                exports.getModificationDate = getModificationDate;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isAscii = isAscii;
                exports.isBool = isBool;
                exports.isNum = isNum;
                exports.isSameOrigin = isSameOrigin;
                exports.isString = isString;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.removeNullCharacters = removeNullCharacters;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF16BEString = stringToUTF16BEString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                __w_pdfjs_require__(5);
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                var FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                var RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                var AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                var PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                var TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                var ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                var AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                var AnnotationStateModelType = {
                    MARKED: "Marked",
                    REVIEW: "Review"
                };
                exports.AnnotationStateModelType = AnnotationStateModelType;
                var AnnotationMarkedState = {
                    MARKED: "Marked",
                    UNMARKED: "Unmarked"
                };
                exports.AnnotationMarkedState = AnnotationMarkedState;
                var AnnotationReviewState = {
                    ACCEPTED: "Accepted",
                    REJECTED: "Rejected",
                    CANCELLED: "Cancelled",
                    COMPLETED: "Completed",
                    NONE: "None"
                };
                exports.AnnotationReviewState = AnnotationReviewState;
                var AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                var AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                var AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                var AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                var AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                var DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                var PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                var StreamType = {
                    UNKNOWN: "UNKNOWN",
                    FLATE: "FLATE",
                    LZW: "LZW",
                    DCT: "DCT",
                    JPX: "JPX",
                    JBIG: "JBIG",
                    A85: "A85",
                    AHX: "AHX",
                    CCF: "CCF",
                    RLX: "RLX"
                };
                exports.StreamType = StreamType;
                var FontType = {
                    UNKNOWN: "UNKNOWN",
                    TYPE1: "TYPE1",
                    TYPE1STANDARD: "TYPE1STANDARD",
                    TYPE1C: "TYPE1C",
                    CIDFONTTYPE0: "CIDFONTTYPE0",
                    CIDFONTTYPE0C: "CIDFONTTYPE0C",
                    TRUETYPE: "TRUETYPE",
                    CIDFONTTYPE2: "CIDFONTTYPE2",
                    TYPE3: "TYPE3",
                    OPENTYPE: "OPENTYPE",
                    TYPE0: "TYPE0",
                    MMTYPE1: "MMTYPE1"
                };
                exports.FontType = FontType;
                var VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                var CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1,
                    STREAM: 2
                };
                exports.CMapCompressionType = CMapCompressionType;
                var OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotations: 78,
                    endAnnotations: 79,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintJpegXObject: 82,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                var UNSUPPORTED_FEATURES = {
                    unknown: "unknown",
                    forms: "forms",
                    javaScript: "javaScript",
                    signatures: "signatures",
                    smask: "smask",
                    shadingPattern: "shadingPattern",
                    font: "font",
                    errorTilingPattern: "errorTilingPattern",
                    errorExtGState: "errorExtGState",
                    errorXObject: "errorXObject",
                    errorFontLoadType3: "errorFontLoadType3",
                    errorFontState: "errorFontState",
                    errorFontMissing: "errorFontMissing",
                    errorFontTranslate: "errorFontTranslate",
                    errorColorSpace: "errorColorSpace",
                    errorOperatorList: "errorOperatorList",
                    errorFontToUnicode: "errorFontToUnicode",
                    errorFontLoadNative: "errorFontLoadNative",
                    errorFontBuildPath: "errorFontBuildPath",
                    errorFontGetPath: "errorFontGetPath",
                    errorMarkedContent: "errorMarkedContent",
                    errorContentSubStream: "errorContentSubStream"
                };
                exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
                var PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                var verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log("Info: ".concat(msg));
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log("Warning: ".concat(msg));
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function isSameOrigin(baseUrl, otherUrl) {
                    var base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch (e) {
                        return false;
                    }
                    var other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                }
                function _isValidProtocol(url) {
                    if (!url) return false;
                    switch(url.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url) {
                    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                var dots = url.match(/\./g);
                                if (dots && dots.length >= 2) url = "http://".concat(url);
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch (ex) {}
                        }
                        var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch (ex) {}
                    return null;
                }
                function shadow(obj, prop, value) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                var BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                var PasswordException = /*#__PURE__*/ function(_BaseException) {
                    _inherits(PasswordException, _BaseException);
                    var _super = _createSuper(PasswordException);
                    function PasswordException(msg, code) {
                        var _this;
                        _classCallCheck(this, PasswordException);
                        _this = _super.call(this, msg, "PasswordException");
                        _this.code = code;
                        return _this;
                    }
                    return PasswordException;
                }(BaseException);
                exports.PasswordException = PasswordException;
                var UnknownErrorException = /*#__PURE__*/ function(_BaseException2) {
                    _inherits(UnknownErrorException, _BaseException2);
                    var _super2 = _createSuper(UnknownErrorException);
                    function UnknownErrorException(msg, details) {
                        var _this2;
                        _classCallCheck(this, UnknownErrorException);
                        _this2 = _super2.call(this, msg, "UnknownErrorException");
                        _this2.details = details;
                        return _this2;
                    }
                    return UnknownErrorException;
                }(BaseException);
                exports.UnknownErrorException = UnknownErrorException;
                var InvalidPDFException = /*#__PURE__*/ function(_BaseException3) {
                    _inherits(InvalidPDFException, _BaseException3);
                    var _super3 = _createSuper(InvalidPDFException);
                    function InvalidPDFException(msg) {
                        _classCallCheck(this, InvalidPDFException);
                        return _super3.call(this, msg, "InvalidPDFException");
                    }
                    return InvalidPDFException;
                }(BaseException);
                exports.InvalidPDFException = InvalidPDFException;
                var MissingPDFException = /*#__PURE__*/ function(_BaseException4) {
                    _inherits(MissingPDFException, _BaseException4);
                    var _super4 = _createSuper(MissingPDFException);
                    function MissingPDFException(msg) {
                        _classCallCheck(this, MissingPDFException);
                        return _super4.call(this, msg, "MissingPDFException");
                    }
                    return MissingPDFException;
                }(BaseException);
                exports.MissingPDFException = MissingPDFException;
                var UnexpectedResponseException = /*#__PURE__*/ function(_BaseException5) {
                    _inherits(UnexpectedResponseException, _BaseException5);
                    var _super5 = _createSuper(UnexpectedResponseException);
                    function UnexpectedResponseException(msg, status) {
                        var _this3;
                        _classCallCheck(this, UnexpectedResponseException);
                        _this3 = _super5.call(this, msg, "UnexpectedResponseException");
                        _this3.status = status;
                        return _this3;
                    }
                    return UnexpectedResponseException;
                }(BaseException);
                exports.UnexpectedResponseException = UnexpectedResponseException;
                var FormatError = /*#__PURE__*/ function(_BaseException6) {
                    _inherits(FormatError, _BaseException6);
                    var _super6 = _createSuper(FormatError);
                    function FormatError(msg) {
                        _classCallCheck(this, FormatError);
                        return _super6.call(this, msg, "FormatError");
                    }
                    return FormatError;
                }(BaseException);
                exports.FormatError = FormatError;
                var AbortException = /*#__PURE__*/ function(_BaseException7) {
                    _inherits(AbortException, _BaseException7);
                    var _super7 = _createSuper(AbortException);
                    function AbortException(msg) {
                        _classCallCheck(this, AbortException);
                        return _super7.call(this, msg, "AbortException");
                    }
                    return AbortException;
                }(BaseException);
                exports.AbortException = AbortException;
                var NullCharactersRegExp = /\x00+/g;
                var InvisibleCharactersRegExp = /[\x01-\x1F]/g;
                function removeNullCharacters(str) {
                    var replaceInvisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    if (typeof str !== "string") {
                        warn("The argument for removeNullCharacters must be a string.");
                        return str;
                    }
                    if (replaceInvisible) str = str.replace(InvisibleCharactersRegExp, " ");
                    return str.replace(NullCharactersRegExp, "");
                }
                function bytesToString(bytes) {
                    assert(bytes !== null && _typeof(bytes) === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
                    var length = bytes.length;
                    var MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    var strBuf = [];
                    for(var i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        var chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    assert(typeof str === "string", "Invalid argument for stringToBytes");
                    var length = str.length;
                    var bytes = new Uint8Array(length);
                    for(var i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function arrayByteLength(arr) {
                    if (arr.length !== undefined) return arr.length;
                    assert(arr.byteLength !== undefined, "arrayByteLength - invalid argument.");
                    return arr.byteLength;
                }
                function arraysToBytes(arr) {
                    var length = arr.length;
                    if (length === 1 && arr[0] instanceof Uint8Array) return arr[0];
                    var resultLength = 0;
                    for(var i = 0; i < length; i++)resultLength += arrayByteLength(arr[i]);
                    var pos = 0;
                    var data = new Uint8Array(resultLength);
                    for(var _i = 0; _i < length; _i++){
                        var item = arr[_i];
                        if (!(item instanceof Uint8Array)) {
                            if (typeof item === "string") item = stringToBytes(item);
                            else item = new Uint8Array(item);
                        }
                        var itemLength = item.byteLength;
                        data.set(item, pos);
                        pos += itemLength;
                    }
                    return data;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    var obj = Object.create(null);
                    var _iterator = _createForOfIteratorHelper(map), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];
                            obj[key] = value;
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return obj;
                }
                function isLittleEndian() {
                    var buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    var view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                var IsLittleEndianCached = {
                    get value () {
                        return shadow(this, "value", isLittleEndian());
                    }
                };
                exports.IsLittleEndianCached = IsLittleEndianCached;
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                var IsEvalSupportedCached = {
                    get value () {
                        return shadow(this, "value", isEvalSupported());
                    }
                };
                exports.IsEvalSupportedCached = IsEvalSupportedCached;
                var hexNumbers = _toConsumableArray(Array(256).keys()).map(function(n) {
                    return n.toString(16).padStart(2, "0");
                });
                var Util = /*#__PURE__*/ function() {
                    function Util() {
                        _classCallCheck(this, Util);
                    }
                    _createClass(Util, null, [
                        {
                            key: "makeHexColor",
                            value: function makeHexColor(r, g, b) {
                                return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(m1, m2) {
                                return [
                                    m1[0] * m2[0] + m1[2] * m2[1],
                                    m1[1] * m2[0] + m1[3] * m2[1],
                                    m1[0] * m2[2] + m1[2] * m2[3],
                                    m1[1] * m2[2] + m1[3] * m2[3],
                                    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                                    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                                ];
                            }
                        },
                        {
                            key: "applyTransform",
                            value: function applyTransform(p, m) {
                                var xt = p[0] * m[0] + p[1] * m[2] + m[4];
                                var yt = p[0] * m[1] + p[1] * m[3] + m[5];
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "applyInverseTransform",
                            value: function applyInverseTransform(p, m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                                var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "getAxialAlignedBoundingBox",
                            value: function getAxialAlignedBoundingBox(r, m) {
                                var p1 = Util.applyTransform(r, m);
                                var p2 = Util.applyTransform(r.slice(2, 4), m);
                                var p3 = Util.applyTransform([
                                    r[0],
                                    r[3]
                                ], m);
                                var p4 = Util.applyTransform([
                                    r[2],
                                    r[1]
                                ], m);
                                return [
                                    Math.min(p1[0], p2[0], p3[0], p4[0]),
                                    Math.min(p1[1], p2[1], p3[1], p4[1]),
                                    Math.max(p1[0], p2[0], p3[0], p4[0]),
                                    Math.max(p1[1], p2[1], p3[1], p4[1])
                                ];
                            }
                        },
                        {
                            key: "inverseTransform",
                            value: function inverseTransform(m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                return [
                                    m[3] / d,
                                    -m[1] / d,
                                    -m[2] / d,
                                    m[0] / d,
                                    (m[2] * m[5] - m[4] * m[3]) / d,
                                    (m[4] * m[1] - m[5] * m[0]) / d
                                ];
                            }
                        },
                        {
                            key: "apply3dTransform",
                            value: function apply3dTransform(m, v) {
                                return [
                                    m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
                                    m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
                                    m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
                                ];
                            }
                        },
                        {
                            key: "singularValueDecompose2dScale",
                            value: function singularValueDecompose2dScale(m) {
                                var transpose = [
                                    m[0],
                                    m[2],
                                    m[1],
                                    m[3]
                                ];
                                var a = m[0] * transpose[0] + m[1] * transpose[2];
                                var b = m[0] * transpose[1] + m[1] * transpose[3];
                                var c = m[2] * transpose[0] + m[3] * transpose[2];
                                var d = m[2] * transpose[1] + m[3] * transpose[3];
                                var first = (a + d) / 2;
                                var second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
                                var sx = first + second || 1;
                                var sy = first - second || 1;
                                return [
                                    Math.sqrt(sx),
                                    Math.sqrt(sy)
                                ];
                            }
                        },
                        {
                            key: "normalizeRect",
                            value: function normalizeRect(rect) {
                                var r = rect.slice(0);
                                if (rect[0] > rect[2]) {
                                    r[0] = rect[2];
                                    r[2] = rect[0];
                                }
                                if (rect[1] > rect[3]) {
                                    r[1] = rect[3];
                                    r[3] = rect[1];
                                }
                                return r;
                            }
                        },
                        {
                            key: "intersect",
                            value: function intersect(rect1, rect2) {
                                function compare(a, b) {
                                    return a - b;
                                }
                                var orderedX = [
                                    rect1[0],
                                    rect1[2],
                                    rect2[0],
                                    rect2[2]
                                ].sort(compare);
                                var orderedY = [
                                    rect1[1],
                                    rect1[3],
                                    rect2[1],
                                    rect2[3]
                                ].sort(compare);
                                var result = [];
                                rect1 = Util.normalizeRect(rect1);
                                rect2 = Util.normalizeRect(rect2);
                                if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
                                    result[0] = orderedX[1];
                                    result[2] = orderedX[2];
                                } else return null;
                                if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
                                    result[1] = orderedY[1];
                                    result[3] = orderedY[2];
                                } else return null;
                                return result;
                            }
                        },
                        {
                            key: "bezierBoundingBox",
                            value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                                var tvalues = [], bounds = [
                                    [],
                                    []
                                ];
                                var a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                                for(var i = 0; i < 2; ++i){
                                    if (i === 0) {
                                        b = 6 * x0 - 12 * x1 + 6 * x2;
                                        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                        c = 3 * x1 - 3 * x0;
                                    } else {
                                        b = 6 * y0 - 12 * y1 + 6 * y2;
                                        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                        c = 3 * y1 - 3 * y0;
                                    }
                                    if (Math.abs(a) < 1e-12) {
                                        if (Math.abs(b) < 1e-12) continue;
                                        t = -c / b;
                                        if (0 < t && t < 1) tvalues.push(t);
                                        continue;
                                    }
                                    b2ac = b * b - 4 * c * a;
                                    sqrtb2ac = Math.sqrt(b2ac);
                                    if (b2ac < 0) continue;
                                    t1 = (-b + sqrtb2ac) / (2 * a);
                                    if (0 < t1 && t1 < 1) tvalues.push(t1);
                                    t2 = (-b - sqrtb2ac) / (2 * a);
                                    if (0 < t2 && t2 < 1) tvalues.push(t2);
                                }
                                var j = tvalues.length, mt;
                                var jlen = j;
                                while(j--){
                                    t = tvalues[j];
                                    mt = 1 - t;
                                    bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                                    bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                                }
                                bounds[0][jlen] = x0;
                                bounds[1][jlen] = y0;
                                bounds[0][jlen + 1] = x3;
                                bounds[1][jlen + 1] = y3;
                                bounds[0].length = bounds[1].length = jlen + 2;
                                return [
                                    Math.min.apply(Math, _toConsumableArray(bounds[0])),
                                    Math.min.apply(Math, _toConsumableArray(bounds[1])),
                                    Math.max.apply(Math, _toConsumableArray(bounds[0])),
                                    Math.max.apply(Math, _toConsumableArray(bounds[1]))
                                ];
                            }
                        }
                    ]);
                    return Util;
                }();
                exports.Util = Util;
                var PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    var length = str.length, strBuf = [];
                    if (str[0] === "\xFE" && str[1] === "\xFF") for(var i = 2; i < length; i += 2)strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
                    else if (str[0] === "\xFF" && str[1] === "\xFE") for(var _i2 = 2; _i2 < length; _i2 += 2)strBuf.push(String.fromCharCode(str.charCodeAt(_i2 + 1) << 8 | str.charCodeAt(_i2)));
                    else for(var _i3 = 0; _i3 < length; ++_i3){
                        var code = PDFStringTranslateTable[str.charCodeAt(_i3)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(_i3));
                    }
                    return strBuf.join("");
                }
                function escapeString(str) {
                    return str.replace(/([()\\\n\r])/g, function(match) {
                        if (match === "\n") return "\\n";
                        else if (match === "\r") return "\\r";
                        return "\\".concat(match);
                    });
                }
                function isAscii(str) {
                    return /^[\x00-\x7F]*$/.test(str);
                }
                function stringToUTF16BEString(str) {
                    var buf = [
                        "\xFE\xFF"
                    ];
                    for(var i = 0, ii = str.length; i < ii; i++){
                        var _char = str.charCodeAt(i);
                        buf.push(String.fromCharCode(_char >> 8 & 0xff), String.fromCharCode(_char & 0xff));
                    }
                    return buf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isBool(v) {
                    return typeof v === "boolean";
                }
                function isNum(v) {
                    return typeof v === "number";
                }
                function isString(v) {
                    return typeof v === "string";
                }
                function isArrayBuffer(v) {
                    return _typeof(v) === "object" && v !== null && v.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(var i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate() {
                    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
                    var buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                function createPromiseCapability() {
                    var capability = Object.create(null);
                    var isSettled = false;
                    Object.defineProperty(capability, "settled", {
                        get: function get() {
                            return isSettled;
                        }
                    });
                    capability.promise = new Promise(function(resolve, reject) {
                        capability.resolve = function(data) {
                            isSettled = true;
                            resolve(data);
                        };
                        capability.reject = function(reason) {
                            isSettled = true;
                            reject(reason);
                        };
                    });
                    return capability;
                }
                function createObjectURL(data) {
                    var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var buffer = "data:".concat(contentType, ";base64,");
                    for(var i = 0, ii = data.length; i < ii; i += 3){
                        var b1 = data[i] & 0xff;
                        var b2 = data[i + 1] & 0xff;
                        var b3 = data[i + 2] & 0xff;
                        var d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        var d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        var d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var _is_node = __w_pdfjs_require__(6);
                if (typeof globalThis === "undefined" || !globalThis._pdfjsCompatibilityChecked) {
                    if (typeof globalThis === "undefined" || globalThis.Math !== Math) globalThis = __w_pdfjs_require__(7);
                    globalThis._pdfjsCompatibilityChecked = true;
                    (function checkNodeBtoa() {
                        if (globalThis.btoa || !_is_node.isNodeJS) return;
                        globalThis.btoa = function(chars) {
                            return $04fdcf7a3248ff46$require$Buffer.from(chars, "binary").toString("base64");
                        };
                    })();
                    (function checkNodeAtob() {
                        if (globalThis.atob || !_is_node.isNodeJS) return;
                        globalThis.atob = function(input) {
                            return $04fdcf7a3248ff46$require$Buffer.from(input, "base64").toString("binary");
                        };
                    })();
                    (function checkDOMMatrix() {
                        if (globalThis.DOMMatrix || !_is_node.isNodeJS) return;
                        globalThis.DOMMatrix = __w_pdfjs_require__(69);
                    })();
                    (function checkObjectFromEntries() {
                        if (Object.fromEntries) return;
                        __w_pdfjs_require__(70);
                    })();
                    (function checkPromise() {
                        if (globalThis.Promise.allSettled) return;
                        globalThis.Promise = __w_pdfjs_require__(97);
                    })();
                    (function checkReadableStream() {
                        if (globalThis.ReadableStream || !_is_node.isNodeJS) return;
                        globalThis.ReadableStream = __w_pdfjs_require__(134).ReadableStream;
                    })();
                }
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isNodeJS = void 0;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var isNodeJS = false;
                exports.isNodeJS = isNodeJS;
            /***/ },
            /* 7 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(8);
                module1.exports = __w_pdfjs_require__(10);
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var $ = __w_pdfjs_require__(9);
                var global1 = __w_pdfjs_require__(10);
                $({
                    global: true
                }, {
                    globalThis: global1
                });
            /***/ },
            /* 9 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var getOwnPropertyDescriptor = __w_pdfjs_require__(11).f;
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var redefine = __w_pdfjs_require__(50);
                var setGlobal = __w_pdfjs_require__(41);
                var copyConstructorProperties = __w_pdfjs_require__(57);
                var isForced = __w_pdfjs_require__(68);
                module1.exports = function(options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) target = global1;
                    else if (STATIC) target = global1[TARGET] || setGlobal(TARGET, {});
                    else target = (global1[TARGET] || {}).prototype;
                    if (target) for(key in source){
                        sourceProperty = source[key];
                        if (options.noTargetGet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        } else targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty == typeof targetProperty) continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                        redefine(target, key, sourceProperty, options);
                    }
                };
            /***/ },
            /* 10 */ /***/ (module1)=>{
                var check = function(it) {
                    return it && it.Math == Math && it;
                };
                module1.exports = check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof $parcel$global == 'object' && $parcel$global) || function() {
                    return this;
                }() || Function('return this')();
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var call = __w_pdfjs_require__(14);
                var propertyIsEnumerableModule = __w_pdfjs_require__(15);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var toIndexedObject = __w_pdfjs_require__(17);
                var toPropertyKey = __w_pdfjs_require__(22);
                var hasOwn = __w_pdfjs_require__(42);
                var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPropertyKey(P);
                    if (IE8_DOM_DEFINE) try {
                        return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {}
                    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
                };
            /***/ },
            /* 12 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                module1.exports = !fails(function() {
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] != 7;
                });
            /***/ },
            /* 13 */ /***/ (module1)=>{
                module1.exports = function(exec) {
                    try {
                        return !!exec();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /* 14 */ /***/ (module1)=>{
                var call = Function.prototype.call;
                module1.exports = call.bind ? call.bind(call) : function() {
                    return call.apply(call, arguments);
                };
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                var $propertyIsEnumerable = {}.propertyIsEnumerable;
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                    1: 2
                }, 1);
                exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                } : $propertyIsEnumerable;
            /***/ },
            /* 16 */ /***/ (module1)=>{
                module1.exports = function(bitmap, value) {
                    return {
                        enumerable: !(bitmap & 1),
                        configurable: !(bitmap & 2),
                        writable: !(bitmap & 4),
                        value: value
                    };
                };
            /***/ },
            /* 17 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var IndexedObject = __w_pdfjs_require__(18);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                module1.exports = function(it) {
                    return IndexedObject(requireObjectCoercible(it));
                };
            /***/ },
            /* 18 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var uncurryThis = __w_pdfjs_require__(19);
                var fails = __w_pdfjs_require__(13);
                var classof = __w_pdfjs_require__(20);
                var Object1 = global1.Object;
                var split = uncurryThis(''.split);
                module1.exports = fails(function() {
                    return !Object1('z').propertyIsEnumerable(0);
                }) ? function(it) {
                    return classof(it) == 'String' ? split(it, '') : Object1(it);
                } : Object1;
            /***/ },
            /* 19 */ /***/ (module1)=>{
                var FunctionPrototype = Function.prototype;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                var callBind = bind && bind.bind(call);
                module1.exports = bind ? function(fn) {
                    return fn && callBind(call, fn);
                } : function(fn) {
                    return fn && function() {
                        return call.apply(fn, arguments);
                    };
                };
            /***/ },
            /* 20 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toString = uncurryThis({}.toString);
                var stringSlice = uncurryThis(''.slice);
                module1.exports = function(it) {
                    return stringSlice(toString(it), 8, -1);
                };
            /***/ },
            /* 21 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var TypeError1 = global1.TypeError;
                module1.exports = function(it) {
                    if (it == undefined) throw TypeError1("Can't call method on " + it);
                    return it;
                };
            /***/ },
            /* 22 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toPrimitive = __w_pdfjs_require__(23);
                var isSymbol = __w_pdfjs_require__(26);
                module1.exports = function(argument) {
                    var key = toPrimitive(argument, 'string');
                    return isSymbol(key) ? key : key + '';
                };
            /***/ },
            /* 23 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var isObject = __w_pdfjs_require__(24);
                var isSymbol = __w_pdfjs_require__(26);
                var getMethod = __w_pdfjs_require__(33);
                var ordinaryToPrimitive = __w_pdfjs_require__(36);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TypeError1 = global1.TypeError;
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                module1.exports = function(input, pref) {
                    if (!isObject(input) || isSymbol(input)) return input;
                    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                    var result;
                    if (exoticToPrim) {
                        if (pref === undefined) pref = 'default';
                        result = call(exoticToPrim, input, pref);
                        if (!isObject(result) || isSymbol(result)) return result;
                        throw TypeError1("Can't convert object to primitive value");
                    }
                    if (pref === undefined) pref = 'number';
                    return ordinaryToPrimitive(input, pref);
                };
            /***/ },
            /* 24 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var isCallable = __w_pdfjs_require__(25);
                module1.exports = function(it) {
                    return typeof it == 'object' ? it !== null : isCallable(it);
                };
            /***/ },
            /* 25 */ /***/ (module1)=>{
                module1.exports = function(argument) {
                    return typeof argument == 'function';
                };
            /***/ },
            /* 26 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var getBuiltIn = __w_pdfjs_require__(27);
                var isCallable = __w_pdfjs_require__(25);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var USE_SYMBOL_AS_UID = __w_pdfjs_require__(29);
                var Object1 = global1.Object;
                module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                    return typeof it == 'symbol';
                } : function(it) {
                    var $Symbol = getBuiltIn('Symbol');
                    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object1(it));
                };
            /***/ },
            /* 27 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var aFunction = function(argument) {
                    return isCallable(argument) ? argument : undefined;
                };
                module1.exports = function(namespace, method) {
                    return arguments.length < 2 ? aFunction(global1[namespace]) : global1[namespace] && global1[namespace][method];
                };
            /***/ },
            /* 28 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                module1.exports = uncurryThis({}.isPrototypeOf);
            /***/ },
            /* 29 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var NATIVE_SYMBOL = __w_pdfjs_require__(30);
                module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
            /***/ },
            /* 30 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var V8_VERSION = __w_pdfjs_require__(31);
                var fails = __w_pdfjs_require__(13);
                module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                    var symbol = Symbol();
                    return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                });
            /***/ },
            /* 31 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var userAgent = __w_pdfjs_require__(32);
                var process = global1.process;
                var Deno = global1.Deno;
                var versions = process && process.versions || Deno && Deno.version;
                var v8 = versions && versions.v8;
                var match, version;
                if (v8) {
                    match = v8.split('.');
                    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
                }
                if (!version && userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                        match = userAgent.match(/Chrome\/(\d+)/);
                        if (match) version = +match[1];
                    }
                }
                module1.exports = version;
            /***/ },
            /* 32 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                module1.exports = getBuiltIn('navigator', 'userAgent') || '';
            /***/ },
            /* 33 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var aCallable = __w_pdfjs_require__(34);
                module1.exports = function(V, P) {
                    var func = V[P];
                    return func == null ? undefined : aCallable(func);
                };
            /***/ },
            /* 34 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var tryToString = __w_pdfjs_require__(35);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isCallable(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a function');
                };
            /***/ },
            /* 35 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var String1 = global1.String;
                module1.exports = function(argument) {
                    try {
                        return String1(argument);
                    } catch (error) {
                        return 'Object';
                    }
                };
            /***/ },
            /* 36 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var isCallable = __w_pdfjs_require__(25);
                var isObject = __w_pdfjs_require__(24);
                var TypeError1 = global1.TypeError;
                module1.exports = function(input, pref) {
                    var fn, val;
                    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    throw TypeError1("Can't convert object to primitive value");
                };
            /***/ },
            /* 37 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var shared = __w_pdfjs_require__(38);
                var hasOwn = __w_pdfjs_require__(42);
                var uid = __w_pdfjs_require__(44);
                var NATIVE_SYMBOL = __w_pdfjs_require__(30);
                var USE_SYMBOL_AS_UID = __w_pdfjs_require__(29);
                var WellKnownSymbolsStore = shared('wks');
                var Symbol1 = global1.Symbol;
                var symbolFor = Symbol1 && Symbol1['for'];
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
                module1.exports = function(name) {
                    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
                        var description = 'Symbol.' + name;
                        if (NATIVE_SYMBOL && hasOwn(Symbol1, name)) WellKnownSymbolsStore[name] = Symbol1[name];
                        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
                        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
                    }
                    return WellKnownSymbolsStore[name];
                };
            /***/ },
            /* 38 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var IS_PURE = __w_pdfjs_require__(39);
                var store = __w_pdfjs_require__(40);
                (module1.exports = function(key, value) {
                    return store[key] || (store[key] = value !== undefined ? value : {});
                })('versions', []).push({
                    version: '3.19.3',
                    mode: IS_PURE ? 'pure' : 'global',
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            /***/ },
            /* 39 */ /***/ (module1)=>{
                module1.exports = false;
            /***/ },
            /* 40 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var setGlobal = __w_pdfjs_require__(41);
                var SHARED = '__core-js_shared__';
                var store = global1[SHARED] || setGlobal(SHARED, {});
                module1.exports = store;
            /***/ },
            /* 41 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var defineProperty = Object.defineProperty;
                module1.exports = function(key, value) {
                    try {
                        defineProperty(global1, key, {
                            value: value,
                            configurable: true,
                            writable: true
                        });
                    } catch (error) {
                        global1[key] = value;
                    }
                    return value;
                };
            /***/ },
            /* 42 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toObject = __w_pdfjs_require__(43);
                var hasOwnProperty = uncurryThis({}.hasOwnProperty);
                module1.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty(toObject(it), key);
                };
            /***/ },
            /* 43 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                var Object1 = global1.Object;
                module1.exports = function(argument) {
                    return Object1(requireObjectCoercible(argument));
                };
            /***/ },
            /* 44 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var id = 0;
                var postfix = Math.random();
                var toString = uncurryThis(1.0.toString);
                module1.exports = function(key) {
                    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
                };
            /***/ },
            /* 45 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var fails = __w_pdfjs_require__(13);
                var createElement = __w_pdfjs_require__(46);
                module1.exports = !DESCRIPTORS && !fails(function() {
                    return Object.defineProperty(createElement('div'), 'a', {
                        get: function() {
                            return 7;
                        }
                    }).a != 7;
                });
            /***/ },
            /* 46 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isObject = __w_pdfjs_require__(24);
                var document1 = global1.document;
                var EXISTS = isObject(document1) && isObject(document1.createElement);
                module1.exports = function(it) {
                    return EXISTS ? document1.createElement(it) : {};
                };
            /***/ },
            /* 47 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var definePropertyModule = __w_pdfjs_require__(48);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = DESCRIPTORS ? function(object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                    object[key] = value;
                    return object;
                };
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
                var anObject = __w_pdfjs_require__(49);
                var toPropertyKey = __w_pdfjs_require__(22);
                var TypeError1 = global1.TypeError;
                var $defineProperty = Object.defineProperty;
                exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                        return $defineProperty(O, P, Attributes);
                    } catch (error) {}
                    if ('get' in Attributes || 'set' in Attributes) throw TypeError1('Accessors not supported');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                };
            /***/ },
            /* 49 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isObject = __w_pdfjs_require__(24);
                var String1 = global1.String;
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isObject(argument)) return argument;
                    throw TypeError1(String1(argument) + ' is not an object');
                };
            /***/ },
            /* 50 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var hasOwn = __w_pdfjs_require__(42);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var setGlobal = __w_pdfjs_require__(41);
                var inspectSource = __w_pdfjs_require__(51);
                var InternalStateModule = __w_pdfjs_require__(52);
                var CONFIGURABLE_FUNCTION_NAME = __w_pdfjs_require__(56).CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(String).split('String');
                (module1.exports = function(O, key, value, options) {
                    var unsafe = options ? !!options.unsafe : false;
                    var simple = options ? !!options.enumerable : false;
                    var noTargetGet = options ? !!options.noTargetGet : false;
                    var name = options && options.name !== undefined ? options.name : key;
                    var state;
                    if (isCallable(value)) {
                        if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
                        if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) createNonEnumerableProperty(value, 'name', name);
                        state = enforceInternalState(value);
                        if (!state.source) state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
                    }
                    if (O === global1) {
                        if (simple) O[key] = value;
                        else setGlobal(key, value);
                        return;
                    } else if (!unsafe) delete O[key];
                    else if (!noTargetGet && O[key]) simple = true;
                    if (simple) O[key] = value;
                    else createNonEnumerableProperty(O, key, value);
                })(Function.prototype, 'toString', function toString() {
                    return isCallable(this) && getInternalState(this).source || inspectSource(this);
                });
            /***/ },
            /* 51 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var isCallable = __w_pdfjs_require__(25);
                var store = __w_pdfjs_require__(40);
                var functionToString = uncurryThis(Function.toString);
                if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
                    return functionToString(it);
                };
                module1.exports = store.inspectSource;
            /***/ },
            /* 52 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var NATIVE_WEAK_MAP = __w_pdfjs_require__(53);
                var global1 = __w_pdfjs_require__(10);
                var uncurryThis = __w_pdfjs_require__(19);
                var isObject = __w_pdfjs_require__(24);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var hasOwn = __w_pdfjs_require__(42);
                var shared = __w_pdfjs_require__(40);
                var sharedKey = __w_pdfjs_require__(54);
                var hiddenKeys = __w_pdfjs_require__(55);
                var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
                var TypeError1 = global1.TypeError;
                var WeakMap1 = global1.WeakMap;
                var set, get, has;
                var enforce = function(it) {
                    return has(it) ? get(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                    return function(it) {
                        var state;
                        if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError1('Incompatible receiver, ' + TYPE + ' required');
                        return state;
                    };
                };
                if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap1());
                    var wmget = uncurryThis(store.get);
                    var wmhas = uncurryThis(store.has);
                    var wmset = uncurryThis(store.set);
                    set = function(it, metadata) {
                        if (wmhas(store, it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        wmset(store, it, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return wmget(store, it) || {};
                    };
                    has = function(it) {
                        return wmhas(store, it);
                    };
                } else {
                    var STATE = sharedKey('state');
                    hiddenKeys[STATE] = true;
                    set = function(it, metadata) {
                        if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        createNonEnumerableProperty(it, STATE, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return hasOwn(it, STATE) ? it[STATE] : {};
                    };
                    has = function(it) {
                        return hasOwn(it, STATE);
                    };
                }
                module1.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                };
            /***/ },
            /* 53 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var inspectSource = __w_pdfjs_require__(51);
                var WeakMap1 = global1.WeakMap;
                module1.exports = isCallable(WeakMap1) && /native code/.test(inspectSource(WeakMap1));
            /***/ },
            /* 54 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var shared = __w_pdfjs_require__(38);
                var uid = __w_pdfjs_require__(44);
                var keys = shared('keys');
                module1.exports = function(key) {
                    return keys[key] || (keys[key] = uid(key));
                };
            /***/ },
            /* 55 */ /***/ (module1)=>{
                module1.exports = {};
            /***/ },
            /* 56 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var hasOwn = __w_pdfjs_require__(42);
                var FunctionPrototype = Function.prototype;
                var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
                var EXISTS = hasOwn(FunctionPrototype, 'name');
                var PROPER = EXISTS && (function something() {}).name === 'something';
                var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
                module1.exports = {
                    EXISTS: EXISTS,
                    PROPER: PROPER,
                    CONFIGURABLE: CONFIGURABLE
                };
            /***/ },
            /* 57 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var hasOwn = __w_pdfjs_require__(42);
                var ownKeys = __w_pdfjs_require__(58);
                var getOwnPropertyDescriptorModule = __w_pdfjs_require__(11);
                var definePropertyModule = __w_pdfjs_require__(48);
                module1.exports = function(target, source) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                };
            /***/ },
            /* 58 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                var uncurryThis = __w_pdfjs_require__(19);
                var getOwnPropertyNamesModule = __w_pdfjs_require__(59);
                var getOwnPropertySymbolsModule = __w_pdfjs_require__(67);
                var anObject = __w_pdfjs_require__(49);
                var concat = uncurryThis([].concat);
                module1.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
                };
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                var internalObjectKeys = __w_pdfjs_require__(60);
                var enumBugKeys = __w_pdfjs_require__(66);
                var hiddenKeys = enumBugKeys.concat('length', 'prototype');
                exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                };
            /***/ },
            /* 60 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var hasOwn = __w_pdfjs_require__(42);
                var toIndexedObject = __w_pdfjs_require__(17);
                var indexOf = __w_pdfjs_require__(61).indexOf;
                var hiddenKeys = __w_pdfjs_require__(55);
                var push = uncurryThis([].push);
                module1.exports = function(object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
                    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
                    return result;
                };
            /***/ },
            /* 61 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIndexedObject = __w_pdfjs_require__(17);
                var toAbsoluteIndex = __w_pdfjs_require__(62);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var createMethod = function(IS_INCLUDES) {
                    return function($this, el, fromIndex) {
                        var O = toIndexedObject($this);
                        var length = lengthOfArrayLike(O);
                        var index = toAbsoluteIndex(fromIndex, length);
                        var value;
                        if (IS_INCLUDES && el != el) while(length > index){
                            value = O[index++];
                            if (value != value) return true;
                        }
                        else for(; length > index; index++){
                            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                        }
                        return !IS_INCLUDES && -1;
                    };
                };
                module1.exports = {
                    includes: createMethod(true),
                    indexOf: createMethod(false)
                };
            /***/ },
            /* 62 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var max = Math.max;
                var min = Math.min;
                module1.exports = function(index, length) {
                    var integer = toIntegerOrInfinity(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
            /***/ },
            /* 63 */ /***/ (module1)=>{
                var ceil = Math.ceil;
                var floor = Math.floor;
                module1.exports = function(argument) {
                    var number = +argument;
                    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
                };
            /***/ },
            /* 64 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toLength = __w_pdfjs_require__(65);
                module1.exports = function(obj) {
                    return toLength(obj.length);
                };
            /***/ },
            /* 65 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var min = Math.min;
                module1.exports = function(argument) {
                    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0;
                };
            /***/ },
            /* 66 */ /***/ (module1)=>{
                module1.exports = [
                    'constructor',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'toLocaleString',
                    'toString',
                    'valueOf'
                ];
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module, exports)=>{
                exports.f = Object.getOwnPropertySymbols;
            /***/ },
            /* 68 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                    var value = data[normalize(feature)];
                    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                    return String(string).replace(replacement, '.').toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = 'N';
                var POLYFILL = isForced.POLYFILL = 'P';
                module1.exports = isForced;
            /***/ },
            /* 69 */ /***/ (module1, exports, __w_pdfjs_require__)=>{
                "use strict";
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                (function(global1, factory) {
                    _typeof(exports) === 'object' && true ? module1.exports = factory() : (__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __w_pdfjs_require__, exports, module1) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                })(void 0, function() {
                    'use strict';
                    function fromArray(array) {
                        var m = new CSSMatrix();
                        var a = Array.from(array);
                        if (!a.every(function(n) {
                            return !Number.isNaN(n);
                        })) throw TypeError("CSSMatrix: \"" + array + "\" must only have numbers.");
                        if (a.length === 16) {
                            var m11 = a[0];
                            var m12 = a[1];
                            var m13 = a[2];
                            var m14 = a[3];
                            var m21 = a[4];
                            var m22 = a[5];
                            var m23 = a[6];
                            var m24 = a[7];
                            var m31 = a[8];
                            var m32 = a[9];
                            var m33 = a[10];
                            var m34 = a[11];
                            var m41 = a[12];
                            var m42 = a[13];
                            var m43 = a[14];
                            var m44 = a[15];
                            m.m11 = m11;
                            m.a = m11;
                            m.m21 = m21;
                            m.c = m21;
                            m.m31 = m31;
                            m.m41 = m41;
                            m.e = m41;
                            m.m12 = m12;
                            m.b = m12;
                            m.m22 = m22;
                            m.d = m22;
                            m.m32 = m32;
                            m.m42 = m42;
                            m.f = m42;
                            m.m13 = m13;
                            m.m23 = m23;
                            m.m33 = m33;
                            m.m43 = m43;
                            m.m14 = m14;
                            m.m24 = m24;
                            m.m34 = m34;
                            m.m44 = m44;
                        } else if (a.length === 6) {
                            var M11 = a[0];
                            var M12 = a[1];
                            var M21 = a[2];
                            var M22 = a[3];
                            var M41 = a[4];
                            var M42 = a[5];
                            m.m11 = M11;
                            m.a = M11;
                            m.m12 = M12;
                            m.b = M12;
                            m.m21 = M21;
                            m.c = M21;
                            m.m22 = M22;
                            m.d = M22;
                            m.m41 = M41;
                            m.e = M41;
                            m.m42 = M42;
                            m.f = M42;
                        } else throw new TypeError('CSSMatrix: expecting an Array of 6/16 values.');
                        return m;
                    }
                    function fromMatrix(m) {
                        var keys = Object.keys(new CSSMatrix());
                        if (_typeof(m) === 'object' && keys.every(function(k) {
                            return k in m;
                        })) return fromArray([
                            m.m11,
                            m.m12,
                            m.m13,
                            m.m14,
                            m.m21,
                            m.m22,
                            m.m23,
                            m.m24,
                            m.m31,
                            m.m32,
                            m.m33,
                            m.m34,
                            m.m41,
                            m.m42,
                            m.m43,
                            m.m44
                        ]);
                        throw TypeError("CSSMatrix: \"" + m + "\" is not a DOMMatrix / CSSMatrix / JSON compatible object.");
                    }
                    function fromString(source) {
                        if (typeof source !== 'string') throw TypeError("CSSMatrix: \"" + source + "\" is not a string.");
                        var str = String(source).replace(/\s/g, '');
                        var m = new CSSMatrix();
                        var invalidStringError = "CSSMatrix: invalid transform string \"" + source + "\"";
                        str.split(')').filter(function(f) {
                            return f;
                        }).forEach(function(tf) {
                            var ref = tf.split('(');
                            var prop = ref[0];
                            var value = ref[1];
                            if (!value) throw TypeError(invalidStringError);
                            var components = value.split(',').map(function(n) {
                                return n.includes('rad') ? parseFloat(n) * (180 / Math.PI) : parseFloat(n);
                            });
                            var x = components[0];
                            var y = components[1];
                            var z = components[2];
                            var a = components[3];
                            var xyz = [
                                x,
                                y,
                                z
                            ];
                            var xyza = [
                                x,
                                y,
                                z,
                                a
                            ];
                            if (prop === 'perspective' && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            })) m.m34 = -1 / x;
                            else if (prop.includes('matrix') && [
                                6,
                                16
                            ].includes(components.length) && components.every(function(n) {
                                return !Number.isNaN(+n);
                            })) {
                                var values = components.map(function(n) {
                                    return Math.abs(n) < 1e-6 ? 0 : n;
                                });
                                m = m.multiply(fromArray(values));
                            } else if (prop === 'translate3d' && xyz.every(function(n) {
                                return !Number.isNaN(+n);
                            })) m = m.translate(x, y, z);
                            else if (prop === 'translate' && x && z === undefined) m = m.translate(x, y || 0, 0);
                            else if (prop === 'rotate3d' && xyza.every(function(n) {
                                return !Number.isNaN(+n);
                            }) && a) m = m.rotateAxisAngle(x, y, z, a);
                            else if (prop === 'rotate' && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            })) m = m.rotate(0, 0, x);
                            else if (prop === 'scale3d' && xyz.every(function(n) {
                                return !Number.isNaN(+n);
                            }) && xyz.some(function(n) {
                                return n !== 1;
                            })) m = m.scale(x, y, z);
                            else if (prop === 'scale' && !Number.isNaN(x) && x !== 1 && z === undefined) {
                                var nosy = Number.isNaN(+y);
                                var sy = nosy ? x : y;
                                m = m.scale(x, sy, 1);
                            } else if (prop === 'skew' && x && z === undefined) {
                                m = m.skewX(x);
                                m = y ? m.skewY(y) : m;
                            } else if (/[XYZ]/.test(prop) && x && [
                                y,
                                z
                            ].every(function(n) {
                                return n === undefined;
                            }) && [
                                'translate',
                                'rotate',
                                'scale',
                                'skew'
                            ].some(function(p) {
                                return prop.includes(p);
                            })) {
                                if ([
                                    'skewX',
                                    'skewY'
                                ].includes(prop)) m = m[prop](x);
                                else {
                                    var fn = prop.replace(/[XYZ]/, '');
                                    var axis = prop.replace(fn, '');
                                    var idx = [
                                        'X',
                                        'Y',
                                        'Z'
                                    ].indexOf(axis);
                                    var axeValues = [
                                        idx === 0 ? x : 0,
                                        idx === 1 ? x : 0,
                                        idx === 2 ? x : 0
                                    ];
                                    m = m[fn].apply(m, axeValues);
                                }
                            } else throw TypeError(invalidStringError);
                        });
                        return m;
                    }
                    function Translate(x, y, z) {
                        var m = new CSSMatrix();
                        m.m41 = x;
                        m.e = x;
                        m.m42 = y;
                        m.f = y;
                        m.m43 = z;
                        return m;
                    }
                    function Rotate(rx, ry, rz) {
                        var m = new CSSMatrix();
                        var degToRad = Math.PI / 180;
                        var radX = rx * degToRad;
                        var radY = ry * degToRad;
                        var radZ = rz * degToRad;
                        var cosx = Math.cos(radX);
                        var sinx = -Math.sin(radX);
                        var cosy = Math.cos(radY);
                        var siny = -Math.sin(radY);
                        var cosz = Math.cos(radZ);
                        var sinz = -Math.sin(radZ);
                        var m11 = cosy * cosz;
                        var m12 = -cosy * sinz;
                        m.m11 = m11;
                        m.a = m11;
                        m.m12 = m12;
                        m.b = m12;
                        m.m13 = siny;
                        var m21 = sinx * siny * cosz + cosx * sinz;
                        m.m21 = m21;
                        m.c = m21;
                        var m22 = cosx * cosz - sinx * siny * sinz;
                        m.m22 = m22;
                        m.d = m22;
                        m.m23 = -sinx * cosy;
                        m.m31 = sinx * sinz - cosx * siny * cosz;
                        m.m32 = sinx * cosz + cosx * siny * sinz;
                        m.m33 = cosx * cosy;
                        return m;
                    }
                    function RotateAxisAngle(x, y, z, alpha) {
                        var m = new CSSMatrix();
                        var angle = alpha * (Math.PI / 360);
                        var sinA = Math.sin(angle);
                        var cosA = Math.cos(angle);
                        var sinA2 = sinA * sinA;
                        var length = Math.sqrt(x * x + y * y + z * z);
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (length === 0) {
                            X = 0;
                            Y = 0;
                            Z = 1;
                        } else {
                            X /= length;
                            Y /= length;
                            Z /= length;
                        }
                        var x2 = X * X;
                        var y2 = Y * Y;
                        var z2 = Z * Z;
                        var m11 = 1 - 2 * (y2 + z2) * sinA2;
                        m.m11 = m11;
                        m.a = m11;
                        var m12 = 2 * (X * Y * sinA2 + Z * sinA * cosA);
                        m.m12 = m12;
                        m.b = m12;
                        m.m13 = 2 * (X * Z * sinA2 - Y * sinA * cosA);
                        var m21 = 2 * (Y * X * sinA2 - Z * sinA * cosA);
                        m.m21 = m21;
                        m.c = m21;
                        var m22 = 1 - 2 * (z2 + x2) * sinA2;
                        m.m22 = m22;
                        m.d = m22;
                        m.m23 = 2 * (Y * Z * sinA2 + X * sinA * cosA);
                        m.m31 = 2 * (Z * X * sinA2 + Y * sinA * cosA);
                        m.m32 = 2 * (Z * Y * sinA2 - X * sinA * cosA);
                        m.m33 = 1 - 2 * (x2 + y2) * sinA2;
                        return m;
                    }
                    function Scale(x, y, z) {
                        var m = new CSSMatrix();
                        m.m11 = x;
                        m.a = x;
                        m.m22 = y;
                        m.d = y;
                        m.m33 = z;
                        return m;
                    }
                    function SkewX(angle) {
                        var m = new CSSMatrix();
                        var radA = angle * Math.PI / 180;
                        var t = Math.tan(radA);
                        m.m21 = t;
                        m.c = t;
                        return m;
                    }
                    function SkewY(angle) {
                        var m = new CSSMatrix();
                        var radA = angle * Math.PI / 180;
                        var t = Math.tan(radA);
                        m.m12 = t;
                        m.b = t;
                        return m;
                    }
                    function Multiply(m1, m2) {
                        var m11 = m2.m11 * m1.m11 + m2.m12 * m1.m21 + m2.m13 * m1.m31 + m2.m14 * m1.m41;
                        var m12 = m2.m11 * m1.m12 + m2.m12 * m1.m22 + m2.m13 * m1.m32 + m2.m14 * m1.m42;
                        var m13 = m2.m11 * m1.m13 + m2.m12 * m1.m23 + m2.m13 * m1.m33 + m2.m14 * m1.m43;
                        var m14 = m2.m11 * m1.m14 + m2.m12 * m1.m24 + m2.m13 * m1.m34 + m2.m14 * m1.m44;
                        var m21 = m2.m21 * m1.m11 + m2.m22 * m1.m21 + m2.m23 * m1.m31 + m2.m24 * m1.m41;
                        var m22 = m2.m21 * m1.m12 + m2.m22 * m1.m22 + m2.m23 * m1.m32 + m2.m24 * m1.m42;
                        var m23 = m2.m21 * m1.m13 + m2.m22 * m1.m23 + m2.m23 * m1.m33 + m2.m24 * m1.m43;
                        var m24 = m2.m21 * m1.m14 + m2.m22 * m1.m24 + m2.m23 * m1.m34 + m2.m24 * m1.m44;
                        var m31 = m2.m31 * m1.m11 + m2.m32 * m1.m21 + m2.m33 * m1.m31 + m2.m34 * m1.m41;
                        var m32 = m2.m31 * m1.m12 + m2.m32 * m1.m22 + m2.m33 * m1.m32 + m2.m34 * m1.m42;
                        var m33 = m2.m31 * m1.m13 + m2.m32 * m1.m23 + m2.m33 * m1.m33 + m2.m34 * m1.m43;
                        var m34 = m2.m31 * m1.m14 + m2.m32 * m1.m24 + m2.m33 * m1.m34 + m2.m34 * m1.m44;
                        var m41 = m2.m41 * m1.m11 + m2.m42 * m1.m21 + m2.m43 * m1.m31 + m2.m44 * m1.m41;
                        var m42 = m2.m41 * m1.m12 + m2.m42 * m1.m22 + m2.m43 * m1.m32 + m2.m44 * m1.m42;
                        var m43 = m2.m41 * m1.m13 + m2.m42 * m1.m23 + m2.m43 * m1.m33 + m2.m44 * m1.m43;
                        var m44 = m2.m41 * m1.m14 + m2.m42 * m1.m24 + m2.m43 * m1.m34 + m2.m44 * m1.m44;
                        return fromArray([
                            m11,
                            m12,
                            m13,
                            m14,
                            m21,
                            m22,
                            m23,
                            m24,
                            m31,
                            m32,
                            m33,
                            m34,
                            m41,
                            m42,
                            m43,
                            m44
                        ]);
                    }
                    var CSSMatrix = function CSSMatrix() {
                        var args = [], len = arguments.length;
                        while(len--)args[len] = arguments[len];
                        var m = this;
                        m.a = 1;
                        m.b = 0;
                        m.c = 0;
                        m.d = 1;
                        m.e = 0;
                        m.f = 0;
                        m.m11 = 1;
                        m.m12 = 0;
                        m.m13 = 0;
                        m.m14 = 0;
                        m.m21 = 0;
                        m.m22 = 1;
                        m.m23 = 0;
                        m.m24 = 0;
                        m.m31 = 0;
                        m.m32 = 0;
                        m.m33 = 1;
                        m.m34 = 0;
                        m.m41 = 0;
                        m.m42 = 0;
                        m.m43 = 0;
                        m.m44 = 1;
                        if (args && args.length) {
                            var ARGS = [
                                16,
                                6
                            ].some(function(l) {
                                return l === args.length;
                            }) ? args : args[0];
                            return m.setMatrixValue(ARGS);
                        }
                        return m;
                    };
                    var prototypeAccessors = {
                        isIdentity: {
                            configurable: true
                        },
                        is2D: {
                            configurable: true
                        }
                    };
                    prototypeAccessors.isIdentity.set = function(value) {
                        this.isIdentity = value;
                    };
                    prototypeAccessors.isIdentity.get = function() {
                        var m = this;
                        return m.m11 === 1 && m.m12 === 0 && m.m13 === 0 && m.m14 === 0 && m.m21 === 0 && m.m22 === 1 && m.m23 === 0 && m.m24 === 0 && m.m31 === 0 && m.m32 === 0 && m.m33 === 1 && m.m34 === 0 && m.m41 === 0 && m.m42 === 0 && m.m43 === 0 && m.m44 === 1;
                    };
                    prototypeAccessors.is2D.get = function() {
                        var m = this;
                        return m.m31 === 0 && m.m32 === 0 && m.m33 === 1 && m.m34 === 0 && m.m43 === 0 && m.m44 === 1;
                    };
                    prototypeAccessors.is2D.set = function(value) {
                        this.is2D = value;
                    };
                    CSSMatrix.prototype.setMatrixValue = function setMatrixValue(source) {
                        var m = this;
                        if ([
                            Array,
                            Float64Array,
                            Float32Array
                        ].some(function(a) {
                            return source instanceof a;
                        })) return fromArray(source);
                        if (typeof source === 'string' && source.length && source !== 'none') return fromString(source);
                        if (_typeof(source) === 'object') return fromMatrix(source);
                        return m;
                    };
                    CSSMatrix.prototype.toArray = function toArray() {
                        var m = this;
                        var pow = Math.pow(10, 6);
                        var result;
                        if (m.is2D) result = [
                            m.a,
                            m.b,
                            m.c,
                            m.d,
                            m.e,
                            m.f
                        ];
                        else result = [
                            m.m11,
                            m.m12,
                            m.m13,
                            m.m14,
                            m.m21,
                            m.m22,
                            m.m23,
                            m.m24,
                            m.m31,
                            m.m32,
                            m.m33,
                            m.m34,
                            m.m41,
                            m.m42,
                            m.m43,
                            m.m44
                        ];
                        return result.map(function(n) {
                            return Math.abs(n) < 1e-6 ? 0 : (n * pow >> 0) / pow;
                        });
                    };
                    CSSMatrix.prototype.toString = function toString() {
                        var m = this;
                        var values = m.toArray();
                        var type = m.is2D ? 'matrix' : 'matrix3d';
                        return type + "(" + values + ")";
                    };
                    CSSMatrix.prototype.toJSON = function toJSON() {
                        var m = this;
                        var is2D = m.is2D;
                        var isIdentity = m.isIdentity;
                        return Object.assign({}, m, {
                            is2D: is2D,
                            isIdentity: isIdentity
                        });
                    };
                    CSSMatrix.prototype.multiply = function multiply(m2) {
                        return Multiply(this, m2);
                    };
                    CSSMatrix.prototype.translate = function translate(x, y, z) {
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (Z === undefined) Z = 0;
                        if (Y === undefined) Y = 0;
                        return Multiply(this, Translate(X, Y, Z));
                    };
                    CSSMatrix.prototype.scale = function scale(x, y, z) {
                        var X = x;
                        var Y = y;
                        var Z = z;
                        if (Y === undefined) Y = x;
                        if (Z === undefined) Z = 1;
                        return Multiply(this, Scale(X, Y, Z));
                    };
                    CSSMatrix.prototype.rotate = function rotate(rx, ry, rz) {
                        var RX = rx;
                        var RY = ry;
                        var RZ = rz;
                        if (RY === undefined) RY = 0;
                        if (RZ === undefined) {
                            RZ = RX;
                            RX = 0;
                        }
                        return Multiply(this, Rotate(RX, RY, RZ));
                    };
                    CSSMatrix.prototype.rotateAxisAngle = function rotateAxisAngle(x, y, z, angle) {
                        if ([
                            x,
                            y,
                            z,
                            angle
                        ].some(function(n) {
                            return Number.isNaN(n);
                        })) throw new TypeError('CSSMatrix: expecting 4 values');
                        return Multiply(this, RotateAxisAngle(x, y, z, angle));
                    };
                    CSSMatrix.prototype.skewX = function skewX(angle) {
                        return Multiply(this, SkewX(angle));
                    };
                    CSSMatrix.prototype.skewY = function skewY(angle) {
                        return Multiply(this, SkewY(angle));
                    };
                    CSSMatrix.prototype.transformPoint = function transformPoint(v) {
                        var M = this;
                        var m = Translate(v.x, v.y, v.z);
                        m.m44 = v.w || 1;
                        m = M.multiply(m);
                        return {
                            x: m.m41,
                            y: m.m42,
                            z: m.m43,
                            w: m.m44
                        };
                    };
                    CSSMatrix.prototype.transform = function transform(t) {
                        var m = this;
                        var x = m.m11 * t.x + m.m12 * t.y + m.m13 * t.z + m.m14 * t.w;
                        var y = m.m21 * t.x + m.m22 * t.y + m.m23 * t.z + m.m24 * t.w;
                        var z = m.m31 * t.x + m.m32 * t.y + m.m33 * t.z + m.m34 * t.w;
                        var w = m.m41 * t.x + m.m42 * t.y + m.m43 * t.z + m.m44 * t.w;
                        return {
                            x: x / w,
                            y: y / w,
                            z: z / w,
                            w: w
                        };
                    };
                    Object.defineProperties(CSSMatrix.prototype, prototypeAccessors);
                    Object.assign(CSSMatrix, {
                        Translate: Translate,
                        Rotate: Rotate,
                        RotateAxisAngle: RotateAxisAngle,
                        Scale: Scale,
                        SkewX: SkewX,
                        SkewY: SkewY,
                        Multiply: Multiply,
                        fromArray: fromArray,
                        fromMatrix: fromMatrix,
                        fromString: fromString
                    });
                    var version = "0.0.24";
                    var Version = version;
                    Object.assign(CSSMatrix, {
                        Version: Version
                    });
                    return CSSMatrix;
                });
            /***/ },
            /* 70 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(71);
                __w_pdfjs_require__(86);
                var path = __w_pdfjs_require__(96);
                module1.exports = path.Object.fromEntries;
            /***/ },
            /* 71 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var toIndexedObject = __w_pdfjs_require__(17);
                var addToUnscopables = __w_pdfjs_require__(72);
                var Iterators = __w_pdfjs_require__(77);
                var InternalStateModule = __w_pdfjs_require__(52);
                var defineIterator = __w_pdfjs_require__(78);
                var ARRAY_ITERATOR = 'Array Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                module1.exports = defineIterator(Array, 'Array', function(iterated, kind) {
                    setInternalState(this, {
                        type: ARRAY_ITERATOR,
                        target: toIndexedObject(iterated),
                        index: 0,
                        kind: kind
                    });
                }, function() {
                    var state = getInternalState(this);
                    var target = state.target;
                    var kind = state.kind;
                    var index = state.index++;
                    if (!target || index >= target.length) {
                        state.target = undefined;
                        return {
                            value: undefined,
                            done: true
                        };
                    }
                    if (kind == 'keys') return {
                        value: index,
                        done: false
                    };
                    if (kind == 'values') return {
                        value: target[index],
                        done: false
                    };
                    return {
                        value: [
                            index,
                            target[index]
                        ],
                        done: false
                    };
                }, 'values');
                Iterators.Arguments = Iterators.Array;
                addToUnscopables('keys');
                addToUnscopables('values');
                addToUnscopables('entries');
            /***/ },
            /* 72 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var create = __w_pdfjs_require__(73);
                var definePropertyModule = __w_pdfjs_require__(48);
                var UNSCOPABLES = wellKnownSymbol('unscopables');
                var ArrayPrototype = Array.prototype;
                if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create(null)
                });
                module1.exports = function(key) {
                    ArrayPrototype[UNSCOPABLES][key] = true;
                };
            /***/ },
            /* 73 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var defineProperties = __w_pdfjs_require__(74);
                var enumBugKeys = __w_pdfjs_require__(66);
                var hiddenKeys = __w_pdfjs_require__(55);
                var html = __w_pdfjs_require__(76);
                var documentCreateElement = __w_pdfjs_require__(46);
                var sharedKey = __w_pdfjs_require__(54);
                var GT = '>';
                var LT = '<';
                var PROTOTYPE = 'prototype';
                var SCRIPT = 'script';
                var IE_PROTO = sharedKey('IE_PROTO');
                var EmptyConstructor = function() {};
                var scriptTag = function(content) {
                    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
                };
                var NullProtoObjectViaActiveX = function(activeXDocument) {
                    activeXDocument.write(scriptTag(''));
                    activeXDocument.close();
                    var temp = activeXDocument.parentWindow.Object;
                    activeXDocument = null;
                    return temp;
                };
                var NullProtoObjectViaIFrame = function() {
                    var iframe = documentCreateElement('iframe');
                    var JS = 'java' + SCRIPT + ':';
                    var iframeDocument;
                    iframe.style.display = 'none';
                    html.appendChild(iframe);
                    iframe.src = String(JS);
                    iframeDocument = iframe.contentWindow.document;
                    iframeDocument.open();
                    iframeDocument.write(scriptTag('document.F=Object'));
                    iframeDocument.close();
                    return iframeDocument.F;
                };
                var activeXDocument;
                var NullProtoObject = function() {
                    try {
                        activeXDocument = new ActiveXObject('htmlfile');
                    } catch (error) {}
                    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
                    var length = enumBugKeys.length;
                    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                    return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                module1.exports = Object.create || function create(O, Properties) {
                    var result;
                    if (O !== null) {
                        EmptyConstructor[PROTOTYPE] = anObject(O);
                        result = new EmptyConstructor();
                        EmptyConstructor[PROTOTYPE] = null;
                        result[IE_PROTO] = O;
                    } else result = NullProtoObject();
                    return Properties === undefined ? result : defineProperties(result, Properties);
                };
            /***/ },
            /* 74 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var definePropertyModule = __w_pdfjs_require__(48);
                var anObject = __w_pdfjs_require__(49);
                var toIndexedObject = __w_pdfjs_require__(17);
                var objectKeys = __w_pdfjs_require__(75);
                module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                    anObject(O);
                    var props = toIndexedObject(Properties);
                    var keys = objectKeys(Properties);
                    var length = keys.length;
                    var index = 0;
                    var key;
                    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
                    return O;
                };
            /***/ },
            /* 75 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var internalObjectKeys = __w_pdfjs_require__(60);
                var enumBugKeys = __w_pdfjs_require__(66);
                module1.exports = Object.keys || function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                };
            /***/ },
            /* 76 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var getBuiltIn = __w_pdfjs_require__(27);
                module1.exports = getBuiltIn('document', 'documentElement');
            /***/ },
            /* 77 */ /***/ (module1)=>{
                module1.exports = {};
            /***/ },
            /* 78 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var call = __w_pdfjs_require__(14);
                var IS_PURE = __w_pdfjs_require__(39);
                var FunctionName = __w_pdfjs_require__(56);
                var isCallable = __w_pdfjs_require__(25);
                var createIteratorConstructor = __w_pdfjs_require__(79);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var setToStringTag = __w_pdfjs_require__(83);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var redefine = __w_pdfjs_require__(50);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var Iterators = __w_pdfjs_require__(77);
                var IteratorsCore = __w_pdfjs_require__(80);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol('iterator');
                var KEYS = 'keys';
                var VALUES = 'values';
                var ENTRIES = 'entries';
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                    createIteratorConstructor(IteratorConstructor, NAME, next);
                    var getIterationMethod = function(KIND) {
                        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                        switch(KIND){
                            case KEYS:
                                return function keys() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case VALUES:
                                return function values() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case ENTRIES:
                                return function entries() {
                                    return new IteratorConstructor(this, KIND);
                                };
                        }
                        return function() {
                            return new IteratorConstructor(this);
                        };
                    };
                    var TO_STRING_TAG = NAME + ' Iterator';
                    var INCORRECT_VALUES_NAME = false;
                    var IterablePrototype = Iterable.prototype;
                    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
                    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                    var CurrentIteratorPrototype, methods, KEY;
                    if (anyNativeIterator) {
                        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                        }
                    }
                    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
                        else {
                            INCORRECT_VALUES_NAME = true;
                            defaultIterator = function values() {
                                return call(nativeIterator, this);
                            };
                        }
                    }
                    if (DEFAULT) {
                        methods = {
                            values: getIterationMethod(VALUES),
                            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                            entries: getIterationMethod(ENTRIES)
                        };
                        if (FORCED) {
                            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                        } else $({
                            target: NAME,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                        }, methods);
                    }
                    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) redefine(IterablePrototype, ITERATOR, defaultIterator, {
                        name: DEFAULT
                    });
                    Iterators[NAME] = defaultIterator;
                    return methods;
                };
            /***/ },
            /* 79 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var IteratorPrototype = __w_pdfjs_require__(80).IteratorPrototype;
                var create = __w_pdfjs_require__(73);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var setToStringTag = __w_pdfjs_require__(83);
                var Iterators = __w_pdfjs_require__(77);
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
                    var TO_STRING_TAG = NAME + ' Iterator';
                    IteratorConstructor.prototype = create(IteratorPrototype, {
                        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
                    });
                    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                    Iterators[TO_STRING_TAG] = returnThis;
                    return IteratorConstructor;
                };
            /***/ },
            /* 80 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var create = __w_pdfjs_require__(73);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var redefine = __w_pdfjs_require__(50);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var IS_PURE = __w_pdfjs_require__(39);
                var ITERATOR = wellKnownSymbol('iterator');
                var BUGGY_SAFARI_ITERATORS = false;
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                if ([].keys) {
                    arrayIterator = [].keys();
                    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                    else {
                        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function() {
                    var test = {};
                    return IteratorPrototype[ITERATOR].call(test) !== test;
                });
                if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
                else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
                if (!isCallable(IteratorPrototype[ITERATOR])) redefine(IteratorPrototype, ITERATOR, function() {
                    return this;
                });
                module1.exports = {
                    IteratorPrototype: IteratorPrototype,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
                };
            /***/ },
            /* 81 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var hasOwn = __w_pdfjs_require__(42);
                var isCallable = __w_pdfjs_require__(25);
                var toObject = __w_pdfjs_require__(43);
                var sharedKey = __w_pdfjs_require__(54);
                var CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__(82);
                var IE_PROTO = sharedKey('IE_PROTO');
                var Object1 = global1.Object;
                var ObjectPrototype = Object1.prototype;
                module1.exports = CORRECT_PROTOTYPE_GETTER ? Object1.getPrototypeOf : function(O) {
                    var object = toObject(O);
                    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
                    var constructor = object.constructor;
                    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
                    return object instanceof Object1 ? ObjectPrototype : null;
                };
            /***/ },
            /* 82 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                module1.exports = !fails(function() {
                    function F() {}
                    F.prototype.constructor = null;
                    return Object.getPrototypeOf(new F()) !== F.prototype;
                });
            /***/ },
            /* 83 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var defineProperty = __w_pdfjs_require__(48).f;
                var hasOwn = __w_pdfjs_require__(42);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                module1.exports = function(it, TAG, STATIC) {
                    if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                        configurable: true,
                        value: TAG
                    });
                };
            /***/ },
            /* 84 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var anObject = __w_pdfjs_require__(49);
                var aPossiblePrototype = __w_pdfjs_require__(85);
                module1.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
                    var CORRECT_SETTER = false;
                    var test = {};
                    var setter;
                    try {
                        setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
                        setter(test, []);
                        CORRECT_SETTER = test instanceof Array;
                    } catch (error) {}
                    return function setPrototypeOf(O, proto) {
                        anObject(O);
                        aPossiblePrototype(proto);
                        if (CORRECT_SETTER) setter(O, proto);
                        else O.__proto__ = proto;
                        return O;
                    };
                }() : undefined);
            /***/ },
            /* 85 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isCallable = __w_pdfjs_require__(25);
                var String1 = global1.String;
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (typeof argument == 'object' || isCallable(argument)) return argument;
                    throw TypeError1("Can't set " + String1(argument) + ' as a prototype');
                };
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var $ = __w_pdfjs_require__(9);
                var iterate = __w_pdfjs_require__(87);
                var createProperty = __w_pdfjs_require__(95);
                $({
                    target: 'Object',
                    stat: true
                }, {
                    fromEntries: function fromEntries(iterable) {
                        var obj = {};
                        iterate(iterable, function(k, v) {
                            createProperty(obj, k, v);
                        }, {
                            AS_ENTRIES: true
                        });
                        return obj;
                    }
                });
            /***/ },
            /* 87 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var bind = __w_pdfjs_require__(88);
                var call = __w_pdfjs_require__(14);
                var anObject = __w_pdfjs_require__(49);
                var tryToString = __w_pdfjs_require__(35);
                var isArrayIteratorMethod = __w_pdfjs_require__(89);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var getIterator = __w_pdfjs_require__(90);
                var getIteratorMethod = __w_pdfjs_require__(91);
                var iteratorClose = __w_pdfjs_require__(94);
                var TypeError1 = global1.TypeError;
                var Result = function(stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                };
                var ResultPrototype = Result.prototype;
                module1.exports = function(iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that);
                    var iterator, iterFn, index, length, result, next, step;
                    var stop = function(condition) {
                        if (iterator) iteratorClose(iterator, 'normal', condition);
                        return new Result(true, condition);
                    };
                    var callFn = function(value) {
                        if (AS_ENTRIES) {
                            anObject(value);
                            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                        }
                        return INTERRUPTED ? fn(value, stop) : fn(value);
                    };
                    if (IS_ITERATOR) iterator = iterable;
                    else {
                        iterFn = getIteratorMethod(iterable);
                        if (!iterFn) throw TypeError1(tryToString(iterable) + ' is not iterable');
                        if (isArrayIteratorMethod(iterFn)) {
                            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                                result = callFn(iterable[index]);
                                if (result && isPrototypeOf(ResultPrototype, result)) return result;
                            }
                            return new Result(false);
                        }
                        iterator = getIterator(iterable, iterFn);
                    }
                    next = iterator.next;
                    while(!(step = call(next, iterator)).done){
                        try {
                            result = callFn(step.value);
                        } catch (error) {
                            iteratorClose(iterator, 'throw', error);
                        }
                        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                };
            /***/ },
            /* 88 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var aCallable = __w_pdfjs_require__(34);
                var bind = uncurryThis(uncurryThis.bind);
                module1.exports = function(fn, that) {
                    aCallable(fn);
                    return that === undefined ? fn : bind ? bind(fn, that) : function() {
                        return fn.apply(that, arguments);
                    };
                };
            /***/ },
            /* 89 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var Iterators = __w_pdfjs_require__(77);
                var ITERATOR = wellKnownSymbol('iterator');
                var ArrayPrototype = Array.prototype;
                module1.exports = function(it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
            /***/ },
            /* 90 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var call = __w_pdfjs_require__(14);
                var aCallable = __w_pdfjs_require__(34);
                var anObject = __w_pdfjs_require__(49);
                var tryToString = __w_pdfjs_require__(35);
                var getIteratorMethod = __w_pdfjs_require__(91);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument, usingIterator) {
                    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
                    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
                    throw TypeError1(tryToString(argument) + ' is not iterable');
                };
            /***/ },
            /* 91 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var classof = __w_pdfjs_require__(92);
                var getMethod = __w_pdfjs_require__(33);
                var Iterators = __w_pdfjs_require__(77);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ITERATOR = wellKnownSymbol('iterator');
                module1.exports = function(it) {
                    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
                };
            /***/ },
            /* 92 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var isCallable = __w_pdfjs_require__(25);
                var classofRaw = __w_pdfjs_require__(20);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var Object1 = global1.Object;
                var CORRECT_ARGUMENTS = classofRaw(function() {
                    return arguments;
                }()) == 'Arguments';
                var tryGet = function(it, key) {
                    try {
                        return it[key];
                    } catch (error) {}
                };
                module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                    var O, tag, result;
                    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object1(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
                };
            /***/ },
            /* 93 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var test = {};
                test[TO_STRING_TAG] = 'z';
                module1.exports = String(test) === '[object z]';
            /***/ },
            /* 94 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var call = __w_pdfjs_require__(14);
                var anObject = __w_pdfjs_require__(49);
                var getMethod = __w_pdfjs_require__(33);
                module1.exports = function(iterator, kind, value) {
                    var innerResult, innerError;
                    anObject(iterator);
                    try {
                        innerResult = getMethod(iterator, 'return');
                        if (!innerResult) {
                            if (kind === 'throw') throw value;
                            return value;
                        }
                        innerResult = call(innerResult, iterator);
                    } catch (error) {
                        innerError = true;
                        innerResult = error;
                    }
                    if (kind === 'throw') throw value;
                    if (innerError) throw innerResult;
                    anObject(innerResult);
                    return value;
                };
            /***/ },
            /* 95 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var toPropertyKey = __w_pdfjs_require__(22);
                var definePropertyModule = __w_pdfjs_require__(48);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = function(object, key, value) {
                    var propertyKey = toPropertyKey(key);
                    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                    else object[propertyKey] = value;
                };
            /***/ },
            /* 96 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = global1;
            /***/ },
            /* 97 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                __w_pdfjs_require__(98);
                __w_pdfjs_require__(71);
                __w_pdfjs_require__(105);
                __w_pdfjs_require__(107);
                __w_pdfjs_require__(129);
                __w_pdfjs_require__(130);
                __w_pdfjs_require__(131);
                __w_pdfjs_require__(132);
                var path = __w_pdfjs_require__(96);
                module1.exports = path.Promise;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var global1 = __w_pdfjs_require__(10);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var getPrototypeOf = __w_pdfjs_require__(81);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var copyConstructorProperties = __w_pdfjs_require__(57);
                var create = __w_pdfjs_require__(73);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                var clearErrorStack = __w_pdfjs_require__(99);
                var installErrorCause = __w_pdfjs_require__(101);
                var iterate = __w_pdfjs_require__(87);
                var normalizeStringArgument = __w_pdfjs_require__(102);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ERROR_STACK_INSTALLABLE = __w_pdfjs_require__(104);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var Error1 = global1.Error;
                var push = [].push;
                var $AggregateError = function AggregateError(errors, message) {
                    var options = arguments.length > 2 ? arguments[2] : undefined;
                    var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
                    var that;
                    if (setPrototypeOf) that = setPrototypeOf(new Error1(undefined), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
                    else {
                        that = isInstance ? this : create(AggregateErrorPrototype);
                        createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
                    }
                    createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
                    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
                    installErrorCause(that, options);
                    var errorsArray = [];
                    iterate(errors, push, {
                        that: errorsArray
                    });
                    createNonEnumerableProperty(that, 'errors', errorsArray);
                    return that;
                };
                if (setPrototypeOf) setPrototypeOf($AggregateError, Error1);
                else copyConstructorProperties($AggregateError, Error1);
                var AggregateErrorPrototype = $AggregateError.prototype = create(Error1.prototype, {
                    constructor: createPropertyDescriptor(1, $AggregateError),
                    message: createPropertyDescriptor(1, ''),
                    name: createPropertyDescriptor(1, 'AggregateError')
                });
                $({
                    global: true
                }, {
                    AggregateError: $AggregateError
                });
            /***/ },
            /* 99 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var arraySlice = __w_pdfjs_require__(100);
                var replace = uncurryThis(''.replace);
                var split = uncurryThis(''.split);
                var join = uncurryThis([].join);
                var TEST = function(arg) {
                    return String(Error(arg).stack);
                }('zxcasd');
                var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
                var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
                var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);
                module1.exports = function(stack, dropEntries) {
                    if (typeof stack != 'string') return stack;
                    if (IS_V8_OR_CHAKRA_STACK) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
                    else if (IS_FIREFOX_OR_SAFARI_STACK) return join(arraySlice(split(stack, '\n'), dropEntries), '\n');
                    return stack;
                };
            /***/ },
            /* 100 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var toAbsoluteIndex = __w_pdfjs_require__(62);
                var lengthOfArrayLike = __w_pdfjs_require__(64);
                var createProperty = __w_pdfjs_require__(95);
                var Array1 = global1.Array;
                var max = Math.max;
                module1.exports = function(O, start, end) {
                    var length = lengthOfArrayLike(O);
                    var k = toAbsoluteIndex(start, length);
                    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                    var result = Array1(max(fin - k, 0));
                    for(var n = 0; k < fin; k++, n++)createProperty(result, n, O[k]);
                    result.length = n;
                    return result;
                };
            /***/ },
            /* 101 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var isObject = __w_pdfjs_require__(24);
                var createNonEnumerableProperty = __w_pdfjs_require__(47);
                module1.exports = function(O, options) {
                    if (isObject(options) && 'cause' in options) createNonEnumerableProperty(O, 'cause', options.cause);
                };
            /***/ },
            /* 102 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var toString = __w_pdfjs_require__(103);
                module1.exports = function(argument, $default) {
                    return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
                };
            /***/ },
            /* 103 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var classof = __w_pdfjs_require__(92);
                var String1 = global1.String;
                module1.exports = function(argument) {
                    if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
                    return String1(argument);
                };
            /***/ },
            /* 104 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var fails = __w_pdfjs_require__(13);
                var createPropertyDescriptor = __w_pdfjs_require__(16);
                module1.exports = !fails(function() {
                    var error = Error('a');
                    if (!('stack' in error)) return true;
                    Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
                    return error.stack !== 7;
                });
            /***/ },
            /* 105 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var redefine = __w_pdfjs_require__(50);
                var toString = __w_pdfjs_require__(106);
                if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, 'toString', toString, {
                    unsafe: true
                });
            /***/ },
            /* 106 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(93);
                var classof = __w_pdfjs_require__(92);
                module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                    return '[object ' + classof(this) + ']';
                };
            /***/ },
            /* 107 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var IS_PURE = __w_pdfjs_require__(39);
                var global1 = __w_pdfjs_require__(10);
                var getBuiltIn = __w_pdfjs_require__(27);
                var call = __w_pdfjs_require__(14);
                var NativePromise = __w_pdfjs_require__(108);
                var redefine = __w_pdfjs_require__(50);
                var redefineAll = __w_pdfjs_require__(109);
                var setPrototypeOf = __w_pdfjs_require__(84);
                var setToStringTag = __w_pdfjs_require__(83);
                var setSpecies = __w_pdfjs_require__(110);
                var aCallable = __w_pdfjs_require__(34);
                var isCallable = __w_pdfjs_require__(25);
                var isObject = __w_pdfjs_require__(24);
                var anInstance = __w_pdfjs_require__(111);
                var inspectSource = __w_pdfjs_require__(51);
                var iterate = __w_pdfjs_require__(87);
                var checkCorrectnessOfIteration = __w_pdfjs_require__(112);
                var speciesConstructor = __w_pdfjs_require__(113);
                var task = __w_pdfjs_require__(116).set;
                var microtask = __w_pdfjs_require__(121);
                var promiseResolve = __w_pdfjs_require__(124);
                var hostReportErrors = __w_pdfjs_require__(126);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var InternalStateModule = __w_pdfjs_require__(52);
                var isForced = __w_pdfjs_require__(68);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var IS_BROWSER = __w_pdfjs_require__(128);
                var IS_NODE = __w_pdfjs_require__(120);
                var V8_VERSION = __w_pdfjs_require__(31);
                var SPECIES = wellKnownSymbol('species');
                var PROMISE = 'Promise';
                var getInternalState = InternalStateModule.getterFor(PROMISE);
                var setInternalState = InternalStateModule.set;
                var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
                var NativePromisePrototype = NativePromise && NativePromise.prototype;
                var PromiseConstructor = NativePromise;
                var PromisePrototype = NativePromisePrototype;
                var TypeError1 = global1.TypeError;
                var document1 = global1.document;
                var process = global1.process;
                var newPromiseCapability = newPromiseCapabilityModule.f;
                var newGenericPromiseCapability = newPromiseCapability;
                var DISPATCH_EVENT = !!(document1 && document1.createEvent && global1.dispatchEvent);
                var NATIVE_REJECTION_EVENT = isCallable(global1.PromiseRejectionEvent);
                var UNHANDLED_REJECTION = 'unhandledrejection';
                var REJECTION_HANDLED = 'rejectionhandled';
                var PENDING = 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                var HANDLED = 1;
                var UNHANDLED = 2;
                var SUBCLASSING = false;
                var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
                var FORCED = isForced(PROMISE, function() {
                    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
                    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
                    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
                    if (IS_PURE && !PromisePrototype['finally']) return true;
                    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
                    var promise = new PromiseConstructor(function(resolve) {
                        resolve(1);
                    });
                    var FakePromise = function(exec) {
                        exec(function() {}, function() {});
                    };
                    var constructor = promise.constructor = {};
                    constructor[SPECIES] = FakePromise;
                    SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                    if (!SUBCLASSING) return true;
                    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
                });
                var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
                    PromiseConstructor.all(iterable)['catch'](function() {});
                });
                var isThenable = function(it) {
                    var then;
                    return isObject(it) && isCallable(then = it.then) ? then : false;
                };
                var notify = function(state, isReject) {
                    if (state.notified) return;
                    state.notified = true;
                    var chain = state.reactions;
                    microtask(function() {
                        var value = state.value;
                        var ok = state.state == FULFILLED;
                        var index = 0;
                        while(chain.length > index){
                            var reaction = chain[index++];
                            var handler = ok ? reaction.ok : reaction.fail;
                            var resolve = reaction.resolve;
                            var reject = reaction.reject;
                            var domain = reaction.domain;
                            var result, then, exited;
                            try {
                                if (handler) {
                                    if (!ok) {
                                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                                        state.rejection = HANDLED;
                                    }
                                    if (handler === true) result = value;
                                    else {
                                        if (domain) domain.enter();
                                        result = handler(value);
                                        if (domain) {
                                            domain.exit();
                                            exited = true;
                                        }
                                    }
                                    if (result === reaction.promise) reject(TypeError1('Promise-chain cycle'));
                                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                                    else resolve(result);
                                } else reject(value);
                            } catch (error) {
                                if (domain && !exited) domain.exit();
                                reject(error);
                            }
                        }
                        state.reactions = [];
                        state.notified = false;
                        if (isReject && !state.rejection) onUnhandled(state);
                    });
                };
                var dispatchEvent = function(name, promise, reason) {
                    var event, handler;
                    if (DISPATCH_EVENT) {
                        event = document1.createEvent('Event');
                        event.promise = promise;
                        event.reason = reason;
                        event.initEvent(name, false, true);
                        global1.dispatchEvent(event);
                    } else event = {
                        promise: promise,
                        reason: reason
                    };
                    if (!NATIVE_REJECTION_EVENT && (handler = global1['on' + name])) handler(event);
                    else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
                };
                var onUnhandled = function(state) {
                    call(task, global1, function() {
                        var promise = state.facade;
                        var value = state.value;
                        var IS_UNHANDLED = isUnhandled(state);
                        var result;
                        if (IS_UNHANDLED) {
                            result = perform(function() {
                                if (IS_NODE) process.emit('unhandledRejection', value, promise);
                                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                            });
                            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                            if (result.error) throw result.value;
                        }
                    });
                };
                var isUnhandled = function(state) {
                    return state.rejection !== HANDLED && !state.parent;
                };
                var onHandleUnhandled = function(state) {
                    call(task, global1, function() {
                        var promise = state.facade;
                        if (IS_NODE) process.emit('rejectionHandled', promise);
                        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
                    });
                };
                var bind = function(fn, state, unwrap) {
                    return function(value) {
                        fn(state, value, unwrap);
                    };
                };
                var internalReject = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    state.value = value;
                    state.state = REJECTED;
                    notify(state, true);
                };
                var internalResolve = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    try {
                        if (state.facade === value) throw TypeError1("Promise can't be resolved itself");
                        var then = isThenable(value);
                        if (then) microtask(function() {
                            var wrapper = {
                                done: false
                            };
                            try {
                                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                            } catch (error) {
                                internalReject(wrapper, error, state);
                            }
                        });
                        else {
                            state.value = value;
                            state.state = FULFILLED;
                            notify(state, false);
                        }
                    } catch (error) {
                        internalReject({
                            done: false
                        }, error, state);
                    }
                };
                if (FORCED) {
                    PromiseConstructor = function Promise1(executor) {
                        anInstance(this, PromisePrototype);
                        aCallable(executor);
                        call(Internal, this);
                        var state = getInternalState(this);
                        try {
                            executor(bind(internalResolve, state), bind(internalReject, state));
                        } catch (error) {
                            internalReject(state, error);
                        }
                    };
                    PromisePrototype = PromiseConstructor.prototype;
                    Internal = function Promise1(executor) {
                        setInternalState(this, {
                            type: PROMISE,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: [],
                            rejection: false,
                            state: PENDING,
                            value: undefined
                        });
                    };
                    Internal.prototype = redefineAll(PromisePrototype, {
                        then: function then(onFulfilled, onRejected) {
                            var state = getInternalPromiseState(this);
                            var reactions = state.reactions;
                            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                            reaction.fail = isCallable(onRejected) && onRejected;
                            reaction.domain = IS_NODE ? process.domain : undefined;
                            state.parent = true;
                            reactions[reactions.length] = reaction;
                            if (state.state != PENDING) notify(state, false);
                            return reaction.promise;
                        },
                        'catch': function(onRejected) {
                            return this.then(undefined, onRejected);
                        }
                    });
                    OwnPromiseCapability = function() {
                        var promise = new Internal();
                        var state = getInternalState(promise);
                        this.promise = promise;
                        this.resolve = bind(internalResolve, state);
                        this.reject = bind(internalReject, state);
                    };
                    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                    };
                    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
                        nativeThen = NativePromisePrototype.then;
                        if (!SUBCLASSING) {
                            redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                                var that = this;
                                return new PromiseConstructor(function(resolve, reject) {
                                    call(nativeThen, that, resolve, reject);
                                }).then(onFulfilled, onRejected);
                            }, {
                                unsafe: true
                            });
                            redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], {
                                unsafe: true
                            });
                        }
                        try {
                            delete NativePromisePrototype.constructor;
                        } catch (error) {}
                        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: FORCED
                }, {
                    Promise: PromiseConstructor
                });
                setToStringTag(PromiseConstructor, PROMISE, false, true);
                setSpecies(PROMISE);
                PromiseWrapper = getBuiltIn(PROMISE);
                $({
                    target: PROMISE,
                    stat: true,
                    forced: FORCED
                }, {
                    reject: function reject(r) {
                        var capability = newPromiseCapability(this);
                        call(capability.reject, undefined, r);
                        return capability.promise;
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: IS_PURE || FORCED
                }, {
                    resolve: function resolve(x) {
                        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    all: function all(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call($promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = value;
                                    --remaining || resolve(values);
                                }, reject);
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    },
                    race: function race(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            iterate(iterable, function(promise) {
                                call($promiseResolve, C, promise).then(capability.resolve, reject);
                            });
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 108 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = global1.Promise;
            /***/ },
            /* 109 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var redefine = __w_pdfjs_require__(50);
                module1.exports = function(target, src, options) {
                    for(var key in src)redefine(target, key, src[key], options);
                    return target;
                };
            /***/ },
            /* 110 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var getBuiltIn = __w_pdfjs_require__(27);
                var definePropertyModule = __w_pdfjs_require__(48);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var DESCRIPTORS = __w_pdfjs_require__(12);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(CONSTRUCTOR_NAME) {
                    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                    var defineProperty = definePropertyModule.f;
                    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineProperty(Constructor, SPECIES, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /* 111 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isPrototypeOf = __w_pdfjs_require__(28);
                var TypeError1 = global1.TypeError;
                module1.exports = function(it, Prototype) {
                    if (isPrototypeOf(Prototype, it)) return it;
                    throw TypeError1('Incorrect invocation');
                };
            /***/ },
            /* 112 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var ITERATOR = wellKnownSymbol('iterator');
                var SAFE_CLOSING = false;
                try {
                    var called = 0;
                    var iteratorWithReturn = {
                        next: function() {
                            return {
                                done: !!called++
                            };
                        },
                        'return': function() {
                            SAFE_CLOSING = true;
                        }
                    };
                    iteratorWithReturn[ITERATOR] = function() {
                        return this;
                    };
                    Array.from(iteratorWithReturn, function() {
                        throw 2;
                    });
                } catch (error) {}
                module1.exports = function(exec, SKIP_CLOSING) {
                    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                    var ITERATION_SUPPORT = false;
                    try {
                        var object = {};
                        object[ITERATOR] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT = true
                                    };
                                }
                            };
                        };
                        exec(object);
                    } catch (error) {}
                    return ITERATION_SUPPORT;
                };
            /***/ },
            /* 113 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var aConstructor = __w_pdfjs_require__(114);
                var wellKnownSymbol = __w_pdfjs_require__(37);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(O, defaultConstructor) {
                    var C = anObject(O).constructor;
                    var S;
                    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
                };
            /***/ },
            /* 114 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var isConstructor = __w_pdfjs_require__(115);
                var tryToString = __w_pdfjs_require__(35);
                var TypeError1 = global1.TypeError;
                module1.exports = function(argument) {
                    if (isConstructor(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a constructor');
                };
            /***/ },
            /* 115 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var fails = __w_pdfjs_require__(13);
                var isCallable = __w_pdfjs_require__(25);
                var classof = __w_pdfjs_require__(92);
                var getBuiltIn = __w_pdfjs_require__(27);
                var inspectSource = __w_pdfjs_require__(51);
                var noop = function() {};
                var empty = [];
                var construct = getBuiltIn('Reflect', 'construct');
                var constructorRegExp = /^\s*(?:class|function)\b/;
                var exec = uncurryThis(constructorRegExp.exec);
                var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
                var isConstructorModern = function(argument) {
                    if (!isCallable(argument)) return false;
                    try {
                        construct(noop, empty, argument);
                        return true;
                    } catch (error) {
                        return false;
                    }
                };
                var isConstructorLegacy = function(argument) {
                    if (!isCallable(argument)) return false;
                    switch(classof(argument)){
                        case 'AsyncFunction':
                        case 'GeneratorFunction':
                        case 'AsyncGeneratorFunction':
                            return false;
                    }
                    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
                };
                module1.exports = !construct || fails(function() {
                    var called;
                    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                        called = true;
                    }) || called;
                }) ? isConstructorLegacy : isConstructorModern;
            /***/ },
            /* 116 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var apply = __w_pdfjs_require__(117);
                var bind = __w_pdfjs_require__(88);
                var isCallable = __w_pdfjs_require__(25);
                var hasOwn = __w_pdfjs_require__(42);
                var fails = __w_pdfjs_require__(13);
                var html = __w_pdfjs_require__(76);
                var arraySlice = __w_pdfjs_require__(118);
                var createElement = __w_pdfjs_require__(46);
                var IS_IOS = __w_pdfjs_require__(119);
                var IS_NODE = __w_pdfjs_require__(120);
                var set = global1.setImmediate;
                var clear = global1.clearImmediate;
                var process = global1.process;
                var Dispatch = global1.Dispatch;
                var Function1 = global1.Function;
                var MessageChannel = global1.MessageChannel;
                var String1 = global1.String;
                var counter = 0;
                var queue = {};
                var ONREADYSTATECHANGE = 'onreadystatechange';
                var location, defer, channel, port;
                try {
                    location = global1.location;
                } catch (error) {}
                var run = function(id) {
                    if (hasOwn(queue, id)) {
                        var fn = queue[id];
                        delete queue[id];
                        fn();
                    }
                };
                var runner = function(id) {
                    return function() {
                        run(id);
                    };
                };
                var listener = function(event) {
                    run(event.data);
                };
                var post = function(id) {
                    global1.postMessage(String1(id), location.protocol + '//' + location.host);
                };
                if (!set || !clear) {
                    set = function setImmediate(fn) {
                        var args = arraySlice(arguments, 1);
                        queue[++counter] = function() {
                            apply(isCallable(fn) ? fn : Function1(fn), undefined, args);
                        };
                        defer(counter);
                        return counter;
                    };
                    clear = function clearImmediate(id) {
                        delete queue[id];
                    };
                    if (IS_NODE) defer = function(id) {
                        process.nextTick(runner(id));
                    };
                    else if (Dispatch && Dispatch.now) defer = function(id) {
                        Dispatch.now(runner(id));
                    };
                    else if (MessageChannel && !IS_IOS) {
                        channel = new MessageChannel();
                        port = channel.port2;
                        channel.port1.onmessage = listener;
                        defer = bind(port.postMessage, port);
                    } else if (global1.addEventListener && isCallable(global1.postMessage) && !global1.importScripts && location && location.protocol !== 'file:' && !fails(post)) {
                        defer = post;
                        global1.addEventListener('message', listener, false);
                    } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
                        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                            html.removeChild(this);
                            run(id);
                        };
                    };
                    else defer = function(id) {
                        setTimeout(runner(id), 0);
                    };
                }
                module1.exports = {
                    set: set,
                    clear: clear
                };
            /***/ },
            /* 117 */ /***/ (module1)=>{
                var FunctionPrototype = Function.prototype;
                var apply = FunctionPrototype.apply;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                module1.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function() {
                    return call.apply(apply, arguments);
                });
            /***/ },
            /* 118 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                module1.exports = uncurryThis([].slice);
            /***/ },
            /* 119 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                module1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
            /***/ },
            /* 120 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var classof = __w_pdfjs_require__(20);
                var global1 = __w_pdfjs_require__(10);
                module1.exports = classof(global1.process) == 'process';
            /***/ },
            /* 121 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                var bind = __w_pdfjs_require__(88);
                var getOwnPropertyDescriptor = __w_pdfjs_require__(11).f;
                var macrotask = __w_pdfjs_require__(116).set;
                var IS_IOS = __w_pdfjs_require__(119);
                var IS_IOS_PEBBLE = __w_pdfjs_require__(122);
                var IS_WEBOS_WEBKIT = __w_pdfjs_require__(123);
                var IS_NODE = __w_pdfjs_require__(120);
                var MutationObserver = global1.MutationObserver || global1.WebKitMutationObserver;
                var document1 = global1.document;
                var process = global1.process;
                var Promise1 = global1.Promise;
                var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global1, 'queueMicrotask');
                var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
                var flush, head, last, notify, toggle, node, promise, then;
                if (!queueMicrotask) {
                    flush = function() {
                        var parent, fn;
                        if (IS_NODE && (parent = process.domain)) parent.exit();
                        while(head){
                            fn = head.fn;
                            head = head.next;
                            try {
                                fn();
                            } catch (error) {
                                if (head) notify();
                                else last = undefined;
                                throw error;
                            }
                        }
                        last = undefined;
                        if (parent) parent.enter();
                    };
                    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                        toggle = true;
                        node = document1.createTextNode('');
                        new MutationObserver(flush).observe(node, {
                            characterData: true
                        });
                        notify = function() {
                            node.data = toggle = !toggle;
                        };
                    } else if (!IS_IOS_PEBBLE && Promise1 && Promise1.resolve) {
                        promise = Promise1.resolve(undefined);
                        promise.constructor = Promise1;
                        then = bind(promise.then, promise);
                        notify = function() {
                            then(flush);
                        };
                    } else if (IS_NODE) notify = function() {
                        process.nextTick(flush);
                    };
                    else {
                        macrotask = bind(macrotask, global1);
                        notify = function() {
                            macrotask(flush);
                        };
                    }
                }
                module1.exports = queueMicrotask || function(fn) {
                    var task = {
                        fn: fn,
                        next: undefined
                    };
                    if (last) last.next = task;
                    if (!head) {
                        head = task;
                        notify();
                    }
                    last = task;
                };
            /***/ },
            /* 122 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                var global1 = __w_pdfjs_require__(10);
                module1.exports = /ipad|iphone|ipod/i.test(userAgent) && global1.Pebble !== undefined;
            /***/ },
            /* 123 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var userAgent = __w_pdfjs_require__(32);
                module1.exports = /web0s(?!.*chrome)/i.test(userAgent);
            /***/ },
            /* 124 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var anObject = __w_pdfjs_require__(49);
                var isObject = __w_pdfjs_require__(24);
                var newPromiseCapability = __w_pdfjs_require__(125);
                module1.exports = function(C, x) {
                    anObject(C);
                    if (isObject(x) && x.constructor === C) return x;
                    var promiseCapability = newPromiseCapability.f(C);
                    var resolve = promiseCapability.resolve;
                    resolve(x);
                    return promiseCapability.promise;
                };
            /***/ },
            /* 125 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var aCallable = __w_pdfjs_require__(34);
                var PromiseCapability = function(C) {
                    var resolve, reject;
                    this.promise = new C(function($$resolve, $$reject) {
                        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
                        resolve = $$resolve;
                        reject = $$reject;
                    });
                    this.resolve = aCallable(resolve);
                    this.reject = aCallable(reject);
                };
                module1.exports.f = function(C) {
                    return new PromiseCapability(C);
                };
            /***/ },
            /* 126 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var global1 = __w_pdfjs_require__(10);
                module1.exports = function(a, b) {
                    var console1 = global1.console;
                    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
                };
            /***/ },
            /* 127 */ /***/ (module1)=>{
                module1.exports = function(exec) {
                    try {
                        return {
                            error: false,
                            value: exec()
                        };
                    } catch (error) {
                        return {
                            error: true,
                            value: error
                        };
                    }
                };
            /***/ },
            /* 128 */ /***/ (module1)=>{
                module1.exports = typeof window == 'object';
            /***/ },
            /* 129 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var call = __w_pdfjs_require__(14);
                var aCallable = __w_pdfjs_require__(34);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var iterate = __w_pdfjs_require__(87);
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    allSettled: function allSettled(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'fulfilled',
                                        value: value
                                    };
                                    --remaining || resolve(values);
                                }, function(error) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'rejected',
                                        reason: error
                                    };
                                    --remaining || resolve(values);
                                });
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 130 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var aCallable = __w_pdfjs_require__(34);
                var getBuiltIn = __w_pdfjs_require__(27);
                var call = __w_pdfjs_require__(14);
                var newPromiseCapabilityModule = __w_pdfjs_require__(125);
                var perform = __w_pdfjs_require__(127);
                var iterate = __w_pdfjs_require__(87);
                var PROMISE_ANY_ERROR = 'No one promise resolved';
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    any: function any(iterable) {
                        var C = this;
                        var AggregateError = getBuiltIn('AggregateError');
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var errors = [];
                            var counter = 0;
                            var remaining = 1;
                            var alreadyResolved = false;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyRejected = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyResolved = true;
                                    resolve(value);
                                }, function(error) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyRejected = true;
                                    errors[index] = error;
                                    --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                                });
                            });
                            --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /* 131 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var $ = __w_pdfjs_require__(9);
                var IS_PURE = __w_pdfjs_require__(39);
                var NativePromise = __w_pdfjs_require__(108);
                var fails = __w_pdfjs_require__(13);
                var getBuiltIn = __w_pdfjs_require__(27);
                var isCallable = __w_pdfjs_require__(25);
                var speciesConstructor = __w_pdfjs_require__(113);
                var promiseResolve = __w_pdfjs_require__(124);
                var redefine = __w_pdfjs_require__(50);
                var NON_GENERIC = !!NativePromise && fails(function() {
                    NativePromise.prototype['finally'].call({
                        then: function() {}
                    }, function() {});
                });
                $({
                    target: 'Promise',
                    proto: true,
                    real: true,
                    forced: NON_GENERIC
                }, {
                    'finally': function(onFinally) {
                        var C = speciesConstructor(this, getBuiltIn('Promise'));
                        var isFunction = isCallable(onFinally);
                        return this.then(isFunction ? function(x) {
                            return promiseResolve(C, onFinally()).then(function() {
                                return x;
                            });
                        } : onFinally, isFunction ? function(e) {
                            return promiseResolve(C, onFinally()).then(function() {
                                throw e;
                            });
                        } : onFinally);
                    }
                });
                if (!IS_PURE && isCallable(NativePromise)) {
                    var method = getBuiltIn('Promise').prototype['finally'];
                    if (NativePromise.prototype['finally'] !== method) redefine(NativePromise.prototype, 'finally', method, {
                        unsafe: true
                    });
                }
            /***/ },
            /* 132 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                "use strict";
                var charAt = __w_pdfjs_require__(133).charAt;
                var toString = __w_pdfjs_require__(103);
                var InternalStateModule = __w_pdfjs_require__(52);
                var defineIterator = __w_pdfjs_require__(78);
                var STRING_ITERATOR = 'String Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                defineIterator(String, 'String', function(iterated) {
                    setInternalState(this, {
                        type: STRING_ITERATOR,
                        string: toString(iterated),
                        index: 0
                    });
                }, function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length) return {
                        value: undefined,
                        done: true
                    };
                    point = charAt(string, index);
                    state.index += point.length;
                    return {
                        value: point,
                        done: false
                    };
                });
            /***/ },
            /* 133 */ /***/ (module1, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var uncurryThis = __w_pdfjs_require__(19);
                var toIntegerOrInfinity = __w_pdfjs_require__(63);
                var toString = __w_pdfjs_require__(103);
                var requireObjectCoercible = __w_pdfjs_require__(21);
                var charAt = uncurryThis(''.charAt);
                var charCodeAt = uncurryThis(''.charCodeAt);
                var stringSlice = uncurryThis(''.slice);
                var createMethod = function(CONVERT_TO_STRING) {
                    return function($this, pos) {
                        var S = toString(requireObjectCoercible($this));
                        var position = toIntegerOrInfinity(pos);
                        var size = S.length;
                        var first, second;
                        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                        first = charCodeAt(S, position);
                        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                    };
                };
                module1.exports = {
                    codeAt: createMethod(false),
                    charAt: createMethod(true)
                };
            /***/ },
            /* 134 */ /***/ function(__unused_webpack_module, exports) {
                (function(global1, factory) {
                    factory(exports);
                })(this, function(exports) {
                    'use strict';
                    var SymbolPolyfill = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol : function(description) {
                        return "Symbol(" + description + ")";
                    };
                    function noop() {
                        return undefined;
                    }
                    function getGlobals() {
                        if (typeof self !== 'undefined') return self;
                        else if (typeof window !== 'undefined') return window;
                        else if (typeof $parcel$global !== 'undefined') return $parcel$global;
                        return undefined;
                    }
                    var globals = getGlobals();
                    function typeIsObject(x) {
                        return typeof x === 'object' && x !== null || typeof x === 'function';
                    }
                    var rethrowAssertionErrorRejection = noop;
                    var originalPromise = Promise;
                    var originalPromiseThen = Promise.prototype.then;
                    var originalPromiseResolve = Promise.resolve.bind(originalPromise);
                    var originalPromiseReject = Promise.reject.bind(originalPromise);
                    function newPromise(executor) {
                        return new originalPromise(executor);
                    }
                    function promiseResolvedWith(value) {
                        return originalPromiseResolve(value);
                    }
                    function promiseRejectedWith(reason) {
                        return originalPromiseReject(reason);
                    }
                    function PerformPromiseThen(promise, onFulfilled, onRejected) {
                        return originalPromiseThen.call(promise, onFulfilled, onRejected);
                    }
                    function uponPromise(promise, onFulfilled, onRejected) {
                        PerformPromiseThen(PerformPromiseThen(promise, onFulfilled, onRejected), undefined, rethrowAssertionErrorRejection);
                    }
                    function uponFulfillment(promise, onFulfilled) {
                        uponPromise(promise, onFulfilled);
                    }
                    function uponRejection(promise, onRejected) {
                        uponPromise(promise, undefined, onRejected);
                    }
                    function transformPromiseWith(promise, fulfillmentHandler, rejectionHandler) {
                        return PerformPromiseThen(promise, fulfillmentHandler, rejectionHandler);
                    }
                    function setPromiseIsHandledToTrue(promise) {
                        PerformPromiseThen(promise, undefined, rethrowAssertionErrorRejection);
                    }
                    var queueMicrotask = function() {
                        var globalQueueMicrotask = globals && globals.queueMicrotask;
                        if (typeof globalQueueMicrotask === 'function') return globalQueueMicrotask;
                        var resolvedPromise = promiseResolvedWith(undefined);
                        return function(fn) {
                            return PerformPromiseThen(resolvedPromise, fn);
                        };
                    }();
                    function reflectCall(F, V, args) {
                        if (typeof F !== 'function') throw new TypeError('Argument is not a function');
                        return Function.prototype.apply.call(F, V, args);
                    }
                    function promiseCall(F, V, args) {
                        try {
                            return promiseResolvedWith(reflectCall(F, V, args));
                        } catch (value) {
                            return promiseRejectedWith(value);
                        }
                    }
                    var QUEUE_MAX_ARRAY_SIZE = 16384;
                    var SimpleQueue = function() {
                        function SimpleQueue() {
                            this._cursor = 0;
                            this._size = 0;
                            this._front = {
                                _elements: [],
                                _next: undefined
                            };
                            this._back = this._front;
                            this._cursor = 0;
                            this._size = 0;
                        }
                        Object.defineProperty(SimpleQueue.prototype, "length", {
                            get: function() {
                                return this._size;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        SimpleQueue.prototype.push = function(element) {
                            var oldBack = this._back;
                            var newBack = oldBack;
                            if (oldBack._elements.length === QUEUE_MAX_ARRAY_SIZE - 1) newBack = {
                                _elements: [],
                                _next: undefined
                            };
                            oldBack._elements.push(element);
                            if (newBack !== oldBack) {
                                this._back = newBack;
                                oldBack._next = newBack;
                            }
                            ++this._size;
                        };
                        SimpleQueue.prototype.shift = function() {
                            var oldFront = this._front;
                            var newFront = oldFront;
                            var oldCursor = this._cursor;
                            var newCursor = oldCursor + 1;
                            var elements = oldFront._elements;
                            var element = elements[oldCursor];
                            if (newCursor === QUEUE_MAX_ARRAY_SIZE) {
                                newFront = oldFront._next;
                                newCursor = 0;
                            }
                            --this._size;
                            this._cursor = newCursor;
                            if (oldFront !== newFront) this._front = newFront;
                            elements[oldCursor] = undefined;
                            return element;
                        };
                        SimpleQueue.prototype.forEach = function(callback) {
                            var i = this._cursor;
                            var node = this._front;
                            var elements = node._elements;
                            while(i !== elements.length || node._next !== undefined){
                                if (i === elements.length) {
                                    node = node._next;
                                    elements = node._elements;
                                    i = 0;
                                    if (elements.length === 0) break;
                                }
                                callback(elements[i]);
                                ++i;
                            }
                        };
                        SimpleQueue.prototype.peek = function() {
                            var front = this._front;
                            var cursor = this._cursor;
                            return front._elements[cursor];
                        };
                        return SimpleQueue;
                    }();
                    function ReadableStreamReaderGenericInitialize(reader, stream) {
                        reader._ownerReadableStream = stream;
                        stream._reader = reader;
                        if (stream._state === 'readable') defaultReaderClosedPromiseInitialize(reader);
                        else if (stream._state === 'closed') defaultReaderClosedPromiseInitializeAsResolved(reader);
                        else defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
                    }
                    function ReadableStreamReaderGenericCancel(reader, reason) {
                        var stream = reader._ownerReadableStream;
                        return ReadableStreamCancel(stream, reason);
                    }
                    function ReadableStreamReaderGenericRelease(reader) {
                        if (reader._ownerReadableStream._state === 'readable') defaultReaderClosedPromiseReject(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        else defaultReaderClosedPromiseResetToRejected(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        reader._ownerReadableStream._reader = undefined;
                        reader._ownerReadableStream = undefined;
                    }
                    function readerLockException(name) {
                        return new TypeError('Cannot ' + name + ' a stream using a released reader');
                    }
                    function defaultReaderClosedPromiseInitialize(reader) {
                        reader._closedPromise = newPromise(function(resolve, reject) {
                            reader._closedPromise_resolve = resolve;
                            reader._closedPromise_reject = reject;
                        });
                    }
                    function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
                        defaultReaderClosedPromiseInitialize(reader);
                        defaultReaderClosedPromiseReject(reader, reason);
                    }
                    function defaultReaderClosedPromiseInitializeAsResolved(reader) {
                        defaultReaderClosedPromiseInitialize(reader);
                        defaultReaderClosedPromiseResolve(reader);
                    }
                    function defaultReaderClosedPromiseReject(reader, reason) {
                        if (reader._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(reader._closedPromise);
                        reader._closedPromise_reject(reason);
                        reader._closedPromise_resolve = undefined;
                        reader._closedPromise_reject = undefined;
                    }
                    function defaultReaderClosedPromiseResetToRejected(reader, reason) {
                        defaultReaderClosedPromiseInitializeAsRejected(reader, reason);
                    }
                    function defaultReaderClosedPromiseResolve(reader) {
                        if (reader._closedPromise_resolve === undefined) return;
                        reader._closedPromise_resolve(undefined);
                        reader._closedPromise_resolve = undefined;
                        reader._closedPromise_reject = undefined;
                    }
                    var AbortSteps = SymbolPolyfill('[[AbortSteps]]');
                    var ErrorSteps = SymbolPolyfill('[[ErrorSteps]]');
                    var CancelSteps = SymbolPolyfill('[[CancelSteps]]');
                    var PullSteps = SymbolPolyfill('[[PullSteps]]');
                    var NumberIsFinite = Number.isFinite || function(x) {
                        return typeof x === 'number' && isFinite(x);
                    };
                    var MathTrunc = Math.trunc || function(v) {
                        return v < 0 ? Math.ceil(v) : Math.floor(v);
                    };
                    function isDictionary(x) {
                        return typeof x === 'object' || typeof x === 'function';
                    }
                    function assertDictionary(obj, context) {
                        if (obj !== undefined && !isDictionary(obj)) throw new TypeError(context + " is not an object.");
                    }
                    function assertFunction(x, context) {
                        if (typeof x !== 'function') throw new TypeError(context + " is not a function.");
                    }
                    function isObject(x) {
                        return typeof x === 'object' && x !== null || typeof x === 'function';
                    }
                    function assertObject(x, context) {
                        if (!isObject(x)) throw new TypeError(context + " is not an object.");
                    }
                    function assertRequiredArgument(x, position, context) {
                        if (x === undefined) throw new TypeError("Parameter " + position + " is required in '" + context + "'.");
                    }
                    function assertRequiredField(x, field, context) {
                        if (x === undefined) throw new TypeError(field + " is required in '" + context + "'.");
                    }
                    function convertUnrestrictedDouble(value) {
                        return Number(value);
                    }
                    function censorNegativeZero(x) {
                        return x === 0 ? 0 : x;
                    }
                    function integerPart(x) {
                        return censorNegativeZero(MathTrunc(x));
                    }
                    function convertUnsignedLongLongWithEnforceRange(value, context) {
                        var lowerBound = 0;
                        var upperBound = Number.MAX_SAFE_INTEGER;
                        var x = Number(value);
                        x = censorNegativeZero(x);
                        if (!NumberIsFinite(x)) throw new TypeError(context + " is not a finite number");
                        x = integerPart(x);
                        if (x < lowerBound || x > upperBound) throw new TypeError(context + " is outside the accepted range of " + lowerBound + " to " + upperBound + ", inclusive");
                        if (!NumberIsFinite(x) || x === 0) return 0;
                        return x;
                    }
                    function assertReadableStream(x, context) {
                        if (!IsReadableStream(x)) throw new TypeError(context + " is not a ReadableStream.");
                    }
                    function AcquireReadableStreamDefaultReader(stream) {
                        return new ReadableStreamDefaultReader(stream);
                    }
                    function ReadableStreamAddReadRequest(stream, readRequest) {
                        stream._reader._readRequests.push(readRequest);
                    }
                    function ReadableStreamFulfillReadRequest(stream, chunk, done) {
                        var reader = stream._reader;
                        var readRequest = reader._readRequests.shift();
                        if (done) readRequest._closeSteps();
                        else readRequest._chunkSteps(chunk);
                    }
                    function ReadableStreamGetNumReadRequests(stream) {
                        return stream._reader._readRequests.length;
                    }
                    function ReadableStreamHasDefaultReader(stream) {
                        var reader = stream._reader;
                        if (reader === undefined) return false;
                        if (!IsReadableStreamDefaultReader(reader)) return false;
                        return true;
                    }
                    var ReadableStreamDefaultReader = function() {
                        function ReadableStreamDefaultReader(stream) {
                            assertRequiredArgument(stream, 1, 'ReadableStreamDefaultReader');
                            assertReadableStream(stream, 'First parameter');
                            if (IsReadableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                            ReadableStreamReaderGenericInitialize(this, stream);
                            this._readRequests = new SimpleQueue();
                        }
                        Object.defineProperty(ReadableStreamDefaultReader.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultReader.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('cancel'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('cancel'));
                            return ReadableStreamReaderGenericCancel(this, reason);
                        };
                        ReadableStreamDefaultReader.prototype.read = function() {
                            if (!IsReadableStreamDefaultReader(this)) return promiseRejectedWith(defaultReaderBrandCheckException('read'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('read from'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: false
                                    });
                                },
                                _closeSteps: function() {
                                    return resolvePromise({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e) {
                                    return rejectPromise(e);
                                }
                            };
                            ReadableStreamDefaultReaderRead(this, readRequest);
                            return promise;
                        };
                        ReadableStreamDefaultReader.prototype.releaseLock = function() {
                            if (!IsReadableStreamDefaultReader(this)) throw defaultReaderBrandCheckException('releaseLock');
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readRequests.length > 0) throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
                            ReadableStreamReaderGenericRelease(this);
                        };
                        return ReadableStreamDefaultReader;
                    }();
                    Object.defineProperties(ReadableStreamDefaultReader.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamDefaultReader.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamDefaultReader',
                        configurable: true
                    });
                    function IsReadableStreamDefaultReader(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) return false;
                        return x instanceof ReadableStreamDefaultReader;
                    }
                    function ReadableStreamDefaultReaderRead(reader, readRequest) {
                        var stream = reader._ownerReadableStream;
                        stream._disturbed = true;
                        if (stream._state === 'closed') readRequest._closeSteps();
                        else if (stream._state === 'errored') readRequest._errorSteps(stream._storedError);
                        else stream._readableStreamController[PullSteps](readRequest);
                    }
                    function defaultReaderBrandCheckException(name) {
                        return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
                    }
                    var _a;
                    var AsyncIteratorPrototype;
                    if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
                        AsyncIteratorPrototype = (_a = {}, _a[SymbolPolyfill.asyncIterator] = function() {
                            return this;
                        }, _a);
                        Object.defineProperty(AsyncIteratorPrototype, SymbolPolyfill.asyncIterator, {
                            enumerable: false
                        });
                    }
                    var ReadableStreamAsyncIteratorImpl = function() {
                        function ReadableStreamAsyncIteratorImpl(reader, preventCancel) {
                            this._ongoingPromise = undefined;
                            this._isFinished = false;
                            this._reader = reader;
                            this._preventCancel = preventCancel;
                        }
                        ReadableStreamAsyncIteratorImpl.prototype.next = function() {
                            var _this = this;
                            var nextSteps = function() {
                                return _this._nextSteps();
                            };
                            this._ongoingPromise = this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, nextSteps, nextSteps) : nextSteps();
                            return this._ongoingPromise;
                        };
                        ReadableStreamAsyncIteratorImpl.prototype.return = function(value) {
                            var _this = this;
                            var returnSteps = function() {
                                return _this._returnSteps(value);
                            };
                            return this._ongoingPromise ? transformPromiseWith(this._ongoingPromise, returnSteps, returnSteps) : returnSteps();
                        };
                        ReadableStreamAsyncIteratorImpl.prototype._nextSteps = function() {
                            var _this = this;
                            if (this._isFinished) return Promise.resolve({
                                value: undefined,
                                done: true
                            });
                            var reader = this._reader;
                            if (reader._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('iterate'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    _this._ongoingPromise = undefined;
                                    queueMicrotask(function() {
                                        return resolvePromise({
                                            value: chunk,
                                            done: false
                                        });
                                    });
                                },
                                _closeSteps: function() {
                                    _this._ongoingPromise = undefined;
                                    _this._isFinished = true;
                                    ReadableStreamReaderGenericRelease(reader);
                                    resolvePromise({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(reason) {
                                    _this._ongoingPromise = undefined;
                                    _this._isFinished = true;
                                    ReadableStreamReaderGenericRelease(reader);
                                    rejectPromise(reason);
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                            return promise;
                        };
                        ReadableStreamAsyncIteratorImpl.prototype._returnSteps = function(value) {
                            if (this._isFinished) return Promise.resolve({
                                value: value,
                                done: true
                            });
                            this._isFinished = true;
                            var reader = this._reader;
                            if (reader._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('finish iterating'));
                            if (!this._preventCancel) {
                                var result = ReadableStreamReaderGenericCancel(reader, value);
                                ReadableStreamReaderGenericRelease(reader);
                                return transformPromiseWith(result, function() {
                                    return {
                                        value: value,
                                        done: true
                                    };
                                });
                            }
                            ReadableStreamReaderGenericRelease(reader);
                            return promiseResolvedWith({
                                value: value,
                                done: true
                            });
                        };
                        return ReadableStreamAsyncIteratorImpl;
                    }();
                    var ReadableStreamAsyncIteratorPrototype = {
                        next: function() {
                            if (!IsReadableStreamAsyncIterator(this)) return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'));
                            return this._asyncIteratorImpl.next();
                        },
                        return: function(value) {
                            if (!IsReadableStreamAsyncIterator(this)) return promiseRejectedWith(streamAsyncIteratorBrandCheckException('return'));
                            return this._asyncIteratorImpl.return(value);
                        }
                    };
                    if (AsyncIteratorPrototype !== undefined) Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype, AsyncIteratorPrototype);
                    function AcquireReadableStreamAsyncIterator(stream, preventCancel) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var impl = new ReadableStreamAsyncIteratorImpl(reader, preventCancel);
                        var iterator = Object.create(ReadableStreamAsyncIteratorPrototype);
                        iterator._asyncIteratorImpl = impl;
                        return iterator;
                    }
                    function IsReadableStreamAsyncIterator(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_asyncIteratorImpl')) return false;
                        try {
                            return x._asyncIteratorImpl instanceof ReadableStreamAsyncIteratorImpl;
                        } catch (_a) {
                            return false;
                        }
                    }
                    function streamAsyncIteratorBrandCheckException(name) {
                        return new TypeError("ReadableStreamAsyncIterator." + name + " can only be used on a ReadableSteamAsyncIterator");
                    }
                    var NumberIsNaN = Number.isNaN || function(x) {
                        return x !== x;
                    };
                    function CreateArrayFromList(elements) {
                        return elements.slice();
                    }
                    function CopyDataBlockBytes(dest, destOffset, src, srcOffset, n) {
                        new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
                    }
                    function TransferArrayBuffer(O) {
                        return O;
                    }
                    function IsDetachedBuffer(O) {
                        return false;
                    }
                    function ArrayBufferSlice(buffer, begin, end) {
                        if (buffer.slice) return buffer.slice(begin, end);
                        var length = end - begin;
                        var slice = new ArrayBuffer(length);
                        CopyDataBlockBytes(slice, 0, buffer, begin, length);
                        return slice;
                    }
                    function IsNonNegativeNumber(v) {
                        if (typeof v !== 'number') return false;
                        if (NumberIsNaN(v)) return false;
                        if (v < 0) return false;
                        return true;
                    }
                    function CloneAsUint8Array(O) {
                        var buffer = ArrayBufferSlice(O.buffer, O.byteOffset, O.byteOffset + O.byteLength);
                        return new Uint8Array(buffer);
                    }
                    function DequeueValue(container) {
                        var pair = container._queue.shift();
                        container._queueTotalSize -= pair.size;
                        if (container._queueTotalSize < 0) container._queueTotalSize = 0;
                        return pair.value;
                    }
                    function EnqueueValueWithSize(container, value, size) {
                        if (!IsNonNegativeNumber(size) || size === Infinity) throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
                        container._queue.push({
                            value: value,
                            size: size
                        });
                        container._queueTotalSize += size;
                    }
                    function PeekQueueValue(container) {
                        var pair = container._queue.peek();
                        return pair.value;
                    }
                    function ResetQueue(container) {
                        container._queue = new SimpleQueue();
                        container._queueTotalSize = 0;
                    }
                    var ReadableStreamBYOBRequest = function() {
                        function ReadableStreamBYOBRequest() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableStreamBYOBRequest.prototype, "view", {
                            get: function() {
                                if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('view');
                                return this._view;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBRequest.prototype.respond = function(bytesWritten) {
                            if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('respond');
                            assertRequiredArgument(bytesWritten, 1, 'respond');
                            bytesWritten = convertUnsignedLongLongWithEnforceRange(bytesWritten, 'First parameter');
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError('This BYOB request has been invalidated');
                            IsDetachedBuffer(this._view.buffer);
                            ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
                        };
                        ReadableStreamBYOBRequest.prototype.respondWithNewView = function(view) {
                            if (!IsReadableStreamBYOBRequest(this)) throw byobRequestBrandCheckException('respondWithNewView');
                            assertRequiredArgument(view, 1, 'respondWithNewView');
                            if (!ArrayBuffer.isView(view)) throw new TypeError('You can only respond with array buffer views');
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError('This BYOB request has been invalidated');
                            IsDetachedBuffer(view.buffer);
                            ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
                        };
                        return ReadableStreamBYOBRequest;
                    }();
                    Object.defineProperties(ReadableStreamBYOBRequest.prototype, {
                        respond: {
                            enumerable: true
                        },
                        respondWithNewView: {
                            enumerable: true
                        },
                        view: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamBYOBRequest.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamBYOBRequest',
                        configurable: true
                    });
                    var ReadableByteStreamController = function() {
                        function ReadableByteStreamController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableByteStreamController.prototype, "byobRequest", {
                            get: function() {
                                if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('byobRequest');
                                return ReadableByteStreamControllerGetBYOBRequest(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ReadableByteStreamController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('desiredSize');
                                return ReadableByteStreamControllerGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableByteStreamController.prototype.close = function() {
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('close');
                            if (this._closeRequested) throw new TypeError('The stream has already been closed; do not close it again!');
                            var state = this._controlledReadableByteStream._state;
                            if (state !== 'readable') throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
                            ReadableByteStreamControllerClose(this);
                        };
                        ReadableByteStreamController.prototype.enqueue = function(chunk) {
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('enqueue');
                            assertRequiredArgument(chunk, 1, 'enqueue');
                            if (!ArrayBuffer.isView(chunk)) throw new TypeError('chunk must be an array buffer view');
                            if (chunk.byteLength === 0) throw new TypeError('chunk must have non-zero byteLength');
                            if (chunk.buffer.byteLength === 0) throw new TypeError("chunk's buffer must have non-zero byteLength");
                            if (this._closeRequested) throw new TypeError('stream is closed or draining');
                            var state = this._controlledReadableByteStream._state;
                            if (state !== 'readable') throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
                            ReadableByteStreamControllerEnqueue(this, chunk);
                        };
                        ReadableByteStreamController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsReadableByteStreamController(this)) throw byteStreamControllerBrandCheckException('error');
                            ReadableByteStreamControllerError(this, e);
                        };
                        ReadableByteStreamController.prototype[CancelSteps] = function(reason) {
                            ReadableByteStreamControllerClearPendingPullIntos(this);
                            ResetQueue(this);
                            var result = this._cancelAlgorithm(reason);
                            ReadableByteStreamControllerClearAlgorithms(this);
                            return result;
                        };
                        ReadableByteStreamController.prototype[PullSteps] = function(readRequest) {
                            var stream = this._controlledReadableByteStream;
                            if (this._queueTotalSize > 0) {
                                var entry = this._queue.shift();
                                this._queueTotalSize -= entry.byteLength;
                                ReadableByteStreamControllerHandleQueueDrain(this);
                                var view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
                                readRequest._chunkSteps(view);
                                return;
                            }
                            var autoAllocateChunkSize = this._autoAllocateChunkSize;
                            if (autoAllocateChunkSize !== undefined) {
                                var buffer = void 0;
                                try {
                                    buffer = new ArrayBuffer(autoAllocateChunkSize);
                                } catch (bufferE) {
                                    readRequest._errorSteps(bufferE);
                                    return;
                                }
                                var pullIntoDescriptor = {
                                    buffer: buffer,
                                    bufferByteLength: autoAllocateChunkSize,
                                    byteOffset: 0,
                                    byteLength: autoAllocateChunkSize,
                                    bytesFilled: 0,
                                    elementSize: 1,
                                    viewConstructor: Uint8Array,
                                    readerType: 'default'
                                };
                                this._pendingPullIntos.push(pullIntoDescriptor);
                            }
                            ReadableStreamAddReadRequest(stream, readRequest);
                            ReadableByteStreamControllerCallPullIfNeeded(this);
                        };
                        return ReadableByteStreamController;
                    }();
                    Object.defineProperties(ReadableByteStreamController.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        byobRequest: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableByteStreamController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableByteStreamController',
                        configurable: true
                    });
                    function IsReadableByteStreamController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableByteStream')) return false;
                        return x instanceof ReadableByteStreamController;
                    }
                    function IsReadableStreamBYOBRequest(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) return false;
                        return x instanceof ReadableStreamBYOBRequest;
                    }
                    function ReadableByteStreamControllerCallPullIfNeeded(controller) {
                        var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
                        if (!shouldPull) return;
                        if (controller._pulling) {
                            controller._pullAgain = true;
                            return;
                        }
                        controller._pulling = true;
                        var pullPromise = controller._pullAlgorithm();
                        uponPromise(pullPromise, function() {
                            controller._pulling = false;
                            if (controller._pullAgain) {
                                controller._pullAgain = false;
                                ReadableByteStreamControllerCallPullIfNeeded(controller);
                            }
                        }, function(e) {
                            ReadableByteStreamControllerError(controller, e);
                        });
                    }
                    function ReadableByteStreamControllerClearPendingPullIntos(controller) {
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        controller._pendingPullIntos = new SimpleQueue();
                    }
                    function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
                        var done = false;
                        if (stream._state === 'closed') done = true;
                        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
                        if (pullIntoDescriptor.readerType === 'default') ReadableStreamFulfillReadRequest(stream, filledView, done);
                        else ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
                    }
                    function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
                        var bytesFilled = pullIntoDescriptor.bytesFilled;
                        var elementSize = pullIntoDescriptor.elementSize;
                        return new pullIntoDescriptor.viewConstructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
                    }
                    function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
                        controller._queue.push({
                            buffer: buffer,
                            byteOffset: byteOffset,
                            byteLength: byteLength
                        });
                        controller._queueTotalSize += byteLength;
                    }
                    function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
                        var elementSize = pullIntoDescriptor.elementSize;
                        var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
                        var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
                        var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
                        var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
                        var totalBytesToCopyRemaining = maxBytesToCopy;
                        var ready = false;
                        if (maxAlignedBytes > currentAlignedBytes) {
                            totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
                            ready = true;
                        }
                        var queue = controller._queue;
                        while(totalBytesToCopyRemaining > 0){
                            var headOfQueue = queue.peek();
                            var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
                            var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                            CopyDataBlockBytes(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
                            if (headOfQueue.byteLength === bytesToCopy) queue.shift();
                            else {
                                headOfQueue.byteOffset += bytesToCopy;
                                headOfQueue.byteLength -= bytesToCopy;
                            }
                            controller._queueTotalSize -= bytesToCopy;
                            ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
                            totalBytesToCopyRemaining -= bytesToCopy;
                        }
                        return ready;
                    }
                    function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
                        pullIntoDescriptor.bytesFilled += size;
                    }
                    function ReadableByteStreamControllerHandleQueueDrain(controller) {
                        if (controller._queueTotalSize === 0 && controller._closeRequested) {
                            ReadableByteStreamControllerClearAlgorithms(controller);
                            ReadableStreamClose(controller._controlledReadableByteStream);
                        } else ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
                        if (controller._byobRequest === null) return;
                        controller._byobRequest._associatedReadableByteStreamController = undefined;
                        controller._byobRequest._view = null;
                        controller._byobRequest = null;
                    }
                    function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
                        while(controller._pendingPullIntos.length > 0){
                            if (controller._queueTotalSize === 0) return;
                            var pullIntoDescriptor = controller._pendingPullIntos.peek();
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                                ReadableByteStreamControllerShiftPendingPullInto(controller);
                                ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
                            }
                        }
                    }
                    function ReadableByteStreamControllerPullInto(controller, view, readIntoRequest) {
                        var stream = controller._controlledReadableByteStream;
                        var elementSize = 1;
                        if (view.constructor !== DataView) elementSize = view.constructor.BYTES_PER_ELEMENT;
                        var ctor = view.constructor;
                        var buffer = TransferArrayBuffer(view.buffer);
                        var pullIntoDescriptor = {
                            buffer: buffer,
                            bufferByteLength: buffer.byteLength,
                            byteOffset: view.byteOffset,
                            byteLength: view.byteLength,
                            bytesFilled: 0,
                            elementSize: elementSize,
                            viewConstructor: ctor,
                            readerType: 'byob'
                        };
                        if (controller._pendingPullIntos.length > 0) {
                            controller._pendingPullIntos.push(pullIntoDescriptor);
                            ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
                            return;
                        }
                        if (stream._state === 'closed') {
                            var emptyView = new ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
                            readIntoRequest._closeSteps(emptyView);
                            return;
                        }
                        if (controller._queueTotalSize > 0) {
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor)) {
                                var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
                                ReadableByteStreamControllerHandleQueueDrain(controller);
                                readIntoRequest._chunkSteps(filledView);
                                return;
                            }
                            if (controller._closeRequested) {
                                var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
                                ReadableByteStreamControllerError(controller, e);
                                readIntoRequest._errorSteps(e);
                                return;
                            }
                        }
                        controller._pendingPullIntos.push(pullIntoDescriptor);
                        ReadableStreamAddReadIntoRequest(stream, readIntoRequest);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
                        var stream = controller._controlledReadableByteStream;
                        if (ReadableStreamHasBYOBReader(stream)) while(ReadableStreamGetNumReadIntoRequests(stream) > 0){
                            var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
                            ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
                        }
                    }
                    function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
                        ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
                        if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) return;
                        ReadableByteStreamControllerShiftPendingPullInto(controller);
                        var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
                        if (remainderSize > 0) {
                            var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
                            var remainder = ArrayBufferSlice(pullIntoDescriptor.buffer, end - remainderSize, end);
                            ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
                        }
                        pullIntoDescriptor.bytesFilled -= remainderSize;
                        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
                        ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
                    }
                    function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') ReadableByteStreamControllerRespondInClosedState(controller);
                        else ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerShiftPendingPullInto(controller) {
                        var descriptor = controller._pendingPullIntos.shift();
                        return descriptor;
                    }
                    function ReadableByteStreamControllerShouldCallPull(controller) {
                        var stream = controller._controlledReadableByteStream;
                        if (stream._state !== 'readable') return false;
                        if (controller._closeRequested) return false;
                        if (!controller._started) return false;
                        if (ReadableStreamHasDefaultReader(stream) && ReadableStreamGetNumReadRequests(stream) > 0) return true;
                        if (ReadableStreamHasBYOBReader(stream) && ReadableStreamGetNumReadIntoRequests(stream) > 0) return true;
                        var desiredSize = ReadableByteStreamControllerGetDesiredSize(controller);
                        if (desiredSize > 0) return true;
                        return false;
                    }
                    function ReadableByteStreamControllerClearAlgorithms(controller) {
                        controller._pullAlgorithm = undefined;
                        controller._cancelAlgorithm = undefined;
                    }
                    function ReadableByteStreamControllerClose(controller) {
                        var stream = controller._controlledReadableByteStream;
                        if (controller._closeRequested || stream._state !== 'readable') return;
                        if (controller._queueTotalSize > 0) {
                            controller._closeRequested = true;
                            return;
                        }
                        if (controller._pendingPullIntos.length > 0) {
                            var firstPendingPullInto = controller._pendingPullIntos.peek();
                            if (firstPendingPullInto.bytesFilled > 0) {
                                var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
                                ReadableByteStreamControllerError(controller, e);
                                throw e;
                            }
                        }
                        ReadableByteStreamControllerClearAlgorithms(controller);
                        ReadableStreamClose(stream);
                    }
                    function ReadableByteStreamControllerEnqueue(controller, chunk) {
                        var stream = controller._controlledReadableByteStream;
                        if (controller._closeRequested || stream._state !== 'readable') return;
                        var buffer = chunk.buffer;
                        var byteOffset = chunk.byteOffset;
                        var byteLength = chunk.byteLength;
                        var transferredBuffer = TransferArrayBuffer(buffer);
                        if (controller._pendingPullIntos.length > 0) {
                            var firstPendingPullInto = controller._pendingPullIntos.peek();
                            IsDetachedBuffer(firstPendingPullInto.buffer);
                            firstPendingPullInto.buffer = TransferArrayBuffer(firstPendingPullInto.buffer);
                        }
                        ReadableByteStreamControllerInvalidateBYOBRequest(controller);
                        if (ReadableStreamHasDefaultReader(stream)) {
                            if (ReadableStreamGetNumReadRequests(stream) === 0) ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                            else {
                                if (controller._pendingPullIntos.length > 0) ReadableByteStreamControllerShiftPendingPullInto(controller);
                                var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
                                ReadableStreamFulfillReadRequest(stream, transferredView, false);
                            }
                        } else if (ReadableStreamHasBYOBReader(stream)) {
                            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
                        } else ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
                        ReadableByteStreamControllerCallPullIfNeeded(controller);
                    }
                    function ReadableByteStreamControllerError(controller, e) {
                        var stream = controller._controlledReadableByteStream;
                        if (stream._state !== 'readable') return;
                        ReadableByteStreamControllerClearPendingPullIntos(controller);
                        ResetQueue(controller);
                        ReadableByteStreamControllerClearAlgorithms(controller);
                        ReadableStreamError(stream, e);
                    }
                    function ReadableByteStreamControllerGetBYOBRequest(controller) {
                        if (controller._byobRequest === null && controller._pendingPullIntos.length > 0) {
                            var firstDescriptor = controller._pendingPullIntos.peek();
                            var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
                            var byobRequest = Object.create(ReadableStreamBYOBRequest.prototype);
                            SetUpReadableStreamBYOBRequest(byobRequest, controller, view);
                            controller._byobRequest = byobRequest;
                        }
                        return controller._byobRequest;
                    }
                    function ReadableByteStreamControllerGetDesiredSize(controller) {
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'errored') return null;
                        if (state === 'closed') return 0;
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function ReadableByteStreamControllerRespond(controller, bytesWritten) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') {
                            if (bytesWritten !== 0) throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
                        } else {
                            if (bytesWritten === 0) throw new TypeError('bytesWritten must be greater than 0 when calling respond() on a readable stream');
                            if (firstDescriptor.bytesFilled + bytesWritten > firstDescriptor.byteLength) throw new RangeError('bytesWritten out of range');
                        }
                        firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
                        ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
                    }
                    function ReadableByteStreamControllerRespondWithNewView(controller, view) {
                        var firstDescriptor = controller._pendingPullIntos.peek();
                        var state = controller._controlledReadableByteStream._state;
                        if (state === 'closed') {
                            if (view.byteLength !== 0) throw new TypeError('The view\'s length must be 0 when calling respondWithNewView() on a closed stream');
                        } else {
                            if (view.byteLength === 0) throw new TypeError('The view\'s length must be greater than 0 when calling respondWithNewView() on a readable stream');
                        }
                        if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) throw new RangeError('The region specified by view does not match byobRequest');
                        if (firstDescriptor.bufferByteLength !== view.buffer.byteLength) throw new RangeError('The buffer of view has different capacity than byobRequest');
                        if (firstDescriptor.bytesFilled + view.byteLength > firstDescriptor.byteLength) throw new RangeError('The region specified by view is larger than byobRequest');
                        var viewByteLength = view.byteLength;
                        firstDescriptor.buffer = TransferArrayBuffer(view.buffer);
                        ReadableByteStreamControllerRespondInternal(controller, viewByteLength);
                    }
                    function SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize) {
                        controller._controlledReadableByteStream = stream;
                        controller._pullAgain = false;
                        controller._pulling = false;
                        controller._byobRequest = null;
                        controller._queue = controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._closeRequested = false;
                        controller._started = false;
                        controller._strategyHWM = highWaterMark;
                        controller._pullAlgorithm = pullAlgorithm;
                        controller._cancelAlgorithm = cancelAlgorithm;
                        controller._autoAllocateChunkSize = autoAllocateChunkSize;
                        controller._pendingPullIntos = new SimpleQueue();
                        stream._readableStreamController = controller;
                        var startResult = startAlgorithm();
                        uponPromise(promiseResolvedWith(startResult), function() {
                            controller._started = true;
                            ReadableByteStreamControllerCallPullIfNeeded(controller);
                        }, function(r) {
                            ReadableByteStreamControllerError(controller, r);
                        });
                    }
                    function SetUpReadableByteStreamControllerFromUnderlyingSource(stream, underlyingByteSource, highWaterMark) {
                        var controller = Object.create(ReadableByteStreamController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var pullAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var cancelAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingByteSource.start !== undefined) startAlgorithm = function() {
                            return underlyingByteSource.start(controller);
                        };
                        if (underlyingByteSource.pull !== undefined) pullAlgorithm = function() {
                            return underlyingByteSource.pull(controller);
                        };
                        if (underlyingByteSource.cancel !== undefined) cancelAlgorithm = function(reason) {
                            return underlyingByteSource.cancel(reason);
                        };
                        var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
                        if (autoAllocateChunkSize === 0) throw new TypeError('autoAllocateChunkSize must be greater than 0');
                        SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize);
                    }
                    function SetUpReadableStreamBYOBRequest(request, controller, view) {
                        request._associatedReadableByteStreamController = controller;
                        request._view = view;
                    }
                    function byobRequestBrandCheckException(name) {
                        return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
                    }
                    function byteStreamControllerBrandCheckException(name) {
                        return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
                    }
                    function AcquireReadableStreamBYOBReader(stream) {
                        return new ReadableStreamBYOBReader(stream);
                    }
                    function ReadableStreamAddReadIntoRequest(stream, readIntoRequest) {
                        stream._reader._readIntoRequests.push(readIntoRequest);
                    }
                    function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
                        var reader = stream._reader;
                        var readIntoRequest = reader._readIntoRequests.shift();
                        if (done) readIntoRequest._closeSteps(chunk);
                        else readIntoRequest._chunkSteps(chunk);
                    }
                    function ReadableStreamGetNumReadIntoRequests(stream) {
                        return stream._reader._readIntoRequests.length;
                    }
                    function ReadableStreamHasBYOBReader(stream) {
                        var reader = stream._reader;
                        if (reader === undefined) return false;
                        if (!IsReadableStreamBYOBReader(reader)) return false;
                        return true;
                    }
                    var ReadableStreamBYOBReader = function() {
                        function ReadableStreamBYOBReader(stream) {
                            assertRequiredArgument(stream, 1, 'ReadableStreamBYOBReader');
                            assertReadableStream(stream, 'First parameter');
                            if (IsReadableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                            if (!IsReadableByteStreamController(stream._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
                            ReadableStreamReaderGenericInitialize(this, stream);
                            this._readIntoRequests = new SimpleQueue();
                        }
                        Object.defineProperty(ReadableStreamBYOBReader.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBReader.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('cancel'));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('cancel'));
                            return ReadableStreamReaderGenericCancel(this, reason);
                        };
                        ReadableStreamBYOBReader.prototype.read = function(view) {
                            if (!IsReadableStreamBYOBReader(this)) return promiseRejectedWith(byobReaderBrandCheckException('read'));
                            if (!ArrayBuffer.isView(view)) return promiseRejectedWith(new TypeError('view must be an array buffer view'));
                            if (view.byteLength === 0) return promiseRejectedWith(new TypeError('view must have non-zero byteLength'));
                            if (view.buffer.byteLength === 0) return promiseRejectedWith(new TypeError("view's buffer must have non-zero byteLength"));
                            IsDetachedBuffer(view.buffer);
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith(readerLockException('read from'));
                            var resolvePromise;
                            var rejectPromise;
                            var promise = newPromise(function(resolve, reject) {
                                resolvePromise = resolve;
                                rejectPromise = reject;
                            });
                            var readIntoRequest = {
                                _chunkSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: false
                                    });
                                },
                                _closeSteps: function(chunk) {
                                    return resolvePromise({
                                        value: chunk,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e) {
                                    return rejectPromise(e);
                                }
                            };
                            ReadableStreamBYOBReaderRead(this, view, readIntoRequest);
                            return promise;
                        };
                        ReadableStreamBYOBReader.prototype.releaseLock = function() {
                            if (!IsReadableStreamBYOBReader(this)) throw byobReaderBrandCheckException('releaseLock');
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readIntoRequests.length > 0) throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
                            ReadableStreamReaderGenericRelease(this);
                        };
                        return ReadableStreamBYOBReader;
                    }();
                    Object.defineProperties(ReadableStreamBYOBReader.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamBYOBReader.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamBYOBReader',
                        configurable: true
                    });
                    function IsReadableStreamBYOBReader(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) return false;
                        return x instanceof ReadableStreamBYOBReader;
                    }
                    function ReadableStreamBYOBReaderRead(reader, view, readIntoRequest) {
                        var stream = reader._ownerReadableStream;
                        stream._disturbed = true;
                        if (stream._state === 'errored') readIntoRequest._errorSteps(stream._storedError);
                        else ReadableByteStreamControllerPullInto(stream._readableStreamController, view, readIntoRequest);
                    }
                    function byobReaderBrandCheckException(name) {
                        return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
                    }
                    function ExtractHighWaterMark(strategy, defaultHWM) {
                        var highWaterMark = strategy.highWaterMark;
                        if (highWaterMark === undefined) return defaultHWM;
                        if (NumberIsNaN(highWaterMark) || highWaterMark < 0) throw new RangeError('Invalid highWaterMark');
                        return highWaterMark;
                    }
                    function ExtractSizeAlgorithm(strategy) {
                        var size = strategy.size;
                        if (!size) return function() {
                            return 1;
                        };
                        return size;
                    }
                    function convertQueuingStrategy(init, context) {
                        assertDictionary(init, context);
                        var highWaterMark = init === null || init === void 0 ? void 0 : init.highWaterMark;
                        var size = init === null || init === void 0 ? void 0 : init.size;
                        return {
                            highWaterMark: highWaterMark === undefined ? undefined : convertUnrestrictedDouble(highWaterMark),
                            size: size === undefined ? undefined : convertQueuingStrategySize(size, context + " has member 'size' that")
                        };
                    }
                    function convertQueuingStrategySize(fn, context) {
                        assertFunction(fn, context);
                        return function(chunk) {
                            return convertUnrestrictedDouble(fn(chunk));
                        };
                    }
                    function convertUnderlyingSink(original, context) {
                        assertDictionary(original, context);
                        var abort = original === null || original === void 0 ? void 0 : original.abort;
                        var close = original === null || original === void 0 ? void 0 : original.close;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var type = original === null || original === void 0 ? void 0 : original.type;
                        var write = original === null || original === void 0 ? void 0 : original.write;
                        return {
                            abort: abort === undefined ? undefined : convertUnderlyingSinkAbortCallback(abort, original, context + " has member 'abort' that"),
                            close: close === undefined ? undefined : convertUnderlyingSinkCloseCallback(close, original, context + " has member 'close' that"),
                            start: start === undefined ? undefined : convertUnderlyingSinkStartCallback(start, original, context + " has member 'start' that"),
                            write: write === undefined ? undefined : convertUnderlyingSinkWriteCallback(write, original, context + " has member 'write' that"),
                            type: type
                        };
                    }
                    function convertUnderlyingSinkAbortCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(reason) {
                            return promiseCall(fn, original, [
                                reason
                            ]);
                        };
                    }
                    function convertUnderlyingSinkCloseCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function() {
                            return promiseCall(fn, original, []);
                        };
                    }
                    function convertUnderlyingSinkStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertUnderlyingSinkWriteCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(chunk, controller) {
                            return promiseCall(fn, original, [
                                chunk,
                                controller
                            ]);
                        };
                    }
                    function assertWritableStream(x, context) {
                        if (!IsWritableStream(x)) throw new TypeError(context + " is not a WritableStream.");
                    }
                    function isAbortSignal(value) {
                        if (typeof value !== 'object' || value === null) return false;
                        try {
                            return typeof value.aborted === 'boolean';
                        } catch (_a) {
                            return false;
                        }
                    }
                    var supportsAbortController = typeof AbortController === 'function';
                    function createAbortController() {
                        if (supportsAbortController) return new AbortController();
                        return undefined;
                    }
                    var WritableStream = function() {
                        function WritableStream(rawUnderlyingSink, rawStrategy) {
                            if (rawUnderlyingSink === void 0) rawUnderlyingSink = {};
                            if (rawStrategy === void 0) rawStrategy = {};
                            if (rawUnderlyingSink === undefined) rawUnderlyingSink = null;
                            else assertObject(rawUnderlyingSink, 'First parameter');
                            var strategy = convertQueuingStrategy(rawStrategy, 'Second parameter');
                            var underlyingSink = convertUnderlyingSink(rawUnderlyingSink, 'First parameter');
                            InitializeWritableStream(this);
                            var type = underlyingSink.type;
                            if (type !== undefined) throw new RangeError('Invalid type is specified');
                            var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                            var highWaterMark = ExtractHighWaterMark(strategy, 1);
                            SetUpWritableStreamDefaultControllerFromUnderlyingSink(this, underlyingSink, highWaterMark, sizeAlgorithm);
                        }
                        Object.defineProperty(WritableStream.prototype, "locked", {
                            get: function() {
                                if (!IsWritableStream(this)) throw streamBrandCheckException$2('locked');
                                return IsWritableStreamLocked(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStream.prototype.abort = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsWritableStream(this)) return promiseRejectedWith(streamBrandCheckException$2('abort'));
                            if (IsWritableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot abort a stream that already has a writer'));
                            return WritableStreamAbort(this, reason);
                        };
                        WritableStream.prototype.close = function() {
                            if (!IsWritableStream(this)) return promiseRejectedWith(streamBrandCheckException$2('close'));
                            if (IsWritableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot close a stream that already has a writer'));
                            if (WritableStreamCloseQueuedOrInFlight(this)) return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
                            return WritableStreamClose(this);
                        };
                        WritableStream.prototype.getWriter = function() {
                            if (!IsWritableStream(this)) throw streamBrandCheckException$2('getWriter');
                            return AcquireWritableStreamDefaultWriter(this);
                        };
                        return WritableStream;
                    }();
                    Object.defineProperties(WritableStream.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        getWriter: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStream.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStream',
                        configurable: true
                    });
                    function AcquireWritableStreamDefaultWriter(stream) {
                        return new WritableStreamDefaultWriter(stream);
                    }
                    function CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
                        if (highWaterMark === void 0) highWaterMark = 1;
                        if (sizeAlgorithm === void 0) sizeAlgorithm = function() {
                            return 1;
                        };
                        var stream = Object.create(WritableStream.prototype);
                        InitializeWritableStream(stream);
                        var controller = Object.create(WritableStreamDefaultController.prototype);
                        SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
                        return stream;
                    }
                    function InitializeWritableStream(stream) {
                        stream._state = 'writable';
                        stream._storedError = undefined;
                        stream._writer = undefined;
                        stream._writableStreamController = undefined;
                        stream._writeRequests = new SimpleQueue();
                        stream._inFlightWriteRequest = undefined;
                        stream._closeRequest = undefined;
                        stream._inFlightCloseRequest = undefined;
                        stream._pendingAbortRequest = undefined;
                        stream._backpressure = false;
                    }
                    function IsWritableStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) return false;
                        return x instanceof WritableStream;
                    }
                    function IsWritableStreamLocked(stream) {
                        if (stream._writer === undefined) return false;
                        return true;
                    }
                    function WritableStreamAbort(stream, reason) {
                        var _a;
                        if (stream._state === 'closed' || stream._state === 'errored') return promiseResolvedWith(undefined);
                        stream._writableStreamController._abortReason = reason;
                        (_a = stream._writableStreamController._abortController) === null || _a === void 0 || _a.abort();
                        var state = stream._state;
                        if (state === 'closed' || state === 'errored') return promiseResolvedWith(undefined);
                        if (stream._pendingAbortRequest !== undefined) return stream._pendingAbortRequest._promise;
                        var wasAlreadyErroring = false;
                        if (state === 'erroring') {
                            wasAlreadyErroring = true;
                            reason = undefined;
                        }
                        var promise = newPromise(function(resolve, reject) {
                            stream._pendingAbortRequest = {
                                _promise: undefined,
                                _resolve: resolve,
                                _reject: reject,
                                _reason: reason,
                                _wasAlreadyErroring: wasAlreadyErroring
                            };
                        });
                        stream._pendingAbortRequest._promise = promise;
                        if (!wasAlreadyErroring) WritableStreamStartErroring(stream, reason);
                        return promise;
                    }
                    function WritableStreamClose(stream) {
                        var state = stream._state;
                        if (state === 'closed' || state === 'errored') return promiseRejectedWith(new TypeError("The stream (in " + state + " state) is not in the writable state and cannot be closed"));
                        var promise = newPromise(function(resolve, reject) {
                            var closeRequest = {
                                _resolve: resolve,
                                _reject: reject
                            };
                            stream._closeRequest = closeRequest;
                        });
                        var writer = stream._writer;
                        if (writer !== undefined && stream._backpressure && state === 'writable') defaultWriterReadyPromiseResolve(writer);
                        WritableStreamDefaultControllerClose(stream._writableStreamController);
                        return promise;
                    }
                    function WritableStreamAddWriteRequest(stream) {
                        var promise = newPromise(function(resolve, reject) {
                            var writeRequest = {
                                _resolve: resolve,
                                _reject: reject
                            };
                            stream._writeRequests.push(writeRequest);
                        });
                        return promise;
                    }
                    function WritableStreamDealWithRejection(stream, error) {
                        var state = stream._state;
                        if (state === 'writable') {
                            WritableStreamStartErroring(stream, error);
                            return;
                        }
                        WritableStreamFinishErroring(stream);
                    }
                    function WritableStreamStartErroring(stream, reason) {
                        var controller = stream._writableStreamController;
                        stream._state = 'erroring';
                        stream._storedError = reason;
                        var writer = stream._writer;
                        if (writer !== undefined) WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
                        if (!WritableStreamHasOperationMarkedInFlight(stream) && controller._started) WritableStreamFinishErroring(stream);
                    }
                    function WritableStreamFinishErroring(stream) {
                        stream._state = 'errored';
                        stream._writableStreamController[ErrorSteps]();
                        var storedError = stream._storedError;
                        stream._writeRequests.forEach(function(writeRequest) {
                            writeRequest._reject(storedError);
                        });
                        stream._writeRequests = new SimpleQueue();
                        if (stream._pendingAbortRequest === undefined) {
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                            return;
                        }
                        var abortRequest = stream._pendingAbortRequest;
                        stream._pendingAbortRequest = undefined;
                        if (abortRequest._wasAlreadyErroring) {
                            abortRequest._reject(storedError);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                            return;
                        }
                        var promise = stream._writableStreamController[AbortSteps](abortRequest._reason);
                        uponPromise(promise, function() {
                            abortRequest._resolve();
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                        }, function(reason) {
                            abortRequest._reject(reason);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
                        });
                    }
                    function WritableStreamFinishInFlightWrite(stream) {
                        stream._inFlightWriteRequest._resolve(undefined);
                        stream._inFlightWriteRequest = undefined;
                    }
                    function WritableStreamFinishInFlightWriteWithError(stream, error) {
                        stream._inFlightWriteRequest._reject(error);
                        stream._inFlightWriteRequest = undefined;
                        WritableStreamDealWithRejection(stream, error);
                    }
                    function WritableStreamFinishInFlightClose(stream) {
                        stream._inFlightCloseRequest._resolve(undefined);
                        stream._inFlightCloseRequest = undefined;
                        var state = stream._state;
                        if (state === 'erroring') {
                            stream._storedError = undefined;
                            if (stream._pendingAbortRequest !== undefined) {
                                stream._pendingAbortRequest._resolve();
                                stream._pendingAbortRequest = undefined;
                            }
                        }
                        stream._state = 'closed';
                        var writer = stream._writer;
                        if (writer !== undefined) defaultWriterClosedPromiseResolve(writer);
                    }
                    function WritableStreamFinishInFlightCloseWithError(stream, error) {
                        stream._inFlightCloseRequest._reject(error);
                        stream._inFlightCloseRequest = undefined;
                        if (stream._pendingAbortRequest !== undefined) {
                            stream._pendingAbortRequest._reject(error);
                            stream._pendingAbortRequest = undefined;
                        }
                        WritableStreamDealWithRejection(stream, error);
                    }
                    function WritableStreamCloseQueuedOrInFlight(stream) {
                        if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamHasOperationMarkedInFlight(stream) {
                        if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamMarkCloseRequestInFlight(stream) {
                        stream._inFlightCloseRequest = stream._closeRequest;
                        stream._closeRequest = undefined;
                    }
                    function WritableStreamMarkFirstWriteRequestInFlight(stream) {
                        stream._inFlightWriteRequest = stream._writeRequests.shift();
                    }
                    function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
                        if (stream._closeRequest !== undefined) {
                            stream._closeRequest._reject(stream._storedError);
                            stream._closeRequest = undefined;
                        }
                        var writer = stream._writer;
                        if (writer !== undefined) defaultWriterClosedPromiseReject(writer, stream._storedError);
                    }
                    function WritableStreamUpdateBackpressure(stream, backpressure) {
                        var writer = stream._writer;
                        if (writer !== undefined && backpressure !== stream._backpressure) {
                            if (backpressure) defaultWriterReadyPromiseReset(writer);
                            else defaultWriterReadyPromiseResolve(writer);
                        }
                        stream._backpressure = backpressure;
                    }
                    var WritableStreamDefaultWriter = function() {
                        function WritableStreamDefaultWriter(stream) {
                            assertRequiredArgument(stream, 1, 'WritableStreamDefaultWriter');
                            assertWritableStream(stream, 'First parameter');
                            if (IsWritableStreamLocked(stream)) throw new TypeError('This stream has already been locked for exclusive writing by another writer');
                            this._ownerWritableStream = stream;
                            stream._writer = this;
                            var state = stream._state;
                            if (state === 'writable') {
                                if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._backpressure) defaultWriterReadyPromiseInitialize(this);
                                else defaultWriterReadyPromiseInitializeAsResolved(this);
                                defaultWriterClosedPromiseInitialize(this);
                            } else if (state === 'erroring') {
                                defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
                                defaultWriterClosedPromiseInitialize(this);
                            } else if (state === 'closed') {
                                defaultWriterReadyPromiseInitializeAsResolved(this);
                                defaultWriterClosedPromiseInitializeAsResolved(this);
                            } else {
                                var storedError = stream._storedError;
                                defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
                                defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
                            }
                        }
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "closed", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('closed'));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "desiredSize", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) throw defaultWriterBrandCheckException('desiredSize');
                                if (this._ownerWritableStream === undefined) throw defaultWriterLockException('desiredSize');
                                return WritableStreamDefaultWriterGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter.prototype, "ready", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('ready'));
                                return this._readyPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultWriter.prototype.abort = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('abort'));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith(defaultWriterLockException('abort'));
                            return WritableStreamDefaultWriterAbort(this, reason);
                        };
                        WritableStreamDefaultWriter.prototype.close = function() {
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('close'));
                            var stream = this._ownerWritableStream;
                            if (stream === undefined) return promiseRejectedWith(defaultWriterLockException('close'));
                            if (WritableStreamCloseQueuedOrInFlight(stream)) return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
                            return WritableStreamDefaultWriterClose(this);
                        };
                        WritableStreamDefaultWriter.prototype.releaseLock = function() {
                            if (!IsWritableStreamDefaultWriter(this)) throw defaultWriterBrandCheckException('releaseLock');
                            var stream = this._ownerWritableStream;
                            if (stream === undefined) return;
                            WritableStreamDefaultWriterRelease(this);
                        };
                        WritableStreamDefaultWriter.prototype.write = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsWritableStreamDefaultWriter(this)) return promiseRejectedWith(defaultWriterBrandCheckException('write'));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith(defaultWriterLockException('write to'));
                            return WritableStreamDefaultWriterWrite(this, chunk);
                        };
                        return WritableStreamDefaultWriter;
                    }();
                    Object.defineProperties(WritableStreamDefaultWriter.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        write: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        },
                        ready: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStreamDefaultWriter.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStreamDefaultWriter',
                        configurable: true
                    });
                    function IsWritableStreamDefaultWriter(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) return false;
                        return x instanceof WritableStreamDefaultWriter;
                    }
                    function WritableStreamDefaultWriterAbort(writer, reason) {
                        var stream = writer._ownerWritableStream;
                        return WritableStreamAbort(stream, reason);
                    }
                    function WritableStreamDefaultWriterClose(writer) {
                        var stream = writer._ownerWritableStream;
                        return WritableStreamClose(stream);
                    }
                    function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
                        var stream = writer._ownerWritableStream;
                        var state = stream._state;
                        if (WritableStreamCloseQueuedOrInFlight(stream) || state === 'closed') return promiseResolvedWith(undefined);
                        if (state === 'errored') return promiseRejectedWith(stream._storedError);
                        return WritableStreamDefaultWriterClose(writer);
                    }
                    function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
                        if (writer._closedPromiseState === 'pending') defaultWriterClosedPromiseReject(writer, error);
                        else defaultWriterClosedPromiseResetToRejected(writer, error);
                    }
                    function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
                        if (writer._readyPromiseState === 'pending') defaultWriterReadyPromiseReject(writer, error);
                        else defaultWriterReadyPromiseResetToRejected(writer, error);
                    }
                    function WritableStreamDefaultWriterGetDesiredSize(writer) {
                        var stream = writer._ownerWritableStream;
                        var state = stream._state;
                        if (state === 'errored' || state === 'erroring') return null;
                        if (state === 'closed') return 0;
                        return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
                    }
                    function WritableStreamDefaultWriterRelease(writer) {
                        var stream = writer._ownerWritableStream;
                        var releasedError = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
                        WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
                        WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
                        stream._writer = undefined;
                        writer._ownerWritableStream = undefined;
                    }
                    function WritableStreamDefaultWriterWrite(writer, chunk) {
                        var stream = writer._ownerWritableStream;
                        var controller = stream._writableStreamController;
                        var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
                        if (stream !== writer._ownerWritableStream) return promiseRejectedWith(defaultWriterLockException('write to'));
                        var state = stream._state;
                        if (state === 'errored') return promiseRejectedWith(stream._storedError);
                        if (WritableStreamCloseQueuedOrInFlight(stream) || state === 'closed') return promiseRejectedWith(new TypeError('The stream is closing or closed and cannot be written to'));
                        if (state === 'erroring') return promiseRejectedWith(stream._storedError);
                        var promise = WritableStreamAddWriteRequest(stream);
                        WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
                        return promise;
                    }
                    var closeSentinel = {};
                    var WritableStreamDefaultController = function() {
                        function WritableStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(WritableStreamDefaultController.prototype, "abortReason", {
                            get: function() {
                                if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('abortReason');
                                return this._abortReason;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultController.prototype, "signal", {
                            get: function() {
                                if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('signal');
                                if (this._abortController === undefined) throw new TypeError('WritableStreamDefaultController.prototype.signal is not supported');
                                return this._abortController.signal;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsWritableStreamDefaultController(this)) throw defaultControllerBrandCheckException$2('error');
                            var state = this._controlledWritableStream._state;
                            if (state !== 'writable') return;
                            WritableStreamDefaultControllerError(this, e);
                        };
                        WritableStreamDefaultController.prototype[AbortSteps] = function(reason) {
                            var result = this._abortAlgorithm(reason);
                            WritableStreamDefaultControllerClearAlgorithms(this);
                            return result;
                        };
                        WritableStreamDefaultController.prototype[ErrorSteps] = function() {
                            ResetQueue(this);
                        };
                        return WritableStreamDefaultController;
                    }();
                    Object.defineProperties(WritableStreamDefaultController.prototype, {
                        abortReason: {
                            enumerable: true
                        },
                        signal: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(WritableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'WritableStreamDefaultController',
                        configurable: true
                    });
                    function IsWritableStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledWritableStream')) return false;
                        return x instanceof WritableStreamDefaultController;
                    }
                    function SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
                        controller._controlledWritableStream = stream;
                        stream._writableStreamController = controller;
                        controller._queue = undefined;
                        controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._abortReason = undefined;
                        controller._abortController = createAbortController();
                        controller._started = false;
                        controller._strategySizeAlgorithm = sizeAlgorithm;
                        controller._strategyHWM = highWaterMark;
                        controller._writeAlgorithm = writeAlgorithm;
                        controller._closeAlgorithm = closeAlgorithm;
                        controller._abortAlgorithm = abortAlgorithm;
                        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                        WritableStreamUpdateBackpressure(stream, backpressure);
                        var startResult = startAlgorithm();
                        var startPromise = promiseResolvedWith(startResult);
                        uponPromise(startPromise, function() {
                            controller._started = true;
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                        }, function(r) {
                            controller._started = true;
                            WritableStreamDealWithRejection(stream, r);
                        });
                    }
                    function SetUpWritableStreamDefaultControllerFromUnderlyingSink(stream, underlyingSink, highWaterMark, sizeAlgorithm) {
                        var controller = Object.create(WritableStreamDefaultController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var writeAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var closeAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var abortAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingSink.start !== undefined) startAlgorithm = function() {
                            return underlyingSink.start(controller);
                        };
                        if (underlyingSink.write !== undefined) writeAlgorithm = function(chunk) {
                            return underlyingSink.write(chunk, controller);
                        };
                        if (underlyingSink.close !== undefined) closeAlgorithm = function() {
                            return underlyingSink.close();
                        };
                        if (underlyingSink.abort !== undefined) abortAlgorithm = function(reason) {
                            return underlyingSink.abort(reason);
                        };
                        SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
                    }
                    function WritableStreamDefaultControllerClearAlgorithms(controller) {
                        controller._writeAlgorithm = undefined;
                        controller._closeAlgorithm = undefined;
                        controller._abortAlgorithm = undefined;
                        controller._strategySizeAlgorithm = undefined;
                    }
                    function WritableStreamDefaultControllerClose(controller) {
                        EnqueueValueWithSize(controller, closeSentinel, 0);
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                    }
                    function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
                        try {
                            return controller._strategySizeAlgorithm(chunk);
                        } catch (chunkSizeE) {
                            WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
                            return 1;
                        }
                    }
                    function WritableStreamDefaultControllerGetDesiredSize(controller) {
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
                        try {
                            EnqueueValueWithSize(controller, chunk, chunkSize);
                        } catch (enqueueE) {
                            WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
                            return;
                        }
                        var stream = controller._controlledWritableStream;
                        if (!WritableStreamCloseQueuedOrInFlight(stream) && stream._state === 'writable') {
                            var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                            WritableStreamUpdateBackpressure(stream, backpressure);
                        }
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                    }
                    function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
                        var stream = controller._controlledWritableStream;
                        if (!controller._started) return;
                        if (stream._inFlightWriteRequest !== undefined) return;
                        var state = stream._state;
                        if (state === 'erroring') {
                            WritableStreamFinishErroring(stream);
                            return;
                        }
                        if (controller._queue.length === 0) return;
                        var value = PeekQueueValue(controller);
                        if (value === closeSentinel) WritableStreamDefaultControllerProcessClose(controller);
                        else WritableStreamDefaultControllerProcessWrite(controller, value);
                    }
                    function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
                        if (controller._controlledWritableStream._state === 'writable') WritableStreamDefaultControllerError(controller, error);
                    }
                    function WritableStreamDefaultControllerProcessClose(controller) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamMarkCloseRequestInFlight(stream);
                        DequeueValue(controller);
                        var sinkClosePromise = controller._closeAlgorithm();
                        WritableStreamDefaultControllerClearAlgorithms(controller);
                        uponPromise(sinkClosePromise, function() {
                            WritableStreamFinishInFlightClose(stream);
                        }, function(reason) {
                            WritableStreamFinishInFlightCloseWithError(stream, reason);
                        });
                    }
                    function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamMarkFirstWriteRequestInFlight(stream);
                        var sinkWritePromise = controller._writeAlgorithm(chunk);
                        uponPromise(sinkWritePromise, function() {
                            WritableStreamFinishInFlightWrite(stream);
                            var state = stream._state;
                            DequeueValue(controller);
                            if (!WritableStreamCloseQueuedOrInFlight(stream) && state === 'writable') {
                                var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
                                WritableStreamUpdateBackpressure(stream, backpressure);
                            }
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
                        }, function(reason) {
                            if (stream._state === 'writable') WritableStreamDefaultControllerClearAlgorithms(controller);
                            WritableStreamFinishInFlightWriteWithError(stream, reason);
                        });
                    }
                    function WritableStreamDefaultControllerGetBackpressure(controller) {
                        var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
                        return desiredSize <= 0;
                    }
                    function WritableStreamDefaultControllerError(controller, error) {
                        var stream = controller._controlledWritableStream;
                        WritableStreamDefaultControllerClearAlgorithms(controller);
                        WritableStreamStartErroring(stream, error);
                    }
                    function streamBrandCheckException$2(name) {
                        return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
                    }
                    function defaultControllerBrandCheckException$2(name) {
                        return new TypeError("WritableStreamDefaultController.prototype." + name + " can only be used on a WritableStreamDefaultController");
                    }
                    function defaultWriterBrandCheckException(name) {
                        return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
                    }
                    function defaultWriterLockException(name) {
                        return new TypeError('Cannot ' + name + ' a stream using a released writer');
                    }
                    function defaultWriterClosedPromiseInitialize(writer) {
                        writer._closedPromise = newPromise(function(resolve, reject) {
                            writer._closedPromise_resolve = resolve;
                            writer._closedPromise_reject = reject;
                            writer._closedPromiseState = 'pending';
                        });
                    }
                    function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
                        defaultWriterClosedPromiseInitialize(writer);
                        defaultWriterClosedPromiseReject(writer, reason);
                    }
                    function defaultWriterClosedPromiseInitializeAsResolved(writer) {
                        defaultWriterClosedPromiseInitialize(writer);
                        defaultWriterClosedPromiseResolve(writer);
                    }
                    function defaultWriterClosedPromiseReject(writer, reason) {
                        if (writer._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(writer._closedPromise);
                        writer._closedPromise_reject(reason);
                        writer._closedPromise_resolve = undefined;
                        writer._closedPromise_reject = undefined;
                        writer._closedPromiseState = 'rejected';
                    }
                    function defaultWriterClosedPromiseResetToRejected(writer, reason) {
                        defaultWriterClosedPromiseInitializeAsRejected(writer, reason);
                    }
                    function defaultWriterClosedPromiseResolve(writer) {
                        if (writer._closedPromise_resolve === undefined) return;
                        writer._closedPromise_resolve(undefined);
                        writer._closedPromise_resolve = undefined;
                        writer._closedPromise_reject = undefined;
                        writer._closedPromiseState = 'resolved';
                    }
                    function defaultWriterReadyPromiseInitialize(writer) {
                        writer._readyPromise = newPromise(function(resolve, reject) {
                            writer._readyPromise_resolve = resolve;
                            writer._readyPromise_reject = reject;
                        });
                        writer._readyPromiseState = 'pending';
                    }
                    function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
                        defaultWriterReadyPromiseInitialize(writer);
                        defaultWriterReadyPromiseReject(writer, reason);
                    }
                    function defaultWriterReadyPromiseInitializeAsResolved(writer) {
                        defaultWriterReadyPromiseInitialize(writer);
                        defaultWriterReadyPromiseResolve(writer);
                    }
                    function defaultWriterReadyPromiseReject(writer, reason) {
                        if (writer._readyPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue(writer._readyPromise);
                        writer._readyPromise_reject(reason);
                        writer._readyPromise_resolve = undefined;
                        writer._readyPromise_reject = undefined;
                        writer._readyPromiseState = 'rejected';
                    }
                    function defaultWriterReadyPromiseReset(writer) {
                        defaultWriterReadyPromiseInitialize(writer);
                    }
                    function defaultWriterReadyPromiseResetToRejected(writer, reason) {
                        defaultWriterReadyPromiseInitializeAsRejected(writer, reason);
                    }
                    function defaultWriterReadyPromiseResolve(writer) {
                        if (writer._readyPromise_resolve === undefined) return;
                        writer._readyPromise_resolve(undefined);
                        writer._readyPromise_resolve = undefined;
                        writer._readyPromise_reject = undefined;
                        writer._readyPromiseState = 'fulfilled';
                    }
                    var NativeDOMException = typeof DOMException !== 'undefined' ? DOMException : undefined;
                    function isDOMExceptionConstructor(ctor) {
                        if (!(typeof ctor === 'function' || typeof ctor === 'object')) return false;
                        try {
                            new ctor();
                            return true;
                        } catch (_a) {
                            return false;
                        }
                    }
                    function createDOMExceptionPolyfill() {
                        var ctor = function DOMException1(message, name) {
                            this.message = message || '';
                            this.name = name || 'Error';
                            if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        };
                        ctor.prototype = Object.create(Error.prototype);
                        Object.defineProperty(ctor.prototype, 'constructor', {
                            value: ctor,
                            writable: true,
                            configurable: true
                        });
                        return ctor;
                    }
                    var DOMException$1 = isDOMExceptionConstructor(NativeDOMException) ? NativeDOMException : createDOMExceptionPolyfill();
                    function ReadableStreamPipeTo(source, dest, preventClose, preventAbort, preventCancel, signal) {
                        var reader = AcquireReadableStreamDefaultReader(source);
                        var writer = AcquireWritableStreamDefaultWriter(dest);
                        source._disturbed = true;
                        var shuttingDown = false;
                        var currentWrite = promiseResolvedWith(undefined);
                        return newPromise(function(resolve, reject) {
                            var abortAlgorithm;
                            if (signal !== undefined) {
                                abortAlgorithm = function() {
                                    var error = new DOMException$1('Aborted', 'AbortError');
                                    var actions = [];
                                    if (!preventAbort) actions.push(function() {
                                        if (dest._state === 'writable') return WritableStreamAbort(dest, error);
                                        return promiseResolvedWith(undefined);
                                    });
                                    if (!preventCancel) actions.push(function() {
                                        if (source._state === 'readable') return ReadableStreamCancel(source, error);
                                        return promiseResolvedWith(undefined);
                                    });
                                    shutdownWithAction(function() {
                                        return Promise.all(actions.map(function(action) {
                                            return action();
                                        }));
                                    }, true, error);
                                };
                                if (signal.aborted) {
                                    abortAlgorithm();
                                    return;
                                }
                                signal.addEventListener('abort', abortAlgorithm);
                            }
                            function pipeLoop() {
                                return newPromise(function(resolveLoop, rejectLoop) {
                                    function next(done) {
                                        if (done) resolveLoop();
                                        else PerformPromiseThen(pipeStep(), next, rejectLoop);
                                    }
                                    next(false);
                                });
                            }
                            function pipeStep() {
                                if (shuttingDown) return promiseResolvedWith(true);
                                return PerformPromiseThen(writer._readyPromise, function() {
                                    return newPromise(function(resolveRead, rejectRead) {
                                        ReadableStreamDefaultReaderRead(reader, {
                                            _chunkSteps: function(chunk) {
                                                currentWrite = PerformPromiseThen(WritableStreamDefaultWriterWrite(writer, chunk), undefined, noop);
                                                resolveRead(false);
                                            },
                                            _closeSteps: function() {
                                                return resolveRead(true);
                                            },
                                            _errorSteps: rejectRead
                                        });
                                    });
                                });
                            }
                            isOrBecomesErrored(source, reader._closedPromise, function(storedError) {
                                if (!preventAbort) shutdownWithAction(function() {
                                    return WritableStreamAbort(dest, storedError);
                                }, true, storedError);
                                else shutdown(true, storedError);
                            });
                            isOrBecomesErrored(dest, writer._closedPromise, function(storedError) {
                                if (!preventCancel) shutdownWithAction(function() {
                                    return ReadableStreamCancel(source, storedError);
                                }, true, storedError);
                                else shutdown(true, storedError);
                            });
                            isOrBecomesClosed(source, reader._closedPromise, function() {
                                if (!preventClose) shutdownWithAction(function() {
                                    return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
                                });
                                else shutdown();
                            });
                            if (WritableStreamCloseQueuedOrInFlight(dest) || dest._state === 'closed') {
                                var destClosed_1 = new TypeError('the destination writable stream closed before all data could be piped to it');
                                if (!preventCancel) shutdownWithAction(function() {
                                    return ReadableStreamCancel(source, destClosed_1);
                                }, true, destClosed_1);
                                else shutdown(true, destClosed_1);
                            }
                            setPromiseIsHandledToTrue(pipeLoop());
                            function waitForWritesToFinish() {
                                var oldCurrentWrite = currentWrite;
                                return PerformPromiseThen(currentWrite, function() {
                                    return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
                                });
                            }
                            function isOrBecomesErrored(stream, promise, action) {
                                if (stream._state === 'errored') action(stream._storedError);
                                else uponRejection(promise, action);
                            }
                            function isOrBecomesClosed(stream, promise, action) {
                                if (stream._state === 'closed') action();
                                else uponFulfillment(promise, action);
                            }
                            function shutdownWithAction(action, originalIsError, originalError) {
                                if (shuttingDown) return;
                                shuttingDown = true;
                                if (dest._state === 'writable' && !WritableStreamCloseQueuedOrInFlight(dest)) uponFulfillment(waitForWritesToFinish(), doTheRest);
                                else doTheRest();
                                function doTheRest() {
                                    uponPromise(action(), function() {
                                        return finalize(originalIsError, originalError);
                                    }, function(newError) {
                                        return finalize(true, newError);
                                    });
                                }
                            }
                            function shutdown(isError, error) {
                                if (shuttingDown) return;
                                shuttingDown = true;
                                if (dest._state === 'writable' && !WritableStreamCloseQueuedOrInFlight(dest)) uponFulfillment(waitForWritesToFinish(), function() {
                                    return finalize(isError, error);
                                });
                                else finalize(isError, error);
                            }
                            function finalize(isError, error) {
                                WritableStreamDefaultWriterRelease(writer);
                                ReadableStreamReaderGenericRelease(reader);
                                if (signal !== undefined) signal.removeEventListener('abort', abortAlgorithm);
                                if (isError) reject(error);
                                else resolve(undefined);
                            }
                        });
                    }
                    var ReadableStreamDefaultController = function() {
                        function ReadableStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(ReadableStreamDefaultController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('desiredSize');
                                return ReadableStreamDefaultControllerGetDesiredSize(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultController.prototype.close = function() {
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('close');
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) throw new TypeError('The stream is not in a state that permits close');
                            ReadableStreamDefaultControllerClose(this);
                        };
                        ReadableStreamDefaultController.prototype.enqueue = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('enqueue');
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(this)) throw new TypeError('The stream is not in a state that permits enqueue');
                            return ReadableStreamDefaultControllerEnqueue(this, chunk);
                        };
                        ReadableStreamDefaultController.prototype.error = function(e) {
                            if (e === void 0) e = undefined;
                            if (!IsReadableStreamDefaultController(this)) throw defaultControllerBrandCheckException$1('error');
                            ReadableStreamDefaultControllerError(this, e);
                        };
                        ReadableStreamDefaultController.prototype[CancelSteps] = function(reason) {
                            ResetQueue(this);
                            var result = this._cancelAlgorithm(reason);
                            ReadableStreamDefaultControllerClearAlgorithms(this);
                            return result;
                        };
                        ReadableStreamDefaultController.prototype[PullSteps] = function(readRequest) {
                            var stream = this._controlledReadableStream;
                            if (this._queue.length > 0) {
                                var chunk = DequeueValue(this);
                                if (this._closeRequested && this._queue.length === 0) {
                                    ReadableStreamDefaultControllerClearAlgorithms(this);
                                    ReadableStreamClose(stream);
                                } else ReadableStreamDefaultControllerCallPullIfNeeded(this);
                                readRequest._chunkSteps(chunk);
                            } else {
                                ReadableStreamAddReadRequest(stream, readRequest);
                                ReadableStreamDefaultControllerCallPullIfNeeded(this);
                            }
                        };
                        return ReadableStreamDefaultController;
                    }();
                    Object.defineProperties(ReadableStreamDefaultController.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStreamDefaultController',
                        configurable: true
                    });
                    function IsReadableStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableStream')) return false;
                        return x instanceof ReadableStreamDefaultController;
                    }
                    function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
                        var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
                        if (!shouldPull) return;
                        if (controller._pulling) {
                            controller._pullAgain = true;
                            return;
                        }
                        controller._pulling = true;
                        var pullPromise = controller._pullAlgorithm();
                        uponPromise(pullPromise, function() {
                            controller._pulling = false;
                            if (controller._pullAgain) {
                                controller._pullAgain = false;
                                ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                            }
                        }, function(e) {
                            ReadableStreamDefaultControllerError(controller, e);
                        });
                    }
                    function ReadableStreamDefaultControllerShouldCallPull(controller) {
                        var stream = controller._controlledReadableStream;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return false;
                        if (!controller._started) return false;
                        if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) return true;
                        var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
                        if (desiredSize > 0) return true;
                        return false;
                    }
                    function ReadableStreamDefaultControllerClearAlgorithms(controller) {
                        controller._pullAlgorithm = undefined;
                        controller._cancelAlgorithm = undefined;
                        controller._strategySizeAlgorithm = undefined;
                    }
                    function ReadableStreamDefaultControllerClose(controller) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return;
                        var stream = controller._controlledReadableStream;
                        controller._closeRequested = true;
                        if (controller._queue.length === 0) {
                            ReadableStreamDefaultControllerClearAlgorithms(controller);
                            ReadableStreamClose(stream);
                        }
                    }
                    function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(controller)) return;
                        var stream = controller._controlledReadableStream;
                        if (IsReadableStreamLocked(stream) && ReadableStreamGetNumReadRequests(stream) > 0) ReadableStreamFulfillReadRequest(stream, chunk, false);
                        else {
                            var chunkSize = void 0;
                            try {
                                chunkSize = controller._strategySizeAlgorithm(chunk);
                            } catch (chunkSizeE) {
                                ReadableStreamDefaultControllerError(controller, chunkSizeE);
                                throw chunkSizeE;
                            }
                            try {
                                EnqueueValueWithSize(controller, chunk, chunkSize);
                            } catch (enqueueE) {
                                ReadableStreamDefaultControllerError(controller, enqueueE);
                                throw enqueueE;
                            }
                        }
                        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                    }
                    function ReadableStreamDefaultControllerError(controller, e) {
                        var stream = controller._controlledReadableStream;
                        if (stream._state !== 'readable') return;
                        ResetQueue(controller);
                        ReadableStreamDefaultControllerClearAlgorithms(controller);
                        ReadableStreamError(stream, e);
                    }
                    function ReadableStreamDefaultControllerGetDesiredSize(controller) {
                        var state = controller._controlledReadableStream._state;
                        if (state === 'errored') return null;
                        if (state === 'closed') return 0;
                        return controller._strategyHWM - controller._queueTotalSize;
                    }
                    function ReadableStreamDefaultControllerHasBackpressure(controller) {
                        if (ReadableStreamDefaultControllerShouldCallPull(controller)) return false;
                        return true;
                    }
                    function ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) {
                        var state = controller._controlledReadableStream._state;
                        if (!controller._closeRequested && state === 'readable') return true;
                        return false;
                    }
                    function SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
                        controller._controlledReadableStream = stream;
                        controller._queue = undefined;
                        controller._queueTotalSize = undefined;
                        ResetQueue(controller);
                        controller._started = false;
                        controller._closeRequested = false;
                        controller._pullAgain = false;
                        controller._pulling = false;
                        controller._strategySizeAlgorithm = sizeAlgorithm;
                        controller._strategyHWM = highWaterMark;
                        controller._pullAlgorithm = pullAlgorithm;
                        controller._cancelAlgorithm = cancelAlgorithm;
                        stream._readableStreamController = controller;
                        var startResult = startAlgorithm();
                        uponPromise(promiseResolvedWith(startResult), function() {
                            controller._started = true;
                            ReadableStreamDefaultControllerCallPullIfNeeded(controller);
                        }, function(r) {
                            ReadableStreamDefaultControllerError(controller, r);
                        });
                    }
                    function SetUpReadableStreamDefaultControllerFromUnderlyingSource(stream, underlyingSource, highWaterMark, sizeAlgorithm) {
                        var controller = Object.create(ReadableStreamDefaultController.prototype);
                        var startAlgorithm = function() {
                            return undefined;
                        };
                        var pullAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        var cancelAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (underlyingSource.start !== undefined) startAlgorithm = function() {
                            return underlyingSource.start(controller);
                        };
                        if (underlyingSource.pull !== undefined) pullAlgorithm = function() {
                            return underlyingSource.pull(controller);
                        };
                        if (underlyingSource.cancel !== undefined) cancelAlgorithm = function(reason) {
                            return underlyingSource.cancel(reason);
                        };
                        SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
                    }
                    function defaultControllerBrandCheckException$1(name) {
                        return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
                    }
                    function ReadableStreamTee(stream, cloneForBranch2) {
                        if (IsReadableByteStreamController(stream._readableStreamController)) return ReadableByteStreamTee(stream);
                        return ReadableStreamDefaultTee(stream);
                    }
                    function ReadableStreamDefaultTee(stream, cloneForBranch2) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var reading = false;
                        var readAgain = false;
                        var canceled1 = false;
                        var canceled2 = false;
                        var reason1;
                        var reason2;
                        var branch1;
                        var branch2;
                        var resolveCancelPromise;
                        var cancelPromise = newPromise(function(resolve) {
                            resolveCancelPromise = resolve;
                        });
                        function pullAlgorithm() {
                            if (reading) {
                                readAgain = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgain = false;
                                        var chunk1 = chunk;
                                        var chunk2 = chunk;
                                        if (!canceled1) ReadableStreamDefaultControllerEnqueue(branch1._readableStreamController, chunk1);
                                        if (!canceled2) ReadableStreamDefaultControllerEnqueue(branch2._readableStreamController, chunk2);
                                        reading = false;
                                        if (readAgain) pullAlgorithm();
                                    });
                                },
                                _closeSteps: function() {
                                    reading = false;
                                    if (!canceled1) ReadableStreamDefaultControllerClose(branch1._readableStreamController);
                                    if (!canceled2) ReadableStreamDefaultControllerClose(branch2._readableStreamController);
                                    if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                            return promiseResolvedWith(undefined);
                        }
                        function cancel1Algorithm(reason) {
                            canceled1 = true;
                            reason1 = reason;
                            if (canceled2) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function cancel2Algorithm(reason) {
                            canceled2 = true;
                            reason2 = reason;
                            if (canceled1) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function startAlgorithm() {}
                        branch1 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel1Algorithm);
                        branch2 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel2Algorithm);
                        uponRejection(reader._closedPromise, function(r) {
                            ReadableStreamDefaultControllerError(branch1._readableStreamController, r);
                            ReadableStreamDefaultControllerError(branch2._readableStreamController, r);
                            if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                        });
                        return [
                            branch1,
                            branch2
                        ];
                    }
                    function ReadableByteStreamTee(stream) {
                        var reader = AcquireReadableStreamDefaultReader(stream);
                        var reading = false;
                        var readAgainForBranch1 = false;
                        var readAgainForBranch2 = false;
                        var canceled1 = false;
                        var canceled2 = false;
                        var reason1;
                        var reason2;
                        var branch1;
                        var branch2;
                        var resolveCancelPromise;
                        var cancelPromise = newPromise(function(resolve) {
                            resolveCancelPromise = resolve;
                        });
                        function forwardReaderError(thisReader) {
                            uponRejection(thisReader._closedPromise, function(r) {
                                if (thisReader !== reader) return;
                                ReadableByteStreamControllerError(branch1._readableStreamController, r);
                                ReadableByteStreamControllerError(branch2._readableStreamController, r);
                                if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                            });
                        }
                        function pullWithDefaultReader() {
                            if (IsReadableStreamBYOBReader(reader)) {
                                ReadableStreamReaderGenericRelease(reader);
                                reader = AcquireReadableStreamDefaultReader(stream);
                                forwardReaderError(reader);
                            }
                            var readRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgainForBranch1 = false;
                                        readAgainForBranch2 = false;
                                        var chunk1 = chunk;
                                        var chunk2 = chunk;
                                        if (!canceled1 && !canceled2) try {
                                            chunk2 = CloneAsUint8Array(chunk);
                                        } catch (cloneE) {
                                            ReadableByteStreamControllerError(branch1._readableStreamController, cloneE);
                                            ReadableByteStreamControllerError(branch2._readableStreamController, cloneE);
                                            resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                                            return;
                                        }
                                        if (!canceled1) ReadableByteStreamControllerEnqueue(branch1._readableStreamController, chunk1);
                                        if (!canceled2) ReadableByteStreamControllerEnqueue(branch2._readableStreamController, chunk2);
                                        reading = false;
                                        if (readAgainForBranch1) pull1Algorithm();
                                        else if (readAgainForBranch2) pull2Algorithm();
                                    });
                                },
                                _closeSteps: function() {
                                    reading = false;
                                    if (!canceled1) ReadableByteStreamControllerClose(branch1._readableStreamController);
                                    if (!canceled2) ReadableByteStreamControllerClose(branch2._readableStreamController);
                                    if (branch1._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(branch1._readableStreamController, 0);
                                    if (branch2._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(branch2._readableStreamController, 0);
                                    if (!canceled1 || !canceled2) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead(reader, readRequest);
                        }
                        function pullWithBYOBReader(view, forBranch2) {
                            if (IsReadableStreamDefaultReader(reader)) {
                                ReadableStreamReaderGenericRelease(reader);
                                reader = AcquireReadableStreamBYOBReader(stream);
                                forwardReaderError(reader);
                            }
                            var byobBranch = forBranch2 ? branch2 : branch1;
                            var otherBranch = forBranch2 ? branch1 : branch2;
                            var readIntoRequest = {
                                _chunkSteps: function(chunk) {
                                    queueMicrotask(function() {
                                        readAgainForBranch1 = false;
                                        readAgainForBranch2 = false;
                                        var byobCanceled = forBranch2 ? canceled2 : canceled1;
                                        var otherCanceled = forBranch2 ? canceled1 : canceled2;
                                        if (!otherCanceled) {
                                            var clonedChunk = void 0;
                                            try {
                                                clonedChunk = CloneAsUint8Array(chunk);
                                            } catch (cloneE) {
                                                ReadableByteStreamControllerError(byobBranch._readableStreamController, cloneE);
                                                ReadableByteStreamControllerError(otherBranch._readableStreamController, cloneE);
                                                resolveCancelPromise(ReadableStreamCancel(stream, cloneE));
                                                return;
                                            }
                                            if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                            ReadableByteStreamControllerEnqueue(otherBranch._readableStreamController, clonedChunk);
                                        } else if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                        reading = false;
                                        if (readAgainForBranch1) pull1Algorithm();
                                        else if (readAgainForBranch2) pull2Algorithm();
                                    });
                                },
                                _closeSteps: function(chunk) {
                                    reading = false;
                                    var byobCanceled = forBranch2 ? canceled2 : canceled1;
                                    var otherCanceled = forBranch2 ? canceled1 : canceled2;
                                    if (!byobCanceled) ReadableByteStreamControllerClose(byobBranch._readableStreamController);
                                    if (!otherCanceled) ReadableByteStreamControllerClose(otherBranch._readableStreamController);
                                    if (chunk !== undefined) {
                                        if (!byobCanceled) ReadableByteStreamControllerRespondWithNewView(byobBranch._readableStreamController, chunk);
                                        if (!otherCanceled && otherBranch._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond(otherBranch._readableStreamController, 0);
                                    }
                                    if (!byobCanceled || !otherCanceled) resolveCancelPromise(undefined);
                                },
                                _errorSteps: function() {
                                    reading = false;
                                }
                            };
                            ReadableStreamBYOBReaderRead(reader, view, readIntoRequest);
                        }
                        function pull1Algorithm() {
                            if (reading) {
                                readAgainForBranch1 = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch1._readableStreamController);
                            if (byobRequest === null) pullWithDefaultReader();
                            else pullWithBYOBReader(byobRequest._view, false);
                            return promiseResolvedWith(undefined);
                        }
                        function pull2Algorithm() {
                            if (reading) {
                                readAgainForBranch2 = true;
                                return promiseResolvedWith(undefined);
                            }
                            reading = true;
                            var byobRequest = ReadableByteStreamControllerGetBYOBRequest(branch2._readableStreamController);
                            if (byobRequest === null) pullWithDefaultReader();
                            else pullWithBYOBReader(byobRequest._view, true);
                            return promiseResolvedWith(undefined);
                        }
                        function cancel1Algorithm(reason) {
                            canceled1 = true;
                            reason1 = reason;
                            if (canceled2) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function cancel2Algorithm(reason) {
                            canceled2 = true;
                            reason2 = reason;
                            if (canceled1) {
                                var compositeReason = CreateArrayFromList([
                                    reason1,
                                    reason2
                                ]);
                                var cancelResult = ReadableStreamCancel(stream, compositeReason);
                                resolveCancelPromise(cancelResult);
                            }
                            return cancelPromise;
                        }
                        function startAlgorithm() {}
                        branch1 = CreateReadableByteStream(startAlgorithm, pull1Algorithm, cancel1Algorithm);
                        branch2 = CreateReadableByteStream(startAlgorithm, pull2Algorithm, cancel2Algorithm);
                        forwardReaderError(reader);
                        return [
                            branch1,
                            branch2
                        ];
                    }
                    function convertUnderlyingDefaultOrByteSource(source, context) {
                        assertDictionary(source, context);
                        var original = source;
                        var autoAllocateChunkSize = original === null || original === void 0 ? void 0 : original.autoAllocateChunkSize;
                        var cancel = original === null || original === void 0 ? void 0 : original.cancel;
                        var pull = original === null || original === void 0 ? void 0 : original.pull;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var type = original === null || original === void 0 ? void 0 : original.type;
                        return {
                            autoAllocateChunkSize: autoAllocateChunkSize === undefined ? undefined : convertUnsignedLongLongWithEnforceRange(autoAllocateChunkSize, context + " has member 'autoAllocateChunkSize' that"),
                            cancel: cancel === undefined ? undefined : convertUnderlyingSourceCancelCallback(cancel, original, context + " has member 'cancel' that"),
                            pull: pull === undefined ? undefined : convertUnderlyingSourcePullCallback(pull, original, context + " has member 'pull' that"),
                            start: start === undefined ? undefined : convertUnderlyingSourceStartCallback(start, original, context + " has member 'start' that"),
                            type: type === undefined ? undefined : convertReadableStreamType(type, context + " has member 'type' that")
                        };
                    }
                    function convertUnderlyingSourceCancelCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(reason) {
                            return promiseCall(fn, original, [
                                reason
                            ]);
                        };
                    }
                    function convertUnderlyingSourcePullCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return promiseCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertUnderlyingSourceStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertReadableStreamType(type, context) {
                        type = "" + type;
                        if (type !== 'bytes') throw new TypeError(context + " '" + type + "' is not a valid enumeration value for ReadableStreamType");
                        return type;
                    }
                    function convertReaderOptions(options, context) {
                        assertDictionary(options, context);
                        var mode = options === null || options === void 0 ? void 0 : options.mode;
                        return {
                            mode: mode === undefined ? undefined : convertReadableStreamReaderMode(mode, context + " has member 'mode' that")
                        };
                    }
                    function convertReadableStreamReaderMode(mode, context) {
                        mode = "" + mode;
                        if (mode !== 'byob') throw new TypeError(context + " '" + mode + "' is not a valid enumeration value for ReadableStreamReaderMode");
                        return mode;
                    }
                    function convertIteratorOptions(options, context) {
                        assertDictionary(options, context);
                        var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
                        return {
                            preventCancel: Boolean(preventCancel)
                        };
                    }
                    function convertPipeOptions(options, context) {
                        assertDictionary(options, context);
                        var preventAbort = options === null || options === void 0 ? void 0 : options.preventAbort;
                        var preventCancel = options === null || options === void 0 ? void 0 : options.preventCancel;
                        var preventClose = options === null || options === void 0 ? void 0 : options.preventClose;
                        var signal = options === null || options === void 0 ? void 0 : options.signal;
                        if (signal !== undefined) assertAbortSignal(signal, context + " has member 'signal' that");
                        return {
                            preventAbort: Boolean(preventAbort),
                            preventCancel: Boolean(preventCancel),
                            preventClose: Boolean(preventClose),
                            signal: signal
                        };
                    }
                    function assertAbortSignal(signal, context) {
                        if (!isAbortSignal(signal)) throw new TypeError(context + " is not an AbortSignal.");
                    }
                    function convertReadableWritablePair(pair, context) {
                        assertDictionary(pair, context);
                        var readable = pair === null || pair === void 0 ? void 0 : pair.readable;
                        assertRequiredField(readable, 'readable', 'ReadableWritablePair');
                        assertReadableStream(readable, context + " has member 'readable' that");
                        var writable = pair === null || pair === void 0 ? void 0 : pair.writable;
                        assertRequiredField(writable, 'writable', 'ReadableWritablePair');
                        assertWritableStream(writable, context + " has member 'writable' that");
                        return {
                            readable: readable,
                            writable: writable
                        };
                    }
                    var ReadableStream1 = function() {
                        function ReadableStream1(rawUnderlyingSource, rawStrategy) {
                            if (rawUnderlyingSource === void 0) rawUnderlyingSource = {};
                            if (rawStrategy === void 0) rawStrategy = {};
                            if (rawUnderlyingSource === undefined) rawUnderlyingSource = null;
                            else assertObject(rawUnderlyingSource, 'First parameter');
                            var strategy = convertQueuingStrategy(rawStrategy, 'Second parameter');
                            var underlyingSource = convertUnderlyingDefaultOrByteSource(rawUnderlyingSource, 'First parameter');
                            InitializeReadableStream(this);
                            if (underlyingSource.type === 'bytes') {
                                if (strategy.size !== undefined) throw new RangeError('The strategy for a byte stream cannot have a size function');
                                var highWaterMark = ExtractHighWaterMark(strategy, 0);
                                SetUpReadableByteStreamControllerFromUnderlyingSource(this, underlyingSource, highWaterMark);
                            } else {
                                var sizeAlgorithm = ExtractSizeAlgorithm(strategy);
                                var highWaterMark = ExtractHighWaterMark(strategy, 1);
                                SetUpReadableStreamDefaultControllerFromUnderlyingSource(this, underlyingSource, highWaterMark, sizeAlgorithm);
                            }
                        }
                        Object.defineProperty(ReadableStream1.prototype, "locked", {
                            get: function() {
                                if (!IsReadableStream(this)) throw streamBrandCheckException$1('locked');
                                return IsReadableStreamLocked(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStream1.prototype.cancel = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsReadableStream(this)) return promiseRejectedWith(streamBrandCheckException$1('cancel'));
                            if (IsReadableStreamLocked(this)) return promiseRejectedWith(new TypeError('Cannot cancel a stream that already has a reader'));
                            return ReadableStreamCancel(this, reason);
                        };
                        ReadableStream1.prototype.getReader = function(rawOptions) {
                            if (rawOptions === void 0) rawOptions = undefined;
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('getReader');
                            var options = convertReaderOptions(rawOptions, 'First parameter');
                            if (options.mode === undefined) return AcquireReadableStreamDefaultReader(this);
                            return AcquireReadableStreamBYOBReader(this);
                        };
                        ReadableStream1.prototype.pipeThrough = function(rawTransform, rawOptions) {
                            if (rawOptions === void 0) rawOptions = {};
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('pipeThrough');
                            assertRequiredArgument(rawTransform, 1, 'pipeThrough');
                            var transform = convertReadableWritablePair(rawTransform, 'First parameter');
                            var options = convertPipeOptions(rawOptions, 'Second parameter');
                            if (IsReadableStreamLocked(this)) throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream');
                            if (IsWritableStreamLocked(transform.writable)) throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream');
                            var promise = ReadableStreamPipeTo(this, transform.writable, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
                            setPromiseIsHandledToTrue(promise);
                            return transform.readable;
                        };
                        ReadableStream1.prototype.pipeTo = function(destination, rawOptions) {
                            if (rawOptions === void 0) rawOptions = {};
                            if (!IsReadableStream(this)) return promiseRejectedWith(streamBrandCheckException$1('pipeTo'));
                            if (destination === undefined) return promiseRejectedWith("Parameter 1 is required in 'pipeTo'.");
                            if (!IsWritableStream(destination)) return promiseRejectedWith(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                            var options;
                            try {
                                options = convertPipeOptions(rawOptions, 'Second parameter');
                            } catch (e) {
                                return promiseRejectedWith(e);
                            }
                            if (IsReadableStreamLocked(this)) return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
                            if (IsWritableStreamLocked(destination)) return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
                            return ReadableStreamPipeTo(this, destination, options.preventClose, options.preventAbort, options.preventCancel, options.signal);
                        };
                        ReadableStream1.prototype.tee = function() {
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('tee');
                            var branches = ReadableStreamTee(this);
                            return CreateArrayFromList(branches);
                        };
                        ReadableStream1.prototype.values = function(rawOptions) {
                            if (rawOptions === void 0) rawOptions = undefined;
                            if (!IsReadableStream(this)) throw streamBrandCheckException$1('values');
                            var options = convertIteratorOptions(rawOptions, 'First parameter');
                            return AcquireReadableStreamAsyncIterator(this, options.preventCancel);
                        };
                        return ReadableStream1;
                    }();
                    Object.defineProperties(ReadableStream1.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        getReader: {
                            enumerable: true
                        },
                        pipeThrough: {
                            enumerable: true
                        },
                        pipeTo: {
                            enumerable: true
                        },
                        tee: {
                            enumerable: true
                        },
                        values: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ReadableStream1.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ReadableStream',
                        configurable: true
                    });
                    if (typeof SymbolPolyfill.asyncIterator === 'symbol') Object.defineProperty(ReadableStream1.prototype, SymbolPolyfill.asyncIterator, {
                        value: ReadableStream1.prototype.values,
                        writable: true,
                        configurable: true
                    });
                    function CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
                        if (highWaterMark === void 0) highWaterMark = 1;
                        if (sizeAlgorithm === void 0) sizeAlgorithm = function() {
                            return 1;
                        };
                        var stream = Object.create(ReadableStream1.prototype);
                        InitializeReadableStream(stream);
                        var controller = Object.create(ReadableStreamDefaultController.prototype);
                        SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
                        return stream;
                    }
                    function CreateReadableByteStream(startAlgorithm, pullAlgorithm, cancelAlgorithm) {
                        var stream = Object.create(ReadableStream1.prototype);
                        InitializeReadableStream(stream);
                        var controller = Object.create(ReadableByteStreamController.prototype);
                        SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, 0, undefined);
                        return stream;
                    }
                    function InitializeReadableStream(stream) {
                        stream._state = 'readable';
                        stream._reader = undefined;
                        stream._storedError = undefined;
                        stream._disturbed = false;
                    }
                    function IsReadableStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) return false;
                        return x instanceof ReadableStream1;
                    }
                    function IsReadableStreamLocked(stream) {
                        if (stream._reader === undefined) return false;
                        return true;
                    }
                    function ReadableStreamCancel(stream, reason) {
                        stream._disturbed = true;
                        if (stream._state === 'closed') return promiseResolvedWith(undefined);
                        if (stream._state === 'errored') return promiseRejectedWith(stream._storedError);
                        ReadableStreamClose(stream);
                        var reader = stream._reader;
                        if (reader !== undefined && IsReadableStreamBYOBReader(reader)) {
                            reader._readIntoRequests.forEach(function(readIntoRequest) {
                                readIntoRequest._closeSteps(undefined);
                            });
                            reader._readIntoRequests = new SimpleQueue();
                        }
                        var sourceCancelPromise = stream._readableStreamController[CancelSteps](reason);
                        return transformPromiseWith(sourceCancelPromise, noop);
                    }
                    function ReadableStreamClose(stream) {
                        stream._state = 'closed';
                        var reader = stream._reader;
                        if (reader === undefined) return;
                        defaultReaderClosedPromiseResolve(reader);
                        if (IsReadableStreamDefaultReader(reader)) {
                            reader._readRequests.forEach(function(readRequest) {
                                readRequest._closeSteps();
                            });
                            reader._readRequests = new SimpleQueue();
                        }
                    }
                    function ReadableStreamError(stream, e) {
                        stream._state = 'errored';
                        stream._storedError = e;
                        var reader = stream._reader;
                        if (reader === undefined) return;
                        defaultReaderClosedPromiseReject(reader, e);
                        if (IsReadableStreamDefaultReader(reader)) {
                            reader._readRequests.forEach(function(readRequest) {
                                readRequest._errorSteps(e);
                            });
                            reader._readRequests = new SimpleQueue();
                        } else {
                            reader._readIntoRequests.forEach(function(readIntoRequest) {
                                readIntoRequest._errorSteps(e);
                            });
                            reader._readIntoRequests = new SimpleQueue();
                        }
                    }
                    function streamBrandCheckException$1(name) {
                        return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
                    }
                    function convertQueuingStrategyInit(init, context) {
                        assertDictionary(init, context);
                        var highWaterMark = init === null || init === void 0 ? void 0 : init.highWaterMark;
                        assertRequiredField(highWaterMark, 'highWaterMark', 'QueuingStrategyInit');
                        return {
                            highWaterMark: convertUnrestrictedDouble(highWaterMark)
                        };
                    }
                    var byteLengthSizeFunction = function(chunk) {
                        return chunk.byteLength;
                    };
                    Object.defineProperty(byteLengthSizeFunction, 'name', {
                        value: 'size',
                        configurable: true
                    });
                    var ByteLengthQueuingStrategy = function() {
                        function ByteLengthQueuingStrategy(options) {
                            assertRequiredArgument(options, 1, 'ByteLengthQueuingStrategy');
                            options = convertQueuingStrategyInit(options, 'First parameter');
                            this._byteLengthQueuingStrategyHighWaterMark = options.highWaterMark;
                        }
                        Object.defineProperty(ByteLengthQueuingStrategy.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy(this)) throw byteLengthBrandCheckException('highWaterMark');
                                return this._byteLengthQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ByteLengthQueuingStrategy.prototype, "size", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy(this)) throw byteLengthBrandCheckException('size');
                                return byteLengthSizeFunction;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return ByteLengthQueuingStrategy;
                    }();
                    Object.defineProperties(ByteLengthQueuingStrategy.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(ByteLengthQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                        value: 'ByteLengthQueuingStrategy',
                        configurable: true
                    });
                    function byteLengthBrandCheckException(name) {
                        return new TypeError("ByteLengthQueuingStrategy.prototype." + name + " can only be used on a ByteLengthQueuingStrategy");
                    }
                    function IsByteLengthQueuingStrategy(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_byteLengthQueuingStrategyHighWaterMark')) return false;
                        return x instanceof ByteLengthQueuingStrategy;
                    }
                    var countSizeFunction = function() {
                        return 1;
                    };
                    Object.defineProperty(countSizeFunction, 'name', {
                        value: 'size',
                        configurable: true
                    });
                    var CountQueuingStrategy = function() {
                        function CountQueuingStrategy(options) {
                            assertRequiredArgument(options, 1, 'CountQueuingStrategy');
                            options = convertQueuingStrategyInit(options, 'First parameter');
                            this._countQueuingStrategyHighWaterMark = options.highWaterMark;
                        }
                        Object.defineProperty(CountQueuingStrategy.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsCountQueuingStrategy(this)) throw countBrandCheckException('highWaterMark');
                                return this._countQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(CountQueuingStrategy.prototype, "size", {
                            get: function() {
                                if (!IsCountQueuingStrategy(this)) throw countBrandCheckException('size');
                                return countSizeFunction;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return CountQueuingStrategy;
                    }();
                    Object.defineProperties(CountQueuingStrategy.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(CountQueuingStrategy.prototype, SymbolPolyfill.toStringTag, {
                        value: 'CountQueuingStrategy',
                        configurable: true
                    });
                    function countBrandCheckException(name) {
                        return new TypeError("CountQueuingStrategy.prototype." + name + " can only be used on a CountQueuingStrategy");
                    }
                    function IsCountQueuingStrategy(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_countQueuingStrategyHighWaterMark')) return false;
                        return x instanceof CountQueuingStrategy;
                    }
                    function convertTransformer(original, context) {
                        assertDictionary(original, context);
                        var flush = original === null || original === void 0 ? void 0 : original.flush;
                        var readableType = original === null || original === void 0 ? void 0 : original.readableType;
                        var start = original === null || original === void 0 ? void 0 : original.start;
                        var transform = original === null || original === void 0 ? void 0 : original.transform;
                        var writableType = original === null || original === void 0 ? void 0 : original.writableType;
                        return {
                            flush: flush === undefined ? undefined : convertTransformerFlushCallback(flush, original, context + " has member 'flush' that"),
                            readableType: readableType,
                            start: start === undefined ? undefined : convertTransformerStartCallback(start, original, context + " has member 'start' that"),
                            transform: transform === undefined ? undefined : convertTransformerTransformCallback(transform, original, context + " has member 'transform' that"),
                            writableType: writableType
                        };
                    }
                    function convertTransformerFlushCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return promiseCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertTransformerStartCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(controller) {
                            return reflectCall(fn, original, [
                                controller
                            ]);
                        };
                    }
                    function convertTransformerTransformCallback(fn, original, context) {
                        assertFunction(fn, context);
                        return function(chunk, controller) {
                            return promiseCall(fn, original, [
                                chunk,
                                controller
                            ]);
                        };
                    }
                    var TransformStream = function() {
                        function TransformStream(rawTransformer, rawWritableStrategy, rawReadableStrategy) {
                            if (rawTransformer === void 0) rawTransformer = {};
                            if (rawWritableStrategy === void 0) rawWritableStrategy = {};
                            if (rawReadableStrategy === void 0) rawReadableStrategy = {};
                            if (rawTransformer === undefined) rawTransformer = null;
                            var writableStrategy = convertQueuingStrategy(rawWritableStrategy, 'Second parameter');
                            var readableStrategy = convertQueuingStrategy(rawReadableStrategy, 'Third parameter');
                            var transformer = convertTransformer(rawTransformer, 'First parameter');
                            if (transformer.readableType !== undefined) throw new RangeError('Invalid readableType specified');
                            if (transformer.writableType !== undefined) throw new RangeError('Invalid writableType specified');
                            var readableHighWaterMark = ExtractHighWaterMark(readableStrategy, 0);
                            var readableSizeAlgorithm = ExtractSizeAlgorithm(readableStrategy);
                            var writableHighWaterMark = ExtractHighWaterMark(writableStrategy, 1);
                            var writableSizeAlgorithm = ExtractSizeAlgorithm(writableStrategy);
                            var startPromise_resolve;
                            var startPromise = newPromise(function(resolve) {
                                startPromise_resolve = resolve;
                            });
                            InitializeTransformStream(this, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
                            SetUpTransformStreamDefaultControllerFromTransformer(this, transformer);
                            if (transformer.start !== undefined) startPromise_resolve(transformer.start(this._transformStreamController));
                            else startPromise_resolve(undefined);
                        }
                        Object.defineProperty(TransformStream.prototype, "readable", {
                            get: function() {
                                if (!IsTransformStream(this)) throw streamBrandCheckException('readable');
                                return this._readable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(TransformStream.prototype, "writable", {
                            get: function() {
                                if (!IsTransformStream(this)) throw streamBrandCheckException('writable');
                                return this._writable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return TransformStream;
                    }();
                    Object.defineProperties(TransformStream.prototype, {
                        readable: {
                            enumerable: true
                        },
                        writable: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(TransformStream.prototype, SymbolPolyfill.toStringTag, {
                        value: 'TransformStream',
                        configurable: true
                    });
                    function InitializeTransformStream(stream, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm) {
                        function startAlgorithm() {
                            return startPromise;
                        }
                        function writeAlgorithm(chunk) {
                            return TransformStreamDefaultSinkWriteAlgorithm(stream, chunk);
                        }
                        function abortAlgorithm(reason) {
                            return TransformStreamDefaultSinkAbortAlgorithm(stream, reason);
                        }
                        function closeAlgorithm() {
                            return TransformStreamDefaultSinkCloseAlgorithm(stream);
                        }
                        stream._writable = CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, writableHighWaterMark, writableSizeAlgorithm);
                        function pullAlgorithm() {
                            return TransformStreamDefaultSourcePullAlgorithm(stream);
                        }
                        function cancelAlgorithm(reason) {
                            TransformStreamErrorWritableAndUnblockWrite(stream, reason);
                            return promiseResolvedWith(undefined);
                        }
                        stream._readable = CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
                        stream._backpressure = undefined;
                        stream._backpressureChangePromise = undefined;
                        stream._backpressureChangePromise_resolve = undefined;
                        TransformStreamSetBackpressure(stream, true);
                        stream._transformStreamController = undefined;
                    }
                    function IsTransformStream(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) return false;
                        return x instanceof TransformStream;
                    }
                    function TransformStreamError(stream, e) {
                        ReadableStreamDefaultControllerError(stream._readable._readableStreamController, e);
                        TransformStreamErrorWritableAndUnblockWrite(stream, e);
                    }
                    function TransformStreamErrorWritableAndUnblockWrite(stream, e) {
                        TransformStreamDefaultControllerClearAlgorithms(stream._transformStreamController);
                        WritableStreamDefaultControllerErrorIfNeeded(stream._writable._writableStreamController, e);
                        if (stream._backpressure) TransformStreamSetBackpressure(stream, false);
                    }
                    function TransformStreamSetBackpressure(stream, backpressure) {
                        if (stream._backpressureChangePromise !== undefined) stream._backpressureChangePromise_resolve();
                        stream._backpressureChangePromise = newPromise(function(resolve) {
                            stream._backpressureChangePromise_resolve = resolve;
                        });
                        stream._backpressure = backpressure;
                    }
                    var TransformStreamDefaultController = function() {
                        function TransformStreamDefaultController() {
                            throw new TypeError('Illegal constructor');
                        }
                        Object.defineProperty(TransformStreamDefaultController.prototype, "desiredSize", {
                            get: function() {
                                if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('desiredSize');
                                var readableController = this._controlledTransformStream._readable._readableStreamController;
                                return ReadableStreamDefaultControllerGetDesiredSize(readableController);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        TransformStreamDefaultController.prototype.enqueue = function(chunk) {
                            if (chunk === void 0) chunk = undefined;
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('enqueue');
                            TransformStreamDefaultControllerEnqueue(this, chunk);
                        };
                        TransformStreamDefaultController.prototype.error = function(reason) {
                            if (reason === void 0) reason = undefined;
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('error');
                            TransformStreamDefaultControllerError(this, reason);
                        };
                        TransformStreamDefaultController.prototype.terminate = function() {
                            if (!IsTransformStreamDefaultController(this)) throw defaultControllerBrandCheckException('terminate');
                            TransformStreamDefaultControllerTerminate(this);
                        };
                        return TransformStreamDefaultController;
                    }();
                    Object.defineProperties(TransformStreamDefaultController.prototype, {
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        terminate: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill.toStringTag === 'symbol') Object.defineProperty(TransformStreamDefaultController.prototype, SymbolPolyfill.toStringTag, {
                        value: 'TransformStreamDefaultController',
                        configurable: true
                    });
                    function IsTransformStreamDefaultController(x) {
                        if (!typeIsObject(x)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) return false;
                        return x instanceof TransformStreamDefaultController;
                    }
                    function SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm) {
                        controller._controlledTransformStream = stream;
                        stream._transformStreamController = controller;
                        controller._transformAlgorithm = transformAlgorithm;
                        controller._flushAlgorithm = flushAlgorithm;
                    }
                    function SetUpTransformStreamDefaultControllerFromTransformer(stream, transformer) {
                        var controller = Object.create(TransformStreamDefaultController.prototype);
                        var transformAlgorithm = function(chunk) {
                            try {
                                TransformStreamDefaultControllerEnqueue(controller, chunk);
                                return promiseResolvedWith(undefined);
                            } catch (transformResultE) {
                                return promiseRejectedWith(transformResultE);
                            }
                        };
                        var flushAlgorithm = function() {
                            return promiseResolvedWith(undefined);
                        };
                        if (transformer.transform !== undefined) transformAlgorithm = function(chunk) {
                            return transformer.transform(chunk, controller);
                        };
                        if (transformer.flush !== undefined) flushAlgorithm = function() {
                            return transformer.flush(controller);
                        };
                        SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm);
                    }
                    function TransformStreamDefaultControllerClearAlgorithms(controller) {
                        controller._transformAlgorithm = undefined;
                        controller._flushAlgorithm = undefined;
                    }
                    function TransformStreamDefaultControllerEnqueue(controller, chunk) {
                        var stream = controller._controlledTransformStream;
                        var readableController = stream._readable._readableStreamController;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController)) throw new TypeError('Readable side is not in a state that permits enqueue');
                        try {
                            ReadableStreamDefaultControllerEnqueue(readableController, chunk);
                        } catch (e) {
                            TransformStreamErrorWritableAndUnblockWrite(stream, e);
                            throw stream._readable._storedError;
                        }
                        var backpressure = ReadableStreamDefaultControllerHasBackpressure(readableController);
                        if (backpressure !== stream._backpressure) TransformStreamSetBackpressure(stream, true);
                    }
                    function TransformStreamDefaultControllerError(controller, e) {
                        TransformStreamError(controller._controlledTransformStream, e);
                    }
                    function TransformStreamDefaultControllerPerformTransform(controller, chunk) {
                        var transformPromise = controller._transformAlgorithm(chunk);
                        return transformPromiseWith(transformPromise, undefined, function(r) {
                            TransformStreamError(controller._controlledTransformStream, r);
                            throw r;
                        });
                    }
                    function TransformStreamDefaultControllerTerminate(controller) {
                        var stream = controller._controlledTransformStream;
                        var readableController = stream._readable._readableStreamController;
                        ReadableStreamDefaultControllerClose(readableController);
                        var error = new TypeError('TransformStream terminated');
                        TransformStreamErrorWritableAndUnblockWrite(stream, error);
                    }
                    function TransformStreamDefaultSinkWriteAlgorithm(stream, chunk) {
                        var controller = stream._transformStreamController;
                        if (stream._backpressure) {
                            var backpressureChangePromise = stream._backpressureChangePromise;
                            return transformPromiseWith(backpressureChangePromise, function() {
                                var writable = stream._writable;
                                var state = writable._state;
                                if (state === 'erroring') throw writable._storedError;
                                return TransformStreamDefaultControllerPerformTransform(controller, chunk);
                            });
                        }
                        return TransformStreamDefaultControllerPerformTransform(controller, chunk);
                    }
                    function TransformStreamDefaultSinkAbortAlgorithm(stream, reason) {
                        TransformStreamError(stream, reason);
                        return promiseResolvedWith(undefined);
                    }
                    function TransformStreamDefaultSinkCloseAlgorithm(stream) {
                        var readable = stream._readable;
                        var controller = stream._transformStreamController;
                        var flushPromise = controller._flushAlgorithm();
                        TransformStreamDefaultControllerClearAlgorithms(controller);
                        return transformPromiseWith(flushPromise, function() {
                            if (readable._state === 'errored') throw readable._storedError;
                            ReadableStreamDefaultControllerClose(readable._readableStreamController);
                        }, function(r) {
                            TransformStreamError(stream, r);
                            throw readable._storedError;
                        });
                    }
                    function TransformStreamDefaultSourcePullAlgorithm(stream) {
                        TransformStreamSetBackpressure(stream, false);
                        return stream._backpressureChangePromise;
                    }
                    function defaultControllerBrandCheckException(name) {
                        return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
                    }
                    function streamBrandCheckException(name) {
                        return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
                    }
                    exports.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy;
                    exports.CountQueuingStrategy = CountQueuingStrategy;
                    exports.ReadableByteStreamController = ReadableByteStreamController;
                    exports.ReadableStream = ReadableStream1;
                    exports.ReadableStreamBYOBReader = ReadableStreamBYOBReader;
                    exports.ReadableStreamBYOBRequest = ReadableStreamBYOBRequest;
                    exports.ReadableStreamDefaultController = ReadableStreamDefaultController;
                    exports.ReadableStreamDefaultReader = ReadableStreamDefaultReader;
                    exports.TransformStream = TransformStream;
                    exports.TransformStreamDefaultController = TransformStreamDefaultController;
                    exports.WritableStream = WritableStream;
                    exports.WritableStreamDefaultController = WritableStreamDefaultController;
                    exports.WritableStreamDefaultWriter = WritableStreamDefaultWriter;
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                });
            /***/ },
            /* 135 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var BaseCanvasFactory = /*#__PURE__*/ function() {
                    function BaseCanvasFactory() {
                        _classCallCheck(this, BaseCanvasFactory);
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    _createClass(BaseCanvasFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                var canvas = this._createCanvas(width, height);
                                return {
                                    canvas: canvas,
                                    context: canvas.getContext("2d")
                                };
                            }
                        },
                        {
                            key: "reset",
                            value: function reset(canvasAndContext, width, height) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                canvasAndContext.canvas.width = width;
                                canvasAndContext.canvas.height = height;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy(canvasAndContext) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                canvasAndContext.canvas.width = 0;
                                canvasAndContext.canvas.height = 0;
                                canvasAndContext.canvas = null;
                                canvasAndContext.context = null;
                            }
                        },
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                            }
                        }
                    ]);
                    return BaseCanvasFactory;
                }();
                exports.BaseCanvasFactory = BaseCanvasFactory;
                var BaseCMapReaderFactory = /*#__PURE__*/ function() {
                    function BaseCMapReaderFactory(_ref) {
                        var _ref$baseUrl = _ref.baseUrl, baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl, _ref$isCompressed = _ref.isCompressed, isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed;
                        _classCallCheck(this, BaseCMapReaderFactory);
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    _createClass(BaseCMapReaderFactory, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(_ref2) {
                                    var _this = this;
                                    var name, url, compressionType;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                name = _ref2.name;
                                                if (this.baseUrl) {
                                                    _context.next = 3;
                                                    break;
                                                }
                                                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                                            case 3:
                                                if (name) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                throw new Error("CMap name must be specified.");
                                            case 5:
                                                url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                                                compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                                                return _context.abrupt("return", this._fetchData(url, compressionType)["catch"](function(reason) {
                                                    throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                                                }));
                                            case 8:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function fetch1(_x) {
                                    return _fetch.apply(this, arguments);
                                }
                                return fetch1;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseCMapReaderFactory;
                }();
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                var BaseStandardFontDataFactory = /*#__PURE__*/ function() {
                    function BaseStandardFontDataFactory(_ref3) {
                        var _ref3$baseUrl = _ref3.baseUrl, baseUrl = _ref3$baseUrl === void 0 ? null : _ref3$baseUrl;
                        _classCallCheck(this, BaseStandardFontDataFactory);
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    _createClass(BaseStandardFontDataFactory, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2(_ref4) {
                                    var filename, url;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                filename = _ref4.filename;
                                                if (this.baseUrl) {
                                                    _context2.next = 3;
                                                    break;
                                                }
                                                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                                            case 3:
                                                if (filename) {
                                                    _context2.next = 5;
                                                    break;
                                                }
                                                throw new Error("Font filename must be specified.");
                                            case 5:
                                                url = "".concat(this.baseUrl).concat(filename);
                                                return _context2.abrupt("return", this._fetchData(url)["catch"](function(reason) {
                                                    throw new Error("Unable to load font data at: ".concat(url));
                                                }));
                                            case 7:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function fetch1(_x2) {
                                    return _fetch2.apply(this, arguments);
                                }
                                return fetch1;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseStandardFontDataFactory;
                }();
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                var BaseSVGFactory = /*#__PURE__*/ function() {
                    function BaseSVGFactory() {
                        _classCallCheck(this, BaseSVGFactory);
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    _createClass(BaseSVGFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                                var svg = this._createSVG("svg:svg");
                                svg.setAttribute("version", "1.1");
                                svg.setAttribute("width", "".concat(width, "px"));
                                svg.setAttribute("height", "".concat(height, "px"));
                                svg.setAttribute("preserveAspectRatio", "none");
                                svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
                                return svg;
                            }
                        },
                        {
                            key: "createElement",
                            value: function createElement(type) {
                                if (typeof type !== "string") throw new Error("Invalid SVG element type");
                                return this._createSVG(type);
                            }
                        },
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                (0, _util.unreachable)("Abstract method `_createSVG` called.");
                            }
                        }
                    ]);
                    return BaseSVGFactory;
                }();
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 136 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.build = exports.RenderTask = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                exports.getDocument = getDocument;
                exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
                exports.version = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _font_loader = __w_pdfjs_require__(137);
                var _node_utils = __w_pdfjs_require__(138);
                var _annotation_storage = __w_pdfjs_require__(139);
                var _canvas = __w_pdfjs_require__(140);
                var _worker_options = __w_pdfjs_require__(142);
                var _is_node = __w_pdfjs_require__(6);
                var _message_handler = __w_pdfjs_require__(143);
                var _metadata = __w_pdfjs_require__(144);
                var _optional_content_config = __w_pdfjs_require__(145);
                var _transport_stream = __w_pdfjs_require__(146);
                var _xfa_text = __w_pdfjs_require__(147);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _classPrivateFieldInitSpec(obj, privateMap, value) {
                    _checkPrivateRedeclaration(obj, privateMap);
                    privateMap.set(obj, value);
                }
                function _checkPrivateRedeclaration(obj, privateCollection) {
                    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldSet(receiver, privateMap, value) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
                    _classApplyDescriptorSet(receiver, descriptor, value);
                    return value;
                }
                function _classApplyDescriptorSet(receiver, descriptor, value) {
                    if (descriptor.set) descriptor.set.call(receiver, value);
                    else {
                        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
                        descriptor.value = value;
                    }
                }
                function _classPrivateFieldGet(receiver, privateMap) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
                    return _classApplyDescriptorGet(receiver, descriptor);
                }
                function _classExtractFieldDescriptor(receiver, privateMap, action) {
                    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
                    return privateMap.get(receiver);
                }
                function _classApplyDescriptorGet(receiver, descriptor) {
                    if (descriptor.get) return descriptor.get.call(receiver);
                    return descriptor.value;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof1(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var DEFAULT_RANGE_CHUNK_SIZE = 65536;
                var RENDERING_CANCELLED_TIMEOUT = 100;
                var DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                var DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                var DefaultStandardFontDataFactory = _is_node.isNodeJS ? _node_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                var createPDFNetworkStream;
                function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
                    createPDFNetworkStream = pdfNetworkStreamFactory;
                }
                function getDocument(src) {
                    var task = new PDFDocumentLoadingTask();
                    var source;
                    if (typeof src === "string" || src instanceof URL) source = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) source = {
                        data: src
                    };
                    else if (src instanceof PDFDataRangeTransport) source = {
                        range: src
                    };
                    else {
                        if (_typeof(src) !== "object") throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
                        if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                        source = src;
                    }
                    var params = Object.create(null);
                    var rangeTransport = null, worker = null;
                    for(var key in source){
                        var value = source[key];
                        switch(key){
                            case "url":
                                if (typeof window !== "undefined") try {
                                    params[key] = new URL(value, window.location).href;
                                    continue;
                                } catch (ex) {
                                    (0, _util.warn)("Cannot create valid URL: \"".concat(ex, "\"."));
                                }
                                else if (typeof value === "string" || value instanceof URL) {
                                    params[key] = value.toString();
                                    continue;
                                }
                                throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                            case "range":
                                rangeTransport = value;
                                continue;
                            case "worker":
                                worker = value;
                                continue;
                            case "data":
                                if (_is_node.isNodeJS && typeof $04fdcf7a3248ff46$require$Buffer !== "undefined" && value instanceof $04fdcf7a3248ff46$require$Buffer) params[key] = new Uint8Array(value);
                                else if (value instanceof Uint8Array) break;
                                else if (typeof value === "string") params[key] = (0, _util.stringToBytes)(value);
                                else if (_typeof(value) === "object" && value !== null && !isNaN(value.length)) params[key] = new Uint8Array(value);
                                else if ((0, _util.isArrayBuffer)(value)) params[key] = new Uint8Array(value);
                                else throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                                continue;
                        }
                        params[key] = value;
                    }
                    params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
                    params.CMapReaderFactory = params.CMapReaderFactory || DefaultCMapReaderFactory;
                    params.StandardFontDataFactory = params.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    params.ignoreErrors = params.stopAtErrors !== true;
                    params.fontExtraProperties = params.fontExtraProperties === true;
                    params.pdfBug = params.pdfBug === true;
                    params.enableXfa = params.enableXfa === true;
                    if (typeof params.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params.docBaseUrl)) params.docBaseUrl = null;
                    if (!Number.isInteger(params.maxImageSize)) params.maxImageSize = -1;
                    if (typeof params.useWorkerFetch !== "boolean") params.useWorkerFetch = params.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && params.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory;
                    if (typeof params.isEvalSupported !== "boolean") params.isEvalSupported = true;
                    if (typeof params.disableFontFace !== "boolean") params.disableFontFace = _is_node.isNodeJS;
                    if (typeof params.useSystemFonts !== "boolean") params.useSystemFonts = !_is_node.isNodeJS && !params.disableFontFace;
                    if (typeof params.ownerDocument === "undefined") params.ownerDocument = globalThis.document;
                    if (typeof params.disableRange !== "boolean") params.disableRange = false;
                    if (typeof params.disableStream !== "boolean") params.disableStream = false;
                    if (typeof params.disableAutoFetch !== "boolean") params.disableAutoFetch = false;
                    (0, _util.setVerbosityLevel)(params.verbosity);
                    if (!worker) {
                        var workerParams = {
                            verbosity: params.verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    var docId = task.docId;
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        var workerIdPromise = _fetchDocument(worker, params, rangeTransport, docId);
                        var networkStreamPromise = new Promise(function(resolve) {
                            var networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: params.length,
                                initialData: params.initialData,
                                progressiveDone: params.progressiveDone,
                                contentDispositionFilename: params.contentDispositionFilename,
                                disableRange: params.disableRange,
                                disableStream: params.disableStream
                            }, rangeTransport);
                            else if (!params.data) networkStream = createPDFNetworkStream({
                                url: params.url,
                                length: params.length,
                                httpHeaders: params.httpHeaders,
                                withCredentials: params.withCredentials,
                                rangeChunkSize: params.rangeChunkSize,
                                disableRange: params.disableRange,
                                disableStream: params.disableStream
                            });
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function(_ref) {
                            var _ref2 = _slicedToArray(_ref, 2), workerId = _ref2[0], networkStream = _ref2[1];
                            if (task.destroyed) throw new Error("Loading aborted");
                            var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            var transport = new WorkerTransport(messageHandler, task, networkStream, params);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    })["catch"](task._capability.reject);
                    return task;
                }
                function _fetchDocument(_x, _x2, _x3, _x4) {
                    return _fetchDocument2.apply(this, arguments);
                }
                function _fetchDocument2() {
                    _fetchDocument2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee7(worker, source, pdfDataRangeTransport, docId) {
                        var workerId;
                        return _regenerator["default"].wrap(function _callee7$(_context7) {
                            while(true)switch(_context7.prev = _context7.next){
                                case 0:
                                    if (!worker.destroyed) {
                                        _context7.next = 2;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 2:
                                    if (pdfDataRangeTransport) {
                                        source.length = pdfDataRangeTransport.length;
                                        source.initialData = pdfDataRangeTransport.initialData;
                                        source.progressiveDone = pdfDataRangeTransport.progressiveDone;
                                        source.contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
                                    }
                                    _context7.next = 5;
                                    return worker.messageHandler.sendWithPromise("GetDocRequest", {
                                        docId: docId,
                                        apiVersion: '2.12.313',
                                        source: {
                                            data: source.data,
                                            url: source.url,
                                            password: source.password,
                                            disableAutoFetch: source.disableAutoFetch,
                                            rangeChunkSize: source.rangeChunkSize,
                                            length: source.length
                                        },
                                        maxImageSize: source.maxImageSize,
                                        disableFontFace: source.disableFontFace,
                                        docBaseUrl: source.docBaseUrl,
                                        ignoreErrors: source.ignoreErrors,
                                        isEvalSupported: source.isEvalSupported,
                                        fontExtraProperties: source.fontExtraProperties,
                                        enableXfa: source.enableXfa,
                                        useSystemFonts: source.useSystemFonts,
                                        cMapUrl: source.useWorkerFetch ? source.cMapUrl : null,
                                        standardFontDataUrl: source.useWorkerFetch ? source.standardFontDataUrl : null
                                    });
                                case 5:
                                    workerId = _context7.sent;
                                    if (!worker.destroyed) {
                                        _context7.next = 8;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 8:
                                    return _context7.abrupt("return", workerId);
                                case 9:
                                case "end":
                                    return _context7.stop();
                            }
                        }, _callee7);
                    }));
                    return _fetchDocument2.apply(this, arguments);
                }
                var PDFDocumentLoadingTask = /*#__PURE__*/ function() {
                    function PDFDocumentLoadingTask() {
                        _classCallCheck(this, PDFDocumentLoadingTask);
                        this._capability = (0, _util.createPromiseCapability)();
                        this._transport = null;
                        this._worker = null;
                        this.docId = "d".concat(PDFDocumentLoadingTask.idCounters.doc++);
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                        this.onUnsupportedFeature = null;
                    }
                    _createClass(PDFDocumentLoadingTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                var _destroy = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var _this$_transport;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                this.destroyed = true;
                                                _context.next = 3;
                                                return (_this$_transport = this._transport) === null || _this$_transport === void 0 ? void 0 : _this$_transport.destroy();
                                            case 3:
                                                this._transport = null;
                                                if (this._worker) {
                                                    this._worker.destroy();
                                                    this._worker = null;
                                                }
                                            case 5:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function destroy() {
                                    return _destroy.apply(this, arguments);
                                }
                                return destroy;
                            }()
                        }
                    ], [
                        {
                            key: "idCounters",
                            get: function get() {
                                return (0, _util.shadow)(this, "idCounters", {
                                    doc: 0
                                });
                            }
                        }
                    ]);
                    return PDFDocumentLoadingTask;
                }();
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                var PDFDataRangeTransport = /*#__PURE__*/ function() {
                    function PDFDataRangeTransport(length, initialData) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFDataRangeTransport);
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = (0, _util.createPromiseCapability)();
                    }
                    _createClass(PDFDataRangeTransport, [
                        {
                            key: "addRangeListener",
                            value: function addRangeListener(listener) {
                                this._rangeListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressListener",
                            value: function addProgressListener(listener) {
                                this._progressListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveReadListener",
                            value: function addProgressiveReadListener(listener) {
                                this._progressiveReadListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveDoneListener",
                            value: function addProgressiveDoneListener(listener) {
                                this._progressiveDoneListeners.push(listener);
                            }
                        },
                        {
                            key: "onDataRange",
                            value: function onDataRange(begin, chunk) {
                                var _iterator = _createForOfIteratorHelper(this._rangeListeners), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var listener = _step.value;
                                        listener(begin, chunk);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        },
                        {
                            key: "onDataProgress",
                            value: function onDataProgress(loaded, total) {
                                var _this = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator2 = _createForOfIteratorHelper(_this._progressListeners), _step2;
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            var listener = _step2.value;
                                            listener(loaded, total);
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveRead",
                            value: function onDataProgressiveRead(chunk) {
                                var _this2 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator3 = _createForOfIteratorHelper(_this2._progressiveReadListeners), _step3;
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            var listener = _step3.value;
                                            listener(chunk);
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveDone",
                            value: function onDataProgressiveDone() {
                                var _this3 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator4 = _createForOfIteratorHelper(_this3._progressiveDoneListeners), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var listener = _step4.value;
                                            listener();
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "transportReady",
                            value: function transportReady() {
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "requestDataRange",
                            value: function requestDataRange(begin, end) {
                                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                            }
                        },
                        {
                            key: "abort",
                            value: function abort() {}
                        }
                    ]);
                    return PDFDataRangeTransport;
                }();
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                var PDFDocumentProxy = /*#__PURE__*/ function() {
                    function PDFDocumentProxy(pdfInfo, transport) {
                        var _this4 = this;
                        _classCallCheck(this, PDFDocumentProxy);
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "fingerprint", {
                            get: function get() {
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead.");
                                return this.fingerprints[0];
                            }
                        });
                        Object.defineProperty(this, "getStats", {
                            value: function() {
                                var _value = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead.");
                                                return _context2.abrupt("return", _this4.stats || {
                                                    streamTypes: {},
                                                    fontTypes: {}
                                                });
                                            case 2:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2);
                                }));
                                function value() {
                                    return _value.apply(this, arguments);
                                }
                                return value;
                            }()
                        });
                    }
                    _createClass(PDFDocumentProxy, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return this._transport.annotationStorage;
                            }
                        },
                        {
                            key: "numPages",
                            get: function get() {
                                return this._pdfInfo.numPages;
                            }
                        },
                        {
                            key: "fingerprints",
                            get: function get() {
                                return this._pdfInfo.fingerprints;
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return this._transport.stats;
                            }
                        },
                        {
                            key: "isPureXfa",
                            get: function get() {
                                return !!this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "allXfaHtml",
                            get: function get() {
                                return this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                return this._transport.getPage(pageNumber);
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                return this._transport.getPageIndex(ref);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this._transport.getDestinations();
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                return this._transport.getDestination(id);
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this._transport.getPageLabels();
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this._transport.getPageLayout();
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this._transport.getPageMode();
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this._transport.getViewerPreferences();
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this._transport.getOpenAction();
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this._transport.getAttachments();
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript() {
                                return this._transport.getJavaScript();
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._transport.getDocJSActions();
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this._transport.getOutline();
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this._transport.getOptionalContentConfig();
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this._transport.getPermissions();
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                return this._transport.getMetadata();
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this._transport.getMarkInfo();
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this._transport.getData();
                            }
                        },
                        {
                            key: "getDownloadInfo",
                            value: function getDownloadInfo() {
                                return this._transport.downloadInfoCapability.promise;
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                return this.loadingTask.destroy();
                            }
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                return this._transport.loadingParams;
                            }
                        },
                        {
                            key: "loadingTask",
                            get: function get() {
                                return this._transport.loadingTask;
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                if (this._transport.annotationStorage.size <= 0) (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                                return this._transport.saveDocument();
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return this._transport.getFieldObjects();
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return this._transport.hasJSActions();
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this._transport.getCalculationOrderIds();
                            }
                        }
                    ]);
                    return PDFDocumentProxy;
                }();
                exports.PDFDocumentProxy = PDFDocumentProxy;
                var PDFPageProxy = /*#__PURE__*/ function() {
                    function PDFPageProxy(pageIndex, pageInfo, transport, ownerDocument) {
                        var pdfBug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                        _classCallCheck(this, PDFPageProxy);
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._ownerDocument = ownerDocument;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this.cleanupAfterRender = false;
                        this.pendingCleanup = false;
                        this._intentStates = new Map();
                        this._annotationPromises = new Map();
                        this.destroyed = false;
                    }
                    _createClass(PDFPageProxy, [
                        {
                            key: "pageNumber",
                            get: function get() {
                                return this._pageIndex + 1;
                            }
                        },
                        {
                            key: "rotate",
                            get: function get() {
                                return this._pageInfo.rotate;
                            }
                        },
                        {
                            key: "ref",
                            get: function get() {
                                return this._pageInfo.ref;
                            }
                        },
                        {
                            key: "userUnit",
                            get: function get() {
                                return this._pageInfo.userUnit;
                            }
                        },
                        {
                            key: "view",
                            get: function get() {
                                return this._pageInfo.view;
                            }
                        },
                        {
                            key: "getViewport",
                            value: function getViewport() {
                                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, scale = _ref3.scale, _ref3$rotation = _ref3.rotation, rotation = _ref3$rotation === void 0 ? this.rotate : _ref3$rotation, _ref3$offsetX = _ref3.offsetX, offsetX = _ref3$offsetX === void 0 ? 0 : _ref3$offsetX, _ref3$offsetY = _ref3.offsetY, offsetY = _ref3$offsetY === void 0 ? 0 : _ref3$offsetY, _ref3$dontFlip = _ref3.dontFlip, dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
                                return new _display_utils.PageViewport({
                                    viewBox: this.view,
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations() {
                                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$intent = _ref4.intent, intent = _ref4$intent === void 0 ? "display" : _ref4$intent;
                                var intentArgs = this._transport.getRenderingIntent(intent);
                                var promise = this._annotationPromises.get(intentArgs.cacheKey);
                                if (!promise) {
                                    promise = this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                                    this._annotationPromises.set(intentArgs.cacheKey, promise);
                                    promise = promise.then(function(annotations) {
                                        var _iterator5 = _createForOfIteratorHelper(annotations), _step5;
                                        try {
                                            var _loop = function _loop() {
                                                var annotation = _step5.value;
                                                if (annotation.titleObj !== undefined) Object.defineProperty(annotation, "title", {
                                                    get: function get() {
                                                        (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead.");
                                                        return annotation.titleObj.str;
                                                    }
                                                });
                                                if (annotation.contentsObj !== undefined) Object.defineProperty(annotation, "contents", {
                                                    get: function get() {
                                                        (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead.");
                                                        return annotation.contentsObj.str;
                                                    }
                                                });
                                            };
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;)_loop();
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        return annotations;
                                    });
                                }
                                return promise;
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
                            }
                        },
                        {
                            key: "getXfa",
                            value: function() {
                                var _getXfa = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee3() {
                                    var _this$_transport$_htm;
                                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                                        while(true)switch(_context3.prev = _context3.next){
                                            case 0:
                                                return _context3.abrupt("return", ((_this$_transport$_htm = this._transport._htmlForXfa) === null || _this$_transport$_htm === void 0 ? void 0 : _this$_transport$_htm.children[this._pageIndex]) || null);
                                            case 1:
                                            case "end":
                                                return _context3.stop();
                                        }
                                    }, _callee3, this);
                                }));
                                function getXfa() {
                                    return _getXfa.apply(this, arguments);
                                }
                                return getXfa;
                            }()
                        },
                        {
                            key: "render",
                            value: function render(_ref5) {
                                var _arguments$, _arguments$2, _this5 = this, _intentState;
                                var canvasContext = _ref5.canvasContext, viewport = _ref5.viewport, _ref5$intent = _ref5.intent, intent = _ref5$intent === void 0 ? "display" : _ref5$intent, _ref5$annotationMode = _ref5.annotationMode, annotationMode = _ref5$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref5$annotationMode, _ref5$transform = _ref5.transform, transform = _ref5$transform === void 0 ? null : _ref5$transform, _ref5$imageLayer = _ref5.imageLayer, imageLayer = _ref5$imageLayer === void 0 ? null : _ref5$imageLayer, _ref5$canvasFactory = _ref5.canvasFactory, canvasFactory = _ref5$canvasFactory === void 0 ? null : _ref5$canvasFactory, _ref5$background = _ref5.background, background = _ref5$background === void 0 ? null : _ref5$background, _ref5$optionalContent = _ref5.optionalContentConfigPromise, optionalContentConfigPromise = _ref5$optionalContent === void 0 ? null : _ref5$optionalContent, _ref5$annotationCanva = _ref5.annotationCanvasMap, annotationCanvasMap = _ref5$annotationCanva === void 0 ? null : _ref5$annotationCanva;
                                if (((_arguments$ = arguments[0]) === null || _arguments$ === void 0 ? void 0 : _arguments$.renderInteractiveForms) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].renderInteractiveForms === true && annotationMode === _util.AnnotationMode.ENABLE) annotationMode = _util.AnnotationMode.ENABLE_FORMS;
                                }
                                if (((_arguments$2 = arguments[0]) === null || _arguments$2 === void 0 ? void 0 : _arguments$2.includeAnnotationStorage) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].includeAnnotationStorage === true && annotationMode === _util.AnnotationMode.ENABLE) annotationMode = _util.AnnotationMode.ENABLE_STORAGE;
                                }
                                if (this._stats) this._stats.time("Overall");
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode);
                                this.pendingCleanup = false;
                                if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                if (intentState.streamReaderCancelTimeout) {
                                    clearTimeout(intentState.streamReaderCancelTimeout);
                                    intentState.streamReaderCancelTimeout = null;
                                }
                                var canvasFactoryInstance = canvasFactory || new DefaultCanvasFactory({
                                    ownerDocument: this._ownerDocument
                                });
                                var intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                                if (!intentState.displayReadyCapability) {
                                    intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                var complete = function complete(error) {
                                    intentState.renderTasks["delete"](internalRenderTask);
                                    if (_this5.cleanupAfterRender || intentPrint) _this5.pendingCleanup = true;
                                    _this5._tryCleanup();
                                    if (error) {
                                        internalRenderTask.capability.reject(error);
                                        _this5._abortOperatorList({
                                            intentState: intentState,
                                            reason: error instanceof Error ? error : new Error(error)
                                        });
                                    } else internalRenderTask.capability.resolve();
                                    if (_this5._stats) {
                                        _this5._stats.timeEnd("Rendering");
                                        _this5._stats.timeEnd("Overall");
                                    }
                                };
                                var internalRenderTask = new InternalRenderTask({
                                    callback: complete,
                                    params: {
                                        canvasContext: canvasContext,
                                        viewport: viewport,
                                        transform: transform,
                                        imageLayer: imageLayer,
                                        background: background
                                    },
                                    objs: this.objs,
                                    commonObjs: this.commonObjs,
                                    annotationCanvasMap: annotationCanvasMap,
                                    operatorList: intentState.operatorList,
                                    pageIndex: this._pageIndex,
                                    canvasFactory: canvasFactoryInstance,
                                    useRequestAnimationFrame: !intentPrint,
                                    pdfBug: this._pdfBug
                                });
                                ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
                                var renderTask = internalRenderTask.task;
                                Promise.all([
                                    intentState.displayReadyCapability.promise,
                                    optionalContentConfigPromise
                                ]).then(function(_ref6) {
                                    var _ref7 = _slicedToArray(_ref6, 2), transparency = _ref7[0], optionalContentConfig = _ref7[1];
                                    if (_this5.pendingCleanup) {
                                        complete();
                                        return;
                                    }
                                    if (_this5._stats) _this5._stats.time("Rendering");
                                    internalRenderTask.initializeGraphics({
                                        transparency: transparency,
                                        optionalContentConfig: optionalContentConfig
                                    });
                                    internalRenderTask.operatorListChanged();
                                })["catch"](complete);
                                return renderTask;
                            }
                        },
                        {
                            key: "getOperatorList",
                            value: function getOperatorList() {
                                var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref8$intent = _ref8.intent, intent = _ref8$intent === void 0 ? "display" : _ref8$intent, _ref8$annotationMode = _ref8.annotationMode, annotationMode = _ref8$annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref8$annotationMode;
                                function operatorListChanged() {
                                    if (intentState.operatorList.lastChunk) {
                                        intentState.opListReadCapability.resolve(intentState.operatorList);
                                        intentState.renderTasks["delete"](opListTask);
                                    }
                                }
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, true);
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                var opListTask;
                                if (!intentState.opListReadCapability) {
                                    var _intentState2;
                                    opListTask = Object.create(null);
                                    opListTask.operatorListChanged = operatorListChanged;
                                    intentState.opListReadCapability = (0, _util.createPromiseCapability)();
                                    ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = new Set())).add(opListTask);
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                return intentState.opListReadCapability.promise;
                            }
                        },
                        {
                            key: "streamTextContent",
                            value: function streamTextContent() {
                                var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref9$normalizeWhites = _ref9.normalizeWhitespace, normalizeWhitespace = _ref9$normalizeWhites === void 0 ? false : _ref9$normalizeWhites, _ref9$disableCombineT = _ref9.disableCombineTextItems, disableCombineTextItems = _ref9$disableCombineT === void 0 ? false : _ref9$disableCombineT, _ref9$includeMarkedCo = _ref9.includeMarkedContent, includeMarkedContent = _ref9$includeMarkedCo === void 0 ? false : _ref9$includeMarkedCo;
                                var TEXT_CONTENT_CHUNK_SIZE = 100;
                                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                                    pageIndex: this._pageIndex,
                                    normalizeWhitespace: normalizeWhitespace === true,
                                    combineTextItems: disableCombineTextItems !== true,
                                    includeMarkedContent: includeMarkedContent === true
                                }, {
                                    highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                                    size: function size(textContent) {
                                        return textContent.items.length;
                                    }
                                });
                            }
                        },
                        {
                            key: "getTextContent",
                            value: function getTextContent() {
                                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (this._transport._htmlForXfa) return this.getXfa().then(function(xfa) {
                                    return _xfa_text.XfaText.textContent(xfa);
                                });
                                var readableStream = this.streamTextContent(params);
                                return new Promise(function(resolve, reject) {
                                    function pump() {
                                        reader.read().then(function(_ref10) {
                                            var _textContent$items;
                                            var value = _ref10.value, done = _ref10.done;
                                            if (done) {
                                                resolve(textContent);
                                                return;
                                            }
                                            Object.assign(textContent.styles, value.styles);
                                            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
                                            pump();
                                        }, reject);
                                    }
                                    var reader = readableStream.getReader();
                                    var textContent = {
                                        items: [],
                                        styles: Object.create(null)
                                    };
                                    pump();
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree() {
                                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
                            }
                        },
                        {
                            key: "_destroy",
                            value: function _destroy() {
                                this.destroyed = true;
                                var waitOn = [];
                                var _iterator6 = _createForOfIteratorHelper(this._intentStates.values()), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var intentState = _step6.value;
                                        this._abortOperatorList({
                                            intentState: intentState,
                                            reason: new Error("Page was destroyed."),
                                            force: true
                                        });
                                        if (intentState.opListReadCapability) continue;
                                        var _iterator7 = _createForOfIteratorHelper(intentState.renderTasks), _step7;
                                        try {
                                            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                var internalRenderTask = _step7.value;
                                                waitOn.push(internalRenderTask.completed);
                                                internalRenderTask.cancel();
                                            }
                                        } catch (err) {
                                            _iterator7.e(err);
                                        } finally{
                                            _iterator7.f();
                                        }
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                this.pendingCleanup = false;
                                return Promise.all(waitOn);
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                this.pendingCleanup = true;
                                return this._tryCleanup(resetStats);
                            }
                        },
                        {
                            key: "_tryCleanup",
                            value: function _tryCleanup() {
                                var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.pendingCleanup) return false;
                                var _iterator8 = _createForOfIteratorHelper(this._intentStates.values()), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _step8$value = _step8.value, renderTasks = _step8$value.renderTasks, operatorList = _step8$value.operatorList;
                                        if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                                this._intentStates.clear();
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                if (resetStats && this._stats) this._stats = new _display_utils.StatTimer();
                                this.pendingCleanup = false;
                                return true;
                            }
                        },
                        {
                            key: "_startRenderPage",
                            value: function _startRenderPage(transparency, cacheKey) {
                                var intentState = this._intentStates.get(cacheKey);
                                if (!intentState) return;
                                if (this._stats) this._stats.timeEnd("Page Request");
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.resolve(transparency);
                            }
                        },
                        {
                            key: "_renderPageChunk",
                            value: function _renderPageChunk(operatorListChunk, intentState) {
                                for(var i = 0, ii = operatorListChunk.length; i < ii; i++){
                                    intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                                    intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                                }
                                intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                                var _iterator9 = _createForOfIteratorHelper(intentState.renderTasks), _step9;
                                try {
                                    for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                                        var internalRenderTask = _step9.value;
                                        internalRenderTask.operatorListChanged();
                                    }
                                } catch (err) {
                                    _iterator9.e(err);
                                } finally{
                                    _iterator9.f();
                                }
                                if (operatorListChunk.lastChunk) this._tryCleanup();
                            }
                        },
                        {
                            key: "_pumpOperatorList",
                            value: function _pumpOperatorList(_ref11) {
                                var _this6 = this;
                                var renderingIntent = _ref11.renderingIntent, cacheKey = _ref11.cacheKey;
                                var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                                    pageIndex: this._pageIndex,
                                    intent: renderingIntent,
                                    cacheKey: cacheKey,
                                    annotationStorage: renderingIntent & _util.RenderingIntentFlag.ANNOTATIONS_STORAGE ? this._transport.annotationStorage.serializable : null
                                });
                                var reader = readableStream.getReader();
                                var intentState = this._intentStates.get(cacheKey);
                                intentState.streamReader = reader;
                                var pump = function pump() {
                                    reader.read().then(function(_ref12) {
                                        var value = _ref12.value, done = _ref12.done;
                                        if (done) {
                                            intentState.streamReader = null;
                                            return;
                                        }
                                        if (_this6._transport.destroyed) return;
                                        _this6._renderPageChunk(value, intentState);
                                        pump();
                                    }, function(reason) {
                                        intentState.streamReader = null;
                                        if (_this6._transport.destroyed) return;
                                        if (intentState.operatorList) {
                                            intentState.operatorList.lastChunk = true;
                                            var _iterator10 = _createForOfIteratorHelper(intentState.renderTasks), _step10;
                                            try {
                                                for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                                                    var internalRenderTask = _step10.value;
                                                    internalRenderTask.operatorListChanged();
                                                }
                                            } catch (err) {
                                                _iterator10.e(err);
                                            } finally{
                                                _iterator10.f();
                                            }
                                            _this6._tryCleanup();
                                        }
                                        if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                        else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                        else throw reason;
                                    });
                                };
                                pump();
                            }
                        },
                        {
                            key: "_abortOperatorList",
                            value: function _abortOperatorList(_ref13) {
                                var _this7 = this;
                                var intentState = _ref13.intentState, reason = _ref13.reason, _ref13$force = _ref13.force, force = _ref13$force === void 0 ? false : _ref13$force;
                                if (!intentState.streamReader) return;
                                if (!force) {
                                    if (intentState.renderTasks.size > 0) return;
                                    if (reason instanceof _display_utils.RenderingCancelledException) {
                                        intentState.streamReaderCancelTimeout = setTimeout(function() {
                                            _this7._abortOperatorList({
                                                intentState: intentState,
                                                reason: reason,
                                                force: true
                                            });
                                            intentState.streamReaderCancelTimeout = null;
                                        }, RENDERING_CANCELLED_TIMEOUT);
                                        return;
                                    }
                                }
                                intentState.streamReader.cancel(new _util.AbortException(reason.message))["catch"](function() {});
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                var _iterator11 = _createForOfIteratorHelper(this._intentStates), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var _step11$value = _slicedToArray(_step11.value, 2), curCacheKey = _step11$value[0], curIntentState = _step11$value[1];
                                        if (curIntentState === intentState) {
                                            this._intentStates["delete"](curCacheKey);
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator11.e(err);
                                } finally{
                                    _iterator11.f();
                                }
                                this.cleanup();
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return this._stats;
                            }
                        }
                    ]);
                    return PDFPageProxy;
                }();
                exports.PDFPageProxy = PDFPageProxy;
                var LoopbackPort = /*#__PURE__*/ function() {
                    function LoopbackPort() {
                        _classCallCheck(this, LoopbackPort);
                        this._listeners = [];
                        this._deferred = Promise.resolve();
                    }
                    _createClass(LoopbackPort, [
                        {
                            key: "postMessage",
                            value: function postMessage(obj, transfers) {
                                var _this8 = this;
                                function cloneValue(object) {
                                    if (globalThis.structuredClone) return globalThis.structuredClone(object, transfers);
                                    function fallbackCloneValue(value) {
                                        if (typeof value === "function" || _typeof(value) === "symbol" || value instanceof URL) throw new Error("LoopbackPort.postMessage - cannot clone: ".concat(value === null || value === void 0 ? void 0 : value.toString()));
                                        if (_typeof(value) !== "object" || value === null) return value;
                                        if (cloned.has(value)) return cloned.get(value);
                                        var buffer, result;
                                        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
                                            if (transfers !== null && transfers !== void 0 && transfers.includes(buffer)) result = new value.constructor(buffer, value.byteOffset, value.byteLength);
                                            else result = new value.constructor(value);
                                            cloned.set(value, result);
                                            return result;
                                        }
                                        if (value instanceof Map) {
                                            result = new Map();
                                            cloned.set(value, result);
                                            var _iterator12 = _createForOfIteratorHelper(value), _step12;
                                            try {
                                                for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                                                    var _step12$value = _slicedToArray(_step12.value, 2), key = _step12$value[0], val = _step12$value[1];
                                                    result.set(key, fallbackCloneValue(val));
                                                }
                                            } catch (err) {
                                                _iterator12.e(err);
                                            } finally{
                                                _iterator12.f();
                                            }
                                            return result;
                                        }
                                        if (value instanceof Set) {
                                            result = new Set();
                                            cloned.set(value, result);
                                            var _iterator13 = _createForOfIteratorHelper(value), _step13;
                                            try {
                                                for(_iterator13.s(); !(_step13 = _iterator13.n()).done;){
                                                    var _val = _step13.value;
                                                    result.add(fallbackCloneValue(_val));
                                                }
                                            } catch (err) {
                                                _iterator13.e(err);
                                            } finally{
                                                _iterator13.f();
                                            }
                                            return result;
                                        }
                                        result = Array.isArray(value) ? [] : Object.create(null);
                                        cloned.set(value, result);
                                        for(var i in value){
                                            var _value$hasOwnProperty;
                                            var desc = void 0, p = value;
                                            while(!(desc = Object.getOwnPropertyDescriptor(p, i)))p = Object.getPrototypeOf(p);
                                            if (typeof desc.value === "undefined") continue;
                                            if (typeof desc.value === "function" && !((_value$hasOwnProperty = value.hasOwnProperty) !== null && _value$hasOwnProperty !== void 0 && _value$hasOwnProperty.call(value, i))) continue;
                                            result[i] = fallbackCloneValue(desc.value);
                                        }
                                        return result;
                                    }
                                    var cloned = new WeakMap();
                                    return fallbackCloneValue(object);
                                }
                                var event = {
                                    data: cloneValue(obj)
                                };
                                this._deferred.then(function() {
                                    var _iterator14 = _createForOfIteratorHelper(_this8._listeners), _step14;
                                    try {
                                        for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                                            var listener = _step14.value;
                                            listener.call(_this8, event);
                                        }
                                    } catch (err) {
                                        _iterator14.e(err);
                                    } finally{
                                        _iterator14.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "addEventListener",
                            value: function addEventListener(name, listener) {
                                this._listeners.push(listener);
                            }
                        },
                        {
                            key: "removeEventListener",
                            value: function removeEventListener(name, listener) {
                                var i = this._listeners.indexOf(listener);
                                this._listeners.splice(i, 1);
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate() {
                                this._listeners.length = 0;
                            }
                        }
                    ]);
                    return LoopbackPort;
                }();
                exports.LoopbackPort = LoopbackPort;
                var PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                if (_is_node.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
                    var _document, _document$currentScri;
                    var pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document$currentScri = _document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    var wrapper = "importScripts(\"".concat(url, "\");");
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                var PDFWorker = /*#__PURE__*/ function() {
                    function PDFWorker() {
                        var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref14$name = _ref14.name, name = _ref14$name === void 0 ? null : _ref14$name, _ref14$port = _ref14.port, port = _ref14$port === void 0 ? null : _ref14$port, _ref14$verbosity = _ref14.verbosity, verbosity = _ref14$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref14$verbosity;
                        _classCallCheck(this, PDFWorker);
                        if (port && PDFWorker._workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = (0, _util.createPromiseCapability)();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            PDFWorker._workerPorts.set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    _createClass(PDFWorker, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._readyCapability.promise;
                            }
                        },
                        {
                            key: "port",
                            get: function get() {
                                return this._port;
                            }
                        },
                        {
                            key: "messageHandler",
                            get: function get() {
                                return this._messageHandler;
                            }
                        },
                        {
                            key: "_initializeFromPort",
                            value: function _initializeFromPort(port) {
                                this._port = port;
                                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                                this._messageHandler.on("ready", function() {});
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "_initialize",
                            value: function _initialize() {
                                var _this9 = this;
                                if (typeof Worker !== "undefined" && !PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                                    var workerSrc = PDFWorker.workerSrc;
                                    try {
                                        if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                        var worker = new Worker(workerSrc);
                                        var messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                        var terminateEarly = function terminateEarly() {
                                            worker.removeEventListener("error", onWorkerError);
                                            messageHandler.destroy();
                                            worker.terminate();
                                            if (_this9.destroyed) _this9._readyCapability.reject(new Error("Worker was destroyed"));
                                            else _this9._setupFakeWorker();
                                        };
                                        var onWorkerError = function onWorkerError() {
                                            if (!_this9._webWorker) terminateEarly();
                                        };
                                        worker.addEventListener("error", onWorkerError);
                                        messageHandler.on("test", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this9.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            if (data) {
                                                _this9._messageHandler = messageHandler;
                                                _this9._port = worker;
                                                _this9._webWorker = worker;
                                                _this9._readyCapability.resolve();
                                                messageHandler.send("configure", {
                                                    verbosity: _this9.verbosity
                                                });
                                            } else {
                                                _this9._setupFakeWorker();
                                                messageHandler.destroy();
                                                worker.terminate();
                                            }
                                        });
                                        messageHandler.on("ready", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this9.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            try {
                                                sendTest();
                                            } catch (e) {
                                                _this9._setupFakeWorker();
                                            }
                                        });
                                        var sendTest = function sendTest() {
                                            var testObj = new Uint8Array([
                                                255
                                            ]);
                                            try {
                                                messageHandler.send("test", testObj, [
                                                    testObj.buffer
                                                ]);
                                            } catch (ex) {
                                                (0, _util.warn)("Cannot use postMessage transfers.");
                                                testObj[0] = 0;
                                                messageHandler.send("test", testObj);
                                            }
                                        };
                                        sendTest();
                                        return;
                                    } catch (e) {
                                        (0, _util.info)("The worker has been disabled.");
                                    }
                                }
                                this._setupFakeWorker();
                            }
                        },
                        {
                            key: "_setupFakeWorker",
                            value: function _setupFakeWorker() {
                                var _this10 = this;
                                if (!PDFWorkerUtil.isWorkerDisabled) {
                                    (0, _util.warn)("Setting up fake worker.");
                                    PDFWorkerUtil.isWorkerDisabled = true;
                                }
                                PDFWorker._setupFakeWorkerGlobal.then(function(WorkerMessageHandler) {
                                    if (_this10.destroyed) {
                                        _this10._readyCapability.reject(new Error("Worker was destroyed"));
                                        return;
                                    }
                                    var port = new LoopbackPort();
                                    _this10._port = port;
                                    var id = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
                                    var workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                                    WorkerMessageHandler.setup(workerHandler, port);
                                    var messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                                    _this10._messageHandler = messageHandler;
                                    _this10._readyCapability.resolve();
                                    messageHandler.send("configure", {
                                        verbosity: _this10.verbosity
                                    });
                                })["catch"](function(reason) {
                                    _this10._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.destroyed = true;
                                if (this._webWorker) {
                                    this._webWorker.terminate();
                                    this._webWorker = null;
                                }
                                PDFWorker._workerPorts["delete"](this._port);
                                this._port = null;
                                if (this._messageHandler) {
                                    this._messageHandler.destroy();
                                    this._messageHandler = null;
                                }
                            }
                        }
                    ], [
                        {
                            key: "_workerPorts",
                            get: function get() {
                                return (0, _util.shadow)(this, "_workerPorts", new WeakMap());
                            }
                        },
                        {
                            key: "fromPort",
                            value: function fromPort(params) {
                                if (!(params !== null && params !== void 0 && params.port)) throw new Error("PDFWorker.fromPort - invalid method signature.");
                                if (this._workerPorts.has(params.port)) return this._workerPorts.get(params.port);
                                return new PDFWorker(params);
                            }
                        },
                        {
                            key: "workerSrc",
                            get: function get() {
                                if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                                    if (!_is_node.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                                    return PDFWorkerUtil.fallbackWorkerSrc;
                                }
                                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                            }
                        },
                        {
                            key: "_mainThreadWorkerMessageHandler",
                            get: function get() {
                                try {
                                    var _globalThis$pdfjsWork;
                                    return ((_globalThis$pdfjsWork = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork === void 0 ? void 0 : _globalThis$pdfjsWork.WorkerMessageHandler) || null;
                                } catch (ex) {
                                    return null;
                                }
                            }
                        },
                        {
                            key: "_setupFakeWorkerGlobal",
                            get: function get() {
                                var _this11 = this;
                                var loader = /*#__PURE__*/ function() {
                                    var _ref15 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee4() {
                                        var mainWorkerMessageHandler, worker;
                                        return _regenerator["default"].wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    mainWorkerMessageHandler = _this11._mainThreadWorkerMessageHandler;
                                                    if (!mainWorkerMessageHandler) {
                                                        _context4.next = 3;
                                                        break;
                                                    }
                                                    return _context4.abrupt("return", mainWorkerMessageHandler);
                                                case 3:
                                                    if (!(_is_node.isNodeJS && true)) {
                                                        _context4.next = 6;
                                                        break;
                                                    }
                                                    worker = eval("require")(_this11.workerSrc);
                                                    return _context4.abrupt("return", worker.WorkerMessageHandler);
                                                case 6:
                                                    _context4.next = 8;
                                                    return (0, _display_utils.loadScript)(_this11.workerSrc);
                                                case 8:
                                                    return _context4.abrupt("return", window.pdfjsWorker.WorkerMessageHandler);
                                                case 9:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function loader() {
                                        return _ref15.apply(this, arguments);
                                    };
                                }();
                                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                            }
                        }
                    ]);
                    return PDFWorker;
                }();
                exports.PDFWorker = PDFWorker;
                PDFWorker.getWorkerSrc = function() {
                    (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead.");
                    return this.workerSrc;
                };
                var _docStats = /*#__PURE__*/ new WeakMap();
                var _pageCache = /*#__PURE__*/ new WeakMap();
                var _pagePromises = /*#__PURE__*/ new WeakMap();
                var _metadataPromise = /*#__PURE__*/ new WeakMap();
                var WorkerTransport = /*#__PURE__*/ function() {
                    function WorkerTransport(messageHandler, loadingTask, networkStream, params) {
                        _classCallCheck(this, WorkerTransport);
                        _classPrivateFieldInitSpec(this, _docStats, {
                            writable: true,
                            value: null
                        });
                        _classPrivateFieldInitSpec(this, _pageCache, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _pagePromises, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _metadataPromise, {
                            writable: true,
                            value: null
                        });
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            docId: loadingTask.docId,
                            onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        if (!params.useWorkerFetch) {
                            this.CMapReaderFactory = new params.CMapReaderFactory({
                                baseUrl: params.cMapUrl,
                                isCompressed: params.cMapPacked
                            });
                            this.StandardFontDataFactory = new params.StandardFontDataFactory({
                                baseUrl: params.standardFontDataUrl
                            });
                        }
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._passwordCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = (0, _util.createPromiseCapability)();
                        this.setupMessageHandler();
                    }
                    _createClass(WorkerTransport, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return _classPrivateFieldGet(this, _docStats);
                            }
                        },
                        {
                            key: "getRenderingIntent",
                            value: function getRenderingIntent(intent) {
                                var annotationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.AnnotationMode.ENABLE;
                                var isOpList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                var renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                                var lastModified = "";
                                switch(intent){
                                    case "any":
                                        renderingIntent = _util.RenderingIntentFlag.ANY;
                                        break;
                                    case "display":
                                        break;
                                    case "print":
                                        renderingIntent = _util.RenderingIntentFlag.PRINT;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent));
                                }
                                switch(annotationMode){
                                    case _util.AnnotationMode.DISABLE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                        break;
                                    case _util.AnnotationMode.ENABLE:
                                        break;
                                    case _util.AnnotationMode.ENABLE_FORMS:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                        break;
                                    case _util.AnnotationMode.ENABLE_STORAGE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                        lastModified = this.annotationStorage.lastModified;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
                                }
                                if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                                return {
                                    renderingIntent: renderingIntent,
                                    cacheKey: "".concat(renderingIntent, "_").concat(lastModified)
                                };
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this12 = this;
                                if (this.destroyCapability) return this.destroyCapability.promise;
                                this.destroyed = true;
                                this.destroyCapability = (0, _util.createPromiseCapability)();
                                if (this._passwordCapability) this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                                var waitOn = [];
                                var _iterator15 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values()), _step15;
                                try {
                                    for(_iterator15.s(); !(_step15 = _iterator15.n()).done;){
                                        var page = _step15.value;
                                        waitOn.push(page._destroy());
                                    }
                                } catch (err) {
                                    _iterator15.e(err);
                                } finally{
                                    _iterator15.f();
                                }
                                _classPrivateFieldGet(this, _pageCache).clear();
                                _classPrivateFieldGet(this, _pagePromises).clear();
                                if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                                var terminated = this.messageHandler.sendWithPromise("Terminate", null);
                                waitOn.push(terminated);
                                Promise.all(waitOn).then(function() {
                                    _this12.commonObjs.clear();
                                    _this12.fontLoader.clear();
                                    _classPrivateFieldSet(_this12, _metadataPromise, null);
                                    _this12._getFieldObjectsPromise = null;
                                    _this12._hasJSActionsPromise = null;
                                    if (_this12._networkStream) _this12._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                                    if (_this12.messageHandler) {
                                        _this12.messageHandler.destroy();
                                        _this12.messageHandler = null;
                                    }
                                    _this12.destroyCapability.resolve();
                                }, this.destroyCapability.reject);
                                return this.destroyCapability.promise;
                            }
                        },
                        {
                            key: "setupMessageHandler",
                            value: function setupMessageHandler() {
                                var _this13 = this;
                                var messageHandler = this.messageHandler, loadingTask = this.loadingTask;
                                messageHandler.on("GetReader", function(data, sink) {
                                    (0, _util.assert)(_this13._networkStream, "GetReader - no `IPDFStream` instance available.");
                                    _this13._fullReader = _this13._networkStream.getFullReader();
                                    _this13._fullReader.onProgress = function(evt) {
                                        _this13._lastProgress = {
                                            loaded: evt.loaded,
                                            total: evt.total
                                        };
                                    };
                                    sink.onPull = function() {
                                        _this13._fullReader.read().then(function(_ref16) {
                                            var value = _ref16.value, done = _ref16.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        })["catch"](function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        _this13._fullReader.cancel(reason);
                                        sink.ready["catch"](function(readyReason) {
                                            if (_this13.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("ReaderHeadersReady", function(data) {
                                    var headersCapability = (0, _util.createPromiseCapability)();
                                    var fullReader = _this13._fullReader;
                                    fullReader.headersReady.then(function() {
                                        if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                            if (_this13._lastProgress) {
                                                var _loadingTask$onProgre;
                                                (_loadingTask$onProgre = loadingTask.onProgress) === null || _loadingTask$onProgre === void 0 || _loadingTask$onProgre.call(loadingTask, _this13._lastProgress);
                                            }
                                            fullReader.onProgress = function(evt) {
                                                var _loadingTask$onProgre2;
                                                (_loadingTask$onProgre2 = loadingTask.onProgress) === null || _loadingTask$onProgre2 === void 0 || _loadingTask$onProgre2.call(loadingTask, {
                                                    loaded: evt.loaded,
                                                    total: evt.total
                                                });
                                            };
                                        }
                                        headersCapability.resolve({
                                            isStreamingSupported: fullReader.isStreamingSupported,
                                            isRangeSupported: fullReader.isRangeSupported,
                                            contentLength: fullReader.contentLength
                                        });
                                    }, headersCapability.reject);
                                    return headersCapability.promise;
                                });
                                messageHandler.on("GetRangeReader", function(data, sink) {
                                    (0, _util.assert)(_this13._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                                    var rangeReader = _this13._networkStream.getRangeReader(data.begin, data.end);
                                    if (!rangeReader) {
                                        sink.close();
                                        return;
                                    }
                                    sink.onPull = function() {
                                        rangeReader.read().then(function(_ref17) {
                                            var value = _ref17.value, done = _ref17.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetRangeReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        })["catch"](function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        rangeReader.cancel(reason);
                                        sink.ready["catch"](function(readyReason) {
                                            if (_this13.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("GetDoc", function(_ref18) {
                                    var pdfInfo = _ref18.pdfInfo;
                                    _this13._numPages = pdfInfo.numPages;
                                    _this13._htmlForXfa = pdfInfo.htmlForXfa;
                                    delete pdfInfo.htmlForXfa;
                                    loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this13));
                                });
                                messageHandler.on("DocException", function(ex) {
                                    var reason;
                                    switch(ex.name){
                                        case "PasswordException":
                                            reason = new _util.PasswordException(ex.message, ex.code);
                                            break;
                                        case "InvalidPDFException":
                                            reason = new _util.InvalidPDFException(ex.message);
                                            break;
                                        case "MissingPDFException":
                                            reason = new _util.MissingPDFException(ex.message);
                                            break;
                                        case "UnexpectedResponseException":
                                            reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                            break;
                                        case "UnknownErrorException":
                                            reason = new _util.UnknownErrorException(ex.message, ex.details);
                                            break;
                                        default:
                                            (0, _util.unreachable)("DocException - expected a valid Error.");
                                    }
                                    loadingTask._capability.reject(reason);
                                });
                                messageHandler.on("PasswordRequest", function(exception) {
                                    _this13._passwordCapability = (0, _util.createPromiseCapability)();
                                    if (loadingTask.onPassword) {
                                        var updatePassword = function updatePassword(password) {
                                            _this13._passwordCapability.resolve({
                                                password: password
                                            });
                                        };
                                        try {
                                            loadingTask.onPassword(updatePassword, exception.code);
                                        } catch (ex) {
                                            _this13._passwordCapability.reject(ex);
                                        }
                                    } else _this13._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                                    return _this13._passwordCapability.promise;
                                });
                                messageHandler.on("DataLoaded", function(data) {
                                    var _loadingTask$onProgre3;
                                    (_loadingTask$onProgre3 = loadingTask.onProgress) === null || _loadingTask$onProgre3 === void 0 || _loadingTask$onProgre3.call(loadingTask, {
                                        loaded: data.length,
                                        total: data.length
                                    });
                                    _this13.downloadInfoCapability.resolve(data);
                                });
                                messageHandler.on("StartRenderPage", function(data) {
                                    if (_this13.destroyed) return;
                                    var page = _classPrivateFieldGet(_this13, _pageCache).get(data.pageIndex);
                                    page._startRenderPage(data.transparency, data.cacheKey);
                                });
                                messageHandler.on("commonobj", function(_ref19) {
                                    var _globalThis$FontInspe;
                                    var _ref20 = _slicedToArray(_ref19, 3), id = _ref20[0], type = _ref20[1], exportedData = _ref20[2];
                                    if (_this13.destroyed) return;
                                    if (_this13.commonObjs.has(id)) return;
                                    switch(type){
                                        case "Font":
                                            var params = _this13._params;
                                            if ("error" in exportedData) {
                                                var exportedError = exportedData.error;
                                                (0, _util.warn)("Error during font loading: ".concat(exportedError));
                                                _this13.commonObjs.resolve(id, exportedError);
                                                break;
                                            }
                                            var fontRegistry = null;
                                            if (params.pdfBug && (_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled) fontRegistry = {
                                                registerFont: function registerFont(font, url) {
                                                    globalThis.FontInspector.fontAdded(font, url);
                                                }
                                            };
                                            var font = new _font_loader.FontFaceObject(exportedData, {
                                                isEvalSupported: params.isEvalSupported,
                                                disableFontFace: params.disableFontFace,
                                                ignoreErrors: params.ignoreErrors,
                                                onUnsupportedFeature: _this13._onUnsupportedFeature.bind(_this13),
                                                fontRegistry: fontRegistry
                                            });
                                            _this13.fontLoader.bind(font)["catch"](function(reason) {
                                                return messageHandler.sendWithPromise("FontFallback", {
                                                    id: id
                                                });
                                            })["finally"](function() {
                                                if (!params.fontExtraProperties && font.data) font.data = null;
                                                _this13.commonObjs.resolve(id, font);
                                            });
                                            break;
                                        case "FontPath":
                                        case "Image":
                                            _this13.commonObjs.resolve(id, exportedData);
                                            break;
                                        default:
                                            throw new Error("Got unknown common object type ".concat(type));
                                    }
                                });
                                messageHandler.on("obj", function(_ref21) {
                                    var _imageData$data;
                                    var _ref22 = _slicedToArray(_ref21, 4), id = _ref22[0], pageIndex = _ref22[1], type = _ref22[2], imageData = _ref22[3];
                                    if (_this13.destroyed) return;
                                    var pageProxy = _classPrivateFieldGet(_this13, _pageCache).get(pageIndex);
                                    if (pageProxy.objs.has(id)) return;
                                    switch(type){
                                        case "Image":
                                            pageProxy.objs.resolve(id, imageData);
                                            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
                                            if ((imageData === null || imageData === void 0 ? void 0 : (_imageData$data = imageData.data) === null || _imageData$data === void 0 ? void 0 : _imageData$data.length) > MAX_IMAGE_SIZE_TO_STORE) pageProxy.cleanupAfterRender = true;
                                            break;
                                        case "Pattern":
                                            pageProxy.objs.resolve(id, imageData);
                                            break;
                                        default:
                                            throw new Error("Got unknown object type ".concat(type));
                                    }
                                });
                                messageHandler.on("DocProgress", function(data) {
                                    var _loadingTask$onProgre4;
                                    if (_this13.destroyed) return;
                                    (_loadingTask$onProgre4 = loadingTask.onProgress) === null || _loadingTask$onProgre4 === void 0 || _loadingTask$onProgre4.call(loadingTask, {
                                        loaded: data.loaded,
                                        total: data.total
                                    });
                                });
                                messageHandler.on("DocStats", function(data) {
                                    if (_this13.destroyed) return;
                                    _classPrivateFieldSet(_this13, _docStats, Object.freeze({
                                        streamTypes: Object.freeze(data.streamTypes),
                                        fontTypes: Object.freeze(data.fontTypes)
                                    }));
                                });
                                messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
                                messageHandler.on("FetchBuiltInCMap", function(data) {
                                    if (_this13.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this13.CMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this13.CMapReaderFactory.fetch(data);
                                });
                                messageHandler.on("FetchStandardFontData", function(data) {
                                    if (_this13.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this13.StandardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this13.StandardFontDataFactory.fetch(data);
                                });
                            }
                        },
                        {
                            key: "_onUnsupportedFeature",
                            value: function _onUnsupportedFeature(_ref23) {
                                var _this$loadingTask$onU, _this$loadingTask;
                                var featureId = _ref23.featureId;
                                if (this.destroyed) return;
                                (_this$loadingTask$onU = (_this$loadingTask = this.loadingTask).onUnsupportedFeature) === null || _this$loadingTask$onU === void 0 || _this$loadingTask$onU.call(_this$loadingTask, featureId);
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this.messageHandler.sendWithPromise("GetData", null);
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                var _this14 = this;
                                if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request"));
                                var pageIndex = pageNumber - 1, cachedPromise = _classPrivateFieldGet(this, _pagePromises).get(pageIndex);
                                if (cachedPromise) return cachedPromise;
                                var promise = this.messageHandler.sendWithPromise("GetPage", {
                                    pageIndex: pageIndex
                                }).then(function(pageInfo) {
                                    if (_this14.destroyed) throw new Error("Transport destroyed");
                                    var page = new PDFPageProxy(pageIndex, pageInfo, _this14, _this14._params.ownerDocument, _this14._params.pdfBug);
                                    _classPrivateFieldGet(_this14, _pageCache).set(pageIndex, page);
                                    return page;
                                });
                                _classPrivateFieldGet(this, _pagePromises).set(pageIndex, promise);
                                return promise;
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                return this.messageHandler.sendWithPromise("GetPageIndex", {
                                    ref: ref
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations(pageIndex, intent) {
                                return this.messageHandler.sendWithPromise("GetAnnotations", {
                                    pageIndex: pageIndex,
                                    intent: intent
                                });
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                var _this$_fullReader$fil, _this$_fullReader, _this15 = this;
                                return this.messageHandler.sendWithPromise("SaveDocument", {
                                    isPureXfa: !!this._htmlForXfa,
                                    numPages: this._numPages,
                                    annotationStorage: this.annotationStorage.serializable,
                                    filename: (_this$_fullReader$fil = (_this$_fullReader = this._fullReader) === null || _this$_fullReader === void 0 ? void 0 : _this$_fullReader.filename) !== null && _this$_fullReader$fil !== void 0 ? _this$_fullReader$fil : null
                                })["finally"](function() {
                                    _this15.annotationStorage.resetModified();
                                });
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this.messageHandler.sendWithPromise("GetDestinations", null);
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                                return this.messageHandler.sendWithPromise("GetDestination", {
                                    id: id
                                });
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this.messageHandler.sendWithPromise("GetPageLabels", null);
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this.messageHandler.sendWithPromise("GetPageLayout", null);
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this.messageHandler.sendWithPromise("GetPageMode", null);
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this.messageHandler.sendWithPromise("GetOpenAction", null);
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this.messageHandler.sendWithPromise("GetAttachments", null);
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript() {
                                return this.messageHandler.sendWithPromise("GetJavaScript", null);
                            }
                        },
                        {
                            key: "getDocJSActions",
                            value: function getDocJSActions() {
                                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
                            }
                        },
                        {
                            key: "getPageJSActions",
                            value: function getPageJSActions(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetStructTree", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this.messageHandler.sendWithPromise("GetOutline", null);
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function(results) {
                                    return new _optional_content_config.OptionalContentConfig(results);
                                });
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this.messageHandler.sendWithPromise("GetPermissions", null);
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                var _this16 = this;
                                return _classPrivateFieldGet(this, _metadataPromise) || _classPrivateFieldSet(this, _metadataPromise, this.messageHandler.sendWithPromise("GetMetadata", null).then(function(results) {
                                    var _this16$_fullReader$f, _this16$_fullReader, _this16$_fullReader$c, _this16$_fullReader2;
                                    return {
                                        info: results[0],
                                        metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                        contentDispositionFilename: (_this16$_fullReader$f = (_this16$_fullReader = _this16._fullReader) === null || _this16$_fullReader === void 0 ? void 0 : _this16$_fullReader.filename) !== null && _this16$_fullReader$f !== void 0 ? _this16$_fullReader$f : null,
                                        contentLength: (_this16$_fullReader$c = (_this16$_fullReader2 = _this16._fullReader) === null || _this16$_fullReader2 === void 0 ? void 0 : _this16$_fullReader2.contentLength) !== null && _this16$_fullReader$c !== void 0 ? _this16$_fullReader$c : null
                                    };
                                }));
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                            }
                        },
                        {
                            key: "startCleanup",
                            value: function() {
                                var _startCleanup = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee5() {
                                    var keepLoadedFonts, _iterator16, _step16, page, cleanupSuccessful, _args5 = arguments;
                                    return _regenerator["default"].wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                keepLoadedFonts = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
                                                _context5.next = 3;
                                                return this.messageHandler.sendWithPromise("Cleanup", null);
                                            case 3:
                                                if (!this.destroyed) {
                                                    _context5.next = 5;
                                                    break;
                                                }
                                                return _context5.abrupt("return");
                                            case 5:
                                                _iterator16 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values());
                                                _context5.prev = 6;
                                                _iterator16.s();
                                            case 8:
                                                if ((_step16 = _iterator16.n()).done) {
                                                    _context5.next = 15;
                                                    break;
                                                }
                                                page = _step16.value;
                                                cleanupSuccessful = page.cleanup();
                                                if (cleanupSuccessful) {
                                                    _context5.next = 13;
                                                    break;
                                                }
                                                throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                                            case 13:
                                                _context5.next = 8;
                                                break;
                                            case 15:
                                                _context5.next = 20;
                                                break;
                                            case 17:
                                                _context5.prev = 17;
                                                _context5.t0 = _context5["catch"](6);
                                                _iterator16.e(_context5.t0);
                                            case 20:
                                                _context5.prev = 20;
                                                _iterator16.f();
                                                return _context5.finish(20);
                                            case 23:
                                                this.commonObjs.clear();
                                                if (!keepLoadedFonts) this.fontLoader.clear();
                                                _classPrivateFieldSet(this, _metadataPromise, null);
                                                this._getFieldObjectsPromise = null;
                                                this._hasJSActionsPromise = null;
                                            case 28:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5, this, [
                                        [
                                            6,
                                            17,
                                            20,
                                            23
                                        ]
                                    ]);
                                }));
                                function startCleanup() {
                                    return _startCleanup.apply(this, arguments);
                                }
                                return startCleanup;
                            }()
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                var params = this._params;
                                return (0, _util.shadow)(this, "loadingParams", {
                                    disableAutoFetch: params.disableAutoFetch,
                                    enableXfa: params.enableXfa
                                });
                            }
                        }
                    ]);
                    return WorkerTransport;
                }();
                var PDFObjects = /*#__PURE__*/ function() {
                    function PDFObjects() {
                        _classCallCheck(this, PDFObjects);
                        this._objs = Object.create(null);
                    }
                    _createClass(PDFObjects, [
                        {
                            key: "_ensureObj",
                            value: function _ensureObj(objId) {
                                if (this._objs[objId]) return this._objs[objId];
                                return this._objs[objId] = {
                                    capability: (0, _util.createPromiseCapability)(),
                                    data: null,
                                    resolved: false
                                };
                            }
                        },
                        {
                            key: "get",
                            value: function get(objId) {
                                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                if (callback) {
                                    this._ensureObj(objId).capability.promise.then(callback);
                                    return null;
                                }
                                var obj = this._objs[objId];
                                if (!obj || !obj.resolved) throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
                                return obj.data;
                            }
                        },
                        {
                            key: "has",
                            value: function has(objId) {
                                var obj = this._objs[objId];
                                return (obj === null || obj === void 0 ? void 0 : obj.resolved) || false;
                            }
                        },
                        {
                            key: "resolve",
                            value: function resolve(objId, data) {
                                var obj = this._ensureObj(objId);
                                obj.resolved = true;
                                obj.data = data;
                                obj.capability.resolve(data);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this._objs = Object.create(null);
                            }
                        }
                    ]);
                    return PDFObjects;
                }();
                var RenderTask = /*#__PURE__*/ function() {
                    function RenderTask(internalRenderTask) {
                        _classCallCheck(this, RenderTask);
                        this._internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    _createClass(RenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._internalRenderTask.capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                this._internalRenderTask.cancel();
                            }
                        }
                    ]);
                    return RenderTask;
                }();
                exports.RenderTask = RenderTask;
                var InternalRenderTask = /*#__PURE__*/ function() {
                    function InternalRenderTask(_ref24) {
                        var callback = _ref24.callback, params = _ref24.params, objs = _ref24.objs, commonObjs = _ref24.commonObjs, annotationCanvasMap = _ref24.annotationCanvasMap, operatorList = _ref24.operatorList, pageIndex = _ref24.pageIndex, canvasFactory = _ref24.canvasFactory, _ref24$useRequestAnim = _ref24.useRequestAnimationFrame, useRequestAnimationFrame = _ref24$useRequestAnim === void 0 ? false : _ref24$useRequestAnim, _ref24$pdfBug = _ref24.pdfBug, pdfBug = _ref24$pdfBug === void 0 ? false : _ref24$pdfBug;
                        _classCallCheck(this, InternalRenderTask);
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this._pdfBug = pdfBug;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = (0, _util.createPromiseCapability)();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    _createClass(InternalRenderTask, [
                        {
                            key: "completed",
                            get: function get() {
                                return this.capability.promise["catch"](function() {});
                            }
                        },
                        {
                            key: "initializeGraphics",
                            value: function initializeGraphics(_ref25) {
                                var _globalThis$StepperMa;
                                var _ref25$transparency = _ref25.transparency, transparency = _ref25$transparency === void 0 ? false : _ref25$transparency, optionalContentConfig = _ref25.optionalContentConfig;
                                if (this.cancelled) return;
                                if (this._canvas) {
                                    if (InternalRenderTask.canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                    InternalRenderTask.canvasInUse.add(this._canvas);
                                }
                                if (this._pdfBug && (_globalThis$StepperMa = globalThis.StepperManager) !== null && _globalThis$StepperMa !== void 0 && _globalThis$StepperMa.enabled) {
                                    this.stepper = globalThis.StepperManager.create(this._pageIndex);
                                    this.stepper.init(this.operatorList);
                                    this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                                }
                                var _this$params = this.params, canvasContext = _this$params.canvasContext, viewport = _this$params.viewport, transform = _this$params.transform, imageLayer = _this$params.imageLayer, background = _this$params.background;
                                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, imageLayer, optionalContentConfig, this.annotationCanvasMap);
                                this.gfx.beginDrawing({
                                    transform: transform,
                                    viewport: viewport,
                                    transparency: transparency,
                                    background: background
                                });
                                this.operatorListIdx = 0;
                                this.graphicsReady = true;
                                if (this.graphicsReadyCallback) this.graphicsReadyCallback();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                                this.running = false;
                                this.cancelled = true;
                                if (this.gfx) this.gfx.endDrawing();
                                if (this._canvas) InternalRenderTask.canvasInUse["delete"](this._canvas);
                                this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas"));
                            }
                        },
                        {
                            key: "operatorListChanged",
                            value: function operatorListChanged() {
                                if (!this.graphicsReady) {
                                    if (!this.graphicsReadyCallback) this.graphicsReadyCallback = this._continueBound;
                                    return;
                                }
                                if (this.stepper) this.stepper.updateOperatorList(this.operatorList);
                                if (this.running) return;
                                this._continue();
                            }
                        },
                        {
                            key: "_continue",
                            value: function _continue() {
                                this.running = true;
                                if (this.cancelled) return;
                                if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                                else this._scheduleNext();
                            }
                        },
                        {
                            key: "_scheduleNext",
                            value: function _scheduleNext() {
                                var _this17 = this;
                                if (this._useRequestAnimationFrame) window.requestAnimationFrame(function() {
                                    _this17._nextBound()["catch"](_this17._cancelBound);
                                });
                                else Promise.resolve().then(this._nextBound)["catch"](this._cancelBound);
                            }
                        },
                        {
                            key: "_next",
                            value: function() {
                                var _next2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee6() {
                                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                if (!this.cancelled) {
                                                    _context6.next = 2;
                                                    break;
                                                }
                                                return _context6.abrupt("return");
                                            case 2:
                                                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                                                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                                                    this.running = false;
                                                    if (this.operatorList.lastChunk) {
                                                        this.gfx.endDrawing();
                                                        if (this._canvas) InternalRenderTask.canvasInUse["delete"](this._canvas);
                                                        this.callback();
                                                    }
                                                }
                                            case 4:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6, this);
                                }));
                                function _next() {
                                    return _next2.apply(this, arguments);
                                }
                                return _next;
                            }()
                        }
                    ], [
                        {
                            key: "canvasInUse",
                            get: function get() {
                                return (0, _util.shadow)(this, "canvasInUse", new WeakSet());
                            }
                        }
                    ]);
                    return InternalRenderTask;
                }();
                var version = '2.12.313';
                exports.version = version;
                var build = 'a2ae56f39';
                exports.build = build;
            /***/ },
            /* 137 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var BaseFontLoader = /*#__PURE__*/ function() {
                    function BaseFontLoader(_ref) {
                        var docId = _ref.docId, onUnsupportedFeature = _ref.onUnsupportedFeature, _ref$ownerDocument = _ref.ownerDocument, ownerDocument = _ref$ownerDocument === void 0 ? globalThis.document : _ref$ownerDocument, _ref$styleElement = _ref.styleElement, styleElement = _ref$styleElement === void 0 ? null : _ref$styleElement;
                        _classCallCheck(this, BaseFontLoader);
                        if (this.constructor === BaseFontLoader) (0, _util.unreachable)("Cannot initialize BaseFontLoader.");
                        this.docId = docId;
                        this._onUnsupportedFeature = onUnsupportedFeature;
                        this._document = ownerDocument;
                        this.nativeFontFaces = [];
                        this.styleElement = null;
                    }
                    _createClass(BaseFontLoader, [
                        {
                            key: "addNativeFontFace",
                            value: function addNativeFontFace(nativeFontFace) {
                                this.nativeFontFaces.push(nativeFontFace);
                                this._document.fonts.add(nativeFontFace);
                            }
                        },
                        {
                            key: "insertRule",
                            value: function insertRule(rule) {
                                var styleElement = this.styleElement;
                                if (!styleElement) {
                                    styleElement = this.styleElement = this._document.createElement("style");
                                    styleElement.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
                                    this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
                                }
                                var styleSheet = styleElement.sheet;
                                styleSheet.insertRule(rule, styleSheet.cssRules.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                var _iterator = _createForOfIteratorHelper(this.nativeFontFaces), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var nativeFontFace = _step.value;
                                        this._document.fonts["delete"](nativeFontFace);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this.nativeFontFaces.length = 0;
                                if (this.styleElement) {
                                    this.styleElement.remove();
                                    this.styleElement = null;
                                }
                            }
                        },
                        {
                            key: "bind",
                            value: function() {
                                var _bind = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(font) {
                                    var _this = this;
                                    var nativeFontFace, rule;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!(font.attached || font.missingFile)) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                return _context.abrupt("return");
                                            case 2:
                                                font.attached = true;
                                                if (!this.isFontLoadingAPISupported) {
                                                    _context.next = 19;
                                                    break;
                                                }
                                                nativeFontFace = font.createNativeFontFace();
                                                if (!nativeFontFace) {
                                                    _context.next = 18;
                                                    break;
                                                }
                                                this.addNativeFontFace(nativeFontFace);
                                                _context.prev = 7;
                                                _context.next = 10;
                                                return nativeFontFace.loaded;
                                            case 10:
                                                _context.next = 18;
                                                break;
                                            case 12:
                                                _context.prev = 12;
                                                _context.t0 = _context["catch"](7);
                                                this._onUnsupportedFeature({
                                                    featureId: _util.UNSUPPORTED_FEATURES.errorFontLoadNative
                                                });
                                                (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."));
                                                font.disableFontFace = true;
                                                throw _context.t0;
                                            case 18:
                                                return _context.abrupt("return");
                                            case 19:
                                                rule = font.createFontFaceRule();
                                                if (!rule) {
                                                    _context.next = 26;
                                                    break;
                                                }
                                                this.insertRule(rule);
                                                if (!this.isSyncFontLoadingSupported) {
                                                    _context.next = 24;
                                                    break;
                                                }
                                                return _context.abrupt("return");
                                            case 24:
                                                _context.next = 26;
                                                return new Promise(function(resolve) {
                                                    var request = _this._queueLoadingCallback(resolve);
                                                    _this._prepareFontLoadEvent([
                                                        rule
                                                    ], [
                                                        font
                                                    ], request);
                                                });
                                            case 26:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this, [
                                        [
                                            7,
                                            12
                                        ]
                                    ]);
                                }));
                                function bind(_x) {
                                    return _bind.apply(this, arguments);
                                }
                                return bind;
                            }()
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback(callback) {
                                (0, _util.unreachable)("Abstract method `_queueLoadingCallback`.");
                            }
                        },
                        {
                            key: "isFontLoadingAPISupported",
                            get: function get() {
                                var _this$_document;
                                var hasFonts = !!((_this$_document = this._document) !== null && _this$_document !== void 0 && _this$_document.fonts);
                                return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                            }
                        },
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get() {
                                (0, _util.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get() {
                                (0, _util.unreachable)("Abstract method `_loadTestFont`.");
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent(rules, fontsToLoad, request) {
                                (0, _util.unreachable)("Abstract method `_prepareFontLoadEvent`.");
                            }
                        }
                    ]);
                    return BaseFontLoader;
                }();
                var FontLoader;
                exports.FontLoader = FontLoader;
                exports.FontLoader = FontLoader = /*#__PURE__*/ function(_BaseFontLoader) {
                    _inherits(GenericFontLoader, _BaseFontLoader);
                    var _super = _createSuper(GenericFontLoader);
                    function GenericFontLoader(params) {
                        var _this2;
                        _classCallCheck(this, GenericFontLoader);
                        _this2 = _super.call(this, params);
                        _this2.loadingContext = {
                            requests: [],
                            nextRequestId: 0
                        };
                        _this2.loadTestFontId = 0;
                        return _this2;
                    }
                    _createClass(GenericFontLoader, [
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get() {
                                var supported = false;
                                if (typeof navigator === "undefined") supported = true;
                                else {
                                    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                                    if ((m === null || m === void 0 ? void 0 : m[1]) >= 14) supported = true;
                                }
                                return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                            }
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback(callback) {
                                function completeRequest() {
                                    (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                                    request.done = true;
                                    while(context.requests.length > 0 && context.requests[0].done){
                                        var otherRequest = context.requests.shift();
                                        setTimeout(otherRequest.callback, 0);
                                    }
                                }
                                var context = this.loadingContext;
                                var request = {
                                    id: "pdfjs-font-loading-".concat(context.nextRequestId++),
                                    done: false,
                                    complete: completeRequest,
                                    callback: callback
                                };
                                context.requests.push(request);
                                return request;
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get() {
                                var getLoadTestFont = function getLoadTestFont() {
                                    return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                                };
                                return (0, _util.shadow)(this, "_loadTestFont", getLoadTestFont());
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent(rules, fonts, request) {
                                function int32(data, offset) {
                                    return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                                }
                                function spliceString(s, offset, remove, insert) {
                                    var chunk1 = s.substring(0, offset);
                                    var chunk2 = s.substring(offset + remove);
                                    return chunk1 + insert + chunk2;
                                }
                                var i, ii;
                                var canvas = this._document.createElement("canvas");
                                canvas.width = 1;
                                canvas.height = 1;
                                var ctx = canvas.getContext("2d");
                                var called = 0;
                                function isFontReady(name, callback) {
                                    called++;
                                    if (called > 30) {
                                        (0, _util.warn)("Load test font never loaded.");
                                        callback();
                                        return;
                                    }
                                    ctx.font = "30px " + name;
                                    ctx.fillText(".", 0, 20);
                                    var imageData = ctx.getImageData(0, 0, 1, 1);
                                    if (imageData.data[3] > 0) {
                                        callback();
                                        return;
                                    }
                                    setTimeout(isFontReady.bind(null, name, callback));
                                }
                                var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
                                var data = this._loadTestFont;
                                var COMMENT_OFFSET = 976;
                                data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                                var CFF_CHECKSUM_OFFSET = 16;
                                var XXXX_VALUE = 0x58585858;
                                var checksum = int32(data, CFF_CHECKSUM_OFFSET);
                                for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                                if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                                data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                                var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
                                var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
                                this.insertRule(rule);
                                var names = [];
                                var _iterator2 = _createForOfIteratorHelper(fonts), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var font = _step2.value;
                                        names.push(font.loadedName);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                names.push(loadTestFontId);
                                var div = this._document.createElement("div");
                                div.style.visibility = "hidden";
                                div.style.width = div.style.height = "10px";
                                div.style.position = "absolute";
                                div.style.top = div.style.left = "0px";
                                for(var _i = 0, _names = names; _i < _names.length; _i++){
                                    var name = _names[_i];
                                    var span = this._document.createElement("span");
                                    span.textContent = "Hi";
                                    span.style.fontFamily = name;
                                    div.appendChild(span);
                                }
                                this._document.body.appendChild(div);
                                isFontReady(loadTestFontId, function() {
                                    div.remove();
                                    request.complete();
                                });
                            }
                        }
                    ]);
                    return GenericFontLoader;
                }(BaseFontLoader);
                var FontFaceObject = /*#__PURE__*/ function() {
                    function FontFaceObject(translatedData, _ref2) {
                        var _ref2$isEvalSupported = _ref2.isEvalSupported, isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported, _ref2$disableFontFace = _ref2.disableFontFace, disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace, _ref2$ignoreErrors = _ref2.ignoreErrors, ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors, onUnsupportedFeature = _ref2.onUnsupportedFeature, _ref2$fontRegistry = _ref2.fontRegistry, fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry;
                        _classCallCheck(this, FontFaceObject);
                        this.compiledGlyphs = Object.create(null);
                        for(var i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._onUnsupportedFeature = onUnsupportedFeature;
                        this.fontRegistry = fontRegistry;
                    }
                    _createClass(FontFaceObject, [
                        {
                            key: "createNativeFontFace",
                            value: function createNativeFontFace() {
                                if (!this.data || this.disableFontFace) return null;
                                var nativeFontFace;
                                if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                                else {
                                    var css = {
                                        weight: this.cssFontInfo.fontWeight
                                    };
                                    if (this.cssFontInfo.italicAngle) css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
                                    nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this);
                                return nativeFontFace;
                            }
                        },
                        {
                            key: "createFontFaceRule",
                            value: function createFontFaceRule() {
                                if (!this.data || this.disableFontFace) return null;
                                var data = (0, _util.bytesToString)(this.data);
                                var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
                                var rule;
                                if (!this.cssFontInfo) rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");
                                else {
                                    var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
                                    if (this.cssFontInfo.italicAngle) css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
                                    rule = "@font-face {font-family:\"".concat(this.cssFontInfo.fontFamily, "\";").concat(css, "src:").concat(url, "}");
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this, url);
                                return rule;
                            }
                        },
                        {
                            key: "getPathGenerator",
                            value: function getPathGenerator(objs, character) {
                                if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                                var cmds;
                                try {
                                    cmds = objs.get(this.loadedName + "_path_" + character);
                                } catch (ex) {
                                    if (!this.ignoreErrors) throw ex;
                                    this._onUnsupportedFeature({
                                        featureId: _util.UNSUPPORTED_FEATURES.errorFontGetPath
                                    });
                                    (0, _util.warn)("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
                                    return this.compiledGlyphs[character] = function(c, size) {};
                                }
                                if (this.isEvalSupported && _util.IsEvalSupportedCached.value) {
                                    var jsBuf = [];
                                    var _iterator3 = _createForOfIteratorHelper(cmds), _step3;
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            var current = _step3.value;
                                            var args = current.args !== undefined ? current.args.join(",") : "";
                                            jsBuf.push("c.", current.cmd, "(", args, ");\n");
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                                }
                                return this.compiledGlyphs[character] = function(c, size) {
                                    var _iterator4 = _createForOfIteratorHelper(cmds), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var _current = _step4.value;
                                            if (_current.cmd === "scale") _current.args = [
                                                size,
                                                -size
                                            ];
                                            c[_current.cmd].apply(c, _current.args);
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                };
                            }
                        }
                    ]);
                    return FontFaceObject;
                }();
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 138 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(135);
                var _is_node = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(4);
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var NodeCanvasFactory = function NodeCanvasFactory() {
                    _classCallCheck(this, NodeCanvasFactory);
                    (0, _util.unreachable)("Not implemented: NodeCanvasFactory");
                };
                exports.NodeCanvasFactory = NodeCanvasFactory;
                var NodeCMapReaderFactory = function NodeCMapReaderFactory() {
                    _classCallCheck(this, NodeCMapReaderFactory);
                    (0, _util.unreachable)("Not implemented: NodeCMapReaderFactory");
                };
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                var NodeStandardFontDataFactory = function NodeStandardFontDataFactory() {
                    _classCallCheck(this, NodeStandardFontDataFactory);
                    (0, _util.unreachable)("Not implemented: NodeStandardFontDataFactory");
                };
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
                if (_is_node.isNodeJS) {
                    var fetchData = function fetchData(url) {
                        return new Promise(function(resolve, reject) {
                            var fs = (parcelRequire("iJ8TW"));
                            fs.readFile(url, function(error, data) {
                                if (error || !data) {
                                    reject(new Error(error));
                                    return;
                                }
                                resolve(new Uint8Array(data));
                            });
                        });
                    };
                    exports.NodeCanvasFactory = NodeCanvasFactory = /*#__PURE__*/ function(_BaseCanvasFactory) {
                        _inherits(NodeCanvasFactory, _BaseCanvasFactory);
                        var _super = _createSuper(NodeCanvasFactory);
                        function NodeCanvasFactory() {
                            _classCallCheck(this, NodeCanvasFactory);
                            return _super.apply(this, arguments);
                        }
                        _createClass(NodeCanvasFactory, [
                            {
                                key: "_createCanvas",
                                value: function _createCanvas(width, height) {
                                    var Canvas = (parcelRequire("iJ8TW"));
                                    return Canvas.createCanvas(width, height);
                                }
                            }
                        ]);
                        return NodeCanvasFactory;
                    }(_base_factory.BaseCanvasFactory);
                    exports.NodeCMapReaderFactory = NodeCMapReaderFactory = /*#__PURE__*/ function(_BaseCMapReaderFactor) {
                        _inherits(NodeCMapReaderFactory, _BaseCMapReaderFactor);
                        var _super2 = _createSuper(NodeCMapReaderFactory);
                        function NodeCMapReaderFactory() {
                            _classCallCheck(this, NodeCMapReaderFactory);
                            return _super2.apply(this, arguments);
                        }
                        _createClass(NodeCMapReaderFactory, [
                            {
                                key: "_fetchData",
                                value: function _fetchData(url, compressionType) {
                                    return fetchData(url).then(function(data) {
                                        return {
                                            cMapData: data,
                                            compressionType: compressionType
                                        };
                                    });
                                }
                            }
                        ]);
                        return NodeCMapReaderFactory;
                    }(_base_factory.BaseCMapReaderFactory);
                    exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory = /*#__PURE__*/ function(_BaseStandardFontData) {
                        _inherits(NodeStandardFontDataFactory, _BaseStandardFontData);
                        var _super3 = _createSuper(NodeStandardFontDataFactory);
                        function NodeStandardFontDataFactory() {
                            _classCallCheck(this, NodeStandardFontDataFactory);
                            return _super3.apply(this, arguments);
                        }
                        _createClass(NodeStandardFontDataFactory, [
                            {
                                key: "_fetchData",
                                value: function _fetchData(url) {
                                    return fetchData(url);
                                }
                            }
                        ]);
                        return NodeStandardFontDataFactory;
                    }(_base_factory.BaseStandardFontDataFactory);
                }
            /***/ },
            /* 139 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(4);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var AnnotationStorage = /*#__PURE__*/ function() {
                    function AnnotationStorage() {
                        _classCallCheck(this, AnnotationStorage);
                        this._storage = new Map();
                        this._timeStamp = Date.now();
                        this._modified = false;
                        this.onSetModified = null;
                        this.onResetModified = null;
                    }
                    _createClass(AnnotationStorage, [
                        {
                            key: "getValue",
                            value: function getValue(key, defaultValue) {
                                var value = this._storage.get(key);
                                if (value === undefined) return defaultValue;
                                return Object.assign(defaultValue, value);
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue(key, value) {
                                var obj = this._storage.get(key);
                                var modified = false;
                                if (obj !== undefined) for(var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++){
                                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), entry = _Object$entries$_i[0], val = _Object$entries$_i[1];
                                    if (obj[entry] !== val) {
                                        modified = true;
                                        obj[entry] = val;
                                    }
                                }
                                else {
                                    modified = true;
                                    this._storage.set(key, value);
                                }
                                if (modified) {
                                    this._timeStamp = Date.now();
                                    this._setModified();
                                }
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return this._storage.size > 0 ? (0, _util.objectFromMap)(this._storage) : null;
                            }
                        },
                        {
                            key: "size",
                            get: function get() {
                                return this._storage.size;
                            }
                        },
                        {
                            key: "_setModified",
                            value: function _setModified() {
                                if (!this._modified) {
                                    this._modified = true;
                                    if (typeof this.onSetModified === "function") this.onSetModified();
                                }
                            }
                        },
                        {
                            key: "resetModified",
                            value: function resetModified() {
                                if (this._modified) {
                                    this._modified = false;
                                    if (typeof this.onResetModified === "function") this.onResetModified();
                                }
                            }
                        },
                        {
                            key: "serializable",
                            get: function get() {
                                return this._storage.size > 0 ? this._storage : null;
                            }
                        },
                        {
                            key: "lastModified",
                            get: function get() {
                                return this._timeStamp.toString();
                            }
                        }
                    ]);
                    return AnnotationStorage;
                }();
                exports.AnnotationStorage = AnnotationStorage;
            /***/ },
            /* 140 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(4);
                var _pattern_helper = __w_pdfjs_require__(141);
                var _display_utils = __w_pdfjs_require__(1);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                var MIN_FONT_SIZE = 16;
                var MAX_FONT_SIZE = 100;
                var MAX_GROUP_SIZE = 4096;
                var EXECUTION_TIME = 15;
                var EXECUTION_STEPS = 10;
                var COMPILE_TYPE3_GLYPHS = true;
                var MAX_SIZE_TO_COMPILE = 1000;
                var FULL_CHUNK_HEIGHT = 16;
                var LINEWIDTH_SCALE_FACTOR = 1.000001;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = function() {
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                function addContextCurrentTransform(ctx) {
                    if (ctx.mozCurrentTransform) return;
                    ctx._originalSave = ctx.save;
                    ctx._originalRestore = ctx.restore;
                    ctx._originalRotate = ctx.rotate;
                    ctx._originalScale = ctx.scale;
                    ctx._originalTranslate = ctx.translate;
                    ctx._originalTransform = ctx.transform;
                    ctx._originalSetTransform = ctx.setTransform;
                    ctx._originalResetTransform = ctx.resetTransform;
                    ctx._transformMatrix = ctx._transformMatrix || [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ];
                    ctx._transformStack = [];
                    try {
                        var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx), "lineWidth");
                        ctx._setLineWidth = desc.set;
                        ctx._getLineWidth = desc.get;
                        Object.defineProperty(ctx, "lineWidth", {
                            set: function setLineWidth(width) {
                                this._setLineWidth(width * LINEWIDTH_SCALE_FACTOR);
                            },
                            get: function getLineWidth() {
                                return this._getLineWidth();
                            }
                        });
                    } catch (_) {}
                    Object.defineProperty(ctx, "mozCurrentTransform", {
                        get: function getCurrentTransform() {
                            return this._transformMatrix;
                        }
                    });
                    Object.defineProperty(ctx, "mozCurrentTransformInverse", {
                        get: function getCurrentTransformInverse() {
                            var _this$_transformMatri = _slicedToArray(this._transformMatrix, 6), a = _this$_transformMatri[0], b = _this$_transformMatri[1], c = _this$_transformMatri[2], d = _this$_transformMatri[3], e = _this$_transformMatri[4], f = _this$_transformMatri[5];
                            var ad_bc = a * d - b * c;
                            var bc_ad = b * c - a * d;
                            return [
                                d / ad_bc,
                                b / bc_ad,
                                c / bc_ad,
                                a / ad_bc,
                                (d * e - c * f) / bc_ad,
                                (b * e - a * f) / ad_bc
                            ];
                        }
                    });
                    ctx.save = function ctxSave() {
                        var old = this._transformMatrix;
                        this._transformStack.push(old);
                        this._transformMatrix = old.slice(0, 6);
                        this._originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        var prev = this._transformStack.pop();
                        if (prev) {
                            this._transformMatrix = prev;
                            this._originalRestore();
                        }
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        var m = this._transformMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                        this._originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        var m = this._transformMatrix;
                        m[0] *= x;
                        m[1] *= x;
                        m[2] *= y;
                        m[3] *= y;
                        this._originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        var m = this._transformMatrix;
                        this._transformMatrix = [
                            m[0] * a + m[2] * b,
                            m[1] * a + m[3] * b,
                            m[0] * c + m[2] * d,
                            m[1] * c + m[3] * d,
                            m[0] * e + m[2] * f + m[4],
                            m[1] * e + m[3] * f + m[5]
                        ];
                        ctx._originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        this._transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        ctx._originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        this._transformMatrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        ctx._originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        var cosValue = Math.cos(angle);
                        var sinValue = Math.sin(angle);
                        var m = this._transformMatrix;
                        this._transformMatrix = [
                            m[0] * cosValue + m[2] * sinValue,
                            m[1] * cosValue + m[3] * sinValue,
                            m[0] * -sinValue + m[2] * cosValue,
                            m[1] * -sinValue + m[3] * cosValue,
                            m[4],
                            m[5]
                        ];
                        this._originalRotate(angle);
                    };
                }
                var CachedCanvases = /*#__PURE__*/ function() {
                    function CachedCanvases(canvasFactory) {
                        _classCallCheck(this, CachedCanvases);
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    _createClass(CachedCanvases, [
                        {
                            key: "getCanvas",
                            value: function getCanvas(id, width, height, trackTransform) {
                                var canvasEntry;
                                if (this.cache[id] !== undefined) {
                                    canvasEntry = this.cache[id];
                                    this.canvasFactory.reset(canvasEntry, width, height);
                                    canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
                                } else {
                                    canvasEntry = this.canvasFactory.create(width, height);
                                    this.cache[id] = canvasEntry;
                                }
                                if (trackTransform) addContextCurrentTransform(canvasEntry.context);
                                return canvasEntry;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                for(var id in this.cache){
                                    var canvasEntry = this.cache[id];
                                    this.canvasFactory.destroy(canvasEntry);
                                    delete this.cache[id];
                                }
                            }
                        }
                    ]);
                    return CachedCanvases;
                }();
                function compileType3Glyph(imgData) {
                    var POINT_TO_PROCESS_LIMIT = 1000;
                    var POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    var width = imgData.width, height = imgData.height, width1 = width + 1;
                    var i, ii, j, j0;
                    var points = new Uint8Array(width1 * (height + 1));
                    var lineSize = width + 7 & -8, data0 = imgData.data;
                    var data = new Uint8Array(lineSize * height);
                    var pos = 0;
                    for(i = 0, ii = data0.length; i < ii; i++){
                        var elem = data0[i];
                        var mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    var count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    var steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    var outlines = [];
                    for(i = 0; count && i <= height; i++){
                        var p = i * width1;
                        var end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        var coords = [
                            p % width1,
                            i
                        ];
                        var p0 = p;
                        var type = points[p];
                        do {
                            var step = steps[type];
                            do p += step;
                            while (!points[p]);
                            var pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            coords.push(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        outlines.push(coords);
                        --i;
                    }
                    var drawOutline = function drawOutline(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.beginPath();
                        for(var k = 0, kk = outlines.length; k < kk; k++){
                            var o = outlines[k];
                            c.moveTo(o[0], o[1]);
                            for(var l = 2, ll = o.length; l < ll; l += 2)c.lineTo(o[l], o[l + 1]);
                        }
                        c.fill();
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                var CanvasExtraState = /*#__PURE__*/ function() {
                    function CanvasExtraState(width, height) {
                        _classCallCheck(this, CanvasExtraState);
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = null;
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    _createClass(CanvasExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                var clone = Object.create(this);
                                clone.clipBox = this.clipBox.slice();
                                return clone;
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        },
                        {
                            key: "updatePathMinMax",
                            value: function updatePathMinMax(transform, x, y) {
                                var _Util$applyTransform = _util.Util.applyTransform([
                                    x,
                                    y
                                ], transform);
                                var _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2);
                                x = _Util$applyTransform2[0];
                                y = _Util$applyTransform2[1];
                                this.minX = Math.min(this.minX, x);
                                this.minY = Math.min(this.minY, y);
                                this.maxX = Math.max(this.maxX, x);
                                this.maxY = Math.max(this.maxY, y);
                            }
                        },
                        {
                            key: "updateCurvePathMinMax",
                            value: function updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3) {
                                var box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                                this.updatePathMinMax(transform, box[0], box[1]);
                                this.updatePathMinMax(transform, box[2], box[3]);
                            }
                        },
                        {
                            key: "getPathBoundingBox",
                            value: function getPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
                                var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var box = [
                                    this.minX,
                                    this.minY,
                                    this.maxX,
                                    this.maxY
                                ];
                                if (pathType === _pattern_helper.PathType.STROKE) {
                                    if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                                    var xStrokePad = scale[0] * this.lineWidth / 2;
                                    var yStrokePad = scale[1] * this.lineWidth / 2;
                                    box[0] -= xStrokePad;
                                    box[1] -= yStrokePad;
                                    box[2] += xStrokePad;
                                    box[3] += yStrokePad;
                                }
                                return box;
                            }
                        },
                        {
                            key: "updateClipFromPath",
                            value: function updateClipFromPath() {
                                var intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                                this.startNewPathAndClipBox(intersect || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            }
                        },
                        {
                            key: "startNewPathAndClipBox",
                            value: function startNewPathAndClipBox(box) {
                                this.clipBox = box;
                                this.minX = Infinity;
                                this.minY = Infinity;
                                this.maxX = 0;
                                this.maxY = 0;
                            }
                        },
                        {
                            key: "getClippedPathBoundingBox",
                            value: function getClippedPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
                                var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                            }
                        }
                    ]);
                    return CanvasExtraState;
                }();
                function putBinaryImageData(ctx, imgData) {
                    var transferMaps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0, destPos;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    var i, j, thisChunkHeight, elemsInThisChunk;
                    var transferMapRed, transferMapGreen, transferMapBlue, transferMapGray;
                    if (transferMaps) switch(transferMaps.length){
                        case 1:
                            transferMapRed = transferMaps[0];
                            transferMapGreen = transferMaps[0];
                            transferMapBlue = transferMaps[0];
                            transferMapGray = transferMaps[0];
                            break;
                        case 4:
                            transferMapRed = transferMaps[0];
                            transferMapGreen = transferMaps[1];
                            transferMapBlue = transferMaps[2];
                            transferMapGray = transferMaps[3];
                            break;
                    }
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        var srcLength = src.byteLength;
                        var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        var dest32DataLength = dest32.length;
                        var fullSrcDiff = width + 7 >> 3;
                        var white = 0xffffffff;
                        var black = _util.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff;
                        if (transferMapGray) {
                            if (transferMapGray[0] === 0xff && transferMapGray[0xff] === 0) {
                                var _ref = [
                                    black,
                                    white
                                ];
                                white = _ref[0];
                                black = _ref[1];
                            }
                        }
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                var srcDiff = srcLength - srcPos;
                                var k = 0;
                                var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                var kEndUnrolled = kEnd & -8;
                                var mask = 0;
                                var srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        var hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            if (hasTransferMaps) for(var _k = 0; _k < elemsInThisChunk; _k += 4){
                                if (transferMapRed) dest[_k + 0] = transferMapRed[dest[_k + 0]];
                                if (transferMapGreen) dest[_k + 1] = transferMapGreen[dest[_k + 1]];
                                if (transferMapBlue) dest[_k + 2] = transferMapBlue[dest[_k + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            if (hasTransferMaps) for(var _k2 = 0; _k2 < elemsInThisChunk; _k2 += 4){
                                if (transferMapRed) dest[_k2 + 0] = transferMapRed[dest[_k2 + 0]];
                                if (transferMapGreen) dest[_k2 + 1] = transferMapGreen[dest[_k2 + 1]];
                                if (transferMapBlue) dest[_k2 + 2] = transferMapBlue[dest[_k2 + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        var _hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            if (_hasTransferMaps) for(var _k3 = 0; _k3 < destPos; _k3 += 4){
                                if (transferMapRed) dest[_k3 + 0] = transferMapRed[dest[_k3 + 0]];
                                if (transferMapGreen) dest[_k3 + 1] = transferMapGreen[dest[_k3 + 1]];
                                if (transferMapBlue) dest[_k3 + 2] = transferMapBlue[dest[_k3 + 2]];
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error("bad image kind: ".concat(imgData.kind));
                }
                function putBinaryImageMask(ctx, imgData) {
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    for(var i = 0; i < totalChunks; i++){
                        var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        var destPos = 3;
                        for(var j = 0; j < thisChunkHeight; j++){
                            var elem = void 0, mask = 0;
                            for(var k = 0; k < width; k++){
                                if (!mask) {
                                    elem = src[srcPos++];
                                    mask = 128;
                                }
                                dest[destPos] = elem & mask ? 0 : 255;
                                destPos += 4;
                                mask >>= 1;
                            }
                        }
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    var properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font"
                    ];
                    for(var i = 0, ii = properties.length; i < ii; i++){
                        var property = properties[i];
                        if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    }
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = "#000000";
                    ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    var length = bytes.length;
                    for(var i = 3; i < length; i += 4){
                        var alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            var alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    var scale = 1 / 255;
                    for(var i = 3; i < length; i += 4){
                        var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    for(var i = 3; i < length; i += 4){
                        var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    var hasBackdrop = !!backdrop;
                    var r0 = hasBackdrop ? backdrop[0] : 0;
                    var g0 = hasBackdrop ? backdrop[1] : 0;
                    var b0 = hasBackdrop ? backdrop[2] : 0;
                    var composeFn;
                    if (subtype === "Luminosity") composeFn = composeSMaskLuminosity;
                    else composeFn = composeSMaskAlpha;
                    var PIXELS_TO_PROCESS = 1048576;
                    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(var row = 0; row < height; row += chunkSize){
                        var chunkHeight = Math.min(chunkSize, height - row);
                        var maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        var layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    var layerOffsetX = layerBox[0];
                    var layerOffsetY = layerBox[1];
                    var layerWidth = layerBox[2] - layerOffsetX;
                    var layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var NORMAL_CLIP = {};
                var EO_CLIP = {};
                var CanvasGraphics = /*#__PURE__*/ function() {
                    function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer, optionalContentConfig, annotationCanvasMap) {
                        _classCallCheck(this, CanvasGraphics);
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.imageLayer = imageLayer;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        if (canvasCtx) addContextCurrentTransform(canvasCtx);
                        this._cachedGetSinglePixelWidth = null;
                    }
                    _createClass(CanvasGraphics, [
                        {
                            key: "beginDrawing",
                            value: function beginDrawing(_ref2) {
                                var transform = _ref2.transform, viewport = _ref2.viewport, _ref2$transparency = _ref2.transparency, transparency = _ref2$transparency === void 0 ? false : _ref2$transparency, _ref2$background = _ref2.background, background = _ref2$background === void 0 ? null : _ref2$background;
                                var width = this.ctx.canvas.width;
                                var height = this.ctx.canvas.height;
                                this.ctx.save();
                                this.ctx.fillStyle = background || "rgb(255, 255, 255)";
                                this.ctx.fillRect(0, 0, width, height);
                                this.ctx.restore();
                                if (transparency) {
                                    var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height, true);
                                    this.compositeCtx = this.ctx;
                                    this.transparentCanvas = transparentCanvas.canvas;
                                    this.ctx = transparentCanvas.context;
                                    this.ctx.save();
                                    this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                                }
                                this.ctx.save();
                                resetCtxToDefault(this.ctx);
                                if (transform) {
                                    this.ctx.transform.apply(this.ctx, transform);
                                    this.outputScaleX = transform[0];
                                    this.outputScaleY = transform[0];
                                }
                                this.ctx.transform.apply(this.ctx, viewport.transform);
                                this.viewportScale = viewport.scale;
                                this.baseTransform = this.ctx.mozCurrentTransform.slice();
                                this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                                if (this.imageLayer) this.imageLayer.beginLayout();
                            }
                        },
                        {
                            key: "executeOperatorList",
                            value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var i = executionStartIdx || 0;
                                var argsArrayLen = argsArray.length;
                                if (argsArrayLen === i) return i;
                                var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                                var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                                var steps = 0;
                                var commonObjs = this.commonObjs;
                                var objs = this.objs;
                                var fnId;
                                while(true){
                                    if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                        stepper.breakIt(i, continueCallback);
                                        return i;
                                    }
                                    fnId = fnArray[i];
                                    if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                                    else {
                                        var _iterator = _createForOfIteratorHelper(argsArray[i]), _step;
                                        try {
                                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                                var depObjId = _step.value;
                                                var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                                if (!objsPool.has(depObjId)) {
                                                    objsPool.get(depObjId, continueCallback);
                                                    return i;
                                                }
                                            }
                                        } catch (err) {
                                            _iterator.e(err);
                                        } finally{
                                            _iterator.f();
                                        }
                                    }
                                    i++;
                                    if (i === argsArrayLen) return i;
                                    if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                        if (Date.now() > endTime) {
                                            continueCallback();
                                            return i;
                                        }
                                        steps = 0;
                                    }
                                }
                            }
                        },
                        {
                            key: "endDrawing",
                            value: function endDrawing() {
                                while(this.stateStack.length || this.current.activeSMask !== null)this.restore();
                                this.ctx.restore();
                                if (this.transparentCanvas) {
                                    this.ctx = this.compositeCtx;
                                    this.ctx.save();
                                    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                    this.ctx.drawImage(this.transparentCanvas, 0, 0);
                                    this.ctx.restore();
                                    this.transparentCanvas = null;
                                }
                                this.cachedCanvases.clear();
                                this.cachedPatterns.clear();
                                if (this.imageLayer) this.imageLayer.endLayout();
                            }
                        },
                        {
                            key: "_scaleImage",
                            value: function _scaleImage(img, inverseTransform) {
                                var width = img.width;
                                var height = img.height;
                                var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                                var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                                var paintWidth = width, paintHeight = height;
                                var tmpCanvasId = "prescale1";
                                var tmpCanvas, tmpCtx;
                                while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                                    var newWidth = paintWidth, newHeight = paintHeight;
                                    if (widthScale > 2 && paintWidth > 1) {
                                        newWidth = Math.ceil(paintWidth / 2);
                                        widthScale /= paintWidth / newWidth;
                                    }
                                    if (heightScale > 2 && paintHeight > 1) {
                                        newHeight = Math.ceil(paintHeight / 2);
                                        heightScale /= paintHeight / newHeight;
                                    }
                                    tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                                    tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, newWidth, newHeight);
                                    tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                                    img = tmpCanvas.canvas;
                                    paintWidth = newWidth;
                                    paintHeight = newHeight;
                                    tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                                }
                                return {
                                    img: img,
                                    paintWidth: paintWidth,
                                    paintHeight: paintHeight
                                };
                            }
                        },
                        {
                            key: "_createMaskCanvas",
                            value: function _createMaskCanvas(img) {
                                var ctx = this.ctx;
                                var width = img.width, height = img.height;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                var maskCtx = maskCanvas.context;
                                putBinaryImageMask(maskCtx, img);
                                var objToCanvas = ctx.mozCurrentTransform;
                                var maskToCanvas = _util.Util.transform(objToCanvas, [
                                    1 / width,
                                    0,
                                    0,
                                    -1 / height,
                                    0,
                                    0
                                ]);
                                maskToCanvas = _util.Util.transform(maskToCanvas, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    -height
                                ]);
                                var cord1 = _util.Util.applyTransform([
                                    0,
                                    0
                                ], maskToCanvas);
                                var cord2 = _util.Util.applyTransform([
                                    width,
                                    height
                                ], maskToCanvas);
                                var rect = _util.Util.normalizeRect([
                                    cord1[0],
                                    cord1[1],
                                    cord2[0],
                                    cord2[1]
                                ]);
                                var drawnWidth = Math.ceil(rect[2] - rect[0]);
                                var drawnHeight = Math.ceil(rect[3] - rect[1]);
                                var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight, true);
                                var fillCtx = fillCanvas.context;
                                var offsetX = Math.min(cord1[0], cord2[0]);
                                var offsetY = Math.min(cord1[1], cord2[1]);
                                fillCtx.translate(-offsetX, -offsetY);
                                fillCtx.transform.apply(fillCtx, maskToCanvas);
                                var scaled = this._scaleImage(maskCanvas.canvas, fillCtx.mozCurrentTransformInverse);
                                fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled(fillCtx.mozCurrentTransform, img.interpolate);
                                fillCtx.drawImage(scaled.img, 0, 0, scaled.img.width, scaled.img.height, 0, 0, width, height);
                                fillCtx.globalCompositeOperation = "source-in";
                                var inverse = _util.Util.transform(fillCtx.mozCurrentTransformInverse, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -offsetX,
                                    -offsetY
                                ]);
                                fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                                fillCtx.fillRect(0, 0, width, height);
                                return {
                                    canvas: fillCanvas.canvas,
                                    offsetX: Math.round(offsetX),
                                    offsetY: Math.round(offsetY)
                                };
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                this.current.lineWidth = width;
                                this.ctx.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.ctx.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.ctx.miterLimit = limit;
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                var ctx = this.ctx;
                                if (ctx.setLineDash !== undefined) {
                                    ctx.setLineDash(dashArray);
                                    ctx.lineDashOffset = dashPhase;
                                }
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                for(var i = 0, ii = states.length; i < ii; i++){
                                    var state = states[i];
                                    var key = state[0];
                                    var value = state[1];
                                    switch(key){
                                        case "LW":
                                            this.setLineWidth(value);
                                            break;
                                        case "LC":
                                            this.setLineCap(value);
                                            break;
                                        case "LJ":
                                            this.setLineJoin(value);
                                            break;
                                        case "ML":
                                            this.setMiterLimit(value);
                                            break;
                                        case "D":
                                            this.setDash(value[0], value[1]);
                                            break;
                                        case "RI":
                                            this.setRenderingIntent(value);
                                            break;
                                        case "FL":
                                            this.setFlatness(value);
                                            break;
                                        case "Font":
                                            this.setFont(value[0], value[1]);
                                            break;
                                        case "CA":
                                            this.current.strokeAlpha = state[1];
                                            break;
                                        case "ca":
                                            this.current.fillAlpha = state[1];
                                            this.ctx.globalAlpha = state[1];
                                            break;
                                        case "BM":
                                            this.ctx.globalCompositeOperation = value;
                                            break;
                                        case "SMask":
                                            this.current.activeSMask = value ? this.tempSMask : null;
                                            this.tempSMask = null;
                                            this.checkSMaskState();
                                            break;
                                        case "TR":
                                            this.current.transferMaps = value;
                                    }
                                }
                            }
                        },
                        {
                            key: "checkSMaskState",
                            value: function checkSMaskState() {
                                var inSMaskMode = !!this.suspendedCtx;
                                if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                                else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                            }
                        },
                        {
                            key: "beginSMaskMode",
                            value: function beginSMaskMode() {
                                if (this.suspendedCtx) throw new Error("beginSMaskMode called while already in smask mode");
                                var drawnWidth = this.ctx.canvas.width;
                                var drawnHeight = this.ctx.canvas.height;
                                var cacheId = "smaskGroupAt" + this.groupLevel;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                                this.suspendedCtx = this.ctx;
                                this.ctx = scratchCanvas.context;
                                var ctx = this.ctx;
                                ctx.setTransform.apply(ctx, this.suspendedCtx.mozCurrentTransform);
                                copyCtxState(this.suspendedCtx, ctx);
                                mirrorContextOperations(ctx, this.suspendedCtx);
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                            }
                        },
                        {
                            key: "endSMaskMode",
                            value: function endSMaskMode() {
                                if (!this.suspendedCtx) throw new Error("endSMaskMode called while not in smask mode");
                                this.ctx._removeMirroring();
                                copyCtxState(this.ctx, this.suspendedCtx);
                                this.ctx = this.suspendedCtx;
                                this.current.activeSMask = null;
                                this.suspendedCtx = null;
                            }
                        },
                        {
                            key: "compose",
                            value: function compose(dirtyBox) {
                                if (!this.current.activeSMask) return;
                                if (!dirtyBox) dirtyBox = [
                                    0,
                                    0,
                                    this.ctx.canvas.width,
                                    this.ctx.canvas.height
                                ];
                                else {
                                    dirtyBox[0] = Math.floor(dirtyBox[0]);
                                    dirtyBox[1] = Math.floor(dirtyBox[1]);
                                    dirtyBox[2] = Math.ceil(dirtyBox[2]);
                                    dirtyBox[3] = Math.ceil(dirtyBox[3]);
                                }
                                var smask = this.current.activeSMask;
                                var suspendedCtx = this.suspendedCtx;
                                composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                                this.ctx.save();
                                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                                this.ctx.restore();
                            }
                        },
                        {
                            key: "save",
                            value: function save() {
                                this.ctx.save();
                                var old = this.current;
                                this.stateStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                if (this.stateStack.length === 0 && this.current.activeSMask) this.endSMaskMode();
                                if (this.stateStack.length !== 0) {
                                    this.current = this.stateStack.pop();
                                    this.ctx.restore();
                                    this.checkSMaskState();
                                    this.pendingClip = null;
                                    this._cachedGetSinglePixelWidth = null;
                                }
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                this.ctx.transform(a, b, c, d, e, f);
                                this._cachedGetSinglePixelWidth = null;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var startX, startY;
                                for(var i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                                    case _util.OPS.rectangle:
                                        x = args[j++];
                                        y = args[j++];
                                        var width = args[j++];
                                        var height = args[j++];
                                        var xw = x + width;
                                        var yh = y + height;
                                        ctx.moveTo(x, y);
                                        if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                        else {
                                            ctx.lineTo(xw, y);
                                            ctx.lineTo(xw, yh);
                                            ctx.lineTo(x, yh);
                                        }
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, xw, yh);
                                        ctx.closePath();
                                        break;
                                    case _util.OPS.moveTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.moveTo(x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        break;
                                    case _util.OPS.lineTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.lineTo(x, y);
                                        current.updatePathMinMax(ctx.mozCurrentTransform, x, y);
                                        break;
                                    case _util.OPS.curveTo:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 4];
                                        y = args[j + 5];
                                        ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                        j += 6;
                                        break;
                                    case _util.OPS.curveTo2:
                                        startX = x;
                                        startY = y;
                                        ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        j += 4;
                                        break;
                                    case _util.OPS.curveTo3:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                        current.updateCurvePathMinMax(ctx.mozCurrentTransform, startX, startY, args[j], args[j + 1], x, y, x, y);
                                        j += 4;
                                        break;
                                    case _util.OPS.closePath:
                                        ctx.closePath();
                                        break;
                                }
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                this.ctx.closePath();
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke(consumePath) {
                                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                                var ctx = this.ctx;
                                var strokeColor = this.current.strokeColor;
                                ctx.globalAlpha = this.current.strokeAlpha;
                                if (this.contentVisible) {
                                    if (_typeof(strokeColor) === "object" && strokeColor !== null && strokeColor !== void 0 && strokeColor.getPattern) {
                                        var lineWidth = this.getSinglePixelWidth();
                                        ctx.save();
                                        ctx.strokeStyle = strokeColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.STROKE);
                                        ctx.lineWidth = Math.max(lineWidth, this.current.lineWidth);
                                        ctx.stroke();
                                        ctx.restore();
                                    } else {
                                        var _lineWidth = this.getSinglePixelWidth();
                                        if (_lineWidth < 0 && -_lineWidth >= this.current.lineWidth) {
                                            ctx.save();
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx.stroke();
                                            ctx.restore();
                                        } else {
                                            ctx.lineWidth = Math.max(_lineWidth, this.current.lineWidth);
                                            ctx.stroke();
                                        }
                                    }
                                }
                                if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                                ctx.globalAlpha = this.current.fillAlpha;
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "fill",
                            value: function fill(consumePath) {
                                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var needRestore = false;
                                if (isPatternFill) {
                                    ctx.save();
                                    ctx.fillStyle = fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                                    needRestore = true;
                                }
                                var intersect = this.current.getClippedPathBoundingBox();
                                if (this.contentVisible && intersect !== null) {
                                    if (this.pendingEOFill) {
                                        ctx.fill("evenodd");
                                        this.pendingEOFill = false;
                                    } else ctx.fill();
                                }
                                if (needRestore) ctx.restore();
                                if (consumePath) this.consumePath(intersect);
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                this.pendingEOFill = true;
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.fill(false);
                                this.stroke(false);
                                this.consumePath();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                this.pendingEOFill = true;
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.pendingEOFill = true;
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                this.consumePath();
                            }
                        },
                        {
                            key: "clip",
                            value: function clip() {
                                this.pendingClip = NORMAL_CLIP;
                            }
                        },
                        {
                            key: "eoClip",
                            value: function eoClip() {
                                this.pendingClip = EO_CLIP;
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                this.current.textMatrix = _util.IDENTITY_MATRIX;
                                this.current.textMatrixScale = 1;
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var paths = this.pendingTextPaths;
                                var ctx = this.ctx;
                                if (paths === undefined) {
                                    ctx.beginPath();
                                    return;
                                }
                                ctx.save();
                                ctx.beginPath();
                                for(var i = 0; i < paths.length; i++){
                                    var path = paths[i];
                                    ctx.setTransform.apply(ctx, path.transform);
                                    ctx.translate(path.x, path.y);
                                    path.addToPath(ctx, path.fontSize);
                                }
                                ctx.restore();
                                ctx.clip();
                                ctx.beginPath();
                                delete this.pendingTextPaths;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(spacing) {
                                this.current.charSpacing = spacing;
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(spacing) {
                                this.current.wordSpacing = spacing;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(fontRefName, size) {
                                var fontObj = this.commonObjs.get(fontRefName);
                                var current = this.current;
                                if (!fontObj) throw new Error("Can't find font for ".concat(fontRefName));
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                this.current.font = fontObj;
                                this.current.fontSize = size;
                                if (fontObj.isType3Font) return;
                                var name = fontObj.loadedName || "sans-serif";
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                var typeface = "\"".concat(name, "\", ").concat(fontObj.fallbackName);
                                var browserFontSize = size;
                                if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                                else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                                this.current.fontSizeScale = size / browserFontSize;
                                this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(mode) {
                                this.current.textRenderingMode = mode;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(rise) {
                                this.current.textRise = rise;
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                this.current.x = this.current.lineX += x;
                                this.current.y = this.current.lineY += y;
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                this.current.textMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.current.textMatrixScale = Math.hypot(a, b);
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "paintChar",
                            value: function paintChar(character, x, y, patternTransform, resetLineWidthToOne) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var textRenderingMode = current.textRenderingMode;
                                var fontSize = current.fontSize / current.fontSizeScale;
                                var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                                var patternFill = current.patternFill && !font.missingFile;
                                var addToPath;
                                if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                                if (font.disableFontFace || patternFill) {
                                    ctx.save();
                                    ctx.translate(x, y);
                                    ctx.beginPath();
                                    addToPath(ctx, fontSize);
                                    if (patternTransform) ctx.setTransform.apply(ctx, patternTransform);
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne) {
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                        }
                                        ctx.stroke();
                                    }
                                    ctx.restore();
                                } else {
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne) {
                                            ctx.save();
                                            ctx.moveTo(x, y);
                                            ctx.resetTransform();
                                            ctx.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx.strokeText(character, 0, 0);
                                            ctx.restore();
                                        } else ctx.strokeText(character, x, y);
                                    }
                                }
                                if (isAddToPathSet) {
                                    var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                                    paths.push({
                                        transform: ctx.mozCurrentTransform,
                                        x: x,
                                        y: y,
                                        fontSize: fontSize,
                                        addToPath: addToPath
                                    });
                                }
                            }
                        },
                        {
                            key: "isFontSubpixelAAEnabled",
                            get: function get() {
                                var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10), ctx = _this$cachedCanvases$.context;
                                ctx.scale(1.5, 1);
                                ctx.fillText("I", 0, 10);
                                var data = ctx.getImageData(0, 0, 10, 10).data;
                                var enabled = false;
                                for(var i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                                    enabled = true;
                                    break;
                                }
                                return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var current = this.current;
                                var font = current.font;
                                if (font.isType3Font) return this.showType3Text(glyphs);
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return undefined;
                                var ctx = this.ctx;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var glyphsLength = glyphs.length;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                                ctx.save();
                                ctx.transform.apply(ctx, current.textMatrix);
                                ctx.translate(current.x, current.y + current.textRise);
                                if (fontDirection > 0) ctx.scale(textHScale, -1);
                                else ctx.scale(textHScale, 1);
                                var patternTransform;
                                if (current.patternFill) {
                                    ctx.save();
                                    var pattern = current.fillColor.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL);
                                    patternTransform = ctx.mozCurrentTransform;
                                    ctx.restore();
                                    ctx.fillStyle = pattern;
                                }
                                var lineWidth = current.lineWidth;
                                var resetLineWidthToOne = false;
                                var scale = current.textMatrixScale;
                                if (scale === 0 || lineWidth === 0) {
                                    var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                        this._cachedGetSinglePixelWidth = null;
                                        lineWidth = this.getSinglePixelWidth();
                                        resetLineWidthToOne = lineWidth < 0;
                                    }
                                } else lineWidth /= scale;
                                if (fontSizeScale !== 1.0) {
                                    ctx.scale(fontSizeScale, fontSizeScale);
                                    lineWidth /= fontSizeScale;
                                }
                                ctx.lineWidth = lineWidth;
                                var x = 0, i;
                                for(i = 0; i < glyphsLength; ++i){
                                    var glyph = glyphs[i];
                                    if ((0, _util.isNum)(glyph)) {
                                        x += spacingDir * glyph * fontSize / 1000;
                                        continue;
                                    }
                                    var restoreNeeded = false;
                                    var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                    var character = glyph.fontChar;
                                    var accent = glyph.accent;
                                    var scaledX = void 0, scaledY = void 0;
                                    var width = glyph.width;
                                    if (vertical) {
                                        var vmetric = glyph.vmetric || defaultVMetrics;
                                        var vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                        var vy = vmetric[2] * widthAdvanceScale;
                                        width = vmetric ? -vmetric[0] : width;
                                        scaledX = vx / fontSizeScale;
                                        scaledY = (x + vy) / fontSizeScale;
                                    } else {
                                        scaledX = x / fontSizeScale;
                                        scaledY = 0;
                                    }
                                    if (font.remeasure && width > 0) {
                                        var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                        if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                            var characterScaleX = width / measuredWidth;
                                            restoreNeeded = true;
                                            ctx.save();
                                            ctx.scale(characterScaleX, 1);
                                            scaledX /= characterScaleX;
                                        } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                                    }
                                    if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                        if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                        else {
                                            this.paintChar(character, scaledX, scaledY, patternTransform, resetLineWidthToOne);
                                            if (accent) {
                                                var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                                var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                                this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform, resetLineWidthToOne);
                                            }
                                        }
                                    }
                                    var charWidth = void 0;
                                    if (vertical) charWidth = width * widthAdvanceScale - spacing * fontDirection;
                                    else charWidth = width * widthAdvanceScale + spacing * fontDirection;
                                    x += charWidth;
                                    if (restoreNeeded) ctx.restore();
                                }
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                ctx.restore();
                                this.compose();
                                return undefined;
                            }
                        },
                        {
                            key: "showType3Text",
                            value: function showType3Text(glyphs) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                var fontDirection = current.fontDirection;
                                var spacingDir = font.vertical ? 1 : -1;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var textHScale = current.textHScale * fontDirection;
                                var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var glyphsLength = glyphs.length;
                                var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                                var i, glyph, width, spacingLength;
                                if (isTextInvisible || fontSize === 0) return;
                                this._cachedGetSinglePixelWidth = null;
                                ctx.save();
                                ctx.transform.apply(ctx, current.textMatrix);
                                ctx.translate(current.x, current.y);
                                ctx.scale(textHScale, fontDirection);
                                for(i = 0; i < glyphsLength; ++i){
                                    glyph = glyphs[i];
                                    if ((0, _util.isNum)(glyph)) {
                                        spacingLength = spacingDir * glyph * fontSize / 1000;
                                        this.ctx.translate(spacingLength, 0);
                                        current.x += spacingLength * textHScale;
                                        continue;
                                    }
                                    var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                    var operatorList = font.charProcOperatorList[glyph.operatorListId];
                                    if (!operatorList) {
                                        (0, _util.warn)("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
                                        continue;
                                    }
                                    if (this.contentVisible) {
                                        this.processingType3 = glyph;
                                        this.save();
                                        ctx.scale(fontSize, fontSize);
                                        ctx.transform.apply(ctx, fontMatrix);
                                        this.executeOperatorList(operatorList);
                                        this.restore();
                                    }
                                    var transformed = _util.Util.applyTransform([
                                        glyph.width,
                                        0
                                    ], fontMatrix);
                                    width = transformed[0] * fontSize + spacing;
                                    ctx.translate(width, 0);
                                    current.x += width * textHScale;
                                }
                                ctx.restore();
                                this.processingType3 = null;
                            }
                        },
                        {
                            key: "setCharWidth",
                            value: function setCharWidth(xWidth, yWidth) {}
                        },
                        {
                            key: "setCharWidthAndBounds",
                            value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                                this.clip();
                                this.endPath();
                            }
                        },
                        {
                            key: "getColorN_Pattern",
                            value: function getColorN_Pattern(IR) {
                                var _this = this;
                                var pattern;
                                if (IR[0] === "TilingPattern") {
                                    var color = IR[1];
                                    var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                                    var canvasGraphicsFactory = {
                                        createCanvasGraphics: function createCanvasGraphics(ctx) {
                                            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
                                        }
                                    };
                                    pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                                } else pattern = this._getPattern(IR[1], IR[2]);
                                return pattern;
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN() {
                                this.current.strokeColor = this.getColorN_Pattern(arguments);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN() {
                                this.current.fillColor = this.getColorN_Pattern(arguments);
                                this.current.patternFill = true;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.strokeStyle = color;
                                this.current.strokeColor = color;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.fillStyle = color;
                                this.current.fillColor = color;
                                this.current.patternFill = false;
                            }
                        },
                        {
                            key: "_getPattern",
                            value: function _getPattern(objId) {
                                var matrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var pattern;
                                if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                                else {
                                    pattern = (0, _pattern_helper.getShadingPattern)(this.objs.get(objId));
                                    this.cachedPatterns.set(objId, pattern);
                                }
                                if (matrix) pattern.matrix = matrix;
                                return pattern;
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(objId) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                this.save();
                                var pattern = this._getPattern(objId);
                                ctx.fillStyle = pattern.getPattern(ctx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.SHADING);
                                var inv = ctx.mozCurrentTransformInverse;
                                if (inv) {
                                    var canvas = ctx.canvas;
                                    var width = canvas.width;
                                    var height = canvas.height;
                                    var bl = _util.Util.applyTransform([
                                        0,
                                        0
                                    ], inv);
                                    var br = _util.Util.applyTransform([
                                        0,
                                        height
                                    ], inv);
                                    var ul = _util.Util.applyTransform([
                                        width,
                                        0
                                    ], inv);
                                    var ur = _util.Util.applyTransform([
                                        width,
                                        height
                                    ], inv);
                                    var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                                    var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                                    var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                                    var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                                    this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                                } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                                this.compose(this.current.getClippedPathBoundingBox());
                                this.restore();
                            }
                        },
                        {
                            key: "beginInlineImage",
                            value: function beginInlineImage() {
                                (0, _util.unreachable)("Should not call beginInlineImage");
                            }
                        },
                        {
                            key: "beginImageData",
                            value: function beginImageData() {
                                (0, _util.unreachable)("Should not call beginImageData");
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (!this.contentVisible) return;
                                this.save();
                                this.baseTransformStack.push(this.baseTransform);
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform.apply(this, matrix);
                                this.baseTransform = this.ctx.mozCurrentTransform;
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    this.ctx.rect(bbox[0], bbox[1], width, height);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[0], bbox[1]);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox[2], bbox[3]);
                                    this.clip();
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {
                                if (!this.contentVisible) return;
                                this.restore();
                                this.baseTransform = this.baseTransformStack.pop();
                            }
                        },
                        {
                            key: "beginGroup",
                            value: function beginGroup(group) {
                                if (!this.contentVisible) return;
                                this.save();
                                var suspendedCtx = this.suspendedCtx;
                                if (this.current.activeSMask) {
                                    this.suspendedCtx = null;
                                    this.current.activeSMask = null;
                                }
                                var currentCtx = this.ctx;
                                if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                                if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                                var currentTransform = currentCtx.mozCurrentTransform;
                                if (group.matrix) currentCtx.transform.apply(currentCtx, group.matrix);
                                if (!group.bbox) throw new Error("Bounding box is required.");
                                var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
                                var canvasBounds = [
                                    0,
                                    0,
                                    currentCtx.canvas.width,
                                    currentCtx.canvas.height
                                ];
                                bounds = _util.Util.intersect(bounds, canvasBounds) || [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                var offsetX = Math.floor(bounds[0]);
                                var offsetY = Math.floor(bounds[1]);
                                var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                                var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                                var scaleX = 1, scaleY = 1;
                                if (drawnWidth > MAX_GROUP_SIZE) {
                                    scaleX = drawnWidth / MAX_GROUP_SIZE;
                                    drawnWidth = MAX_GROUP_SIZE;
                                }
                                if (drawnHeight > MAX_GROUP_SIZE) {
                                    scaleY = drawnHeight / MAX_GROUP_SIZE;
                                    drawnHeight = MAX_GROUP_SIZE;
                                }
                                this.current.startNewPathAndClipBox([
                                    0,
                                    0,
                                    drawnWidth,
                                    drawnHeight
                                ]);
                                var cacheId = "groupAt" + this.groupLevel;
                                if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                                var groupCtx = scratchCanvas.context;
                                groupCtx.scale(1 / scaleX, 1 / scaleY);
                                groupCtx.translate(-offsetX, -offsetY);
                                groupCtx.transform.apply(groupCtx, currentTransform);
                                if (group.smask) this.smaskStack.push({
                                    canvas: scratchCanvas.canvas,
                                    context: groupCtx,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    scaleX: scaleX,
                                    scaleY: scaleY,
                                    subtype: group.smask.subtype,
                                    backdrop: group.smask.backdrop,
                                    transferMap: group.smask.transferMap || null,
                                    startTransformInverse: null
                                });
                                else {
                                    currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                                    currentCtx.translate(offsetX, offsetY);
                                    currentCtx.scale(scaleX, scaleY);
                                    currentCtx.save();
                                }
                                copyCtxState(currentCtx, groupCtx);
                                this.ctx = groupCtx;
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                                this.groupStack.push({
                                    ctx: currentCtx,
                                    suspendedCtx: suspendedCtx
                                });
                                this.groupLevel++;
                            }
                        },
                        {
                            key: "endGroup",
                            value: function endGroup(group) {
                                if (!this.contentVisible) return;
                                this.groupLevel--;
                                var groupCtx = this.ctx;
                                var _this$groupStack$pop = this.groupStack.pop(), ctx = _this$groupStack$pop.ctx, suspendedCtx = _this$groupStack$pop.suspendedCtx;
                                this.ctx = ctx;
                                this.ctx.imageSmoothingEnabled = false;
                                if (suspendedCtx) this.suspendedCtx = suspendedCtx;
                                if (group.smask) {
                                    this.tempSMask = this.smaskStack.pop();
                                    this.restore();
                                } else {
                                    this.ctx.restore();
                                    var currentMtx = this.ctx.mozCurrentTransform;
                                    this.restore();
                                    this.ctx.save();
                                    this.ctx.setTransform.apply(this.ctx, currentMtx);
                                    var dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        groupCtx.canvas.width,
                                        groupCtx.canvas.height
                                    ], currentMtx);
                                    this.ctx.drawImage(groupCtx.canvas, 0, 0);
                                    this.ctx.restore();
                                    this.compose(dirtyBox);
                                }
                            }
                        },
                        {
                            key: "beginAnnotations",
                            value: function beginAnnotations() {
                                this.save();
                                if (this.baseTransform) this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                            }
                        },
                        {
                            key: "endAnnotations",
                            value: function endAnnotations() {
                                this.restore();
                            }
                        },
                        {
                            key: "beginAnnotation",
                            value: function beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                                this.save();
                                if (Array.isArray(rect) && rect.length === 4) {
                                    var width = rect[2] - rect[0];
                                    var height = rect[3] - rect[1];
                                    if (hasOwnCanvas && this.annotationCanvasMap) {
                                        transform = transform.slice();
                                        transform[4] -= rect[0];
                                        transform[5] -= rect[1];
                                        rect = rect.slice();
                                        rect[0] = rect[1] = 0;
                                        rect[2] = width;
                                        rect[3] = height;
                                        var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(this.ctx.mozCurrentTransform), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                                        var viewportScale = this.viewportScale;
                                        var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                        var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                        this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                        var _this$annotationCanva = this.annotationCanvas, canvas = _this$annotationCanva.canvas, context = _this$annotationCanva.context;
                                        canvas.style.width = "calc(".concat(width, "px * var(--viewport-scale-factor))");
                                        canvas.style.height = "calc(".concat(height, "px * var(--viewport-scale-factor))");
                                        this.annotationCanvasMap.set(id, canvas);
                                        this.annotationCanvas.savedCtx = this.ctx;
                                        this.ctx = context;
                                        this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                        addContextCurrentTransform(this.ctx);
                                        resetCtxToDefault(this.ctx);
                                    } else {
                                        resetCtxToDefault(this.ctx);
                                        this.ctx.rect(rect[0], rect[1], width, height);
                                        this.clip();
                                        this.endPath();
                                    }
                                }
                                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                                this.transform.apply(this, transform);
                                this.transform.apply(this, matrix);
                            }
                        },
                        {
                            key: "endAnnotation",
                            value: function endAnnotation() {
                                if (this.annotationCanvas) {
                                    this.ctx = this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas;
                                }
                                this.restore();
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(img) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var width = img.width, height = img.height;
                                var glyph = this.processingType3;
                                if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
                                    if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) glyph.compiled = compileType3Glyph({
                                        data: img.data,
                                        width: width,
                                        height: height
                                    });
                                    else glyph.compiled = null;
                                }
                                if (glyph !== null && glyph !== void 0 && glyph.compiled) {
                                    glyph.compiled(ctx);
                                    return;
                                }
                                var mask = this._createMaskCanvas(img);
                                var maskCanvas = mask.canvas;
                                ctx.save();
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectRepeat",
                            value: function paintImageMaskXObjectRepeat(imgData, scaleX) {
                                var skewX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                                var skewY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                                var scaleY = arguments.length > 4 ? arguments[4] : undefined;
                                var positions = arguments.length > 5 ? arguments[5] : undefined;
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                ctx.save();
                                var currentTransform = ctx.mozCurrentTransform;
                                ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                                var mask = this._createMaskCanvas(imgData);
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                for(var i = 0, ii = positions.length; i < ii; i += 2){
                                    var trans = _util.Util.transform(currentTransform, [
                                        scaleX,
                                        skewX,
                                        skewY,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ]);
                                    var _Util$applyTransform3 = _util.Util.applyTransform([
                                        0,
                                        0
                                    ], trans), _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2), x = _Util$applyTransform4[0], y = _Util$applyTransform4[1];
                                    ctx.drawImage(mask.canvas, x, y);
                                }
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectGroup",
                            value: function paintImageMaskXObjectGroup(images) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                for(var i = 0, ii = images.length; i < ii; i++){
                                    var image = images[i];
                                    var width = image.width, height = image.height;
                                    var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                    var maskCtx = maskCanvas.context;
                                    maskCtx.save();
                                    putBinaryImageMask(maskCtx, image);
                                    maskCtx.globalCompositeOperation = "source-in";
                                    maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, ctx.mozCurrentTransformInverse, _pattern_helper.PathType.FILL) : fillColor;
                                    maskCtx.fillRect(0, 0, width, height);
                                    maskCtx.restore();
                                    ctx.save();
                                    ctx.transform.apply(ctx, image.transform);
                                    ctx.scale(1, -1);
                                    ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                                    ctx.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                if (!this.contentVisible) return;
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintImageXObjectRepeat",
                            value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                                if (!this.contentVisible) return;
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                var width = imgData.width;
                                var height = imgData.height;
                                var map = [];
                                for(var i = 0, ii = positions.length; i < ii; i += 2)map.push({
                                    transform: [
                                        scaleX,
                                        0,
                                        0,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ],
                                    x: 0,
                                    y: 0,
                                    w: width,
                                    h: height
                                });
                                this.paintInlineImageXObjectGroup(imgData, map);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData) {
                                if (!this.contentVisible) return;
                                var width = imgData.width;
                                var height = imgData.height;
                                var ctx = this.ctx;
                                this.save();
                                ctx.scale(1 / width, -1 / height);
                                var imgToPaint;
                                if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                                else {
                                    var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                                    var tmpCtx = tmpCanvas.context;
                                    putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                                    imgToPaint = tmpCanvas.canvas;
                                }
                                var scaled = this._scaleImage(imgToPaint, ctx.mozCurrentTransformInverse);
                                ctx.imageSmoothingEnabled = getImageSmoothingEnabled(ctx.mozCurrentTransform, imgData.interpolate);
                                ctx.drawImage(scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                                if (this.imageLayer) {
                                    var position = this.getCanvasPosition(0, -height);
                                    this.imageLayer.appendImage({
                                        imgData: imgData,
                                        left: position[0],
                                        top: position[1],
                                        width: width / ctx.mozCurrentTransformInverse[0],
                                        height: height / ctx.mozCurrentTransformInverse[3]
                                    });
                                }
                                this.compose();
                                this.restore();
                            }
                        },
                        {
                            key: "paintInlineImageXObjectGroup",
                            value: function paintInlineImageXObjectGroup(imgData, map) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var w = imgData.width;
                                var h = imgData.height;
                                var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                                var tmpCtx = tmpCanvas.context;
                                putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                                for(var i = 0, ii = map.length; i < ii; i++){
                                    var entry = map[i];
                                    ctx.save();
                                    ctx.transform.apply(ctx, entry.transform);
                                    ctx.scale(1, -1);
                                    ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                                    if (this.imageLayer) {
                                        var position = this.getCanvasPosition(entry.x, entry.y);
                                        this.imageLayer.appendImage({
                                            imgData: imgData,
                                            left: position[0],
                                            top: position[1],
                                            width: w,
                                            height: h
                                        });
                                    }
                                    ctx.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                if (!this.contentVisible) return;
                                this.ctx.fillRect(0, 0, 1, 1);
                                this.compose();
                            }
                        },
                        {
                            key: "markPoint",
                            value: function markPoint(tag) {}
                        },
                        {
                            key: "markPointProps",
                            value: function markPointProps(tag, properties) {}
                        },
                        {
                            key: "beginMarkedContent",
                            value: function beginMarkedContent(tag) {
                                this.markedContentStack.push({
                                    visible: true
                                });
                            }
                        },
                        {
                            key: "beginMarkedContentProps",
                            value: function beginMarkedContentProps(tag, properties) {
                                if (tag === "OC") this.markedContentStack.push({
                                    visible: this.optionalContentConfig.isVisible(properties)
                                });
                                else this.markedContentStack.push({
                                    visible: true
                                });
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "endMarkedContent",
                            value: function endMarkedContent() {
                                this.markedContentStack.pop();
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "beginCompat",
                            value: function beginCompat() {}
                        },
                        {
                            key: "endCompat",
                            value: function endCompat() {}
                        },
                        {
                            key: "consumePath",
                            value: function consumePath(clipBox) {
                                if (this.pendingClip) this.current.updateClipFromPath();
                                if (!this.pendingClip) this.compose(clipBox);
                                var ctx = this.ctx;
                                if (this.pendingClip) {
                                    if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                    else ctx.clip();
                                    this.pendingClip = null;
                                }
                                this.current.startNewPathAndClipBox(this.current.clipBox);
                                ctx.beginPath();
                            }
                        },
                        {
                            key: "getSinglePixelWidth",
                            value: function getSinglePixelWidth() {
                                if (this._cachedGetSinglePixelWidth === null) {
                                    var m = this.ctx.mozCurrentTransform;
                                    var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                    var sqNorm1 = Math.pow(m[0], 2) + Math.pow(m[2], 2);
                                    var sqNorm2 = Math.pow(m[1], 2) + Math.pow(m[3], 2);
                                    var pixelHeight = Math.sqrt(Math.max(sqNorm1, sqNorm2)) / absDet;
                                    if (sqNorm1 !== sqNorm2 && this._combinedScaleFactor * pixelHeight > 1) this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight);
                                    else if (absDet > Number.EPSILON) this._cachedGetSinglePixelWidth = pixelHeight;
                                    else this._cachedGetSinglePixelWidth = 1;
                                }
                                return this._cachedGetSinglePixelWidth;
                            }
                        },
                        {
                            key: "getCanvasPosition",
                            value: function getCanvasPosition(x, y) {
                                var transform = this.ctx.mozCurrentTransform;
                                return [
                                    transform[0] * x + transform[2] * y + transform[4],
                                    transform[1] * x + transform[3] * y + transform[5]
                                ];
                            }
                        },
                        {
                            key: "isContentVisible",
                            value: function isContentVisible() {
                                for(var i = this.markedContentStack.length - 1; i >= 0; i--){
                                    if (!this.markedContentStack[i].visible) return false;
                                }
                                return true;
                            }
                        }
                    ]);
                    return CanvasGraphics;
                }();
                exports.CanvasGraphics = CanvasGraphics;
                for(var op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 141 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(4);
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox || typeof Path2D === "undefined") return;
                    var width = bbox[2] - bbox[0];
                    var height = bbox[3] - bbox[1];
                    var region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                var BaseShadingPattern = /*#__PURE__*/ function() {
                    function BaseShadingPattern() {
                        _classCallCheck(this, BaseShadingPattern);
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    _createClass(BaseShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                (0, _util.unreachable)("Abstract method `getPattern` called.");
                            }
                        }
                    ]);
                    return BaseShadingPattern;
                }();
                var RadialAxialShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern) {
                    _inherits(RadialAxialShadingPattern, _BaseShadingPattern);
                    var _super = _createSuper(RadialAxialShadingPattern);
                    function RadialAxialShadingPattern(IR) {
                        var _this;
                        _classCallCheck(this, RadialAxialShadingPattern);
                        _this = _super.call(this);
                        _this._type = IR[1];
                        _this._bbox = IR[2];
                        _this._colorStops = IR[3];
                        _this._p0 = IR[4];
                        _this._p1 = IR[5];
                        _this._r0 = IR[6];
                        _this._r1 = IR[7];
                        _this.matrix = null;
                        return _this;
                    }
                    _createClass(RadialAxialShadingPattern, [
                        {
                            key: "_createGradient",
                            value: function _createGradient(ctx) {
                                var grad;
                                if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                                else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                                var _iterator = _createForOfIteratorHelper(this._colorStops), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var colorStop = _step.value;
                                        grad.addColorStop(colorStop[0], colorStop[1]);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                return grad;
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var pattern;
                                if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                                    var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, ctx.mozCurrentTransform) || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                                    var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                                    var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                                    var tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.beginPath();
                                    tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                                    inverse = _util.Util.transform(inverse, [
                                        1,
                                        0,
                                        0,
                                        1,
                                        ownerBBox[0],
                                        ownerBBox[1]
                                    ]);
                                    tmpCtx.transform.apply(tmpCtx, owner.baseTransform);
                                    if (this.matrix) tmpCtx.transform.apply(tmpCtx, this.matrix);
                                    applyBoundingBox(tmpCtx, this._bbox);
                                    tmpCtx.fillStyle = this._createGradient(tmpCtx);
                                    tmpCtx.fill();
                                    pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                                    var domMatrix = new DOMMatrix(inverse);
                                    try {
                                        pattern.setTransform(domMatrix);
                                    } catch (ex) {
                                        (0, _util.warn)("RadialAxialShadingPattern.getPattern: \"".concat(ex === null || ex === void 0 ? void 0 : ex.message, "\"."));
                                    }
                                } else {
                                    applyBoundingBox(ctx, this._bbox);
                                    pattern = this._createGradient(ctx);
                                }
                                return pattern;
                            }
                        }
                    ]);
                    return RadialAxialShadingPattern;
                }(BaseShadingPattern);
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    var coords = context.coords, colors = context.colors;
                    var bytes = data.data, rowSize = data.width * 4;
                    var tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    var c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    var c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    var c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    var minY = Math.round(y1), maxY = Math.round(y3);
                    var xa, car, cag, cab;
                    var xb, cbr, cbg, cbb;
                    for(var y = minY; y <= maxY; y++){
                        if (y < y2) {
                            var _k = void 0;
                            if (y < y1) _k = 0;
                            else _k = (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * _k;
                            car = c1r - (c1r - c2r) * _k;
                            cag = c1g - (c1g - c2g) * _k;
                            cab = c1b - (c1b - c2b) * _k;
                        } else {
                            var _k2 = void 0;
                            if (y > y3) _k2 = 1;
                            else if (y2 === y3) _k2 = 0;
                            else _k2 = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * _k2;
                            car = c2r - (c2r - c3r) * _k2;
                            cag = c2g - (c2g - c3g) * _k2;
                            cab = c2b - (c2b - c3b) * _k2;
                        }
                        var k = void 0;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        var x1_ = Math.round(Math.min(xa, xb));
                        var x2_ = Math.round(Math.max(xa, xb));
                        var j = rowSize * y + x1_ * 4;
                        for(var x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    var ps = figure.coords;
                    var cs = figure.colors;
                    var i, ii;
                    switch(figure.type){
                        case "lattice":
                            var verticesPerRow = figure.verticesPerRow;
                            var rows = Math.floor(ps.length / verticesPerRow) - 1;
                            var cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                var q = i * verticesPerRow;
                                for(var j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                var MeshShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern2) {
                    _inherits(MeshShadingPattern, _BaseShadingPattern2);
                    var _super2 = _createSuper(MeshShadingPattern);
                    function MeshShadingPattern(IR) {
                        var _this2;
                        _classCallCheck(this, MeshShadingPattern);
                        _this2 = _super2.call(this);
                        _this2._coords = IR[2];
                        _this2._colors = IR[3];
                        _this2._figures = IR[4];
                        _this2._bounds = IR[5];
                        _this2._bbox = IR[7];
                        _this2._background = IR[8];
                        _this2.matrix = null;
                        return _this2;
                    }
                    _createClass(MeshShadingPattern, [
                        {
                            key: "_createMeshCanvas",
                            value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                                var EXPECTED_SCALE = 1.1;
                                var MAX_PATTERN_SIZE = 3000;
                                var BORDER_SIZE = 2;
                                var offsetX = Math.floor(this._bounds[0]);
                                var offsetY = Math.floor(this._bounds[1]);
                                var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                                var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                                var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var scaleX = boundsWidth / width;
                                var scaleY = boundsHeight / height;
                                var context = {
                                    coords: this._coords,
                                    colors: this._colors,
                                    offsetX: -offsetX,
                                    offsetY: -offsetY,
                                    scaleX: 1 / scaleX,
                                    scaleY: 1 / scaleY
                                };
                                var paddedWidth = width + BORDER_SIZE * 2;
                                var paddedHeight = height + BORDER_SIZE * 2;
                                var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                                var tmpCtx = tmpCanvas.context;
                                var data = tmpCtx.createImageData(width, height);
                                if (backgroundColor) {
                                    var bytes = data.data;
                                    for(var i = 0, ii = bytes.length; i < ii; i += 4){
                                        bytes[i] = backgroundColor[0];
                                        bytes[i + 1] = backgroundColor[1];
                                        bytes[i + 2] = backgroundColor[2];
                                        bytes[i + 3] = 255;
                                    }
                                }
                                var _iterator2 = _createForOfIteratorHelper(this._figures), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var figure = _step2.value;
                                        drawFigure(data, figure, context);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                                var canvas = tmpCanvas.canvas;
                                return {
                                    canvas: canvas,
                                    offsetX: offsetX - BORDER_SIZE * scaleX,
                                    offsetY: offsetY - BORDER_SIZE * scaleY,
                                    scaleX: scaleX,
                                    scaleY: scaleY
                                };
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                applyBoundingBox(ctx, this._bbox);
                                var scale;
                                if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
                                else {
                                    scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                                    if (this.matrix) {
                                        var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                        scale = [
                                            scale[0] * matrixScale[0],
                                            scale[1] * matrixScale[1]
                                        ];
                                    }
                                }
                                var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                                if (pathType !== PathType.SHADING) {
                                    ctx.setTransform.apply(ctx, owner.baseTransform);
                                    if (this.matrix) ctx.transform.apply(ctx, this.matrix);
                                }
                                ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                                return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                            }
                        }
                    ]);
                    return MeshShadingPattern;
                }(BaseShadingPattern);
                var DummyShadingPattern = /*#__PURE__*/ function(_BaseShadingPattern3) {
                    _inherits(DummyShadingPattern, _BaseShadingPattern3);
                    var _super3 = _createSuper(DummyShadingPattern);
                    function DummyShadingPattern() {
                        _classCallCheck(this, DummyShadingPattern);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(DummyShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                return "hotpink";
                            }
                        }
                    ]);
                    return DummyShadingPattern;
                }(BaseShadingPattern);
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error("Unknown IR type: ".concat(IR[0]));
                }
                var PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                var TilingPattern = /*#__PURE__*/ function() {
                    function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
                        _classCallCheck(this, TilingPattern);
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    _createClass(TilingPattern, [
                        {
                            key: "createPatternCanvas",
                            value: function createPatternCanvas(owner) {
                                var operatorList = this.operatorList;
                                var bbox = this.bbox;
                                var xstep = this.xstep;
                                var ystep = this.ystep;
                                var paintType = this.paintType;
                                var tilingType = this.tilingType;
                                var color = this.color;
                                var canvasGraphicsFactory = this.canvasGraphicsFactory;
                                (0, _util.info)("TilingType: " + tilingType);
                                var x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                                var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                                var combinedScale = [
                                    matrixScale[0] * curMatrixScale[0],
                                    matrixScale[1] * curMatrixScale[1]
                                ];
                                var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                                var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                                var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                                var tmpCtx = tmpCanvas.context;
                                var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                                graphics.groupLevel = owner.groupLevel;
                                this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                                var adjustedX0 = x0;
                                var adjustedY0 = y0;
                                var adjustedX1 = x1;
                                var adjustedY1 = y1;
                                if (x0 < 0) {
                                    adjustedX0 = 0;
                                    adjustedX1 += Math.abs(x0);
                                }
                                if (y0 < 0) {
                                    adjustedY0 = 0;
                                    adjustedY1 += Math.abs(y0);
                                }
                                tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                                this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                                graphics.baseTransform = graphics.ctx.mozCurrentTransform.slice();
                                graphics.executeOperatorList(operatorList);
                                graphics.endDrawing();
                                return {
                                    canvas: tmpCanvas.canvas,
                                    scaleX: dimx.scale,
                                    scaleY: dimy.scale,
                                    offsetX: adjustedX0,
                                    offsetY: adjustedY0
                                };
                            }
                        },
                        {
                            key: "getSizeAndScale",
                            value: function getSizeAndScale(step, realOutputSize, scale) {
                                step = Math.abs(step);
                                var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                                var size = Math.ceil(step * scale);
                                if (size >= maxSize) size = maxSize;
                                else scale = size / step;
                                return {
                                    scale: scale,
                                    size: size
                                };
                            }
                        },
                        {
                            key: "clipBbox",
                            value: function clipBbox(graphics, x0, y0, x1, y1) {
                                var bboxWidth = x1 - x0;
                                var bboxHeight = y1 - y0;
                                graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                                graphics.clip();
                                graphics.endPath();
                            }
                        },
                        {
                            key: "setFillAndStrokeStyleToContext",
                            value: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
                                var context = graphics.ctx, current = graphics.current;
                                switch(paintType){
                                    case PaintType.COLORED:
                                        var ctx = this.ctx;
                                        context.fillStyle = ctx.fillStyle;
                                        context.strokeStyle = ctx.strokeStyle;
                                        current.fillColor = ctx.fillStyle;
                                        current.strokeColor = ctx.strokeStyle;
                                        break;
                                    case PaintType.UNCOLORED:
                                        var cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                        context.fillStyle = cssColor;
                                        context.strokeStyle = cssColor;
                                        current.fillColor = cssColor;
                                        current.strokeColor = cssColor;
                                        break;
                                    default:
                                        throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
                                }
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var matrix = inverse;
                                if (pathType !== PathType.SHADING) {
                                    matrix = _util.Util.transform(matrix, owner.baseTransform);
                                    if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                                }
                                var temporaryPatternCanvas = this.createPatternCanvas(owner);
                                var domMatrix = new DOMMatrix(matrix);
                                domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                                var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                                try {
                                    pattern.setTransform(domMatrix);
                                } catch (ex) {
                                    (0, _util.warn)("TilingPattern.getPattern: \"".concat(ex === null || ex === void 0 ? void 0 : ex.message, "\"."));
                                }
                                return pattern;
                            }
                        }
                    ], [
                        {
                            key: "MAX_PATTERN_SIZE",
                            get: function get() {
                                return (0, _util.shadow)(this, "MAX_PATTERN_SIZE", 3000);
                            }
                        }
                    ]);
                    return TilingPattern;
                }();
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 142 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                var GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort;
                GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? "" : GlobalWorkerOptions.workerSrc;
            /***/ },
            /* 143 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                var StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || _typeof(reason) === "object" && reason !== null)) {
                        (0, _util.warn)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                        return reason;
                    }
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                var MessageHandler = /*#__PURE__*/ function() {
                    function MessageHandler(sourceName, targetName, comObj) {
                        var _this = this;
                        _classCallCheck(this, MessageHandler);
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = function(event) {
                            var data = event.data;
                            if (data.targetName !== _this.sourceName) return;
                            if (data.stream) {
                                _this._processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                var callbackId = data.callbackId;
                                var capability = _this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error("Cannot resolve callback ".concat(callbackId));
                                delete _this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            var action = _this.actionHandler[data.action];
                            if (!action) throw new Error("Unknown action from worker: ".concat(data.action));
                            if (data.callbackId) {
                                var cbSourceName = _this.sourceName;
                                var cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                _this._createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    _createClass(MessageHandler, [
                        {
                            key: "on",
                            value: function on(actionName, handler) {
                                var ah = this.actionHandler;
                                if (ah[actionName]) throw new Error("There is already an actionName called \"".concat(actionName, "\""));
                                ah[actionName] = handler;
                            }
                        },
                        {
                            key: "send",
                            value: function send(actionName, data, transfers) {
                                this.comObj.postMessage({
                                    sourceName: this.sourceName,
                                    targetName: this.targetName,
                                    action: actionName,
                                    data: data
                                }, transfers);
                            }
                        },
                        {
                            key: "sendWithPromise",
                            value: function sendWithPromise(actionName, data, transfers) {
                                var callbackId = this.callbackId++;
                                var capability = (0, _util.createPromiseCapability)();
                                this.callbackCapabilities[callbackId] = capability;
                                try {
                                    this.comObj.postMessage({
                                        sourceName: this.sourceName,
                                        targetName: this.targetName,
                                        action: actionName,
                                        callbackId: callbackId,
                                        data: data
                                    }, transfers);
                                } catch (ex) {
                                    capability.reject(ex);
                                }
                                return capability.promise;
                            }
                        },
                        {
                            key: "sendWithStream",
                            value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
                                var _this2 = this;
                                var streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                                return new ReadableStream({
                                    start: function start(controller) {
                                        var startCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId] = {
                                            controller: controller,
                                            startCall: startCapability,
                                            pullCall: null,
                                            cancelCall: null,
                                            isClosed: false
                                        };
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            action: actionName,
                                            streamId: streamId,
                                            data: data,
                                            desiredSize: controller.desiredSize
                                        }, transfers);
                                        return startCapability.promise;
                                    },
                                    pull: function pull(controller) {
                                        var pullCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId].pullCall = pullCapability;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.PULL,
                                            streamId: streamId,
                                            desiredSize: controller.desiredSize
                                        });
                                        return pullCapability.promise;
                                    },
                                    cancel: function cancel(reason) {
                                        (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                        var cancelCapability = (0, _util.createPromiseCapability)();
                                        _this2.streamControllers[streamId].cancelCall = cancelCapability;
                                        _this2.streamControllers[streamId].isClosed = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.CANCEL,
                                            streamId: streamId,
                                            reason: wrapReason(reason)
                                        });
                                        return cancelCapability.promise;
                                    }
                                }, queueingStrategy);
                            }
                        },
                        {
                            key: "_createStreamSink",
                            value: function _createStreamSink(data) {
                                var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                                var self1 = this, action = this.actionHandler[data.action];
                                var streamSink = {
                                    enqueue: function enqueue(chunk) {
                                        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                        var transfers = arguments.length > 2 ? arguments[2] : undefined;
                                        if (this.isCancelled) return;
                                        var lastDesiredSize = this.desiredSize;
                                        this.desiredSize -= size;
                                        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                            this.sinkCapability = (0, _util.createPromiseCapability)();
                                            this.ready = this.sinkCapability.promise;
                                        }
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.ENQUEUE,
                                            streamId: streamId,
                                            chunk: chunk
                                        }, transfers);
                                    },
                                    close: function close() {
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.CLOSE,
                                            streamId: streamId
                                        });
                                        delete self1.streamSinks[streamId];
                                    },
                                    error: function error(reason) {
                                        (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.ERROR,
                                            streamId: streamId,
                                            reason: wrapReason(reason)
                                        });
                                    },
                                    sinkCapability: (0, _util.createPromiseCapability)(),
                                    onPull: null,
                                    onCancel: null,
                                    isCancelled: false,
                                    desiredSize: data.desiredSize,
                                    ready: null
                                };
                                streamSink.sinkCapability.resolve();
                                streamSink.ready = streamSink.sinkCapability.promise;
                                this.streamSinks[streamId] = streamSink;
                                new Promise(function(resolve) {
                                    resolve(action(data.data, streamSink));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.START_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.START_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                            }
                        },
                        {
                            key: "_processStreamMessage",
                            value: function _processStreamMessage(data) {
                                var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                                var streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                                switch(data.stream){
                                    case StreamKind.START_COMPLETE:
                                        if (data.success) streamController.startCall.resolve();
                                        else streamController.startCall.reject(wrapReason(data.reason));
                                        break;
                                    case StreamKind.PULL_COMPLETE:
                                        if (data.success) streamController.pullCall.resolve();
                                        else streamController.pullCall.reject(wrapReason(data.reason));
                                        break;
                                    case StreamKind.PULL:
                                        if (!streamSink) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                            break;
                                        }
                                        if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                        streamSink.desiredSize = data.desiredSize;
                                        new Promise(function(resolve) {
                                            resolve(streamSink.onPull && streamSink.onPull());
                                        }).then(function() {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                        }, function(reason) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.PULL_COMPLETE,
                                                streamId: streamId,
                                                reason: wrapReason(reason)
                                            });
                                        });
                                        break;
                                    case StreamKind.ENQUEUE:
                                        (0, _util.assert)(streamController, "enqueue should have stream controller");
                                        if (streamController.isClosed) break;
                                        streamController.controller.enqueue(data.chunk);
                                        break;
                                    case StreamKind.CLOSE:
                                        (0, _util.assert)(streamController, "close should have stream controller");
                                        if (streamController.isClosed) break;
                                        streamController.isClosed = true;
                                        streamController.controller.close();
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.ERROR:
                                        (0, _util.assert)(streamController, "error should have stream controller");
                                        streamController.controller.error(wrapReason(data.reason));
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.CANCEL_COMPLETE:
                                        if (data.success) streamController.cancelCall.resolve();
                                        else streamController.cancelCall.reject(wrapReason(data.reason));
                                        this._deleteStreamController(streamController, streamId);
                                        break;
                                    case StreamKind.CANCEL:
                                        if (!streamSink) break;
                                        new Promise(function(resolve) {
                                            resolve(streamSink.onCancel && streamSink.onCancel(wrapReason(data.reason)));
                                        }).then(function() {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.CANCEL_COMPLETE,
                                                streamId: streamId,
                                                success: true
                                            });
                                        }, function(reason) {
                                            comObj.postMessage({
                                                sourceName: sourceName,
                                                targetName: targetName,
                                                stream: StreamKind.CANCEL_COMPLETE,
                                                streamId: streamId,
                                                reason: wrapReason(reason)
                                            });
                                        });
                                        streamSink.sinkCapability.reject(wrapReason(data.reason));
                                        streamSink.isCancelled = true;
                                        delete this.streamSinks[streamId];
                                        break;
                                    default:
                                        throw new Error("Unexpected stream case");
                                }
                            }
                        },
                        {
                            key: "_deleteStreamController",
                            value: function() {
                                var _deleteStreamController2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee(streamController, streamId) {
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return Promise.allSettled([
                                                    streamController.startCall && streamController.startCall.promise,
                                                    streamController.pullCall && streamController.pullCall.promise,
                                                    streamController.cancelCall && streamController.cancelCall.promise
                                                ]);
                                            case 2:
                                                delete this.streamControllers[streamId];
                                            case 3:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function _deleteStreamController(_x, _x2) {
                                    return _deleteStreamController2.apply(this, arguments);
                                }
                                return _deleteStreamController;
                            }()
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.comObj.removeEventListener("message", this._onComObjOnMessage);
                            }
                        }
                    ]);
                    return MessageHandler;
                }();
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 144 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(4);
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classPrivateFieldInitSpec(obj, privateMap, value) {
                    _checkPrivateRedeclaration(obj, privateMap);
                    privateMap.set(obj, value);
                }
                function _checkPrivateRedeclaration(obj, privateCollection) {
                    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldGet(receiver, privateMap) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
                    return _classApplyDescriptorGet(receiver, descriptor);
                }
                function _classApplyDescriptorGet(receiver, descriptor) {
                    if (descriptor.get) return descriptor.get.call(receiver);
                    return descriptor.value;
                }
                function _classPrivateFieldSet(receiver, privateMap, value) {
                    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
                    _classApplyDescriptorSet(receiver, descriptor, value);
                    return value;
                }
                function _classExtractFieldDescriptor(receiver, privateMap, action) {
                    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
                    return privateMap.get(receiver);
                }
                function _classApplyDescriptorSet(receiver, descriptor, value) {
                    if (descriptor.set) descriptor.set.call(receiver, value);
                    else {
                        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
                        descriptor.value = value;
                    }
                }
                var _metadataMap = /*#__PURE__*/ new WeakMap();
                var _data = /*#__PURE__*/ new WeakMap();
                var Metadata = /*#__PURE__*/ function() {
                    function Metadata(_ref) {
                        var parsedData = _ref.parsedData, rawData = _ref.rawData;
                        _classCallCheck(this, Metadata);
                        _classPrivateFieldInitSpec(this, _metadataMap, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldInitSpec(this, _data, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldSet(this, _metadataMap, parsedData);
                        _classPrivateFieldSet(this, _data, rawData);
                    }
                    _createClass(Metadata, [
                        {
                            key: "getRaw",
                            value: function getRaw() {
                                return _classPrivateFieldGet(this, _data);
                            }
                        },
                        {
                            key: "get",
                            value: function get(name) {
                                var _classPrivateFieldGet2;
                                return (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _metadataMap).get(name)) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : null;
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return (0, _util.objectFromMap)(_classPrivateFieldGet(this, _metadataMap));
                            }
                        },
                        {
                            key: "has",
                            value: function has(name) {
                                return _classPrivateFieldGet(this, _metadataMap).has(name);
                            }
                        }
                    ]);
                    return Metadata;
                }();
                exports.Metadata = Metadata;
            /***/ },
            /* 145 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(4);
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var OptionalContentGroup = function OptionalContentGroup(name, intent) {
                    _classCallCheck(this, OptionalContentGroup);
                    this.visible = true;
                    this.name = name;
                    this.intent = intent;
                };
                var OptionalContentConfig = /*#__PURE__*/ function() {
                    function OptionalContentConfig(data) {
                        _classCallCheck(this, OptionalContentConfig);
                        this.name = null;
                        this.creator = null;
                        this._order = null;
                        this._groups = new Map();
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this._order = data.order;
                        var _iterator = _createForOfIteratorHelper(data.groups), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var _group = _step.value;
                                this._groups.set(_group.id, new OptionalContentGroup(_group.name, _group.intent));
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        if (data.baseState === "OFF") {
                            var _iterator2 = _createForOfIteratorHelper(this._groups), _step2;
                            try {
                                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                    var group = _step2.value;
                                    group.visible = false;
                                }
                            } catch (err) {
                                _iterator2.e(err);
                            } finally{
                                _iterator2.f();
                            }
                        }
                        var _iterator3 = _createForOfIteratorHelper(data.on), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var on = _step3.value;
                                this._groups.get(on).visible = true;
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                        var _iterator4 = _createForOfIteratorHelper(data.off), _step4;
                        try {
                            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                var off = _step4.value;
                                this._groups.get(off).visible = false;
                            }
                        } catch (err) {
                            _iterator4.e(err);
                        } finally{
                            _iterator4.f();
                        }
                    }
                    _createClass(OptionalContentConfig, [
                        {
                            key: "_evaluateVisibilityExpression",
                            value: function _evaluateVisibilityExpression(array) {
                                var length = array.length;
                                if (length < 2) return true;
                                var operator = array[0];
                                for(var i = 1; i < length; i++){
                                    var element = array[i];
                                    var state = void 0;
                                    if (Array.isArray(element)) state = this._evaluateVisibilityExpression(element);
                                    else if (this._groups.has(element)) state = this._groups.get(element).visible;
                                    else {
                                        (0, _util.warn)("Optional content group not found: ".concat(element));
                                        return true;
                                    }
                                    switch(operator){
                                        case "And":
                                            if (!state) return false;
                                            break;
                                        case "Or":
                                            if (state) return true;
                                            break;
                                        case "Not":
                                            return !state;
                                        default:
                                            return true;
                                    }
                                }
                                return operator === "And";
                            }
                        },
                        {
                            key: "isVisible",
                            value: function isVisible(group) {
                                if (this._groups.size === 0) return true;
                                if (!group) {
                                    (0, _util.warn)("Optional content group not defined.");
                                    return true;
                                }
                                if (group.type === "OCG") {
                                    if (!this._groups.has(group.id)) {
                                        (0, _util.warn)("Optional content group not found: ".concat(group.id));
                                        return true;
                                    }
                                    return this._groups.get(group.id).visible;
                                } else if (group.type === "OCMD") {
                                    if (group.expression) return this._evaluateVisibilityExpression(group.expression);
                                    if (!group.policy || group.policy === "AnyOn") {
                                        var _iterator5 = _createForOfIteratorHelper(group.ids), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var id = _step5.value;
                                                if (!this._groups.has(id)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                                    return true;
                                                }
                                                if (this._groups.get(id).visible) return true;
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        return false;
                                    } else if (group.policy === "AllOn") {
                                        var _iterator6 = _createForOfIteratorHelper(group.ids), _step6;
                                        try {
                                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                var _id = _step6.value;
                                                if (!this._groups.has(_id)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id).visible) return false;
                                            }
                                        } catch (err) {
                                            _iterator6.e(err);
                                        } finally{
                                            _iterator6.f();
                                        }
                                        return true;
                                    } else if (group.policy === "AnyOff") {
                                        var _iterator7 = _createForOfIteratorHelper(group.ids), _step7;
                                        try {
                                            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                var _id2 = _step7.value;
                                                if (!this._groups.has(_id2)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id2));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id2).visible) return true;
                                            }
                                        } catch (err) {
                                            _iterator7.e(err);
                                        } finally{
                                            _iterator7.f();
                                        }
                                        return false;
                                    } else if (group.policy === "AllOff") {
                                        var _iterator8 = _createForOfIteratorHelper(group.ids), _step8;
                                        try {
                                            for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                                var _id3 = _step8.value;
                                                if (!this._groups.has(_id3)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(_id3));
                                                    return true;
                                                }
                                                if (this._groups.get(_id3).visible) return false;
                                            }
                                        } catch (err) {
                                            _iterator8.e(err);
                                        } finally{
                                            _iterator8.f();
                                        }
                                        return true;
                                    }
                                    (0, _util.warn)("Unknown optional content policy ".concat(group.policy, "."));
                                    return true;
                                }
                                (0, _util.warn)("Unknown group type ".concat(group.type, "."));
                                return true;
                            }
                        },
                        {
                            key: "setVisibility",
                            value: function setVisibility(id) {
                                var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                if (!this._groups.has(id)) {
                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                    return;
                                }
                                this._groups.get(id).visible = !!visible;
                            }
                        },
                        {
                            key: "getOrder",
                            value: function getOrder() {
                                if (!this._groups.size) return null;
                                if (this._order) return this._order.slice();
                                return Array.from(this._groups.keys());
                            }
                        },
                        {
                            key: "getGroups",
                            value: function getGroups() {
                                return this._groups.size > 0 ? (0, _util.objectFromMap)(this._groups) : null;
                            }
                        },
                        {
                            key: "getGroup",
                            value: function getGroup(id) {
                                return this._groups.get(id) || null;
                            }
                        }
                    ]);
                    return OptionalContentConfig;
                }();
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 146 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PDFDataTransportStream = /*#__PURE__*/ function() {
                    function PDFDataTransportStream(params, pdfDataRangeTransport) {
                        var _this = this;
                        _classCallCheck(this, PDFDataTransportStream);
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = params.progressiveDone || false;
                        this._contentDispositionFilename = params.contentDispositionFilename || null;
                        var initialData = params.initialData;
                        if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
                            var buffer = new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !params.disableStream;
                        this._isRangeSupported = !params.disableRange;
                        this._contentLength = params.length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener(function(begin, chunk) {
                            _this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener(function(loaded, total) {
                            _this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener(function(chunk) {
                            _this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(function() {
                            _this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _createClass(PDFDataTransportStream, [
                        {
                            key: "_onReceiveData",
                            value: function _onReceiveData(args) {
                                var buffer = new Uint8Array(args.chunk).buffer;
                                if (args.begin === undefined) {
                                    if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                                    else this._queuedChunks.push(buffer);
                                } else {
                                    var found = this._rangeReaders.some(function(rangeReader) {
                                        if (rangeReader._begin !== args.begin) return false;
                                        rangeReader._enqueue(buffer);
                                        return true;
                                    });
                                    (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                                }
                            }
                        },
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                if (evt.total === undefined) {
                                    var firstReader = this._rangeReaders[0];
                                    if (firstReader !== null && firstReader !== void 0 && firstReader.onProgress) firstReader.onProgress({
                                        loaded: evt.loaded
                                    });
                                } else {
                                    var fullReader = this._fullRequestReader;
                                    if (fullReader !== null && fullReader !== void 0 && fullReader.onProgress) fullReader.onProgress({
                                        loaded: evt.loaded,
                                        total: evt.total
                                    });
                                }
                            }
                        },
                        {
                            key: "_onProgressiveDone",
                            value: function _onProgressiveDone() {
                                if (this._fullRequestReader) this._fullRequestReader.progressiveDone();
                                this._progressiveDone = true;
                            }
                        },
                        {
                            key: "_removeRangeReader",
                            value: function _removeRangeReader(reader) {
                                var i = this._rangeReaders.indexOf(reader);
                                if (i >= 0) this._rangeReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                                var queuedChunks = this._queuedChunks;
                                this._queuedChunks = null;
                                return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                                this._pdfDataRangeTransport.requestDataRange(begin, end);
                                this._rangeReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this._pdfDataRangeTransport.abort();
                            }
                        }
                    ]);
                    return PDFDataTransportStream;
                }();
                exports.PDFDataTransportStream = PDFDataTransportStream;
                var PDFDataTransportStreamReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamReader(stream, queuedChunks) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFDataTransportStreamReader);
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        var _iterator2 = _createForOfIteratorHelper(this._queuedChunks), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var chunk = _step2.value;
                                this._loaded += chunk.byteLength;
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _createClass(PDFDataTransportStreamReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunks.push(chunk);
                                this._loaded += chunk.byteLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReady;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._stream._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._stream._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._stream._contentLength;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!(this._queuedChunks.length > 0)) {
                                                    _context.next = 3;
                                                    break;
                                                }
                                                chunk = this._queuedChunks.shift();
                                                return _context.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 3:
                                                if (!this._done) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 5:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context.abrupt("return", requestCapability.promise);
                                            case 8:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator3 = _createForOfIteratorHelper(this._requests), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var requestCapability = _step3.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "progressiveDone",
                            value: function progressiveDone() {
                                if (this._done) return;
                                this._done = true;
                            }
                        }
                    ]);
                    return PDFDataTransportStreamReader;
                }();
                var PDFDataTransportStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamRangeReader(stream, begin, end) {
                        _classCallCheck(this, PDFDataTransportStreamRangeReader);
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _createClass(PDFDataTransportStreamRangeReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length === 0) this._queuedChunk = chunk;
                                else {
                                    var requestsCapability = this._requests.shift();
                                    requestsCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                    var _iterator4 = _createForOfIteratorHelper(this._requests), _step4;
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            var requestCapability = _step4.value;
                                            requestCapability.resolve({
                                                value: undefined,
                                                done: true
                                            });
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                    this._requests.length = 0;
                                }
                                this._done = true;
                                this._stream._removeRangeReader(this);
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                if (!this._queuedChunk) {
                                                    _context2.next = 4;
                                                    break;
                                                }
                                                chunk = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context2.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 4:
                                                if (!this._done) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 6:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context2.abrupt("return", requestCapability.promise);
                                            case 9:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator5 = _createForOfIteratorHelper(this._requests), _step5;
                                try {
                                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                        var requestCapability = _step5.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator5.e(err);
                                } finally{
                                    _iterator5.f();
                                }
                                this._requests.length = 0;
                                this._stream._removeRangeReader(this);
                            }
                        }
                    ]);
                    return PDFDataTransportStreamRangeReader;
                }();
            /***/ },
            /* 147 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var XfaText = /*#__PURE__*/ function() {
                    function XfaText() {
                        _classCallCheck(this, XfaText);
                    }
                    _createClass(XfaText, null, [
                        {
                            key: "textContent",
                            value: function textContent(xfa) {
                                var items = [];
                                var output = {
                                    items: items,
                                    styles: Object.create(null)
                                };
                                function walk(node) {
                                    var _node$attributes;
                                    if (!node) return;
                                    var str = null;
                                    var name = node.name;
                                    if (name === "#text") str = node.value;
                                    else if (!XfaText.shouldBuildText(name)) return;
                                    else if (node !== null && node !== void 0 && (_node$attributes = node.attributes) !== null && _node$attributes !== void 0 && _node$attributes.textContent) str = node.attributes.textContent;
                                    else if (node.value) str = node.value;
                                    if (str !== null) items.push({
                                        str: str
                                    });
                                    if (!node.children) return;
                                    var _iterator = _createForOfIteratorHelper(node.children), _step;
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            var child = _step.value;
                                            walk(child);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                }
                                walk(xfa);
                                return output;
                            }
                        },
                        {
                            key: "shouldBuildText",
                            value: function shouldBuildText(name) {
                                return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                            }
                        }
                    ]);
                    return XfaText;
                }();
                exports.XfaText = XfaText;
            /***/ },
            /* 148 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(139);
                var _scripting_utils = __w_pdfjs_require__(149);
                var _xfa_layer = __w_pdfjs_require__(150);
                function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
                    _classCheckPrivateStaticAccess(receiver, classConstructor);
                    return method;
                }
                function _classCheckPrivateStaticAccess(receiver, classConstructor) {
                    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var DEFAULT_TAB_INDEX = 1000;
                var GetElementsByNameSet = new WeakSet();
                var AnnotationElementFactory = /*#__PURE__*/ function() {
                    function AnnotationElementFactory() {
                        _classCallCheck(this, AnnotationElementFactory);
                    }
                    _createClass(AnnotationElementFactory, null, [
                        {
                            key: "create",
                            value: function create(parameters) {
                                var subtype = parameters.data.annotationType;
                                switch(subtype){
                                    case _util.AnnotationType.LINK:
                                        return new LinkAnnotationElement(parameters);
                                    case _util.AnnotationType.TEXT:
                                        return new TextAnnotationElement(parameters);
                                    case _util.AnnotationType.WIDGET:
                                        var fieldType = parameters.data.fieldType;
                                        switch(fieldType){
                                            case "Tx":
                                                return new TextWidgetAnnotationElement(parameters);
                                            case "Btn":
                                                if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                                else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                                return new PushButtonWidgetAnnotationElement(parameters);
                                            case "Ch":
                                                return new ChoiceWidgetAnnotationElement(parameters);
                                        }
                                        return new WidgetAnnotationElement(parameters);
                                    case _util.AnnotationType.POPUP:
                                        return new PopupAnnotationElement(parameters);
                                    case _util.AnnotationType.FREETEXT:
                                        return new FreeTextAnnotationElement(parameters);
                                    case _util.AnnotationType.LINE:
                                        return new LineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUARE:
                                        return new SquareAnnotationElement(parameters);
                                    case _util.AnnotationType.CIRCLE:
                                        return new CircleAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYLINE:
                                        return new PolylineAnnotationElement(parameters);
                                    case _util.AnnotationType.CARET:
                                        return new CaretAnnotationElement(parameters);
                                    case _util.AnnotationType.INK:
                                        return new InkAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYGON:
                                        return new PolygonAnnotationElement(parameters);
                                    case _util.AnnotationType.HIGHLIGHT:
                                        return new HighlightAnnotationElement(parameters);
                                    case _util.AnnotationType.UNDERLINE:
                                        return new UnderlineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUIGGLY:
                                        return new SquigglyAnnotationElement(parameters);
                                    case _util.AnnotationType.STRIKEOUT:
                                        return new StrikeOutAnnotationElement(parameters);
                                    case _util.AnnotationType.STAMP:
                                        return new StampAnnotationElement(parameters);
                                    case _util.AnnotationType.FILEATTACHMENT:
                                        return new FileAttachmentAnnotationElement(parameters);
                                    default:
                                        return new AnnotationElement(parameters);
                                }
                            }
                        }
                    ]);
                    return AnnotationElementFactory;
                }();
                var AnnotationElement = /*#__PURE__*/ function() {
                    function AnnotationElement(parameters) {
                        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$isRenderable = _ref.isRenderable, isRenderable = _ref$isRenderable === void 0 ? false : _ref$isRenderable, _ref$ignoreBorder = _ref.ignoreBorder, ignoreBorder = _ref$ignoreBorder === void 0 ? false : _ref$ignoreBorder, _ref$createQuadrilate = _ref.createQuadrilaterals, createQuadrilaterals = _ref$createQuadrilate === void 0 ? false : _ref$createQuadrilate;
                        _classCallCheck(this, AnnotationElement);
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.page = parameters.page;
                        this.viewport = parameters.viewport;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this._mouseState = parameters.mouseState;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this.quadrilaterals = this._createQuadrilaterals(ignoreBorder);
                    }
                    _createClass(AnnotationElement, [
                        {
                            key: "_createContainer",
                            value: function _createContainer() {
                                var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                var data = this.data, page = this.page, viewport = this.viewport;
                                var container = document.createElement("section");
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                container.setAttribute("data-annotation-id", data.id);
                                var rect = _util.Util.normalizeRect([
                                    data.rect[0],
                                    page.view[3] - data.rect[1] + page.view[1],
                                    data.rect[2],
                                    page.view[3] - data.rect[3] + page.view[1]
                                ]);
                                if (data.hasOwnCanvas) {
                                    var transform = viewport.transform.slice();
                                    var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(transform), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), scaleX = _Util$singularValueDe2[0], scaleY = _Util$singularValueDe2[1];
                                    width = Math.ceil(width * scaleX);
                                    height = Math.ceil(height * scaleY);
                                    rect[0] *= scaleX;
                                    rect[1] *= scaleY;
                                    for(var i = 0; i < 4; i++)transform[i] = Math.sign(transform[i]);
                                    container.style.transform = "matrix(".concat(transform.join(","), ")");
                                } else container.style.transform = "matrix(".concat(viewport.transform.join(","), ")");
                                container.style.transformOrigin = "".concat(-rect[0], "px ").concat(-rect[1], "px");
                                if (!ignoreBorder && data.borderStyle.width > 0) {
                                    container.style.borderWidth = "".concat(data.borderStyle.width, "px");
                                    if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
                                        width -= 2 * data.borderStyle.width;
                                        height -= 2 * data.borderStyle.width;
                                    }
                                    var horizontalRadius = data.borderStyle.horizontalCornerRadius;
                                    var verticalRadius = data.borderStyle.verticalCornerRadius;
                                    if (horizontalRadius > 0 || verticalRadius > 0) {
                                        var radius = "".concat(horizontalRadius, "px / ").concat(verticalRadius, "px");
                                        container.style.borderRadius = radius;
                                    }
                                    switch(data.borderStyle.style){
                                        case _util.AnnotationBorderStyleType.SOLID:
                                            container.style.borderStyle = "solid";
                                            break;
                                        case _util.AnnotationBorderStyleType.DASHED:
                                            container.style.borderStyle = "dashed";
                                            break;
                                        case _util.AnnotationBorderStyleType.BEVELED:
                                            (0, _util.warn)("Unimplemented border style: beveled");
                                            break;
                                        case _util.AnnotationBorderStyleType.INSET:
                                            (0, _util.warn)("Unimplemented border style: inset");
                                            break;
                                        case _util.AnnotationBorderStyleType.UNDERLINE:
                                            container.style.borderBottomStyle = "solid";
                                            break;
                                        default:
                                            break;
                                    }
                                    var borderColor = data.borderColor || data.color || null;
                                    if (borderColor) container.style.borderColor = _util.Util.makeHexColor(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
                                    else container.style.borderWidth = 0;
                                }
                                container.style.left = "".concat(rect[0], "px");
                                container.style.top = "".concat(rect[1], "px");
                                if (data.hasOwnCanvas) container.style.width = container.style.height = "auto";
                                else {
                                    container.style.width = "".concat(width, "px");
                                    container.style.height = "".concat(height, "px");
                                }
                                return container;
                            }
                        },
                        {
                            key: "_createQuadrilaterals",
                            value: function _createQuadrilaterals() {
                                var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.data.quadPoints) return null;
                                var quadrilaterals = [];
                                var savedRect = this.data.rect;
                                var _iterator = _createForOfIteratorHelper(this.data.quadPoints), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var quadPoint = _step.value;
                                        this.data.rect = [
                                            quadPoint[2].x,
                                            quadPoint[2].y,
                                            quadPoint[1].x,
                                            quadPoint[1].y
                                        ];
                                        quadrilaterals.push(this._createContainer(ignoreBorder));
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                this.data.rect = savedRect;
                                return quadrilaterals;
                            }
                        },
                        {
                            key: "_createPopup",
                            value: function _createPopup(trigger, data) {
                                var container = this.container;
                                if (this.quadrilaterals) {
                                    trigger = trigger || this.quadrilaterals;
                                    container = this.quadrilaterals[0];
                                }
                                if (!trigger) {
                                    trigger = document.createElement("div");
                                    trigger.style.height = container.style.height;
                                    trigger.style.width = container.style.width;
                                    container.appendChild(trigger);
                                }
                                var popupElement = new PopupElement({
                                    container: container,
                                    trigger: trigger,
                                    color: data.color,
                                    titleObj: data.titleObj,
                                    modificationDate: data.modificationDate,
                                    contentsObj: data.contentsObj,
                                    richText: data.richText,
                                    hideWrapper: true
                                });
                                var popup = popupElement.render();
                                popup.style.left = container.style.width;
                                container.appendChild(popup);
                            }
                        },
                        {
                            key: "_renderQuadrilaterals",
                            value: function _renderQuadrilaterals(className) {
                                var _iterator2 = _createForOfIteratorHelper(this.quadrilaterals), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var quadrilateral = _step2.value;
                                        quadrilateral.className = className;
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return this.quadrilaterals;
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                            }
                        },
                        {
                            key: "_getElementsByName",
                            value: function _getElementsByName(name) {
                                var skipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var fields = [];
                                if (this._fieldObjects) {
                                    var fieldObj = this._fieldObjects[name];
                                    if (fieldObj) {
                                        var _iterator3 = _createForOfIteratorHelper(fieldObj), _step3;
                                        try {
                                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                                var _step3$value = _step3.value, page = _step3$value.page, id = _step3$value.id, exportValues = _step3$value.exportValues;
                                                if (page === -1) continue;
                                                if (id === skipId) continue;
                                                var exportValue = typeof exportValues === "string" ? exportValues : null;
                                                var domElement = document.getElementById(id);
                                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                                    (0, _util.warn)("_getElementsByName - element not allowed: ".concat(id));
                                                    continue;
                                                }
                                                fields.push({
                                                    id: id,
                                                    exportValue: exportValue,
                                                    domElement: domElement
                                                });
                                            }
                                        } catch (err) {
                                            _iterator3.e(err);
                                        } finally{
                                            _iterator3.f();
                                        }
                                    }
                                    return fields;
                                }
                                var _iterator4 = _createForOfIteratorHelper(document.getElementsByName(name)), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var _domElement = _step4.value;
                                        var _id = _domElement.id, _exportValue = _domElement.exportValue;
                                        if (_id === skipId) continue;
                                        if (!GetElementsByNameSet.has(_domElement)) continue;
                                        fields.push({
                                            id: _id,
                                            exportValue: _exportValue,
                                            domElement: _domElement
                                        });
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                return fields;
                            }
                        }
                    ], [
                        {
                            key: "platform",
                            get: function get() {
                                var platform = typeof navigator !== "undefined" ? navigator.platform : "";
                                return (0, _util.shadow)(this, "platform", {
                                    isWin: platform.includes("Win"),
                                    isMac: platform.includes("Mac")
                                });
                            }
                        }
                    ]);
                    return AnnotationElement;
                }();
                var LinkAnnotationElement = /*#__PURE__*/ function(_AnnotationElement) {
                    _inherits(LinkAnnotationElement, _AnnotationElement);
                    var _super = _createSuper(LinkAnnotationElement);
                    function LinkAnnotationElement(parameters) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        _classCallCheck(this, LinkAnnotationElement);
                        var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action || parameters.data.isTooltipOnly || parameters.data.resetForm || parameters.data.actions && (parameters.data.actions.Action || parameters.data.actions["Mouse Up"] || parameters.data.actions["Mouse Down"]));
                        return _super.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: !!(options !== null && options !== void 0 && options.ignoreBorder),
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(LinkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var data = this.data, linkService = this.linkService;
                                var link = document.createElement("a");
                                if (data.url) {
                                    var _linkService$addLinkA;
                                    if (!linkService.addLinkAttributes) (0, _util.warn)("LinkAnnotationElement.render - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 || _linkService$addLinkA.call(linkService, link, data.url, data.newWindow);
                                } else if (data.action) this._bindNamedAction(link, data.action);
                                else if (data.dest) this._bindLink(link, data.dest);
                                else {
                                    var hasClickAction = false;
                                    if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                        hasClickAction = true;
                                        this._bindJSAction(link, data);
                                    }
                                    if (data.resetForm) this._bindResetFormAction(link, data.resetForm);
                                    else if (!hasClickAction) this._bindLink(link, "");
                                }
                                if (this.quadrilaterals) return this._renderQuadrilaterals("linkAnnotation").map(function(quadrilateral, index) {
                                    var linkElement = index === 0 ? link : link.cloneNode();
                                    quadrilateral.appendChild(linkElement);
                                    return quadrilateral;
                                });
                                this.container.className = "linkAnnotation";
                                this.container.appendChild(link);
                                return this.container;
                            }
                        },
                        {
                            key: "_bindLink",
                            value: function _bindLink(link, destination) {
                                var _this = this;
                                link.href = this.linkService.getDestinationHash(destination);
                                link.onclick = function() {
                                    if (destination) _this.linkService.goToDestination(destination);
                                    return false;
                                };
                                if (destination || destination === "") link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindNamedAction",
                            value: function _bindNamedAction(link, action) {
                                var _this2 = this;
                                link.href = this.linkService.getAnchorUrl("");
                                link.onclick = function() {
                                    _this2.linkService.executeNamedAction(action);
                                    return false;
                                };
                                link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindJSAction",
                            value: function _bindJSAction(link, data) {
                                var _this3 = this;
                                link.href = this.linkService.getAnchorUrl("");
                                var map = new Map([
                                    [
                                        "Action",
                                        "onclick"
                                    ],
                                    [
                                        "Mouse Up",
                                        "onmouseup"
                                    ],
                                    [
                                        "Mouse Down",
                                        "onmousedown"
                                    ]
                                ]);
                                var _loop = function _loop() {
                                    var name = _Object$keys[_i2];
                                    var jsName = map.get(name);
                                    if (!jsName) return "continue";
                                    link[jsName] = function() {
                                        var _this3$linkService$ev;
                                        (_this3$linkService$ev = _this3.linkService.eventBus) === null || _this3$linkService$ev === void 0 || _this3$linkService$ev.dispatch("dispatcheventinsandbox", {
                                            source: _this3,
                                            detail: {
                                                id: data.id,
                                                name: name
                                            }
                                        });
                                        return false;
                                    };
                                };
                                for(var _i2 = 0, _Object$keys = Object.keys(data.actions); _i2 < _Object$keys.length; _i2++){
                                    var _ret = _loop();
                                    if (_ret === "continue") continue;
                                }
                                if (!link.onclick) link.onclick = function() {
                                    return false;
                                };
                                link.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindResetFormAction",
                            value: function _bindResetFormAction(link, resetForm) {
                                var _this4 = this;
                                var otherClickAction = link.onclick;
                                if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                                link.className = "internalLink";
                                if (!this._fieldObjects) {
                                    (0, _util.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.');
                                    if (!otherClickAction) link.onclick = function() {
                                        return false;
                                    };
                                    return;
                                }
                                link.onclick = function() {
                                    if (otherClickAction) otherClickAction();
                                    var resetFormFields = resetForm.fields, resetFormRefs = resetForm.refs, include = resetForm.include;
                                    var allFields = [];
                                    if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                        var fieldIds = new Set(resetFormRefs);
                                        var _iterator5 = _createForOfIteratorHelper(resetFormFields), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var fieldName = _step5.value;
                                                var _fields = _this4._fieldObjects[fieldName] || [];
                                                var _iterator7 = _createForOfIteratorHelper(_fields), _step7;
                                                try {
                                                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                                        var id = _step7.value.id;
                                                        fieldIds.add(id);
                                                    }
                                                } catch (err) {
                                                    _iterator7.e(err);
                                                } finally{
                                                    _iterator7.f();
                                                }
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        for(var _i3 = 0, _Object$values = Object.values(_this4._fieldObjects); _i3 < _Object$values.length; _i3++){
                                            var fields = _Object$values[_i3];
                                            var _iterator6 = _createForOfIteratorHelper(fields), _step6;
                                            try {
                                                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                    var field = _step6.value;
                                                    if (fieldIds.has(field.id) === include) allFields.push(field);
                                                }
                                            } catch (err) {
                                                _iterator6.e(err);
                                            } finally{
                                                _iterator6.f();
                                            }
                                        }
                                    } else for(var _i4 = 0, _Object$values2 = Object.values(_this4._fieldObjects); _i4 < _Object$values2.length; _i4++){
                                        var _fields2 = _Object$values2[_i4];
                                        allFields.push.apply(allFields, _toConsumableArray(_fields2));
                                    }
                                    var storage = _this4.annotationStorage;
                                    var allIds = [];
                                    for(var _i5 = 0, _allFields = allFields; _i5 < _allFields.length; _i5++){
                                        var _field = _allFields[_i5];
                                        var _id2 = _field.id;
                                        allIds.push(_id2);
                                        switch(_field.type){
                                            case "text":
                                                var value = _field.defaultValue || "";
                                                storage.setValue(_id2, {
                                                    value: value,
                                                    valueAsString: value
                                                });
                                                break;
                                            case "checkbox":
                                            case "radiobutton":
                                                var _value = _field.defaultValue === _field.exportValues;
                                                storage.setValue(_id2, {
                                                    value: _value
                                                });
                                                break;
                                            case "combobox":
                                            case "listbox":
                                                var _value2 = _field.defaultValue || "";
                                                storage.setValue(_id2, {
                                                    value: _value2
                                                });
                                                break;
                                            default:
                                                continue;
                                        }
                                        var domElement = document.getElementById(_id2);
                                        if (!domElement || !GetElementsByNameSet.has(domElement)) continue;
                                        domElement.dispatchEvent(new Event("resetform"));
                                    }
                                    if (_this4.enableScripting) {
                                        var _this4$linkService$ev;
                                        (_this4$linkService$ev = _this4.linkService.eventBus) === null || _this4$linkService$ev === void 0 || _this4$linkService$ev.dispatch("dispatcheventinsandbox", {
                                            source: _this4,
                                            detail: {
                                                id: "app",
                                                ids: allIds,
                                                name: "ResetForm"
                                            }
                                        });
                                    }
                                    return false;
                                };
                            }
                        }
                    ]);
                    return LinkAnnotationElement;
                }(AnnotationElement);
                var TextAnnotationElement = /*#__PURE__*/ function(_AnnotationElement2) {
                    _inherits(TextAnnotationElement, _AnnotationElement2);
                    var _super2 = _createSuper(TextAnnotationElement);
                    function TextAnnotationElement(parameters) {
                        var _parameters$data$titl, _parameters$data$cont, _parameters$data$rich;
                        _classCallCheck(this, TextAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl = parameters.data.titleObj) !== null && _parameters$data$titl !== void 0 && _parameters$data$titl.str || (_parameters$data$cont = parameters.data.contentsObj) !== null && _parameters$data$cont !== void 0 && _parameters$data$cont.str || (_parameters$data$rich = parameters.data.richText) !== null && _parameters$data$rich !== void 0 && _parameters$data$rich.str);
                        return _super2.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(TextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "textAnnotation";
                                var image = document.createElement("img");
                                image.style.height = this.container.style.height;
                                image.style.width = this.container.style.width;
                                image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                                image.alt = "[{{type}} Annotation]";
                                image.dataset.l10nId = "text_annotation_type";
                                image.dataset.l10nArgs = JSON.stringify({
                                    type: this.data.name
                                });
                                if (!this.data.hasPopup) this._createPopup(image, this.data);
                                this.container.appendChild(image);
                                return this.container;
                            }
                        }
                    ]);
                    return TextAnnotationElement;
                }(AnnotationElement);
                var WidgetAnnotationElement = /*#__PURE__*/ function(_AnnotationElement3) {
                    _inherits(WidgetAnnotationElement, _AnnotationElement3);
                    var _super3 = _createSuper(WidgetAnnotationElement);
                    function WidgetAnnotationElement() {
                        _classCallCheck(this, WidgetAnnotationElement);
                        return _super3.apply(this, arguments);
                    }
                    _createClass(WidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                                return this.container;
                            }
                        },
                        {
                            key: "_getKeyModifier",
                            value: function _getKeyModifier(event) {
                                var _AnnotationElement$pl = AnnotationElement.platform, isWin = _AnnotationElement$pl.isWin, isMac = _AnnotationElement$pl.isMac;
                                return isWin && event.ctrlKey || isMac && event.metaKey;
                            }
                        },
                        {
                            key: "_setEventListener",
                            value: function _setEventListener(element, baseName, eventName, valueGetter) {
                                var _this5 = this;
                                if (baseName.includes("mouse")) element.addEventListener(baseName, function(event) {
                                    var _this5$linkService$ev;
                                    (_this5$linkService$ev = _this5.linkService.eventBus) === null || _this5$linkService$ev === void 0 || _this5$linkService$ev.dispatch("dispatcheventinsandbox", {
                                        source: _this5,
                                        detail: {
                                            id: _this5.data.id,
                                            name: eventName,
                                            value: valueGetter(event),
                                            shift: event.shiftKey,
                                            modifier: _this5._getKeyModifier(event)
                                        }
                                    });
                                });
                                else element.addEventListener(baseName, function(event) {
                                    var _this5$linkService$ev2;
                                    (_this5$linkService$ev2 = _this5.linkService.eventBus) === null || _this5$linkService$ev2 === void 0 || _this5$linkService$ev2.dispatch("dispatcheventinsandbox", {
                                        source: _this5,
                                        detail: {
                                            id: _this5.data.id,
                                            name: eventName,
                                            value: event.target.checked
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "_setEventListeners",
                            value: function _setEventListeners(element, names, getter) {
                                var _iterator8 = _createForOfIteratorHelper(names), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _this$data$actions;
                                        var _step8$value = _slicedToArray(_step8.value, 2), baseName = _step8$value[0], eventName = _step8$value[1];
                                        if (eventName === "Action" || (_this$data$actions = this.data.actions) !== null && _this$data$actions !== void 0 && _this$data$actions[eventName]) this._setEventListener(element, baseName, eventName, getter);
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                            }
                        },
                        {
                            key: "_setBackgroundColor",
                            value: function _setBackgroundColor(element) {
                                var color = this.data.backgroundColor || null;
                                element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                            }
                        },
                        {
                            key: "_dispatchEventFromSandbox",
                            value: function _dispatchEventFromSandbox(actions, jsEvent) {
                                var _this6 = this;
                                var setColor = function setColor(jsName, styleName, event) {
                                    var color = event.detail[jsName];
                                    event.target.style[styleName] = _scripting_utils.ColorConverters["".concat(color[0], "_HTML")](color.slice(1));
                                };
                                var commonActions = {
                                    display: function display(event) {
                                        var hidden = event.detail.display % 2 === 1;
                                        event.target.style.visibility = hidden ? "hidden" : "visible";
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            hidden: hidden,
                                            print: event.detail.display === 0 || event.detail.display === 3
                                        });
                                    },
                                    print: function print(event) {
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            print: event.detail.print
                                        });
                                    },
                                    hidden: function hidden(event) {
                                        event.target.style.visibility = event.detail.hidden ? "hidden" : "visible";
                                        _this6.annotationStorage.setValue(_this6.data.id, {
                                            hidden: event.detail.hidden
                                        });
                                    },
                                    focus: function focus(event) {
                                        setTimeout(function() {
                                            return event.target.focus({
                                                preventScroll: false
                                            });
                                        }, 0);
                                    },
                                    userName: function userName(event) {
                                        event.target.title = event.detail.userName;
                                    },
                                    readonly: function readonly(event) {
                                        if (event.detail.readonly) event.target.setAttribute("readonly", "");
                                        else event.target.removeAttribute("readonly");
                                    },
                                    required: function required(event) {
                                        if (event.detail.required) event.target.setAttribute("required", "");
                                        else event.target.removeAttribute("required");
                                    },
                                    bgColor: function bgColor(event) {
                                        setColor("bgColor", "backgroundColor", event);
                                    },
                                    fillColor: function fillColor(event) {
                                        setColor("fillColor", "backgroundColor", event);
                                    },
                                    fgColor: function fgColor(event) {
                                        setColor("fgColor", "color", event);
                                    },
                                    textColor: function textColor(event) {
                                        setColor("textColor", "color", event);
                                    },
                                    borderColor: function borderColor(event) {
                                        setColor("borderColor", "borderColor", event);
                                    },
                                    strokeColor: function strokeColor(event) {
                                        setColor("strokeColor", "borderColor", event);
                                    }
                                };
                                for(var _i6 = 0, _Object$keys2 = Object.keys(jsEvent.detail); _i6 < _Object$keys2.length; _i6++){
                                    var name = _Object$keys2[_i6];
                                    var action = actions[name] || commonActions[name];
                                    if (action) action(jsEvent);
                                }
                            }
                        }
                    ]);
                    return WidgetAnnotationElement;
                }(AnnotationElement);
                var TextWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem) {
                    _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
                    var _super4 = _createSuper(TextWidgetAnnotationElement);
                    function TextWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, TextWidgetAnnotationElement);
                        var isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        return _super4.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(TextWidgetAnnotationElement, [
                        {
                            key: "setPropertyOnSiblings",
                            value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
                                var storage = this.annotationStorage;
                                var _iterator9 = _createForOfIteratorHelper(this._getElementsByName(base.name, base.id)), _step9;
                                try {
                                    for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                                        var element = _step9.value;
                                        if (element.domElement) element.domElement[key] = value;
                                        storage.setValue(element.id, _defineProperty({}, keyInStorage, value));
                                    }
                                } catch (err) {
                                    _iterator9.e(err);
                                } finally{
                                    _iterator9.f();
                                }
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this7 = this;
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                this.container.className = "textWidgetAnnotation";
                                var element = null;
                                if (this.renderForms) {
                                    var storedData = storage.getValue(id, {
                                        value: this.data.fieldValue,
                                        valueAsString: this.data.fieldValue
                                    });
                                    var textContent = storedData.valueAsString || storedData.value || "";
                                    var elementData = {
                                        userValue: null,
                                        formattedValue: null,
                                        beforeInputSelectionRange: null,
                                        beforeInputValue: null
                                    };
                                    if (this.data.multiLine) {
                                        element = document.createElement("textarea");
                                        element.textContent = textContent;
                                    } else {
                                        element = document.createElement("input");
                                        element.type = "text";
                                        element.setAttribute("value", textContent);
                                    }
                                    GetElementsByNameSet.add(element);
                                    element.disabled = this.data.readOnly;
                                    element.name = this.data.fieldName;
                                    element.tabIndex = DEFAULT_TAB_INDEX;
                                    elementData.userValue = textContent;
                                    element.setAttribute("id", id);
                                    element.addEventListener("input", function(event) {
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                        _this7.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                    });
                                    element.addEventListener("resetform", function(event) {
                                        var defaultValue = _this7.data.defaultFieldValue || "";
                                        element.value = elementData.userValue = defaultValue;
                                        delete elementData.formattedValue;
                                    });
                                    var blurListener = function blurListener(event) {
                                        if (elementData.formattedValue) event.target.value = elementData.formattedValue;
                                        event.target.scrollLeft = 0;
                                        elementData.beforeInputSelectionRange = null;
                                    };
                                    if (this.enableScripting && this.hasJSActions) {
                                        var _this$data$actions2;
                                        element.addEventListener("focus", function(event) {
                                            if (elementData.userValue) event.target.value = elementData.userValue;
                                        });
                                        element.addEventListener("updatefromsandbox", function(jsEvent) {
                                            var actions = {
                                                value: function value(event) {
                                                    elementData.userValue = event.detail.value || "";
                                                    storage.setValue(id, {
                                                        value: elementData.userValue.toString()
                                                    });
                                                    if (!elementData.formattedValue) event.target.value = elementData.userValue;
                                                },
                                                valueAsString: function valueAsString(event) {
                                                    elementData.formattedValue = event.detail.valueAsString || "";
                                                    if (event.target !== document.activeElement) event.target.value = elementData.formattedValue;
                                                    storage.setValue(id, {
                                                        formattedValue: elementData.formattedValue
                                                    });
                                                },
                                                selRange: function selRange(event) {
                                                    var _event$detail$selRang = _slicedToArray(event.detail.selRange, 2), selStart = _event$detail$selRang[0], selEnd = _event$detail$selRang[1];
                                                    if (selStart >= 0 && selEnd < event.target.value.length) event.target.setSelectionRange(selStart, selEnd);
                                                }
                                            };
                                            _this7._dispatchEventFromSandbox(actions, jsEvent);
                                        });
                                        element.addEventListener("keydown", function(event) {
                                            var _this7$linkService$ev;
                                            elementData.beforeInputValue = event.target.value;
                                            var commitKey = -1;
                                            if (event.key === "Escape") commitKey = 0;
                                            else if (event.key === "Enter") commitKey = 2;
                                            else if (event.key === "Tab") commitKey = 3;
                                            if (commitKey === -1) return;
                                            elementData.userValue = event.target.value;
                                            (_this7$linkService$ev = _this7.linkService.eventBus) === null || _this7$linkService$ev === void 0 || _this7$linkService$ev.dispatch("dispatcheventinsandbox", {
                                                source: _this7,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: event.target.value,
                                                    willCommit: true,
                                                    commitKey: commitKey,
                                                    selStart: event.target.selectionStart,
                                                    selEnd: event.target.selectionEnd
                                                }
                                            });
                                        });
                                        var _blurListener = blurListener;
                                        blurListener = null;
                                        element.addEventListener("blur", function(event) {
                                            if (_this7._mouseState.isDown) {
                                                var _this7$linkService$ev2;
                                                elementData.userValue = event.target.value;
                                                (_this7$linkService$ev2 = _this7.linkService.eventBus) === null || _this7$linkService$ev2 === void 0 || _this7$linkService$ev2.dispatch("dispatcheventinsandbox", {
                                                    source: _this7,
                                                    detail: {
                                                        id: id,
                                                        name: "Keystroke",
                                                        value: event.target.value,
                                                        willCommit: true,
                                                        commitKey: 1,
                                                        selStart: event.target.selectionStart,
                                                        selEnd: event.target.selectionEnd
                                                    }
                                                });
                                            }
                                            _blurListener(event);
                                        });
                                        element.addEventListener("mousedown", function(event) {
                                            elementData.beforeInputValue = event.target.value;
                                            elementData.beforeInputSelectionRange = null;
                                        });
                                        element.addEventListener("keyup", function(event) {
                                            if (event.target.selectionStart === event.target.selectionEnd) elementData.beforeInputSelectionRange = null;
                                        });
                                        element.addEventListener("select", function(event) {
                                            elementData.beforeInputSelectionRange = [
                                                event.target.selectionStart,
                                                event.target.selectionEnd
                                            ];
                                        });
                                        if ((_this$data$actions2 = this.data.actions) !== null && _this$data$actions2 !== void 0 && _this$data$actions2.Keystroke) element.addEventListener("input", function(event) {
                                            var _this7$linkService$ev3;
                                            var selStart = -1;
                                            var selEnd = -1;
                                            if (elementData.beforeInputSelectionRange) {
                                                var _elementData$beforeIn = _slicedToArray(elementData.beforeInputSelectionRange, 2);
                                                selStart = _elementData$beforeIn[0];
                                                selEnd = _elementData$beforeIn[1];
                                            }
                                            (_this7$linkService$ev3 = _this7.linkService.eventBus) === null || _this7$linkService$ev3 === void 0 || _this7$linkService$ev3.dispatch("dispatcheventinsandbox", {
                                                source: _this7,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: elementData.beforeInputValue,
                                                    change: event.data,
                                                    willCommit: false,
                                                    selStart: selStart,
                                                    selEnd: selEnd
                                                }
                                            });
                                        });
                                        this._setEventListeners(element, [
                                            [
                                                "focus",
                                                "Focus"
                                            ],
                                            [
                                                "blur",
                                                "Blur"
                                            ],
                                            [
                                                "mousedown",
                                                "Mouse Down"
                                            ],
                                            [
                                                "mouseenter",
                                                "Mouse Enter"
                                            ],
                                            [
                                                "mouseleave",
                                                "Mouse Exit"
                                            ],
                                            [
                                                "mouseup",
                                                "Mouse Up"
                                            ]
                                        ], function(event) {
                                            return event.target.value;
                                        });
                                    }
                                    if (blurListener) element.addEventListener("blur", blurListener);
                                    if (this.data.maxLen !== null) element.maxLength = this.data.maxLen;
                                    if (this.data.comb) {
                                        var fieldWidth = this.data.rect[2] - this.data.rect[0];
                                        var combWidth = fieldWidth / this.data.maxLen;
                                        element.classList.add("comb");
                                        element.style.letterSpacing = "calc(".concat(combWidth, "px - 1ch)");
                                    }
                                } else {
                                    element = document.createElement("div");
                                    element.textContent = this.data.fieldValue;
                                    element.style.verticalAlign = "middle";
                                    element.style.display = "table-cell";
                                }
                                this._setTextStyle(element);
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        },
                        {
                            key: "_setTextStyle",
                            value: function _setTextStyle(element) {
                                var TEXT_ALIGNMENT = [
                                    "left",
                                    "center",
                                    "right"
                                ];
                                var _this$data$defaultApp = this.data.defaultAppearanceData, fontSize = _this$data$defaultApp.fontSize, fontColor = _this$data$defaultApp.fontColor;
                                var style = element.style;
                                if (fontSize) style.fontSize = "".concat(fontSize, "px");
                                style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                                if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                            }
                        }
                    ]);
                    return TextWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var CheckboxWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem2) {
                    _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
                    var _super5 = _createSuper(CheckboxWidgetAnnotationElement);
                    function CheckboxWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, CheckboxWidgetAnnotationElement);
                        return _super5.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(CheckboxWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this8 = this;
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.exportValue === data.fieldValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== "Off";
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                this.container.className = "buttonWidgetAnnotation checkBox";
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.disabled = data.readOnly;
                                element.type = "checkbox";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.setAttribute("id", id);
                                element.setAttribute("exportValue", data.exportValue);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event$target = event.target, name = _event$target.name, checked = _event$target.checked;
                                    var _iterator10 = _createForOfIteratorHelper(_this8._getElementsByName(name, id)), _step10;
                                    try {
                                        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                                            var checkbox = _step10.value;
                                            var curChecked = checked && checkbox.exportValue === data.exportValue;
                                            if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                            storage.setValue(checkbox.id, {
                                                value: curChecked
                                            });
                                        }
                                    } catch (err) {
                                        _iterator10.e(err);
                                    } finally{
                                        _iterator10.f();
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue || "Off";
                                    event.target.checked = defaultValue === data.exportValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                event.target.checked = event.detail.value !== "Off";
                                                storage.setValue(id, {
                                                    value: event.target.checked
                                                });
                                            }
                                        };
                                        _this8._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        }
                    ]);
                    return CheckboxWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var RadioButtonWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem3) {
                    _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
                    var _super6 = _createSuper(RadioButtonWidgetAnnotationElement);
                    function RadioButtonWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, RadioButtonWidgetAnnotationElement);
                        return _super6.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(RadioButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this9 = this;
                                this.container.className = "buttonWidgetAnnotation radioButton";
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.fieldValue === data.buttonValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== data.buttonValue;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.disabled = data.readOnly;
                                element.type = "radio";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.setAttribute("id", id);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event$target2 = event.target, name = _event$target2.name, checked = _event$target2.checked;
                                    var _iterator11 = _createForOfIteratorHelper(_this9._getElementsByName(name, id)), _step11;
                                    try {
                                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                            var radio = _step11.value;
                                            storage.setValue(radio.id, {
                                                value: false
                                            });
                                        }
                                    } catch (err) {
                                        _iterator11.e(err);
                                    } finally{
                                        _iterator11.f();
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue;
                                    event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    var pdfButtonValue = data.buttonValue;
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                var checked = pdfButtonValue === event.detail.value;
                                                var _iterator12 = _createForOfIteratorHelper(_this9._getElementsByName(event.target.name)), _step12;
                                                try {
                                                    for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                                                        var radio = _step12.value;
                                                        var curChecked = checked && radio.id === id;
                                                        if (radio.domElement) radio.domElement.checked = curChecked;
                                                        storage.setValue(radio.id, {
                                                            value: curChecked
                                                        });
                                                    }
                                                } catch (err) {
                                                    _iterator12.e(err);
                                                } finally{
                                                    _iterator12.f();
                                                }
                                            }
                                        };
                                        _this9._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this.container.appendChild(element);
                                return this.container;
                            }
                        }
                    ]);
                    return RadioButtonWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PushButtonWidgetAnnotationElement = /*#__PURE__*/ function(_LinkAnnotationElemen) {
                    _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
                    var _super7 = _createSuper(PushButtonWidgetAnnotationElement);
                    function PushButtonWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, PushButtonWidgetAnnotationElement);
                        return _super7.call(this, parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    _createClass(PushButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var container = _get(_getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), "render", this).call(this);
                                container.className = "buttonWidgetAnnotation pushButton";
                                if (this.data.alternativeText) container.title = this.data.alternativeText;
                                return container;
                            }
                        }
                    ]);
                    return PushButtonWidgetAnnotationElement;
                }(LinkAnnotationElement);
                var ChoiceWidgetAnnotationElement = /*#__PURE__*/ function(_WidgetAnnotationElem4) {
                    _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
                    var _super8 = _createSuper(ChoiceWidgetAnnotationElement);
                    function ChoiceWidgetAnnotationElement(parameters) {
                        _classCallCheck(this, ChoiceWidgetAnnotationElement);
                        return _super8.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    _createClass(ChoiceWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this10 = this;
                                this.container.className = "choiceWidgetAnnotation";
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                storage.getValue(id, {
                                    value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : undefined
                                });
                                var fontSize = this.data.defaultAppearanceData.fontSize;
                                if (!fontSize) fontSize = 9;
                                var fontSizeStyle = "calc(".concat(fontSize, "px * var(--zoom-factor))");
                                var selectElement = document.createElement("select");
                                GetElementsByNameSet.add(selectElement);
                                selectElement.disabled = this.data.readOnly;
                                selectElement.name = this.data.fieldName;
                                selectElement.setAttribute("id", id);
                                selectElement.tabIndex = DEFAULT_TAB_INDEX;
                                selectElement.style.fontSize = "".concat(fontSize, "px");
                                if (!this.data.combo) {
                                    selectElement.size = this.data.options.length;
                                    if (this.data.multiSelect) selectElement.multiple = true;
                                }
                                selectElement.addEventListener("resetform", function(event) {
                                    var defaultValue = _this10.data.defaultFieldValue;
                                    var _iterator13 = _createForOfIteratorHelper(selectElement.options), _step13;
                                    try {
                                        for(_iterator13.s(); !(_step13 = _iterator13.n()).done;){
                                            var option = _step13.value;
                                            option.selected = option.value === defaultValue;
                                        }
                                    } catch (err) {
                                        _iterator13.e(err);
                                    } finally{
                                        _iterator13.f();
                                    }
                                });
                                var _iterator14 = _createForOfIteratorHelper(this.data.options), _step14;
                                try {
                                    for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                                        var option = _step14.value;
                                        var optionElement = document.createElement("option");
                                        optionElement.textContent = option.displayValue;
                                        optionElement.value = option.exportValue;
                                        if (this.data.combo) optionElement.style.fontSize = fontSizeStyle;
                                        if (this.data.fieldValue.includes(option.exportValue)) optionElement.setAttribute("selected", true);
                                        selectElement.appendChild(optionElement);
                                    }
                                } catch (err) {
                                    _iterator14.e(err);
                                } finally{
                                    _iterator14.f();
                                }
                                var getValue = function getValue(event, isExport) {
                                    var name = isExport ? "value" : "textContent";
                                    var options = event.target.options;
                                    if (!event.target.multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                                    return Array.prototype.filter.call(options, function(option) {
                                        return option.selected;
                                    }).map(function(option) {
                                        return option[name];
                                    });
                                };
                                var getItems = function getItems(event) {
                                    var options = event.target.options;
                                    return Array.prototype.map.call(options, function(option) {
                                        return {
                                            displayValue: option.textContent,
                                            exportValue: option.value
                                        };
                                    });
                                };
                                if (this.enableScripting && this.hasJSActions) {
                                    selectElement.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function value(event) {
                                                var value = event.detail.value;
                                                var values = new Set(Array.isArray(value) ? value : [
                                                    value
                                                ]);
                                                var _iterator15 = _createForOfIteratorHelper(selectElement.options), _step15;
                                                try {
                                                    for(_iterator15.s(); !(_step15 = _iterator15.n()).done;){
                                                        var option = _step15.value;
                                                        option.selected = values.has(option.value);
                                                    }
                                                } catch (err) {
                                                    _iterator15.e(err);
                                                } finally{
                                                    _iterator15.f();
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true)
                                                });
                                            },
                                            multipleSelection: function multipleSelection(event) {
                                                selectElement.multiple = true;
                                            },
                                            remove: function remove(event) {
                                                var options = selectElement.options;
                                                var index = event.detail.remove;
                                                options[index].selected = false;
                                                selectElement.remove(index);
                                                if (options.length > 0) {
                                                    var i = Array.prototype.findIndex.call(options, function(option) {
                                                        return option.selected;
                                                    });
                                                    if (i === -1) options[0].selected = true;
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            clear: function clear(event) {
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                storage.setValue(id, {
                                                    value: null,
                                                    items: []
                                                });
                                            },
                                            insert: function insert(event) {
                                                var _event$detail$insert = event.detail.insert, index = _event$detail$insert.index, displayValue = _event$detail$insert.displayValue, exportValue = _event$detail$insert.exportValue;
                                                var optionElement = document.createElement("option");
                                                optionElement.textContent = displayValue;
                                                optionElement.value = exportValue;
                                                selectElement.insertBefore(optionElement, selectElement.children[index]);
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            items: function items(event) {
                                                var items = event.detail.items;
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                var _iterator16 = _createForOfIteratorHelper(items), _step16;
                                                try {
                                                    for(_iterator16.s(); !(_step16 = _iterator16.n()).done;){
                                                        var item = _step16.value;
                                                        var displayValue = item.displayValue, exportValue = item.exportValue;
                                                        var optionElement = document.createElement("option");
                                                        optionElement.textContent = displayValue;
                                                        optionElement.value = exportValue;
                                                        selectElement.appendChild(optionElement);
                                                    }
                                                } catch (err) {
                                                    _iterator16.e(err);
                                                } finally{
                                                    _iterator16.f();
                                                }
                                                if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                                storage.setValue(id, {
                                                    value: getValue(event, true),
                                                    items: getItems(event)
                                                });
                                            },
                                            indices: function indices(event) {
                                                var indices = new Set(event.detail.indices);
                                                var _iterator17 = _createForOfIteratorHelper(event.target.options), _step17;
                                                try {
                                                    for(_iterator17.s(); !(_step17 = _iterator17.n()).done;){
                                                        var option = _step17.value;
                                                        option.selected = indices.has(option.index);
                                                    }
                                                } catch (err) {
                                                    _iterator17.e(err);
                                                } finally{
                                                    _iterator17.f();
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(event, true)
                                                });
                                            },
                                            editable: function editable(event) {
                                                event.target.disabled = !event.detail.editable;
                                            }
                                        };
                                        _this10._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    selectElement.addEventListener("input", function(event) {
                                        var _this10$linkService$e;
                                        var exportValue = getValue(event, true);
                                        var value = getValue(event, false);
                                        storage.setValue(id, {
                                            value: exportValue
                                        });
                                        (_this10$linkService$e = _this10.linkService.eventBus) === null || _this10$linkService$e === void 0 || _this10$linkService$e.dispatch("dispatcheventinsandbox", {
                                            source: _this10,
                                            detail: {
                                                id: id,
                                                name: "Keystroke",
                                                value: value,
                                                changeEx: exportValue,
                                                willCommit: true,
                                                commitKey: 1,
                                                keyDown: false
                                            }
                                        });
                                    });
                                    this._setEventListeners(selectElement, [
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ],
                                        [
                                            "input",
                                            "Action"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                } else selectElement.addEventListener("input", function(event) {
                                    storage.setValue(id, {
                                        value: getValue(event)
                                    });
                                });
                                this._setBackgroundColor(selectElement);
                                this.container.appendChild(selectElement);
                                return this.container;
                            }
                        }
                    ]);
                    return ChoiceWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PopupAnnotationElement = /*#__PURE__*/ function(_AnnotationElement4) {
                    _inherits(PopupAnnotationElement, _AnnotationElement4);
                    var _super9 = _createSuper(PopupAnnotationElement);
                    function PopupAnnotationElement(parameters) {
                        var _parameters$data$titl2, _parameters$data$cont2, _parameters$data$rich2;
                        _classCallCheck(this, PopupAnnotationElement);
                        var isRenderable = !!((_parameters$data$titl2 = parameters.data.titleObj) !== null && _parameters$data$titl2 !== void 0 && _parameters$data$titl2.str || (_parameters$data$cont2 = parameters.data.contentsObj) !== null && _parameters$data$cont2 !== void 0 && _parameters$data$cont2.str || (_parameters$data$rich2 = parameters.data.richText) !== null && _parameters$data$rich2 !== void 0 && _parameters$data$rich2.str);
                        return _super9.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    _createClass(PopupAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var IGNORE_TYPES = [
                                    "Line",
                                    "Square",
                                    "Circle",
                                    "PolyLine",
                                    "Polygon",
                                    "Ink"
                                ];
                                this.container.className = "popupAnnotation";
                                if (IGNORE_TYPES.includes(this.data.parentType)) return this.container;
                                var selector = "[data-annotation-id=\"".concat(this.data.parentId, "\"]");
                                var parentElements = this.layer.querySelectorAll(selector);
                                if (parentElements.length === 0) return this.container;
                                var popup = new PopupElement({
                                    container: this.container,
                                    trigger: Array.from(parentElements),
                                    color: this.data.color,
                                    titleObj: this.data.titleObj,
                                    modificationDate: this.data.modificationDate,
                                    contentsObj: this.data.contentsObj,
                                    richText: this.data.richText
                                });
                                var page = this.page;
                                var rect = _util.Util.normalizeRect([
                                    this.data.parentRect[0],
                                    page.view[3] - this.data.parentRect[1] + page.view[1],
                                    this.data.parentRect[2],
                                    page.view[3] - this.data.parentRect[3] + page.view[1]
                                ]);
                                var popupLeft = rect[0] + this.data.parentRect[2] - this.data.parentRect[0];
                                var popupTop = rect[1];
                                this.container.style.transformOrigin = "".concat(-popupLeft, "px ").concat(-popupTop, "px");
                                this.container.style.left = "".concat(popupLeft, "px");
                                this.container.style.top = "".concat(popupTop, "px");
                                this.container.appendChild(popup.render());
                                return this.container;
                            }
                        }
                    ]);
                    return PopupAnnotationElement;
                }(AnnotationElement);
                var PopupElement = /*#__PURE__*/ function() {
                    function PopupElement(parameters) {
                        _classCallCheck(this, PopupElement);
                        this.container = parameters.container;
                        this.trigger = parameters.trigger;
                        this.color = parameters.color;
                        this.titleObj = parameters.titleObj;
                        this.modificationDate = parameters.modificationDate;
                        this.contentsObj = parameters.contentsObj;
                        this.richText = parameters.richText;
                        this.hideWrapper = parameters.hideWrapper || false;
                        this.pinned = false;
                    }
                    _createClass(PopupElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this$richText, _this$contentsObj;
                                var BACKGROUND_ENLIGHT = 0.7;
                                var wrapper = document.createElement("div");
                                wrapper.className = "popupWrapper";
                                this.hideElement = this.hideWrapper ? wrapper : this.container;
                                this.hideElement.hidden = true;
                                var popup = document.createElement("div");
                                popup.className = "popup";
                                var color = this.color;
                                if (color) {
                                    var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
                                    var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
                                    var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
                                    popup.style.backgroundColor = _util.Util.makeHexColor(r | 0, g | 0, b | 0);
                                }
                                var title = document.createElement("h1");
                                title.dir = this.titleObj.dir;
                                title.textContent = this.titleObj.str;
                                popup.appendChild(title);
                                var dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate);
                                if (dateObject) {
                                    var modificationDate = document.createElement("span");
                                    modificationDate.className = "popupDate";
                                    modificationDate.textContent = "{{date}}, {{time}}";
                                    modificationDate.dataset.l10nId = "annotation_date_string";
                                    modificationDate.dataset.l10nArgs = JSON.stringify({
                                        date: dateObject.toLocaleDateString(),
                                        time: dateObject.toLocaleTimeString()
                                    });
                                    popup.appendChild(modificationDate);
                                }
                                if ((_this$richText = this.richText) !== null && _this$richText !== void 0 && _this$richText.str && (!((_this$contentsObj = this.contentsObj) !== null && _this$contentsObj !== void 0 && _this$contentsObj.str) || this.contentsObj.str === this.richText.str)) {
                                    _xfa_layer.XfaLayer.render({
                                        xfaHtml: this.richText.html,
                                        intent: "richText",
                                        div: popup
                                    });
                                    popup.lastChild.className = "richText popupContent";
                                } else {
                                    var contents = this._formatContents(this.contentsObj);
                                    popup.appendChild(contents);
                                }
                                if (!Array.isArray(this.trigger)) this.trigger = [
                                    this.trigger
                                ];
                                var _iterator18 = _createForOfIteratorHelper(this.trigger), _step18;
                                try {
                                    for(_iterator18.s(); !(_step18 = _iterator18.n()).done;){
                                        var element = _step18.value;
                                        element.addEventListener("click", this._toggle.bind(this));
                                        element.addEventListener("mouseover", this._show.bind(this, false));
                                        element.addEventListener("mouseout", this._hide.bind(this, false));
                                    }
                                } catch (err) {
                                    _iterator18.e(err);
                                } finally{
                                    _iterator18.f();
                                }
                                popup.addEventListener("click", this._hide.bind(this, true));
                                wrapper.appendChild(popup);
                                return wrapper;
                            }
                        },
                        {
                            key: "_formatContents",
                            value: function _formatContents(_ref2) {
                                var str = _ref2.str, dir = _ref2.dir;
                                var p = document.createElement("p");
                                p.className = "popupContent";
                                p.dir = dir;
                                var lines = str.split(/(?:\r\n?|\n)/);
                                for(var i = 0, ii = lines.length; i < ii; ++i){
                                    var line = lines[i];
                                    p.appendChild(document.createTextNode(line));
                                    if (i < ii - 1) p.appendChild(document.createElement("br"));
                                }
                                return p;
                            }
                        },
                        {
                            key: "_toggle",
                            value: function _toggle() {
                                if (this.pinned) this._hide(true);
                                else this._show(true);
                            }
                        },
                        {
                            key: "_show",
                            value: function _show() {
                                var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (pin) this.pinned = true;
                                if (this.hideElement.hidden) {
                                    this.hideElement.hidden = false;
                                    this.container.style.zIndex += 1;
                                }
                            }
                        },
                        {
                            key: "_hide",
                            value: function _hide() {
                                var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                                if (unpin) this.pinned = false;
                                if (!this.hideElement.hidden && !this.pinned) {
                                    this.hideElement.hidden = true;
                                    this.container.style.zIndex -= 1;
                                }
                            }
                        }
                    ]);
                    return PopupElement;
                }();
                var FreeTextAnnotationElement = /*#__PURE__*/ function(_AnnotationElement5) {
                    _inherits(FreeTextAnnotationElement, _AnnotationElement5);
                    var _super10 = _createSuper(FreeTextAnnotationElement);
                    function FreeTextAnnotationElement(parameters) {
                        var _parameters$data$titl3, _parameters$data$cont3, _parameters$data$rich3;
                        _classCallCheck(this, FreeTextAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl3 = parameters.data.titleObj) !== null && _parameters$data$titl3 !== void 0 && _parameters$data$titl3.str || (_parameters$data$cont3 = parameters.data.contentsObj) !== null && _parameters$data$cont3 !== void 0 && _parameters$data$cont3.str || (_parameters$data$rich3 = parameters.data.richText) !== null && _parameters$data$rich3 !== void 0 && _parameters$data$rich3.str);
                        return _super10.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(FreeTextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "freeTextAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return FreeTextAnnotationElement;
                }(AnnotationElement);
                var LineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement6) {
                    _inherits(LineAnnotationElement, _AnnotationElement6);
                    var _super11 = _createSuper(LineAnnotationElement);
                    function LineAnnotationElement(parameters) {
                        var _parameters$data$titl4, _parameters$data$cont4, _parameters$data$rich4;
                        _classCallCheck(this, LineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl4 = parameters.data.titleObj) !== null && _parameters$data$titl4 !== void 0 && _parameters$data$titl4.str || (_parameters$data$cont4 = parameters.data.contentsObj) !== null && _parameters$data$cont4 !== void 0 && _parameters$data$cont4.str || (_parameters$data$rich4 = parameters.data.richText) !== null && _parameters$data$rich4 !== void 0 && _parameters$data$rich4.str);
                        return _super11.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(LineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "lineAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var line = this.svgFactory.createElement("svg:line");
                                line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                                line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                                line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                                line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                                line.setAttribute("stroke-width", data.borderStyle.width || 1);
                                line.setAttribute("stroke", "transparent");
                                line.setAttribute("fill", "transparent");
                                svg.appendChild(line);
                                this.container.append(svg);
                                this._createPopup(line, data);
                                return this.container;
                            }
                        }
                    ]);
                    return LineAnnotationElement;
                }(AnnotationElement);
                var SquareAnnotationElement = /*#__PURE__*/ function(_AnnotationElement7) {
                    _inherits(SquareAnnotationElement, _AnnotationElement7);
                    var _super12 = _createSuper(SquareAnnotationElement);
                    function SquareAnnotationElement(parameters) {
                        var _parameters$data$titl5, _parameters$data$cont5, _parameters$data$rich5;
                        _classCallCheck(this, SquareAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl5 = parameters.data.titleObj) !== null && _parameters$data$titl5 !== void 0 && _parameters$data$titl5.str || (_parameters$data$cont5 = parameters.data.contentsObj) !== null && _parameters$data$cont5 !== void 0 && _parameters$data$cont5.str || (_parameters$data$rich5 = parameters.data.richText) !== null && _parameters$data$rich5 !== void 0 && _parameters$data$rich5.str);
                        return _super12.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(SquareAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "squareAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var borderWidth = data.borderStyle.width;
                                var square = this.svgFactory.createElement("svg:rect");
                                square.setAttribute("x", borderWidth / 2);
                                square.setAttribute("y", borderWidth / 2);
                                square.setAttribute("width", width - borderWidth);
                                square.setAttribute("height", height - borderWidth);
                                square.setAttribute("stroke-width", borderWidth || 1);
                                square.setAttribute("stroke", "transparent");
                                square.setAttribute("fill", "transparent");
                                svg.appendChild(square);
                                this.container.append(svg);
                                this._createPopup(square, data);
                                return this.container;
                            }
                        }
                    ]);
                    return SquareAnnotationElement;
                }(AnnotationElement);
                var CircleAnnotationElement = /*#__PURE__*/ function(_AnnotationElement8) {
                    _inherits(CircleAnnotationElement, _AnnotationElement8);
                    var _super13 = _createSuper(CircleAnnotationElement);
                    function CircleAnnotationElement(parameters) {
                        var _parameters$data$titl6, _parameters$data$cont6, _parameters$data$rich6;
                        _classCallCheck(this, CircleAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl6 = parameters.data.titleObj) !== null && _parameters$data$titl6 !== void 0 && _parameters$data$titl6.str || (_parameters$data$cont6 = parameters.data.contentsObj) !== null && _parameters$data$cont6 !== void 0 && _parameters$data$cont6.str || (_parameters$data$rich6 = parameters.data.richText) !== null && _parameters$data$rich6 !== void 0 && _parameters$data$rich6.str);
                        return _super13.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(CircleAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "circleAnnotation";
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var borderWidth = data.borderStyle.width;
                                var circle = this.svgFactory.createElement("svg:ellipse");
                                circle.setAttribute("cx", width / 2);
                                circle.setAttribute("cy", height / 2);
                                circle.setAttribute("rx", width / 2 - borderWidth / 2);
                                circle.setAttribute("ry", height / 2 - borderWidth / 2);
                                circle.setAttribute("stroke-width", borderWidth || 1);
                                circle.setAttribute("stroke", "transparent");
                                circle.setAttribute("fill", "transparent");
                                svg.appendChild(circle);
                                this.container.append(svg);
                                this._createPopup(circle, data);
                                return this.container;
                            }
                        }
                    ]);
                    return CircleAnnotationElement;
                }(AnnotationElement);
                var PolylineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement9) {
                    _inherits(PolylineAnnotationElement, _AnnotationElement9);
                    var _super14 = _createSuper(PolylineAnnotationElement);
                    function PolylineAnnotationElement(parameters) {
                        var _parameters$data$titl7, _parameters$data$cont7, _parameters$data$rich7;
                        var _this11;
                        _classCallCheck(this, PolylineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl7 = parameters.data.titleObj) !== null && _parameters$data$titl7 !== void 0 && _parameters$data$titl7.str || (_parameters$data$cont7 = parameters.data.contentsObj) !== null && _parameters$data$cont7 !== void 0 && _parameters$data$cont7.str || (_parameters$data$rich7 = parameters.data.richText) !== null && _parameters$data$rich7 !== void 0 && _parameters$data$rich7.str);
                        _this11 = _super14.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                        _this11.containerClassName = "polylineAnnotation";
                        _this11.svgElementName = "svg:polyline";
                        return _this11;
                    }
                    _createClass(PolylineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = this.containerClassName;
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var points = [];
                                var _iterator19 = _createForOfIteratorHelper(data.vertices), _step19;
                                try {
                                    for(_iterator19.s(); !(_step19 = _iterator19.n()).done;){
                                        var coordinate = _step19.value;
                                        var x = coordinate.x - data.rect[0];
                                        var y = data.rect[3] - coordinate.y;
                                        points.push(x + "," + y);
                                    }
                                } catch (err) {
                                    _iterator19.e(err);
                                } finally{
                                    _iterator19.f();
                                }
                                points = points.join(" ");
                                var polyline = this.svgFactory.createElement(this.svgElementName);
                                polyline.setAttribute("points", points);
                                polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                polyline.setAttribute("stroke", "transparent");
                                polyline.setAttribute("fill", "transparent");
                                svg.appendChild(polyline);
                                this.container.append(svg);
                                this._createPopup(polyline, data);
                                return this.container;
                            }
                        }
                    ]);
                    return PolylineAnnotationElement;
                }(AnnotationElement);
                var PolygonAnnotationElement = /*#__PURE__*/ function(_PolylineAnnotationEl) {
                    _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
                    var _super15 = _createSuper(PolygonAnnotationElement);
                    function PolygonAnnotationElement(parameters) {
                        var _this12;
                        _classCallCheck(this, PolygonAnnotationElement);
                        _this12 = _super15.call(this, parameters);
                        _this12.containerClassName = "polygonAnnotation";
                        _this12.svgElementName = "svg:polygon";
                        return _this12;
                    }
                    return PolygonAnnotationElement;
                }(PolylineAnnotationElement);
                var CaretAnnotationElement = /*#__PURE__*/ function(_AnnotationElement10) {
                    _inherits(CaretAnnotationElement, _AnnotationElement10);
                    var _super16 = _createSuper(CaretAnnotationElement);
                    function CaretAnnotationElement(parameters) {
                        var _parameters$data$titl8, _parameters$data$cont8, _parameters$data$rich8;
                        _classCallCheck(this, CaretAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl8 = parameters.data.titleObj) !== null && _parameters$data$titl8 !== void 0 && _parameters$data$titl8.str || (_parameters$data$cont8 = parameters.data.contentsObj) !== null && _parameters$data$cont8 !== void 0 && _parameters$data$cont8.str || (_parameters$data$rich8 = parameters.data.richText) !== null && _parameters$data$rich8 !== void 0 && _parameters$data$rich8.str);
                        return _super16.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(CaretAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "caretAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return CaretAnnotationElement;
                }(AnnotationElement);
                var InkAnnotationElement = /*#__PURE__*/ function(_AnnotationElement11) {
                    _inherits(InkAnnotationElement, _AnnotationElement11);
                    var _super17 = _createSuper(InkAnnotationElement);
                    function InkAnnotationElement(parameters) {
                        var _parameters$data$titl9, _parameters$data$cont9, _parameters$data$rich9;
                        var _this13;
                        _classCallCheck(this, InkAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl9 = parameters.data.titleObj) !== null && _parameters$data$titl9 !== void 0 && _parameters$data$titl9.str || (_parameters$data$cont9 = parameters.data.contentsObj) !== null && _parameters$data$cont9 !== void 0 && _parameters$data$cont9.str || (_parameters$data$rich9 = parameters.data.richText) !== null && _parameters$data$rich9 !== void 0 && _parameters$data$rich9.str);
                        _this13 = _super17.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                        _this13.containerClassName = "inkAnnotation";
                        _this13.svgElementName = "svg:polyline";
                        return _this13;
                    }
                    _createClass(InkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = this.containerClassName;
                                var data = this.data;
                                var width = data.rect[2] - data.rect[0];
                                var height = data.rect[3] - data.rect[1];
                                var svg = this.svgFactory.create(width, height);
                                var _iterator20 = _createForOfIteratorHelper(data.inkLists), _step20;
                                try {
                                    for(_iterator20.s(); !(_step20 = _iterator20.n()).done;){
                                        var inkList = _step20.value;
                                        var points = [];
                                        var _iterator21 = _createForOfIteratorHelper(inkList), _step21;
                                        try {
                                            for(_iterator21.s(); !(_step21 = _iterator21.n()).done;){
                                                var coordinate = _step21.value;
                                                var x = coordinate.x - data.rect[0];
                                                var y = data.rect[3] - coordinate.y;
                                                points.push("".concat(x, ",").concat(y));
                                            }
                                        } catch (err) {
                                            _iterator21.e(err);
                                        } finally{
                                            _iterator21.f();
                                        }
                                        points = points.join(" ");
                                        var polyline = this.svgFactory.createElement(this.svgElementName);
                                        polyline.setAttribute("points", points);
                                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                        polyline.setAttribute("stroke", "transparent");
                                        polyline.setAttribute("fill", "transparent");
                                        this._createPopup(polyline, data);
                                        svg.appendChild(polyline);
                                    }
                                } catch (err) {
                                    _iterator20.e(err);
                                } finally{
                                    _iterator20.f();
                                }
                                this.container.append(svg);
                                return this.container;
                            }
                        }
                    ]);
                    return InkAnnotationElement;
                }(AnnotationElement);
                var HighlightAnnotationElement = /*#__PURE__*/ function(_AnnotationElement12) {
                    _inherits(HighlightAnnotationElement, _AnnotationElement12);
                    var _super18 = _createSuper(HighlightAnnotationElement);
                    function HighlightAnnotationElement(parameters) {
                        var _parameters$data$titl10, _parameters$data$cont10, _parameters$data$rich10;
                        _classCallCheck(this, HighlightAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl10 = parameters.data.titleObj) !== null && _parameters$data$titl10 !== void 0 && _parameters$data$titl10.str || (_parameters$data$cont10 = parameters.data.contentsObj) !== null && _parameters$data$cont10 !== void 0 && _parameters$data$cont10.str || (_parameters$data$rich10 = parameters.data.richText) !== null && _parameters$data$rich10 !== void 0 && _parameters$data$rich10.str);
                        return _super18.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(HighlightAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("highlightAnnotation");
                                this.container.className = "highlightAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return HighlightAnnotationElement;
                }(AnnotationElement);
                var UnderlineAnnotationElement = /*#__PURE__*/ function(_AnnotationElement13) {
                    _inherits(UnderlineAnnotationElement, _AnnotationElement13);
                    var _super19 = _createSuper(UnderlineAnnotationElement);
                    function UnderlineAnnotationElement(parameters) {
                        var _parameters$data$titl11, _parameters$data$cont11, _parameters$data$rich11;
                        _classCallCheck(this, UnderlineAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl11 = parameters.data.titleObj) !== null && _parameters$data$titl11 !== void 0 && _parameters$data$titl11.str || (_parameters$data$cont11 = parameters.data.contentsObj) !== null && _parameters$data$cont11 !== void 0 && _parameters$data$cont11.str || (_parameters$data$rich11 = parameters.data.richText) !== null && _parameters$data$rich11 !== void 0 && _parameters$data$rich11.str);
                        return _super19.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(UnderlineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("underlineAnnotation");
                                this.container.className = "underlineAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return UnderlineAnnotationElement;
                }(AnnotationElement);
                var SquigglyAnnotationElement = /*#__PURE__*/ function(_AnnotationElement14) {
                    _inherits(SquigglyAnnotationElement, _AnnotationElement14);
                    var _super20 = _createSuper(SquigglyAnnotationElement);
                    function SquigglyAnnotationElement(parameters) {
                        var _parameters$data$titl12, _parameters$data$cont12, _parameters$data$rich12;
                        _classCallCheck(this, SquigglyAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl12 = parameters.data.titleObj) !== null && _parameters$data$titl12 !== void 0 && _parameters$data$titl12.str || (_parameters$data$cont12 = parameters.data.contentsObj) !== null && _parameters$data$cont12 !== void 0 && _parameters$data$cont12.str || (_parameters$data$rich12 = parameters.data.richText) !== null && _parameters$data$rich12 !== void 0 && _parameters$data$rich12.str);
                        return _super20.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(SquigglyAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("squigglyAnnotation");
                                this.container.className = "squigglyAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return SquigglyAnnotationElement;
                }(AnnotationElement);
                var StrikeOutAnnotationElement = /*#__PURE__*/ function(_AnnotationElement15) {
                    _inherits(StrikeOutAnnotationElement, _AnnotationElement15);
                    var _super21 = _createSuper(StrikeOutAnnotationElement);
                    function StrikeOutAnnotationElement(parameters) {
                        var _parameters$data$titl13, _parameters$data$cont13, _parameters$data$rich13;
                        _classCallCheck(this, StrikeOutAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl13 = parameters.data.titleObj) !== null && _parameters$data$titl13 !== void 0 && _parameters$data$titl13.str || (_parameters$data$cont13 = parameters.data.contentsObj) !== null && _parameters$data$cont13 !== void 0 && _parameters$data$cont13.str || (_parameters$data$rich13 = parameters.data.richText) !== null && _parameters$data$rich13 !== void 0 && _parameters$data$rich13.str);
                        return _super21.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass(StrikeOutAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("strikeoutAnnotation");
                                this.container.className = "strikeoutAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return StrikeOutAnnotationElement;
                }(AnnotationElement);
                var StampAnnotationElement = /*#__PURE__*/ function(_AnnotationElement16) {
                    _inherits(StampAnnotationElement, _AnnotationElement16);
                    var _super22 = _createSuper(StampAnnotationElement);
                    function StampAnnotationElement(parameters) {
                        var _parameters$data$titl14, _parameters$data$cont14, _parameters$data$rich14;
                        _classCallCheck(this, StampAnnotationElement);
                        var isRenderable = !!(parameters.data.hasPopup || (_parameters$data$titl14 = parameters.data.titleObj) !== null && _parameters$data$titl14 !== void 0 && _parameters$data$titl14.str || (_parameters$data$cont14 = parameters.data.contentsObj) !== null && _parameters$data$cont14 !== void 0 && _parameters$data$cont14.str || (_parameters$data$rich14 = parameters.data.richText) !== null && _parameters$data$rich14 !== void 0 && _parameters$data$rich14.str);
                        return _super22.call(this, parameters, {
                            isRenderable: isRenderable,
                            ignoreBorder: true
                        });
                    }
                    _createClass(StampAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.className = "stampAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return StampAnnotationElement;
                }(AnnotationElement);
                var FileAttachmentAnnotationElement = /*#__PURE__*/ function(_AnnotationElement17) {
                    _inherits(FileAttachmentAnnotationElement, _AnnotationElement17);
                    var _super23 = _createSuper(FileAttachmentAnnotationElement);
                    function FileAttachmentAnnotationElement(parameters) {
                        var _this14$linkService$e;
                        var _this14;
                        _classCallCheck(this, FileAttachmentAnnotationElement);
                        _this14 = _super23.call(this, parameters, {
                            isRenderable: true
                        });
                        var _this14$data$file = _this14.data.file, filename = _this14$data$file.filename, content = _this14$data$file.content;
                        _this14.filename = (0, _display_utils.getFilenameFromUrl)(filename);
                        _this14.content = content;
                        (_this14$linkService$e = _this14.linkService.eventBus) === null || _this14$linkService$e === void 0 || _this14$linkService$e.dispatch("fileattachmentannotation", {
                            source: _assertThisInitialized(_this14),
                            id: (0, _util.stringToPDFString)(filename),
                            filename: filename,
                            content: content
                        });
                        return _this14;
                    }
                    _createClass(FileAttachmentAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this$data$titleObj, _this$data$contentsOb;
                                this.container.className = "fileAttachmentAnnotation";
                                var trigger = document.createElement("div");
                                trigger.style.height = this.container.style.height;
                                trigger.style.width = this.container.style.width;
                                trigger.addEventListener("dblclick", this._download.bind(this));
                                if (!this.data.hasPopup && ((_this$data$titleObj = this.data.titleObj) !== null && _this$data$titleObj !== void 0 && _this$data$titleObj.str || (_this$data$contentsOb = this.data.contentsObj) !== null && _this$data$contentsOb !== void 0 && _this$data$contentsOb.str || this.data.richText)) this._createPopup(trigger, this.data);
                                this.container.appendChild(trigger);
                                return this.container;
                            }
                        },
                        {
                            key: "_download",
                            value: function _download() {
                                var _this$downloadManager;
                                (_this$downloadManager = this.downloadManager) === null || _this$downloadManager === void 0 || _this$downloadManager.openOrDownloadData(this.container, this.content, this.filename);
                            }
                        }
                    ]);
                    return FileAttachmentAnnotationElement;
                }(AnnotationElement);
                var AnnotationLayer = /*#__PURE__*/ function() {
                    function AnnotationLayer() {
                        _classCallCheck(this, AnnotationLayer);
                    }
                    _createClass(AnnotationLayer, null, [
                        {
                            key: "render",
                            value: function render(parameters) {
                                var sortedAnnotations = [], popupAnnotations = [];
                                var _iterator22 = _createForOfIteratorHelper(parameters.annotations), _step22;
                                try {
                                    for(_iterator22.s(); !(_step22 = _iterator22.n()).done;){
                                        var _data = _step22.value;
                                        if (!_data) continue;
                                        if (_data.annotationType === _util.AnnotationType.POPUP) {
                                            popupAnnotations.push(_data);
                                            continue;
                                        }
                                        sortedAnnotations.push(_data);
                                    }
                                } catch (err) {
                                    _iterator22.e(err);
                                } finally{
                                    _iterator22.f();
                                }
                                if (popupAnnotations.length) sortedAnnotations.push.apply(sortedAnnotations, popupAnnotations);
                                var div = parameters.div;
                                for(var _i7 = 0, _sortedAnnotations = sortedAnnotations; _i7 < _sortedAnnotations.length; _i7++){
                                    var data = _sortedAnnotations[_i7];
                                    var element = AnnotationElementFactory.create({
                                        data: data,
                                        layer: div,
                                        page: parameters.page,
                                        viewport: parameters.viewport,
                                        linkService: parameters.linkService,
                                        downloadManager: parameters.downloadManager,
                                        imageResourcesPath: parameters.imageResourcesPath || "",
                                        renderForms: parameters.renderForms !== false,
                                        svgFactory: new _display_utils.DOMSVGFactory(),
                                        annotationStorage: parameters.annotationStorage || new _annotation_storage.AnnotationStorage(),
                                        enableScripting: parameters.enableScripting,
                                        hasJSActions: parameters.hasJSActions,
                                        fieldObjects: parameters.fieldObjects,
                                        mouseState: parameters.mouseState || {
                                            isDown: false
                                        }
                                    });
                                    if (element.isRenderable) {
                                        var rendered = element.render();
                                        if (data.hidden) rendered.style.visibility = "hidden";
                                        if (Array.isArray(rendered)) {
                                            var _iterator23 = _createForOfIteratorHelper(rendered), _step23;
                                            try {
                                                for(_iterator23.s(); !(_step23 = _iterator23.n()).done;){
                                                    var renderedElement = _step23.value;
                                                    div.appendChild(renderedElement);
                                                }
                                            } catch (err) {
                                                _iterator23.e(err);
                                            } finally{
                                                _iterator23.f();
                                            }
                                        } else if (element instanceof PopupAnnotationElement) div.prepend(rendered);
                                        else div.appendChild(rendered);
                                    }
                                }
                                _classStaticPrivateMethodGet(this, AnnotationLayer, _setAnnotationCanvasMap).call(this, div, parameters.annotationCanvasMap);
                            }
                        },
                        {
                            key: "update",
                            value: function update(parameters) {
                                var page = parameters.page, viewport = parameters.viewport, annotations = parameters.annotations, annotationCanvasMap = parameters.annotationCanvasMap, div = parameters.div;
                                var transform = viewport.transform;
                                var matrix = "matrix(".concat(transform.join(","), ")");
                                var scale, ownMatrix;
                                var _iterator24 = _createForOfIteratorHelper(annotations), _step24;
                                try {
                                    for(_iterator24.s(); !(_step24 = _iterator24.n()).done;){
                                        var data = _step24.value;
                                        var elements = div.querySelectorAll("[data-annotation-id=\"".concat(data.id, "\"]"));
                                        if (elements) {
                                            var _iterator25 = _createForOfIteratorHelper(elements), _step25;
                                            try {
                                                for(_iterator25.s(); !(_step25 = _iterator25.n()).done;){
                                                    var element = _step25.value;
                                                    if (data.hasOwnCanvas) {
                                                        var rect = _util.Util.normalizeRect([
                                                            data.rect[0],
                                                            page.view[3] - data.rect[1] + page.view[1],
                                                            data.rect[2],
                                                            page.view[3] - data.rect[3] + page.view[1]
                                                        ]);
                                                        if (!ownMatrix) {
                                                            scale = Math.abs(transform[0] || transform[1]);
                                                            var ownTransform = transform.slice();
                                                            for(var i = 0; i < 4; i++)ownTransform[i] = Math.sign(ownTransform[i]);
                                                            ownMatrix = "matrix(".concat(ownTransform.join(","), ")");
                                                        }
                                                        var left = rect[0] * scale;
                                                        var top = rect[1] * scale;
                                                        element.style.left = "".concat(left, "px");
                                                        element.style.top = "".concat(top, "px");
                                                        element.style.transformOrigin = "".concat(-left, "px ").concat(-top, "px");
                                                        element.style.transform = ownMatrix;
                                                    } else element.style.transform = matrix;
                                                }
                                            } catch (err) {
                                                _iterator25.e(err);
                                            } finally{
                                                _iterator25.f();
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _iterator24.e(err);
                                } finally{
                                    _iterator24.f();
                                }
                                _classStaticPrivateMethodGet(this, AnnotationLayer, _setAnnotationCanvasMap).call(this, div, annotationCanvasMap);
                                div.hidden = false;
                            }
                        }
                    ]);
                    return AnnotationLayer;
                }();
                exports.AnnotationLayer = AnnotationLayer;
                function _setAnnotationCanvasMap(div, annotationCanvasMap) {
                    if (!annotationCanvasMap) return;
                    var _iterator26 = _createForOfIteratorHelper(annotationCanvasMap), _step26;
                    try {
                        for(_iterator26.s(); !(_step26 = _iterator26.n()).done;){
                            var _step26$value = _slicedToArray(_step26.value, 2), id = _step26$value[0], canvas = _step26$value[1];
                            var element = div.querySelector("[data-annotation-id=\"".concat(id, "\"]"));
                            if (!element) continue;
                            var firstChild = element.firstChild;
                            if (firstChild.nodeName === "CANVAS") element.replaceChild(canvas, firstChild);
                            else element.insertBefore(canvas, firstChild);
                        }
                    } catch (err) {
                        _iterator26.e(err);
                    } finally{
                        _iterator26.f();
                    }
                    annotationCanvasMap.clear();
                }
            /***/ },
            /* 149 */ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                var ColorConverters = /*#__PURE__*/ function() {
                    function ColorConverters() {
                        _classCallCheck(this, ColorConverters);
                    }
                    _createClass(ColorConverters, null, [
                        {
                            key: "CMYK_G",
                            value: function CMYK_G(_ref) {
                                var _ref2 = _slicedToArray(_ref, 4), c = _ref2[0], y = _ref2[1], m = _ref2[2], k = _ref2[3];
                                return [
                                    "G",
                                    1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                                ];
                            }
                        },
                        {
                            key: "G_CMYK",
                            value: function G_CMYK(_ref3) {
                                var _ref4 = _slicedToArray(_ref3, 1), g = _ref4[0];
                                return [
                                    "CMYK",
                                    0,
                                    0,
                                    0,
                                    1 - g
                                ];
                            }
                        },
                        {
                            key: "G_RGB",
                            value: function G_RGB(_ref5) {
                                var _ref6 = _slicedToArray(_ref5, 1), g = _ref6[0];
                                return [
                                    "RGB",
                                    g,
                                    g,
                                    g
                                ];
                            }
                        },
                        {
                            key: "G_HTML",
                            value: function G_HTML(_ref7) {
                                var _ref8 = _slicedToArray(_ref7, 1), g = _ref8[0];
                                var G = makeColorComp(g);
                                return "#".concat(G).concat(G).concat(G);
                            }
                        },
                        {
                            key: "RGB_G",
                            value: function RGB_G(_ref9) {
                                var _ref10 = _slicedToArray(_ref9, 3), r = _ref10[0], g = _ref10[1], b = _ref10[2];
                                return [
                                    "G",
                                    0.3 * r + 0.59 * g + 0.11 * b
                                ];
                            }
                        },
                        {
                            key: "RGB_HTML",
                            value: function RGB_HTML(_ref11) {
                                var _ref12 = _slicedToArray(_ref11, 3), r = _ref12[0], g = _ref12[1], b = _ref12[2];
                                var R = makeColorComp(r);
                                var G = makeColorComp(g);
                                var B = makeColorComp(b);
                                return "#".concat(R).concat(G).concat(B);
                            }
                        },
                        {
                            key: "T_HTML",
                            value: function T_HTML() {
                                return "#00000000";
                            }
                        },
                        {
                            key: "CMYK_RGB",
                            value: function CMYK_RGB(_ref13) {
                                var _ref14 = _slicedToArray(_ref13, 4), c = _ref14[0], y = _ref14[1], m = _ref14[2], k = _ref14[3];
                                return [
                                    "RGB",
                                    1 - Math.min(1, c + k),
                                    1 - Math.min(1, m + k),
                                    1 - Math.min(1, y + k)
                                ];
                            }
                        },
                        {
                            key: "CMYK_HTML",
                            value: function CMYK_HTML(components) {
                                return this.RGB_HTML(this.CMYK_RGB(components));
                            }
                        },
                        {
                            key: "RGB_CMYK",
                            value: function RGB_CMYK(_ref15) {
                                var _ref16 = _slicedToArray(_ref15, 3), r = _ref16[0], g = _ref16[1], b = _ref16[2];
                                var c = 1 - r;
                                var m = 1 - g;
                                var y = 1 - b;
                                var k = Math.min(c, m, y);
                                return [
                                    "CMYK",
                                    c,
                                    m,
                                    y,
                                    k
                                ];
                            }
                        }
                    ]);
                    return ColorConverters;
                }();
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 150 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _util = __w_pdfjs_require__(4);
                var _xfa_text = __w_pdfjs_require__(147);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var XfaLayer = /*#__PURE__*/ function() {
                    function XfaLayer() {
                        _classCallCheck(this, XfaLayer);
                    }
                    _createClass(XfaLayer, null, [
                        {
                            key: "setupStorage",
                            value: function setupStorage(html, id, element, storage, intent) {
                                var storedData = storage.getValue(id, {
                                    value: null
                                });
                                switch(element.name){
                                    case "textarea":
                                        if (storedData.value !== null) html.textContent = storedData.value;
                                        if (intent === "print") break;
                                        html.addEventListener("input", function(event) {
                                            storage.setValue(id, {
                                                value: event.target.value
                                            });
                                        });
                                        break;
                                    case "input":
                                        if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                            if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                            else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                            if (intent === "print") break;
                                            html.addEventListener("change", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                                });
                                            });
                                        } else {
                                            if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                            if (intent === "print") break;
                                            html.addEventListener("input", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.value
                                                });
                                            });
                                        }
                                        break;
                                    case "select":
                                        if (storedData.value !== null) {
                                            var _iterator = _createForOfIteratorHelper(element.children), _step;
                                            try {
                                                for(_iterator.s(); !(_step = _iterator.n()).done;){
                                                    var option = _step.value;
                                                    if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                                }
                                            } catch (err) {
                                                _iterator.e(err);
                                            } finally{
                                                _iterator.f();
                                            }
                                        }
                                        html.addEventListener("input", function(event) {
                                            var options = event.target.options;
                                            var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: "setAttributes",
                            value: function setAttributes(_ref) {
                                var html = _ref.html, element = _ref.element, _ref$storage = _ref.storage, storage = _ref$storage === void 0 ? null : _ref$storage, intent = _ref.intent, linkService = _ref.linkService;
                                var attributes = element.attributes;
                                var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                                if (attributes.type === "radio") attributes.name = "".concat(attributes.name, "-").concat(intent);
                                for(var _i = 0, _Object$entries = Object.entries(attributes); _i < _Object$entries.length; _i++){
                                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                                    if (value === null || value === undefined || key === "dataId") continue;
                                    if (key !== "style") {
                                        if (key === "textContent") html.textContent = value;
                                        else if (key === "class") {
                                            if (value.length) html.setAttribute(key, value.join(" "));
                                        } else {
                                            if (isHTMLAnchorElement && (key === "href" || key === "newWindow")) continue;
                                            html.setAttribute(key, value);
                                        }
                                    } else Object.assign(html.style, value);
                                }
                                if (isHTMLAnchorElement) {
                                    var _linkService$addLinkA;
                                    if (!linkService.addLinkAttributes) (0, _util.warn)("XfaLayer.setAttribute - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA = linkService.addLinkAttributes) === null || _linkService$addLinkA === void 0 || _linkService$addLinkA.call(linkService, html, attributes.href, attributes.newWindow);
                                }
                                if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                            }
                        },
                        {
                            key: "render",
                            value: function render(parameters) {
                                var storage = parameters.annotationStorage;
                                var linkService = parameters.linkService;
                                var root = parameters.xfaHtml;
                                var intent = parameters.intent || "display";
                                var rootHtml = document.createElement(root.name);
                                if (root.attributes) this.setAttributes({
                                    html: rootHtml,
                                    element: root,
                                    intent: intent,
                                    linkService: linkService
                                });
                                var stack = [
                                    [
                                        root,
                                        -1,
                                        rootHtml
                                    ]
                                ];
                                var rootDiv = parameters.div;
                                rootDiv.appendChild(rootHtml);
                                if (parameters.viewport) {
                                    var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                    rootDiv.style.transform = transform;
                                }
                                if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                                var textDivs = [];
                                while(stack.length > 0){
                                    var _child$attributes;
                                    var _stack = _slicedToArray(stack[stack.length - 1], 3), parent = _stack[0], i = _stack[1], html = _stack[2];
                                    if (i + 1 === parent.children.length) {
                                        stack.pop();
                                        continue;
                                    }
                                    var child = parent.children[++stack[stack.length - 1][1]];
                                    if (child === null) continue;
                                    var name = child.name;
                                    if (name === "#text") {
                                        var node = document.createTextNode(child.value);
                                        textDivs.push(node);
                                        html.appendChild(node);
                                        continue;
                                    }
                                    var childHtml = void 0;
                                    if (child !== null && child !== void 0 && (_child$attributes = child.attributes) !== null && _child$attributes !== void 0 && _child$attributes.xmlns) childHtml = document.createElementNS(child.attributes.xmlns, name);
                                    else childHtml = document.createElement(name);
                                    html.appendChild(childHtml);
                                    if (child.attributes) this.setAttributes({
                                        html: childHtml,
                                        element: child,
                                        storage: storage,
                                        intent: intent,
                                        linkService: linkService
                                    });
                                    if (child.children && child.children.length > 0) stack.push([
                                        child,
                                        -1,
                                        childHtml
                                    ]);
                                    else if (child.value) {
                                        var _node = document.createTextNode(child.value);
                                        if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(_node);
                                        childHtml.appendChild(_node);
                                    }
                                }
                                var _iterator2 = _createForOfIteratorHelper(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var el = _step2.value;
                                        el.setAttribute("readOnly", true);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                return {
                                    textDivs: textDivs
                                };
                            }
                        },
                        {
                            key: "update",
                            value: function update(parameters) {
                                var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                parameters.div.style.transform = transform;
                                parameters.div.hidden = false;
                            }
                        }
                    ]);
                    return XfaLayer;
                }();
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 151 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.renderTextLayer = renderTextLayer;
                var _util = __w_pdfjs_require__(4);
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                var MAX_TEXT_DIVS_TO_RENDER = 100000;
                var DEFAULT_FONT_SIZE = 30;
                var DEFAULT_FONT_ASCENT = 0.8;
                var ascentCache = new Map();
                var AllWhitespaceRegexp = /^\s+$/g;
                function getAscent(fontFamily, ctx) {
                    var cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    ctx.save();
                    ctx.font = "".concat(DEFAULT_FONT_SIZE, "px ").concat(fontFamily);
                    var metrics = ctx.measureText("");
                    var ascent = metrics.fontBoundingBoxAscent;
                    var descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        ctx.restore();
                        var ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(var i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(var _i = 0, ii = pixels.length; _i < ii; _i += 4)if (pixels[_i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(_i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.restore();
                    if (ascent) {
                        var _ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, _ratio);
                        return _ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles, ctx) {
                    var textDiv = document.createElement("span");
                    var textDivProperties = task._enhanceTextSelection ? {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        originalTransform: null,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        scale: 1
                    } : {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL
                    };
                    task._textDivs.push(textDiv);
                    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
                    var angle = Math.atan2(tx[1], tx[0]);
                    var style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    var fontHeight = Math.hypot(tx[2], tx[3]);
                    var fontAscent = fontHeight * getAscent(style.fontFamily, ctx);
                    var left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    textDiv.style.left = "".concat(left, "px");
                    textDiv.style.top = "".concat(top, "px");
                    textDiv.style.fontSize = "".concat(fontHeight, "px");
                    textDiv.style.fontFamily = style.fontFamily;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    var shouldScaleText = false;
                    if (geom.str.length > 1 || task._enhanceTextSelection && AllWhitespaceRegexp.test(geom.str)) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        var absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) {
                        if (style.vertical) textDivProperties.canvasWidth = geom.height * task._viewport.scale;
                        else textDivProperties.canvasWidth = geom.width * task._viewport.scale;
                    }
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._textContentStream) task._layoutText(textDiv);
                    if (task._enhanceTextSelection && textDivProperties.hasText) {
                        var angleCos = 1, angleSin = 0;
                        if (angle !== 0) {
                            angleCos = Math.cos(angle);
                            angleSin = Math.sin(angle);
                        }
                        var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
                        var divHeight = fontHeight;
                        var m, b;
                        if (angle !== 0) {
                            m = [
                                angleCos,
                                angleSin,
                                -angleSin,
                                angleCos,
                                left,
                                top
                            ];
                            b = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                divWidth,
                                divHeight
                            ], m);
                        } else b = [
                            left,
                            top,
                            left + divWidth,
                            top + divHeight
                        ];
                        task._bounds.push({
                            left: b[0],
                            top: b[1],
                            right: b[2],
                            bottom: b[3],
                            div: textDiv,
                            size: [
                                divWidth,
                                divHeight
                            ],
                            m: m
                        });
                    }
                }
                function render(task) {
                    if (task._canceled) return;
                    var textDivs = task._textDivs;
                    var capability = task._capability;
                    var textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        task._renderingDone = true;
                        capability.resolve();
                        return;
                    }
                    if (!task._textContentStream) for(var i = 0; i < textDivsLength; i++)task._layoutText(textDivs[i]);
                    task._renderingDone = true;
                    capability.resolve();
                }
                function findPositiveMin(ts, offset, count) {
                    var result = 0;
                    for(var i = 0; i < count; i++){
                        var t = ts[offset++];
                        if (t > 0) result = result ? Math.min(t, result) : t;
                    }
                    return result;
                }
                function expand(task) {
                    var bounds = task._bounds;
                    var viewport = task._viewport;
                    var expanded = expandBounds(viewport.width, viewport.height, bounds);
                    for(var i = 0; i < expanded.length; i++){
                        var div = bounds[i].div;
                        var divProperties = task._textDivProperties.get(div);
                        if (divProperties.angle === 0) {
                            divProperties.paddingLeft = bounds[i].left - expanded[i].left;
                            divProperties.paddingTop = bounds[i].top - expanded[i].top;
                            divProperties.paddingRight = expanded[i].right - bounds[i].right;
                            divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
                            task._textDivProperties.set(div, divProperties);
                            continue;
                        }
                        var e = expanded[i], b = bounds[i];
                        var m = b.m, c = m[0], s = m[1];
                        var points = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                b.size[1]
                            ],
                            [
                                b.size[0],
                                0
                            ],
                            b.size
                        ];
                        var ts = new Float64Array(64);
                        for(var j = 0, jj = points.length; j < jj; j++){
                            var t = _util.Util.applyTransform(points[j], m);
                            ts[j + 0] = c && (e.left - t[0]) / c;
                            ts[j + 4] = s && (e.top - t[1]) / s;
                            ts[j + 8] = c && (e.right - t[0]) / c;
                            ts[j + 12] = s && (e.bottom - t[1]) / s;
                            ts[j + 16] = s && (e.left - t[0]) / -s;
                            ts[j + 20] = c && (e.top - t[1]) / c;
                            ts[j + 24] = s && (e.right - t[0]) / -s;
                            ts[j + 28] = c && (e.bottom - t[1]) / c;
                            ts[j + 32] = c && (e.left - t[0]) / -c;
                            ts[j + 36] = s && (e.top - t[1]) / -s;
                            ts[j + 40] = c && (e.right - t[0]) / -c;
                            ts[j + 44] = s && (e.bottom - t[1]) / -s;
                            ts[j + 48] = s && (e.left - t[0]) / s;
                            ts[j + 52] = c && (e.top - t[1]) / -c;
                            ts[j + 56] = s && (e.right - t[0]) / s;
                            ts[j + 60] = c && (e.bottom - t[1]) / -c;
                        }
                        var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
                        divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
                        divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
                        divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
                        divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
                        task._textDivProperties.set(div, divProperties);
                    }
                }
                function expandBounds(width, height, boxes) {
                    var bounds = boxes.map(function(box, i) {
                        return {
                            x1: box.left,
                            y1: box.top,
                            x2: box.right,
                            y2: box.bottom,
                            index: i,
                            x1New: undefined,
                            x2New: undefined
                        };
                    });
                    expandBoundsLTR(width, bounds);
                    var expanded = new Array(boxes.length);
                    var _iterator = _createForOfIteratorHelper(bounds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var b = _step.value;
                            var i = b.index;
                            expanded[i] = {
                                left: b.x1New,
                                top: 0,
                                right: b.x2New,
                                bottom: 0
                            };
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    boxes.map(function(box, i) {
                        var e = expanded[i], b = bounds[i];
                        b.x1 = box.top;
                        b.y1 = width - e.right;
                        b.x2 = box.bottom;
                        b.y2 = width - e.left;
                        b.index = i;
                        b.x1New = undefined;
                        b.x2New = undefined;
                    });
                    expandBoundsLTR(height, bounds);
                    var _iterator2 = _createForOfIteratorHelper(bounds), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _b = _step2.value;
                            var _i2 = _b.index;
                            expanded[_i2].top = _b.x1New;
                            expanded[_i2].bottom = _b.x2New;
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    return expanded;
                }
                function expandBoundsLTR(width, bounds) {
                    bounds.sort(function(a, b) {
                        return a.x1 - b.x1 || a.index - b.index;
                    });
                    var fakeBoundary = {
                        x1: -Infinity,
                        y1: -Infinity,
                        x2: 0,
                        y2: Infinity,
                        index: -1,
                        x1New: 0,
                        x2New: 0
                    };
                    var horizon = [
                        {
                            start: -Infinity,
                            end: Infinity,
                            boundary: fakeBoundary
                        }
                    ];
                    var _iterator3 = _createForOfIteratorHelper(bounds), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var boundary = _step3.value;
                            var i = 0;
                            while(i < horizon.length && horizon[i].end <= boundary.y1)i++;
                            var j = horizon.length - 1;
                            while(j >= 0 && horizon[j].start >= boundary.y2)j--;
                            var _horizonPart = void 0, _affectedBoundary = void 0;
                            var q = void 0, k = void 0, maxXNew = -Infinity;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                var xNew = void 0;
                                if (_affectedBoundary.x2 > boundary.x1) xNew = _affectedBoundary.index > boundary.index ? _affectedBoundary.x1New : boundary.x1;
                                else if (_affectedBoundary.x2New === undefined) xNew = (_affectedBoundary.x2 + boundary.x1) / 2;
                                else xNew = _affectedBoundary.x2New;
                                if (xNew > maxXNew) maxXNew = xNew;
                            }
                            boundary.x1New = maxXNew;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                if (_affectedBoundary.x2New === undefined) {
                                    if (_affectedBoundary.x2 > boundary.x1) {
                                        if (_affectedBoundary.index > boundary.index) _affectedBoundary.x2New = _affectedBoundary.x2;
                                    } else _affectedBoundary.x2New = maxXNew;
                                } else if (_affectedBoundary.x2New > maxXNew) _affectedBoundary.x2New = Math.max(maxXNew, _affectedBoundary.x2);
                            }
                            var changedHorizon = [];
                            var lastBoundary = null;
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                var useBoundary = _affectedBoundary.x2 > boundary.x2 ? _affectedBoundary : boundary;
                                if (lastBoundary === useBoundary) changedHorizon[changedHorizon.length - 1].end = _horizonPart.end;
                                else {
                                    changedHorizon.push({
                                        start: _horizonPart.start,
                                        end: _horizonPart.end,
                                        boundary: useBoundary
                                    });
                                    lastBoundary = useBoundary;
                                }
                            }
                            if (horizon[i].start < boundary.y1) {
                                changedHorizon[0].start = boundary.y1;
                                changedHorizon.unshift({
                                    start: horizon[i].start,
                                    end: boundary.y1,
                                    boundary: horizon[i].boundary
                                });
                            }
                            if (boundary.y2 < horizon[j].end) {
                                changedHorizon[changedHorizon.length - 1].end = boundary.y2;
                                changedHorizon.push({
                                    start: boundary.y2,
                                    end: horizon[j].end,
                                    boundary: horizon[j].boundary
                                });
                            }
                            for(q = i; q <= j; q++){
                                _horizonPart = horizon[q];
                                _affectedBoundary = _horizonPart.boundary;
                                if (_affectedBoundary.x2New !== undefined) continue;
                                var used = false;
                                for(k = i - 1; !used && k >= 0 && horizon[k].start >= _affectedBoundary.y1; k--)used = horizon[k].boundary === _affectedBoundary;
                                for(k = j + 1; !used && k < horizon.length && horizon[k].end <= _affectedBoundary.y2; k++)used = horizon[k].boundary === _affectedBoundary;
                                for(k = 0; !used && k < changedHorizon.length; k++)used = changedHorizon[k].boundary === _affectedBoundary;
                                if (!used) _affectedBoundary.x2New = maxXNew;
                            }
                            Array.prototype.splice.apply(horizon, [
                                i,
                                j - i + 1
                            ].concat(changedHorizon));
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                    for(var _i3 = 0, _horizon = horizon; _i3 < _horizon.length; _i3++){
                        var horizonPart = _horizon[_i3];
                        var affectedBoundary = horizonPart.boundary;
                        if (affectedBoundary.x2New === undefined) affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
                    }
                }
                var TextLayerRenderTask = /*#__PURE__*/ function() {
                    function TextLayerRenderTask(_ref) {
                        var _globalThis$FontInspe, _this = this;
                        var textContent = _ref.textContent, textContentStream = _ref.textContentStream, container = _ref.container, viewport = _ref.viewport, textDivs = _ref.textDivs, textContentItemsStr = _ref.textContentItemsStr, enhanceTextSelection = _ref.enhanceTextSelection;
                        _classCallCheck(this, TextLayerRenderTask);
                        this._textContent = textContent;
                        this._textContentStream = textContentStream;
                        this._container = container;
                        this._document = container.ownerDocument;
                        this._viewport = viewport;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._enhanceTextSelection = !!enhanceTextSelection;
                        this._fontInspectorEnabled = !!((_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled);
                        this._reader = null;
                        this._layoutTextLastFontSize = null;
                        this._layoutTextLastFontFamily = null;
                        this._layoutTextCtx = null;
                        this._textDivProperties = new WeakMap();
                        this._renderingDone = false;
                        this._canceled = false;
                        this._capability = (0, _util.createPromiseCapability)();
                        this._renderTimer = null;
                        this._bounds = [];
                        this._capability.promise["finally"](function() {
                            if (!_this._enhanceTextSelection) _this._textDivProperties = null;
                            if (_this._layoutTextCtx) {
                                _this._layoutTextCtx.canvas.width = 0;
                                _this._layoutTextCtx.canvas.height = 0;
                                _this._layoutTextCtx = null;
                            }
                        })["catch"](function() {});
                    }
                    _createClass(TextLayerRenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                this._canceled = true;
                                if (this._reader) {
                                    this._reader.cancel(new _util.AbortException("TextLayer task cancelled."))["catch"](function() {});
                                    this._reader = null;
                                }
                                if (this._renderTimer !== null) {
                                    clearTimeout(this._renderTimer);
                                    this._renderTimer = null;
                                }
                                this._capability.reject(new Error("TextLayer task cancelled."));
                            }
                        },
                        {
                            key: "_processItems",
                            value: function _processItems(items, styleCache) {
                                for(var i = 0, len = items.length; i < len; i++){
                                    if (items[i].str === undefined) {
                                        if (items[i].type === "beginMarkedContentProps" || items[i].type === "beginMarkedContent") {
                                            var parent = this._container;
                                            this._container = document.createElement("span");
                                            this._container.classList.add("markedContent");
                                            if (items[i].id !== null) this._container.setAttribute("id", "".concat(items[i].id));
                                            parent.appendChild(this._container);
                                        } else if (items[i].type === "endMarkedContent") this._container = this._container.parentNode;
                                        continue;
                                    }
                                    this._textContentItemsStr.push(items[i].str);
                                    appendText(this, items[i], styleCache, this._layoutTextCtx);
                                }
                            }
                        },
                        {
                            key: "_layoutText",
                            value: function _layoutText(textDiv) {
                                var textDivProperties = this._textDivProperties.get(textDiv);
                                var transform = "";
                                if (textDivProperties.canvasWidth !== 0 && textDivProperties.hasText) {
                                    var _textDiv$style = textDiv.style, fontSize = _textDiv$style.fontSize, fontFamily = _textDiv$style.fontFamily;
                                    if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
                                        this._layoutTextCtx.font = "".concat(fontSize, " ").concat(fontFamily);
                                        this._layoutTextLastFontSize = fontSize;
                                        this._layoutTextLastFontFamily = fontFamily;
                                    }
                                    var _this$_layoutTextCtx$ = this._layoutTextCtx.measureText(textDiv.textContent), width = _this$_layoutTextCtx$.width;
                                    if (width > 0) {
                                        var scale = textDivProperties.canvasWidth / width;
                                        if (this._enhanceTextSelection) textDivProperties.scale = scale;
                                        transform = "scaleX(".concat(scale, ")");
                                    }
                                }
                                if (textDivProperties.angle !== 0) transform = "rotate(".concat(textDivProperties.angle, "deg) ").concat(transform);
                                if (transform.length > 0) {
                                    if (this._enhanceTextSelection) textDivProperties.originalTransform = transform;
                                    textDiv.style.transform = transform;
                                }
                                if (textDivProperties.hasText) this._container.appendChild(textDiv);
                                if (textDivProperties.hasEOL) {
                                    var br = document.createElement("br");
                                    br.setAttribute("role", "presentation");
                                    this._container.appendChild(br);
                                }
                            }
                        },
                        {
                            key: "_render",
                            value: function _render() {
                                var _this2 = this;
                                var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                                var capability = (0, _util.createPromiseCapability)();
                                var styleCache = Object.create(null);
                                var canvas = this._document.createElement("canvas");
                                canvas.height = canvas.width = DEFAULT_FONT_SIZE;
                                canvas.mozOpaque = true;
                                this._layoutTextCtx = canvas.getContext("2d", {
                                    alpha: false
                                });
                                if (this._textContent) {
                                    var textItems = this._textContent.items;
                                    var textStyles = this._textContent.styles;
                                    this._processItems(textItems, textStyles);
                                    capability.resolve();
                                } else if (this._textContentStream) {
                                    var pump = function pump() {
                                        _this2._reader.read().then(function(_ref2) {
                                            var value = _ref2.value, done = _ref2.done;
                                            if (done) {
                                                capability.resolve();
                                                return;
                                            }
                                            Object.assign(styleCache, value.styles);
                                            _this2._processItems(value.items, styleCache);
                                            pump();
                                        }, capability.reject);
                                    };
                                    this._reader = this._textContentStream.getReader();
                                    pump();
                                } else throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                                capability.promise.then(function() {
                                    styleCache = null;
                                    if (!timeout) render(_this2);
                                    else _this2._renderTimer = setTimeout(function() {
                                        render(_this2);
                                        _this2._renderTimer = null;
                                    }, timeout);
                                }, this._capability.reject);
                            }
                        },
                        {
                            key: "expandTextDivs",
                            value: function expandTextDivs() {
                                var expandDivs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this._enhanceTextSelection || !this._renderingDone) return;
                                if (this._bounds !== null) {
                                    expand(this);
                                    this._bounds = null;
                                }
                                var transformBuf = [], paddingBuf = [];
                                for(var i = 0, ii = this._textDivs.length; i < ii; i++){
                                    var div = this._textDivs[i];
                                    var divProps = this._textDivProperties.get(div);
                                    if (!divProps.hasText) continue;
                                    if (expandDivs) {
                                        transformBuf.length = 0;
                                        paddingBuf.length = 0;
                                        if (divProps.originalTransform) transformBuf.push(divProps.originalTransform);
                                        if (divProps.paddingTop > 0) {
                                            paddingBuf.push("".concat(divProps.paddingTop, "px"));
                                            transformBuf.push("translateY(".concat(-divProps.paddingTop, "px)"));
                                        } else paddingBuf.push(0);
                                        if (divProps.paddingRight > 0) paddingBuf.push("".concat(divProps.paddingRight / divProps.scale, "px"));
                                        else paddingBuf.push(0);
                                        if (divProps.paddingBottom > 0) paddingBuf.push("".concat(divProps.paddingBottom, "px"));
                                        else paddingBuf.push(0);
                                        if (divProps.paddingLeft > 0) {
                                            paddingBuf.push("".concat(divProps.paddingLeft / divProps.scale, "px"));
                                            transformBuf.push("translateX(".concat(-divProps.paddingLeft / divProps.scale, "px)"));
                                        } else paddingBuf.push(0);
                                        div.style.padding = paddingBuf.join(" ");
                                        if (transformBuf.length) div.style.transform = transformBuf.join(" ");
                                    } else {
                                        div.style.padding = null;
                                        div.style.transform = divProps.originalTransform;
                                    }
                                }
                            }
                        }
                    ]);
                    return TextLayerRenderTask;
                }();
                function renderTextLayer(renderParameters) {
                    var task = new TextLayerRenderTask({
                        textContent: renderParameters.textContent,
                        textContentStream: renderParameters.textContentStream,
                        container: renderParameters.container,
                        viewport: renderParameters.viewport,
                        textDivs: renderParameters.textDivs,
                        textContentItemsStr: renderParameters.textContentItemsStr,
                        enhanceTextSelection: renderParameters.enhanceTextSelection
                    });
                    task._render(renderParameters.timeout);
                    return task;
                }
            /***/ },
            /* 152 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _is_node = __w_pdfjs_require__(6);
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var SVGGraphics = function SVGGraphics() {
                    _classCallCheck(this, SVGGraphics);
                    (0, _util.unreachable)("Not implemented: SVGGraphics");
                };
                exports.SVGGraphics = SVGGraphics;
                var opListToTree = function opListToTree(opList) {
                    var opTree = [];
                    var tmp = [];
                    var _iterator = _createForOfIteratorHelper(opList), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var opListElement = _step.value;
                            if (opListElement.fn === "save") {
                                opTree.push({
                                    fnId: 92,
                                    fn: "group",
                                    items: []
                                });
                                tmp.push(opTree);
                                opTree = opTree[opTree.length - 1].items;
                                continue;
                            }
                            if (opListElement.fn === "restore") opTree = tmp.pop();
                            else opTree.push(opListElement);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return opTree;
                };
                var pf = function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    var s = value.toFixed(10);
                    var i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                };
                var pm = function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            var a = Math.acos(m[0]) * 180 / Math.PI;
                            return "rotate(".concat(pf(a), ")");
                        }
                    } else {
                        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
                    }
                    return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
                };
                var SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                var XML_NS = "http://www.w3.org/XML/1998/namespace";
                var XLINK_NS = "http://www.w3.org/1999/xlink";
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var convertImgDataToPng = function() {
                    var PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    var CHUNK_WRAPPER_SIZE = 12;
                    var crcTable = new Int32Array(256);
                    for(var i = 0; i < 256; i++){
                        var c = i;
                        for(var h = 0; h < 8; h++)if (c & 1) c = 0xedb88320 ^ c >> 1 & 0x7fffffff;
                        else c = c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        var crc = -1;
                        for(var _i = start; _i < end; _i++){
                            var a = (crc ^ data[_i]) & 0xff;
                            var b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        var p = offset;
                        var len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        var crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        var a = 1;
                        var b = 0;
                        for(var _i2 = start; _i2 < end; ++_i2){
                            a = (a + (data[_i2] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_is_node.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            var input;
                            if (parseInt($f2AU3.versions.node) >= 8) input = literals;
                            else input = $04fdcf7a3248ff46$require$Buffer.from(literals);
                            var output = (parcelRequire("iJ8TW")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        var len = literals.length;
                        var maxBlockLength = 0xffff;
                        var deflateBlocks = Math.ceil(len / maxBlockLength);
                        var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        var pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        var pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        var adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        var width = imgData.width;
                        var height = imgData.height;
                        var bitDepth, colorType, lineSize;
                        var bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        var literals = new Uint8Array((1 + lineSize) * height);
                        var offsetLiterals = 0, offsetBytes = 0;
                        for(var y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(var _y = 0; _y < height; _y++){
                                offsetLiterals++;
                                for(var _i3 = 0; _i3 < lineSize; _i3++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        var ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        var idat = deflateSync(literals);
                        var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        var data = new Uint8Array(pngLength);
                        var offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return (0, _util.createObjectURL)(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                var SVGExtraState = /*#__PURE__*/ function() {
                    function SVGExtraState() {
                        _classCallCheck(this, SVGExtraState);
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    _createClass(SVGExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                return Object.create(this);
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        }
                    ]);
                    return SVGExtraState;
                }();
                var clipCount = 0;
                var maskCount = 0;
                var shadingCount = 0;
                exports.SVGGraphics = SVGGraphics = /*#__PURE__*/ function() {
                    function SVGGraphics(commonObjs, objs) {
                        var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        _classCallCheck(this, SVGGraphics);
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(var op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    _createClass(SVGGraphics, [
                        {
                            key: "save",
                            value: function save() {
                                this.transformStack.push(this.transformMatrix);
                                var old = this.current;
                                this.extraStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                this.transformMatrix = this.transformStack.pop();
                                this.current = this.extraStack.pop();
                                this.pendingClip = null;
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "group",
                            value: function group(items) {
                                this.save();
                                this.executeOpTree(items);
                                this.restore();
                            }
                        },
                        {
                            key: "loadDependencies",
                            value: function loadDependencies(operatorList) {
                                var _this = this;
                                var fnArray = operatorList.fnArray;
                                var argsArray = operatorList.argsArray;
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    if (fnArray[i] !== _util.OPS.dependency) continue;
                                    var _iterator2 = _createForOfIteratorHelper(argsArray[i]), _step2;
                                    try {
                                        var _loop = function _loop() {
                                            var obj = _step2.value;
                                            var objsPool = obj.startsWith("g_") ? _this.commonObjs : _this.objs;
                                            var promise = new Promise(function(resolve) {
                                                objsPool.get(obj, resolve);
                                            });
                                            _this.current.dependencies.push(promise);
                                        };
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                }
                                return Promise.all(this.current.dependencies);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                var transformMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "getSVG",
                            value: function getSVG(operatorList, viewport) {
                                var _this2 = this;
                                this.viewport = viewport;
                                var svgElement = this._initialize(viewport);
                                return this.loadDependencies(operatorList).then(function() {
                                    _this2.transformMatrix = _util.IDENTITY_MATRIX;
                                    _this2.executeOpTree(_this2.convertOpList(operatorList));
                                    return svgElement;
                                });
                            }
                        },
                        {
                            key: "convertOpList",
                            value: function convertOpList(operatorList) {
                                var operatorIdMapping = this._operatorIdMapping;
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var opList = [];
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    var fnId = fnArray[i];
                                    opList.push({
                                        fnId: fnId,
                                        fn: operatorIdMapping[fnId],
                                        args: argsArray[i]
                                    });
                                }
                                return opListToTree(opList);
                            }
                        },
                        {
                            key: "executeOpTree",
                            value: function executeOpTree(opTree) {
                                var _iterator3 = _createForOfIteratorHelper(opTree), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var opTreeElement = _step3.value;
                                        var fn = opTreeElement.fn;
                                        var fnId = opTreeElement.fnId;
                                        var args = opTreeElement.args;
                                        switch(fnId | 0){
                                            case _util.OPS.beginText:
                                                this.beginText();
                                                break;
                                            case _util.OPS.dependency:
                                                break;
                                            case _util.OPS.setLeading:
                                                this.setLeading(args);
                                                break;
                                            case _util.OPS.setLeadingMoveText:
                                                this.setLeadingMoveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setFont:
                                                this.setFont(args);
                                                break;
                                            case _util.OPS.showText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.showSpacedText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.endText:
                                                this.endText();
                                                break;
                                            case _util.OPS.moveText:
                                                this.moveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setCharSpacing:
                                                this.setCharSpacing(args[0]);
                                                break;
                                            case _util.OPS.setWordSpacing:
                                                this.setWordSpacing(args[0]);
                                                break;
                                            case _util.OPS.setHScale:
                                                this.setHScale(args[0]);
                                                break;
                                            case _util.OPS.setTextMatrix:
                                                this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.setTextRise:
                                                this.setTextRise(args[0]);
                                                break;
                                            case _util.OPS.setTextRenderingMode:
                                                this.setTextRenderingMode(args[0]);
                                                break;
                                            case _util.OPS.setLineWidth:
                                                this.setLineWidth(args[0]);
                                                break;
                                            case _util.OPS.setLineJoin:
                                                this.setLineJoin(args[0]);
                                                break;
                                            case _util.OPS.setLineCap:
                                                this.setLineCap(args[0]);
                                                break;
                                            case _util.OPS.setMiterLimit:
                                                this.setMiterLimit(args[0]);
                                                break;
                                            case _util.OPS.setFillRGBColor:
                                                this.setFillRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeRGBColor:
                                                this.setStrokeRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeColorN:
                                                this.setStrokeColorN(args);
                                                break;
                                            case _util.OPS.setFillColorN:
                                                this.setFillColorN(args);
                                                break;
                                            case _util.OPS.shadingFill:
                                                this.shadingFill(args[0]);
                                                break;
                                            case _util.OPS.setDash:
                                                this.setDash(args[0], args[1]);
                                                break;
                                            case _util.OPS.setRenderingIntent:
                                                this.setRenderingIntent(args[0]);
                                                break;
                                            case _util.OPS.setFlatness:
                                                this.setFlatness(args[0]);
                                                break;
                                            case _util.OPS.setGState:
                                                this.setGState(args[0]);
                                                break;
                                            case _util.OPS.fill:
                                                this.fill();
                                                break;
                                            case _util.OPS.eoFill:
                                                this.eoFill();
                                                break;
                                            case _util.OPS.stroke:
                                                this.stroke();
                                                break;
                                            case _util.OPS.fillStroke:
                                                this.fillStroke();
                                                break;
                                            case _util.OPS.eoFillStroke:
                                                this.eoFillStroke();
                                                break;
                                            case _util.OPS.clip:
                                                this.clip("nonzero");
                                                break;
                                            case _util.OPS.eoClip:
                                                this.clip("evenodd");
                                                break;
                                            case _util.OPS.paintSolidColorImageMask:
                                                this.paintSolidColorImageMask();
                                                break;
                                            case _util.OPS.paintImageXObject:
                                                this.paintImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintInlineImageXObject:
                                                this.paintInlineImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintImageMaskXObject:
                                                this.paintImageMaskXObject(args[0]);
                                                break;
                                            case _util.OPS.paintFormXObjectBegin:
                                                this.paintFormXObjectBegin(args[0], args[1]);
                                                break;
                                            case _util.OPS.paintFormXObjectEnd:
                                                this.paintFormXObjectEnd();
                                                break;
                                            case _util.OPS.closePath:
                                                this.closePath();
                                                break;
                                            case _util.OPS.closeStroke:
                                                this.closeStroke();
                                                break;
                                            case _util.OPS.closeFillStroke:
                                                this.closeFillStroke();
                                                break;
                                            case _util.OPS.closeEOFillStroke:
                                                this.closeEOFillStroke();
                                                break;
                                            case _util.OPS.nextLine:
                                                this.nextLine();
                                                break;
                                            case _util.OPS.transform:
                                                this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.constructPath:
                                                this.constructPath(args[0], args[1]);
                                                break;
                                            case _util.OPS.endPath:
                                                this.endPath();
                                                break;
                                            case 92:
                                                this.group(opTreeElement.items);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented operator ".concat(fn));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(wordSpacing) {
                                this.current.wordSpacing = wordSpacing;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(charSpacing) {
                                this.current.charSpacing = charSpacing;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                var current = this.current;
                                current.textMatrix = current.lineMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                current.textMatrixScale = Math.hypot(a, b);
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtElement.appendChild(current.tspan);
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                var current = this.current;
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.textMatrix = _util.IDENTITY_MATRIX;
                                current.lineMatrix = _util.IDENTITY_MATRIX;
                                current.textMatrixScale = 1;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtgrp = this.svgFactory.createElement("svg:g");
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                var current = this.current;
                                current.x = current.lineX += x;
                                current.y = current.lineY += y;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var x = 0;
                                var _iterator4 = _createForOfIteratorHelper(glyphs), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var glyph = _step4.value;
                                        if (glyph === null) {
                                            x += fontDirection * wordSpacing;
                                            continue;
                                        } else if ((0, _util.isNum)(glyph)) {
                                            x += spacingDir * glyph * fontSize / 1000;
                                            continue;
                                        }
                                        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                        var character = glyph.fontChar;
                                        var scaledX = void 0, scaledY = void 0;
                                        var width = glyph.width;
                                        if (vertical) {
                                            var vx = void 0;
                                            var vmetric = glyph.vmetric || defaultVMetrics;
                                            vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                            vx = -vx * widthAdvanceScale;
                                            var vy = vmetric[2] * widthAdvanceScale;
                                            width = vmetric ? -vmetric[0] : width;
                                            scaledX = vx / fontSizeScale;
                                            scaledY = (x + vy) / fontSizeScale;
                                        } else {
                                            scaledX = x / fontSizeScale;
                                            scaledY = 0;
                                        }
                                        if (glyph.isInFont || font.missingFile) {
                                            current.xcoords.push(current.x + scaledX);
                                            if (vertical) current.ycoords.push(-current.y + scaledY);
                                            current.tspan.textContent += character;
                                        }
                                        var charWidth = void 0;
                                        if (vertical) charWidth = width * widthAdvanceScale - spacing * fontDirection;
                                        else charWidth = width * widthAdvanceScale + spacing * fontDirection;
                                        x += charWidth;
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                                if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                                else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                                if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                                var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                                    if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                                else current.tspan.setAttributeNS(null, "fill", "none");
                                if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    var lineWidthScale = 1 / (current.textMatrixScale || 1);
                                    this._setStrokeAttributes(current.tspan, lineWidthScale);
                                }
                                var textMatrix = current.textMatrix;
                                if (current.textRise !== 0) {
                                    textMatrix = textMatrix.slice();
                                    textMatrix[5] += current.textRise;
                                }
                                current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
                                current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                                current.txtElement.appendChild(current.tspan);
                                current.txtgrp.appendChild(current.txtElement);
                                this._ensureTransformGroup().appendChild(current.txtElement);
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "addFontStyle",
                            value: function addFontStyle(fontObj) {
                                if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                                if (!this.cssStyle) {
                                    this.cssStyle = this.svgFactory.createElement("svg:style");
                                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                                    this.defs.appendChild(this.cssStyle);
                                }
                                var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                                this.cssStyle.textContent += "@font-face { font-family: \"".concat(fontObj.loadedName, "\";") + " src: url(".concat(url, "); }\n");
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(details) {
                                var current = this.current;
                                var fontObj = this.commonObjs.get(details[0]);
                                var size = details[1];
                                current.font = fontObj;
                                if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                                    this.addFontStyle(fontObj);
                                    this.embeddedFonts[fontObj.loadedName] = fontObj;
                                }
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                current.fontSize = size;
                                current.fontFamily = fontObj.loadedName;
                                current.fontWeight = bold;
                                current.fontStyle = italic;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var _current$txtElement;
                                var current = this.current;
                                if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && (_current$txtElement = current.txtElement) !== null && _current$txtElement !== void 0 && _current$txtElement.hasChildNodes()) {
                                    current.element = current.txtElement;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                if (width > 0) this.current.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.current.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.current.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.current.miterLimit = limit;
                            }
                        },
                        {
                            key: "setStrokeAlpha",
                            value: function setStrokeAlpha(strokeAlpha) {
                                this.current.strokeAlpha = strokeAlpha;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                            }
                        },
                        {
                            key: "setFillAlpha",
                            value: function setFillAlpha(fillAlpha) {
                                this.current.fillAlpha = fillAlpha;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                                this.current.xcoords = [];
                                this.current.ycoords = [];
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN(args) {
                                this.current.strokeColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN(args) {
                                this.current.fillColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(args) {
                                var width = this.viewport.width;
                                var height = this.viewport.height;
                                var inv = _util.Util.inverseTransform(this.transformMatrix);
                                var bl = _util.Util.applyTransform([
                                    0,
                                    0
                                ], inv);
                                var br = _util.Util.applyTransform([
                                    0,
                                    height
                                ], inv);
                                var ul = _util.Util.applyTransform([
                                    width,
                                    0
                                ], inv);
                                var ur = _util.Util.applyTransform([
                                    width,
                                    height
                                ], inv);
                                var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                                var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                                var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                                var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", x0);
                                rect.setAttributeNS(null, "y", y0);
                                rect.setAttributeNS(null, "width", x1 - x0);
                                rect.setAttributeNS(null, "height", y1 - y0);
                                rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                                if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                                this._ensureTransformGroup().appendChild(rect);
                            }
                        },
                        {
                            key: "_makeColorN_Pattern",
                            value: function _makeColorN_Pattern(args) {
                                if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                                return this._makeShadingPattern(args);
                            }
                        },
                        {
                            key: "_makeTilingPattern",
                            value: function _makeTilingPattern(args) {
                                var color = args[1];
                                var operatorList = args[2];
                                var matrix = args[3] || _util.IDENTITY_MATRIX;
                                var _args$ = _slicedToArray(args[4], 4), x0 = _args$[0], y0 = _args$[1], x1 = _args$[2], y1 = _args$[3];
                                var xstep = args[5];
                                var ystep = args[6];
                                var paintType = args[7];
                                var tilingId = "shading".concat(shadingCount++);
                                var _Util$normalizeRect = _util.Util.normalizeRect([].concat(_toConsumableArray(_util.Util.applyTransform([
                                    x0,
                                    y0
                                ], matrix)), _toConsumableArray(_util.Util.applyTransform([
                                    x1,
                                    y1
                                ], matrix)))), _Util$normalizeRect2 = _slicedToArray(_Util$normalizeRect, 4), tx0 = _Util$normalizeRect2[0], ty0 = _Util$normalizeRect2[1], tx1 = _Util$normalizeRect2[2], ty1 = _Util$normalizeRect2[3];
                                var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(matrix), _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2), xscale = _Util$singularValueDe2[0], yscale = _Util$singularValueDe2[1];
                                var txstep = xstep * xscale;
                                var tystep = ystep * yscale;
                                var tiling = this.svgFactory.createElement("svg:pattern");
                                tiling.setAttributeNS(null, "id", tilingId);
                                tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                                tiling.setAttributeNS(null, "width", txstep);
                                tiling.setAttributeNS(null, "height", tystep);
                                tiling.setAttributeNS(null, "x", "".concat(tx0));
                                tiling.setAttributeNS(null, "y", "".concat(ty0));
                                var svg = this.svg;
                                var transformMatrix = this.transformMatrix;
                                var fillColor = this.current.fillColor;
                                var strokeColor = this.current.strokeColor;
                                var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                                this.svg = bbox;
                                this.transformMatrix = matrix;
                                if (paintType === 2) {
                                    var cssColor = _util.Util.makeHexColor.apply(_util.Util, _toConsumableArray(color));
                                    this.current.fillColor = cssColor;
                                    this.current.strokeColor = cssColor;
                                }
                                this.executeOpTree(this.convertOpList(operatorList));
                                this.svg = svg;
                                this.transformMatrix = transformMatrix;
                                this.current.fillColor = fillColor;
                                this.current.strokeColor = strokeColor;
                                tiling.appendChild(bbox.childNodes[0]);
                                this.defs.appendChild(tiling);
                                return "url(#".concat(tilingId, ")");
                            }
                        },
                        {
                            key: "_makeShadingPattern",
                            value: function _makeShadingPattern(args) {
                                if (typeof args === "string") args = this.objs.get(args);
                                switch(args[0]){
                                    case "RadialAxial":
                                        var shadingId = "shading".concat(shadingCount++);
                                        var colorStops = args[3];
                                        var gradient;
                                        switch(args[1]){
                                            case "axial":
                                                var point0 = args[4];
                                                var point1 = args[5];
                                                gradient = this.svgFactory.createElement("svg:linearGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "x1", point0[0]);
                                                gradient.setAttributeNS(null, "y1", point0[1]);
                                                gradient.setAttributeNS(null, "x2", point1[0]);
                                                gradient.setAttributeNS(null, "y2", point1[1]);
                                                break;
                                            case "radial":
                                                var focalPoint = args[4];
                                                var circlePoint = args[5];
                                                var focalRadius = args[6];
                                                var circleRadius = args[7];
                                                gradient = this.svgFactory.createElement("svg:radialGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                                gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                                gradient.setAttributeNS(null, "r", circleRadius);
                                                gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                                gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                                gradient.setAttributeNS(null, "fr", focalRadius);
                                                break;
                                            default:
                                                throw new Error("Unknown RadialAxial type: ".concat(args[1]));
                                        }
                                        var _iterator5 = _createForOfIteratorHelper(colorStops), _step5;
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                var colorStop = _step5.value;
                                                var stop = this.svgFactory.createElement("svg:stop");
                                                stop.setAttributeNS(null, "offset", colorStop[0]);
                                                stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                                gradient.appendChild(stop);
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                        this.defs.appendChild(gradient);
                                        return "url(#".concat(shadingId, ")");
                                    case "Mesh":
                                        (0, _util.warn)("Unimplemented pattern Mesh");
                                        return null;
                                    case "Dummy":
                                        return "hotpink";
                                    default:
                                        throw new Error("Unknown IR type: ".concat(args[0]));
                                }
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                this.current.dashArray = dashArray;
                                this.current.dashPhase = dashPhase;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args) {
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var d = [];
                                var j = 0;
                                var _iterator6 = _createForOfIteratorHelper(ops), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var op = _step6.value;
                                        switch(op | 0){
                                            case _util.OPS.rectangle:
                                                x = args[j++];
                                                y = args[j++];
                                                var width = args[j++];
                                                var height = args[j++];
                                                var xw = x + width;
                                                var yh = y + height;
                                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                                break;
                                            case _util.OPS.moveTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("M", pf(x), pf(y));
                                                break;
                                            case _util.OPS.lineTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("L", pf(x), pf(y));
                                                break;
                                            case _util.OPS.curveTo:
                                                x = args[j + 4];
                                                y = args[j + 5];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                                j += 6;
                                                break;
                                            case _util.OPS.curveTo2:
                                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                j += 4;
                                                break;
                                            case _util.OPS.curveTo3:
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                                j += 4;
                                                break;
                                            case _util.OPS.closePath:
                                                d.push("Z");
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                d = d.join(" ");
                                if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                                else {
                                    current.path = this.svgFactory.createElement("svg:path");
                                    this._ensureTransformGroup().appendChild(current.path);
                                }
                                current.path.setAttributeNS(null, "d", d);
                                current.path.setAttributeNS(null, "fill", "none");
                                current.element = current.path;
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                var current = this.current;
                                current.path = null;
                                if (!this.pendingClip) return;
                                if (!current.element) {
                                    this.pendingClip = null;
                                    return;
                                }
                                var clipId = "clippath".concat(clipCount++);
                                var clipPath = this.svgFactory.createElement("svg:clipPath");
                                clipPath.setAttributeNS(null, "id", clipId);
                                clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                var clipElement = current.element.cloneNode(true);
                                if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                                else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                                this.pendingClip = null;
                                clipPath.appendChild(clipElement);
                                this.defs.appendChild(clipPath);
                                if (current.activeClipUrl) {
                                    current.clipGroup = null;
                                    var _iterator7 = _createForOfIteratorHelper(this.extraStack), _step7;
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            var prev = _step7.value;
                                            prev.clipGroup = null;
                                        }
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                                }
                                current.activeClipUrl = "url(#".concat(clipId, ")");
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "clip",
                            value: function clip(type) {
                                this.pendingClip = type;
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                var current = this.current;
                                if (current.path) {
                                    var d = "".concat(current.path.getAttributeNS(null, "d"), "Z");
                                    current.path.setAttributeNS(null, "d", d);
                                }
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(textRise) {
                                this.current.textRise = textRise;
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(textRenderingMode) {
                                this.current.textRenderingMode = textRenderingMode;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                var _iterator8 = _createForOfIteratorHelper(states), _step8;
                                try {
                                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                        var _step8$value = _slicedToArray(_step8.value, 2), key = _step8$value[0], value = _step8$value[1];
                                        switch(key){
                                            case "LW":
                                                this.setLineWidth(value);
                                                break;
                                            case "LC":
                                                this.setLineCap(value);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(value);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(value);
                                                break;
                                            case "D":
                                                this.setDash(value[0], value[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(value);
                                                break;
                                            case "FL":
                                                this.setFlatness(value);
                                                break;
                                            case "Font":
                                                this.setFont(value);
                                                break;
                                            case "CA":
                                                this.setStrokeAlpha(value);
                                                break;
                                            case "ca":
                                                this.setFillAlpha(value);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _iterator8.e(err);
                                } finally{
                                    _iterator8.f();
                                }
                            }
                        },
                        {
                            key: "fill",
                            value: function fill() {
                                var current = this.current;
                                if (current.element) {
                                    current.element.setAttributeNS(null, "fill", current.fillColor);
                                    current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke() {
                                var current = this.current;
                                if (current.element) {
                                    this._setStrokeAttributes(current.element);
                                    current.element.setAttributeNS(null, "fill", "none");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "_setStrokeAttributes",
                            value: function _setStrokeAttributes(element) {
                                var lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                var current = this.current;
                                var dashArray = current.dashArray;
                                if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                                    return lineWidthScale * value;
                                });
                                element.setAttributeNS(null, "stroke", current.strokeColor);
                                element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                                element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                                element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                                element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                                element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                                element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                                element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.stroke();
                                this.fill();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.closePath();
                                this.eoFillStroke();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", "1px");
                                rect.setAttributeNS(null, "height", "1px");
                                rect.setAttributeNS(null, "fill", this.current.fillColor);
                                this._ensureTransformGroup().appendChild(rect);
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                var imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData, mask) {
                                var width = imgData.width;
                                var height = imgData.height;
                                var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                                var cliprect = this.svgFactory.createElement("svg:rect");
                                cliprect.setAttributeNS(null, "x", "0");
                                cliprect.setAttributeNS(null, "y", "0");
                                cliprect.setAttributeNS(null, "width", pf(width));
                                cliprect.setAttributeNS(null, "height", pf(height));
                                this.current.element = cliprect;
                                this.clip("nonzero");
                                var imgEl = this.svgFactory.createElement("svg:image");
                                imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                                imgEl.setAttributeNS(null, "x", "0");
                                imgEl.setAttributeNS(null, "y", pf(-height));
                                imgEl.setAttributeNS(null, "width", pf(width) + "px");
                                imgEl.setAttributeNS(null, "height", pf(height) + "px");
                                imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));
                                if (mask) mask.appendChild(imgEl);
                                else this._ensureTransformGroup().appendChild(imgEl);
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(imgData) {
                                var current = this.current;
                                var width = imgData.width;
                                var height = imgData.height;
                                var fillColor = current.fillColor;
                                current.maskId = "mask".concat(maskCount++);
                                var mask = this.svgFactory.createElement("svg:mask");
                                mask.setAttributeNS(null, "id", current.maskId);
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", pf(width));
                                rect.setAttributeNS(null, "height", pf(height));
                                rect.setAttributeNS(null, "fill", fillColor);
                                rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
                                this.defs.appendChild(mask);
                                this._ensureTransformGroup().appendChild(rect);
                                this.paintInlineImageXObject(imgData, mask);
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    var cliprect = this.svgFactory.createElement("svg:rect");
                                    cliprect.setAttributeNS(null, "x", bbox[0]);
                                    cliprect.setAttributeNS(null, "y", bbox[1]);
                                    cliprect.setAttributeNS(null, "width", pf(width));
                                    cliprect.setAttributeNS(null, "height", pf(height));
                                    this.current.element = cliprect;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {}
                        },
                        {
                            key: "_initialize",
                            value: function _initialize(viewport) {
                                var svg = this.svgFactory.create(viewport.width, viewport.height);
                                var definitions = this.svgFactory.createElement("svg:defs");
                                svg.appendChild(definitions);
                                this.defs = definitions;
                                var rootGroup = this.svgFactory.createElement("svg:g");
                                rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                                svg.appendChild(rootGroup);
                                this.svg = rootGroup;
                                return svg;
                            }
                        },
                        {
                            key: "_ensureClipGroup",
                            value: function _ensureClipGroup() {
                                if (!this.current.clipGroup) {
                                    var clipGroup = this.svgFactory.createElement("svg:g");
                                    clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                                    this.svg.appendChild(clipGroup);
                                    this.current.clipGroup = clipGroup;
                                }
                                return this.current.clipGroup;
                            }
                        },
                        {
                            key: "_ensureTransformGroup",
                            value: function _ensureTransformGroup() {
                                if (!this.tgrp) {
                                    this.tgrp = this.svgFactory.createElement("svg:g");
                                    this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                    if (this.current.activeClipUrl) this._ensureClipGroup().appendChild(this.tgrp);
                                    else this.svg.appendChild(this.tgrp);
                                }
                                return this.tgrp;
                            }
                        }
                    ]);
                    return SVGGraphics;
                }();
            /***/ },
            /* 153 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var fs = (parcelRequire("iJ8TW"));
                var http = (parcelRequire("iJ8TW"));
                var https = (parcelRequire("iJ8TW"));
                var url = (parcelRequire("iJ8TW"));
                var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    var parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse("file:///".concat(sourceUrl));
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                var PDFNodeStream = /*#__PURE__*/ function() {
                    function PDFNodeStream(source) {
                        _classCallCheck(this, PDFNodeStream);
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFNodeStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(start, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                                this._rangeRequestReaders.push(rangeReader);
                                return rangeReader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFNodeStream;
                }();
                exports.PDFNodeStream = PDFNodeStream;
                var BaseFullReader = /*#__PURE__*/ function() {
                    function BaseFullReader(stream) {
                        _classCallCheck(this, BaseFullReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        var source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        this._headersCapability = (0, _util.createPromiseCapability)();
                    }
                    _createClass(BaseFullReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, buffer;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context.next = 4;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk = this._readableStream.read();
                                                if (!(chunk === null)) {
                                                    _context.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util.createPromiseCapability)();
                                                return _context.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return _context.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this._done = true;
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this._error(reason);
                                });
                                if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseFullReader;
                }();
                var BaseRangeReader = /*#__PURE__*/ function() {
                    function BaseRangeReader(stream) {
                        _classCallCheck(this, BaseRangeReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        var source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    _createClass(BaseRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, buffer;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context2.next = 4;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk = this._readableStream.read();
                                                if (!(chunk === null)) {
                                                    _context2.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util.createPromiseCapability)();
                                                return _context2.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return _context2.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this2 = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this2._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this2._done = true;
                                    _this2._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this2._error(reason);
                                });
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseRangeReader;
                }();
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                var PDFNodeStreamFullReader = /*#__PURE__*/ function(_BaseFullReader) {
                    _inherits(PDFNodeStreamFullReader, _BaseFullReader);
                    var _super = _createSuper(PDFNodeStreamFullReader);
                    function PDFNodeStreamFullReader(stream) {
                        var _this3;
                        _classCallCheck(this, PDFNodeStreamFullReader);
                        _this3 = _super.call(this, stream);
                        var handleResponse = function handleResponse(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException("Missing PDF \"".concat(_this3._url, "\"."));
                                _this3._storedError = error;
                                _this3._headersCapability.reject(error);
                                return;
                            }
                            _this3._headersCapability.resolve();
                            _this3._setReadableStream(response);
                            var getResponseHeader = function getResponseHeader(name) {
                                return _this3._readableStream.headers[name.toLowerCase()];
                            };
                            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: _this3._rangeChunkSize,
                                disableRange: _this3._disableRange
                            }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                            _this3._isRangeSupported = allowRangeRequests;
                            _this3._contentLength = suggestedLength || _this3._contentLength;
                            _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        _this3._request = null;
                        if (_this3._url.protocol === "http:") _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
                        else _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
                        _this3._request.on("error", function(reason) {
                            _this3._storedError = reason;
                            _this3._headersCapability.reject(reason);
                        });
                        _this3._request.end();
                        return _this3;
                    }
                    return PDFNodeStreamFullReader;
                }(BaseFullReader);
                var PDFNodeStreamRangeReader = /*#__PURE__*/ function(_BaseRangeReader) {
                    _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
                    var _super2 = _createSuper(PDFNodeStreamRangeReader);
                    function PDFNodeStreamRangeReader(stream, start, end) {
                        var _this4;
                        _classCallCheck(this, PDFNodeStreamRangeReader);
                        _this4 = _super2.call(this, stream);
                        _this4._httpHeaders = {};
                        for(var property in stream.httpHeaders){
                            var value = stream.httpHeaders[property];
                            if (typeof value === "undefined") continue;
                            _this4._httpHeaders[property] = value;
                        }
                        _this4._httpHeaders.Range = "bytes=".concat(start, "-").concat(end - 1);
                        var handleResponse = function handleResponse(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException("Missing PDF \"".concat(_this4._url, "\"."));
                                _this4._storedError = error;
                                return;
                            }
                            _this4._setReadableStream(response);
                        };
                        _this4._request = null;
                        if (_this4._url.protocol === "http:") _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
                        else _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
                        _this4._request.on("error", function(reason) {
                            _this4._storedError = reason;
                        });
                        _this4._request.end();
                        return _this4;
                    }
                    return PDFNodeStreamRangeReader;
                }(BaseRangeReader);
                var PDFNodeStreamFsFullReader = /*#__PURE__*/ function(_BaseFullReader2) {
                    _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
                    var _super3 = _createSuper(PDFNodeStreamFsFullReader);
                    function PDFNodeStreamFsFullReader(stream) {
                        var _this5;
                        _classCallCheck(this, PDFNodeStreamFsFullReader);
                        _this5 = _super3.call(this, stream);
                        var path = decodeURIComponent(_this5._url.path);
                        if (fileUriRegex.test(_this5._url.href)) path = path.replace(/^\//, "");
                        fs.lstat(path, function(error, stat) {
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException("Missing PDF \"".concat(path, "\"."));
                                _this5._storedError = error;
                                _this5._headersCapability.reject(error);
                                return;
                            }
                            _this5._contentLength = stat.size;
                            _this5._setReadableStream(fs.createReadStream(path));
                            _this5._headersCapability.resolve();
                        });
                        return _this5;
                    }
                    return PDFNodeStreamFsFullReader;
                }(BaseFullReader);
                var PDFNodeStreamFsRangeReader = /*#__PURE__*/ function(_BaseRangeReader2) {
                    _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
                    var _super4 = _createSuper(PDFNodeStreamFsRangeReader);
                    function PDFNodeStreamFsRangeReader(stream, start, end) {
                        var _this6;
                        _classCallCheck(this, PDFNodeStreamFsRangeReader);
                        _this6 = _super4.call(this, stream);
                        var path = decodeURIComponent(_this6._url.path);
                        if (fileUriRegex.test(_this6._url.href)) path = path.replace(/^\//, "");
                        _this6._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                        return _this6;
                    }
                    return PDFNodeStreamFsRangeReader;
                }(BaseRangeReader);
            /***/ },
            /* 154 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(4);
                var _content_disposition = __w_pdfjs_require__(155);
                var _display_utils = __w_pdfjs_require__(1);
                function validateRangeRequestCapabilities(_ref) {
                    var getResponseHeader = _ref.getResponseHeader, isHttp = _ref.isHttp, rangeChunkSize = _ref.rangeChunkSize, disableRange = _ref.disableRange;
                    (0, _util.assert)(rangeChunkSize > 0, "Range chunk size must be larger than zero");
                    var returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    var length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    var contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch (ex) {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException("Unexpected server response (".concat(status, ") while retrieving PDF \"").concat(url, "\"."), status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 155 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(4);
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
                    if (_i == null) return;
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _s, _e;
                    try {
                        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"] != null) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    var needsEncodingFixup = true;
                    var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        var _filename = rfc2047decode(tmp);
                        return fixupEncoding(_filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var _filename2 = rfc2616unquote(tmp);
                        _filename2 = rfc2047decode(_filename2);
                        return fixupEncoding(_filename2);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                var decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                var buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch (e) {
                                if (/^utf-?8$/i.test(encoding)) try {
                                    value = decodeURIComponent(escape(value));
                                    needsEncodingFixup = false;
                                } catch (err) {}
                            }
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        var matches = [];
                        var match;
                        var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            var _match = match, _match2 = _slicedToArray(_match, 4), n = _match2[1], quot = _match2[2], part = _match2[3];
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        var parts = [];
                        for(var _n2 = 0; _n2 < matches.length; ++_n2){
                            if (!(_n2 in matches)) break;
                            var _matches$_n = _slicedToArray(matches[_n2], 2), _quot = _matches$_n[0], _part = _matches$_n[1];
                            _part = rfc2616unquote(_part);
                            if (_quot) {
                                _part = unescape(_part);
                                if (_n2 === 0) _part = rfc5987decode(_part);
                            }
                            parts.push(_part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            var parts = value.slice(1).split('\\"');
                            for(var i = 0; i < parts.length; ++i){
                                var quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replace(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        var encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        var encoding = extvalue.slice(0, encodingend);
                        var langvalue = extvalue.slice(encodingend + 1);
                        var value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replace(/_/g, " ");
                                text = text.replace(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch (e) {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 156 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var OK_RESPONSE = 200;
                var PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    var data = xhr.response;
                    if (typeof data !== "string") return data;
                    var array = (0, _util.stringToBytes)(data);
                    return array.buffer;
                }
                var NetworkManager = /*#__PURE__*/ function() {
                    function NetworkManager(url) {
                        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _classCallCheck(this, NetworkManager);
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.getXhr = args.getXhr || function NetworkManager_getXhr() {
                            return new XMLHttpRequest();
                        };
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    _createClass(NetworkManager, [
                        {
                            key: "requestRange",
                            value: function requestRange(begin, end, listeners) {
                                var args = {
                                    begin: begin,
                                    end: end
                                };
                                for(var prop in listeners)args[prop] = listeners[prop];
                                return this.request(args);
                            }
                        },
                        {
                            key: "requestFull",
                            value: function requestFull(listeners) {
                                return this.request(listeners);
                            }
                        },
                        {
                            key: "request",
                            value: function request(args) {
                                var xhr = this.getXhr();
                                var xhrId = this.currXhrId++;
                                var pendingRequest = this.pendingRequests[xhrId] = {
                                    xhr: xhr
                                };
                                xhr.open("GET", this.url);
                                xhr.withCredentials = this.withCredentials;
                                for(var property in this.httpHeaders){
                                    var value = this.httpHeaders[property];
                                    if (typeof value === "undefined") continue;
                                    xhr.setRequestHeader(property, value);
                                }
                                if (this.isHttp && "begin" in args && "end" in args) {
                                    xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
                                    pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                                } else pendingRequest.expectedStatus = OK_RESPONSE;
                                xhr.responseType = "arraybuffer";
                                if (args.onError) xhr.onerror = function(evt) {
                                    args.onError(xhr.status);
                                };
                                xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                                xhr.onprogress = this.onProgress.bind(this, xhrId);
                                pendingRequest.onHeadersReceived = args.onHeadersReceived;
                                pendingRequest.onDone = args.onDone;
                                pendingRequest.onError = args.onError;
                                pendingRequest.onProgress = args.onProgress;
                                xhr.send(null);
                                return xhrId;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress(xhrId, evt) {
                                var _pendingRequest$onPro;
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                (_pendingRequest$onPro = pendingRequest.onProgress) === null || _pendingRequest$onPro === void 0 || _pendingRequest$onPro.call(pendingRequest, evt);
                            }
                        },
                        {
                            key: "onStateChange",
                            value: function onStateChange(xhrId, evt) {
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                var xhr = pendingRequest.xhr;
                                if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                                    pendingRequest.onHeadersReceived();
                                    delete pendingRequest.onHeadersReceived;
                                }
                                if (xhr.readyState !== 4) return;
                                if (!(xhrId in this.pendingRequests)) return;
                                delete this.pendingRequests[xhrId];
                                if (xhr.status === 0 && this.isHttp) {
                                    var _pendingRequest$onErr;
                                    (_pendingRequest$onErr = pendingRequest.onError) === null || _pendingRequest$onErr === void 0 || _pendingRequest$onErr.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var xhrStatus = xhr.status || OK_RESPONSE;
                                var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                                if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                                    var _pendingRequest$onErr2;
                                    (_pendingRequest$onErr2 = pendingRequest.onError) === null || _pendingRequest$onErr2 === void 0 || _pendingRequest$onErr2.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var chunk = getArrayBuffer(xhr);
                                if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                                    var rangeHeader = xhr.getResponseHeader("Content-Range");
                                    var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                                    pendingRequest.onDone({
                                        begin: parseInt(matches[1], 10),
                                        chunk: chunk
                                    });
                                } else if (chunk) pendingRequest.onDone({
                                    begin: 0,
                                    chunk: chunk
                                });
                                else {
                                    var _pendingRequest$onErr3;
                                    (_pendingRequest$onErr3 = pendingRequest.onError) === null || _pendingRequest$onErr3 === void 0 || _pendingRequest$onErr3.call(pendingRequest, xhr.status);
                                }
                            }
                        },
                        {
                            key: "getRequestXhr",
                            value: function getRequestXhr(xhrId) {
                                return this.pendingRequests[xhrId].xhr;
                            }
                        },
                        {
                            key: "isPendingRequest",
                            value: function isPendingRequest(xhrId) {
                                return xhrId in this.pendingRequests;
                            }
                        },
                        {
                            key: "abortRequest",
                            value: function abortRequest(xhrId) {
                                var xhr = this.pendingRequests[xhrId].xhr;
                                delete this.pendingRequests[xhrId];
                                xhr.abort();
                            }
                        }
                    ]);
                    return NetworkManager;
                }();
                var PDFNetworkStream = /*#__PURE__*/ function() {
                    function PDFNetworkStream(source) {
                        _classCallCheck(this, PDFNetworkStream);
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFNetworkStream, [
                        {
                            key: "_onRangeRequestReaderClosed",
                            value: function _onRangeRequestReaderClosed(reader) {
                                var i = this._rangeRequestReaders.indexOf(reader);
                                if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                                reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this$_fullRequestRea;
                                (_this$_fullRequestRea = this._fullRequestReader) === null || _this$_fullRequestRea === void 0 || _this$_fullRequestRea.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFNetworkStream;
                }();
                exports.PDFNetworkStream = PDFNetworkStream;
                var PDFNetworkStreamFullRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamFullRequestReader(manager, source) {
                        _classCallCheck(this, PDFNetworkStreamFullRequestReader);
                        this._manager = manager;
                        var args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = (0, _util.createPromiseCapability)();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _createClass(PDFNetworkStreamFullRequestReader, [
                        {
                            key: "_onHeadersReceived",
                            value: function _onHeadersReceived() {
                                var fullRequestXhrId = this._fullRequestId;
                                var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                                var getResponseHeader = function getResponseHeader(name) {
                                    return fullRequestXhr.getResponseHeader(name);
                                };
                                var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                    getResponseHeader: getResponseHeader,
                                    isHttp: this._manager.isHttp,
                                    rangeChunkSize: this._rangeChunkSize,
                                    disableRange: this._disableRange
                                }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                                if (allowRangeRequests) this._isRangeSupported = true;
                                this._contentLength = suggestedLength || this._contentLength;
                                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                                if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                                this._headersReceivedCapability.resolve();
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                if (data) {
                                    if (this._requests.length > 0) {
                                        var requestCapability = this._requests.shift();
                                        requestCapability.resolve({
                                            value: data.chunk,
                                            done: false
                                        });
                                    } else this._cachedChunks.push(data.chunk);
                                }
                                this._done = true;
                                if (this._cachedChunks.length > 0) return;
                                var _iterator2 = _createForOfIteratorHelper(this._requests), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var _requestCapability = _step2.value;
                                        _requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                this._headersReceivedCapability.reject(this._storedError);
                                var _iterator3 = _createForOfIteratorHelper(this._requests), _step3;
                                try {
                                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                        var requestCapability = _step3.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _iterator3.e(err);
                                } finally{
                                    _iterator3.f();
                                }
                                this._requests.length = 0;
                                this._cachedChunks.length = 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                var _this$onProgress;
                                (_this$onProgress = this.onProgress) === null || _this$onProgress === void 0 || _this$onProgress.call(this, {
                                    loaded: evt.loaded,
                                    total: evt.lengthComputable ? evt.total : this._contentLength
                                });
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReceivedCapability.promise;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._cachedChunks.length > 0)) {
                                                    _context.next = 5;
                                                    break;
                                                }
                                                chunk = this._cachedChunks.shift();
                                                return _context.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 5:
                                                if (!this._done) {
                                                    _context.next = 7;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 7:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context.abrupt("return", requestCapability.promise);
                                            case 10:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                this._headersReceivedCapability.reject(reason);
                                var _iterator4 = _createForOfIteratorHelper(this._requests), _step4;
                                try {
                                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                        var requestCapability = _step4.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator4.e(err);
                                } finally{
                                    _iterator4.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                                this._fullRequestReader = null;
                            }
                        }
                    ]);
                    return PDFNetworkStreamFullRequestReader;
                }();
                var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
                        _classCallCheck(this, PDFNetworkStreamRangeRequestReader);
                        this._manager = manager;
                        var args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _createClass(PDFNetworkStreamRangeRequestReader, [
                        {
                            key: "_close",
                            value: function _close() {
                                var _this$onClosed;
                                (_this$onClosed = this.onClosed) === null || _this$onClosed === void 0 || _this$onClosed.call(this, this);
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                var chunk = data.chunk;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunk = chunk;
                                this._done = true;
                                var _iterator5 = _createForOfIteratorHelper(this._requests), _step5;
                                try {
                                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                        var _requestCapability2 = _step5.value;
                                        _requestCapability2.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator5.e(err);
                                } finally{
                                    _iterator5.f();
                                }
                                this._requests.length = 0;
                                this._close();
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                var _iterator6 = _createForOfIteratorHelper(this._requests), _step6;
                                try {
                                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                        var requestCapability = _step6.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _iterator6.e(err);
                                } finally{
                                    _iterator6.f();
                                }
                                this._requests.length = 0;
                                this._queuedChunk = null;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                if (!this.isStreamingSupported) {
                                    var _this$onProgress2;
                                    (_this$onProgress2 = this.onProgress) === null || _this$onProgress2 === void 0 || _this$onProgress2.call(this, {
                                        loaded: evt.loaded
                                    });
                                }
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var chunk, requestCapability;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context2.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._queuedChunk !== null)) {
                                                    _context2.next = 6;
                                                    break;
                                                }
                                                chunk = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context2.abrupt("return", {
                                                    value: chunk,
                                                    done: false
                                                });
                                            case 6:
                                                if (!this._done) {
                                                    _context2.next = 8;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 8:
                                                requestCapability = (0, _util.createPromiseCapability)();
                                                this._requests.push(requestCapability);
                                                return _context2.abrupt("return", requestCapability.promise);
                                            case 11:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iterator7 = _createForOfIteratorHelper(this._requests), _step7;
                                try {
                                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                        var requestCapability = _step7.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _iterator7.e(err);
                                } finally{
                                    _iterator7.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                                this._close();
                            }
                        }
                    ]);
                    return PDFNetworkStreamRangeRequestReader;
                }();
            /***/ },
            /* 157 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _network_utils = __w_pdfjs_require__(154);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    var headers = new Headers();
                    for(var property in httpHeaders){
                        var value = httpHeaders[property];
                        if (typeof value === "undefined") continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                var PDFFetchStream = /*#__PURE__*/ function() {
                    function PDFFetchStream(source) {
                        _classCallCheck(this, PDFFetchStream);
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass(PDFFetchStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this$_fullRequestRea, _this$_fullRequestRea2;
                                return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFFetchStreamReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFFetchStreamRangeReader(this, begin, end);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                                var _iterator = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)), _step;
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                            }
                        }
                    ]);
                    return PDFFetchStream;
                }();
                exports.PDFFetchStream = PDFFetchStream;
                var PDFFetchStreamReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamReader(stream) {
                        var _this = this;
                        _classCallCheck(this, PDFFetchStreamReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = (0, _util.createPromiseCapability)();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this._reader = response.body.getReader();
                            _this._headersCapability.resolve();
                            var getResponseHeader = function getResponseHeader(name) {
                                return response.headers.get(name);
                            };
                            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: _this._stream.isHttp,
                                rangeChunkSize: _this._rangeChunkSize,
                                disableRange: _this._disableRange
                            }), allowRangeRequests = _validateRangeRequest.allowRangeRequests, suggestedLength = _validateRangeRequest.suggestedLength;
                            _this._isRangeSupported = allowRangeRequests;
                            _this._contentLength = suggestedLength || _this._contentLength;
                            _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!_this._isStreamingSupported && _this._isRangeSupported) _this.cancel(new _util.AbortException("Streaming is disabled."));
                        })["catch"](this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass(PDFFetchStreamReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee() {
                                    var _yield$this$_reader$r, value, done, buffer;
                                    return _regenerator["default"].wrap(function _callee$(_context) {
                                        while(true)switch(_context.prev = _context.next){
                                            case 0:
                                                _context.next = 2;
                                                return this._headersCapability.promise;
                                            case 2:
                                                _context.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r = _context.sent;
                                                value = _yield$this$_reader$r.value;
                                                done = _yield$this$_reader$r.done;
                                                if (!done) {
                                                    _context.next = 9;
                                                    break;
                                                }
                                                return _context.abrupt("return", {
                                                    value: value,
                                                    done: done
                                                });
                                            case 9:
                                                this._loaded += value.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer = new Uint8Array(value).buffer;
                                                return _context.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee, this);
                                }));
                                function read() {
                                    return _read.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (this._reader) this._reader.cancel(reason);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamReader;
                }();
                var PDFFetchStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamRangeReader(stream, begin, end) {
                        var _this2 = this;
                        _classCallCheck(this, PDFFetchStreamRangeReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = (0, _util.createPromiseCapability)();
                        this._isStreamingSupported = !source.disableStream;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this2._readCapability.resolve();
                            _this2._reader = response.body.getReader();
                        })["catch"](this._readCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass(PDFFetchStreamRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee2() {
                                    var _yield$this$_reader$r2, value, done, buffer;
                                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                _context2.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r2 = _context2.sent;
                                                value = _yield$this$_reader$r2.value;
                                                done = _yield$this$_reader$r2.done;
                                                if (!done) {
                                                    _context2.next = 9;
                                                    break;
                                                }
                                                return _context2.abrupt("return", {
                                                    value: value,
                                                    done: done
                                                });
                                            case 9:
                                                this._loaded += value.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer = new Uint8Array(value).buffer;
                                                return _context2.abrupt("return", {
                                                    value: buffer,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2, this);
                                }));
                                function read() {
                                    return _read2.apply(this, arguments);
                                }
                                return read;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (this._reader) this._reader.cancel(reason);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamRangeReader;
                }();
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/node module decorator */ /******/ (()=>{
            /******/ __w_pdfjs_require__.nmd = (module1)=>{
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        (()=>{
            "use strict";
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function get() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function get() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function get() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function get() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "LinkTarget", {
                enumerable: true,
                get: function get() {
                    return _display_utils.LinkTarget;
                }
            });
            Object.defineProperty(exports, "LoopbackPort", {
                enumerable: true,
                get: function get() {
                    return _api.LoopbackPort;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function get() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function get() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function get() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function get() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function get() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function get() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function get() {
                    return _svg.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UNSUPPORTED_FEATURES", {
                enumerable: true,
                get: function get() {
                    return _util.UNSUPPORTED_FEATURES;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function get() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function get() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function get() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function get() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "addLinkAttributes", {
                enumerable: true,
                get: function get() {
                    return _display_utils.addLinkAttributes;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function get() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createObjectURL", {
                enumerable: true,
                get: function get() {
                    return _util.createObjectURL;
                }
            });
            Object.defineProperty(exports, "createPromiseCapability", {
                enumerable: true,
                get: function get() {
                    return _util.createPromiseCapability;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function get() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function get() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function get() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function get() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "removeNullCharacters", {
                enumerable: true,
                get: function get() {
                    return _util.removeNullCharacters;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function get() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function get() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function get() {
                    return _api.version;
                }
            });
            var _display_utils = __w_pdfjs_require__(1);
            var _util = __w_pdfjs_require__(4);
            var _api = __w_pdfjs_require__(136);
            var _annotation_layer = __w_pdfjs_require__(148);
            var _worker_options = __w_pdfjs_require__(142);
            var _is_node = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(151);
            var _svg = __w_pdfjs_require__(152);
            var _xfa_layer = __w_pdfjs_require__(150);
            var pdfjsVersion = '2.12.313';
            var pdfjsBuild = 'a2ae56f39';
            if (_is_node.isNodeJS) {
                var _require = __w_pdfjs_require__(153), PDFNodeStream = _require.PDFNodeStream;
                (0, _api.setPDFNetworkStreamFactory)(function(params) {
                    return new PDFNodeStream(params);
                });
            } else {
                var _require2 = __w_pdfjs_require__(156), PDFNetworkStream = _require2.PDFNetworkStream;
                var _require3 = __w_pdfjs_require__(157), PDFFetchStream = _require3.PDFFetchStream;
                (0, _api.setPDFNetworkStreamFactory)(function(params) {
                    if ((0, _display_utils.isValidFetchUrl)(params.url)) return new PDFFetchStream(params);
                    return new PDFNetworkStream(params);
                });
            }
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("2LX06", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $204dbcdb7d1395df$export$a143d493d941bafc, (v) => $204dbcdb7d1395df$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $204dbcdb7d1395df$export$f99ded8fe4b79145, (v) => $204dbcdb7d1395df$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $204dbcdb7d1395df$export$a143d493d941bafc;
var $204dbcdb7d1395df$export$e4cf37d7f6fb9e0a;
var $204dbcdb7d1395df$export$f99ded8fe4b79145;
var $204dbcdb7d1395df$export$599f31c3813fae4d;
'use strict';

var $6X9Gk = parcelRequire("6X9Gk");

var $50hib = parcelRequire("50hib");
const $204dbcdb7d1395df$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$204dbcdb7d1395df$export$a143d493d941bafc = $204dbcdb7d1395df$var$Buffer;
$204dbcdb7d1395df$export$e4cf37d7f6fb9e0a = $204dbcdb7d1395df$var$SlowBuffer;
$204dbcdb7d1395df$export$f99ded8fe4b79145 = 50;
const $204dbcdb7d1395df$var$K_MAX_LENGTH = 0x7fffffff;
$204dbcdb7d1395df$export$599f31c3813fae4d = $204dbcdb7d1395df$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $204dbcdb7d1395df$var$Buffer.TYPED_ARRAY_SUPPORT = $204dbcdb7d1395df$var$typedArraySupport();
if (!$204dbcdb7d1395df$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $204dbcdb7d1395df$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($204dbcdb7d1395df$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$204dbcdb7d1395df$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($204dbcdb7d1395df$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$204dbcdb7d1395df$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $204dbcdb7d1395df$var$createBuffer(length) {
    if (length > $204dbcdb7d1395df$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $204dbcdb7d1395df$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $204dbcdb7d1395df$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $204dbcdb7d1395df$var$allocUnsafe(arg);
    }
    return $204dbcdb7d1395df$var$from(arg, encodingOrOffset, length);
}
$204dbcdb7d1395df$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $204dbcdb7d1395df$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $204dbcdb7d1395df$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $204dbcdb7d1395df$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($204dbcdb7d1395df$var$isInstance(value, ArrayBuffer) || value && $204dbcdb7d1395df$var$isInstance(value.buffer, ArrayBuffer)) return $204dbcdb7d1395df$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($204dbcdb7d1395df$var$isInstance(value, SharedArrayBuffer) || value && $204dbcdb7d1395df$var$isInstance(value.buffer, SharedArrayBuffer))) return $204dbcdb7d1395df$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $204dbcdb7d1395df$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $204dbcdb7d1395df$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $204dbcdb7d1395df$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $204dbcdb7d1395df$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $204dbcdb7d1395df$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($204dbcdb7d1395df$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($204dbcdb7d1395df$var$Buffer, Uint8Array);
function $204dbcdb7d1395df$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $204dbcdb7d1395df$var$alloc(size, fill, encoding) {
    $204dbcdb7d1395df$var$assertSize(size);
    if (size <= 0) return $204dbcdb7d1395df$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $204dbcdb7d1395df$var$createBuffer(size).fill(fill, encoding) : $204dbcdb7d1395df$var$createBuffer(size).fill(fill);
    return $204dbcdb7d1395df$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $204dbcdb7d1395df$var$Buffer.alloc = function(size, fill, encoding) {
    return $204dbcdb7d1395df$var$alloc(size, fill, encoding);
};
function $204dbcdb7d1395df$var$allocUnsafe(size) {
    $204dbcdb7d1395df$var$assertSize(size);
    return $204dbcdb7d1395df$var$createBuffer(size < 0 ? 0 : $204dbcdb7d1395df$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $204dbcdb7d1395df$var$Buffer.allocUnsafe = function(size) {
    return $204dbcdb7d1395df$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $204dbcdb7d1395df$var$Buffer.allocUnsafeSlow = function(size) {
    return $204dbcdb7d1395df$var$allocUnsafe(size);
};
function $204dbcdb7d1395df$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$204dbcdb7d1395df$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $204dbcdb7d1395df$var$byteLength(string, encoding) | 0;
    let buf = $204dbcdb7d1395df$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $204dbcdb7d1395df$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $204dbcdb7d1395df$var$checked(array.length) | 0;
    const buf = $204dbcdb7d1395df$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $204dbcdb7d1395df$var$fromArrayView(arrayView) {
    if ($204dbcdb7d1395df$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $204dbcdb7d1395df$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $204dbcdb7d1395df$var$fromArrayLike(arrayView);
}
function $204dbcdb7d1395df$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $204dbcdb7d1395df$var$Buffer.prototype);
    return buf;
}
function $204dbcdb7d1395df$var$fromObject(obj) {
    if ($204dbcdb7d1395df$var$Buffer.isBuffer(obj)) {
        const len = $204dbcdb7d1395df$var$checked(obj.length) | 0;
        const buf = $204dbcdb7d1395df$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $204dbcdb7d1395df$var$numberIsNaN(obj.length)) return $204dbcdb7d1395df$var$createBuffer(0);
        return $204dbcdb7d1395df$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $204dbcdb7d1395df$var$fromArrayLike(obj.data);
}
function $204dbcdb7d1395df$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $204dbcdb7d1395df$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $204dbcdb7d1395df$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $204dbcdb7d1395df$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $204dbcdb7d1395df$var$Buffer.alloc(+length);
}
$204dbcdb7d1395df$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $204dbcdb7d1395df$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$204dbcdb7d1395df$var$Buffer.compare = function compare(a, b) {
    if ($204dbcdb7d1395df$var$isInstance(a, Uint8Array)) a = $204dbcdb7d1395df$var$Buffer.from(a, a.offset, a.byteLength);
    if ($204dbcdb7d1395df$var$isInstance(b, Uint8Array)) b = $204dbcdb7d1395df$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$204dbcdb7d1395df$var$Buffer.isBuffer(a) || !$204dbcdb7d1395df$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$204dbcdb7d1395df$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$204dbcdb7d1395df$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $204dbcdb7d1395df$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $204dbcdb7d1395df$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($204dbcdb7d1395df$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$204dbcdb7d1395df$var$Buffer.isBuffer(buf)) buf = $204dbcdb7d1395df$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$204dbcdb7d1395df$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $204dbcdb7d1395df$var$byteLength(string, encoding) {
    if ($204dbcdb7d1395df$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $204dbcdb7d1395df$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $204dbcdb7d1395df$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $204dbcdb7d1395df$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $204dbcdb7d1395df$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$204dbcdb7d1395df$var$Buffer.byteLength = $204dbcdb7d1395df$var$byteLength;
function $204dbcdb7d1395df$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $204dbcdb7d1395df$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $204dbcdb7d1395df$var$utf8Slice(this, start, end);
        case 'ascii':
            return $204dbcdb7d1395df$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $204dbcdb7d1395df$var$latin1Slice(this, start, end);
        case 'base64':
            return $204dbcdb7d1395df$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $204dbcdb7d1395df$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$204dbcdb7d1395df$var$Buffer.prototype._isBuffer = true;
function $204dbcdb7d1395df$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$204dbcdb7d1395df$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$204dbcdb7d1395df$var$swap(this, i, i + 1);
    return this;
};
$204dbcdb7d1395df$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $204dbcdb7d1395df$var$swap(this, i, i + 3);
        $204dbcdb7d1395df$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$204dbcdb7d1395df$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $204dbcdb7d1395df$var$swap(this, i, i + 7);
        $204dbcdb7d1395df$var$swap(this, i + 1, i + 6);
        $204dbcdb7d1395df$var$swap(this, i + 2, i + 5);
        $204dbcdb7d1395df$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$204dbcdb7d1395df$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $204dbcdb7d1395df$var$utf8Slice(this, 0, length);
    return $204dbcdb7d1395df$var$slowToString.apply(this, arguments);
};
$204dbcdb7d1395df$var$Buffer.prototype.toLocaleString = $204dbcdb7d1395df$var$Buffer.prototype.toString;
$204dbcdb7d1395df$var$Buffer.prototype.equals = function equals(b) {
    if (!$204dbcdb7d1395df$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $204dbcdb7d1395df$var$Buffer.compare(this, b) === 0;
};
$204dbcdb7d1395df$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $204dbcdb7d1395df$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($204dbcdb7d1395df$var$customInspectSymbol) $204dbcdb7d1395df$var$Buffer.prototype[$204dbcdb7d1395df$var$customInspectSymbol] = $204dbcdb7d1395df$var$Buffer.prototype.inspect;
$204dbcdb7d1395df$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($204dbcdb7d1395df$var$isInstance(target, Uint8Array)) target = $204dbcdb7d1395df$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$204dbcdb7d1395df$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $204dbcdb7d1395df$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($204dbcdb7d1395df$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $204dbcdb7d1395df$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($204dbcdb7d1395df$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $204dbcdb7d1395df$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $204dbcdb7d1395df$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $204dbcdb7d1395df$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$204dbcdb7d1395df$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$204dbcdb7d1395df$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $204dbcdb7d1395df$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$204dbcdb7d1395df$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $204dbcdb7d1395df$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $204dbcdb7d1395df$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($204dbcdb7d1395df$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $204dbcdb7d1395df$var$utf8Write(buf, string, offset, length) {
    return $204dbcdb7d1395df$var$blitBuffer($204dbcdb7d1395df$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $204dbcdb7d1395df$var$asciiWrite(buf, string, offset, length) {
    return $204dbcdb7d1395df$var$blitBuffer($204dbcdb7d1395df$var$asciiToBytes(string), buf, offset, length);
}
function $204dbcdb7d1395df$var$base64Write(buf, string, offset, length) {
    return $204dbcdb7d1395df$var$blitBuffer($204dbcdb7d1395df$var$base64ToBytes(string), buf, offset, length);
}
function $204dbcdb7d1395df$var$ucs2Write(buf, string, offset, length) {
    return $204dbcdb7d1395df$var$blitBuffer($204dbcdb7d1395df$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$204dbcdb7d1395df$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $204dbcdb7d1395df$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $204dbcdb7d1395df$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $204dbcdb7d1395df$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $204dbcdb7d1395df$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $204dbcdb7d1395df$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$204dbcdb7d1395df$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $204dbcdb7d1395df$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6X9Gk.fromByteArray(buf);
    else return $6X9Gk.fromByteArray(buf.slice(start, end));
}
function $204dbcdb7d1395df$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $204dbcdb7d1395df$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $204dbcdb7d1395df$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $204dbcdb7d1395df$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $204dbcdb7d1395df$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $204dbcdb7d1395df$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $204dbcdb7d1395df$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $204dbcdb7d1395df$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $204dbcdb7d1395df$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $204dbcdb7d1395df$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $204dbcdb7d1395df$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$204dbcdb7d1395df$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $204dbcdb7d1395df$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $204dbcdb7d1395df$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$204dbcdb7d1395df$var$Buffer.prototype.readUintLE = $204dbcdb7d1395df$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readUintBE = $204dbcdb7d1395df$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readUint8 = $204dbcdb7d1395df$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$204dbcdb7d1395df$var$Buffer.prototype.readUint16LE = $204dbcdb7d1395df$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$204dbcdb7d1395df$var$Buffer.prototype.readUint16BE = $204dbcdb7d1395df$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$204dbcdb7d1395df$var$Buffer.prototype.readUint32LE = $204dbcdb7d1395df$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$204dbcdb7d1395df$var$Buffer.prototype.readUint32BE = $204dbcdb7d1395df$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$204dbcdb7d1395df$var$Buffer.prototype.readBigUInt64LE = $204dbcdb7d1395df$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $204dbcdb7d1395df$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $204dbcdb7d1395df$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$204dbcdb7d1395df$var$Buffer.prototype.readBigUInt64BE = $204dbcdb7d1395df$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $204dbcdb7d1395df$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $204dbcdb7d1395df$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$204dbcdb7d1395df$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$204dbcdb7d1395df$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$204dbcdb7d1395df$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$204dbcdb7d1395df$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$204dbcdb7d1395df$var$Buffer.prototype.readBigInt64LE = $204dbcdb7d1395df$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $204dbcdb7d1395df$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $204dbcdb7d1395df$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$204dbcdb7d1395df$var$Buffer.prototype.readBigInt64BE = $204dbcdb7d1395df$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $204dbcdb7d1395df$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $204dbcdb7d1395df$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$204dbcdb7d1395df$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return $50hib.read(this, offset, true, 23, 4);
};
$204dbcdb7d1395df$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 4, this.length);
    return $50hib.read(this, offset, false, 23, 4);
};
$204dbcdb7d1395df$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 8, this.length);
    return $50hib.read(this, offset, true, 52, 8);
};
$204dbcdb7d1395df$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkOffset(offset, 8, this.length);
    return $50hib.read(this, offset, false, 52, 8);
};
function $204dbcdb7d1395df$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$204dbcdb7d1395df$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$204dbcdb7d1395df$var$Buffer.prototype.writeUintLE = $204dbcdb7d1395df$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $204dbcdb7d1395df$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUintBE = $204dbcdb7d1395df$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $204dbcdb7d1395df$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUint8 = $204dbcdb7d1395df$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUint16LE = $204dbcdb7d1395df$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUint16BE = $204dbcdb7d1395df$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUint32LE = $204dbcdb7d1395df$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeUint32BE = $204dbcdb7d1395df$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $204dbcdb7d1395df$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $204dbcdb7d1395df$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $204dbcdb7d1395df$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $204dbcdb7d1395df$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$204dbcdb7d1395df$var$Buffer.prototype.writeBigUInt64LE = $204dbcdb7d1395df$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $204dbcdb7d1395df$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$204dbcdb7d1395df$var$Buffer.prototype.writeBigUInt64BE = $204dbcdb7d1395df$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $204dbcdb7d1395df$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$204dbcdb7d1395df$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $204dbcdb7d1395df$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $204dbcdb7d1395df$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$204dbcdb7d1395df$var$Buffer.prototype.writeBigInt64LE = $204dbcdb7d1395df$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $204dbcdb7d1395df$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$204dbcdb7d1395df$var$Buffer.prototype.writeBigInt64BE = $204dbcdb7d1395df$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $204dbcdb7d1395df$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $204dbcdb7d1395df$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $204dbcdb7d1395df$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $50hib.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$204dbcdb7d1395df$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $204dbcdb7d1395df$var$writeFloat(this, value, offset, true, noAssert);
};
$204dbcdb7d1395df$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $204dbcdb7d1395df$var$writeFloat(this, value, offset, false, noAssert);
};
function $204dbcdb7d1395df$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $204dbcdb7d1395df$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $50hib.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$204dbcdb7d1395df$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $204dbcdb7d1395df$var$writeDouble(this, value, offset, true, noAssert);
};
$204dbcdb7d1395df$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $204dbcdb7d1395df$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$204dbcdb7d1395df$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$204dbcdb7d1395df$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$204dbcdb7d1395df$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$204dbcdb7d1395df$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $204dbcdb7d1395df$var$Buffer.isBuffer(val) ? val : $204dbcdb7d1395df$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $204dbcdb7d1395df$var$errors = {};
function $204dbcdb7d1395df$var$E(sym, getMessage, Base) {
    $204dbcdb7d1395df$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$204dbcdb7d1395df$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$204dbcdb7d1395df$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$204dbcdb7d1395df$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $204dbcdb7d1395df$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $204dbcdb7d1395df$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $204dbcdb7d1395df$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $204dbcdb7d1395df$var$checkBounds(buf, offset, byteLength) {
    $204dbcdb7d1395df$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $204dbcdb7d1395df$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $204dbcdb7d1395df$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $204dbcdb7d1395df$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $204dbcdb7d1395df$var$checkBounds(buf, offset, byteLength);
}
function $204dbcdb7d1395df$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $204dbcdb7d1395df$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $204dbcdb7d1395df$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $204dbcdb7d1395df$var$validateNumber(value, type);
        throw new $204dbcdb7d1395df$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $204dbcdb7d1395df$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $204dbcdb7d1395df$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $204dbcdb7d1395df$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $204dbcdb7d1395df$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($204dbcdb7d1395df$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $204dbcdb7d1395df$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $204dbcdb7d1395df$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $204dbcdb7d1395df$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $204dbcdb7d1395df$var$base64ToBytes(str) {
    return $6X9Gk.toByteArray($204dbcdb7d1395df$var$base64clean(str));
}
function $204dbcdb7d1395df$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $204dbcdb7d1395df$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $204dbcdb7d1395df$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $204dbcdb7d1395df$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $204dbcdb7d1395df$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $204dbcdb7d1395df$var$BufferBigIntNotDefined : fn;
}
function $204dbcdb7d1395df$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6X9Gk", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $50ffc35690c827e6$export$d622b2ad8d90c771, (v) => $50ffc35690c827e6$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $50ffc35690c827e6$export$6100ba28696e12de, (v) => $50ffc35690c827e6$export$6100ba28696e12de = v);
var $50ffc35690c827e6$export$a48f0734ac7c2329;
var $50ffc35690c827e6$export$d622b2ad8d90c771;
var $50ffc35690c827e6$export$6100ba28696e12de;
'use strict';
$50ffc35690c827e6$export$a48f0734ac7c2329 = $50ffc35690c827e6$var$byteLength;
$50ffc35690c827e6$export$d622b2ad8d90c771 = $50ffc35690c827e6$var$toByteArray;
$50ffc35690c827e6$export$6100ba28696e12de = $50ffc35690c827e6$var$fromByteArray;
var $50ffc35690c827e6$var$lookup = [];
var $50ffc35690c827e6$var$revLookup = [];
var $50ffc35690c827e6$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $50ffc35690c827e6$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $50ffc35690c827e6$var$i = 0, $50ffc35690c827e6$var$len = $50ffc35690c827e6$var$code.length; $50ffc35690c827e6$var$i < $50ffc35690c827e6$var$len; ++$50ffc35690c827e6$var$i){
    $50ffc35690c827e6$var$lookup[$50ffc35690c827e6$var$i] = $50ffc35690c827e6$var$code[$50ffc35690c827e6$var$i];
    $50ffc35690c827e6$var$revLookup[$50ffc35690c827e6$var$code.charCodeAt($50ffc35690c827e6$var$i)] = $50ffc35690c827e6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$50ffc35690c827e6$var$revLookup['-'.charCodeAt(0)] = 62;
$50ffc35690c827e6$var$revLookup['_'.charCodeAt(0)] = 63;
function $50ffc35690c827e6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $50ffc35690c827e6$var$byteLength(b64) {
    var lens = $50ffc35690c827e6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $50ffc35690c827e6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $50ffc35690c827e6$var$toByteArray(b64) {
    var tmp;
    var lens = $50ffc35690c827e6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $50ffc35690c827e6$var$Arr($50ffc35690c827e6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i)] << 18 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i)] << 2 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i)] << 10 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $50ffc35690c827e6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $50ffc35690c827e6$var$tripletToBase64(num) {
    return $50ffc35690c827e6$var$lookup[num >> 18 & 0x3F] + $50ffc35690c827e6$var$lookup[num >> 12 & 0x3F] + $50ffc35690c827e6$var$lookup[num >> 6 & 0x3F] + $50ffc35690c827e6$var$lookup[num & 0x3F];
}
function $50ffc35690c827e6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($50ffc35690c827e6$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $50ffc35690c827e6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($50ffc35690c827e6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($50ffc35690c827e6$var$lookup[tmp >> 2] + $50ffc35690c827e6$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($50ffc35690c827e6$var$lookup[tmp >> 10] + $50ffc35690c827e6$var$lookup[tmp >> 4 & 0x3F] + $50ffc35690c827e6$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("50hib", function(module, exports) {

$parcel$export(module.exports, "read", () => $3a4a5db46e787f56$export$aafa59e2e03f2942, (v) => $3a4a5db46e787f56$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $3a4a5db46e787f56$export$68d8715fc104d294, (v) => $3a4a5db46e787f56$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $3a4a5db46e787f56$export$aafa59e2e03f2942;
var $3a4a5db46e787f56$export$68d8715fc104d294;
$3a4a5db46e787f56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$3a4a5db46e787f56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("f2AU3", function(module, exports) {
// shim for using process in browser
var $af33ab174df7e509$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $af33ab174df7e509$var$cachedSetTimeout;
var $af33ab174df7e509$var$cachedClearTimeout;
function $af33ab174df7e509$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $af33ab174df7e509$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $af33ab174df7e509$var$cachedSetTimeout = setTimeout;
        else $af33ab174df7e509$var$cachedSetTimeout = $af33ab174df7e509$var$defaultSetTimout;
    } catch (e) {
        $af33ab174df7e509$var$cachedSetTimeout = $af33ab174df7e509$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $af33ab174df7e509$var$cachedClearTimeout = clearTimeout;
        else $af33ab174df7e509$var$cachedClearTimeout = $af33ab174df7e509$var$defaultClearTimeout;
    } catch (e) {
        $af33ab174df7e509$var$cachedClearTimeout = $af33ab174df7e509$var$defaultClearTimeout;
    }
})();
function $af33ab174df7e509$var$runTimeout(fun) {
    if ($af33ab174df7e509$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($af33ab174df7e509$var$cachedSetTimeout === $af33ab174df7e509$var$defaultSetTimout || !$af33ab174df7e509$var$cachedSetTimeout) && setTimeout) {
        $af33ab174df7e509$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af33ab174df7e509$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $af33ab174df7e509$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $af33ab174df7e509$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $af33ab174df7e509$var$runClearTimeout(marker) {
    if ($af33ab174df7e509$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($af33ab174df7e509$var$cachedClearTimeout === $af33ab174df7e509$var$defaultClearTimeout || !$af33ab174df7e509$var$cachedClearTimeout) && clearTimeout) {
        $af33ab174df7e509$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af33ab174df7e509$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $af33ab174df7e509$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $af33ab174df7e509$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $af33ab174df7e509$var$queue = [];
var $af33ab174df7e509$var$draining = false;
var $af33ab174df7e509$var$currentQueue;
var $af33ab174df7e509$var$queueIndex = -1;
function $af33ab174df7e509$var$cleanUpNextTick() {
    if (!$af33ab174df7e509$var$draining || !$af33ab174df7e509$var$currentQueue) return;
    $af33ab174df7e509$var$draining = false;
    if ($af33ab174df7e509$var$currentQueue.length) $af33ab174df7e509$var$queue = $af33ab174df7e509$var$currentQueue.concat($af33ab174df7e509$var$queue);
    else $af33ab174df7e509$var$queueIndex = -1;
    if ($af33ab174df7e509$var$queue.length) $af33ab174df7e509$var$drainQueue();
}
function $af33ab174df7e509$var$drainQueue() {
    if ($af33ab174df7e509$var$draining) return;
    var timeout = $af33ab174df7e509$var$runTimeout($af33ab174df7e509$var$cleanUpNextTick);
    $af33ab174df7e509$var$draining = true;
    var len = $af33ab174df7e509$var$queue.length;
    while(len){
        $af33ab174df7e509$var$currentQueue = $af33ab174df7e509$var$queue;
        $af33ab174df7e509$var$queue = [];
        while(++$af33ab174df7e509$var$queueIndex < len)if ($af33ab174df7e509$var$currentQueue) $af33ab174df7e509$var$currentQueue[$af33ab174df7e509$var$queueIndex].run();
        $af33ab174df7e509$var$queueIndex = -1;
        len = $af33ab174df7e509$var$queue.length;
    }
    $af33ab174df7e509$var$currentQueue = null;
    $af33ab174df7e509$var$draining = false;
    $af33ab174df7e509$var$runClearTimeout(timeout);
}
$af33ab174df7e509$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $af33ab174df7e509$var$queue.push(new $af33ab174df7e509$var$Item(fun, args));
    if ($af33ab174df7e509$var$queue.length === 1 && !$af33ab174df7e509$var$draining) $af33ab174df7e509$var$runTimeout($af33ab174df7e509$var$drainQueue);
};
// v8 likes predictible objects
function $af33ab174df7e509$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$af33ab174df7e509$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$af33ab174df7e509$var$process.title = 'browser';
$af33ab174df7e509$var$process.browser = true;
$af33ab174df7e509$var$process.env = {};
$af33ab174df7e509$var$process.argv = [];
$af33ab174df7e509$var$process.version = ''; // empty string to avoid regexp issues
$af33ab174df7e509$var$process.versions = {};
function $af33ab174df7e509$var$noop() {}
$af33ab174df7e509$var$process.on = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.addListener = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.once = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.off = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.removeListener = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.removeAllListeners = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.emit = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.prependListener = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.prependOnceListener = $af33ab174df7e509$var$noop;
$af33ab174df7e509$var$process.listeners = function(name) {
    return [];
};
$af33ab174df7e509$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$af33ab174df7e509$var$process.cwd = function() {
    return '/';
};
$af33ab174df7e509$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$af33ab174df7e509$var$process.umask = function() {
    return 0;
};

});

parcelRegister("iJ8TW", function(module, exports) {
"use strict";

});


parcelRegister("k6tn1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $ihUyS = parcelRequire("ihUyS");
function $ea2b26878b90e447$var$emptyFunction() {}
function $ea2b26878b90e447$var$emptyFunctionWithReset() {}
$ea2b26878b90e447$var$emptyFunctionWithReset.resetWarningCache = $ea2b26878b90e447$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $ihUyS) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ea2b26878b90e447$var$emptyFunctionWithReset,
        resetWarningCache: $ea2b26878b90e447$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("ihUyS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $036f935cbb2bdb9c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $036f935cbb2bdb9c$var$ReactPropTypesSecret;

});


"use strict";
var $e22f6ead04c39931$exports = {};
'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $fdFIW = parcelRequire("fdFIW");

var $8csIg = parcelRequire("8csIg");

var $e88d0 = parcelRequire("e88d0");

var $4ELbO = parcelRequire("4ELbO");

var $nFBKj = parcelRequire("nFBKj");
var $8bca351580405085$require$META = $nFBKj.KEY;

var $as1c7 = parcelRequire("as1c7");

var $lXpxg = parcelRequire("lXpxg");

var $7jOVX = parcelRequire("7jOVX");

var $5DFYi = parcelRequire("5DFYi");

var $fjK8l = parcelRequire("fjK8l");

var $gXnT8 = parcelRequire("gXnT8");

var $afVtj = parcelRequire("afVtj");
var $61fcb55a7537c51f$exports = {};
// all enumerable object keys, includes symbols

var $gHcyI = parcelRequire("gHcyI");

var $87NIy = parcelRequire("87NIy");

var $jHwil = parcelRequire("jHwil");
$61fcb55a7537c51f$exports = function(it) {
    var result = $gHcyI(it);
    var getSymbols = $87NIy.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $jHwil.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};



var $k2l0Y = parcelRequire("k2l0Y");

var $cYx5q = parcelRequire("cYx5q");

var $a8jEg = parcelRequire("a8jEg");

var $60LZ2 = parcelRequire("60LZ2");

var $h1IuT = parcelRequire("h1IuT");

var $h0Sfn = parcelRequire("h0Sfn");

var $3PFaa = parcelRequire("3PFaa");

var $9lrow = parcelRequire("9lrow");

var $linom = parcelRequire("linom");

var $6Vt7w = parcelRequire("6Vt7w");

var $87NIy = parcelRequire("87NIy");

var $hjnWf = parcelRequire("hjnWf");

var $gHcyI = parcelRequire("gHcyI");
var $8bca351580405085$var$gOPD = $6Vt7w.f;
var $8bca351580405085$var$dP = $hjnWf.f;
var $8bca351580405085$var$gOPN = $linom.f;
var $8bca351580405085$var$$Symbol = $fRJfg.Symbol;
var $8bca351580405085$var$$JSON = $fRJfg.JSON;
var $8bca351580405085$var$_stringify = $8bca351580405085$var$$JSON && $8bca351580405085$var$$JSON.stringify;
var $8bca351580405085$var$PROTOTYPE = 'prototype';
var $8bca351580405085$var$HIDDEN = $fjK8l('_hidden');
var $8bca351580405085$var$TO_PRIMITIVE = $fjK8l('toPrimitive');
var $8bca351580405085$var$isEnum = {}.propertyIsEnumerable;
var $8bca351580405085$var$SymbolRegistry = $lXpxg('symbol-registry');
var $8bca351580405085$var$AllSymbols = $lXpxg('symbols');
var $8bca351580405085$var$OPSymbols = $lXpxg('op-symbols');
var $8bca351580405085$var$ObjectProto = Object[$8bca351580405085$var$PROTOTYPE];
var $8bca351580405085$var$USE_NATIVE = typeof $8bca351580405085$var$$Symbol == 'function' && !!$87NIy.f;
var $8bca351580405085$var$QObject = $fRJfg.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $8bca351580405085$var$setter = !$8bca351580405085$var$QObject || !$8bca351580405085$var$QObject[$8bca351580405085$var$PROTOTYPE] || !$8bca351580405085$var$QObject[$8bca351580405085$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $8bca351580405085$var$setSymbolDesc = $8csIg && $as1c7(function() {
    return $9lrow($8bca351580405085$var$dP({}, 'a', {
        get: function() {
            return $8bca351580405085$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $8bca351580405085$var$gOPD($8bca351580405085$var$ObjectProto, key);
    if (protoDesc) delete $8bca351580405085$var$ObjectProto[key];
    $8bca351580405085$var$dP(it, key, D);
    if (protoDesc && it !== $8bca351580405085$var$ObjectProto) $8bca351580405085$var$dP($8bca351580405085$var$ObjectProto, key, protoDesc);
} : $8bca351580405085$var$dP;
var $8bca351580405085$var$wrap = function(tag) {
    var sym = $8bca351580405085$var$AllSymbols[tag] = $9lrow($8bca351580405085$var$$Symbol[$8bca351580405085$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $8bca351580405085$var$isSymbol = $8bca351580405085$var$USE_NATIVE && typeof $8bca351580405085$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $8bca351580405085$var$$Symbol;
};
var $8bca351580405085$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $8bca351580405085$var$ObjectProto) $8bca351580405085$var$$defineProperty($8bca351580405085$var$OPSymbols, key, D);
    $cYx5q(it);
    key = $h0Sfn(key, true);
    $cYx5q(D);
    if ($fdFIW($8bca351580405085$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$fdFIW(it, $8bca351580405085$var$HIDDEN)) $8bca351580405085$var$dP(it, $8bca351580405085$var$HIDDEN, $3PFaa(1, {}));
            it[$8bca351580405085$var$HIDDEN][key] = true;
        } else {
            if ($fdFIW(it, $8bca351580405085$var$HIDDEN) && it[$8bca351580405085$var$HIDDEN][key]) it[$8bca351580405085$var$HIDDEN][key] = false;
            D = $9lrow(D, {
                enumerable: $3PFaa(0, false)
            });
        }
        return $8bca351580405085$var$setSymbolDesc(it, key, D);
    }
    return $8bca351580405085$var$dP(it, key, D);
};
var $8bca351580405085$var$$defineProperties = function defineProperties(it, P) {
    $cYx5q(it);
    var keys = $61fcb55a7537c51f$exports(P = $h1IuT(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$8bca351580405085$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $8bca351580405085$var$$create = function create(it, P) {
    return P === undefined ? $9lrow(it) : $8bca351580405085$var$$defineProperties($9lrow(it), P);
};
var $8bca351580405085$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $8bca351580405085$var$isEnum.call(this, key = $h0Sfn(key, true));
    if (this === $8bca351580405085$var$ObjectProto && $fdFIW($8bca351580405085$var$AllSymbols, key) && !$fdFIW($8bca351580405085$var$OPSymbols, key)) return false;
    return E || !$fdFIW(this, key) || !$fdFIW($8bca351580405085$var$AllSymbols, key) || $fdFIW(this, $8bca351580405085$var$HIDDEN) && this[$8bca351580405085$var$HIDDEN][key] ? E : true;
};
var $8bca351580405085$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $h1IuT(it);
    key = $h0Sfn(key, true);
    if (it === $8bca351580405085$var$ObjectProto && $fdFIW($8bca351580405085$var$AllSymbols, key) && !$fdFIW($8bca351580405085$var$OPSymbols, key)) return;
    var D = $8bca351580405085$var$gOPD(it, key);
    if (D && $fdFIW($8bca351580405085$var$AllSymbols, key) && !($fdFIW(it, $8bca351580405085$var$HIDDEN) && it[$8bca351580405085$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $8bca351580405085$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $8bca351580405085$var$gOPN($h1IuT(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$fdFIW($8bca351580405085$var$AllSymbols, key = names[i++]) && key != $8bca351580405085$var$HIDDEN && key != $8bca351580405085$require$META) result.push(key);
    return result;
};
var $8bca351580405085$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $8bca351580405085$var$ObjectProto;
    var names = $8bca351580405085$var$gOPN(IS_OP ? $8bca351580405085$var$OPSymbols : $h1IuT(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($fdFIW($8bca351580405085$var$AllSymbols, key = names[i++]) && (IS_OP ? $fdFIW($8bca351580405085$var$ObjectProto, key) : true)) result.push($8bca351580405085$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$8bca351580405085$var$USE_NATIVE) {
    $8bca351580405085$var$$Symbol = function Symbol() {
        if (this instanceof $8bca351580405085$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $5DFYi(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $8bca351580405085$var$ObjectProto) $set.call($8bca351580405085$var$OPSymbols, value);
            if ($fdFIW(this, $8bca351580405085$var$HIDDEN) && $fdFIW(this[$8bca351580405085$var$HIDDEN], tag)) this[$8bca351580405085$var$HIDDEN][tag] = false;
            $8bca351580405085$var$setSymbolDesc(this, tag, $3PFaa(1, value));
        };
        if ($8csIg && $8bca351580405085$var$setter) $8bca351580405085$var$setSymbolDesc($8bca351580405085$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $8bca351580405085$var$wrap(tag);
    };
    $4ELbO($8bca351580405085$var$$Symbol[$8bca351580405085$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $6Vt7w.f = $8bca351580405085$var$$getOwnPropertyDescriptor;
    $hjnWf.f = $8bca351580405085$var$$defineProperty;
    (parcelRequire("1UujU")).f = $linom.f = $8bca351580405085$var$$getOwnPropertyNames;
    (parcelRequire("jHwil")).f = $8bca351580405085$var$$propertyIsEnumerable;
    $87NIy.f = $8bca351580405085$var$$getOwnPropertySymbols;
    if ($8csIg && !(parcelRequire("8N1Ra"))) $4ELbO($8bca351580405085$var$ObjectProto, 'propertyIsEnumerable', $8bca351580405085$var$$propertyIsEnumerable, true);
    $gXnT8.f = function(name) {
        return $8bca351580405085$var$wrap($fjK8l(name));
    };
}
$e88d0($e88d0.G + $e88d0.W + $e88d0.F * !$8bca351580405085$var$USE_NATIVE, {
    Symbol: $8bca351580405085$var$$Symbol
});
for(var $8bca351580405085$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $8bca351580405085$var$j = 0; $8bca351580405085$var$es6Symbols.length > $8bca351580405085$var$j;)$fjK8l($8bca351580405085$var$es6Symbols[$8bca351580405085$var$j++]);
for(var $8bca351580405085$var$wellKnownSymbols = $gHcyI($fjK8l.store), $8bca351580405085$var$k = 0; $8bca351580405085$var$wellKnownSymbols.length > $8bca351580405085$var$k;)$afVtj($8bca351580405085$var$wellKnownSymbols[$8bca351580405085$var$k++]);
$e88d0($e88d0.S + $e88d0.F * !$8bca351580405085$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $fdFIW($8bca351580405085$var$SymbolRegistry, key += '') ? $8bca351580405085$var$SymbolRegistry[key] : $8bca351580405085$var$SymbolRegistry[key] = $8bca351580405085$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$8bca351580405085$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $8bca351580405085$var$SymbolRegistry)if ($8bca351580405085$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $8bca351580405085$var$setter = true;
    },
    useSimple: function() {
        $8bca351580405085$var$setter = false;
    }
});
$e88d0($e88d0.S + $e88d0.F * !$8bca351580405085$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $8bca351580405085$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $8bca351580405085$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $8bca351580405085$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $8bca351580405085$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $8bca351580405085$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $8bca351580405085$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $8bca351580405085$var$FAILS_ON_PRIMITIVES = $as1c7(function() {
    $87NIy.f(1);
});
$e88d0($e88d0.S + $e88d0.F * $8bca351580405085$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $87NIy.f($60LZ2(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$8bca351580405085$var$$JSON && $e88d0($e88d0.S + $e88d0.F * (!$8bca351580405085$var$USE_NATIVE || $as1c7(function() {
    var S = $8bca351580405085$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $8bca351580405085$var$_stringify([
        S
    ]) != '[null]' || $8bca351580405085$var$_stringify({
        a: S
    }) != '{}' || $8bca351580405085$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$a8jEg(replacer) && it === undefined || $8bca351580405085$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$k2l0Y(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$8bca351580405085$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $8bca351580405085$var$_stringify.apply($8bca351580405085$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$8bca351580405085$var$$Symbol[$8bca351580405085$var$PROTOTYPE][$8bca351580405085$var$TO_PRIMITIVE] || (parcelRequire("5eEKu"))($8bca351580405085$var$$Symbol[$8bca351580405085$var$PROTOTYPE], $8bca351580405085$var$TO_PRIMITIVE, $8bca351580405085$var$$Symbol[$8bca351580405085$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$7jOVX($8bca351580405085$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$7jOVX(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$7jOVX($fRJfg.JSON, 'JSON', true);



var $e88d0 = parcelRequire("e88d0");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$e88d0($e88d0.S, 'Object', {
    create: (parcelRequire("9lrow"))
});



var $e88d0 = parcelRequire("e88d0");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$e88d0($e88d0.S + $e88d0.F * !(parcelRequire("8csIg")), 'Object', {
    defineProperty: (parcelRequire("hjnWf")).f
});



var $e88d0 = parcelRequire("e88d0");


// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$e88d0($e88d0.S + $e88d0.F * !(parcelRequire("8csIg")), 'Object', {
    defineProperties: (parcelRequire("2Ss6l"))
});


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $h1IuT = parcelRequire("h1IuT");

var $6Vt7w = parcelRequire("6Vt7w");
var $ee9fdce7153d8f55$require$$getOwnPropertyDescriptor = $6Vt7w.f;

(parcelRequire("4jrsJ"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $ee9fdce7153d8f55$require$$getOwnPropertyDescriptor($h1IuT(it), key);
    };
});


// 19.1.2.9 Object.getPrototypeOf(O)

var $60LZ2 = parcelRequire("60LZ2");

var $eojdB = parcelRequire("eojdB");

(parcelRequire("4jrsJ"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $eojdB($60LZ2(it));
    };
});


// 19.1.2.14 Object.keys(O)

var $60LZ2 = parcelRequire("60LZ2");

var $gHcyI = parcelRequire("gHcyI");

(parcelRequire("4jrsJ"))('keys', function() {
    return function keys(it) {
        return $gHcyI($60LZ2(it));
    };
});


// 19.1.2.7 Object.getOwnPropertyNames(O)


(parcelRequire("4jrsJ"))('getOwnPropertyNames', function() {
    return (parcelRequire("linom")).f;
});


// 19.1.2.5 Object.freeze(O)

var $a8jEg = parcelRequire("a8jEg");

var $nFBKj = parcelRequire("nFBKj");
var $4055bc3cd10f1f48$require$meta = $nFBKj.onFreeze;

(parcelRequire("4jrsJ"))('freeze', function($freeze) {
    return function freeze(it) {
        return $freeze && $a8jEg(it) ? $freeze($4055bc3cd10f1f48$require$meta(it)) : it;
    };
});


// 19.1.2.17 Object.seal(O)

var $a8jEg = parcelRequire("a8jEg");

var $nFBKj = parcelRequire("nFBKj");
var $8997df3328016a64$require$meta = $nFBKj.onFreeze;

(parcelRequire("4jrsJ"))('seal', function($seal) {
    return function seal(it) {
        return $seal && $a8jEg(it) ? $seal($8997df3328016a64$require$meta(it)) : it;
    };
});


// 19.1.2.15 Object.preventExtensions(O)

var $a8jEg = parcelRequire("a8jEg");

var $nFBKj = parcelRequire("nFBKj");
var $68df7f6620e0023c$require$meta = $nFBKj.onFreeze;

(parcelRequire("4jrsJ"))('preventExtensions', function($preventExtensions) {
    return function preventExtensions(it) {
        return $preventExtensions && $a8jEg(it) ? $preventExtensions($68df7f6620e0023c$require$meta(it)) : it;
    };
});


// 19.1.2.12 Object.isFrozen(O)

var $a8jEg = parcelRequire("a8jEg");

(parcelRequire("4jrsJ"))('isFrozen', function($isFrozen) {
    return function isFrozen(it) {
        return $a8jEg(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
});


// 19.1.2.13 Object.isSealed(O)

var $a8jEg = parcelRequire("a8jEg");

(parcelRequire("4jrsJ"))('isSealed', function($isSealed) {
    return function isSealed(it) {
        return $a8jEg(it) ? $isSealed ? $isSealed(it) : false : true;
    };
});


// 19.1.2.11 Object.isExtensible(O)

var $a8jEg = parcelRequire("a8jEg");

(parcelRequire("4jrsJ"))('isExtensible', function($isExtensible) {
    return function isExtensible(it) {
        return $a8jEg(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
});


// 19.1.3.1 Object.assign(target, source)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S + $e88d0.F, 'Object', {
    assign: (parcelRequire("iTgBc"))
});


// 19.1.3.10 Object.is(value1, value2)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Object', {
    is: (parcelRequire("3N3vf"))
});


// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Object', {
    setPrototypeOf: (parcelRequire("c6KGM")).set
});


'use strict';

var $gTUcM = parcelRequire("gTUcM");
var $c7062f9f1c34acba$var$test = {};

var $fjK8l = parcelRequire("fjK8l");
$c7062f9f1c34acba$var$test[$fjK8l('toStringTag')] = 'z';

if ($c7062f9f1c34acba$var$test + '' != '[object z]') (parcelRequire("4ELbO"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $gTUcM(this) + ']';
}, true);


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P, 'Function', {
    bind: (parcelRequire("ladkF"))
});



var $hjnWf = parcelRequire("hjnWf");
var $8c88e2c723b32ac9$require$dP = $hjnWf.f;
var $8c88e2c723b32ac9$var$FProto = Function.prototype;
var $8c88e2c723b32ac9$var$nameRE = /^\s*function ([^ (]*)/;
var $8c88e2c723b32ac9$var$NAME = 'name';

// 19.2.4.2 name
$8c88e2c723b32ac9$var$NAME in $8c88e2c723b32ac9$var$FProto || (parcelRequire("8csIg")) && $8c88e2c723b32ac9$require$dP($8c88e2c723b32ac9$var$FProto, $8c88e2c723b32ac9$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return ('' + this).match($8c88e2c723b32ac9$var$nameRE)[1];
        } catch (e) {
            return '';
        }
    }
});


'use strict';

var $a8jEg = parcelRequire("a8jEg");

var $eojdB = parcelRequire("eojdB");

var $e478e33410863c7a$var$HAS_INSTANCE = (parcelRequire("fjK8l"))('hasInstance');
var $e478e33410863c7a$var$FunctionProto = Function.prototype;

// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!($e478e33410863c7a$var$HAS_INSTANCE in $e478e33410863c7a$var$FunctionProto)) (parcelRequire("hjnWf")).f($e478e33410863c7a$var$FunctionProto, $e478e33410863c7a$var$HAS_INSTANCE, {
    value: function(O) {
        if (typeof this != 'function' || !$a8jEg(O)) return false;
        if (!$a8jEg(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $eojdB(O))if (this.prototype === O) return true;
        return false;
    }
});



var $e88d0 = parcelRequire("e88d0");
var $473dbef9f6204506$exports = {};

var $fRJfg = parcelRequire("fRJfg");
var $473dbef9f6204506$require$$parseInt = $fRJfg.parseInt;

var $glTQQ = parcelRequire("glTQQ");
var $473dbef9f6204506$require$$trim = $glTQQ.trim;

var $dWWlA = parcelRequire("dWWlA");
var $473dbef9f6204506$var$hex = /^[-+]?0[xX]/;
$473dbef9f6204506$exports = $473dbef9f6204506$require$$parseInt($dWWlA + '08') !== 8 || $473dbef9f6204506$require$$parseInt($dWWlA + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $473dbef9f6204506$require$$trim(String(str), 3);
    return $473dbef9f6204506$require$$parseInt(string, radix >>> 0 || ($473dbef9f6204506$var$hex.test(string) ? 16 : 10));
} : $473dbef9f6204506$require$$parseInt;


// 18.2.5 parseInt(string, radix)
$e88d0($e88d0.G + $e88d0.F * (parseInt != $473dbef9f6204506$exports), {
    parseInt: $473dbef9f6204506$exports
});



var $e88d0 = parcelRequire("e88d0");
var $618fdec02ff914b9$exports = {};

var $fRJfg = parcelRequire("fRJfg");
var $618fdec02ff914b9$require$$parseFloat = $fRJfg.parseFloat;

var $glTQQ = parcelRequire("glTQQ");
var $618fdec02ff914b9$require$$trim = $glTQQ.trim;

$618fdec02ff914b9$exports = 1 / $618fdec02ff914b9$require$$parseFloat((parcelRequire("dWWlA")) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $618fdec02ff914b9$require$$trim(String(str), 3);
    var result = $618fdec02ff914b9$require$$parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $618fdec02ff914b9$require$$parseFloat;


// 18.2.4 parseFloat(string)
$e88d0($e88d0.G + $e88d0.F * (parseFloat != $618fdec02ff914b9$exports), {
    parseFloat: $618fdec02ff914b9$exports
});


'use strict';

var $fRJfg = parcelRequire("fRJfg");

var $fdFIW = parcelRequire("fdFIW");

var $gyczm = parcelRequire("gyczm");

var $kNhgM = parcelRequire("kNhgM");

var $h0Sfn = parcelRequire("h0Sfn");

var $as1c7 = parcelRequire("as1c7");

var $1UujU = parcelRequire("1UujU");
var $595627482d8b971a$require$gOPN = $1UujU.f;

var $6Vt7w = parcelRequire("6Vt7w");
var $595627482d8b971a$require$gOPD = $6Vt7w.f;

var $hjnWf = parcelRequire("hjnWf");
var $595627482d8b971a$require$dP = $hjnWf.f;

var $glTQQ = parcelRequire("glTQQ");
var $595627482d8b971a$require$$trim = $glTQQ.trim;
var $595627482d8b971a$var$NUMBER = 'Number';
var $595627482d8b971a$var$$Number = $fRJfg[$595627482d8b971a$var$NUMBER];
var $595627482d8b971a$var$Base = $595627482d8b971a$var$$Number;
var $595627482d8b971a$var$proto = $595627482d8b971a$var$$Number.prototype;

// Opera ~12 has broken Object#toString
var $595627482d8b971a$var$BROKEN_COF = $gyczm((parcelRequire("9lrow"))($595627482d8b971a$var$proto)) == $595627482d8b971a$var$NUMBER;
var $595627482d8b971a$var$TRIM = 'trim' in String.prototype;
// 7.1.3 ToNumber(argument)
var $595627482d8b971a$var$toNumber = function(argument) {
    var it = $h0Sfn(argument, false);
    if (typeof it == 'string' && it.length > 2) {
        it = $595627482d8b971a$var$TRIM ? it.trim() : $595627482d8b971a$require$$trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;
        if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(it.charCodeAt(1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal /^0o[0-7]+$/i
                default:
                    return +it;
            }
            for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
                code = digits.charCodeAt(i);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};


if (!$595627482d8b971a$var$$Number(' 0o1') || !$595627482d8b971a$var$$Number('0b1') || $595627482d8b971a$var$$Number('+0x1')) {
    $595627482d8b971a$var$$Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $595627482d8b971a$var$$Number && ($595627482d8b971a$var$BROKEN_COF ? $as1c7(function() {
            $595627482d8b971a$var$proto.valueOf.call(that);
        }) : $gyczm(that) != $595627482d8b971a$var$NUMBER) ? $kNhgM(new $595627482d8b971a$var$Base($595627482d8b971a$var$toNumber(it)), that, $595627482d8b971a$var$$Number) : $595627482d8b971a$var$toNumber(it);
    };
    for(var $595627482d8b971a$var$keys = (parcelRequire("8csIg")) ? $595627482d8b971a$require$gOPN($595627482d8b971a$var$Base) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(','), $595627482d8b971a$var$j = 0, $595627482d8b971a$var$key; $595627482d8b971a$var$keys.length > $595627482d8b971a$var$j; $595627482d8b971a$var$j++)if ($fdFIW($595627482d8b971a$var$Base, $595627482d8b971a$var$key = $595627482d8b971a$var$keys[$595627482d8b971a$var$j]) && !$fdFIW($595627482d8b971a$var$$Number, $595627482d8b971a$var$key)) $595627482d8b971a$require$dP($595627482d8b971a$var$$Number, $595627482d8b971a$var$key, $595627482d8b971a$require$gOPD($595627482d8b971a$var$Base, $595627482d8b971a$var$key));
    $595627482d8b971a$var$$Number.prototype = $595627482d8b971a$var$proto;
    $595627482d8b971a$var$proto.constructor = $595627482d8b971a$var$$Number;
    (parcelRequire("4ELbO"))($fRJfg, $595627482d8b971a$var$NUMBER, $595627482d8b971a$var$$Number);
}


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $8KZEi = parcelRequire("8KZEi");
var $8a06fc418ea407fd$exports = {};

var $gyczm = parcelRequire("gyczm");
$8a06fc418ea407fd$exports = function(it, msg) {
    if (typeof it != 'number' && $gyczm(it) != 'Number') throw TypeError(msg);
    return +it;
};



var $1uiiY = parcelRequire("1uiiY");
var $2d6136a4c173fff5$var$$toFixed = 1.0.toFixed;
var $2d6136a4c173fff5$var$floor = Math.floor;
var $2d6136a4c173fff5$var$data = [
    0,
    0,
    0,
    0,
    0,
    0
];
var $2d6136a4c173fff5$var$ERROR = 'Number.toFixed: incorrect invocation!';
var $2d6136a4c173fff5$var$ZERO = '0';
var $2d6136a4c173fff5$var$multiply = function(n, c) {
    var i = -1;
    var c2 = c;
    while(++i < 6){
        c2 += n * $2d6136a4c173fff5$var$data[i];
        $2d6136a4c173fff5$var$data[i] = c2 % 1e7;
        c2 = $2d6136a4c173fff5$var$floor(c2 / 1e7);
    }
};
var $2d6136a4c173fff5$var$divide = function(n) {
    var i = 6;
    var c = 0;
    while(--i >= 0){
        c += $2d6136a4c173fff5$var$data[i];
        $2d6136a4c173fff5$var$data[i] = $2d6136a4c173fff5$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $2d6136a4c173fff5$var$numToString = function() {
    var i = 6;
    var s = '';
    while(--i >= 0)if (s !== '' || i === 0 || $2d6136a4c173fff5$var$data[i] !== 0) {
        var t = String($2d6136a4c173fff5$var$data[i]);
        s = s === '' ? t : s + $1uiiY.call($2d6136a4c173fff5$var$ZERO, 7 - t.length) + t;
    }
    return s;
};
var $2d6136a4c173fff5$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $2d6136a4c173fff5$var$pow(x, n - 1, acc * x) : $2d6136a4c173fff5$var$pow(x * x, n / 2, acc);
};
var $2d6136a4c173fff5$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};

$e88d0($e88d0.P + $e88d0.F * (!!$2d6136a4c173fff5$var$$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !(parcelRequire("as1c7"))(function() {
    // V8 ~ Android 4.3-
    $2d6136a4c173fff5$var$$toFixed.call({});
})), 'Number', {
    toFixed: function toFixed(fractionDigits) {
        var x = $8a06fc418ea407fd$exports(this, $2d6136a4c173fff5$var$ERROR);
        var f = $8KZEi(fractionDigits);
        var s = '';
        var m = $2d6136a4c173fff5$var$ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError($2d6136a4c173fff5$var$ERROR);
        // eslint-disable-next-line no-self-compare
        if (x != x) return 'NaN';
        if (x <= -1000000000000000000000 || x >= 1e21) return String(x);
        if (x < 0) {
            s = '-';
            x = -x;
        }
        if (x > 1e-21) {
            e = $2d6136a4c173fff5$var$log(x * $2d6136a4c173fff5$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? x * $2d6136a4c173fff5$var$pow(2, -e, 1) : x / $2d6136a4c173fff5$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $2d6136a4c173fff5$var$multiply(0, z);
                j = f;
                while(j >= 7){
                    $2d6136a4c173fff5$var$multiply(1e7, 0);
                    j -= 7;
                }
                $2d6136a4c173fff5$var$multiply($2d6136a4c173fff5$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $2d6136a4c173fff5$var$divide(8388608);
                    j -= 23;
                }
                $2d6136a4c173fff5$var$divide(1 << j);
                $2d6136a4c173fff5$var$multiply(1, 1);
                $2d6136a4c173fff5$var$divide(2);
                m = $2d6136a4c173fff5$var$numToString();
            } else {
                $2d6136a4c173fff5$var$multiply(0, z);
                $2d6136a4c173fff5$var$multiply(1 << -e, 0);
                m = $2d6136a4c173fff5$var$numToString() + $1uiiY.call($2d6136a4c173fff5$var$ZERO, f);
            }
        }
        if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + $1uiiY.call($2d6136a4c173fff5$var$ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else m = s + m;
        return m;
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $as1c7 = parcelRequire("as1c7");

var $b88586cc08df8192$var$$toPrecision = 1.0.toPrecision;
$e88d0($e88d0.P + $e88d0.F * ($as1c7(function() {
    // IE7-
    return $b88586cc08df8192$var$$toPrecision.call(1, undefined) !== '1';
}) || !$as1c7(function() {
    // V8 ~ Android 4.3-
    $b88586cc08df8192$var$$toPrecision.call({});
})), 'Number', {
    toPrecision: function toPrecision(precision) {
        var that = $8a06fc418ea407fd$exports(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $b88586cc08df8192$var$$toPrecision.call(that) : $b88586cc08df8192$var$$toPrecision.call(that, precision);
    }
});


// 20.1.2.1 Number.EPSILON

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Number', {
    EPSILON: Math.pow(2, -52)
});


// 20.1.2.2 Number.isFinite(number)

var $e88d0 = parcelRequire("e88d0");

var $fRJfg = parcelRequire("fRJfg");
var $42efcefbbde2b00c$require$_isFinite = $fRJfg.isFinite;
$e88d0($e88d0.S, 'Number', {
    isFinite: function isFinite(it) {
        return typeof it == 'number' && $42efcefbbde2b00c$require$_isFinite(it);
    }
});


// 20.1.2.3 Number.isInteger(number)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Number', {
    isInteger: (parcelRequire("fOCrm"))
});


// 20.1.2.4 Number.isNaN(number)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Number', {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});


// 20.1.2.5 Number.isSafeInteger(number)

var $e88d0 = parcelRequire("e88d0");

var $fOCrm = parcelRequire("fOCrm");
var $f8f48c61a5e6e7d8$var$abs = Math.abs;
$e88d0($e88d0.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
        return $fOCrm(number) && $f8f48c61a5e6e7d8$var$abs(number) <= 0x1fffffffffffff;
    }
});


// 20.1.2.6 Number.MAX_SAFE_INTEGER

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
});


// 20.1.2.10 Number.MIN_SAFE_INTEGER

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Number', {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $e88d0 = parcelRequire("e88d0");

// 20.1.2.12 Number.parseFloat(string)
$e88d0($e88d0.S + $e88d0.F * (Number.parseFloat != $618fdec02ff914b9$exports), 'Number', {
    parseFloat: $618fdec02ff914b9$exports
});



var $e88d0 = parcelRequire("e88d0");

// 20.1.2.13 Number.parseInt(string, radix)
$e88d0($e88d0.S + $e88d0.F * (Number.parseInt != $473dbef9f6204506$exports), 'Number', {
    parseInt: $473dbef9f6204506$exports
});


// 20.2.2.3 Math.acosh(x)

var $e88d0 = parcelRequire("e88d0");

var $lTkrp = parcelRequire("lTkrp");
var $525b39812c7ea069$var$sqrt = Math.sqrt;
var $525b39812c7ea069$var$$acosh = Math.acosh;
$e88d0($e88d0.S + $e88d0.F * !($525b39812c7ea069$var$$acosh && Math.floor($525b39812c7ea069$var$$acosh(Number.MAX_VALUE)) == 710 && $525b39812c7ea069$var$$acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : $lTkrp(x - 1 + $525b39812c7ea069$var$sqrt(x - 1) * $525b39812c7ea069$var$sqrt(x + 1));
    }
});


// 20.2.2.5 Math.asinh(x)

var $e88d0 = parcelRequire("e88d0");
var $f6ed14b1438a4d96$var$$asinh = Math.asinh;
function $f6ed14b1438a4d96$var$asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -$f6ed14b1438a4d96$var$asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}
// Tor Browser bug: Math.asinh(0) -> -0
$e88d0($e88d0.S + $e88d0.F * !($f6ed14b1438a4d96$var$$asinh && 1 / $f6ed14b1438a4d96$var$$asinh(0) > 0), 'Math', {
    asinh: $f6ed14b1438a4d96$var$asinh
});


// 20.2.2.7 Math.atanh(x)

var $e88d0 = parcelRequire("e88d0");
var $92965786d1ffe0e1$var$$atanh = Math.atanh;
// Tor Browser bug: Math.atanh(-0) -> 0
$e88d0($e88d0.S + $e88d0.F * !($92965786d1ffe0e1$var$$atanh && 1 / $92965786d1ffe0e1$var$$atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
});


// 20.2.2.9 Math.cbrt(x)

var $e88d0 = parcelRequire("e88d0");

var $jE34f = parcelRequire("jE34f");
$e88d0($e88d0.S, 'Math', {
    cbrt: function cbrt(x) {
        return $jE34f(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
});


// 20.2.2.11 Math.clz32(x)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
});


// 20.2.2.12 Math.cosh(x)

var $e88d0 = parcelRequire("e88d0");
var $60f572e1734c9dbe$var$exp = Math.exp;
$e88d0($e88d0.S, 'Math', {
    cosh: function cosh(x) {
        return ($60f572e1734c9dbe$var$exp(x = +x) + $60f572e1734c9dbe$var$exp(-x)) / 2;
    }
});


// 20.2.2.14 Math.expm1(x)

var $e88d0 = parcelRequire("e88d0");
var $053c48a1fbc758bf$exports = {};
// 20.2.2.14 Math.expm1(x)
var $053c48a1fbc758bf$var$$expm1 = Math.expm1;
$053c48a1fbc758bf$exports = !$053c48a1fbc758bf$var$$expm1 || $053c48a1fbc758bf$var$$expm1(10) > 22025.465794806719 || $053c48a1fbc758bf$var$$expm1(10) < 22025.4657948067165168 || $053c48a1fbc758bf$var$$expm1(-0.00000000000000002) != -0.00000000000000002 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -0.000001 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $053c48a1fbc758bf$var$$expm1;


$e88d0($e88d0.S + $e88d0.F * ($053c48a1fbc758bf$exports != Math.expm1), 'Math', {
    expm1: $053c48a1fbc758bf$exports
});


// 20.2.2.16 Math.fround(x)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Math', {
    fround: (parcelRequire("6JdnZ"))
});


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var $e88d0 = parcelRequire("e88d0");
var $6961381440cb2d89$var$abs = Math.abs;
$e88d0($e88d0.S, 'Math', {
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $6961381440cb2d89$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
});


// 20.2.2.18 Math.imul(x, y)

var $e88d0 = parcelRequire("e88d0");
var $a1a9a3098f38cde4$var$$imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$e88d0($e88d0.S + $e88d0.F * (parcelRequire("as1c7"))(function() {
    return $a1a9a3098f38cde4$var$$imul(0xffffffff, 5) != -5 || $a1a9a3098f38cde4$var$$imul.length != 2;
}), 'Math', {
    imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


// 20.2.2.21 Math.log10(x)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
    }
});


// 20.2.2.20 Math.log1p(x)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Math', {
    log1p: (parcelRequire("lTkrp"))
});


// 20.2.2.22 Math.log2(x)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    log2: function log2(x) {
        return Math.log(x) / Math.LN2;
    }
});


// 20.2.2.28 Math.sign(x)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Math', {
    sign: (parcelRequire("jE34f"))
});


// 20.2.2.30 Math.sinh(x)

var $e88d0 = parcelRequire("e88d0");

var $4e7e597eae7a9fbb$var$exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$e88d0($e88d0.S + $e88d0.F * (parcelRequire("as1c7"))(function() {
    return !Math.sinh(-0.00000000000000002) != -0.00000000000000002;
}), 'Math', {
    sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? ($053c48a1fbc758bf$exports(x) - $053c48a1fbc758bf$exports(-x)) / 2 : ($4e7e597eae7a9fbb$var$exp(x - 1) - $4e7e597eae7a9fbb$var$exp(-x - 1)) * (Math.E / 2);
    }
});


// 20.2.2.33 Math.tanh(x)

var $e88d0 = parcelRequire("e88d0");

var $03c613df31f9acbe$var$exp = Math.exp;
$e88d0($e88d0.S, 'Math', {
    tanh: function tanh(x) {
        var a = $053c48a1fbc758bf$exports(x = +x);
        var b = $053c48a1fbc758bf$exports(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($03c613df31f9acbe$var$exp(x) + $03c613df31f9acbe$var$exp(-x));
    }
});


// 20.2.2.34 Math.trunc(x)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
    }
});



var $e88d0 = parcelRequire("e88d0");

var $79CKs = parcelRequire("79CKs");
var $90d3d7002a67bf14$var$fromCharCode = String.fromCharCode;
var $90d3d7002a67bf14$var$$fromCodePoint = String.fromCodePoint;
// length should be 1, old FF problem
$e88d0($e88d0.S + $e88d0.F * (!!$90d3d7002a67bf14$var$$fromCodePoint && $90d3d7002a67bf14$var$$fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while(aLen > i){
            code = +arguments[i++];
            if ($79CKs(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? $90d3d7002a67bf14$var$fromCharCode(code) : $90d3d7002a67bf14$var$fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
    }
});



var $e88d0 = parcelRequire("e88d0");

var $h1IuT = parcelRequire("h1IuT");

var $6oAU6 = parcelRequire("6oAU6");
$e88d0($e88d0.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
        var tpl = $h1IuT(callSite.raw);
        var len = $6oAU6(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while(len > i){
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
    }
});


'use strict';

// 21.1.3.25 String.prototype.trim()
(parcelRequire("glTQQ"))('trim', function($trim) {
    return function trim() {
        return $trim(this, 3);
    };
});


'use strict';

var $ebd135ddd966cd23$var$$at = (parcelRequire("2TsAR"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("k0W9G"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $ebd135ddd966cd23$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $2edcd3fcbd8ddff9$var$$at = (parcelRequire("2TsAR"))(false);
$e88d0($e88d0.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
        return $2edcd3fcbd8ddff9$var$$at(this, pos);
    }
});


// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';

var $e88d0 = parcelRequire("e88d0");

var $6oAU6 = parcelRequire("6oAU6");
var $2e0878575e7cacfe$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $51c8b46ff212d7eb$exports = {};
// 7.2.8 IsRegExp(argument)

var $a8jEg = parcelRequire("a8jEg");

var $gyczm = parcelRequire("gyczm");

var $51c8b46ff212d7eb$var$MATCH = (parcelRequire("fjK8l"))('match');
$51c8b46ff212d7eb$exports = function(it) {
    var isRegExp;
    return $a8jEg(it) && ((isRegExp = it[$51c8b46ff212d7eb$var$MATCH]) !== undefined ? !!isRegExp : $gyczm(it) == 'RegExp');
};



var $iedom = parcelRequire("iedom");
$2e0878575e7cacfe$exports = function(that, searchString, NAME) {
    if ($51c8b46ff212d7eb$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($iedom(that));
};


var $869ed243b9a88f29$var$ENDS_WITH = 'endsWith';
var $869ed243b9a88f29$var$$endsWith = ''[$869ed243b9a88f29$var$ENDS_WITH];

$e88d0($e88d0.P + $e88d0.F * (parcelRequire("gmWLF"))($869ed243b9a88f29$var$ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $2e0878575e7cacfe$exports(this, searchString, $869ed243b9a88f29$var$ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = $6oAU6(that.length);
        var end = endPosition === undefined ? len : Math.min($6oAU6(endPosition), len);
        var search = String(searchString);
        return $869ed243b9a88f29$var$$endsWith ? $869ed243b9a88f29$var$$endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
});


// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';

var $e88d0 = parcelRequire("e88d0");

var $d015e30da7add58e$var$INCLUDES = 'includes';

$e88d0($e88d0.P + $e88d0.F * (parcelRequire("gmWLF"))($d015e30da7add58e$var$INCLUDES), 'String', {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$2e0878575e7cacfe$exports(this, searchString, $d015e30da7add58e$var$INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: (parcelRequire("1uiiY"))
});


// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $e88d0 = parcelRequire("e88d0");

var $6oAU6 = parcelRequire("6oAU6");

var $34875e8609c32dc9$var$STARTS_WITH = 'startsWith';
var $34875e8609c32dc9$var$$startsWith = ''[$34875e8609c32dc9$var$STARTS_WITH];

$e88d0($e88d0.P + $e88d0.F * (parcelRequire("gmWLF"))($34875e8609c32dc9$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $2e0878575e7cacfe$exports(this, searchString, $34875e8609c32dc9$var$STARTS_WITH);
        var index = $6oAU6(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $34875e8609c32dc9$var$$startsWith ? $34875e8609c32dc9$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});


'use strict';

// B.2.3.2 String.prototype.anchor(name)
(parcelRequire("lQyYn"))('anchor', function(createHTML) {
    return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    };
});


'use strict';

// B.2.3.3 String.prototype.big()
(parcelRequire("lQyYn"))('big', function(createHTML) {
    return function big() {
        return createHTML(this, 'big', '', '');
    };
});


'use strict';

// B.2.3.4 String.prototype.blink()
(parcelRequire("lQyYn"))('blink', function(createHTML) {
    return function blink() {
        return createHTML(this, 'blink', '', '');
    };
});


'use strict';

// B.2.3.5 String.prototype.bold()
(parcelRequire("lQyYn"))('bold', function(createHTML) {
    return function bold() {
        return createHTML(this, 'b', '', '');
    };
});


'use strict';

// B.2.3.6 String.prototype.fixed()
(parcelRequire("lQyYn"))('fixed', function(createHTML) {
    return function fixed() {
        return createHTML(this, 'tt', '', '');
    };
});


'use strict';

// B.2.3.7 String.prototype.fontcolor(color)
(parcelRequire("lQyYn"))('fontcolor', function(createHTML) {
    return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    };
});


'use strict';

// B.2.3.8 String.prototype.fontsize(size)
(parcelRequire("lQyYn"))('fontsize', function(createHTML) {
    return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    };
});


'use strict';

// B.2.3.9 String.prototype.italics()
(parcelRequire("lQyYn"))('italics', function(createHTML) {
    return function italics() {
        return createHTML(this, 'i', '', '');
    };
});


'use strict';

// B.2.3.10 String.prototype.link(url)
(parcelRequire("lQyYn"))('link', function(createHTML) {
    return function link(url) {
        return createHTML(this, 'a', 'href', url);
    };
});


'use strict';

// B.2.3.11 String.prototype.small()
(parcelRequire("lQyYn"))('small', function(createHTML) {
    return function small() {
        return createHTML(this, 'small', '', '');
    };
});


'use strict';

// B.2.3.12 String.prototype.strike()
(parcelRequire("lQyYn"))('strike', function(createHTML) {
    return function strike() {
        return createHTML(this, 'strike', '', '');
    };
});


'use strict';

// B.2.3.13 String.prototype.sub()
(parcelRequire("lQyYn"))('sub', function(createHTML) {
    return function sub() {
        return createHTML(this, 'sub', '', '');
    };
});


'use strict';

// B.2.3.14 String.prototype.sup()
(parcelRequire("lQyYn"))('sup', function(createHTML) {
    return function sup() {
        return createHTML(this, 'sup', '', '');
    };
});


// 20.3.3.1 / 15.9.4.4 Date.now()

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $h0Sfn = parcelRequire("h0Sfn");

$e88d0($e88d0.P + $e88d0.F * (parcelRequire("as1c7"))(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
}), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
        var O = $60LZ2(this);
        var pv = $h0Sfn(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $e88d0 = parcelRequire("e88d0");
var $057a37b3a18320db$exports = {};
'use strict';

var $as1c7 = parcelRequire("as1c7");
var $057a37b3a18320db$var$getTime = Date.prototype.getTime;
var $057a37b3a18320db$var$$toISOString = Date.prototype.toISOString;
var $057a37b3a18320db$var$lz = function(num) {
    return num > 9 ? num : '0' + num;
};
// PhantomJS / old WebKit has a broken implementations
$057a37b3a18320db$exports = $as1c7(function() {
    return $057a37b3a18320db$var$$toISOString.call(new Date(-50000000000000 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !$as1c7(function() {
    $057a37b3a18320db$var$$toISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!isFinite($057a37b3a18320db$var$getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + $057a37b3a18320db$var$lz(d.getUTCMonth() + 1) + '-' + $057a37b3a18320db$var$lz(d.getUTCDate()) + 'T' + $057a37b3a18320db$var$lz(d.getUTCHours()) + ':' + $057a37b3a18320db$var$lz(d.getUTCMinutes()) + ':' + $057a37b3a18320db$var$lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + $057a37b3a18320db$var$lz(m)) + 'Z';
} : $057a37b3a18320db$var$$toISOString;


// PhantomJS / old WebKit has a broken implementations
$e88d0($e88d0.P + $e88d0.F * (Date.prototype.toISOString !== $057a37b3a18320db$exports), 'Date', {
    toISOString: $057a37b3a18320db$exports
});


var $edc2e2a46874000a$var$DateProto = Date.prototype;
var $edc2e2a46874000a$var$INVALID_DATE = 'Invalid Date';
var $edc2e2a46874000a$var$TO_STRING = 'toString';
var $edc2e2a46874000a$var$$toString = $edc2e2a46874000a$var$DateProto[$edc2e2a46874000a$var$TO_STRING];
var $edc2e2a46874000a$var$getTime = $edc2e2a46874000a$var$DateProto.getTime;

if (new Date(NaN) + '' != $edc2e2a46874000a$var$INVALID_DATE) (parcelRequire("4ELbO"))($edc2e2a46874000a$var$DateProto, $edc2e2a46874000a$var$TO_STRING, function toString() {
    var value = $edc2e2a46874000a$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $edc2e2a46874000a$var$$toString.call(this) : $edc2e2a46874000a$var$INVALID_DATE;
});



var $df8d305863313d58$var$TO_PRIMITIVE = (parcelRequire("fjK8l"))('toPrimitive');
var $df8d305863313d58$var$proto = Date.prototype;


if (!($df8d305863313d58$var$TO_PRIMITIVE in $df8d305863313d58$var$proto)) (parcelRequire("5eEKu"))($df8d305863313d58$var$proto, $df8d305863313d58$var$TO_PRIMITIVE, (parcelRequire("aYJHn")));


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Array', {
    isArray: (parcelRequire("k2l0Y"))
});


'use strict';

var $bKCrG = parcelRequire("bKCrG");

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $iUAhO = parcelRequire("iUAhO");

var $7cwkx = parcelRequire("7cwkx");

var $6oAU6 = parcelRequire("6oAU6");
var $5f8f189a9ef8edff$exports = {};
'use strict';

var $hjnWf = parcelRequire("hjnWf");

var $3PFaa = parcelRequire("3PFaa");
$5f8f189a9ef8edff$exports = function(object, index, value) {
    if (index in object) $hjnWf.f(object, index, $3PFaa(0, value));
    else object[index] = value;
};



var $cNTiY = parcelRequire("cNTiY");

$e88d0($e88d0.S + $e88d0.F * !(parcelRequire("6W0vs"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $60LZ2(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $cNTiY(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $bKCrG(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $7cwkx(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$5f8f189a9ef8edff$exports(result, index, mapping ? $iUAhO(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $6oAU6(O.length);
            for(result = new C(length); length > index; index++)$5f8f189a9ef8edff$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");


// WebKit Array.of isn't generic
$e88d0($e88d0.S + $e88d0.F * (parcelRequire("as1c7"))(function() {
    function F() {}
    return !(Array.of.call(F) instanceof F);
}), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of() {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);
        while(aLen > index)$5f8f189a9ef8edff$exports(result, index, arguments[index++]);
        result.length = aLen;
        return result;
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $h1IuT = parcelRequire("h1IuT");
var $6bb66e08b4fe631c$var$arrayJoin = [].join;


// fallback for not array-like strings
$e88d0($e88d0.P + $e88d0.F * ((parcelRequire("3yrVW")) != Object || !(parcelRequire("7BiMX"))($6bb66e08b4fe631c$var$arrayJoin)), 'Array', {
    join: function join(separator) {
        return $6bb66e08b4fe631c$var$arrayJoin.call($h1IuT(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $fWBj0 = parcelRequire("fWBj0");

var $gyczm = parcelRequire("gyczm");

var $79CKs = parcelRequire("79CKs");

var $6oAU6 = parcelRequire("6oAU6");
var $d05dec66e4c962e6$var$arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$e88d0($e88d0.P + $e88d0.F * (parcelRequire("as1c7"))(function() {
    if ($fWBj0) $d05dec66e4c962e6$var$arraySlice.call($fWBj0);
}), 'Array', {
    slice: function slice(begin, end) {
        var len = $6oAU6(this.length);
        var klass = $gyczm(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return $d05dec66e4c962e6$var$arraySlice.call(this, begin, end);
        var start = $79CKs(begin, len);
        var upTo = $79CKs(end, len);
        var size = $6oAU6(upTo - start);
        var cloned = new Array(size);
        var i = 0;
        for(; i < size; i++)cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        return cloned;
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $3fVrL = parcelRequire("3fVrL");

var $60LZ2 = parcelRequire("60LZ2");

var $as1c7 = parcelRequire("as1c7");
var $33713371d9995436$var$$sort = [].sort;
var $33713371d9995436$var$test = [
    1,
    2,
    3
];

$e88d0($e88d0.P + $e88d0.F * ($as1c7(function() {
    // IE8-
    $33713371d9995436$var$test.sort(undefined);
}) || !$as1c7(function() {
    // V8 bug
    $33713371d9995436$var$test.sort(null);
// Old WebKit
}) || !(parcelRequire("7BiMX"))($33713371d9995436$var$$sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
        return comparefn === undefined ? $33713371d9995436$var$$sort.call($60LZ2(this)) : $33713371d9995436$var$$sort.call($60LZ2(this), $3fVrL(comparefn));
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $eb7a7139ac901dd4$var$$forEach = (parcelRequire("mgfCC"))(0);

var $eb7a7139ac901dd4$var$STRICT = (parcelRequire("7BiMX"))([].forEach, true);
$e88d0($e88d0.P + $e88d0.F * !$eb7a7139ac901dd4$var$STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn /* , thisArg */ ) {
        return $eb7a7139ac901dd4$var$$forEach(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $1b029e0fdacc1fec$var$$map = (parcelRequire("mgfCC"))(1);

$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn /* , thisArg */ ) {
        return $1b029e0fdacc1fec$var$$map(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $8a64efd2e7bb9d5f$var$$filter = (parcelRequire("mgfCC"))(2);

$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $8a64efd2e7bb9d5f$var$$filter(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $a925dba5a1655fb4$var$$some = (parcelRequire("mgfCC"))(3);

$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn /* , thisArg */ ) {
        return $a925dba5a1655fb4$var$$some(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $e5ce8a8f94d79ce4$var$$every = (parcelRequire("mgfCC"))(4);

$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn /* , thisArg */ ) {
        return $e5ce8a8f94d79ce4$var$$every(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");
var $972647839d930b6a$exports = {};

var $3fVrL = parcelRequire("3fVrL");

var $60LZ2 = parcelRequire("60LZ2");

var $3yrVW = parcelRequire("3yrVW");

var $6oAU6 = parcelRequire("6oAU6");
$972647839d930b6a$exports = function(that, callbackfn, aLen, memo, isRight) {
    $3fVrL(callbackfn);
    var O = $60LZ2(that);
    var self = $3yrVW(O);
    var length = $6oAU6(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $972647839d930b6a$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");


$e88d0($e88d0.P + $e88d0.F * !(parcelRequire("7BiMX"))([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $972647839d930b6a$exports(this, callbackfn, arguments.length, arguments[1], true);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $1d0865e6724c0bdb$var$$indexOf = (parcelRequire("6zju3"))(false);
var $1d0865e6724c0bdb$var$$native = [].indexOf;
var $1d0865e6724c0bdb$var$NEGATIVE_ZERO = !!$1d0865e6724c0bdb$var$$native && 1 / [
    1
].indexOf(1, -0) < 0;

$e88d0($e88d0.P + $e88d0.F * ($1d0865e6724c0bdb$var$NEGATIVE_ZERO || !(parcelRequire("7BiMX"))($1d0865e6724c0bdb$var$$native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        return $1d0865e6724c0bdb$var$NEGATIVE_ZERO ? $1d0865e6724c0bdb$var$$native.apply(this, arguments) || 0 : $1d0865e6724c0bdb$var$$indexOf(this, searchElement, arguments[1]);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $h1IuT = parcelRequire("h1IuT");

var $8KZEi = parcelRequire("8KZEi");

var $6oAU6 = parcelRequire("6oAU6");
var $e054377bd0b6c5b6$var$$native = [].lastIndexOf;
var $e054377bd0b6c5b6$var$NEGATIVE_ZERO = !!$e054377bd0b6c5b6$var$$native && 1 / [
    1
].lastIndexOf(1, -0) < 0;

$e88d0($e88d0.P + $e88d0.F * ($e054377bd0b6c5b6$var$NEGATIVE_ZERO || !(parcelRequire("7BiMX"))($e054377bd0b6c5b6$var$$native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
        // convert -0 to +0
        if ($e054377bd0b6c5b6$var$NEGATIVE_ZERO) return $e054377bd0b6c5b6$var$$native.apply(this, arguments) || 0;
        var O = $h1IuT(this);
        var length = $6oAU6(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, $8KZEi(arguments[1]));
        if (index < 0) index = length + index;
        for(; index >= 0; index--)if (index in O) {
            if (O[index] === searchElement) return index || 0;
        }
        return -1;
    }
});


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P, 'Array', {
    copyWithin: (parcelRequire("1bFtr"))
});

(parcelRequire("lwTuI"))('copyWithin');


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P, 'Array', {
    fill: (parcelRequire("5Y7zp"))
});

(parcelRequire("lwTuI"))('fill');


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $e31aef083bd6f0c1$var$$find = (parcelRequire("mgfCC"))(5);
var $e31aef083bd6f0c1$var$KEY = 'find';
var $e31aef083bd6f0c1$var$forced = true;
// Shouldn't skip holes
if ($e31aef083bd6f0c1$var$KEY in []) Array(1)[$e31aef083bd6f0c1$var$KEY](function() {
    $e31aef083bd6f0c1$var$forced = false;
});
$e88d0($e88d0.P + $e88d0.F * $e31aef083bd6f0c1$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $e31aef083bd6f0c1$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("lwTuI"))($e31aef083bd6f0c1$var$KEY);


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $a05d76adb1b6c6ca$var$$find = (parcelRequire("mgfCC"))(6);
var $a05d76adb1b6c6ca$var$KEY = 'findIndex';
var $a05d76adb1b6c6ca$var$forced = true;
// Shouldn't skip holes
if ($a05d76adb1b6c6ca$var$KEY in []) Array(1)[$a05d76adb1b6c6ca$var$KEY](function() {
    $a05d76adb1b6c6ca$var$forced = false;
});
$e88d0($e88d0.P + $e88d0.F * $a05d76adb1b6c6ca$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $a05d76adb1b6c6ca$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("lwTuI"))($a05d76adb1b6c6ca$var$KEY);



(parcelRequire("dQX1C"))('Array');


parcelRequire("2jMtE");

var $fRJfg = parcelRequire("fRJfg");

var $kNhgM = parcelRequire("kNhgM");

var $hjnWf = parcelRequire("hjnWf");
var $554e914084e36d00$require$dP = $hjnWf.f;

var $1UujU = parcelRequire("1UujU");
var $554e914084e36d00$require$gOPN = $1UujU.f;


var $cYtFt = parcelRequire("cYtFt");
var $554e914084e36d00$var$$RegExp = $fRJfg.RegExp;
var $554e914084e36d00$var$Base = $554e914084e36d00$var$$RegExp;
var $554e914084e36d00$var$proto = $554e914084e36d00$var$$RegExp.prototype;
var $554e914084e36d00$var$re1 = /a/g;
var $554e914084e36d00$var$re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var $554e914084e36d00$var$CORRECT_NEW = new $554e914084e36d00$var$$RegExp($554e914084e36d00$var$re1) !== $554e914084e36d00$var$re1;



var $fjK8l = parcelRequire("fjK8l");

if ((parcelRequire("8csIg")) && (!$554e914084e36d00$var$CORRECT_NEW || (parcelRequire("as1c7"))(function() {
    $554e914084e36d00$var$re2[$fjK8l('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $554e914084e36d00$var$$RegExp($554e914084e36d00$var$re1) != $554e914084e36d00$var$re1 || $554e914084e36d00$var$$RegExp($554e914084e36d00$var$re2) == $554e914084e36d00$var$re2 || $554e914084e36d00$var$$RegExp($554e914084e36d00$var$re1, 'i') != '/a/i';
}))) {
    $554e914084e36d00$var$$RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $554e914084e36d00$var$$RegExp;
        var piRE = $51c8b46ff212d7eb$exports(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $554e914084e36d00$var$$RegExp && fiU ? p : $kNhgM($554e914084e36d00$var$CORRECT_NEW ? new $554e914084e36d00$var$Base(piRE && !fiU ? p.source : p, f) : $554e914084e36d00$var$Base((piRE = p instanceof $554e914084e36d00$var$$RegExp) ? p.source : p, piRE && fiU ? $cYtFt.call(p) : f), tiRE ? this : $554e914084e36d00$var$proto, $554e914084e36d00$var$$RegExp);
    };
    var $554e914084e36d00$var$proxy = function(key) {
        key in $554e914084e36d00$var$$RegExp || $554e914084e36d00$require$dP($554e914084e36d00$var$$RegExp, key, {
            configurable: true,
            get: function() {
                return $554e914084e36d00$var$Base[key];
            },
            set: function(it) {
                $554e914084e36d00$var$Base[key] = it;
            }
        });
    };
    for(var $554e914084e36d00$var$keys = $554e914084e36d00$require$gOPN($554e914084e36d00$var$Base), $554e914084e36d00$var$i = 0; $554e914084e36d00$var$keys.length > $554e914084e36d00$var$i;)$554e914084e36d00$var$proxy($554e914084e36d00$var$keys[$554e914084e36d00$var$i++]);
    $554e914084e36d00$var$proto.constructor = $554e914084e36d00$var$$RegExp;
    $554e914084e36d00$var$$RegExp.prototype = $554e914084e36d00$var$proto;
    (parcelRequire("4ELbO"))($fRJfg, 'RegExp', $554e914084e36d00$var$$RegExp);
}

(parcelRequire("dQX1C"))('RegExp');


parcelRequire("dwwSd");
'use strict';
// 21.2.5.3 get RegExp.prototype.flags()



if ((parcelRequire("8csIg")) && /./g.flags != 'g') (parcelRequire("hjnWf")).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: (parcelRequire("cYtFt"))
});



var $cYx5q = parcelRequire("cYx5q");

var $cYtFt = parcelRequire("cYtFt");

var $8csIg = parcelRequire("8csIg");
var $e17d49300b43216d$var$TO_STRING = 'toString';
var $e17d49300b43216d$var$$toString = /./[$e17d49300b43216d$var$TO_STRING];

var $e17d49300b43216d$var$define = function(fn) {
    (parcelRequire("4ELbO"))(RegExp.prototype, $e17d49300b43216d$var$TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if ((parcelRequire("as1c7"))(function() {
    return $e17d49300b43216d$var$$toString.call({
        source: 'a',
        flags: 'b'
    }) != '/a/b';
})) $e17d49300b43216d$var$define(function toString() {
    var R = $cYx5q(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !$8csIg && R instanceof RegExp ? $cYtFt.call(R) : undefined);
});
else if ($e17d49300b43216d$var$$toString.name != $e17d49300b43216d$var$TO_STRING) $e17d49300b43216d$var$define(function toString() {
    return $e17d49300b43216d$var$$toString.call(this);
});



'use strict';

var $cYx5q = parcelRequire("cYx5q");

var $6oAU6 = parcelRequire("6oAU6");
var $00a2088a7540c748$exports = {};
'use strict';

var $00a2088a7540c748$var$at = (parcelRequire("2TsAR"))(true);
// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
$00a2088a7540c748$exports = function(S, index, unicode) {
    return index + (unicode ? $00a2088a7540c748$var$at(S, index).length : 1);
};


var $75f650735467e244$exports = {};
'use strict';

var $gTUcM = parcelRequire("gTUcM");
var $75f650735467e244$var$builtinExec = RegExp.prototype.exec;
// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
$75f650735467e244$exports = function(R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if (typeof result !== 'object') throw new TypeError('RegExp exec method returned something other than an Object or null');
        return result;
    }
    if ($gTUcM(R) !== 'RegExp') throw new TypeError('RegExp#exec called on incompatible receiver');
    return $75f650735467e244$var$builtinExec.call(R, S);
};



// @@match logic
(parcelRequire("7MkNY"))('match', 1, function(defined, MATCH, $match, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = $cYx5q(regexp);
            var S = String(this);
            if (!rx.global) return $75f650735467e244$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $75f650735467e244$exports(rx, S)) !== null){
                var matchStr = String(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $00a2088a7540c748$exports(S, $6oAU6(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $cYx5q = parcelRequire("cYx5q");

var $60LZ2 = parcelRequire("60LZ2");

var $6oAU6 = parcelRequire("6oAU6");

var $8KZEi = parcelRequire("8KZEi");


var $9744ab0cd2a693de$var$max = Math.max;
var $9744ab0cd2a693de$var$min = Math.min;
var $9744ab0cd2a693de$var$floor = Math.floor;
var $9744ab0cd2a693de$var$SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var $9744ab0cd2a693de$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
var $9744ab0cd2a693de$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};

// @@replace logic
(parcelRequire("7MkNY"))('replace', 2, function(defined, REPLACE, $replace, maybeCallNative) {
    return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = $cYx5q(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $75f650735467e244$exports(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = String(result[0]);
                if (matchStr === '') rx.lastIndex = $00a2088a7540c748$exports(S, $6oAU6(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = String(result[0]);
                var position = $9744ab0cd2a693de$var$max($9744ab0cd2a693de$var$min($8KZEi(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($9744ab0cd2a693de$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = String(replaceValue.apply(undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
    // https://tc39.github.io/ecma262/#sec-getsubstitution
    function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = $9744ab0cd2a693de$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
            namedCaptures = $60LZ2(namedCaptures);
            symbols = $9744ab0cd2a693de$var$SUBSTITUTION_SYMBOLS;
        }
        return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch(ch.charAt(0)){
                case '$':
                    return '$';
                case '&':
                    return matched;
                case '`':
                    return str.slice(0, position);
                case "'":
                    return str.slice(tailPos);
                case '<':
                    capture = namedCaptures[ch.slice(1, -1)];
                    break;
                default:
                    var n = +ch;
                    if (n === 0) return match;
                    if (n > m) {
                        var f = $9744ab0cd2a693de$var$floor(n / 10);
                        if (f === 0) return match;
                        if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                    }
                    capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
        });
    }
});


'use strict';

var $cYx5q = parcelRequire("cYx5q");

var $3N3vf = parcelRequire("3N3vf");


// @@search logic
(parcelRequire("7MkNY"))('search', 1, function(defined, SEARCH, $search, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = $cYx5q(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!$3N3vf(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $75f650735467e244$exports(rx, S);
            if (!$3N3vf(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';


var $cYx5q = parcelRequire("cYx5q");

var $jHqVA = parcelRequire("jHqVA");


var $6oAU6 = parcelRequire("6oAU6");


var $2F0oV = parcelRequire("2F0oV");

var $as1c7 = parcelRequire("as1c7");
var $7cc21b008cb7c522$var$$min = Math.min;
var $7cc21b008cb7c522$var$$push = [].push;
var $7cc21b008cb7c522$var$$SPLIT = 'split';
var $7cc21b008cb7c522$var$LENGTH = 'length';
var $7cc21b008cb7c522$var$LAST_INDEX = 'lastIndex';
var $7cc21b008cb7c522$var$MAX_UINT32 = 0xffffffff;
// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var $7cc21b008cb7c522$var$SUPPORTS_Y = !$as1c7(function() {
    RegExp($7cc21b008cb7c522$var$MAX_UINT32, 'y');
});

// @@split logic
(parcelRequire("7MkNY"))('split', 2, function(defined, SPLIT, $split, maybeCallNative) {
    var internalSplit;
    if ('abbc'[$7cc21b008cb7c522$var$$SPLIT](/(b)*/)[1] == 'c' || 'test'[$7cc21b008cb7c522$var$$SPLIT](/(?:)/, -1)[$7cc21b008cb7c522$var$LENGTH] != 4 || 'ab'[$7cc21b008cb7c522$var$$SPLIT](/(?:ab)*/)[$7cc21b008cb7c522$var$LENGTH] != 2 || '.'[$7cc21b008cb7c522$var$$SPLIT](/(.?)(.?)/)[$7cc21b008cb7c522$var$LENGTH] != 4 || '.'[$7cc21b008cb7c522$var$$SPLIT](/()()/)[$7cc21b008cb7c522$var$LENGTH] > 1 || ''[$7cc21b008cb7c522$var$$SPLIT](/.?/)[$7cc21b008cb7c522$var$LENGTH]) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        // If `separator` is not a regex, use native split
        if (!$51c8b46ff212d7eb$exports(separator)) return $split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? $7cc21b008cb7c522$var$MAX_UINT32 : limit >>> 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while(match = $2F0oV.call(separatorCopy, string)){
            lastIndex = separatorCopy[$7cc21b008cb7c522$var$LAST_INDEX];
            if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[$7cc21b008cb7c522$var$LENGTH] > 1 && match.index < string[$7cc21b008cb7c522$var$LENGTH]) $7cc21b008cb7c522$var$$push.apply(output, match.slice(1));
                lastLength = match[0][$7cc21b008cb7c522$var$LENGTH];
                lastLastIndex = lastIndex;
                if (output[$7cc21b008cb7c522$var$LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[$7cc21b008cb7c522$var$LAST_INDEX] === match.index) separatorCopy[$7cc21b008cb7c522$var$LAST_INDEX]++; // Avoid an infinite loop
        }
        if (lastLastIndex === string[$7cc21b008cb7c522$var$LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output[$7cc21b008cb7c522$var$LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    else if ('0'[$7cc21b008cb7c522$var$$SPLIT](undefined, 0)[$7cc21b008cb7c522$var$LENGTH]) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
    else internalSplit = $split;
    return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = $cYx5q(regexp);
            var S = String(this);
            var C = $jHqVA(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($7cc21b008cb7c522$var$SUPPORTS_Y ? 'y' : 'g');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($7cc21b008cb7c522$var$SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? $7cc21b008cb7c522$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $75f650735467e244$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $7cc21b008cb7c522$var$SUPPORTS_Y ? q : 0;
                var z = $75f650735467e244$exports(splitter, $7cc21b008cb7c522$var$SUPPORTS_Y ? S : S.slice(q));
                var e;
                if (z === null || (e = $7cc21b008cb7c522$var$$min($6oAU6(splitter.lastIndex + ($7cc21b008cb7c522$var$SUPPORTS_Y ? 0 : q)), S.length)) === p) q = $00a2088a7540c748$exports(S, q, unicodeMatching);
                else {
                    A.push(S.slice(p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        A.push(z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            A.push(S.slice(p));
            return A;
        }
    ];
});


'use strict';

var $8N1Ra = parcelRequire("8N1Ra");

var $fRJfg = parcelRequire("fRJfg");

var $bKCrG = parcelRequire("bKCrG");

var $gTUcM = parcelRequire("gTUcM");

var $e88d0 = parcelRequire("e88d0");

var $a8jEg = parcelRequire("a8jEg");

var $3fVrL = parcelRequire("3fVrL");

var $2gG2X = parcelRequire("2gG2X");

var $k17JG = parcelRequire("k17JG");

var $jHqVA = parcelRequire("jHqVA");

var $bFqCF = parcelRequire("bFqCF");
var $869b366a615b2851$require$task = $bFqCF.set;

var $869b366a615b2851$var$microtask = (parcelRequire("4LikV"))();
var $4b9c5acb115e89f5$exports = {};

$parcel$export($4b9c5acb115e89f5$exports, "f", () => $4b9c5acb115e89f5$export$2d1720544b23b823, (v) => $4b9c5acb115e89f5$export$2d1720544b23b823 = v);
var $4b9c5acb115e89f5$export$2d1720544b23b823;
'use strict';

var $3fVrL = parcelRequire("3fVrL");
function $4b9c5acb115e89f5$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $3fVrL(resolve);
    this.reject = $3fVrL(reject);
}
$4b9c5acb115e89f5$export$2d1720544b23b823 = function(C) {
    return new $4b9c5acb115e89f5$var$PromiseCapability(C);
};


var $10dc095fec71510a$exports = {};
$10dc095fec71510a$exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};


var $42ebb6f7877fc04a$exports = {};

var $fRJfg = parcelRequire("fRJfg");
var $42ebb6f7877fc04a$var$navigator = $fRJfg.navigator;
$42ebb6f7877fc04a$exports = $42ebb6f7877fc04a$var$navigator && $42ebb6f7877fc04a$var$navigator.userAgent || '';


var $eb7667a604b79307$exports = {};

var $cYx5q = parcelRequire("cYx5q");

var $a8jEg = parcelRequire("a8jEg");

$eb7667a604b79307$exports = function(C, x) {
    $cYx5q(C);
    if ($a8jEg(x) && x.constructor === C) return x;
    var promiseCapability = $4b9c5acb115e89f5$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $869b366a615b2851$var$PROMISE = 'Promise';
var $869b366a615b2851$var$TypeError = $fRJfg.TypeError;
var $869b366a615b2851$var$process = $fRJfg.process;
var $869b366a615b2851$var$versions = $869b366a615b2851$var$process && $869b366a615b2851$var$process.versions;
var $869b366a615b2851$var$v8 = $869b366a615b2851$var$versions && $869b366a615b2851$var$versions.v8 || '';
var $869b366a615b2851$var$$Promise = $fRJfg[$869b366a615b2851$var$PROMISE];
var $869b366a615b2851$var$isNode = $gTUcM($869b366a615b2851$var$process) == 'process';
var $869b366a615b2851$var$empty = function() {};
var $869b366a615b2851$var$Internal, $869b366a615b2851$var$newGenericPromiseCapability, $869b366a615b2851$var$OwnPromiseCapability, $869b366a615b2851$var$Wrapper;
var $869b366a615b2851$var$newPromiseCapability = $869b366a615b2851$var$newGenericPromiseCapability = $4b9c5acb115e89f5$export$2d1720544b23b823;

var $869b366a615b2851$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $869b366a615b2851$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("fjK8l"))('species')] = function(exec) {
            exec($869b366a615b2851$var$empty, $869b366a615b2851$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($869b366a615b2851$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($869b366a615b2851$var$empty) instanceof FakePromise && $869b366a615b2851$var$v8.indexOf('6.6') !== 0 && $42ebb6f7877fc04a$exports.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $869b366a615b2851$var$isThenable = function(it) {
    var then;
    return $a8jEg(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $869b366a615b2851$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $869b366a615b2851$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $869b366a615b2851$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($869b366a615b2851$var$TypeError('Promise-chain cycle'));
                    else if (then = $869b366a615b2851$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $869b366a615b2851$var$onUnhandled(promise);
    });
};
var $869b366a615b2851$var$onUnhandled = function(promise) {
    $869b366a615b2851$require$task.call($fRJfg, function() {
        var value = promise._v;
        var unhandled = $869b366a615b2851$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $10dc095fec71510a$exports(function() {
                if ($869b366a615b2851$var$isNode) $869b366a615b2851$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $fRJfg.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $fRJfg.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $869b366a615b2851$var$isNode || $869b366a615b2851$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $869b366a615b2851$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $869b366a615b2851$var$onHandleUnhandled = function(promise) {
    $869b366a615b2851$require$task.call($fRJfg, function() {
        var handler;
        if ($869b366a615b2851$var$isNode) $869b366a615b2851$var$process.emit('rejectionHandled', promise);
        else if (handler = $fRJfg.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $869b366a615b2851$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $869b366a615b2851$var$notify(promise, true);
};
var $869b366a615b2851$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $869b366a615b2851$var$TypeError("Promise can't be resolved itself");
        if (then = $869b366a615b2851$var$isThenable(value)) $869b366a615b2851$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $bKCrG($869b366a615b2851$var$$resolve, wrapper, 1), $bKCrG($869b366a615b2851$var$$reject, wrapper, 1));
            } catch (e) {
                $869b366a615b2851$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $869b366a615b2851$var$notify(promise, false);
        }
    } catch (e) {
        $869b366a615b2851$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$869b366a615b2851$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $869b366a615b2851$var$$Promise = function Promise(executor) {
        $2gG2X(this, $869b366a615b2851$var$$Promise, $869b366a615b2851$var$PROMISE, '_h');
        $3fVrL(executor);
        $869b366a615b2851$var$Internal.call(this);
        try {
            executor($bKCrG($869b366a615b2851$var$$resolve, this, 1), $bKCrG($869b366a615b2851$var$$reject, this, 1));
        } catch (err) {
            $869b366a615b2851$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $869b366a615b2851$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $869b366a615b2851$var$Internal.prototype = (parcelRequire("j7N7T"))($869b366a615b2851$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $869b366a615b2851$var$newPromiseCapability($jHqVA(this, $869b366a615b2851$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $869b366a615b2851$var$isNode ? $869b366a615b2851$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $869b366a615b2851$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $869b366a615b2851$var$OwnPromiseCapability = function() {
        var promise = new $869b366a615b2851$var$Internal();
        this.promise = promise;
        this.resolve = $bKCrG($869b366a615b2851$var$$resolve, promise, 1);
        this.reject = $bKCrG($869b366a615b2851$var$$reject, promise, 1);
    };
    $4b9c5acb115e89f5$exports.f = $869b366a615b2851$var$newPromiseCapability = function(C) {
        return C === $869b366a615b2851$var$$Promise || C === $869b366a615b2851$var$Wrapper ? new $869b366a615b2851$var$OwnPromiseCapability(C) : $869b366a615b2851$var$newGenericPromiseCapability(C);
    };
}
$e88d0($e88d0.G + $e88d0.W + $e88d0.F * !$869b366a615b2851$var$USE_NATIVE, {
    Promise: $869b366a615b2851$var$$Promise
});

(parcelRequire("7jOVX"))($869b366a615b2851$var$$Promise, $869b366a615b2851$var$PROMISE);

(parcelRequire("dQX1C"))($869b366a615b2851$var$PROMISE);

$869b366a615b2851$var$Wrapper = (parcelRequire("6OFbT"))[$869b366a615b2851$var$PROMISE];
// statics
$e88d0($e88d0.S + $e88d0.F * !$869b366a615b2851$var$USE_NATIVE, $869b366a615b2851$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $869b366a615b2851$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$e88d0($e88d0.S + $e88d0.F * ($8N1Ra || !$869b366a615b2851$var$USE_NATIVE), $869b366a615b2851$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $eb7667a604b79307$exports($8N1Ra && this === $869b366a615b2851$var$Wrapper ? $869b366a615b2851$var$$Promise : this, x);
    }
});

$e88d0($e88d0.S + $e88d0.F * !($869b366a615b2851$var$USE_NATIVE && (parcelRequire("6W0vs"))(function(iter) {
    $869b366a615b2851$var$$Promise.all(iter)['catch']($869b366a615b2851$var$empty);
})), $869b366a615b2851$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $869b366a615b2851$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $10dc095fec71510a$exports(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $k17JG(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $869b366a615b2851$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $10dc095fec71510a$exports(function() {
            $k17JG(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});


var $de4b064f06c2a4b5$exports = {};
'use strict';
var $6e63158f4c91a434$exports = {};
'use strict';

var $hjnWf = parcelRequire("hjnWf");
var $6e63158f4c91a434$require$dP = $hjnWf.f;

var $9lrow = parcelRequire("9lrow");

var $j7N7T = parcelRequire("j7N7T");

var $bKCrG = parcelRequire("bKCrG");

var $2gG2X = parcelRequire("2gG2X");

var $k17JG = parcelRequire("k17JG");

var $k0W9G = parcelRequire("k0W9G");

var $1gUOu = parcelRequire("1gUOu");

var $dQX1C = parcelRequire("dQX1C");

var $8csIg = parcelRequire("8csIg");

var $nFBKj = parcelRequire("nFBKj");
var $6e63158f4c91a434$require$fastKey = $nFBKj.fastKey;

var $j26DO = parcelRequire("j26DO");
var $6e63158f4c91a434$var$SIZE = $8csIg ? '_s' : 'size';
var $6e63158f4c91a434$var$getEntry = function(that, key) {
    // fast case
    var index = $6e63158f4c91a434$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$6e63158f4c91a434$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $2gG2X(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $9lrow(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$6e63158f4c91a434$var$SIZE] = 0; // size
            if (iterable != undefined) $k17JG(iterable, IS_MAP, that[ADDER], that);
        });
        $j7N7T(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $j26DO(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$6e63158f4c91a434$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $j26DO(this, NAME);
                var entry = $6e63158f4c91a434$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$6e63158f4c91a434$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $j26DO(this, NAME);
                var f = $bKCrG(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$6e63158f4c91a434$var$getEntry($j26DO(this, NAME), key);
            }
        });
        if ($8csIg) $6e63158f4c91a434$require$dP(C.prototype, 'size', {
            get: function() {
                return $j26DO(this, NAME)[$6e63158f4c91a434$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $6e63158f4c91a434$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $6e63158f4c91a434$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$6e63158f4c91a434$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $6e63158f4c91a434$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $k0W9G(C, NAME, function(iterated, kind) {
            this._t = $j26DO(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $1gUOu(1);
            }
            // return step by kind
            if (kind == 'keys') return $1gUOu(0, entry.k);
            if (kind == 'values') return $1gUOu(0, entry.v);
            return $1gUOu(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $dQX1C(NAME);
    }
};



var $j26DO = parcelRequire("j26DO");
var $de4b064f06c2a4b5$var$MAP = 'Map';

// 23.1 Map Objects
$de4b064f06c2a4b5$exports = (parcelRequire("hGsNI"))($de4b064f06c2a4b5$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $6e63158f4c91a434$exports.getEntry($j26DO(this, $de4b064f06c2a4b5$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $6e63158f4c91a434$exports.def($j26DO(this, $de4b064f06c2a4b5$var$MAP), key === 0 ? 0 : key, value);
    }
}, $6e63158f4c91a434$exports, true);


var $098b52086a739cd0$exports = {};
'use strict';


var $j26DO = parcelRequire("j26DO");
var $098b52086a739cd0$var$SET = 'Set';

// 23.2 Set Objects
$098b52086a739cd0$exports = (parcelRequire("hGsNI"))($098b52086a739cd0$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $6e63158f4c91a434$exports.def($j26DO(this, $098b52086a739cd0$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $6e63158f4c91a434$exports);


parcelRequire("fEM2o");
'use strict';

var $bd8zE = parcelRequire("bd8zE");

var $j26DO = parcelRequire("j26DO");
var $bb8df8365116012c$var$WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
(parcelRequire("hGsNI"))($bb8df8365116012c$var$WEAK_SET, function(get) {
    return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
        return $bd8zE.def($j26DO(this, $bb8df8365116012c$var$WEAK_SET), value, true);
    }
}, $bd8zE, false, true);


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $4mWd7 = parcelRequire("4mWd7");

var $hjcH4 = parcelRequire("hjcH4");

var $cYx5q = parcelRequire("cYx5q");

var $79CKs = parcelRequire("79CKs");

var $6oAU6 = parcelRequire("6oAU6");

var $a8jEg = parcelRequire("a8jEg");

var $fRJfg = parcelRequire("fRJfg");
var $ddabc306e96c2ff9$require$ArrayBuffer = $fRJfg.ArrayBuffer;

var $jHqVA = parcelRequire("jHqVA");
var $ddabc306e96c2ff9$var$$ArrayBuffer = $hjcH4.ArrayBuffer;
var $ddabc306e96c2ff9$var$$DataView = $hjcH4.DataView;
var $ddabc306e96c2ff9$var$$isView = $4mWd7.ABV && $ddabc306e96c2ff9$require$ArrayBuffer.isView;
var $ddabc306e96c2ff9$var$$slice = $ddabc306e96c2ff9$var$$ArrayBuffer.prototype.slice;
var $ddabc306e96c2ff9$var$VIEW = $4mWd7.VIEW;
var $ddabc306e96c2ff9$var$ARRAY_BUFFER = 'ArrayBuffer';
$e88d0($e88d0.G + $e88d0.W + $e88d0.F * ($ddabc306e96c2ff9$require$ArrayBuffer !== $ddabc306e96c2ff9$var$$ArrayBuffer), {
    ArrayBuffer: $ddabc306e96c2ff9$var$$ArrayBuffer
});
$e88d0($e88d0.S + $e88d0.F * !$4mWd7.CONSTR, $ddabc306e96c2ff9$var$ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
        return $ddabc306e96c2ff9$var$$isView && $ddabc306e96c2ff9$var$$isView(it) || $a8jEg(it) && $ddabc306e96c2ff9$var$VIEW in it;
    }
});

$e88d0($e88d0.P + $e88d0.U + $e88d0.F * (parcelRequire("as1c7"))(function() {
    return !new $ddabc306e96c2ff9$var$$ArrayBuffer(2).slice(1, undefined).byteLength;
}), $ddabc306e96c2ff9$var$ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
        if ($ddabc306e96c2ff9$var$$slice !== undefined && end === undefined) return $ddabc306e96c2ff9$var$$slice.call($cYx5q(this), start); // FF fix
        var len = $cYx5q(this).byteLength;
        var first = $79CKs(start, len);
        var fin = $79CKs(end === undefined ? len : end, len);
        var result = new ($jHqVA(this, $ddabc306e96c2ff9$var$$ArrayBuffer))($6oAU6(fin - first));
        var viewS = new $ddabc306e96c2ff9$var$$DataView(this);
        var viewT = new $ddabc306e96c2ff9$var$$DataView(result);
        var index = 0;
        while(first < fin)viewT.setUint8(index++, viewS.getUint8(first++));
        return result;
    }
});

(parcelRequire("dQX1C"))($ddabc306e96c2ff9$var$ARRAY_BUFFER);



var $e88d0 = parcelRequire("e88d0");


$e88d0($e88d0.G + $e88d0.W + $e88d0.F * !(parcelRequire("4mWd7")).ABV, {
    DataView: (parcelRequire("hjcH4")).DataView
});



(parcelRequire("6pwKG"))('Int8', 1, function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Uint8', 1, function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Uint8', 1, function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



(parcelRequire("6pwKG"))('Int16', 2, function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Uint16', 2, function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Int32', 4, function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Uint32', 4, function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Float32', 4, function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("6pwKG"))('Float64', 8, function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)

var $e88d0 = parcelRequire("e88d0");

var $3fVrL = parcelRequire("3fVrL");

var $cYx5q = parcelRequire("cYx5q");

var $3ab7345f31846aea$var$rApply = ((parcelRequire("fRJfg")).Reflect || {}).apply;
var $3ab7345f31846aea$var$fApply = Function.apply;

// MS Edge argumentsList argument is optional
$e88d0($e88d0.S + $e88d0.F * !(parcelRequire("as1c7"))(function() {
    $3ab7345f31846aea$var$rApply(function() {});
}), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
        var T = $3fVrL(target);
        var L = $cYx5q(argumentsList);
        return $3ab7345f31846aea$var$rApply ? $3ab7345f31846aea$var$rApply(T, thisArgument, L) : $3ab7345f31846aea$var$fApply.call(T, thisArgument, L);
    }
});


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])

var $e88d0 = parcelRequire("e88d0");

var $9lrow = parcelRequire("9lrow");

var $3fVrL = parcelRequire("3fVrL");

var $cYx5q = parcelRequire("cYx5q");

var $a8jEg = parcelRequire("a8jEg");

var $as1c7 = parcelRequire("as1c7");

var $ladkF = parcelRequire("ladkF");

var $a7f5dca3fa4094f7$var$rConstruct = ((parcelRequire("fRJfg")).Reflect || {}).construct;
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $a7f5dca3fa4094f7$var$NEW_TARGET_BUG = $as1c7(function() {
    function F() {}
    return !($a7f5dca3fa4094f7$var$rConstruct(function() {}, [], F) instanceof F);
});
var $a7f5dca3fa4094f7$var$ARGS_BUG = !$as1c7(function() {
    $a7f5dca3fa4094f7$var$rConstruct(function() {});
});
$e88d0($e88d0.S + $e88d0.F * ($a7f5dca3fa4094f7$var$NEW_TARGET_BUG || $a7f5dca3fa4094f7$var$ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args /* , newTarget */ ) {
        $3fVrL(Target);
        $cYx5q(args);
        var newTarget = arguments.length < 3 ? Target : $3fVrL(arguments[2]);
        if ($a7f5dca3fa4094f7$var$ARGS_BUG && !$a7f5dca3fa4094f7$var$NEW_TARGET_BUG) return $a7f5dca3fa4094f7$var$rConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $args.push.apply($args, args);
            return new ($ladkF.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $9lrow($a8jEg(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return $a8jEg(result) ? result : instance;
    }
});


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)

var $hjnWf = parcelRequire("hjnWf");

var $e88d0 = parcelRequire("e88d0");

var $cYx5q = parcelRequire("cYx5q");

var $h0Sfn = parcelRequire("h0Sfn");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$e88d0($e88d0.S + $e88d0.F * (parcelRequire("as1c7"))(function() {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty($hjnWf.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
}), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $cYx5q(target);
        propertyKey = $h0Sfn(propertyKey, true);
        $cYx5q(attributes);
        try {
            $hjnWf.f(target, propertyKey, attributes);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var $e88d0 = parcelRequire("e88d0");

var $6Vt7w = parcelRequire("6Vt7w");
var $c543dc409ecd0660$require$gOPD = $6Vt7w.f;

var $cYx5q = parcelRequire("cYx5q");
$e88d0($e88d0.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = $c543dc409ecd0660$require$gOPD($cYx5q(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $cYx5q = parcelRequire("cYx5q");
var $54513a04e757a45f$var$Enumerate = function(iterated) {
    this._t = $cYx5q(iterated); // target
    this._i = 0; // next index
    var keys = this._k = []; // keys
    var key;
    for(key in iterated)keys.push(key);
};

(parcelRequire("eyH2O"))($54513a04e757a45f$var$Enumerate, 'Object', function() {
    var that = this;
    var keys = that._k;
    var key;
    do {
        if (that._i >= keys.length) return {
            value: undefined,
            done: true
        };
    }while (!((key = keys[that._i++]) in that._t));
    return {
        value: key,
        done: false
    };
});
$e88d0($e88d0.S, 'Reflect', {
    enumerate: function enumerate(target) {
        return new $54513a04e757a45f$var$Enumerate(target);
    }
});


// 26.1.6 Reflect.get(target, propertyKey [, receiver])

var $6Vt7w = parcelRequire("6Vt7w");

var $eojdB = parcelRequire("eojdB");

var $fdFIW = parcelRequire("fdFIW");

var $e88d0 = parcelRequire("e88d0");

var $a8jEg = parcelRequire("a8jEg");

var $cYx5q = parcelRequire("cYx5q");
function $3f238f1a684a1ea2$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if ($cYx5q(target) === receiver) return target[propertyKey];
    if (desc = $6Vt7w.f(target, propertyKey)) return $fdFIW(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if ($a8jEg(proto = $eojdB(target))) return $3f238f1a684a1ea2$var$get(proto, propertyKey, receiver);
}
$e88d0($e88d0.S, 'Reflect', {
    get: $3f238f1a684a1ea2$var$get
});


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)

var $6Vt7w = parcelRequire("6Vt7w");

var $e88d0 = parcelRequire("e88d0");

var $cYx5q = parcelRequire("cYx5q");
$e88d0($e88d0.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $6Vt7w.f($cYx5q(target), propertyKey);
    }
});


// 26.1.8 Reflect.getPrototypeOf(target)

var $e88d0 = parcelRequire("e88d0");

var $eojdB = parcelRequire("eojdB");

var $cYx5q = parcelRequire("cYx5q");
$e88d0($e88d0.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
        return $eojdB($cYx5q(target));
    }
});


// 26.1.9 Reflect.has(target, propertyKey)

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Reflect', {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


// 26.1.10 Reflect.isExtensible(target)

var $e88d0 = parcelRequire("e88d0");

var $cYx5q = parcelRequire("cYx5q");
var $40f91948679a3ab9$var$$isExtensible = Object.isExtensible;
$e88d0($e88d0.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
        $cYx5q(target);
        return $40f91948679a3ab9$var$$isExtensible ? $40f91948679a3ab9$var$$isExtensible(target) : true;
    }
});


// 26.1.11 Reflect.ownKeys(target)

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Reflect', {
    ownKeys: (parcelRequire("6Gb4O"))
});


// 26.1.12 Reflect.preventExtensions(target)

var $e88d0 = parcelRequire("e88d0");

var $cYx5q = parcelRequire("cYx5q");
var $2e872f1983ee450b$var$$preventExtensions = Object.preventExtensions;
$e88d0($e88d0.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
        $cYx5q(target);
        try {
            if ($2e872f1983ee450b$var$$preventExtensions) $2e872f1983ee450b$var$$preventExtensions(target);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])

var $hjnWf = parcelRequire("hjnWf");

var $6Vt7w = parcelRequire("6Vt7w");

var $eojdB = parcelRequire("eojdB");

var $fdFIW = parcelRequire("fdFIW");

var $e88d0 = parcelRequire("e88d0");

var $3PFaa = parcelRequire("3PFaa");

var $cYx5q = parcelRequire("cYx5q");

var $a8jEg = parcelRequire("a8jEg");
function $3be1dabdb4e96211$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = $6Vt7w.f($cYx5q(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
        if ($a8jEg(proto = $eojdB(target))) return $3be1dabdb4e96211$var$set(proto, propertyKey, V, receiver);
        ownDesc = $3PFaa(0);
    }
    if ($fdFIW(ownDesc, 'value')) {
        if (ownDesc.writable === false || !$a8jEg(receiver)) return false;
        if (existingDescriptor = $6Vt7w.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $hjnWf.f(receiver, propertyKey, existingDescriptor);
        } else $hjnWf.f(receiver, propertyKey, $3PFaa(0, V));
        return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}
$e88d0($e88d0.S, 'Reflect', {
    set: $3be1dabdb4e96211$var$set
});


// 26.1.14 Reflect.setPrototypeOf(target, proto)

var $e88d0 = parcelRequire("e88d0");

var $c6KGM = parcelRequire("c6KGM");
if ($c6KGM) $e88d0($e88d0.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $c6KGM.check(target, proto);
        try {
            $c6KGM.set(target, proto);
            return true;
        } catch (e) {
            return false;
        }
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $1490b0798e4bd2d5$var$$includes = (parcelRequire("6zju3"))(true);
$e88d0($e88d0.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $1490b0798e4bd2d5$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("lwTuI"))('includes');


'use strict';

var $e88d0 = parcelRequire("e88d0");
var $0a5f67539faa9ac5$exports = {};
'use strict';

var $k2l0Y = parcelRequire("k2l0Y");

var $a8jEg = parcelRequire("a8jEg");

var $6oAU6 = parcelRequire("6oAU6");

var $bKCrG = parcelRequire("bKCrG");

var $0a5f67539faa9ac5$var$IS_CONCAT_SPREADABLE = (parcelRequire("fjK8l"))('isConcatSpreadable');
function $0a5f67539faa9ac5$var$flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $bKCrG(mapper, thisArg, 3) : false;
    var element, spreadable;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if ($a8jEg(element)) {
                spreadable = element[$0a5f67539faa9ac5$var$IS_CONCAT_SPREADABLE];
                spreadable = spreadable !== undefined ? !!spreadable : $k2l0Y(element);
            }
            if (spreadable && depth > 0) targetIndex = $0a5f67539faa9ac5$var$flattenIntoArray(target, original, element, $6oAU6(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
}
$0a5f67539faa9ac5$exports = $0a5f67539faa9ac5$var$flattenIntoArray;



var $60LZ2 = parcelRequire("60LZ2");

var $6oAU6 = parcelRequire("6oAU6");

var $3fVrL = parcelRequire("3fVrL");

var $7zU3P = parcelRequire("7zU3P");
$e88d0($e88d0.P, 'Array', {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $60LZ2(this);
        var sourceLen, A;
        $3fVrL(callbackfn);
        sourceLen = $6oAU6(O.length);
        A = $7zU3P(O, 0);
        $0a5f67539faa9ac5$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
    }
});

(parcelRequire("lwTuI"))('flatMap');


'use strict';

var $e88d0 = parcelRequire("e88d0");


var $60LZ2 = parcelRequire("60LZ2");

var $6oAU6 = parcelRequire("6oAU6");

var $8KZEi = parcelRequire("8KZEi");

var $7zU3P = parcelRequire("7zU3P");
$e88d0($e88d0.P, 'Array', {
    flatten: function flatten() {
        var depthArg = arguments[0];
        var O = $60LZ2(this);
        var sourceLen = $6oAU6(O.length);
        var A = $7zU3P(O, 0);
        $0a5f67539faa9ac5$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $8KZEi(depthArg));
        return A;
    }
});

(parcelRequire("lwTuI"))('flatten');


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $a2057e656e2c3107$var$$at = (parcelRequire("2TsAR"))(true);

var $as1c7 = parcelRequire("as1c7");
var $a2057e656e2c3107$var$FORCED = $as1c7(function() {
    return "\uD842\uDFB7".at(0) !== "\uD842\uDFB7";
});
$e88d0($e88d0.P + $e88d0.F * $a2057e656e2c3107$var$FORCED, 'String', {
    at: function at(pos) {
        return $a2057e656e2c3107$var$$at(this, pos);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");
var $6209d982b4f9eac1$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end

var $6oAU6 = parcelRequire("6oAU6");

var $1uiiY = parcelRequire("1uiiY");

var $iedom = parcelRequire("iedom");
$6209d982b4f9eac1$exports = function(that, maxLength, fillString, left) {
    var S = String($iedom(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = $6oAU6(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = $1uiiY.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
};



// https://github.com/zloirock/core-js/issues/280
var $297059852bb84e4a$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($42ebb6f7877fc04a$exports);
$e88d0($e88d0.P + $e88d0.F * $297059852bb84e4a$var$WEBKIT_BUG, 'String', {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $6209d982b4f9eac1$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");


// https://github.com/zloirock/core-js/issues/280
var $fe44ba8bccf4704d$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($42ebb6f7877fc04a$exports);
$e88d0($e88d0.P + $e88d0.F * $fe44ba8bccf4704d$var$WEBKIT_BUG, 'String', {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $6209d982b4f9eac1$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
});


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("glTQQ"))('trimLeft', function($trim) {
    return function trimLeft() {
        return $trim(this, 1);
    };
}, 'trimStart');


'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("glTQQ"))('trimRight', function($trim) {
    return function trimRight() {
        return $trim(this, 2);
    };
}, 'trimEnd');


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $iedom = parcelRequire("iedom");

var $6oAU6 = parcelRequire("6oAU6");


var $cYtFt = parcelRequire("cYtFt");
var $bcdb70fef85ddf5f$var$RegExpProto = RegExp.prototype;
var $bcdb70fef85ddf5f$var$$RegExpStringIterator = function(regexp, string) {
    this._r = regexp;
    this._s = string;
};

(parcelRequire("eyH2O"))($bcdb70fef85ddf5f$var$$RegExpStringIterator, 'RegExp String', function next() {
    var match = this._r.exec(this._s);
    return {
        value: match,
        done: match === null
    };
});
$e88d0($e88d0.P, 'String', {
    matchAll: function matchAll(regexp) {
        $iedom(this);
        if (!$51c8b46ff212d7eb$exports(regexp)) throw TypeError(regexp + ' is not a regexp!');
        var S = String(this);
        var flags = 'flags' in $bcdb70fef85ddf5f$var$RegExpProto ? String(regexp.flags) : $cYtFt.call(regexp);
        var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
        rx.lastIndex = $6oAU6(regexp.lastIndex);
        return new $bcdb70fef85ddf5f$var$$RegExpStringIterator(rx, S);
    }
});



(parcelRequire("afVtj"))('asyncIterator');



(parcelRequire("afVtj"))('observable');


// https://github.com/tc39/proposal-object-getownpropertydescriptors

var $e88d0 = parcelRequire("e88d0");

var $6Gb4O = parcelRequire("6Gb4O");

var $h1IuT = parcelRequire("h1IuT");

var $6Vt7w = parcelRequire("6Vt7w");

$e88d0($e88d0.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $h1IuT(object);
        var getDesc = $6Vt7w.f;
        var keys = $6Gb4O(O);
        var result = {};
        var i = 0;
        var key, desc;
        while(keys.length > i){
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) $5f8f189a9ef8edff$exports(result, key, desc);
        }
        return result;
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $e88d0 = parcelRequire("e88d0");

var $104e86c0222554b1$var$$values = (parcelRequire("1BSkJ"))(false);
$e88d0($e88d0.S, 'Object', {
    values: function values(it) {
        return $104e86c0222554b1$var$$values(it);
    }
});


// https://github.com/tc39/proposal-object-values-entries

var $e88d0 = parcelRequire("e88d0");

var $2d0c6efa00517eb0$var$$entries = (parcelRequire("1BSkJ"))(true);
$e88d0($e88d0.S, 'Object', {
    entries: function entries(it) {
        return $2d0c6efa00517eb0$var$$entries(it);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $3fVrL = parcelRequire("3fVrL");

var $hjnWf = parcelRequire("hjnWf");


// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
(parcelRequire("8csIg")) && $e88d0($e88d0.P + (parcelRequire("2V8Oi")), 'Object', {
    __defineGetter__: function __defineGetter__(P, getter) {
        $hjnWf.f($60LZ2(this), P, {
            get: $3fVrL(getter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $3fVrL = parcelRequire("3fVrL");

var $hjnWf = parcelRequire("hjnWf");


// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
(parcelRequire("8csIg")) && $e88d0($e88d0.P + (parcelRequire("2V8Oi")), 'Object', {
    __defineSetter__: function __defineSetter__(P, setter) {
        $hjnWf.f($60LZ2(this), P, {
            set: $3fVrL(setter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $h0Sfn = parcelRequire("h0Sfn");

var $eojdB = parcelRequire("eojdB");

var $6Vt7w = parcelRequire("6Vt7w");
var $63082c8cdd23f846$require$getOwnPropertyDescriptor = $6Vt7w.f;


// B.2.2.4 Object.prototype.__lookupGetter__(P)
(parcelRequire("8csIg")) && $e88d0($e88d0.P + (parcelRequire("2V8Oi")), 'Object', {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $60LZ2(this);
        var K = $h0Sfn(P, true);
        var D;
        do {
            if (D = $63082c8cdd23f846$require$getOwnPropertyDescriptor(O, K)) return D.get;
        }while (O = $eojdB(O));
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $60LZ2 = parcelRequire("60LZ2");

var $h0Sfn = parcelRequire("h0Sfn");

var $eojdB = parcelRequire("eojdB");

var $6Vt7w = parcelRequire("6Vt7w");
var $ce938098cead65bd$require$getOwnPropertyDescriptor = $6Vt7w.f;


// B.2.2.5 Object.prototype.__lookupSetter__(P)
(parcelRequire("8csIg")) && $e88d0($e88d0.P + (parcelRequire("2V8Oi")), 'Object', {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $60LZ2(this);
        var K = $h0Sfn(P, true);
        var D;
        do {
            if (D = $ce938098cead65bd$require$getOwnPropertyDescriptor(O, K)) return D.set;
        }while (O = $eojdB(O));
    }
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P + $e88d0.R, 'Map', {
    toJSON: (parcelRequire("8qrPW"))('Map')
});


// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.P + $e88d0.R, 'Set', {
    toJSON: (parcelRequire("8qrPW"))('Set')
});


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of

(parcelRequire("kM8Jz"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of

(parcelRequire("kM8Jz"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of

(parcelRequire("kM8Jz"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of

(parcelRequire("kM8Jz"))('WeakSet');


// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from

(parcelRequire("aWhSb"))('Map');


// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from

(parcelRequire("aWhSb"))('Set');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from

(parcelRequire("aWhSb"))('WeakMap');


// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from

(parcelRequire("aWhSb"))('WeakSet');


// https://github.com/tc39/proposal-global

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.G, {
    global: (parcelRequire("fRJfg"))
});


// https://github.com/tc39/proposal-global

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'System', {
    global: (parcelRequire("fRJfg"))
});


// https://github.com/ljharb/proposal-is-error

var $e88d0 = parcelRequire("e88d0");

var $gyczm = parcelRequire("gyczm");
$e88d0($e88d0.S, 'Error', {
    isError: function isError(it) {
        return $gyczm(it) === 'Error';
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    clamp: function clamp(x, lower, upper) {
        return Math.min(upper, Math.max(lower, x));
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    DEG_PER_RAD: Math.PI / 180
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");
var $3fb08ed32bf4a6d1$var$RAD_PER_DEG = 180 / Math.PI;
$e88d0($e88d0.S, 'Math', {
    degrees: function degrees(radians) {
        return radians * $3fb08ed32bf4a6d1$var$RAD_PER_DEG;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");

var $kvqJ5 = parcelRequire("kvqJ5");

var $6JdnZ = parcelRequire("6JdnZ");
$e88d0($e88d0.S, 'Math', {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $6JdnZ($kvqJ5(x, inLow, inHigh, outLow, outHigh));
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    imulh: function imulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    RAD_PER_DEG: 180 / Math.PI
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");
var $b1d722a16a1dc8e3$var$DEG_PER_RAD = Math.PI / 180;
$e88d0($e88d0.S, 'Math', {
    radians: function radians(degrees) {
        return degrees * $b1d722a16a1dc8e3$var$DEG_PER_RAD;
    }
});


// https://rwaldron.github.io/proposal-math-extensions/

var $e88d0 = parcelRequire("e88d0");

$e88d0($e88d0.S, 'Math', {
    scale: (parcelRequire("kvqJ5"))
});


// https://gist.github.com/BrendanEich/4294d5c212a6d2254703

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    umulh: function umulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


// http://jfbastien.github.io/papers/Math.signbit.html

var $e88d0 = parcelRequire("e88d0");
$e88d0($e88d0.S, 'Math', {
    signbit: function signbit(x) {
        // eslint-disable-next-line no-self-compare
        return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
    }
});


// https://github.com/tc39/proposal-promise-finally
'use strict';

var $e88d0 = parcelRequire("e88d0");

var $6OFbT = parcelRequire("6OFbT");

var $fRJfg = parcelRequire("fRJfg");

var $jHqVA = parcelRequire("jHqVA");

$e88d0($e88d0.P + $e88d0.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $jHqVA(this, $6OFbT.Promise || $fRJfg.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $eb7667a604b79307$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $eb7667a604b79307$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");


$e88d0($e88d0.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $4b9c5acb115e89f5$export$2d1720544b23b823(this);
        var result = $10dc095fec71510a$exports(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});


var $d857d2730d651222$exports = {};


var $e88d0 = parcelRequire("e88d0");

var $d857d2730d651222$var$shared = (parcelRequire("lXpxg"))('metadata');

var $d857d2730d651222$var$store = $d857d2730d651222$var$shared.store || ($d857d2730d651222$var$shared.store = new (parcelRequire("fEM2o"))());
var $d857d2730d651222$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $d857d2730d651222$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return undefined;
        $d857d2730d651222$var$store.set(target, targetMetadata = new $de4b064f06c2a4b5$exports());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return undefined;
        targetMetadata.set(targetKey, keyMetadata = new $de4b064f06c2a4b5$exports());
    }
    return keyMetadata;
};
var $d857d2730d651222$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $d857d2730d651222$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $d857d2730d651222$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $d857d2730d651222$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $d857d2730d651222$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $d857d2730d651222$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $d857d2730d651222$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $d857d2730d651222$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        keys.push(key);
    });
    return keys;
};
var $d857d2730d651222$var$toMetaKey = function(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var $d857d2730d651222$var$exp = function(O) {
    $e88d0($e88d0.S, 'Reflect', O);
};
$d857d2730d651222$exports = {
    store: $d857d2730d651222$var$store,
    map: $d857d2730d651222$var$getOrCreateMetadataMap,
    has: $d857d2730d651222$var$ordinaryHasOwnMetadata,
    get: $d857d2730d651222$var$ordinaryGetOwnMetadata,
    set: $d857d2730d651222$var$ordinaryDefineOwnMetadata,
    keys: $d857d2730d651222$var$ordinaryOwnMetadataKeys,
    key: $d857d2730d651222$var$toMetaKey,
    exp: $d857d2730d651222$var$exp
};



var $cYx5q = parcelRequire("cYx5q");
var $05f72f5de8f98106$var$toMetaKey = $d857d2730d651222$exports.key;
var $05f72f5de8f98106$var$ordinaryDefineOwnMetadata = $d857d2730d651222$exports.set;
$d857d2730d651222$exports.exp({
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        $05f72f5de8f98106$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $cYx5q(target), $05f72f5de8f98106$var$toMetaKey(targetKey));
    }
});




var $cYx5q = parcelRequire("cYx5q");
var $b41d69f7f9cd5799$var$toMetaKey = $d857d2730d651222$exports.key;
var $b41d69f7f9cd5799$var$getOrCreateMetadataMap = $d857d2730d651222$exports.map;
var $b41d69f7f9cd5799$var$store = $d857d2730d651222$exports.store;
$d857d2730d651222$exports.exp({
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $b41d69f7f9cd5799$var$toMetaKey(arguments[2]);
        var metadataMap = $b41d69f7f9cd5799$var$getOrCreateMetadataMap($cYx5q(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $b41d69f7f9cd5799$var$store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || $b41d69f7f9cd5799$var$store['delete'](target);
    }
});




var $cYx5q = parcelRequire("cYx5q");

var $eojdB = parcelRequire("eojdB");
var $135063a041fc3aa8$var$ordinaryHasOwnMetadata = $d857d2730d651222$exports.has;
var $135063a041fc3aa8$var$ordinaryGetOwnMetadata = $d857d2730d651222$exports.get;
var $135063a041fc3aa8$var$toMetaKey = $d857d2730d651222$exports.key;
var $135063a041fc3aa8$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $135063a041fc3aa8$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $135063a041fc3aa8$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $eojdB(O);
    return parent !== null ? $135063a041fc3aa8$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
$d857d2730d651222$exports.exp({
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        return $135063a041fc3aa8$var$ordinaryGetMetadata(metadataKey, $cYx5q(target), arguments.length < 3 ? undefined : $135063a041fc3aa8$var$toMetaKey(arguments[2]));
    }
});




var $lDFri = parcelRequire("lDFri");


var $cYx5q = parcelRequire("cYx5q");

var $eojdB = parcelRequire("eojdB");
var $e5dfff0d999bd62f$var$ordinaryOwnMetadataKeys = $d857d2730d651222$exports.keys;
var $e5dfff0d999bd62f$var$toMetaKey = $d857d2730d651222$exports.key;
var $e5dfff0d999bd62f$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $e5dfff0d999bd62f$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $eojdB(O);
    if (parent === null) return oKeys;
    var pKeys = $e5dfff0d999bd62f$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $lDFri(new $098b52086a739cd0$exports(oKeys.concat(pKeys))) : pKeys : oKeys;
};
$d857d2730d651222$exports.exp({
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        return $e5dfff0d999bd62f$var$ordinaryMetadataKeys($cYx5q(target), arguments.length < 2 ? undefined : $e5dfff0d999bd62f$var$toMetaKey(arguments[1]));
    }
});




var $cYx5q = parcelRequire("cYx5q");
var $59806221f6ed1548$var$ordinaryGetOwnMetadata = $d857d2730d651222$exports.get;
var $59806221f6ed1548$var$toMetaKey = $d857d2730d651222$exports.key;
$d857d2730d651222$exports.exp({
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $59806221f6ed1548$var$ordinaryGetOwnMetadata(metadataKey, $cYx5q(target), arguments.length < 3 ? undefined : $59806221f6ed1548$var$toMetaKey(arguments[2]));
    }
});




var $cYx5q = parcelRequire("cYx5q");
var $c7cc2ed9dd65469c$var$ordinaryOwnMetadataKeys = $d857d2730d651222$exports.keys;
var $c7cc2ed9dd65469c$var$toMetaKey = $d857d2730d651222$exports.key;
$d857d2730d651222$exports.exp({
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        return $c7cc2ed9dd65469c$var$ordinaryOwnMetadataKeys($cYx5q(target), arguments.length < 2 ? undefined : $c7cc2ed9dd65469c$var$toMetaKey(arguments[1]));
    }
});




var $cYx5q = parcelRequire("cYx5q");

var $eojdB = parcelRequire("eojdB");
var $7de11058e8d5a0c4$var$ordinaryHasOwnMetadata = $d857d2730d651222$exports.has;
var $7de11058e8d5a0c4$var$toMetaKey = $d857d2730d651222$exports.key;
var $7de11058e8d5a0c4$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $7de11058e8d5a0c4$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $eojdB(O);
    return parent !== null ? $7de11058e8d5a0c4$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
$d857d2730d651222$exports.exp({
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        return $7de11058e8d5a0c4$var$ordinaryHasMetadata(metadataKey, $cYx5q(target), arguments.length < 3 ? undefined : $7de11058e8d5a0c4$var$toMetaKey(arguments[2]));
    }
});




var $cYx5q = parcelRequire("cYx5q");
var $7f4520b1b8ef5150$var$ordinaryHasOwnMetadata = $d857d2730d651222$exports.has;
var $7f4520b1b8ef5150$var$toMetaKey = $d857d2730d651222$exports.key;
$d857d2730d651222$exports.exp({
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        return $7f4520b1b8ef5150$var$ordinaryHasOwnMetadata(metadataKey, $cYx5q(target), arguments.length < 3 ? undefined : $7f4520b1b8ef5150$var$toMetaKey(arguments[2]));
    }
});




var $cYx5q = parcelRequire("cYx5q");

var $3fVrL = parcelRequire("3fVrL");
var $edf2e55a788ae2dd$var$toMetaKey = $d857d2730d651222$exports.key;
var $edf2e55a788ae2dd$var$ordinaryDefineOwnMetadata = $d857d2730d651222$exports.set;
$d857d2730d651222$exports.exp({
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, targetKey) {
            $edf2e55a788ae2dd$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? $cYx5q : $3fVrL)(target), $edf2e55a788ae2dd$var$toMetaKey(targetKey));
        };
    }
});


// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask

var $e88d0 = parcelRequire("e88d0");

var $7ce25bbd6df6c471$var$microtask = (parcelRequire("4LikV"))();

var $fRJfg = parcelRequire("fRJfg");
var $7ce25bbd6df6c471$require$process = $fRJfg.process;

var $7ce25bbd6df6c471$var$isNode = (parcelRequire("gyczm"))($7ce25bbd6df6c471$require$process) == 'process';
$e88d0($e88d0.G, {
    asap: function asap(fn) {
        var domain = $7ce25bbd6df6c471$var$isNode && $7ce25bbd6df6c471$require$process.domain;
        $7ce25bbd6df6c471$var$microtask(domain ? domain.bind(fn) : fn);
    }
});


'use strict';

var $e88d0 = parcelRequire("e88d0");

var $fRJfg = parcelRequire("fRJfg");

var $6OFbT = parcelRequire("6OFbT");

var $fb35fb3ba1316b39$var$microtask = (parcelRequire("4LikV"))();

var $fb35fb3ba1316b39$var$OBSERVABLE = (parcelRequire("fjK8l"))('observable');

var $3fVrL = parcelRequire("3fVrL");

var $cYx5q = parcelRequire("cYx5q");

var $2gG2X = parcelRequire("2gG2X");

var $j7N7T = parcelRequire("j7N7T");

var $5eEKu = parcelRequire("5eEKu");

var $k17JG = parcelRequire("k17JG");
var $fb35fb3ba1316b39$var$RETURN = $k17JG.RETURN;
var $fb35fb3ba1316b39$var$getMethod = function(fn) {
    return fn == null ? undefined : $3fVrL(fn);
};
var $fb35fb3ba1316b39$var$cleanupSubscription = function(subscription) {
    var cleanup = subscription._c;
    if (cleanup) {
        subscription._c = undefined;
        cleanup();
    }
};
var $fb35fb3ba1316b39$var$subscriptionClosed = function(subscription) {
    return subscription._o === undefined;
};
var $fb35fb3ba1316b39$var$closeSubscription = function(subscription) {
    if (!$fb35fb3ba1316b39$var$subscriptionClosed(subscription)) {
        subscription._o = undefined;
        $fb35fb3ba1316b39$var$cleanupSubscription(subscription);
    }
};
var $fb35fb3ba1316b39$var$Subscription = function(observer, subscriber) {
    $cYx5q(observer);
    this._c = undefined;
    this._o = observer;
    observer = new $fb35fb3ba1316b39$var$SubscriptionObserver(this);
    try {
        var cleanup = subscriber(observer);
        var subscription = cleanup;
        if (cleanup != null) {
            if (typeof cleanup.unsubscribe === 'function') cleanup = function() {
                subscription.unsubscribe();
            };
            else $3fVrL(cleanup);
            this._c = cleanup;
        }
    } catch (e) {
        observer.error(e);
        return;
    }
    if ($fb35fb3ba1316b39$var$subscriptionClosed(this)) $fb35fb3ba1316b39$var$cleanupSubscription(this);
};
$fb35fb3ba1316b39$var$Subscription.prototype = $j7N7T({}, {
    unsubscribe: function unsubscribe() {
        $fb35fb3ba1316b39$var$closeSubscription(this);
    }
});
var $fb35fb3ba1316b39$var$SubscriptionObserver = function(subscription) {
    this._s = subscription;
};
$fb35fb3ba1316b39$var$SubscriptionObserver.prototype = $j7N7T({}, {
    next: function next(value) {
        var subscription = this._s;
        if (!$fb35fb3ba1316b39$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            try {
                var m = $fb35fb3ba1316b39$var$getMethod(observer.next);
                if (m) return m.call(observer, value);
            } catch (e) {
                try {
                    $fb35fb3ba1316b39$var$closeSubscription(subscription);
                } finally{
                    throw e;
                }
            }
        }
    },
    error: function error(value) {
        var subscription = this._s;
        if ($fb35fb3ba1316b39$var$subscriptionClosed(subscription)) throw value;
        var observer = subscription._o;
        subscription._o = undefined;
        try {
            var m = $fb35fb3ba1316b39$var$getMethod(observer.error);
            if (!m) throw value;
            value = m.call(observer, value);
        } catch (e) {
            try {
                $fb35fb3ba1316b39$var$cleanupSubscription(subscription);
            } finally{
                throw e;
            }
        }
        $fb35fb3ba1316b39$var$cleanupSubscription(subscription);
        return value;
    },
    complete: function complete(value) {
        var subscription = this._s;
        if (!$fb35fb3ba1316b39$var$subscriptionClosed(subscription)) {
            var observer = subscription._o;
            subscription._o = undefined;
            try {
                var m = $fb35fb3ba1316b39$var$getMethod(observer.complete);
                value = m ? m.call(observer, value) : undefined;
            } catch (e) {
                try {
                    $fb35fb3ba1316b39$var$cleanupSubscription(subscription);
                } finally{
                    throw e;
                }
            }
            $fb35fb3ba1316b39$var$cleanupSubscription(subscription);
            return value;
        }
    }
});
var $fb35fb3ba1316b39$var$$Observable = function Observable(subscriber) {
    $2gG2X(this, $fb35fb3ba1316b39$var$$Observable, 'Observable', '_f')._f = $3fVrL(subscriber);
};
$j7N7T($fb35fb3ba1316b39$var$$Observable.prototype, {
    subscribe: function subscribe(observer) {
        return new $fb35fb3ba1316b39$var$Subscription(observer, this._f);
    },
    forEach: function forEach(fn) {
        var that = this;
        return new ($6OFbT.Promise || $fRJfg.Promise)(function(resolve, reject) {
            $3fVrL(fn);
            var subscription = that.subscribe({
                next: function(value) {
                    try {
                        return fn(value);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    }
});
$j7N7T($fb35fb3ba1316b39$var$$Observable, {
    from: function from(x) {
        var C = typeof this === 'function' ? this : $fb35fb3ba1316b39$var$$Observable;
        var method = $fb35fb3ba1316b39$var$getMethod($cYx5q(x)[$fb35fb3ba1316b39$var$OBSERVABLE]);
        if (method) {
            var observable = $cYx5q(method.call(x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        return new C(function(observer) {
            var done = false;
            $fb35fb3ba1316b39$var$microtask(function() {
                if (!done) {
                    try {
                        if ($k17JG(x, false, function(it) {
                            observer.next(it);
                            if (done) return $fb35fb3ba1316b39$var$RETURN;
                        }) === $fb35fb3ba1316b39$var$RETURN) return;
                    } catch (e) {
                        if (done) throw e;
                        observer.error(e);
                        return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    },
    of: function of() {
        for(var i = 0, l = arguments.length, items = new Array(l); i < l;)items[i] = arguments[i++];
        return new (typeof this === 'function' ? this : $fb35fb3ba1316b39$var$$Observable)(function(observer) {
            var done = false;
            $fb35fb3ba1316b39$var$microtask(function() {
                if (!done) {
                    for(var j = 0; j < items.length; ++j){
                        observer.next(items[j]);
                        if (done) return;
                    }
                    observer.complete();
                }
            });
            return function() {
                done = true;
            };
        });
    }
});
$5eEKu($fb35fb3ba1316b39$var$$Observable.prototype, $fb35fb3ba1316b39$var$OBSERVABLE, function() {
    return this;
});
$e88d0($e88d0.G, {
    Observable: $fb35fb3ba1316b39$var$$Observable
});

(parcelRequire("dQX1C"))('Observable');


// ie9- setTimeout & setInterval additional parameters fix

var $fRJfg = parcelRequire("fRJfg");

var $e88d0 = parcelRequire("e88d0");

var $3bf8c628b7259a4a$var$slice = [].slice;
var $3bf8c628b7259a4a$var$MSIE = /MSIE .\./.test($42ebb6f7877fc04a$exports); // <- dirty ie9- check
var $3bf8c628b7259a4a$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $3bf8c628b7259a4a$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$e88d0($e88d0.G + $e88d0.B + $e88d0.F * $3bf8c628b7259a4a$var$MSIE, {
    setTimeout: $3bf8c628b7259a4a$var$wrap($fRJfg.setTimeout),
    setInterval: $3bf8c628b7259a4a$var$wrap($fRJfg.setInterval)
});



var $e88d0 = parcelRequire("e88d0");

var $bFqCF = parcelRequire("bFqCF");
$e88d0($e88d0.G + $e88d0.B, {
    setImmediate: $bFqCF.set,
    clearImmediate: $bFqCF.clear
});



var $2jMtE = parcelRequire("2jMtE");

var $gHcyI = parcelRequire("gHcyI");

var $4ELbO = parcelRequire("4ELbO");

var $fRJfg = parcelRequire("fRJfg");

var $5eEKu = parcelRequire("5eEKu");

var $eKE8G = parcelRequire("eKE8G");

var $fjK8l = parcelRequire("fjK8l");
var $993cb7e31972d384$var$ITERATOR = $fjK8l('iterator');
var $993cb7e31972d384$var$TO_STRING_TAG = $fjK8l('toStringTag');
var $993cb7e31972d384$var$ArrayValues = $eKE8G.Array;
var $993cb7e31972d384$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $993cb7e31972d384$var$collections = $gHcyI($993cb7e31972d384$var$DOMIterables), $993cb7e31972d384$var$i = 0; $993cb7e31972d384$var$i < $993cb7e31972d384$var$collections.length; $993cb7e31972d384$var$i++){
    var $993cb7e31972d384$var$NAME = $993cb7e31972d384$var$collections[$993cb7e31972d384$var$i];
    var $993cb7e31972d384$var$explicit = $993cb7e31972d384$var$DOMIterables[$993cb7e31972d384$var$NAME];
    var $993cb7e31972d384$var$Collection = $fRJfg[$993cb7e31972d384$var$NAME];
    var $993cb7e31972d384$var$proto = $993cb7e31972d384$var$Collection && $993cb7e31972d384$var$Collection.prototype;
    var $993cb7e31972d384$var$key;
    if ($993cb7e31972d384$var$proto) {
        if (!$993cb7e31972d384$var$proto[$993cb7e31972d384$var$ITERATOR]) $5eEKu($993cb7e31972d384$var$proto, $993cb7e31972d384$var$ITERATOR, $993cb7e31972d384$var$ArrayValues);
        if (!$993cb7e31972d384$var$proto[$993cb7e31972d384$var$TO_STRING_TAG]) $5eEKu($993cb7e31972d384$var$proto, $993cb7e31972d384$var$TO_STRING_TAG, $993cb7e31972d384$var$NAME);
        $eKE8G[$993cb7e31972d384$var$NAME] = $993cb7e31972d384$var$ArrayValues;
        if ($993cb7e31972d384$var$explicit) {
            for($993cb7e31972d384$var$key in $2jMtE)if (!$993cb7e31972d384$var$proto[$993cb7e31972d384$var$key]) $4ELbO($993cb7e31972d384$var$proto, $993cb7e31972d384$var$key, $2jMtE[$993cb7e31972d384$var$key], true);
        }
    }
}



$e22f6ead04c39931$exports = (parcelRequire("6OFbT"));


var $5b6e91221499983c$exports = {};
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */ !function(global1) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = true;
    var runtime = global1.regeneratorRuntime;
    if (runtime) {
        if (inModule) // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        $5b6e91221499983c$exports = runtime;
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
    }
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global1.regeneratorRuntime = inModule ? $5b6e91221499983c$exports : {};
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self1, context);
        return generator;
    }
    runtime.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            prototype[method] = function(arg) {
                return this._invoke(method, arg);
            };
        });
    }
    runtime.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return Promise.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                }, reject);
            }
        }
        if (typeof global1.process === "object" && global1.process.domain) invoke = global1.process.domain.bind(invoke);
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    runtime.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self1, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self1, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self1, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    runtime.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    runtime.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
}(// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
typeof $parcel$global === "object" ? $parcel$global : typeof window === "object" ? window : typeof self === "object" ? self : $5b6e91221499983c$exports);


var $cfb4b82b6c9c68af$exports = {};
// https://github.com/benjamingr/RexExp.escape

var $e88d0 = parcelRequire("e88d0");

var $c77361c80d1b0cb0$var$$re = (parcelRequire("1JDbu"))(/[\\^$*+?.()|[\]{}]/g, '\\$&');
$e88d0($e88d0.S, 'RegExp', {
    escape: function escape(it) {
        return $c77361c80d1b0cb0$var$$re(it);
    }
});



$cfb4b82b6c9c68af$exports = (parcelRequire("6OFbT")).RegExp.escape;


if ($parcel$global._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");
$parcel$global._babelPolyfill = true;
var $178fad2d033e4f2f$var$DEFINE_PROPERTY = "defineProperty";
function $178fad2d033e4f2f$var$define(O, key, value) {
    O[key] || Object[$178fad2d033e4f2f$var$DEFINE_PROPERTY](O, key, {
        writable: true,
        configurable: true,
        value: value
    });
}
$178fad2d033e4f2f$var$define(String.prototype, "padLeft", "".padStart);
$178fad2d033e4f2f$var$define(String.prototype, "padRight", "".padEnd);
"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(key) {
    [][key] && $178fad2d033e4f2f$var$define(Array, key, Function.call.bind([][key]));
});


var $ce6a5d94e0bda3fb$exports = {};
'use strict';

$ce6a5d94e0bda3fb$exports = (parcelRequire("lfkdM"));


parcelRequire("bNh2M");
var $fe0364397da30eaa$export$882461b6382ed46c;
var $fe0364397da30eaa$export$757ceba2d55c277e;
'use strict';
var $7062565431c19451$exports = {};
'use strict';
function $7062565431c19451$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7062565431c19451$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7062565431c19451$var$checkDCE();

$7062565431c19451$exports = (parcelRequire("4JlCC"));


var $fe0364397da30eaa$var$i;
$fe0364397da30eaa$export$882461b6382ed46c = $7062565431c19451$exports.createRoot;
$fe0364397da30eaa$export$757ceba2d55c277e = $7062565431c19451$exports.hydrateRoot;





var $bNh2M = parcelRequire("bNh2M");
const $047030d75d5c8297$var$en = {
    home: {
        albumList: "Recent Albums",
        about: "About Notestand"
    },
    newAlbumFromURL: {
        description: "Put URL or a part of URL of Google Drive(tm) folder to create a new album.",
        placeholder: "example: drive.google.com/open?id=<Id Goes Here>",
        buttonLabel: "Create New Album"
    },
    menu: {
        openOriginal: "Open Original",
        closeScore: "Close This Score",
        toggleTheme: "Toggle Theme",
        copyCurrentUrl: "Copy Current URL",
        toastCopiedCurrentUrl: "Current URL was Copied to Clipboard"
    },
    account: {
        signIn: "Sign In with Google",
        signOut: "Sign Out"
    }
};
const $047030d75d5c8297$var$ja = {
    home: {
        albumList: "\u30A2\u30EB\u30D0\u30E0\u4E00\u89A7",
        about: "Notestand\u306B\u3064\u3044\u3066"
    },
    newAlbumFromURL: {
        description: "Google Drive\u306EURL\u307E\u305F\u306F\u305D\u306E\u4E00\u90E8\u304B\u3089\u30A2\u30EB\u30D0\u30E0\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002",
        placeholder: "\u4F8B: drive.google.com/open?id=<\u3053\u3053\u306BId\u304C\u5165\u308A\u307E\u3059>",
        buttonLabel: "\u30A2\u30EB\u30D0\u30E0\u3092\u4F5C\u6210"
    },
    menu: {
        openOriginal: "\u5143\u30D5\u30A1\u30A4\u30EB\u3092\u958B\u304F",
        closeScore: "\u697D\u8B5C\u3092\u9589\u3058\u308B",
        toggleTheme: "\u30C6\u30FC\u30DE\u3092\u5207\u308A\u66FF\u3048\u308B",
        copyCurrentUrl: "\u73FE\u5728\u306EURL\u3092\u30B3\u30D4\u30FC",
        toastCopiedCurrentUrl: "URL\u304C\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F"
    },
    account: {
        signIn: "Google\u3067\u30ED\u30B0\u30A4\u30F3",
        signOut: "\u30ED\u30B0\u30A2\u30A6\u30C8"
    }
};
const $047030d75d5c8297$var$zh_s = {
    home: {
        albumList: "\u8C31\u518C\u4E00\u89C8\u8868",
        about: "\u5173\u4E8ENotestand"
    },
    newAlbumFromURL: {
        description: "\u4ECEGoogle Drive\u7684URL\u6216URL\u4E00\u90E8\u5206, \u80FD\u5236\u4F5C\u8C31\u518C",
        placeholder: "\u4F8B: drive.google.com/open?id=<\u8FD9\u513FId>",
        buttonLabel: "\u5236\u4F5C\u8C31\u518C"
    },
    menu: {
        openOriginal: "\u6253\u5F00\u539F\u7248",
        closeScore: "\u5173\u8FD9\u4E2A\u4E50\u8C31",
        toggleTheme: "\u5F00\u5173\u4E3B\u9898",
        copyCurrentUrl: "\u590D\u5199\u73B0\u5728\u7684URL",
        toastCopiedCurrentUrl: "URL\u5230\u526A\u8D34\u677F\u590D\u5236\u4E86"
    },
    account: {
        signIn: "\u7528\u8C37\u6B4C\u6CE8\u518C",
        signOut: "\u6CE8\u9500"
    }
};
const $047030d75d5c8297$var$LocaleReadContext = /*#__PURE__*/ $bNh2M.createContext(undefined);
const $047030d75d5c8297$var$LocaleWriteContext = /*#__PURE__*/ $bNh2M.createContext((s)=>{
    localStorage.setItem("locale", s);
});
function $047030d75d5c8297$export$43bb16f9c6d9e3f7() {
    const locale = (0, $bNh2M.useContext)($047030d75d5c8297$var$LocaleReadContext);
    if (locale === undefined) return [
        $047030d75d5c8297$var$en,
        "en"
    ];
    const asset = {
        ja: $047030d75d5c8297$var$ja,
        "ch-CN": $047030d75d5c8297$var$zh_s
    }[locale] ?? $047030d75d5c8297$var$en;
    return [
        asset,
        locale
    ];
}
const $047030d75d5c8297$export$ff34e5addbd1eccb = ({ children: children })=>{
    const [locale, setLocale] = (0, $bNh2M.useState)("en");
    (0, $bNh2M.useEffect)(()=>{
        try {
            const l = localStorage.getItem("locale");
            if (!l) return;
            setLocale(l);
        } catch (e) {}
    }, []);
    (0, $bNh2M.useEffect)(()=>{
        document.body.setAttribute("lang", locale);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($047030d75d5c8297$var$LocaleWriteContext.Provider, {
        value: (s)=>{
            try {
                localStorage.setItem("locale", s);
            } catch (e) {}
            setLocale(s);
        },
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($047030d75d5c8297$var$LocaleReadContext.Provider, {
            value: locale,
            children: children
        })
    });
};
function $047030d75d5c8297$export$bdbc0c78cfd00496() {
    const setLocale = (0, $bNh2M.useContext)($047030d75d5c8297$var$LocaleWriteContext);
    return {
        setCurrentLocale: setLocale
    };
}



/// <reference types="gapi.client.drive-v3" />
/// <reference path="./google-identity.d.ts" />
/// <reference path="./gapi-client-gis.d.ts" />
function $e718d0a2e2d09f3a$export$5c069c93d2b7493f(ms) {
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve();
        }, ms);
    });
}
function $e718d0a2e2d09f3a$export$761f4adc3008ef1c(ms_fallback = 4000) {
    // @ts-ignore
    return window.requestIdleCallback ? new Promise((resolve, reject)=>{
        // @ts-ignore
        window.requestIdleCallback(()=>resolve());
    }) : $e718d0a2e2d09f3a$export$5c069c93d2b7493f(ms_fallback);
}
function $e718d0a2e2d09f3a$export$889ea624f2cb2c57(fn) {
    return fn();
}
function $e718d0a2e2d09f3a$export$9fd238990985ffcd(fn, spanMs) {
    const now = ()=>new Date().getTime();
    const time = now();
    return (...args)=>{
        if (now() - time > spanMs) return fn(...args);
    };
}


var $7c9b300c545ed81c$exports = {};
'use strict';
var $af085ae27cb2741e$exports = {};

$parcel$export($af085ae27cb2741e$exports, "INTERNAL_overrideCreateStore", () => $af085ae27cb2741e$export$cfdd58e14a91411a, (v) => $af085ae27cb2741e$export$cfdd58e14a91411a = v);
$parcel$export($af085ae27cb2741e$exports, "atom", () => $af085ae27cb2741e$export$5fb5cc0d078610b, (v) => $af085ae27cb2741e$export$5fb5cc0d078610b = v);
$parcel$export($af085ae27cb2741e$exports, "createStore", () => $af085ae27cb2741e$export$f51a9068ac82ea43, (v) => $af085ae27cb2741e$export$f51a9068ac82ea43 = v);
$parcel$export($af085ae27cb2741e$exports, "getDefaultStore", () => $af085ae27cb2741e$export$39b2e4393dfcb8aa, (v) => $af085ae27cb2741e$export$39b2e4393dfcb8aa = v);
var $af085ae27cb2741e$export$cfdd58e14a91411a;
var $af085ae27cb2741e$export$5fb5cc0d078610b;
var $af085ae27cb2741e$export$f51a9068ac82ea43;
var $af085ae27cb2741e$export$39b2e4393dfcb8aa;
'use strict';
var $8dc2d4c6187d1fef$export$82a1790dbcdcfc9f;
var $8dc2d4c6187d1fef$export$1b8bba60163162e5;
var $8dc2d4c6187d1fef$export$67edddd3275fb47c;
var $8dc2d4c6187d1fef$export$5454bef94246c3c;
var $8dc2d4c6187d1fef$export$23808a6f53e55c3;
var $8dc2d4c6187d1fef$export$a044c555aa9c2601;
var $8dc2d4c6187d1fef$export$7c24d1ef3bea9769;
var $8dc2d4c6187d1fef$export$33f6e9f7330dc7e3;
var $8dc2d4c6187d1fef$export$5ab0738ada359ec5;
var $8dc2d4c6187d1fef$export$696d075174b4543b;
var $8dc2d4c6187d1fef$export$488563b9c383d273;
'use strict';
function $8dc2d4c6187d1fef$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $8dc2d4c6187d1fef$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: true
            } : {
                done: false,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8dc2d4c6187d1fef$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8dc2d4c6187d1fef$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8dc2d4c6187d1fef$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8dc2d4c6187d1fef$var$hasInitialValue(atom) {
    return 'init' in atom;
}
function $8dc2d4c6187d1fef$var$isActuallyWritableAtom(atom) {
    return typeof atom.write === 'function';
}
function $8dc2d4c6187d1fef$var$hasOnMount(atom) {
    return !!atom.onMount;
}
function $8dc2d4c6187d1fef$var$isAtomStateInitialized(atomState) {
    return 'v' in atomState || 'e' in atomState;
}
function $8dc2d4c6187d1fef$var$returnAtomValue(atomState) {
    if ('e' in atomState) throw atomState.e;
    return atomState.v;
}
function $8dc2d4c6187d1fef$var$isPromiseLike(p) {
    return typeof (p == null ? void 0 : p.then) === 'function';
}
function $8dc2d4c6187d1fef$var$shouldThrowSynchronously(error) {
    if (!(error instanceof Error)) return false;
    var name = error.name;
    var message = error.message.toLowerCase();
    return (name === 'RangeError' || name === 'InternalError') && (message.includes('call stack') || message.includes('too much recursion') || message.includes('stack overflow'));
}
function $8dc2d4c6187d1fef$var$addPendingPromiseToDependency(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        var cleanup = function cleanup() {
            return dependencyAtomState.p.delete(atom);
        };
        promise.then(cleanup, cleanup);
    }
}
function $8dc2d4c6187d1fef$var$getMountedOrPendingDependents(atom, atomState, mountedMap) {
    var mounted = mountedMap.get(atom);
    var mountedDependents = mounted == null ? void 0 : mounted.t;
    var pendingDependents = atomState.p;
    if (!(mountedDependents != null && mountedDependents.size)) return pendingDependents;
    if (!pendingDependents.size) return mountedDependents;
    var dependents = new Set(mountedDependents);
    for(var _iterator = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(pendingDependents), _step; !(_step = _iterator()).done;){
        var a = _step.value;
        dependents.add(a);
    }
    return dependents;
}
var $8dc2d4c6187d1fef$var$createStoreHook = function createStoreHook() {
    var callbacks = new Set();
    var notify = function notify() {
        return callbacks.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(fn) {
        callbacks.add(fn);
        return function() {
            return callbacks.delete(fn);
        };
    };
    return notify;
};
var $8dc2d4c6187d1fef$var$createStoreHookForAtoms = function createStoreHookForAtoms() {
    var all = {};
    var callbacks = new WeakMap();
    var notify = function notify(atom) {
        var _callbacks$get, _callbacks$get2;
        (_callbacks$get = callbacks.get(all)) == null || _callbacks$get.forEach(function(fn) {
            return fn(atom);
        });
        (_callbacks$get2 = callbacks.get(atom)) == null || _callbacks$get2.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(atom, fn) {
        var key = atom || all;
        var fns = callbacks.get(key);
        if (!fns) {
            fns = new Set();
            callbacks.set(key, fns);
        }
        fns.add(fn);
        return function() {
            fns.delete(fn);
            if (!fns.size) callbacks.delete(key);
        };
    };
    return notify;
};
function $8dc2d4c6187d1fef$var$initializeStoreHooks(storeHooks) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _ref6;
    (_ref = storeHooks).i || (_ref.i = $8dc2d4c6187d1fef$var$createStoreHookForAtoms());
    (_ref2 = storeHooks).r || (_ref2.r = $8dc2d4c6187d1fef$var$createStoreHookForAtoms());
    (_ref3 = storeHooks).c || (_ref3.c = $8dc2d4c6187d1fef$var$createStoreHookForAtoms());
    (_ref4 = storeHooks).m || (_ref4.m = $8dc2d4c6187d1fef$var$createStoreHookForAtoms());
    (_ref5 = storeHooks).u || (_ref5.u = $8dc2d4c6187d1fef$var$createStoreHookForAtoms());
    (_ref6 = storeHooks).f || (_ref6.f = $8dc2d4c6187d1fef$var$createStoreHook());
    return storeHooks;
}
function $8dc2d4c6187d1fef$var$hasOnInit(atom) {
    return !!atom.INTERNAL_onInit;
}
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomRead = function BUILDING_BLOCK_atomRead(_buildingBlocks, _store, atom) {
    for(var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)params[_key - 3] = arguments[_key];
    return atom.read.apply(atom, params);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomWrite = function BUILDING_BLOCK_atomWrite(_buildingBlocks, _store, atom) {
    for(var _len2 = arguments.length, params = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)params[_key2 - 3] = arguments[_key2];
    return atom.write.apply(atom, params);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomOnInit = function BUILDING_BLOCK_atomOnInit(_buildingBlocks, store, atom) {
    return atom.INTERNAL_onInit(store);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomOnMount = function BUILDING_BLOCK_atomOnMount(_buildingBlocks, _store, atom, setAtom) {
    return atom.onMount == null ? void 0 : atom.onMount(setAtom);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_ensureAtomState = function BUILDING_BLOCK_ensureAtomState(buildingBlocks, store, atom) {
    var atomStateMap = buildingBlocks[0];
    var atomState = atomStateMap.get(atom);
    if (!atomState) {
        var _storeHooks = buildingBlocks[6];
        var _atomOnInit = buildingBlocks[9];
        atomState = {
            d: new Map(),
            p: new Set(),
            n: 0
        };
        atomStateMap.set(atom, atomState);
        _storeHooks.i == null || _storeHooks.i(atom);
        if ($8dc2d4c6187d1fef$var$hasOnInit(atom)) _atomOnInit(buildingBlocks, store, atom);
    }
    return atomState;
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_flushCallbacks = function BUILDING_BLOCK_flushCallbacks(buildingBlocks, store) {
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var mountCallbacks = buildingBlocks[4];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    if (!storeHooks.f && !changedAtoms.size && !mountCallbacks.size && !unmountCallbacks.size) return;
    var errors = [];
    var call = function call(fn) {
        try {
            fn();
        } catch (e) {
            errors.push(e);
        }
    };
    do {
        if (storeHooks.f) call(storeHooks.f);
        var callbacks = new Set();
        for(var _iterator2 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(changedAtoms), _step2; !(_step2 = _iterator2()).done;){
            var _mountedMap$get;
            var _atom = _step2.value;
            var listeners = (_mountedMap$get = mountedMap.get(_atom)) == null ? void 0 : _mountedMap$get.l;
            if (listeners) for(var _iterator6 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(listeners), _step6; !(_step6 = _iterator6()).done;){
                var _listener = _step6.value;
                callbacks.add(_listener);
            }
        }
        changedAtoms.clear();
        for(var _iterator3 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(unmountCallbacks), _step3; !(_step3 = _iterator3()).done;){
            var fn = _step3.value;
            callbacks.add(fn);
        }
        unmountCallbacks.clear();
        for(var _iterator4 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(mountCallbacks), _step4; !(_step4 = _iterator4()).done;){
            var _fn = _step4.value;
            callbacks.add(_fn);
        }
        mountCallbacks.clear();
        for(var _iterator5 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(callbacks), _step5; !(_step5 = _iterator5()).done;){
            var _fn2 = _step5.value;
            call(_fn2);
        }
        if (changedAtoms.size) recomputeInvalidatedAtoms(buildingBlocks, store);
    }while (changedAtoms.size || unmountCallbacks.size || mountCallbacks.size);
    if (errors.length) throw new AggregateError(errors);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_recomputeInvalidatedAtoms = function BUILDING_BLOCK_recomputeInvalidatedAtoms(buildingBlocks, store) {
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var ensureAtomState = buildingBlocks[11];
    var readAtomState = buildingBlocks[14];
    var mountDependencies = buildingBlocks[17];
    if (!changedAtoms.size) return;
    var sortedReversedAtoms = [];
    var sortedReversedStates = [];
    var visiting = new WeakSet();
    var visited = new WeakSet();
    var stackAtoms = [];
    var stackStates = [];
    for(var _iterator7 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(changedAtoms), _step7; !(_step7 = _iterator7()).done;){
        var _atom2 = _step7.value;
        stackAtoms.push(_atom2);
        stackStates.push(ensureAtomState(buildingBlocks, store, _atom2));
    }
    while(stackAtoms.length){
        var top = stackAtoms.length - 1;
        var a = stackAtoms[top];
        var aState = stackStates[top];
        if (visited.has(a)) {
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        if (visiting.has(a)) {
            if (invalidatedAtoms.get(a) === aState.n) {
                sortedReversedAtoms.push(a);
                sortedReversedStates.push(aState);
            }
            visited.add(a);
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        visiting.add(a);
        for(var _iterator8 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose($8dc2d4c6187d1fef$var$getMountedOrPendingDependents(a, aState, mountedMap)), _step8; !(_step8 = _iterator8()).done;){
            var d = _step8.value;
            if (!visiting.has(d)) {
                stackAtoms.push(d);
                stackStates.push(ensureAtomState(buildingBlocks, store, d));
            }
        }
    }
    for(var i = sortedReversedAtoms.length - 1; i >= 0; --i){
        var _a = sortedReversedAtoms[i];
        var _aState = sortedReversedStates[i];
        var hasChangedDeps = false;
        for(var _iterator9 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(_aState.d.keys()), _step9; !(_step9 = _iterator9()).done;){
            var dep = _step9.value;
            if (dep !== _a && changedAtoms.has(dep)) {
                hasChangedDeps = true;
                break;
            }
        }
        if (hasChangedDeps) {
            invalidatedAtoms.set(_a, _aState.n);
            readAtomState(buildingBlocks, store, _a);
            mountDependencies(buildingBlocks, store, _a);
        }
        invalidatedAtoms.delete(_a);
    }
};
var $8dc2d4c6187d1fef$var$storeMutationSet = new WeakSet();
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_readAtomState = function BUILDING_BLOCK_readAtomState(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomRead = buildingBlocks[7];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var writeAtomState = buildingBlocks[16];
    var mountDependencies = buildingBlocks[17];
    var setAtomStateValueOrPromise = buildingBlocks[20];
    var registerAbortHandler = buildingBlocks[26];
    var storeEpochHolder = buildingBlocks[28];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var storeEpochNumber = storeEpochHolder[0];
    if ($8dc2d4c6187d1fef$var$isAtomStateInitialized(atomState)) {
        if (mountedMap.has(atom) && invalidatedAtoms.get(atom) !== atomState.n || atomState.m === storeEpochNumber) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
        var hasChangedDeps = false;
        for(var _iterator0 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(atomState.d), _step0; !(_step0 = _iterator0()).done;){
            var _step0$value = _step0.value, a = _step0$value[0], _n = _step0$value[1];
            if (readAtomState(buildingBlocks, store, a).n !== _n) {
                hasChangedDeps = true;
                break;
            }
        }
        if (!hasChangedDeps) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
    }
    var isSync = true;
    var prevDeps = new Set(atomState.d.keys());
    var pruneDependencies = function pruneDependencies() {
        for(var _iterator1 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(prevDeps), _step1; !(_step1 = _iterator1()).done;){
            var _a2 = _step1.value;
            atomState.d.delete(_a2);
        }
    };
    var mountDependenciesIfAsync = function mountDependenciesIfAsync() {
        if (mountedMap.has(atom)) {
            var shouldRecompute = !changedAtoms.size;
            mountDependencies(buildingBlocks, store, atom);
            if (shouldRecompute) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    var getter = function getter(a) {
        if (a === atom) {
            var _aState2 = ensureAtomState(buildingBlocks, store, a);
            if (!$8dc2d4c6187d1fef$var$isAtomStateInitialized(_aState2)) {
                if ($8dc2d4c6187d1fef$var$hasInitialValue(a)) setAtomStateValueOrPromise(buildingBlocks, store, a, a.init);
                else throw new Error('no atom init');
            }
            return $8dc2d4c6187d1fef$var$returnAtomValue(_aState2);
        }
        var aState = readAtomState(buildingBlocks, store, a);
        try {
            return $8dc2d4c6187d1fef$var$returnAtomValue(aState);
        } finally{
            prevDeps.delete(a);
            atomState.d.set(a, aState.n);
            if ($8dc2d4c6187d1fef$var$isPromiseLike(atomState.v)) $8dc2d4c6187d1fef$var$addPendingPromiseToDependency(atom, atomState.v, aState);
            if (mountedMap.has(atom)) {
                var _mountedMap$get2;
                (_mountedMap$get2 = mountedMap.get(a)) == null || _mountedMap$get2.t.add(atom);
            }
            if (!isSync) mountDependenciesIfAsync();
        }
    };
    var controller;
    var setSelf;
    var options = {
        get signal () {
            if (!controller) controller = new AbortController();
            return controller.signal;
        },
        get setSelf () {
            if (!setSelf && $8dc2d4c6187d1fef$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                if (!isSync) try {
                    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                    return writeAtomState(buildingBlocks, store, atom, args);
                } finally{
                    recomputeInvalidatedAtoms(buildingBlocks, store);
                    flushCallbacks(buildingBlocks, store);
                }
            };
            return setSelf;
        }
    };
    var prevEpochNumber = atomState.n;
    var prevInvalidated = invalidatedAtoms.get(atom) === prevEpochNumber;
    try {
        var _valueOrPromise = atomRead(buildingBlocks, store, atom, getter, options);
        setAtomStateValueOrPromise(buildingBlocks, store, atom, _valueOrPromise);
        if ($8dc2d4c6187d1fef$var$isPromiseLike(_valueOrPromise)) {
            registerAbortHandler(buildingBlocks, store, _valueOrPromise, function() {
                var _controller;
                return (_controller = controller) == null ? void 0 : _controller.abort();
            });
            var settle = function settle() {
                pruneDependencies();
                mountDependenciesIfAsync();
            };
            _valueOrPromise.then(settle, settle);
        } else pruneDependencies();
        storeHooks.r == null || storeHooks.r(atom);
        atomState.m = storeEpochNumber;
        return atomState;
    } catch (error) {
        if ($8dc2d4c6187d1fef$var$shouldThrowSynchronously(error)) throw error;
        delete atomState.v;
        atomState.e = error;
        ++atomState.n;
        atomState.m = storeEpochNumber;
        return atomState;
    } finally{
        isSync = false;
        if (atomState.n !== prevEpochNumber && prevInvalidated) {
            invalidatedAtoms.set(atom, atomState.n);
            changedAtoms.add(atom);
            storeHooks.c == null || storeHooks.c(atom);
        }
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_invalidateDependents = function BUILDING_BLOCK_invalidateDependents(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var ensureAtomState = buildingBlocks[11];
    var stack = [
        atom
    ];
    while(stack.length){
        var a = stack.pop();
        var aState = ensureAtomState(buildingBlocks, store, a);
        for(var _iterator10 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose($8dc2d4c6187d1fef$var$getMountedOrPendingDependents(a, aState, mountedMap)), _step10; !(_step10 = _iterator10()).done;){
            var d = _step10.value;
            var dState = ensureAtomState(buildingBlocks, store, d);
            if (invalidatedAtoms.get(d) !== dState.n) {
                invalidatedAtoms.set(d, dState.n);
                stack.push(d);
            }
        }
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_writeAtomState = function BUILDING_BLOCK_writeAtomState(buildingBlocks, store, atom, args) {
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomWrite = buildingBlocks[8];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var invalidateDependents = buildingBlocks[15];
    var writeAtomState = buildingBlocks[16];
    var mountDependencies = buildingBlocks[17];
    var setAtomStateValueOrPromise = buildingBlocks[20];
    var storeEpochHolder = buildingBlocks[28];
    var isSync = true;
    var getter = function getter(a) {
        return $8dc2d4c6187d1fef$var$returnAtomValue(readAtomState(buildingBlocks, store, a));
    };
    var setter = function setter(a) {
        var aState = ensureAtomState(buildingBlocks, store, a);
        try {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            if (a === atom) {
                if (!$8dc2d4c6187d1fef$var$hasInitialValue(a)) throw new Error('atom not writable');
                var prevEpochNumber = aState.n;
                var v = args[0];
                setAtomStateValueOrPromise(buildingBlocks, store, a, v);
                mountDependencies(buildingBlocks, store, a);
                if (prevEpochNumber !== aState.n) {
                    ++storeEpochHolder[0];
                    changedAtoms.add(a);
                    invalidateDependents(buildingBlocks, store, a);
                    storeHooks.c == null || storeHooks.c(a);
                }
                return undefined;
            } else return writeAtomState(buildingBlocks, store, a, args);
        } finally{
            if (!isSync) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    try {
        return atomWrite.apply(void 0, [
            buildingBlocks,
            store,
            atom,
            getter,
            setter
        ].concat(args));
    } finally{
        isSync = false;
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_mountDependencies = function BUILDING_BLOCK_mountDependencies(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState = buildingBlocks[11];
    var invalidateDependents = buildingBlocks[15];
    var mountAtom = buildingBlocks[18];
    var unmountAtom = buildingBlocks[19];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (mounted && atomState.d.size > 0) {
        for(var _iterator11 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(atomState.d), _step11; !(_step11 = _iterator11()).done;){
            var _step11$value = _step11.value, a = _step11$value[0], _n2 = _step11$value[1];
            if (!mounted.d.has(a)) {
                var aState = ensureAtomState(buildingBlocks, store, a);
                var aMounted = mountAtom(buildingBlocks, store, a);
                aMounted.t.add(atom);
                mounted.d.add(a);
                if (_n2 !== aState.n) {
                    changedAtoms.add(a);
                    invalidateDependents(buildingBlocks, store, a);
                    storeHooks.c == null || storeHooks.c(a);
                }
            }
        }
        for(var _iterator12 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(mounted.d), _step12; !(_step12 = _iterator12()).done;){
            var _a3 = _step12.value;
            if (!atomState.d.has(_a3)) {
                mounted.d.delete(_a3);
                var _aMounted = unmountAtom(buildingBlocks, store, _a3);
                _aMounted == null || _aMounted.t.delete(atom);
            }
        }
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_mountAtom = function BUILDING_BLOCK_mountAtom(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var mountCallbacks = buildingBlocks[4];
    var storeHooks = buildingBlocks[6];
    var atomOnMount = buildingBlocks[10];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var writeAtomState = buildingBlocks[16];
    var mountAtom = buildingBlocks[18];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (!mounted) {
        readAtomState(buildingBlocks, store, atom);
        for(var _iterator13 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step13; !(_step13 = _iterator13()).done;){
            var a = _step13.value;
            var aMounted = mountAtom(buildingBlocks, store, a);
            aMounted.t.add(atom);
        }
        mounted = {
            l: new Set(),
            d: new Set(atomState.d.keys()),
            t: new Set()
        };
        mountedMap.set(atom, mounted);
        if ($8dc2d4c6187d1fef$var$isActuallyWritableAtom(atom) && $8dc2d4c6187d1fef$var$hasOnMount(atom)) {
            var processOnMount = function processOnMount() {
                var isSync = true;
                var setAtom = function setAtom() {
                    try {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        return writeAtomState(buildingBlocks, store, atom, args);
                    } finally{
                        if (!isSync) {
                            recomputeInvalidatedAtoms(buildingBlocks, store);
                            flushCallbacks(buildingBlocks, store);
                        }
                    }
                };
                try {
                    var onUnmount = atomOnMount(buildingBlocks, store, atom, setAtom);
                    if (onUnmount) mounted.u = function() {
                        isSync = true;
                        try {
                            onUnmount();
                        } finally{
                            isSync = false;
                        }
                    };
                } finally{
                    isSync = false;
                }
            };
            mountCallbacks.add(processOnMount);
        }
        storeHooks.m == null || storeHooks.m(atom);
    }
    return mounted;
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_unmountAtom = function BUILDING_BLOCK_unmountAtom(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState = buildingBlocks[11];
    var unmountAtom = buildingBlocks[19];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (!mounted || mounted.l.size) return mounted;
    var isDependent = false;
    for(var _iterator14 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(mounted.t), _step14; !(_step14 = _iterator14()).done;){
        var _mountedMap$get3;
        var _a4 = _step14.value;
        if ((_mountedMap$get3 = mountedMap.get(_a4)) != null && _mountedMap$get3.d.has(atom)) {
            isDependent = true;
            break;
        }
    }
    if (!isDependent) {
        if (mounted.u) unmountCallbacks.add(mounted.u);
        mounted = undefined;
        mountedMap.delete(atom);
        for(var _iterator15 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step15; !(_step15 = _iterator15()).done;){
            var a = _step15.value;
            var aMounted = unmountAtom(buildingBlocks, store, a);
            aMounted == null || aMounted.t.delete(atom);
        }
        storeHooks.u == null || storeHooks.u(atom);
        return undefined;
    }
    return mounted;
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_setAtomStateValueOrPromise = function BUILDING_BLOCK_setAtomStateValueOrPromise(buildingBlocks, store, atom, valueOrPromise) {
    var ensureAtomState = buildingBlocks[11];
    var abortPromise = buildingBlocks[27];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var hasPrevValue = 'v' in atomState;
    var prevValue = atomState.v;
    if ($8dc2d4c6187d1fef$var$isPromiseLike(valueOrPromise)) for(var _iterator16 = $8dc2d4c6187d1fef$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step16; !(_step16 = _iterator16()).done;){
        var a = _step16.value;
        $8dc2d4c6187d1fef$var$addPendingPromiseToDependency(atom, valueOrPromise, ensureAtomState(buildingBlocks, store, a));
    }
    atomState.v = valueOrPromise;
    delete atomState.e;
    if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
        ++atomState.n;
        if ($8dc2d4c6187d1fef$var$isPromiseLike(prevValue)) abortPromise(buildingBlocks, store, prevValue);
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeGet = function BUILDING_BLOCK_storeGet(buildingBlocks, store, atom) {
    var readAtomState = buildingBlocks[14];
    return $8dc2d4c6187d1fef$var$returnAtomValue(readAtomState(buildingBlocks, store, atom));
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeSet = function BUILDING_BLOCK_storeSet(buildingBlocks, store, atom) {
    var changedAtoms = buildingBlocks[3];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var writeAtomState = buildingBlocks[16];
    var prevChangedAtomsSize = changedAtoms.size;
    try {
        for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
        return writeAtomState(buildingBlocks, store, atom, args);
    } finally{
        if (changedAtoms.size !== prevChangedAtomsSize) {
            recomputeInvalidatedAtoms(buildingBlocks, store);
            flushCallbacks(buildingBlocks, store);
        }
    }
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeSub = function BUILDING_BLOCK_storeSub(buildingBlocks, store, atom, listener) {
    var flushCallbacks = buildingBlocks[12];
    var mountAtom = buildingBlocks[18];
    var unmountAtom = buildingBlocks[19];
    var mounted = mountAtom(buildingBlocks, store, atom);
    var listeners = mounted.l;
    listeners.add(listener);
    flushCallbacks(buildingBlocks, store);
    return function() {
        listeners.delete(listener);
        unmountAtom(buildingBlocks, store, atom);
        flushCallbacks(buildingBlocks, store);
    };
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_registerAbortHandler = function BUILDING_BLOCK_registerAbortHandler(buildingBlocks, _store, promise, abortHandler) {
    var abortHandlersMap = buildingBlocks[25];
    var abortHandlers = abortHandlersMap.get(promise);
    if (!abortHandlers) {
        abortHandlers = new Set();
        abortHandlersMap.set(promise, abortHandlers);
        var cleanup = function cleanup() {
            return abortHandlersMap.delete(promise);
        };
        promise.then(cleanup, cleanup);
    }
    abortHandlers.add(abortHandler);
};
var $8dc2d4c6187d1fef$var$BUILDING_BLOCK_abortPromise = function BUILDING_BLOCK_abortPromise(buildingBlocks, _store, promise) {
    var abortHandlersMap = buildingBlocks[25];
    var abortHandlers = abortHandlersMap.get(promise);
    abortHandlers == null || abortHandlers.forEach(function(fn) {
        return fn();
    });
};
var $8dc2d4c6187d1fef$var$buildingBlockMap = new WeakMap();
function $8dc2d4c6187d1fef$var$getBuildingBlocks(store) {
    var buildingBlocks = $8dc2d4c6187d1fef$var$buildingBlockMap.get(store);
    var enhanceBuildingBlocks = buildingBlocks[24];
    if (enhanceBuildingBlocks) return enhanceBuildingBlocks(buildingBlocks, store);
    return buildingBlocks;
}
function $8dc2d4c6187d1fef$var$buildStore() {
    for(var _len7 = arguments.length, partialBuildingBlocks = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)partialBuildingBlocks[_key7] = arguments[_key7];
    var store = {
        get: function get(atom) {
            return storeGet(buildingBlocks, store, atom);
        },
        set: function set(atom) {
            for(var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++)args[_key8 - 1] = arguments[_key8];
            return storeSet.apply(void 0, [
                buildingBlocks,
                store,
                atom
            ].concat(args));
        },
        sub: function sub(atom, listener) {
            return storeSub(buildingBlocks, store, atom, listener);
        }
    };
    var buildingBlocks = [
        new WeakMap(),
        new WeakMap(),
        new WeakMap(),
        new Set(),
        new Set(),
        new Set(),
        {},
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomRead,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomWrite,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomOnInit,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_atomOnMount,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_ensureAtomState,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_flushCallbacks,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_recomputeInvalidatedAtoms,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_readAtomState,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_invalidateDependents,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_writeAtomState,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_mountDependencies,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_mountAtom,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_unmountAtom,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_setAtomStateValueOrPromise,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeGet,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeSet,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_storeSub,
        undefined,
        new WeakMap(),
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_registerAbortHandler,
        $8dc2d4c6187d1fef$var$BUILDING_BLOCK_abortPromise,
        [
            0
        ]
    ].map(function(fn, i) {
        return partialBuildingBlocks[i] || fn;
    });
    $8dc2d4c6187d1fef$var$buildingBlockMap.set(store, Object.freeze(buildingBlocks));
    var storeGet = buildingBlocks[21];
    var storeSet = buildingBlocks[22];
    var storeSub = buildingBlocks[23];
    return store;
}
$8dc2d4c6187d1fef$export$82a1790dbcdcfc9f = $8dc2d4c6187d1fef$var$addPendingPromiseToDependency;
$8dc2d4c6187d1fef$export$1b8bba60163162e5 = $8dc2d4c6187d1fef$var$buildStore;
$8dc2d4c6187d1fef$export$67edddd3275fb47c = $8dc2d4c6187d1fef$var$getBuildingBlocks;
$8dc2d4c6187d1fef$export$5454bef94246c3c = $8dc2d4c6187d1fef$var$getMountedOrPendingDependents;
$8dc2d4c6187d1fef$export$23808a6f53e55c3 = $8dc2d4c6187d1fef$var$hasInitialValue;
$8dc2d4c6187d1fef$export$a044c555aa9c2601 = $8dc2d4c6187d1fef$var$initializeStoreHooks;
$8dc2d4c6187d1fef$export$7c24d1ef3bea9769 = $8dc2d4c6187d1fef$var$isActuallyWritableAtom;
$8dc2d4c6187d1fef$export$33f6e9f7330dc7e3 = $8dc2d4c6187d1fef$var$isAtomStateInitialized;
$8dc2d4c6187d1fef$export$5ab0738ada359ec5 = $8dc2d4c6187d1fef$var$isPromiseLike;
$8dc2d4c6187d1fef$export$696d075174b4543b = $8dc2d4c6187d1fef$var$returnAtomValue;
$8dc2d4c6187d1fef$export$488563b9c383d273 = $8dc2d4c6187d1fef$var$shouldThrowSynchronously;


var $af085ae27cb2741e$var$keyCount = 0;
function $af085ae27cb2741e$var$atom(read, write) {
    var key = "atom" + ++$af085ae27cb2741e$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === 'function') config.read = read;
    else {
        config.init = read;
        config.read = $af085ae27cb2741e$var$defaultRead;
        config.write = $af085ae27cb2741e$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $af085ae27cb2741e$var$defaultRead(get) {
    return get(this);
}
function $af085ae27cb2741e$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === 'function' ? arg(get(this)) : arg);
}
var $af085ae27cb2741e$var$overriddenCreateStore;
function $af085ae27cb2741e$var$INTERNAL_overrideCreateStore(fn) {
    $af085ae27cb2741e$var$overriddenCreateStore = fn($af085ae27cb2741e$var$overriddenCreateStore);
}
function $af085ae27cb2741e$var$createStore() {
    if ($af085ae27cb2741e$var$overriddenCreateStore) return $af085ae27cb2741e$var$overriddenCreateStore();
    return $8dc2d4c6187d1fef$export$1b8bba60163162e5();
}
var $af085ae27cb2741e$var$defaultStore;
function $af085ae27cb2741e$var$getDefaultStore() {
    if (!$af085ae27cb2741e$var$defaultStore) {
        $af085ae27cb2741e$var$defaultStore = $af085ae27cb2741e$var$createStore();
        var _ref;
    }
    return $af085ae27cb2741e$var$defaultStore;
}
$af085ae27cb2741e$export$cfdd58e14a91411a = $af085ae27cb2741e$var$INTERNAL_overrideCreateStore;
$af085ae27cb2741e$export$5fb5cc0d078610b = $af085ae27cb2741e$var$atom;
$af085ae27cb2741e$export$f51a9068ac82ea43 = $af085ae27cb2741e$var$createStore;
$af085ae27cb2741e$export$39b2e4393dfcb8aa = $af085ae27cb2741e$var$getDefaultStore;


var $dc17d039fe66eb98$exports = {};

$parcel$export($dc17d039fe66eb98$exports, "Provider", () => $dc17d039fe66eb98$export$2881499e37b75b9a, (v) => $dc17d039fe66eb98$export$2881499e37b75b9a = v);
$parcel$export($dc17d039fe66eb98$exports, "useAtom", () => $dc17d039fe66eb98$export$83cf7ae8bb57e7ed, (v) => $dc17d039fe66eb98$export$83cf7ae8bb57e7ed = v);
$parcel$export($dc17d039fe66eb98$exports, "useAtomValue", () => $dc17d039fe66eb98$export$89a40582f8c436cc, (v) => $dc17d039fe66eb98$export$89a40582f8c436cc = v);
$parcel$export($dc17d039fe66eb98$exports, "useSetAtom", () => $dc17d039fe66eb98$export$a247c952d39ea7ea, (v) => $dc17d039fe66eb98$export$a247c952d39ea7ea = v);
$parcel$export($dc17d039fe66eb98$exports, "useStore", () => $dc17d039fe66eb98$export$6ccbb43953eebf8, (v) => $dc17d039fe66eb98$export$6ccbb43953eebf8 = v);
var $dc17d039fe66eb98$export$2881499e37b75b9a;
var $dc17d039fe66eb98$export$83cf7ae8bb57e7ed;
var $dc17d039fe66eb98$export$89a40582f8c436cc;
var $dc17d039fe66eb98$export$a247c952d39ea7ea;
var $dc17d039fe66eb98$export$6ccbb43953eebf8;
'use client';
'use strict';

var $bNh2M = parcelRequire("bNh2M");


var $dc17d039fe66eb98$var$StoreContext = $bNh2M.createContext(undefined);
function $dc17d039fe66eb98$var$useStore(options) {
    var store = $bNh2M.useContext($dc17d039fe66eb98$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || $af085ae27cb2741e$export$39b2e4393dfcb8aa();
}
function $dc17d039fe66eb98$var$Provider(_ref) {
    var children = _ref.children, store = _ref.store;
    var storeRef = $bNh2M.useRef(null);
    if (store) return $bNh2M.createElement($dc17d039fe66eb98$var$StoreContext.Provider, {
        value: store
    }, children);
    if (storeRef.current === null) storeRef.current = $af085ae27cb2741e$export$f51a9068ac82ea43();
    return $bNh2M.createElement($dc17d039fe66eb98$var$StoreContext.Provider, {
        value: storeRef.current
    }, children);
}
var $dc17d039fe66eb98$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === 'function';
};
var $dc17d039fe66eb98$var$attachPromiseStatus = function attachPromiseStatus(promise) {
    if (!promise.status) {
        promise.status = 'pending';
        promise.then(function(v) {
            promise.status = 'fulfilled';
            promise.value = v;
        }, function(e) {
            promise.status = 'rejected';
            promise.reason = e;
        });
    }
};
var $dc17d039fe66eb98$var$use = $bNh2M.use || function(promise) {
    if (promise.status === 'pending') throw promise;
    else if (promise.status === 'fulfilled') return promise.value;
    else if (promise.status === 'rejected') throw promise.reason;
    else {
        $dc17d039fe66eb98$var$attachPromiseStatus(promise);
        throw promise;
    }
};
var $dc17d039fe66eb98$var$continuablePromiseMap = new WeakMap();
var $dc17d039fe66eb98$var$createContinuablePromise = function createContinuablePromise(store, promise, getValue) {
    var buildingBlocks = $8dc2d4c6187d1fef$export$67edddd3275fb47c(store);
    var registerAbortHandler = buildingBlocks[26];
    var continuablePromise = $dc17d039fe66eb98$var$continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise(function(resolve, reject) {
            var curr = promise;
            var onFulfilled = function onFulfilled(me) {
                return function(v) {
                    if (curr === me) resolve(v);
                };
            };
            var onRejected = function onRejected(me) {
                return function(e) {
                    if (curr === me) reject(e);
                };
            };
            var _onAbort = function onAbort() {
                try {
                    var nextValue = getValue();
                    if ($dc17d039fe66eb98$var$isPromiseLike(nextValue)) {
                        $dc17d039fe66eb98$var$continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        registerAbortHandler(buildingBlocks, store, nextValue, _onAbort);
                    } else resolve(nextValue);
                } catch (e) {
                    reject(e);
                }
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            registerAbortHandler(buildingBlocks, store, promise, _onAbort);
        });
        $dc17d039fe66eb98$var$continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function $dc17d039fe66eb98$var$useAtomValue(atom, options) {
    var _ref = options || {}, delay = _ref.delay, _ref$unstable_promise = _ref.unstable_promiseStatus, promiseStatus = _ref$unstable_promise === void 0 ? !$bNh2M.use : _ref$unstable_promise;
    var store = $dc17d039fe66eb98$var$useStore(options);
    var _useReducer = $bNh2M.useReducer(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, undefined, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), _useReducer$ = _useReducer[0], valueFromReducer = _useReducer$[0], storeFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    $bNh2M.useEffect(function() {
        var unsub = store.sub(atom, function() {
            if (promiseStatus) try {
                var _value = store.get(atom);
                if ($dc17d039fe66eb98$var$isPromiseLike(_value)) $dc17d039fe66eb98$var$attachPromiseStatus($dc17d039fe66eb98$var$createContinuablePromise(store, _value, function() {
                    return store.get(atom);
                }));
            } catch (_unused) {}
            if (typeof delay === 'number') {
                console.warn("[DEPRECATED] delay option is deprecated and will be removed in v3.\n\nMigration guide:\n\nCreate a custom hook like the following.\n\nfunction useAtomValueWithDelay<Value>(\n  atom: Atom<Value>,\n  options: { delay: number },\n): Value {\n  const { delay } = options\n  const store = useStore(options)\n  const [value, setValue] = useState(() => store.get(atom))\n  useEffect(() => {\n    const unsub = store.sub(atom, () => {\n      setTimeout(() => setValue(store.get(atom)), delay)\n    })\n    return unsub\n  }, [store, atom, delay])\n  return value\n}\n");
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay,
        promiseStatus
    ]);
    $bNh2M.useDebugValue(value);
    if ($dc17d039fe66eb98$var$isPromiseLike(value)) {
        var promise = $dc17d039fe66eb98$var$createContinuablePromise(store, value, function() {
            return store.get(atom);
        });
        if (promiseStatus) $dc17d039fe66eb98$var$attachPromiseStatus(promise);
        return $dc17d039fe66eb98$var$use(promise);
    }
    return value;
}
function $dc17d039fe66eb98$var$useSetAtom(atom, options) {
    var store = $dc17d039fe66eb98$var$useStore(options);
    var setAtom = $bNh2M.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return store.set.apply(store, [
            atom
        ].concat(args));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $dc17d039fe66eb98$var$useAtom(atom, options) {
    return [
        $dc17d039fe66eb98$var$useAtomValue(atom, options),
        $dc17d039fe66eb98$var$useSetAtom(atom, options)
    ];
}
$dc17d039fe66eb98$export$2881499e37b75b9a = $dc17d039fe66eb98$var$Provider;
$dc17d039fe66eb98$export$83cf7ae8bb57e7ed = $dc17d039fe66eb98$var$useAtom;
$dc17d039fe66eb98$export$89a40582f8c436cc = $dc17d039fe66eb98$var$useAtomValue;
$dc17d039fe66eb98$export$a247c952d39ea7ea = $dc17d039fe66eb98$var$useSetAtom;
$dc17d039fe66eb98$export$6ccbb43953eebf8 = $dc17d039fe66eb98$var$useStore;


Object.keys($af085ae27cb2741e$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($7c9b300c545ed81c$exports, k)) Object.defineProperty($7c9b300c545ed81c$exports, k, {
        enumerable: true,
        get: function() {
            return $af085ae27cb2741e$exports[k];
        }
    });
});
Object.keys($dc17d039fe66eb98$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($7c9b300c545ed81c$exports, k)) Object.defineProperty($7c9b300c545ed81c$exports, k, {
        enumerable: true,
        get: function() {
            return $dc17d039fe66eb98$exports[k];
        }
    });
});


class $630abbaa58d51e28$export$11bd41ce883b0bf4 {
}
class $630abbaa58d51e28$export$759a2d753d4ac61a {
    constructor(wrapped){
        this.wrapped = wrapped;
    }
}
let $630abbaa58d51e28$var$account = "";
const $630abbaa58d51e28$var$DRIVE_SCOPE = "https://www.googleapis.com/auth/drive";
const $630abbaa58d51e28$var$accountAtom = (0, $7c9b300c545ed81c$exports.atom)("");
function $630abbaa58d51e28$export$83a8e409853da004() {
    const [name, setName] = (0, $7c9b300c545ed81c$exports.useAtom)($630abbaa58d51e28$var$accountAtom);
    const signIn = async ()=>{
        const displayName = await $630abbaa58d51e28$export$2ac0064d6c47123a.signIn();
        setName(displayName);
    };
    const signOut = ()=>{
        $630abbaa58d51e28$export$2ac0064d6c47123a.signOut();
        setName("");
    };
    return {
        signIn: signIn,
        signOut: signOut,
        name: name
    };
}
//#region GDriveHandler
class $630abbaa58d51e28$var$GDriveHandler {
    #initialized;
    #requestHandler;
    #gapiScriptLoaded;
    #gisScriptLoaded;
    #initStarted;
    #tokenClient;
    constructor(){
        this.#initialized = false;
        this.#requestHandler = new $630abbaa58d51e28$var$RequestHandler(()=>this.#ensureAccessToken());
        this.#gapiScriptLoaded = false;
        this.#gisScriptLoaded = false;
        this.#initStarted = false;
        this.#tokenClient = null;
        window["checkAuth"] = ()=>{
            this.#gapiScriptLoaded = true;
            this.#tryInit();
        };
        window["checkGis"] = ()=>{
            this.#gisScriptLoaded = true;
            this.#tryInit();
        };
    }
    #tryInit() {
        if (!this.#gapiScriptLoaded) return;
        if (!this.#gisScriptLoaded) return;
        if (this.#initStarted) return;
        this.#initStarted = true;
        gapi.load("client", ()=>{
            this.#initClients();
        });
    }
    async #initClients() {
        const clientId = "301982289129-sn4f86tfe411faarmukgakfu8qa7pfg8.apps.googleusercontent.com";
        if (!clientId) {
            console.error("GD_CLIENT_ID is not set");
            return;
        }
        try {
            const apiKey = "AIzaSyCnW8hbwC82NC3LvolaVTmbDn3iJSgDLO0";
            if (!apiKey) {
                console.error("GD_API_KEY is not set");
                return;
            }
            await gapi.client.init({
                apiKey: apiKey,
                discoveryDocs: [
                    "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
                ]
            });
            this.#tokenClient = google.accounts.oauth2.initTokenClient({
                client_id: clientId,
                scope: $630abbaa58d51e28$var$DRIVE_SCOPE,
                callback: ()=>{}
            });
            await this.#tryRestoreSession();
        } catch (err) {
            console.error("Google API client init failed:", err);
        }
    }
    /** Re-request token when prior consent exists (no full re-login UI when possible). */ async #tryRestoreSession() {
        try {
            await this.#requestAccessToken({
                prompt: ""
            });
            $630abbaa58d51e28$var$account = await this.#fetchUserDisplayName();
            this.#initialized = true;
        } catch  {
            this.#initialized = false;
        }
    }
    #requestAccessToken(options = {}) {
        return new Promise((resolve, reject)=>{
            if (!this.#tokenClient) {
                reject(new Error("Google Identity Services is not initialized"));
                return;
            }
            this.#tokenClient.callback = (tokenResponse)=>{
                if (tokenResponse.error) {
                    const { error: error, error_description: error_description } = tokenResponse;
                    reject(new Error(`${error}: ${error_description || ""}`));
                    return;
                }
                resolve();
            };
            this.#tokenClient.requestAccessToken(options);
        });
    }
    /** Used by API layer when access token expired (GIS does not auto-refresh). */ async #ensureAccessToken() {
        const token = gapi.client.getToken();
        if (token?.access_token) return;
        await this.#requestAccessToken({
            prompt: ""
        });
    }
    async #fetchUserDisplayName() {
        const resp = await gapi.client.drive.about.get({
            fields: "user(displayName)"
        });
        return resp.result.user?.displayName || "";
    }
    async signIn() {
        await this.#requestAccessToken({
            prompt: "select_account"
        });
        const displayName = await this.#fetchUserDisplayName();
        $630abbaa58d51e28$var$account = displayName;
        this.#initialized = true;
        return displayName;
    }
    signOut() {
        const token = gapi.client.getToken();
        if (token?.access_token) google.accounts.oauth2.revoke(token.access_token, ()=>{
            gapi.client.setToken(null);
        });
        else gapi.client.setToken(null);
        $630abbaa58d51e28$var$account = "";
        this.#initialized = false;
    }
    async #loadGdrive() {
        let offlineCnt = 0;
        while(!this.#initialized){
            await (0, $e718d0a2e2d09f3a$export$5c069c93d2b7493f)(1000);
            offlineCnt = navigator.onLine ? 0 : offlineCnt + 1;
            if (offlineCnt > 5) throw new $630abbaa58d51e28$export$11bd41ce883b0bf4();
        }
    }
    async listFiles(q, pageSize = 120) {
        await this.#loadGdrive();
        let pageToken = "";
        const files = [];
        do {
            const response = await this.#requestHandler.addRequest(gapi.client.drive.files.list({
                pageSize: pageSize,
                ...pageToken ? {
                    pageToken: pageToken
                } : {},
                q: q,
                fields: "nextPageToken, files(id, name)"
            }));
            pageToken = response.result.nextPageToken ?? "";
            files.push(...response.result.files);
        }while (pageToken);
        return files;
    }
    async findOneFile(q) {
        const files = await this.listFiles(q, 1);
        if (files.length) return files[0];
        return null;
    }
    async getFileItself(fileId) {
        await this.#loadGdrive();
        const resp = await this.#requestHandler.addRequest(gapi.client.drive.files.get({
            fileId: fileId
        }));
        return resp.result;
    }
    async getContent(id, type = "string") {
        await this.#loadGdrive();
        const resp = await this.#requestHandler.addRequest(gapi.client.drive.files.get({
            alt: "media",
            fileId: id
        }));
        const rawstring = resp.body;
        return type === "string" ? rawstring : Uint8Array.from(rawstring.split("").map((e)=>e.charCodeAt(0)));
    }
}
//#region RequestHandler
class $630abbaa58d51e28$var$RequestHandler {
    #requests;
    #refreshToken;
    constructor(refreshToken){
        this.#requests = [];
        this.#refreshToken = refreshToken;
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>{
            while(true){
                await (0, $e718d0a2e2d09f3a$export$761f4adc3008ef1c)(1000);
                if (this.#requests.length) {
                    this.#batch(this.#requests).execute(()=>{});
                    this.#requests.fill(undefined, 0, this.#requests.length);
                    this.#requests.length = 0;
                }
            }
        });
    }
    #batch(requests) {
        const b = gapi.client.newBatch();
        for(let i = 0; i < requests.length; i++){
            const request = requests[i];
            if (!request) continue;
            b.add(request);
        }
        return b;
    }
    async addRequest(r, retryTime = 0) {
        if (retryTime > 10) throw "Retry Limit Exceeded";
        this.#requests.push(r);
        const res = await r;
        if (res.status === 401 && retryTime < 3) {
            gapi.client.setToken(null);
            try {
                await this.#refreshToken();
                return this.addRequest(r, retryTime + 1);
            } catch  {
                throw "Authorization required";
            }
        }
        if (res.status === 403) {
            console.log(`403: User Rate Limit Exceeded. wait ${1000 * 2 ** retryTime}ms`);
            await (0, $e718d0a2e2d09f3a$export$5c069c93d2b7493f)(1000 * 2 ** retryTime);
            return this.addRequest(r, retryTime + 1);
        }
        return res;
    }
}
const $630abbaa58d51e28$export$2ac0064d6c47123a = new $630abbaa58d51e28$var$GDriveHandler();



parcelRequire("bNh2M");
function $83be4e8e99a6273a$export$409ec18e0392f49a() {
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    // const account = useAccount();
    const { signOut: signOut, name: name } = (0, $630abbaa58d51e28$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "account_info",
        hidden: !name,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                id: "account_name",
                children: name
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("button", {
                id: "account_inout_button",
                onClick: ()=>{
                    signOut();
                },
                children: i18n.account.signIn
            })
        ]
    });
}
const $83be4e8e99a6273a$export$e4624626de9ce646 = ()=>{
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    // const account = useAccount();
    const { signIn: signIn, name: name } = (0, $630abbaa58d51e28$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "signin_button_wrapper",
        hidden: !!name,
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("button", {
            className: "signin_button",
            onClick: ()=>{
                signIn();
            },
            children: [
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("img", {
                    src: "/image/google_logo_signin.png",
                    alt: "",
                    className: "signin_button_icon",
                    width: "96",
                    height: "96"
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                    className: "signin_button_text",
                    children: i18n.account.signIn
                })
            ]
        })
    });
};
function $83be4e8e99a6273a$var$clickSignIn() {
    (0, $630abbaa58d51e28$export$2ac0064d6c47123a).signIn();
}
function $83be4e8e99a6273a$var$clickSignOut() {
    (0, $630abbaa58d51e28$export$2ac0064d6c47123a).signOut();
}




parcelRequire("bNh2M");
const $e54ba3d42fd52a1c$export$65f7da49be6579a0 = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "language_wrapper",
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
            id: "language",
            children: [
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($e54ba3d42fd52a1c$var$Selection, {
                    code: "ja",
                    children: "\u65E5\u672C\u8A9E"
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($e54ba3d42fd52a1c$var$Selection, {
                    code: "en",
                    children: "English"
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($e54ba3d42fd52a1c$var$Selection, {
                    code: "zh-CN",
                    children: "\u7B80\u4F53\u4E2D\u6587"
                })
            ]
        })
    });
};
const $e54ba3d42fd52a1c$var$Selection = ({ code: code, children: children })=>{
    const [, current] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    const { setCurrentLocale: setCurrentLocale } = (0, $047030d75d5c8297$export$bdbc0c78cfd00496)();
    const active = current === code;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "selection",
        onClick: ()=>setCurrentLocale(code),
        "data-active": active,
        children: children
    }, code);
};






var $bNh2M = parcelRequire("bNh2M");
/**
 * react-router v7.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bNh2M = parcelRequire("bNh2M");
var $e6c15aaa44b364a9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.17.0_react-d_5427150f64344fb6731409ac4a6e91a6/node_modules/react-router/dist/development/chunk-6CSD65Y2.mjs"
});
var $e6c15aaa44b364a9$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $e6c15aaa44b364a9$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $e6c15aaa44b364a9$var$__typeError("Cannot " + msg);
var $e6c15aaa44b364a9$var$__privateGet = (obj, member, getter)=>($e6c15aaa44b364a9$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $e6c15aaa44b364a9$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $e6c15aaa44b364a9$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $e6c15aaa44b364a9$var$__privateSet = (obj, member, value, setter)=>($e6c15aaa44b364a9$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $e6c15aaa44b364a9$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($e6c15aaa44b364a9$export$e19cd5f9376f8cee || {});
var $e6c15aaa44b364a9$var$PopStateEventType = "popstate";
function $e6c15aaa44b364a9$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $e6c15aaa44b364a9$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $e6c15aaa44b364a9$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $e6c15aaa44b364a9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $e6c15aaa44b364a9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $e6c15aaa44b364a9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $e6c15aaa44b364a9$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $e6c15aaa44b364a9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to);
    }
    return $e6c15aaa44b364a9$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $e6c15aaa44b364a9$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e6c15aaa44b364a9$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e6c15aaa44b364a9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e6c15aaa44b364a9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $e6c15aaa44b364a9$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e6c15aaa44b364a9$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e6c15aaa44b364a9$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $e6c15aaa44b364a9$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $e6c15aaa44b364a9$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $e6c15aaa44b364a9$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e6c15aaa44b364a9$var$createKey(),
        mask: mask
    };
    return location;
}
function $e6c15aaa44b364a9$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $e6c15aaa44b364a9$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e6c15aaa44b364a9$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $e6c15aaa44b364a9$var$isLocation(to) ? to : $e6c15aaa44b364a9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e6c15aaa44b364a9$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $e6c15aaa44b364a9$var$isLocation(to) ? to : $e6c15aaa44b364a9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e6c15aaa44b364a9$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $e6c15aaa44b364a9$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($e6c15aaa44b364a9$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($e6c15aaa44b364a9$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $e6c15aaa44b364a9$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $e6c15aaa44b364a9$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $e6c15aaa44b364a9$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $e6c15aaa44b364a9$var$_map;
var $e6c15aaa44b364a9$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $e6c15aaa44b364a9$var$__privateAdd(this, $e6c15aaa44b364a9$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_map).has(context)) return $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_map).set(context, value);
    }
};
$e6c15aaa44b364a9$var$_map = new WeakMap();
var $e6c15aaa44b364a9$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e6c15aaa44b364a9$var$isUnsupportedLazyRouteObjectKey(key) {
    return $e6c15aaa44b364a9$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $e6c15aaa44b364a9$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $e6c15aaa44b364a9$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $e6c15aaa44b364a9$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $e6c15aaa44b364a9$var$isIndexRoute(route) {
    return route.index === true;
}
function $e6c15aaa44b364a9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e6c15aaa44b364a9$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $e6c15aaa44b364a9$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($e6c15aaa44b364a9$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $e6c15aaa44b364a9$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $e6c15aaa44b364a9$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $e6c15aaa44b364a9$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $e6c15aaa44b364a9$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $e6c15aaa44b364a9$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $e6c15aaa44b364a9$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $e6c15aaa44b364a9$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e6c15aaa44b364a9$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $e6c15aaa44b364a9$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $e6c15aaa44b364a9$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $e6c15aaa44b364a9$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $e6c15aaa44b364a9$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $e6c15aaa44b364a9$var$flattenAndRankRoutes(routes) {
    let branches = $e6c15aaa44b364a9$var$flattenRoutes(routes);
    $e6c15aaa44b364a9$var$rankRouteBranches(branches);
    return branches;
}
function $e6c15aaa44b364a9$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $e6c15aaa44b364a9$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e6c15aaa44b364a9$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $e6c15aaa44b364a9$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $e6c15aaa44b364a9$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e6c15aaa44b364a9$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $e6c15aaa44b364a9$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $e6c15aaa44b364a9$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e6c15aaa44b364a9$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e6c15aaa44b364a9$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $e6c15aaa44b364a9$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $e6c15aaa44b364a9$var$paramRe = /^:[\w-]+$/;
var $e6c15aaa44b364a9$var$dynamicSegmentValue = 3;
var $e6c15aaa44b364a9$var$indexRouteValue = 2;
var $e6c15aaa44b364a9$var$emptySegmentValue = 1;
var $e6c15aaa44b364a9$var$staticSegmentValue = 10;
var $e6c15aaa44b364a9$var$splatPenalty = -2;
var $e6c15aaa44b364a9$var$isSplat = (s)=>s === "*";
function $e6c15aaa44b364a9$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e6c15aaa44b364a9$var$isSplat)) initialScore += $e6c15aaa44b364a9$var$splatPenalty;
    if (index) initialScore += $e6c15aaa44b364a9$var$indexRouteValue;
    return segments.filter((s)=>!$e6c15aaa44b364a9$var$isSplat(s)).reduce((score, segment)=>score + ($e6c15aaa44b364a9$var$paramRe.test(segment) ? $e6c15aaa44b364a9$var$dynamicSegmentValue : segment === "" ? $e6c15aaa44b364a9$var$emptySegmentValue : $e6c15aaa44b364a9$var$staticSegmentValue), initialScore);
}
function $e6c15aaa44b364a9$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e6c15aaa44b364a9$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e6c15aaa44b364a9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e6c15aaa44b364a9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e6c15aaa44b364a9$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e6c15aaa44b364a9$var$normalizePathname($e6c15aaa44b364a9$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e6c15aaa44b364a9$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $e6c15aaa44b364a9$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e6c15aaa44b364a9$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $e6c15aaa44b364a9$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $e6c15aaa44b364a9$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e6c15aaa44b364a9$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e6c15aaa44b364a9$var$compilePath(path, caseSensitive = false, end = true) {
    $e6c15aaa44b364a9$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $e6c15aaa44b364a9$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e6c15aaa44b364a9$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $e6c15aaa44b364a9$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $e6c15aaa44b364a9$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $e6c15aaa44b364a9$var$joinPaths([
        basename,
        pathname
    ]);
}
var $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $e6c15aaa44b364a9$var$isAbsoluteUrl = (url)=>$e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX.test(url);
function $e6c15aaa44b364a9$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $e6c15aaa44b364a9$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $e6c15aaa44b364a9$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $e6c15aaa44b364a9$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e6c15aaa44b364a9$var$normalizeSearch(search),
        hash: $e6c15aaa44b364a9$var$normalizeHash(hash)
    };
}
function $e6c15aaa44b364a9$var$resolvePathname(relativePath, fromPathname) {
    let segments = $e6c15aaa44b364a9$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e6c15aaa44b364a9$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $e6c15aaa44b364a9$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $e6c15aaa44b364a9$var$getResolveToMatches(matches) {
    let pathMatches = $e6c15aaa44b364a9$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $e6c15aaa44b364a9$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $e6c15aaa44b364a9$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $e6c15aaa44b364a9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $e6c15aaa44b364a9$var$getInvalidPathError("?", "pathname", "search", to));
        $e6c15aaa44b364a9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $e6c15aaa44b364a9$var$getInvalidPathError("#", "pathname", "hash", to));
        $e6c15aaa44b364a9$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $e6c15aaa44b364a9$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e6c15aaa44b364a9$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $e6c15aaa44b364a9$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $e6c15aaa44b364a9$var$joinPaths = (paths)=>$e6c15aaa44b364a9$var$removeDoubleSlashes(paths.join("/"));
var $e6c15aaa44b364a9$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $e6c15aaa44b364a9$var$normalizePathname = (pathname)=>$e6c15aaa44b364a9$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $e6c15aaa44b364a9$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $e6c15aaa44b364a9$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $e6c15aaa44b364a9$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $e6c15aaa44b364a9$export$4051a07651545597(data2, init) {
    return new $e6c15aaa44b364a9$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $e6c15aaa44b364a9$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $e6c15aaa44b364a9$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e6c15aaa44b364a9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $e6c15aaa44b364a9$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e6c15aaa44b364a9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $e6c15aaa44b364a9$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $e6c15aaa44b364a9$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $e6c15aaa44b364a9$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $e6c15aaa44b364a9$var$joinPaths(parts) || "/";
}
var $e6c15aaa44b364a9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $e6c15aaa44b364a9$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($e6c15aaa44b364a9$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $e6c15aaa44b364a9$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $e6c15aaa44b364a9$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $e6c15aaa44b364a9$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $e6c15aaa44b364a9$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $e6c15aaa44b364a9$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $e6c15aaa44b364a9$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$e6c15aaa44b364a9$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $e6c15aaa44b364a9$var$wrapImpl(aggregated[key], original, (...args)=>$e6c15aaa44b364a9$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$e6c15aaa44b364a9$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$e6c15aaa44b364a9$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $e6c15aaa44b364a9$var$wrapImpl(aggregated.middleware, original, (...args)=>$e6c15aaa44b364a9$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$e6c15aaa44b364a9$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $e6c15aaa44b364a9$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$e6c15aaa44b364a9$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $e6c15aaa44b364a9$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $e6c15aaa44b364a9$export$fe53371bee54353d(to) : ".",
                ...$e6c15aaa44b364a9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$e6c15aaa44b364a9$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$e6c15aaa44b364a9$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $e6c15aaa44b364a9$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$e6c15aaa44b364a9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$e6c15aaa44b364a9$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $e6c15aaa44b364a9$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $e6c15aaa44b364a9$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $e6c15aaa44b364a9$var$getReadonlyRequest(request),
            context: context != null ? $e6c15aaa44b364a9$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $e6c15aaa44b364a9$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $e6c15aaa44b364a9$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $e6c15aaa44b364a9$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $e6c15aaa44b364a9$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $e6c15aaa44b364a9$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $e6c15aaa44b364a9$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $e6c15aaa44b364a9$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $e6c15aaa44b364a9$var$getReadonlyContext(context)
    };
}
function $e6c15aaa44b364a9$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $e6c15aaa44b364a9$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $e6c15aaa44b364a9$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $e6c15aaa44b364a9$var$getReadonlyContext(context) {
    if ($e6c15aaa44b364a9$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $e6c15aaa44b364a9$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $e6c15aaa44b364a9$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $e6c15aaa44b364a9$var$objectProtoNames;
}
// lib/router/router.ts
var $e6c15aaa44b364a9$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $e6c15aaa44b364a9$var$validMutationMethods = new Set($e6c15aaa44b364a9$var$validMutationMethodsArr);
var $e6c15aaa44b364a9$var$validRequestMethodsArr = [
    "GET",
    ...$e6c15aaa44b364a9$var$validMutationMethodsArr
];
var $e6c15aaa44b364a9$var$validRequestMethods = new Set($e6c15aaa44b364a9$var$validRequestMethodsArr);
var $e6c15aaa44b364a9$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $e6c15aaa44b364a9$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $e6c15aaa44b364a9$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $e6c15aaa44b364a9$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $e6c15aaa44b364a9$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $e6c15aaa44b364a9$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $e6c15aaa44b364a9$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $e6c15aaa44b364a9$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $e6c15aaa44b364a9$var$_routes, $e6c15aaa44b364a9$var$_branches, $e6c15aaa44b364a9$var$_hmrRoutes, $e6c15aaa44b364a9$var$_hmrBranches;
var $e6c15aaa44b364a9$var$DataRoutes = class {
    constructor(routes){
        $e6c15aaa44b364a9$var$__privateAdd(this, $e6c15aaa44b364a9$var$_routes);
        $e6c15aaa44b364a9$var$__privateAdd(this, $e6c15aaa44b364a9$var$_branches);
        $e6c15aaa44b364a9$var$__privateAdd(this, $e6c15aaa44b364a9$var$_hmrRoutes);
        $e6c15aaa44b364a9$var$__privateAdd(this, $e6c15aaa44b364a9$var$_hmrBranches);
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_routes, routes);
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_branches, $e6c15aaa44b364a9$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrRoutes) ?? $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrBranches) ?? $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_branches);
    }
    get hasHMRRoutes() {
        return $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_routes, routes);
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_branches, $e6c15aaa44b364a9$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_hmrRoutes, routes);
        $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_hmrBranches, $e6c15aaa44b364a9$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrRoutes)) {
            $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_routes, $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrRoutes));
            $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_branches, $e6c15aaa44b364a9$var$__privateGet(this, $e6c15aaa44b364a9$var$_hmrBranches));
            $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_hmrRoutes, void 0);
            $e6c15aaa44b364a9$var$__privateSet(this, $e6c15aaa44b364a9$var$_hmrBranches, void 0);
        }
    }
};
$e6c15aaa44b364a9$var$_routes = new WeakMap();
$e6c15aaa44b364a9$var$_branches = new WeakMap();
$e6c15aaa44b364a9$var$_hmrRoutes = new WeakMap();
$e6c15aaa44b364a9$var$_hmrBranches = new WeakMap();
function $e6c15aaa44b364a9$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $e6c15aaa44b364a9$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $e6c15aaa44b364a9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$e6c15aaa44b364a9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $e6c15aaa44b364a9$var$DataRoutes($e6c15aaa44b364a9$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $e6c15aaa44b364a9$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $e6c15aaa44b364a9$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$e6c15aaa44b364a9$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $e6c15aaa44b364a9$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $e6c15aaa44b364a9$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $e6c15aaa44b364a9$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e6c15aaa44b364a9$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $e6c15aaa44b364a9$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e6c15aaa44b364a9$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e6c15aaa44b364a9$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $e6c15aaa44b364a9$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e6c15aaa44b364a9$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e6c15aaa44b364a9$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $e6c15aaa44b364a9$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $e6c15aaa44b364a9$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $e6c15aaa44b364a9$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $e6c15aaa44b364a9$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $e6c15aaa44b364a9$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $e6c15aaa44b364a9$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e6c15aaa44b364a9$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $e6c15aaa44b364a9$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $e6c15aaa44b364a9$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e6c15aaa44b364a9$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $e6c15aaa44b364a9$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $e6c15aaa44b364a9$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $e6c15aaa44b364a9$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e6c15aaa44b364a9$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e6c15aaa44b364a9$var$isErrorResult(result) && $e6c15aaa44b364a9$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e6c15aaa44b364a9$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $e6c15aaa44b364a9$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$e6c15aaa44b364a9$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $e6c15aaa44b364a9$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $e6c15aaa44b364a9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $e6c15aaa44b364a9$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $e6c15aaa44b364a9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e6c15aaa44b364a9$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $e6c15aaa44b364a9$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
            let boundaryMatch = $e6c15aaa44b364a9$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $e6c15aaa44b364a9$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $e6c15aaa44b364a9$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $e6c15aaa44b364a9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $e6c15aaa44b364a9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$e6c15aaa44b364a9$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $e6c15aaa44b364a9$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $e6c15aaa44b364a9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $e6c15aaa44b364a9$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $e6c15aaa44b364a9$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $e6c15aaa44b364a9$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e6c15aaa44b364a9$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $e6c15aaa44b364a9$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e6c15aaa44b364a9$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e6c15aaa44b364a9$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e6c15aaa44b364a9$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $e6c15aaa44b364a9$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $e6c15aaa44b364a9$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($e6c15aaa44b364a9$var$isRedirectResult(actionResult) || $e6c15aaa44b364a9$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($e6c15aaa44b364a9$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e6c15aaa44b364a9$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($e6c15aaa44b364a9$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e6c15aaa44b364a9$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $e6c15aaa44b364a9$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $e6c15aaa44b364a9$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $e6c15aaa44b364a9$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $e6c15aaa44b364a9$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $e6c15aaa44b364a9$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $e6c15aaa44b364a9$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $e6c15aaa44b364a9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $e6c15aaa44b364a9$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $e6c15aaa44b364a9$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e6c15aaa44b364a9$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $e6c15aaa44b364a9$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e6c15aaa44b364a9$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e6c15aaa44b364a9$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $e6c15aaa44b364a9$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(void 0));
            return;
        }
        if ($e6c15aaa44b364a9$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $e6c15aaa44b364a9$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $e6c15aaa44b364a9$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $e6c15aaa44b364a9$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($e6c15aaa44b364a9$var$isAbsoluteUrl(location)) {
                const url = $e6c15aaa44b364a9$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e6c15aaa44b364a9$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e6c15aaa44b364a9$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($e6c15aaa44b364a9$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $e6c15aaa44b364a9$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $e6c15aaa44b364a9$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e6c15aaa44b364a9$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($e6c15aaa44b364a9$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $e6c15aaa44b364a9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $e6c15aaa44b364a9$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $e6c15aaa44b364a9$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $e6c15aaa44b364a9$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $e6c15aaa44b364a9$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $e6c15aaa44b364a9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $e6c15aaa44b364a9$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $e6c15aaa44b364a9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $e6c15aaa44b364a9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e6c15aaa44b364a9$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e6c15aaa44b364a9$export$386d57f03f0b2883;
        $e6c15aaa44b364a9$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $e6c15aaa44b364a9$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e6c15aaa44b364a9$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $e6c15aaa44b364a9$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$e6c15aaa44b364a9$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e6c15aaa44b364a9$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($e6c15aaa44b364a9$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $e6c15aaa44b364a9$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $e6c15aaa44b364a9$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $e6c15aaa44b364a9$export$3336b097a6fbc59a(routes, opts) {
    $e6c15aaa44b364a9$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $e6c15aaa44b364a9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$e6c15aaa44b364a9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $e6c15aaa44b364a9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $e6c15aaa44b364a9$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $e6c15aaa44b364a9$var$defaultNormalizePath;
        let method = request.method;
        let location = $e6c15aaa44b364a9$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $e6c15aaa44b364a9$export$b8d3e69d4b3eff04();
        if (!$e6c15aaa44b364a9$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e6c15aaa44b364a9$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e6c15aaa44b364a9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $e6c15aaa44b364a9$export$f5708dca728d7177(requestContext instanceof $e6c15aaa44b364a9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $e6c15aaa44b364a9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $e6c15aaa44b364a9$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $e6c15aaa44b364a9$var$createDataFunctionUrl(request, location),
                    pattern: $e6c15aaa44b364a9$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($e6c15aaa44b364a9$export$6e80290866a84dd4(error)) return error;
                    if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $e6c15aaa44b364a9$export$f2680fa305b734ca(error.status, error.statusText, await $e6c15aaa44b364a9$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(error)) error = $e6c15aaa44b364a9$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $e6c15aaa44b364a9$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $e6c15aaa44b364a9$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $e6c15aaa44b364a9$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $e6c15aaa44b364a9$var$defaultNormalizePath;
        let method = request.method;
        let location = $e6c15aaa44b364a9$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $e6c15aaa44b364a9$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $e6c15aaa44b364a9$export$b8d3e69d4b3eff04();
        if (!$e6c15aaa44b364a9$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e6c15aaa44b364a9$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e6c15aaa44b364a9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e6c15aaa44b364a9$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e6c15aaa44b364a9$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $e6c15aaa44b364a9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $e6c15aaa44b364a9$export$f5708dca728d7177(requestContext instanceof $e6c15aaa44b364a9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $e6c15aaa44b364a9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $e6c15aaa44b364a9$var$runServerMiddlewarePipeline({
                request: request,
                url: $e6c15aaa44b364a9$var$createDataFunctionUrl(request, location),
                pattern: $e6c15aaa44b364a9$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($e6c15aaa44b364a9$var$dataWithResponseInitToResponse(error));
                if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $e6c15aaa44b364a9$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $e6c15aaa44b364a9$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($e6c15aaa44b364a9$var$isDataStrategyResult(e) && $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($e6c15aaa44b364a9$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e6c15aaa44b364a9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e6c15aaa44b364a9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($e6c15aaa44b364a9$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($e6c15aaa44b364a9$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e6c15aaa44b364a9$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e6c15aaa44b364a9$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $e6c15aaa44b364a9$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $e6c15aaa44b364a9$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e6c15aaa44b364a9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $e6c15aaa44b364a9$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e6c15aaa44b364a9$var$callDataStrategyImpl(dataStrategy || $e6c15aaa44b364a9$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e6c15aaa44b364a9$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $e6c15aaa44b364a9$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(result.result)) throw $e6c15aaa44b364a9$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $e6c15aaa44b364a9$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $e6c15aaa44b364a9$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $e6c15aaa44b364a9$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $e6c15aaa44b364a9$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $e6c15aaa44b364a9$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $e6c15aaa44b364a9$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $e6c15aaa44b364a9$var$resolveTo(to ? to : ".", $e6c15aaa44b364a9$var$getResolveToMatches(contextualMatches), $e6c15aaa44b364a9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e6c15aaa44b364a9$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $e6c15aaa44b364a9$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $e6c15aaa44b364a9$export$fe53371bee54353d(path);
}
function $e6c15aaa44b364a9$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$e6c15aaa44b364a9$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e6c15aaa44b364a9$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e6c15aaa44b364a9$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e6c15aaa44b364a9$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $e6c15aaa44b364a9$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$e6c15aaa44b364a9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$e6c15aaa44b364a9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e6c15aaa44b364a9$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e6c15aaa44b364a9$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e6c15aaa44b364a9$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e6c15aaa44b364a9$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e6c15aaa44b364a9$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($e6c15aaa44b364a9$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $e6c15aaa44b364a9$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $e6c15aaa44b364a9$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $e6c15aaa44b364a9$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $e6c15aaa44b364a9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $e6c15aaa44b364a9$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$e6c15aaa44b364a9$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $e6c15aaa44b364a9$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($e6c15aaa44b364a9$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($e6c15aaa44b364a9$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $e6c15aaa44b364a9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $e6c15aaa44b364a9$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $e6c15aaa44b364a9$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $e6c15aaa44b364a9$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($e6c15aaa44b364a9$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $e6c15aaa44b364a9$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $e6c15aaa44b364a9$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$e6c15aaa44b364a9$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $e6c15aaa44b364a9$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $e6c15aaa44b364a9$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e6c15aaa44b364a9$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e6c15aaa44b364a9$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e6c15aaa44b364a9$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$e6c15aaa44b364a9$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $e6c15aaa44b364a9$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $e6c15aaa44b364a9$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $e6c15aaa44b364a9$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$e6c15aaa44b364a9$var$isSameRoute(aChild, bChild))) ?? false;
}
var $e6c15aaa44b364a9$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $e6c15aaa44b364a9$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $e6c15aaa44b364a9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $e6c15aaa44b364a9$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $e6c15aaa44b364a9$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $e6c15aaa44b364a9$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $e6c15aaa44b364a9$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $e6c15aaa44b364a9$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $e6c15aaa44b364a9$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $e6c15aaa44b364a9$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $e6c15aaa44b364a9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $e6c15aaa44b364a9$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $e6c15aaa44b364a9$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $e6c15aaa44b364a9$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $e6c15aaa44b364a9$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $e6c15aaa44b364a9$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $e6c15aaa44b364a9$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $e6c15aaa44b364a9$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $e6c15aaa44b364a9$var$isNonNullable(value) {
    return value !== void 0;
}
function $e6c15aaa44b364a9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $e6c15aaa44b364a9$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($e6c15aaa44b364a9$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $e6c15aaa44b364a9$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $e6c15aaa44b364a9$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $e6c15aaa44b364a9$var$defaultDataStrategy(args);
    return $e6c15aaa44b364a9$var$runClientMiddlewarePipeline(args, ()=>$e6c15aaa44b364a9$var$defaultDataStrategy(args));
}
function $e6c15aaa44b364a9$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $e6c15aaa44b364a9$var$runMiddlewarePipeline(args, handler, processResult, $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(result) ? $e6c15aaa44b364a9$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $e6c15aaa44b364a9$var$runClientMiddlewarePipeline(args, handler) {
    return $e6c15aaa44b364a9$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($e6c15aaa44b364a9$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $e6c15aaa44b364a9$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $e6c15aaa44b364a9$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $e6c15aaa44b364a9$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $e6c15aaa44b364a9$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $e6c15aaa44b364a9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $e6c15aaa44b364a9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $e6c15aaa44b364a9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $e6c15aaa44b364a9$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $e6c15aaa44b364a9$var$loadLazyRoute(match.route, $e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $e6c15aaa44b364a9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $e6c15aaa44b364a9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $e6c15aaa44b364a9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $e6c15aaa44b364a9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $e6c15aaa44b364a9$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $e6c15aaa44b364a9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $e6c15aaa44b364a9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $e6c15aaa44b364a9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $e6c15aaa44b364a9$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $e6c15aaa44b364a9$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $e6c15aaa44b364a9$var$createDataFunctionUrl(request, path),
        pattern: $e6c15aaa44b364a9$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $e6c15aaa44b364a9$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $e6c15aaa44b364a9$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $e6c15aaa44b364a9$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $e6c15aaa44b364a9$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e6c15aaa44b364a9$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e6c15aaa44b364a9$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e6c15aaa44b364a9$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $e6c15aaa44b364a9$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $e6c15aaa44b364a9$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $e6c15aaa44b364a9$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $e6c15aaa44b364a9$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $e6c15aaa44b364a9$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $e6c15aaa44b364a9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $e6c15aaa44b364a9$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e6c15aaa44b364a9$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e6c15aaa44b364a9$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $e6c15aaa44b364a9$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $e6c15aaa44b364a9$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($e6c15aaa44b364a9$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($e6c15aaa44b364a9$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $e6c15aaa44b364a9$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $e6c15aaa44b364a9$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($e6c15aaa44b364a9$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $e6c15aaa44b364a9$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e6c15aaa44b364a9$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e6c15aaa44b364a9$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $e6c15aaa44b364a9$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e6c15aaa44b364a9$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $e6c15aaa44b364a9$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e6c15aaa44b364a9$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e6c15aaa44b364a9$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e6c15aaa44b364a9$export$f5708dca728d7177(!$e6c15aaa44b364a9$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $e6c15aaa44b364a9$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $e6c15aaa44b364a9$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $e6c15aaa44b364a9$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e6c15aaa44b364a9$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $e6c15aaa44b364a9$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $e6c15aaa44b364a9$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($e6c15aaa44b364a9$var$isErrorResult(result)) {
            let boundaryMatch = $e6c15aaa44b364a9$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($e6c15aaa44b364a9$var$isRedirectResult(result)) $e6c15aaa44b364a9$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $e6c15aaa44b364a9$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e6c15aaa44b364a9$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $e6c15aaa44b364a9$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e6c15aaa44b364a9$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e6c15aaa44b364a9$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $e6c15aaa44b364a9$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e6c15aaa44b364a9$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e6c15aaa44b364a9$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $e6c15aaa44b364a9$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $e6c15aaa44b364a9$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e6c15aaa44b364a9$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e6c15aaa44b364a9$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(path) : path;
    return $e6c15aaa44b364a9$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $e6c15aaa44b364a9$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $e6c15aaa44b364a9$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $e6c15aaa44b364a9$var$dataWithResponseInitToErrorResponse(data2) {
    return new $e6c15aaa44b364a9$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $e6c15aaa44b364a9$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $e6c15aaa44b364a9$var$isDataStrategyResult(value));
}
function $e6c15aaa44b364a9$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $e6c15aaa44b364a9$var$isRedirectDataStrategyResult(result) {
    return $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result.result) && $e6c15aaa44b364a9$var$redirectStatusCodes.has(result.result.status);
}
function $e6c15aaa44b364a9$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $e6c15aaa44b364a9$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e6c15aaa44b364a9$export$794b2760043cf8cd(statusCode) {
    return $e6c15aaa44b364a9$var$redirectStatusCodes.has(statusCode);
}
function $e6c15aaa44b364a9$export$6e80290866a84dd4(result) {
    return $e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result) && $e6c15aaa44b364a9$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $e6c15aaa44b364a9$var$isValidMethod(method) {
    return $e6c15aaa44b364a9$var$validRequestMethods.has(method.toUpperCase());
}
function $e6c15aaa44b364a9$export$cbae47800eb95bc3(method) {
    return $e6c15aaa44b364a9$var$validMutationMethods.has(method.toUpperCase());
}
function $e6c15aaa44b364a9$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e6c15aaa44b364a9$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e6c15aaa44b364a9$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $e6c15aaa44b364a9$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e6c15aaa44b364a9$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $e6c15aaa44b364a9$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $e6c15aaa44b364a9$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e6c15aaa44b364a9$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $e6c15aaa44b364a9$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $e6c15aaa44b364a9$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $e6c15aaa44b364a9$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e6c15aaa44b364a9$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $e6c15aaa44b364a9$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e6c15aaa44b364a9$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e6c15aaa44b364a9$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $e6c15aaa44b364a9$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $e6c15aaa44b364a9$export$2eeee58951ff3c1c = $bNh2M.createContext(null);
$e6c15aaa44b364a9$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $e6c15aaa44b364a9$export$315e3ffb01f217 = $bNh2M.createContext(null);
$e6c15aaa44b364a9$export$315e3ffb01f217.displayName = "DataRouterState";
var $e6c15aaa44b364a9$export$717f757c655223f1 = $bNh2M.createContext(false);
function $e6c15aaa44b364a9$var$useIsRSCRouterContext() {
    return $bNh2M.useContext($e6c15aaa44b364a9$export$717f757c655223f1);
}
var $e6c15aaa44b364a9$export$3681f408decb40d1 = $bNh2M.createContext({
    isTransitioning: false
});
$e6c15aaa44b364a9$export$3681f408decb40d1.displayName = "ViewTransition";
var $e6c15aaa44b364a9$export$cb3f1df1bef00a39 = $bNh2M.createContext(/* @__PURE__ */ new Map());
$e6c15aaa44b364a9$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $e6c15aaa44b364a9$var$AwaitContext = $bNh2M.createContext(null);
$e6c15aaa44b364a9$var$AwaitContext.displayName = "Await";
var $e6c15aaa44b364a9$export$2666c20e15407622 = (props)=>$bNh2M.createElement($e6c15aaa44b364a9$var$AwaitContext.Provider, props);
var $e6c15aaa44b364a9$export$3044ab7fdabeaee6 = $bNh2M.createContext(null);
$e6c15aaa44b364a9$export$3044ab7fdabeaee6.displayName = "Navigation";
var $e6c15aaa44b364a9$export$e6a44b110a0c44d3 = $bNh2M.createContext(null);
$e6c15aaa44b364a9$export$e6a44b110a0c44d3.displayName = "Location";
var $e6c15aaa44b364a9$export$aac280ed165a4397 = $bNh2M.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$e6c15aaa44b364a9$export$aac280ed165a4397.displayName = "Route";
var $e6c15aaa44b364a9$var$RouteErrorContext = $bNh2M.createContext(null);
$e6c15aaa44b364a9$var$RouteErrorContext.displayName = "RouteError";
var $e6c15aaa44b364a9$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $e6c15aaa44b364a9$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $e6c15aaa44b364a9$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $e6c15aaa44b364a9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $e6c15aaa44b364a9$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$e6c15aaa44b364a9$var$ERROR_DIGEST_BASE}:${$e6c15aaa44b364a9$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $e6c15aaa44b364a9$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$e6c15aaa44b364a9$var$ERROR_DIGEST_BASE}:${$e6c15aaa44b364a9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $e6c15aaa44b364a9$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $e6c15aaa44b364a9$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $e6c15aaa44b364a9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $e6c15aaa44b364a9$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $e6c15aaa44b364a9$export$9c954a9d03d32f4a() {
    return $bNh2M.useContext($e6c15aaa44b364a9$export$e6a44b110a0c44d3) != null;
}
function $e6c15aaa44b364a9$export$45d76561a5302f2b() {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $bNh2M.useContext($e6c15aaa44b364a9$export$e6a44b110a0c44d3).location;
}
function $e6c15aaa44b364a9$export$1b3f31771c5d07c() {
    return $bNh2M.useContext($e6c15aaa44b364a9$export$e6a44b110a0c44d3).navigationType;
}
function $e6c15aaa44b364a9$export$6c330e8992e8a295(pattern) {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    return $bNh2M.useMemo(()=>$e6c15aaa44b364a9$export$81336c211d5ff295(pattern, $e6c15aaa44b364a9$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $e6c15aaa44b364a9$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $e6c15aaa44b364a9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6).static;
    if (!isStatic) $bNh2M.useLayoutEffect(cb);
}
function $e6c15aaa44b364a9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    return isDataRoute ? $e6c15aaa44b364a9$var$useNavigateStable() : $e6c15aaa44b364a9$var$useNavigateUnstable();
}
function $e6c15aaa44b364a9$var$useNavigateUnstable() {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let { matches: matches } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($e6c15aaa44b364a9$var$getResolveToMatches(matches));
    let activeRef = $bNh2M.useRef(false);
    $e6c15aaa44b364a9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bNh2M.useCallback((to, options = {})=>{
        $e6c15aaa44b364a9$var$warning(activeRef.current, $e6c15aaa44b364a9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $e6c15aaa44b364a9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e6c15aaa44b364a9$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $e6c15aaa44b364a9$var$OutletContext = $bNh2M.createContext(null);
function $e6c15aaa44b364a9$export$4138103a3ae699cc() {
    return $bNh2M.useContext($e6c15aaa44b364a9$var$OutletContext);
}
function $e6c15aaa44b364a9$export$a3be3530d8e40d0b(context) {
    let outlet = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397).outlet;
    return $bNh2M.useMemo(()=>outlet && /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $e6c15aaa44b364a9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $e6c15aaa44b364a9$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($e6c15aaa44b364a9$var$getResolveToMatches(matches));
    return $bNh2M.useMemo(()=>$e6c15aaa44b364a9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $e6c15aaa44b364a9$export$5d3fca4a98652595(routes, locationArg) {
    return $e6c15aaa44b364a9$var$useRoutesImpl(routes, locationArg);
}
function $e6c15aaa44b364a9$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $e6c15aaa44b364a9$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $e6c15aaa44b364a9$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $e6c15aaa44b364a9$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $e6c15aaa44b364a9$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
        $e6c15aaa44b364a9$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $e6c15aaa44b364a9$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $e6c15aaa44b364a9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $e6c15aaa44b364a9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $e6c15aaa44b364a9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $e6c15aaa44b364a9$var$DefaultErrorComponent() {
    let error = $e6c15aaa44b364a9$export$ed527bf60f6e05f2();
    let message = $e6c15aaa44b364a9$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, /* @__PURE__ */ $bNh2M.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $bNh2M.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $bNh2M.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $bNh2M.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, /* @__PURE__ */ $bNh2M.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $bNh2M.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $bNh2M.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $e6c15aaa44b364a9$var$defaultErrorElement = /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$DefaultErrorComponent, null);
var $e6c15aaa44b364a9$var$RenderErrorBoundary = class extends $bNh2M.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $e6c15aaa44b364a9$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$e6c15aaa44b364a9$var$RenderErrorBoundary.contextType = $e6c15aaa44b364a9$export$717f757c655223f1;
var $e6c15aaa44b364a9$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $e6c15aaa44b364a9$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $e6c15aaa44b364a9$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $e6c15aaa44b364a9$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $e6c15aaa44b364a9$var$parseToInfo(redirect2.location, basename);
            if ($e6c15aaa44b364a9$var$isBrowser && !$e6c15aaa44b364a9$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $e6c15aaa44b364a9$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $bNh2M.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $e6c15aaa44b364a9$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $e6c15aaa44b364a9$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $e6c15aaa44b364a9$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $e6c15aaa44b364a9$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $e6c15aaa44b364a9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $e6c15aaa44b364a9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $bNh2M.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $e6c15aaa44b364a9$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $e6c15aaa44b364a9$var$useDataRouterContext(hookName) {
    let ctx = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    $e6c15aaa44b364a9$export$f5708dca728d7177(ctx, $e6c15aaa44b364a9$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $e6c15aaa44b364a9$var$useDataRouterState(hookName) {
    let state = $bNh2M.useContext($e6c15aaa44b364a9$export$315e3ffb01f217);
    $e6c15aaa44b364a9$export$f5708dca728d7177(state, $e6c15aaa44b364a9$var$getDataRouterConsoleError(hookName));
    return state;
}
function $e6c15aaa44b364a9$var$useRouteContext(hookName) {
    let route = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    $e6c15aaa44b364a9$export$f5708dca728d7177(route, $e6c15aaa44b364a9$var$getDataRouterConsoleError(hookName));
    return route;
}
function $e6c15aaa44b364a9$var$useCurrentRouteId(hookName) {
    let route = $e6c15aaa44b364a9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $e6c15aaa44b364a9$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $e6c15aaa44b364a9$var$useRouteId() {
    return $e6c15aaa44b364a9$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $e6c15aaa44b364a9$export$d0fd4b7106de2769() {
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $bNh2M.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $e6c15aaa44b364a9$export$600dc272ed516c15() {
    let dataRouterContext = $e6c15aaa44b364a9$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $bNh2M.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $bNh2M.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $e6c15aaa44b364a9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $e6c15aaa44b364a9$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $bNh2M.useMemo(()=>matches.map((m)=>$e6c15aaa44b364a9$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $e6c15aaa44b364a9$export$1448a5050d252c4d() {
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $e6c15aaa44b364a9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $e6c15aaa44b364a9$export$fd5d37484eab868d(routeId) {
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $e6c15aaa44b364a9$export$fdc00f3f26066d5e() {
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $e6c15aaa44b364a9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $e6c15aaa44b364a9$export$ed527bf60f6e05f2() {
    let error = $bNh2M.useContext($e6c15aaa44b364a9$var$RouteErrorContext);
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $e6c15aaa44b364a9$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $e6c15aaa44b364a9$export$78a72ddb39bdd145() {
    let value = $bNh2M.useContext($e6c15aaa44b364a9$var$AwaitContext);
    return value?._data;
}
function $e6c15aaa44b364a9$export$17f53340677d5831() {
    let value = $bNh2M.useContext($e6c15aaa44b364a9$var$AwaitContext);
    return value?._error;
}
var $e6c15aaa44b364a9$var$blockerId = 0;
function $e6c15aaa44b364a9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $e6c15aaa44b364a9$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $e6c15aaa44b364a9$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $bNh2M.useState("");
    let blockerFunction = $bNh2M.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $e6c15aaa44b364a9$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $e6c15aaa44b364a9$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $bNh2M.useEffect(()=>{
        let key = String(++$e6c15aaa44b364a9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $bNh2M.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $e6c15aaa44b364a9$export$386d57f03f0b2883;
}
function $e6c15aaa44b364a9$var$useNavigateStable() {
    let { router: router } = $e6c15aaa44b364a9$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $e6c15aaa44b364a9$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $bNh2M.useRef(false);
    $e6c15aaa44b364a9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bNh2M.useCallback(async (to, options = {})=>{
        $e6c15aaa44b364a9$var$warning(activeRef.current, $e6c15aaa44b364a9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $e6c15aaa44b364a9$var$alreadyWarned = {};
function $e6c15aaa44b364a9$var$warningOnce(key, cond, message) {
    if (!cond && !$e6c15aaa44b364a9$var$alreadyWarned[key]) {
        $e6c15aaa44b364a9$var$alreadyWarned[key] = true;
        $e6c15aaa44b364a9$var$warning(false, message);
    }
}
function $e6c15aaa44b364a9$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $e6c15aaa44b364a9$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $e6c15aaa44b364a9$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $e6c15aaa44b364a9$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $e6c15aaa44b364a9$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $e6c15aaa44b364a9$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $bNh2M.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$e6c15aaa44b364a9$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $bNh2M.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$e6c15aaa44b364a9$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $bNh2M.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $e6c15aaa44b364a9$var$alreadyWarned2 = {};
function $e6c15aaa44b364a9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$e6c15aaa44b364a9$var$alreadyWarned2[message]) {
        $e6c15aaa44b364a9$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $e6c15aaa44b364a9$var$USE_OPTIMISTIC = "useOptimistic";
var $e6c15aaa44b364a9$var$useOptimisticImpl = $bNh2M[$e6c15aaa44b364a9$var$USE_OPTIMISTIC];
var $e6c15aaa44b364a9$var$stableUseOptimisticSetter = ()=>void 0;
function $e6c15aaa44b364a9$var$useOptimisticSafe(val) {
    if ($e6c15aaa44b364a9$var$useOptimisticImpl) return $e6c15aaa44b364a9$var$useOptimisticImpl(val);
    else return [
        val,
        $e6c15aaa44b364a9$var$stableUseOptimisticSetter
    ];
}
function $e6c15aaa44b364a9$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
            if (route.element) $e6c15aaa44b364a9$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $bNh2M.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $e6c15aaa44b364a9$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $bNh2M.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($e6c15aaa44b364a9$export$945fecf35a8ef089) {
            if (route.errorElement) $e6c15aaa44b364a9$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $bNh2M.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $e6c15aaa44b364a9$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $e6c15aaa44b364a9$export$f30f7e456d254e83(routes, opts) {
    return $e6c15aaa44b364a9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $e6c15aaa44b364a9$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $e6c15aaa44b364a9$export$e2fd2c03906469db,
        mapRouteProperties: $e6c15aaa44b364a9$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $e6c15aaa44b364a9$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $e6c15aaa44b364a9$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $e6c15aaa44b364a9$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $bNh2M.useState(router.state);
    let [state, setOptimisticState] = $e6c15aaa44b364a9$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $bNh2M.useState();
    let [vtContext, setVtContext] = $bNh2M.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bNh2M.useState();
    let [transition, setTransition] = $bNh2M.useState();
    let [interruption, setInterruption] = $bNh2M.useState();
    let fetcherData = $bNh2M.useRef(/* @__PURE__ */ new Map());
    let setState = $bNh2M.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $e6c15aaa44b364a9$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $e6c15aaa44b364a9$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $e6c15aaa44b364a9$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $bNh2M.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$e6c15aaa44b364a9$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $bNh2M.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bNh2M.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $e6c15aaa44b364a9$var$Deferred());
    }, [
        vtContext
    ]);
    $bNh2M.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $bNh2M.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$e6c15aaa44b364a9$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $bNh2M.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $bNh2M.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $bNh2M.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bNh2M.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $e6c15aaa44b364a9$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $e6c15aaa44b364a9$var$MemoizedDataRoutes = $bNh2M.memo($e6c15aaa44b364a9$var$DataRoutes2);
function $e6c15aaa44b364a9$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $e6c15aaa44b364a9$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $e6c15aaa44b364a9$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $bNh2M.useRef();
    if (historyRef.current == null) historyRef.current = $e6c15aaa44b364a9$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bNh2M.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bNh2M.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bNh2M.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bNh2M.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $e6c15aaa44b364a9$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $e6c15aaa44b364a9$export$f5708dca728d7177($e6c15aaa44b364a9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    $e6c15aaa44b364a9$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let navigate = $e6c15aaa44b364a9$export$9770f232ac06a008();
    let path = $e6c15aaa44b364a9$var$resolveTo(to, $e6c15aaa44b364a9$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bNh2M.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $e6c15aaa44b364a9$export$910ae8079b2c2852(props) {
    return $e6c15aaa44b364a9$export$a3be3530d8e40d0b(props.context);
}
function $e6c15aaa44b364a9$export$e7b0ac011bb776c6(props) {
    $e6c15aaa44b364a9$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $e6c15aaa44b364a9$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $e6c15aaa44b364a9$export$f5708dca728d7177(!$e6c15aaa44b364a9$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bNh2M.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $e6c15aaa44b364a9$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $bNh2M.useMemo(()=>{
        let trailingPathname = $e6c15aaa44b364a9$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $e6c15aaa44b364a9$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $e6c15aaa44b364a9$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $e6c15aaa44b364a9$export$5d3fca4a98652595($e6c15aaa44b364a9$export$16da398f5434bdec(children), location);
}
function $e6c15aaa44b364a9$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $bNh2M.useContext($e6c15aaa44b364a9$export$315e3ffb01f217);
    let onError = $bNh2M.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $e6c15aaa44b364a9$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$ResolveAwait, null, children));
}
var $e6c15aaa44b364a9$var$AwaitErrorBoundary = class extends $bNh2M.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $e6c15aaa44b364a9$var$ResolveAwait({ children: children }) {
    let data2 = $e6c15aaa44b364a9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, toRender);
}
function $e6c15aaa44b364a9$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $bNh2M.Children.forEach(children, (element, index)=>{
        if (!$bNh2M.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bNh2M.Fragment) {
            routes.push.apply(routes, $e6c15aaa44b364a9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $e6c15aaa44b364a9$export$f5708dca728d7177(element.type === $e6c15aaa44b364a9$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $e6c15aaa44b364a9$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $e6c15aaa44b364a9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $e6c15aaa44b364a9$export$9b5b6d122dea0c88 = $e6c15aaa44b364a9$export$16da398f5434bdec;
function $e6c15aaa44b364a9$export$daf73786167a7f72(matches) {
    return $e6c15aaa44b364a9$var$_renderMatches(matches);
}
function $e6c15aaa44b364a9$var$useRouteComponentProps() {
    return {
        params: $e6c15aaa44b364a9$export$99eaa27ddbbb95ef(),
        loaderData: $e6c15aaa44b364a9$export$1448a5050d252c4d(),
        actionData: $e6c15aaa44b364a9$export$fdc00f3f26066d5e(),
        matches: $e6c15aaa44b364a9$export$2378eb7f5ff86053()
    };
}
function $e6c15aaa44b364a9$export$6c4f3826290c37af({ children: children }) {
    const props = $e6c15aaa44b364a9$var$useRouteComponentProps();
    return $bNh2M.cloneElement(children, props);
}
function $e6c15aaa44b364a9$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $e6c15aaa44b364a9$var$useRouteComponentProps();
        return $bNh2M.createElement(Component4, props);
    };
}
function $e6c15aaa44b364a9$var$useHydrateFallbackProps() {
    return {
        params: $e6c15aaa44b364a9$export$99eaa27ddbbb95ef(),
        loaderData: $e6c15aaa44b364a9$export$1448a5050d252c4d(),
        actionData: $e6c15aaa44b364a9$export$fdc00f3f26066d5e()
    };
}
function $e6c15aaa44b364a9$export$f8cff34f39c1932a({ children: children }) {
    const props = $e6c15aaa44b364a9$var$useHydrateFallbackProps();
    return $bNh2M.cloneElement(children, props);
}
function $e6c15aaa44b364a9$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $e6c15aaa44b364a9$var$useHydrateFallbackProps();
        return $bNh2M.createElement(HydrateFallback, props);
    };
}
function $e6c15aaa44b364a9$var$useErrorBoundaryProps() {
    return {
        params: $e6c15aaa44b364a9$export$99eaa27ddbbb95ef(),
        loaderData: $e6c15aaa44b364a9$export$1448a5050d252c4d(),
        actionData: $e6c15aaa44b364a9$export$fdc00f3f26066d5e(),
        error: $e6c15aaa44b364a9$export$ed527bf60f6e05f2()
    };
}
function $e6c15aaa44b364a9$export$e5afde5c4b6d747b({ children: children }) {
    const props = $e6c15aaa44b364a9$var$useErrorBoundaryProps();
    return $bNh2M.cloneElement(children, props);
}
function $e6c15aaa44b364a9$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $e6c15aaa44b364a9$var$useErrorBoundaryProps();
        return $bNh2M.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $e6c15aaa44b364a9$var$defaultMethod = "get";
var $e6c15aaa44b364a9$var$defaultEncType = "application/x-www-form-urlencoded";
function $e6c15aaa44b364a9$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $e6c15aaa44b364a9$var$isButtonElement(object) {
    return $e6c15aaa44b364a9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e6c15aaa44b364a9$var$isFormElement(object) {
    return $e6c15aaa44b364a9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e6c15aaa44b364a9$var$isInputElement(object) {
    return $e6c15aaa44b364a9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e6c15aaa44b364a9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e6c15aaa44b364a9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e6c15aaa44b364a9$var$isModifiedEvent(event);
}
function $e6c15aaa44b364a9$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e6c15aaa44b364a9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e6c15aaa44b364a9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $e6c15aaa44b364a9$var$_formDataSupportsSubmitter = null;
function $e6c15aaa44b364a9$var$isFormDataSubmitterSupported() {
    if ($e6c15aaa44b364a9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $e6c15aaa44b364a9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $e6c15aaa44b364a9$var$_formDataSupportsSubmitter = true;
    }
    return $e6c15aaa44b364a9$var$_formDataSupportsSubmitter;
}
var $e6c15aaa44b364a9$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $e6c15aaa44b364a9$var$getFormEncType(encType) {
    if (encType != null && !$e6c15aaa44b364a9$var$supportedFormEncTypes.has(encType)) {
        $e6c15aaa44b364a9$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$e6c15aaa44b364a9$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $e6c15aaa44b364a9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($e6c15aaa44b364a9$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $e6c15aaa44b364a9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $e6c15aaa44b364a9$var$defaultMethod;
        encType = $e6c15aaa44b364a9$var$getFormEncType(target.getAttribute("enctype")) || $e6c15aaa44b364a9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($e6c15aaa44b364a9$var$isButtonElement(target) || $e6c15aaa44b364a9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $e6c15aaa44b364a9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $e6c15aaa44b364a9$var$defaultMethod;
        encType = $e6c15aaa44b364a9$var$getFormEncType(target.getAttribute("formenctype")) || $e6c15aaa44b364a9$var$getFormEncType(form.getAttribute("enctype")) || $e6c15aaa44b364a9$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$e6c15aaa44b364a9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($e6c15aaa44b364a9$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $e6c15aaa44b364a9$var$defaultMethod;
        action = null;
        encType = $e6c15aaa44b364a9$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $e6c15aaa44b364a9$var$HOLE = -1;
var $e6c15aaa44b364a9$var$NAN = -2;
var $e6c15aaa44b364a9$var$NEGATIVE_INFINITY = -3;
var $e6c15aaa44b364a9$var$NEGATIVE_ZERO = -4;
var $e6c15aaa44b364a9$var$NULL = -5;
var $e6c15aaa44b364a9$var$POSITIVE_INFINITY = -6;
var $e6c15aaa44b364a9$var$UNDEFINED = -7;
var $e6c15aaa44b364a9$var$TYPE_BIGINT = "B";
var $e6c15aaa44b364a9$var$TYPE_DATE = "D";
var $e6c15aaa44b364a9$var$TYPE_ERROR = "E";
var $e6c15aaa44b364a9$var$TYPE_MAP = "M";
var $e6c15aaa44b364a9$var$TYPE_NULL_OBJECT = "N";
var $e6c15aaa44b364a9$var$TYPE_PROMISE = "P";
var $e6c15aaa44b364a9$var$TYPE_REGEXP = "R";
var $e6c15aaa44b364a9$var$TYPE_SET = "S";
var $e6c15aaa44b364a9$var$TYPE_SYMBOL = "Y";
var $e6c15aaa44b364a9$var$TYPE_URL = "U";
var $e6c15aaa44b364a9$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $e6c15aaa44b364a9$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $e6c15aaa44b364a9$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $e6c15aaa44b364a9$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $e6c15aaa44b364a9$var$TIME_LIMIT_MS = 1;
var $e6c15aaa44b364a9$var$getNow = ()=>Date.now();
var $e6c15aaa44b364a9$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $e6c15aaa44b364a9$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $e6c15aaa44b364a9$var$UNDEFINED;
    if (input === null) return $e6c15aaa44b364a9$var$NULL;
    if (Number.isNaN(input)) return $e6c15aaa44b364a9$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $e6c15aaa44b364a9$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $e6c15aaa44b364a9$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $e6c15aaa44b364a9$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $e6c15aaa44b364a9$var$stringify.call(this, stack);
    return index;
}
async function $e6c15aaa44b364a9$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $e6c15aaa44b364a9$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $e6c15aaa44b364a9$var$UNDEFINED;
        if (value === null) return $e6c15aaa44b364a9$var$NULL;
        if (Number.isNaN(value)) return $e6c15aaa44b364a9$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $e6c15aaa44b364a9$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $e6c15aaa44b364a9$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $e6c15aaa44b364a9$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $e6c15aaa44b364a9$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $e6c15aaa44b364a9$var$TIME_LIMIT_MS) {
            await $e6c15aaa44b364a9$var$yieldToMain();
            lastYieldTime = $e6c15aaa44b364a9$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$e6c15aaa44b364a9$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$e6c15aaa44b364a9$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$e6c15aaa44b364a9$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $e6c15aaa44b364a9$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$e6c15aaa44b364a9$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$e6c15aaa44b364a9$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$e6c15aaa44b364a9$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$e6c15aaa44b364a9$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$e6c15aaa44b364a9$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$e6c15aaa44b364a9$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$e6c15aaa44b364a9$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$e6c15aaa44b364a9$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$e6c15aaa44b364a9$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$e6c15aaa44b364a9$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($e6c15aaa44b364a9$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $e6c15aaa44b364a9$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $e6c15aaa44b364a9$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $e6c15aaa44b364a9$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $e6c15aaa44b364a9$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $e6c15aaa44b364a9$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $e6c15aaa44b364a9$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $e6c15aaa44b364a9$var$hydrate.call(this, startIndex);
}
function $e6c15aaa44b364a9$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $e6c15aaa44b364a9$var$UNDEFINED:
                set(void 0);
                continue;
            case $e6c15aaa44b364a9$var$NULL:
                set(null);
                continue;
            case $e6c15aaa44b364a9$var$NAN:
                set(NaN);
                continue;
            case $e6c15aaa44b364a9$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $e6c15aaa44b364a9$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $e6c15aaa44b364a9$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $e6c15aaa44b364a9$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $e6c15aaa44b364a9$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $e6c15aaa44b364a9$var$globalObj && $e6c15aaa44b364a9$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $e6c15aaa44b364a9$var$globalObj && typeof $e6c15aaa44b364a9$var$globalObj[errorType] === "function" ? new $e6c15aaa44b364a9$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $e6c15aaa44b364a9$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $e6c15aaa44b364a9$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $e6c15aaa44b364a9$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $e6c15aaa44b364a9$var$Deferred2();
    const reader = readable.pipeThrough($e6c15aaa44b364a9$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $e6c15aaa44b364a9$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $e6c15aaa44b364a9$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $e6c15aaa44b364a9$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $e6c15aaa44b364a9$var$unflatten.call(this, line)
    };
}
async function $e6c15aaa44b364a9$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $e6c15aaa44b364a9$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $e6c15aaa44b364a9$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $e6c15aaa44b364a9$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $e6c15aaa44b364a9$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $e6c15aaa44b364a9$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $e6c15aaa44b364a9$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $e6c15aaa44b364a9$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_PROMISE}${deferredId}:[["${$e6c15aaa44b364a9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $e6c15aaa44b364a9$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_ERROR}${deferredId}:[["${$e6c15aaa44b364a9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$e6c15aaa44b364a9$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $e6c15aaa44b364a9$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $e6c15aaa44b364a9$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $e6c15aaa44b364a9$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $e6c15aaa44b364a9$export$4cf11838cdc2a8a8(html) {
    return html.replace($e6c15aaa44b364a9$var$ESCAPE_REGEX, (match)=>$e6c15aaa44b364a9$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $e6c15aaa44b364a9$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $e6c15aaa44b364a9$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $e6c15aaa44b364a9$var$SingleFetchNoResultError = class extends Error {
};
var $e6c15aaa44b364a9$export$ae9272e641ead836 = 202;
var $e6c15aaa44b364a9$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $e6c15aaa44b364a9$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $bNh2M.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$e6c15aaa44b364a9$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, scriptTag, /* @__PURE__ */ $bNh2M.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, scriptTag, /* @__PURE__ */ $bNh2M.createElement($bNh2M.Suspense, null, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $e6c15aaa44b364a9$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $e6c15aaa44b364a9$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $e6c15aaa44b364a9$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $e6c15aaa44b364a9$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $e6c15aaa44b364a9$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $e6c15aaa44b364a9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $e6c15aaa44b364a9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $e6c15aaa44b364a9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $e6c15aaa44b364a9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $e6c15aaa44b364a9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $e6c15aaa44b364a9$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $e6c15aaa44b364a9$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($e6c15aaa44b364a9$export$3f1eb41d9a6a6a27(result.result) || $e6c15aaa44b364a9$export$972111febbeef05b(result.result) || $e6c15aaa44b364a9$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $e6c15aaa44b364a9$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $e6c15aaa44b364a9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $e6c15aaa44b364a9$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $e6c15aaa44b364a9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$e6c15aaa44b364a9$var$createDeferred2());
    let singleFetchDfd = $e6c15aaa44b364a9$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $e6c15aaa44b364a9$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $e6c15aaa44b364a9$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $e6c15aaa44b364a9$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $e6c15aaa44b364a9$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $e6c15aaa44b364a9$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $e6c15aaa44b364a9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $e6c15aaa44b364a9$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $e6c15aaa44b364a9$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $e6c15aaa44b364a9$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $e6c15aaa44b364a9$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $e6c15aaa44b364a9$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$e6c15aaa44b364a9$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$e6c15aaa44b364a9$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $e6c15aaa44b364a9$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $e6c15aaa44b364a9$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $e6c15aaa44b364a9$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $e6c15aaa44b364a9$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $e6c15aaa44b364a9$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $e6c15aaa44b364a9$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($e6c15aaa44b364a9$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $e6c15aaa44b364a9$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $e6c15aaa44b364a9$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($e6c15aaa44b364a9$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$e6c15aaa44b364a9$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $e6c15aaa44b364a9$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $e6c15aaa44b364a9$export$4023ad4ecd4126a2(body, global) {
    return $e6c15aaa44b364a9$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $e6c15aaa44b364a9$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $e6c15aaa44b364a9$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$e6c15aaa44b364a9$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $e6c15aaa44b364a9$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $e6c15aaa44b364a9$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $e6c15aaa44b364a9$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $e6c15aaa44b364a9$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $e6c15aaa44b364a9$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $e6c15aaa44b364a9$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $e6c15aaa44b364a9$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $e6c15aaa44b364a9$var$getModuleLinkHrefs(matches, manifest);
    return $e6c15aaa44b364a9$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $e6c15aaa44b364a9$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $e6c15aaa44b364a9$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $e6c15aaa44b364a9$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($e6c15aaa44b364a9$var$prefetchStyleLink));
}
async function $e6c15aaa44b364a9$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$e6c15aaa44b364a9$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$e6c15aaa44b364a9$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$e6c15aaa44b364a9$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($e6c15aaa44b364a9$var$prefetchStyleLink));
}
async function $e6c15aaa44b364a9$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $e6c15aaa44b364a9$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $e6c15aaa44b364a9$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $e6c15aaa44b364a9$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $e6c15aaa44b364a9$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $e6c15aaa44b364a9$var$dedupeLinkDescriptors(links.flat(1).filter($e6c15aaa44b364a9$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $e6c15aaa44b364a9$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $e6c15aaa44b364a9$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $e6c15aaa44b364a9$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $e6c15aaa44b364a9$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $e6c15aaa44b364a9$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $e6c15aaa44b364a9$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$e6c15aaa44b364a9$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($e6c15aaa44b364a9$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $e6c15aaa44b364a9$var$_isPreloadSupported;
function $e6c15aaa44b364a9$var$isPreloadSupported() {
    if ($e6c15aaa44b364a9$var$_isPreloadSupported !== void 0) return $e6c15aaa44b364a9$var$_isPreloadSupported;
    let el = document.createElement("link");
    $e6c15aaa44b364a9$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $e6c15aaa44b364a9$var$_isPreloadSupported;
}
function $e6c15aaa44b364a9$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $e6c15aaa44b364a9$export$945fecf35a8ef089 ? /* @__PURE__ */ $bNh2M.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $e6c15aaa44b364a9$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $e6c15aaa44b364a9$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $e6c15aaa44b364a9$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $e6c15aaa44b364a9$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RemixRootDefaultErrorBoundary, {
            error: $e6c15aaa44b364a9$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $bNh2M.createElement(routeModule.Layout, null, /* @__PURE__ */ $bNh2M.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $bNh2M.createElement(routeModule.Layout, null, /* @__PURE__ */ $bNh2M.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $bNh2M.createElement(routeModule.Layout, null, /* @__PURE__ */ $bNh2M.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $e6c15aaa44b364a9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $e6c15aaa44b364a9$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $e6c15aaa44b364a9$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$e6c15aaa44b364a9$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $e6c15aaa44b364a9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $e6c15aaa44b364a9$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $e6c15aaa44b364a9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $e6c15aaa44b364a9$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $e6c15aaa44b364a9$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $e6c15aaa44b364a9$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $e6c15aaa44b364a9$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $e6c15aaa44b364a9$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $e6c15aaa44b364a9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $e6c15aaa44b364a9$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $e6c15aaa44b364a9$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $e6c15aaa44b364a9$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $e6c15aaa44b364a9$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$e6c15aaa44b364a9$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $e6c15aaa44b364a9$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $e6c15aaa44b364a9$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $e6c15aaa44b364a9$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $e6c15aaa44b364a9$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $e6c15aaa44b364a9$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $e6c15aaa44b364a9$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $e6c15aaa44b364a9$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $e6c15aaa44b364a9$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $e6c15aaa44b364a9$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $e6c15aaa44b364a9$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $e6c15aaa44b364a9$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $e6c15aaa44b364a9$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $e6c15aaa44b364a9$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $e6c15aaa44b364a9$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $e6c15aaa44b364a9$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $e6c15aaa44b364a9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $e6c15aaa44b364a9$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $e6c15aaa44b364a9$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $e6c15aaa44b364a9$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $e6c15aaa44b364a9$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $e6c15aaa44b364a9$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $e6c15aaa44b364a9$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $e6c15aaa44b364a9$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $e6c15aaa44b364a9$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $e6c15aaa44b364a9$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $e6c15aaa44b364a9$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $e6c15aaa44b364a9$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $e6c15aaa44b364a9$var$nextPaths = /* @__PURE__ */ new Set();
var $e6c15aaa44b364a9$var$discoveredPathsMaxSize = 1e3;
var $e6c15aaa44b364a9$var$discoveredPaths = /* @__PURE__ */ new Set();
var $e6c15aaa44b364a9$export$b5915cf27fa06b9f = 7680;
function $e6c15aaa44b364a9$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $e6c15aaa44b364a9$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $e6c15aaa44b364a9$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $e6c15aaa44b364a9$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$e6c15aaa44b364a9$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($e6c15aaa44b364a9$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $e6c15aaa44b364a9$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $e6c15aaa44b364a9$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $e6c15aaa44b364a9$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $bNh2M.useEffect(()=>{
        if (!$e6c15aaa44b364a9$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$e6c15aaa44b364a9$var$discoveredPaths.has(pathname)) $e6c15aaa44b364a9$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($e6c15aaa44b364a9$var$nextPaths.keys()).filter((path)=>{
                if ($e6c15aaa44b364a9$var$discoveredPaths.has(path)) {
                    $e6c15aaa44b364a9$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $e6c15aaa44b364a9$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $e6c15aaa44b364a9$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $e6c15aaa44b364a9$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $e6c15aaa44b364a9$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $e6c15aaa44b364a9$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $e6c15aaa44b364a9$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($e6c15aaa44b364a9$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $e6c15aaa44b364a9$export$b5915cf27fa06b9f) {
        $e6c15aaa44b364a9$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($e6c15aaa44b364a9$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($e6c15aaa44b364a9$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($e6c15aaa44b364a9$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$e6c15aaa44b364a9$var$addToFifoQueue(p, $e6c15aaa44b364a9$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $e6c15aaa44b364a9$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $e6c15aaa44b364a9$var$addToFifoQueue(path, queue) {
    if (queue.size >= $e6c15aaa44b364a9$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $e6c15aaa44b364a9$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $e6c15aaa44b364a9$var$useDataRouterContext2() {
    let context = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    $e6c15aaa44b364a9$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $e6c15aaa44b364a9$var$useDataRouterStateContext() {
    let context = $bNh2M.useContext($e6c15aaa44b364a9$export$315e3ffb01f217);
    $e6c15aaa44b364a9$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $e6c15aaa44b364a9$export$208d6a3bc3aa62bd = $bNh2M.createContext(void 0);
$e6c15aaa44b364a9$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $e6c15aaa44b364a9$var$useFrameworkContext() {
    let context = $bNh2M.useContext($e6c15aaa44b364a9$export$208d6a3bc3aa62bd);
    $e6c15aaa44b364a9$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $e6c15aaa44b364a9$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $bNh2M.useContext($e6c15aaa44b364a9$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $bNh2M.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $bNh2M.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $bNh2M.useRef(null);
    $bNh2M.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $bNh2M.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $e6c15aaa44b364a9$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $e6c15aaa44b364a9$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $e6c15aaa44b364a9$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $e6c15aaa44b364a9$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $e6c15aaa44b364a9$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $e6c15aaa44b364a9$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $e6c15aaa44b364a9$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$e6c15aaa44b364a9$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $e6c15aaa44b364a9$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $e6c15aaa44b364a9$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $e6c15aaa44b364a9$var$useDataRouterStateContext();
    let matches = $e6c15aaa44b364a9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $bNh2M.useMemo(()=>$e6c15aaa44b364a9$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $bNh2M.createElement("style", {
        [$e6c15aaa44b364a9$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $bNh2M.createElement("link", {
        [$e6c15aaa44b364a9$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$e6c15aaa44b364a9$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $bNh2M.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $e6c15aaa44b364a9$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $e6c15aaa44b364a9$var$useIsRSCRouterContext();
    let { router: router } = $e6c15aaa44b364a9$var$useDataRouterContext2();
    let matches = $bNh2M.useMemo(()=>$e6c15aaa44b364a9$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $e6c15aaa44b364a9$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $bNh2M.useState([]);
    $bNh2M.useEffect(()=>{
        let interrupted = false;
        $e6c15aaa44b364a9$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $e6c15aaa44b364a9$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let { future: future } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let { basename: basename } = $e6c15aaa44b364a9$var$useDataRouterContext2();
    let dataHrefs = $bNh2M.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $e6c15aaa44b364a9$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bNh2M.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $e6c15aaa44b364a9$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let { basename: basename } = $e6c15aaa44b364a9$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $e6c15aaa44b364a9$var$useDataRouterStateContext();
    let newMatchesForData = $bNh2M.useMemo(()=>$e6c15aaa44b364a9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $bNh2M.useMemo(()=>$e6c15aaa44b364a9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $bNh2M.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $e6c15aaa44b364a9$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $bNh2M.useMemo(()=>$e6c15aaa44b364a9$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $e6c15aaa44b364a9$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bNh2M.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $bNh2M.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $bNh2M.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $e6c15aaa44b364a9$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $e6c15aaa44b364a9$var$useDataRouterStateContext();
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let _matches = $e6c15aaa44b364a9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$e6c15aaa44b364a9$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $bNh2M.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $bNh2M.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $bNh2M.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $bNh2M.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $e6c15aaa44b364a9$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $bNh2M.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $e6c15aaa44b364a9$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $e6c15aaa44b364a9$var$isHydrated = false;
function $e6c15aaa44b364a9$export$3be068dde909e563() {
    $e6c15aaa44b364a9$var$isHydrated = true;
}
function $e6c15aaa44b364a9$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $e6c15aaa44b364a9$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $e6c15aaa44b364a9$var$useDataRouterContext2();
    let { matches: routerMatches } = $e6c15aaa44b364a9$var$useDataRouterStateContext();
    let isRSCRouterContext = $e6c15aaa44b364a9$var$useIsRSCRouterContext();
    let enableFogOfWar = $e6c15aaa44b364a9$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $e6c15aaa44b364a9$var$getActiveMatches(routerMatches, null, isSpaMode);
    $bNh2M.useEffect(()=>{
        $e6c15aaa44b364a9$export$3be068dde909e563();
    }, []);
    let initialScripts = $bNh2M.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $e6c15aaa44b364a9$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($e6c15aaa44b364a9$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, /* @__PURE__ */ $bNh2M.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $bNh2M.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $e6c15aaa44b364a9$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($e6c15aaa44b364a9$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $e6c15aaa44b364a9$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $e6c15aaa44b364a9$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $bNh2M.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $bNh2M.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $bNh2M.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $bNh2M.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $e6c15aaa44b364a9$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $e6c15aaa44b364a9$export$32e57f52df4b6e34 = class extends $bNh2M.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $e6c15aaa44b364a9$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $bNh2M.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($e6c15aaa44b364a9$export$972111febbeef05b(error)) return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $bNh2M.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $e6c15aaa44b364a9$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $bNh2M.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $bNh2M.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $e6c15aaa44b364a9$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $e6c15aaa44b364a9$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $bNh2M.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $bNh2M.createElement("head", null, /* @__PURE__ */ $bNh2M.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $bNh2M.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $bNh2M.createElement("title", null, title)), /* @__PURE__ */ $bNh2M.createElement("body", null, /* @__PURE__ */ $bNh2M.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$ff0bf87698939488, null) : null)));
}
var $e6c15aaa44b364a9$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($e6c15aaa44b364a9$var$isBrowser2) window.__reactRouterVersion = "7.17.0";
} catch (e) {}
function $e6c15aaa44b364a9$export$1f3f55432a00e06d(routes, opts) {
    return $e6c15aaa44b364a9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $e6c15aaa44b364a9$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $e6c15aaa44b364a9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $e6c15aaa44b364a9$export$9269a41d8c4635e,
        hydrationRouteProperties: $e6c15aaa44b364a9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $e6c15aaa44b364a9$export$1ba7ed8a3a7b3765(routes, opts) {
    return $e6c15aaa44b364a9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $e6c15aaa44b364a9$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $e6c15aaa44b364a9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $e6c15aaa44b364a9$export$9269a41d8c4635e,
        hydrationRouteProperties: $e6c15aaa44b364a9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $e6c15aaa44b364a9$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $e6c15aaa44b364a9$var$deserializeErrors(state.errors)
    };
    return state;
}
function $e6c15aaa44b364a9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $e6c15aaa44b364a9$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $e6c15aaa44b364a9$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $bNh2M.useRef();
    if (historyRef.current == null) historyRef.current = $e6c15aaa44b364a9$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bNh2M.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bNh2M.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bNh2M.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bNh2M.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $e6c15aaa44b364a9$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $bNh2M.useRef();
    if (historyRef.current == null) historyRef.current = $e6c15aaa44b364a9$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bNh2M.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bNh2M.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bNh2M.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bNh2M.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $e6c15aaa44b364a9$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $bNh2M.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bNh2M.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bNh2M.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bNh2M.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$e6c15aaa44b364a9$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $e6c15aaa44b364a9$export$a6c7ac8248d6e38a = $bNh2M.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $e6c15aaa44b364a9$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $e6c15aaa44b364a9$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $e6c15aaa44b364a9$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $e6c15aaa44b364a9$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $e6c15aaa44b364a9$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $e6c15aaa44b364a9$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $bNh2M.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $e6c15aaa44b364a9$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, link, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$e6c15aaa44b364a9$export$a6c7ac8248d6e38a.displayName = "Link";
var $e6c15aaa44b364a9$export$b0d92dbee9b5b60d = $bNh2M.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $e6c15aaa44b364a9$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let routerState = $bNh2M.useContext($e6c15aaa44b364a9$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $e6c15aaa44b364a9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $e6c15aaa44b364a9$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$e6c15aaa44b364a9$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $e6c15aaa44b364a9$export$a7fed597f4b8afd8 = $bNh2M.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $e6c15aaa44b364a9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let submit = $e6c15aaa44b364a9$export$47c85c6e3a081d3();
    let formAction = $e6c15aaa44b364a9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $bNh2M.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $bNh2M.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$e6c15aaa44b364a9$export$a7fed597f4b8afd8.displayName = "Form";
function $e6c15aaa44b364a9$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $bNh2M.useContext($e6c15aaa44b364a9$export$208d6a3bc3aa62bd);
    let { basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let matches = $e6c15aaa44b364a9$export$2378eb7f5ff86053();
    $e6c15aaa44b364a9$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $bNh2M.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $e6c15aaa44b364a9$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $bNh2M.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$e6c15aaa44b364a9$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $e6c15aaa44b364a9$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$e6c15aaa44b364a9$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$e6c15aaa44b364a9$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $e6c15aaa44b364a9$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $e6c15aaa44b364a9$var$useDataRouterContext3(hookName) {
    let ctx = $bNh2M.useContext($e6c15aaa44b364a9$export$2eeee58951ff3c1c);
    $e6c15aaa44b364a9$export$f5708dca728d7177(ctx, $e6c15aaa44b364a9$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $e6c15aaa44b364a9$var$useDataRouterState2(hookName) {
    let state = $bNh2M.useContext($e6c15aaa44b364a9$export$315e3ffb01f217);
    $e6c15aaa44b364a9$export$f5708dca728d7177(state, $e6c15aaa44b364a9$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $e6c15aaa44b364a9$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $e6c15aaa44b364a9$export$9770f232ac06a008();
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let path = $e6c15aaa44b364a9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $bNh2M.useCallback((event)=>{
        if ($e6c15aaa44b364a9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $e6c15aaa44b364a9$export$fe53371bee54353d(location) === $e6c15aaa44b364a9$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $bNh2M.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $e6c15aaa44b364a9$export$f1a78c17382fe22a(defaultInit) {
    $e6c15aaa44b364a9$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $bNh2M.useRef($e6c15aaa44b364a9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bNh2M.useRef(false);
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let searchParams = $bNh2M.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e6c15aaa44b364a9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $e6c15aaa44b364a9$export$9770f232ac06a008();
    let setSearchParams = $bNh2M.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e6c15aaa44b364a9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $e6c15aaa44b364a9$var$fetcherId = 0;
var $e6c15aaa44b364a9$var$getUniqueFetcherId = ()=>`__${String(++$e6c15aaa44b364a9$var$fetcherId)}__`;
function $e6c15aaa44b364a9$export$47c85c6e3a081d3() {
    let { router: router } = $e6c15aaa44b364a9$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let currentRouteId = $e6c15aaa44b364a9$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $bNh2M.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e6c15aaa44b364a9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $e6c15aaa44b364a9$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $e6c15aaa44b364a9$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let routeContext = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    $e6c15aaa44b364a9$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$e6c15aaa44b364a9$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $e6c15aaa44b364a9$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $e6c15aaa44b364a9$export$fe53371bee54353d(path);
}
function $e6c15aaa44b364a9$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $e6c15aaa44b364a9$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $e6c15aaa44b364a9$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $bNh2M.useContext($e6c15aaa44b364a9$export$cb3f1df1bef00a39);
    let route = $bNh2M.useContext($e6c15aaa44b364a9$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $e6c15aaa44b364a9$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $e6c15aaa44b364a9$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $e6c15aaa44b364a9$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $bNh2M.useId();
    let [fetcherKey, setFetcherKey] = $bNh2M.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $bNh2M.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $bNh2M.useCallback(async (href, opts)=>{
        $e6c15aaa44b364a9$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $e6c15aaa44b364a9$export$47c85c6e3a081d3();
    let submit = $bNh2M.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $bNh2M.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $bNh2M.useMemo(()=>{
        let FetcherForm2 = $bNh2M.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $e6c15aaa44b364a9$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bNh2M.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $e6c15aaa44b364a9$export$fa996778a3a31087() {
    let state = $e6c15aaa44b364a9$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $bNh2M.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $e6c15aaa44b364a9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $e6c15aaa44b364a9$var$savedScrollPositions = {};
function $e6c15aaa44b364a9$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $e6c15aaa44b364a9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $e6c15aaa44b364a9$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $e6c15aaa44b364a9$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e6c15aaa44b364a9$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $bNh2M.useContext($e6c15aaa44b364a9$export$3044ab7fdabeaee6);
    let location = $e6c15aaa44b364a9$export$45d76561a5302f2b();
    let matches = $e6c15aaa44b364a9$export$2378eb7f5ff86053();
    let navigation = $e6c15aaa44b364a9$export$d0fd4b7106de2769();
    $bNh2M.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $e6c15aaa44b364a9$var$usePageHide($bNh2M.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $e6c15aaa44b364a9$var$getScrollRestorationKey(location, matches, basename, getKey);
            $e6c15aaa44b364a9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $e6c15aaa44b364a9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e6c15aaa44b364a9$var$savedScrollPositions));
        } catch (error) {
            $e6c15aaa44b364a9$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $bNh2M.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e6c15aaa44b364a9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e6c15aaa44b364a9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $bNh2M.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($e6c15aaa44b364a9$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$e6c15aaa44b364a9$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $bNh2M.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $e6c15aaa44b364a9$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $e6c15aaa44b364a9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bNh2M.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $e6c15aaa44b364a9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bNh2M.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $e6c15aaa44b364a9$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $e6c15aaa44b364a9$export$b273b3273281a049(when);
    $bNh2M.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bNh2M.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $e6c15aaa44b364a9$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $bNh2M.useContext($e6c15aaa44b364a9$export$3681f408decb40d1);
    $e6c15aaa44b364a9$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $e6c15aaa44b364a9$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $e6c15aaa44b364a9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $e6c15aaa44b364a9$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $e6c15aaa44b364a9$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $e6c15aaa44b364a9$export$81336c211d5ff295(path.pathname, nextPath) != null || $e6c15aaa44b364a9$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $e6c15aaa44b364a9$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $e6c15aaa44b364a9$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $e6c15aaa44b364a9$var$getStatelessNavigator();
    return /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $e6c15aaa44b364a9$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $e6c15aaa44b364a9$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $e6c15aaa44b364a9$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $e6c15aaa44b364a9$var$serializeErrors(context.errors)
        };
        let json = $e6c15aaa44b364a9$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $bNh2M.createElement($bNh2M.Fragment, null, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $bNh2M.createElement($e6c15aaa44b364a9$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $bNh2M.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $e6c15aaa44b364a9$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($e6c15aaa44b364a9$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $e6c15aaa44b364a9$var$getStatelessNavigator() {
    return {
        createHref: $e6c15aaa44b364a9$var$createHref,
        encodeLocation: $e6c15aaa44b364a9$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $e6c15aaa44b364a9$export$69163f0b72ec60d9(routes, opts) {
    return $e6c15aaa44b364a9$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $e6c15aaa44b364a9$export$9269a41d8c4635e
    });
}
function $e6c15aaa44b364a9$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $e6c15aaa44b364a9$export$87cb1a9238dc3fba(routes, $e6c15aaa44b364a9$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $e6c15aaa44b364a9$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $e6c15aaa44b364a9$var$createHref,
        encodeLocation: $e6c15aaa44b364a9$var$encodeLocation,
        getFetcher () {
            return $e6c15aaa44b364a9$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $e6c15aaa44b364a9$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $e6c15aaa44b364a9$var$createHref(to) {
    return typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to);
}
function $e6c15aaa44b364a9$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $e6c15aaa44b364a9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $e6c15aaa44b364a9$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;


const $f2ecb52910ce2e55$export$90274d638f54d9c0 = ()=>{
    const [disabled, setDisabled] = (0, $bNh2M.useState)(true);
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    const account = (0, $630abbaa58d51e28$export$83a8e409853da004)();
    const navigate = (0, $e6c15aaa44b364a9$export$9770f232ac06a008)();
    function openAlbum(id) {
        navigate(`/view?album=${id}`);
    }
    let throttle;
    function oninput(e) {
        setDisabled(true);
        const { value: value } = e.currentTarget;
        if (throttle) window.clearTimeout(throttle);
        throttle = window.setTimeout(()=>{
            $f2ecb52910ce2e55$var$confirmedId(value).then((_)=>{
                setDisabled(false);
            }, (_)=>{
                setDisabled(true);
            });
        }, 300);
    }
    function onsubmit(e) {
        const target = e.target;
        const value = decodeURIComponent(target.gdrive_id.value);
        e.preventDefault();
        $f2ecb52910ce2e55$var$confirmedId(value).then((id)=>{
            setDisabled(false);
            openAlbum(id);
            target.gdrive_id.value = "";
        }, (_)=>{
            setDisabled(true);
        });
    }
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "home_new_album",
        hidden: !account,
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("details", {
            children: [
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("summary", {
                    children: i18n.newAlbumFromURL.buttonLabel
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("form", {
                    onSubmit: onsubmit,
                    children: [
                        /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                            className: "labeltext",
                            children: i18n.newAlbumFromURL.description
                        }),
                        /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("input", {
                            type: "text",
                            id: "home_new_album_input",
                            name: "gdrive_id",
                            onInput: oninput,
                            placeholder: i18n.newAlbumFromURL.placeholder
                        }),
                        /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("button", {
                            id: "home_new_album_button",
                            type: "submit",
                            disabled: disabled,
                            children: i18n.newAlbumFromURL.buttonLabel
                        })
                    ]
                })
            ]
        })
    });
};
async function $f2ecb52910ce2e55$var$confirmedId(partURL) {
    if (!partURL) throw new Error("error");
    const result = /.*(?:[=/])(.+)$/.exec(partURL);
    const id = result ? result[1] : partURL;
    await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).getFileItself(id);
    return id;
}




var $bNh2M = parcelRequire("bNh2M");
class $130f8adfdbb984a7$export$bf861c9e00bce713 {
    constructor(name, id){
        this.name = name;
        this.id = id;
    }
    static createFromFile(file) {
        const result = /(.*)\.[^.]*$/.exec(file.name);
        return new $130f8adfdbb984a7$export$bf861c9e00bce713(result?.[1] || file.name, file.id);
    }
}



class $3fbb877a61794509$export$2ee11c425a1bd6c1 {
    constructor(name, id){
        this.name = name;
        this.id = id;
    }
    serialize() {
        return {
            name: this.name,
            path: this.id
        };
    }
    static deserialize(json) {
        return new $3fbb877a61794509$export$2ee11c425a1bd6c1(json.name, json.id);
    }
} // export class AlbumManager {
 // state = this.dispatcher.create<AlbumLoadingState>({ state: "no-album" })
 // album = new BaseProperty<Album | null>(null)
 // id: Observable<string>
 // name: Observable<PromiseState<string>>
 // kanjiHint: Observable<PromiseState<KanjiHint>>
 // tunes: Observable<PromiseState<IndexedTunes>>
 // constructor (man: AlbumListManager) {
 //   const progress = this.album.c(map(album =>
 //     album ? man.prefetcher.fetch(album.id, false) : null
 //   ));
 //   this.id = this.album
 //     .c(map(album => album ? album.id : undefined))
 //     .asProperty();
 //   this.kanjiHint = progress
 //     .c(mapAsync(async p => p ? p.kanjiHint : new KanjiHint([])))
 //     .asProperty();
 //   // .c(map(p => p.state === 'done' ? p.value : new KanjiHint([])))
 //   this.name = progress
 //     .c(mapAsync(async p => p ? p.name : ''))
 //     .asProperty();
 //   // .c(map(p => p.state === 'done' ? p.value : ''))
 //   this.tunes = progress
 //     .c(mapAsync(async p => p ? p.tunes : new IndexedTunes()))
 //     .asProperty();
 //   this.tunes.addEventListener(() => {
 //     scoreManager.clear();
 //   });
 // }
 // forId (id: string): Tune {
 //   const tunes = this.tunes.value;
 //   if (tunes.state !== 'done') {
 //     throw 'Cannot find tune; album tunes loading not completed now';
 //     return null;
 //   }
 //   for (const t of tunes.value.getTunesSorted()) {
 //     if (t.id === id) return t;
 //   }
 //   throw `there is no tune for id: ${id} in the open album.`;
 // }
 // }



const $809fa35e8082e7a9$var$Dexie = (parcelRequire("eloFi")).default.Dexie;
class $809fa35e8082e7a9$var$MyDB extends $809fa35e8082e7a9$var$Dexie {
    constructor(){
        super("Notestand");
        this.version(1).stores({
            albums: "id, name"
        });
    }
}
const $809fa35e8082e7a9$var$db = new $809fa35e8082e7a9$var$MyDB();
(function(persistant) {
    async function albumExists(album) {
        try {
            const data = await $809fa35e8082e7a9$var$db.albums.get(album.id);
            return !!data;
        } catch (e) {
            return false;
        }
    }
    persistant.albumExists = albumExists;
    async function addAlbum(album) {
        const { id: id, name: name } = album;
        $809fa35e8082e7a9$var$db.albums.put({
            id: id,
            name: name
        });
    }
    persistant.addAlbum = addAlbum;
    async function renameAlbum(id, name) {
        $809fa35e8082e7a9$var$db.albums.update(id, {
            name: name
        });
    }
    persistant.renameAlbum = renameAlbum;
    function loadAlbumList() {
        return $809fa35e8082e7a9$var$db.albums.toArray((vales)=>vales.map((0, $3fbb877a61794509$export$2ee11c425a1bd6c1).deserialize));
    }
    persistant.loadAlbumList = loadAlbumList;
    async function deleteAlbum(a) {
        $809fa35e8082e7a9$var$db.albums.delete(a.id);
    }
    persistant.deleteAlbum = deleteAlbum;
})($809fa35e8082e7a9$export$c0cc7a7b63fa5fcd || ($809fa35e8082e7a9$export$c0cc7a7b63fa5fcd = {}));
var $809fa35e8082e7a9$export$c0cc7a7b63fa5fcd;


function $68cb68e0073bc15b$export$5d22647f2a1a26ab(regex, s) {
    return $68cb68e0073bc15b$var$safeResult(regex.test(s) ? regex.exec(s) : null);
}
function $68cb68e0073bc15b$var$safeResult(result) {
    return {
        getOrElse (index, fallback) {
            return result ? result[index] : fallback;
        }
    };
}


class $9b175a0b2843ddca$var$_DAO_WEB {
    async getKanjiHintNotation(albumId) {
        const notestand = await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).findOneFile(`'${albumId}' in parents and trashed = false and mimeType = 'application/vnd.google-apps.folder' and name contains 'notestand'`);
        if (!notestand) return "";
        const kanjihintFile = await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).findOneFile(`'${notestand.id}' in parents and trashed = false and name contains 'kanjihint'`);
        if (!kanjihintFile) return "";
        return await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).getContent(kanjihintFile.id);
    }
    async lookupTunesInAlbum(albumId) {
        const files = await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).listFiles(`'${albumId}' in parents and trashed = false and mimeType = 'application/pdf'`).catch((reason)=>(console.log(`error: ${reason}`), []));
        return files.map((0, $130f8adfdbb984a7$export$bf861c9e00bce713).createFromFile);
    }
    async getEntityName(id) {
        const file = await (0, $630abbaa58d51e28$export$2ac0064d6c47123a).getFileItself(id);
        return (0, $68cb68e0073bc15b$export$5d22647f2a1a26ab)(/(.*)\.[^.]*$/, file.name).getOrElse(1, file.name);
    }
    getTuneContent(tuneId) {
        return (0, $630abbaa58d51e28$export$2ac0064d6c47123a).getContent(tuneId, "typed-array");
    }
    async openOriginal(item) {
        window.open(`https://drive.google.com/open?id=${item.id}`, "_blank");
    }
}
function $9b175a0b2843ddca$export$16b3ab30485f58bd() {
    return Object.assign(new $9b175a0b2843ddca$var$_DAO_WEB(), (0, $809fa35e8082e7a9$export$c0cc7a7b63fa5fcd));
}


const $01d6f1e7a7e9eaad$export$d20ece2d152515e7 = (0, $9b175a0b2843ddca$export$16b3ab30485f58bd)();




function $75a321daa887b448$export$ae316f0eeb712a36() {
    const { search: search } = (0, $e6c15aaa44b364a9$export$45d76561a5302f2b)();
    try {
        const q = new Map(search.substring(1).split("&").map((_)=>_.split("=")));
        return [
            q,
            null
        ];
    } catch  {
        return [
            null,
            new Error("Invalid query parameter: " + search)
        ];
    }
}
function $75a321daa887b448$export$8a39e334f881b685() {
    const [q] = $75a321daa887b448$export$ae316f0eeb712a36();
    return q.get("album");
}
function $75a321daa887b448$export$446faf09d69f9c36() {
    const [q] = $75a321daa887b448$export$ae316f0eeb712a36();
    return q.get("score");
}



const $f0ef9d515918349c$export$ea09568aab55509f = ()=>{
    const [recentAlbums, setRecentAlbums] = (0, $bNh2M.useState)([]);
    const currentAlbumId = (0, $75a321daa887b448$export$8a39e334f881b685)();
    (0, $bNh2M.useEffect)(()=>{
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>setRecentAlbums(await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).loadAlbumList()));
    }, [
        currentAlbumId
    ]);
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "container_albums",
        children: recentAlbums.map((album)=>[
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
                    to: `/view?album=${album.id}`,
                    className: "album",
                    children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                        className: "tab_album_name",
                        children: album.name
                    })
                }, album.id)
            ])
    });
};


parcelRequire("bNh2M");
function $3ad783fe7d4f9484$var$HomeHeading() {
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "home_heading",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                id: "home_heading_text",
                children: i18n.home.albumList
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $83be4e8e99a6273a$export$409ec18e0392f49a), {})
        ]
    });
}
function $3ad783fe7d4f9484$var$LinkToAbout() {
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "link_to_about_wrapper",
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("a", {
            href: "/",
            id: "link_to_about",
            children: i18n.home.about
        })
    });
}
const $3ad783fe7d4f9484$var$Home = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($3ad783fe7d4f9484$var$HomeHeading, {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $f0ef9d515918349c$export$ea09568aab55509f), {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $83be4e8e99a6273a$export$e4624626de9ce646), {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e54ba3d42fd52a1c$export$65f7da49be6579a0), {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $f2ecb52910ce2e55$export$90274d638f54d9c0), {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($3ad783fe7d4f9484$var$LinkToAbout, {})
        ]
    });
};
var $3ad783fe7d4f9484$export$2e2bcd8739ae039 = $3ad783fe7d4f9484$var$Home;






var $bNh2M = parcelRequire("bNh2M");

parcelRequire("bNh2M");





var $bNh2M = parcelRequire("bNh2M");
function $1bdd51c8b08dbc2b$export$b22cd1a3b5022e9a(key, value) {
    return function(r) {
        if (r[key] === undefined && value === undefined) return {
            ...r,
            [key]: []
        };
        if (value === undefined) return r;
        const arr = r[key] ?? [];
        return {
            ...r,
            [key]: [
                ...arr,
                value
            ]
        };
    };
}
function $1bdd51c8b08dbc2b$export$8af121ae7401c4(value) {
    return function(arr) {
        const set = new Set(arr);
        set.delete(value);
        return Array.from(set);
    };
}
function $1bdd51c8b08dbc2b$export$27d05c9a86c64d34(value, idKey) {
    const idPred = !idKey ? (v)=>v === value : (v)=>v[idKey] === value[idKey];
    return (arr)=>arr.find(idPred) ? arr : [
            ...arr,
            value
        ];
}
function $1bdd51c8b08dbc2b$export$6486ede9e74d7d9d(arr, id) {
    return arr.find((v)=>v.id === id);
}
function $1bdd51c8b08dbc2b$export$9a8aaeeffc69f727(arr, key, value) {
    const _arr = Array.isArray(arr) ? arr : Array.from(arr);
    return _arr.find((v)=>v[key] === value);
}







var $bNh2M = parcelRequire("bNh2M");

function $4463b45cf3017fae$var$pipe(s, fns) {
    let current = s;
    for (const fn of fns)current = fn(current);
    return current;
}
class $4463b45cf3017fae$export$668df8b271de6d36 {
    static Nullish() {
        return new $4463b45cf3017fae$var$NullAlbumTunes();
    }
    get isEmpty() {
        return false;
    }
    constructor(tunesIndexed){
        this.tunesIndexed = tunesIndexed;
        this.indices = Object.keys(this.tunesIndexed);
    }
    *[Symbol.iterator]() {
        for (const i of this.indices)yield [
            i,
            this.tunesIndexed[i]
        ];
    }
    *getTunesSorted() {
        for (const i of this.indices)yield* this.tunesIndexed[i];
    }
}
class $4463b45cf3017fae$var$NullAlbumTunes extends $4463b45cf3017fae$export$668df8b271de6d36 {
    constructor(){
        super({});
    }
    get isEmpty() {
        return true;
    }
    *[Symbol.iterator]() {}
    *getTunesSorted() {}
}
class $4463b45cf3017fae$export$ae864be1e6f58342 {
    constructor(transformTable){
        this.transformTable = transformTable;
        this.cache = Object.create(null);
    }
    transform(s) {
        const cached = this.cache[s];
        if (cached) return this.cache[s];
        const result = $4463b45cf3017fae$var$pipe(s, this.transformTable);
        this.cache[s] = result;
        return result;
    }
    getIndexName(tune) {
        return $4463b45cf3017fae$var$pipe(tune.name, [
            (name)=>name.replace(/[ァ-ン]/g, (s)=>String.fromCharCode(s.charCodeAt(0) - 0x60)),
            (name)=>this.transform(name)
        ]);
    }
    getSectionIndex(tune) {
        const name = this.getIndexName(tune);
        if (/^[ぁ-お]/.test(name)) return "\u3042";
        if (/^[か-ご]/.test(name)) return "\u304B";
        if (/^[さ-ぞ]/.test(name)) return "\u3055";
        if (/^[た-ど]/.test(name)) return "\u305F";
        if (/^[な-の]/.test(name)) return "\u306A";
        if (/^[は-ぽ]/.test(name)) return "\u306F";
        if (/^[ま-も]/.test(name)) return "\u307E";
        if (/^[ゃ-よ]/.test(name)) return "\u3084";
        if (/^[ら-ろ]/.test(name)) return "\u3089";
        if (/^[ゎ-ん]/.test(name)) return "\u308F";
        if (name === "\u3094") return "\u3094";
        return name.charAt(0);
    }
    indexTunes(tunes) {
        const mapping = {};
        tunes.forEach((t)=>mapping[t.id] = this.getSectionIndex(t));
        tunes.sort((a, b)=>this.transform(a.name).localeCompare(this.transform(b.name)));
        const grouped = {};
        for (const t of tunes){
            const i = mapping[t.id];
            if (grouped[i] === undefined) grouped[i] = [];
            grouped[i].push(t);
        }
        return new $4463b45cf3017fae$export$668df8b271de6d36(grouped);
    }
}
function* $4463b45cf3017fae$var$parseKanjiHintText(lines) {
    for (const line of lines.split(/\r\n|\n|\r/))try {
        const [_, key, value] = /^([^:]+):\s*(.+)$/.exec(line);
        const regexp = RegExp(key);
        yield (s)=>regexp.test(s) ? s.replace(regexp, value) : s;
    } catch (e) {}
}
async function $4463b45cf3017fae$export$63ca227bd8c248da(albumId) {
    const content = await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).getKanjiHintNotation(albumId).catch(()=>null);
    return new $4463b45cf3017fae$export$ae864be1e6f58342(content ? Array.from($4463b45cf3017fae$var$parseKanjiHintText(content)) : []);
}




const $72db29bf798c8557$export$4d6ec5bcc8160e29 = (0, $7c9b300c545ed81c$exports.atom)((0, $4463b45cf3017fae$export$668df8b271de6d36).Nullish());
function $72db29bf798c8557$export$818d003b32cd03f9() {
    const currentAlbumId = (0, $75a321daa887b448$export$8a39e334f881b685)();
    const [tunes, setTunes] = (0, $7c9b300c545ed81c$exports.useAtom)($72db29bf798c8557$export$4d6ec5bcc8160e29);
    const [loading, setLoading] = (0, $bNh2M.useState)(true);
    (0, $bNh2M.useEffect)(()=>{
        if (!currentAlbumId) {
            setTunes((0, $4463b45cf3017fae$export$668df8b271de6d36).Nullish());
            return;
        }
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>{
            setLoading(true);
            const kanjiHint = (0, $4463b45cf3017fae$export$63ca227bd8c248da)(currentAlbumId);
            const tunes = (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).lookupTunesInAlbum(currentAlbumId);
            const indexed = (await kanjiHint).indexTunes(await tunes);
            setLoading(false);
            setTunes(indexed);
        });
    }, [
        currentAlbumId
    ]);
    return {
        loading: loading,
        tunes: tunes,
        indices: tunes.indices
    };
}




const $6796445aad86e7f6$var$scoresOpenAtom = (0, $7c9b300c545ed81c$exports.atom)([]);
const $6796445aad86e7f6$var$msgAtom = (0, $7c9b300c545ed81c$exports.atom)("");
async function $6796445aad86e7f6$var$getTuneDirectly(albumId) {
    const name = await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).getEntityName(albumId);
    return new (0, $130f8adfdbb984a7$export$bf861c9e00bce713)(name, albumId);
}
function $6796445aad86e7f6$export$50b8ce1ec962c68() {
    const [scoresOpen, setScoresOpen] = (0, $7c9b300c545ed81c$exports.useAtom)($6796445aad86e7f6$var$scoresOpenAtom);
    const s = (0, $75a321daa887b448$export$446faf09d69f9c36)();
    const a = (0, $75a321daa887b448$export$8a39e334f881b685)();
    const tuneList = (0, $7c9b300c545ed81c$exports.useAtomValue)((0, $72db29bf798c8557$export$4d6ec5bcc8160e29));
    (0, $bNh2M.useEffect)(()=>{
        setScoresOpen([]);
    }, [
        a
    ]);
    (0, $bNh2M.useEffect)(()=>{
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>{
            const newScore = s && tuneList.isEmpty ? await $6796445aad86e7f6$var$getTuneDirectly(s) : (0, $1bdd51c8b08dbc2b$export$9a8aaeeffc69f727)(tuneList.getTunesSorted(), "id", s);
            if (!newScore) return;
            if ((0, $1bdd51c8b08dbc2b$export$9a8aaeeffc69f727)(scoresOpen, "id", s)) return;
            setScoresOpen((0, $1bdd51c8b08dbc2b$export$27d05c9a86c64d34)(newScore, "id"));
        });
    }, [
        s,
        tuneList
    ]);
    return scoresOpen;
}
function $6796445aad86e7f6$export$4fa39c0fb646aeaf() {
    const [scoresOpen, setScoresOpen] = (0, $7c9b300c545ed81c$exports.useAtom)($6796445aad86e7f6$var$scoresOpenAtom);
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const navigate = (0, $e6c15aaa44b364a9$export$9770f232ac06a008)();
    return (id)=>{
        const tuneIdx = scoresOpen.findIndex((t)=>t.id === id);
        const arr = [
            ...scoresOpen
        ];
        arr.splice(tuneIdx, 1);
        const nextTune = arr.length === 0 ? null : arr[(tuneIdx - 1) % arr.length];
        const backUrl = q.has("album") ? `/view?album=${q.get("album")}` : "/";
        const url = !nextTune ? backUrl : `/view?score=${nextTune.id}` + (q.has("album") ? `&album=${q.get("album")}` : "");
        navigate(url);
        setScoresOpen(arr);
    };
}
function $6796445aad86e7f6$export$6de0c80529fc50e7() {
    const scoresOpen = (0, $7c9b300c545ed81c$exports.useAtomValue)($6796445aad86e7f6$var$scoresOpenAtom);
    const setMsg = (0, $7c9b300c545ed81c$exports.useSetAtom)($6796445aad86e7f6$var$msgAtom);
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const navigate = (0, $e6c15aaa44b364a9$export$9770f232ac06a008)();
    return (id, ward)=>{
        const numScores = scoresOpen.length;
        if (numScores === 1) return;
        const tuneIdx = scoresOpen.findIndex((t)=>t.id === id);
        let targetIdx = tuneIdx + (ward === "forward" ? 1 : -1);
        if (targetIdx < 0) targetIdx = numScores - 1;
        if (targetIdx > numScores - 1) targetIdx = 0;
        const targetId = scoresOpen[targetIdx].id;
        const urlSuffix = q.has("album") ? `&album=${q.get("album")}` : "";
        const url = `/view?score=${targetId}` + urlSuffix;
        navigate(url);
        setMsg(scoresOpen[targetIdx].name);
        setTimeout(()=>{
            setMsg("");
        }, 500);
    };
}
function $6796445aad86e7f6$export$2f3033f727989e7b() {
    return (0, $7c9b300c545ed81c$exports.useAtomValue)($6796445aad86e7f6$var$msgAtom);
}




parcelRequire("bNh2M");
const $e9563b95ab65753c$export$21b07c8f274aebd5 = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("svg", {
        className: "icon arrow",
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M50 20 L20 50 L50 80"
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M20 50 L80 50"
            })
        ]
    });
};
const $e9563b95ab65753c$export$770825e57b48d94e = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("svg", {
        className: "icon hamburger",
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M18 22 L82 22"
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M18 50 L82 50"
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M18 78 L82 78"
            })
        ]
    });
};
const $e9563b95ab65753c$export$3c877bb842c36952 = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("svg", {
        className: "icon cross",
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M20 20 80 80"
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
                d: "M20 80 80 20"
            })
        ]
    });
};
const $e9563b95ab65753c$export$b2539bed5023c21c = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("svg", {
        className: "icon tabs",
        viewBox: "0 0 100 100",
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("path", {
            d: "M25 81.25L25 90.63L87.5 90.63L87.5 21.88L25 21.88L25 81.25L12.5 81.25L12.5 9.38L76.09 9.38L76.09 21.78",
            id: "e2uOPDlCAc"
        })
    });
};



parcelRequire("bNh2M");


var $bNh2M = parcelRequire("bNh2M");
function $13c1aa054ab5f4da$export$c575791007f9dbd1(array, fn) {
    const result = [];
    for(let i = 0; i < array.length; i++)result.push(...fn(array[i], i, array));
    return result;
}
function $13c1aa054ab5f4da$export$1e5c4a8c6c9c8542(array) {
    return array || [];
}
function $13c1aa054ab5f4da$export$3d19121892ad9076(cond, v) {
    return cond ? [
        v
    ] : [];
}
function $13c1aa054ab5f4da$export$13a705e512049f3a() {
    if (navigator.userAgent.toLowerCase().match(/webkit|msie 5/)) {
        // Webkit系（Safari, Chrome, iOS）判定
        if (navigator.userAgent.indexOf("Chrome") != -1) // Chromeはhtml要素
        return document.documentElement;
        else // Chrome以外はbody要素
        return document.body;
    } else // IE（6以上）、Firefox、Operaはhtml要素
    return document.documentElement;
}
function $13c1aa054ab5f4da$export$4a80463661687efe(provider) {
    const map = new Map();
    return (key)=>{
        const got = map.get(key);
        if (got) return got;
        const h = provider(key);
        map.set(key, h);
        return h;
    };
}
function $13c1aa054ab5f4da$export$8b77b7febf685184(doc, ...args) {
    (0, $bNh2M.useEffect)(()=>{
        doc().addEventListener(...args);
        return ()=>{
            doc().removeEventListener(...args);
        };
    }, []);
}






const $7836dfa820e1557f$export$50da548b44c73afa = (0, $7c9b300c545ed81c$exports.atom)(false);
const $7836dfa820e1557f$export$4ba648a807f56802 = ({ scores: scores })=>{
    const [isTabListOpen, setTabListOpen] = (0, $7c9b300c545ed81c$exports.useAtom)($7836dfa820e1557f$export$50da548b44c73afa);
    (0, $13c1aa054ab5f4da$export$8b77b7febf685184)(()=>document, "click", (e)=>{
        const elem = e.target;
        if (!elem.closest(".mob_tab_list, .mob_tablist_open_button")) setTabListOpen(false);
    }, false);
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "mob_tab_list",
        hidden: !isTabListOpen,
        children: scores.map((tune)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($7836dfa820e1557f$var$Tab, {
                tune: tune
            }, tune.id))
    });
};
const $7836dfa820e1557f$var$Tab = ({ tune: tune })=>{
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const _closeScore = (0, $6796445aad86e7f6$export$4fa39c0fb646aeaf)();
    const closeScore = (e)=>{
        _closeScore(tune.id);
        e.stopPropagation();
        e.preventDefault();
    };
    const linkUrl = `/view?score=${tune.id}` + (q.has("album") ? `&album=${q.get("album")}` : "");
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
        className: "tab",
        to: linkUrl,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tab_name",
                children: tune.name
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tab_close_button",
                onClick: closeScore,
                children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$3c877bb842c36952), {})
            })
        ]
    }, tune.id);
};
function $7836dfa820e1557f$var$onclick(e) {
    const target = e.target;
// e.stopPropagation();
// const elemCloseButton = target.closest(".tab_close_button");
// if (elemCloseButton) {
//   activateRipple(elemCloseButton, () => {
//     closeTune(target.closest(".tab")["bound-tab"] as Tune);
//     isTabListOpen.value = scoreManager.scores.value.length > 0;
//   });
//   return true;
// }
// const elemTab = target.closest(".tab");
// if (elemTab) {
//   activateRipple(elemTab, () => {
//     openTune((elemTab["bound-tab"] as Tune).id);
//     isTabListOpen.value = false;
//   });
// }
}




var $bNh2M = parcelRequire("bNh2M");






var $bNh2M = parcelRequire("bNh2M");

const $4a4a78dd066e5c5d$var$themeAtom = (0, $7c9b300c545ed81c$exports.atom)("blight");
function $4a4a78dd066e5c5d$export$9aca36bb09e5ede9() {
    const [theme, setTheme] = (0, $7c9b300c545ed81c$exports.useAtom)($4a4a78dd066e5c5d$var$themeAtom);
    (0, $bNh2M.useEffect)(()=>{
        setTheme(localStorage.getItem("ui-theme") || "blight");
    }, []);
    (0, $bNh2M.useEffect)(()=>{
        document.body.dataset.uitheme = theme;
        localStorage.setItem("ui-theme", theme);
    }, [
        theme
    ]);
}
function $4a4a78dd066e5c5d$export$c07acc0415d9f757() {
    const setValue = (0, $7c9b300c545ed81c$exports.useSetAtom)($4a4a78dd066e5c5d$var$themeAtom);
    const next = {
        blight: "sepia",
        sepia: "dark",
        dark: "blight"
    };
    return ()=>{
        setValue((cur)=>next[cur]);
    };
}


function $ed8e29b4d971a8ff$export$7a81604c42a7e645(target, action) {
    target.classList.add("ripple-active");
    setTimeout(()=>{
        action();
        target.classList.remove("ripple-active");
    }, 200);
}




const $437ae0db12065587$export$e2ff2c2f4cf81116 = (0, $7c9b300c545ed81c$exports.atom)(null);



const $f358c41b17f050c5$export$4fb1fc452da6833a = (0, $7c9b300c545ed81c$exports.atom)(false);
function $f358c41b17f050c5$var$useMenuOpenState() {
    const [isMenuOpen, setMenuOpen] = (0, $7c9b300c545ed81c$exports.useAtom)($f358c41b17f050c5$export$4fb1fc452da6833a);
    const isMenuOpenDyn = (0, $bNh2M.useRef)();
    (0, $bNh2M.useEffect)(()=>{
        isMenuOpenDyn.current = isMenuOpen;
    }, [
        isMenuOpen
    ]);
    return [
        isMenuOpen,
        setMenuOpen,
        ()=>isMenuOpenDyn.current
    ];
}
const $f358c41b17f050c5$export$7d4583da7581e674 = ()=>{
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    const [isMenuOpen, setMenuOpen, getIsMenuOpen] = $f358c41b17f050c5$var$useMenuOpenState();
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const state = q.has("score") ? "Score" : "Album";
    const itemId = q.get("score") ?? q.get("album");
    const closeScore = (0, $6796445aad86e7f6$export$4fa39c0fb646aeaf)();
    const toggleTheme = (0, $4a4a78dd066e5c5d$export$c07acc0415d9f757)();
    (0, $13c1aa054ab5f4da$export$8b77b7febf685184)(()=>document, "click", (e)=>{
        if (!e.target.closest("#menubar") && getIsMenuOpen()) {
            setMenuOpen(false);
            e.preventDefault();
        }
    }, false);
    const onOpenScoreFile = (0, $bNh2M.useCallback)((e)=>{
        (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).openOriginal({
            id: itemId
        });
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
            setMenuOpen(false);
        });
    }, [
        itemId
    ]);
    function onCloseTab(e) {
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
            closeScore(itemId);
        });
    }
    function onCloseMenu(e) {
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
            setMenuOpen(false);
        });
    }
    function onToggleTheme(e) {
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
            toggleTheme();
        });
    }
    function onCopyCurrentUrl(e) {
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
            if (navigator.clipboard) navigator.clipboard.writeText(document.URL);
        });
    }
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "menubar",
        hidden: !isMenuOpen,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                id: "menu-close-button",
                onClick: onCloseMenu,
                children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$3c877bb842c36952), {})
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "menu_item",
                onClick: onOpenScoreFile,
                children: i18n.menu.openOriginal
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "menu_item",
                hidden: state !== "Score",
                onClick: onCloseTab,
                children: i18n.menu.closeScore
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "menu_item",
                onClick: onToggleTheme,
                children: i18n.menu.toggleTheme
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "menu_item",
                onClick: onCopyCurrentUrl,
                children: i18n.menu.copyCurrentUrl
            })
        ]
    });
};
const $f358c41b17f050c5$export$1bc221ec8553027c = ({ item: item, shown: shown })=>{
    const setContextMenu = (0, $7c9b300c545ed81c$exports.useSetAtom)((0, $437ae0db12065587$export$e2ff2c2f4cf81116));
    const [i18n] = (0, $047030d75d5c8297$export$43bb16f9c6d9e3f7)();
    const onOpenScoreFile = (e)=>{
        (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).openOriginal(item);
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(e.target, ()=>{
        // setMenuOpen(false);
        });
    };
    const onCloseCtxMenu = (e)=>{
        setContextMenu(null);
    };
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "ctxmenu_wrap",
        children: shown ? /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)((0, $ce6a5d94e0bda3fb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                    className: "ctxmenu",
                    onClick: onCloseCtxMenu
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                    className: "menu_item",
                    onClick: onOpenScoreFile,
                    children: i18n.menu.openOriginal
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                    className: "menu_item menu_item_close",
                    onClick: onCloseCtxMenu,
                    children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$3c877bb842c36952), {})
                })
            ]
        }) : /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $ce6a5d94e0bda3fb$exports.Fragment), {})
    });
};


const $f9586f0c173f29a3$export$f97dc4a5a0177256 = ({ albumName: albumName })=>{
    const setTabListOpen = (0, $7c9b300c545ed81c$exports.useSetAtom)((0, $7836dfa820e1557f$export$50da548b44c73afa));
    const scoresOpen = (0, $6796445aad86e7f6$export$50b8ce1ec962c68)();
    const currentScoreId = (0, $75a321daa887b448$export$446faf09d69f9c36)();
    const openMenu = (0, $7c9b300c545ed81c$exports.useSetAtom)((0, $f358c41b17f050c5$export$4fb1fc452da6833a));
    function onTabListOpen(e) {
        // activateRipple(e.currentTarget, () => {
        setTabListOpen((v)=>!v);
    // });
    }
    const handleMenuOpenButton = ()=>{
        openMenu(true);
    };
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        className: "tabbar",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($f9586f0c173f29a3$var$BackButton, {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($f9586f0c173f29a3$var$AlbumNameTab, {
                albumName: albumName
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tab_tune_container",
                children: scoresOpen.map((tune)=>{
                    const viewed = tune.id === currentScoreId;
                    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($f9586f0c173f29a3$var$TuneTab, {
                        tune: tune,
                        viewed: viewed
                    }, tune.id);
                })
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "mob_tablist_open_button",
                onClick: onTabListOpen,
                hidden: !scoresOpen.length,
                children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$b2539bed5023c21c), {})
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $7836dfa820e1557f$export$4ba648a807f56802), {
                scores: scoresOpen
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($f9586f0c173f29a3$var$MenuOpenButton, {
                onClick: handleMenuOpenButton
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $f358c41b17f050c5$export$7d4583da7581e674), {})
        ]
    });
};
const $f9586f0c173f29a3$var$BackButton = ()=>{
    const [q, err] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const shouldBackToHome = !!err || !q.has("score") || !q.has("album");
    const backUrl = shouldBackToHome ? "/" : `/view?album=${q.get("album")}`;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
        to: backUrl,
        className: "back_home tab",
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$21b07c8f274aebd5), {})
    });
};
const $f9586f0c173f29a3$var$AlbumNameTab = ({ albumName: albumName })=>{
    const [q, err] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const active = !err && q.has("album") && !q.has("score");
    const albumId = q.get("album");
    const url = `/view?album=${albumId}`;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
        to: url,
        className: "tab_album_name tab",
        "data-active": active,
        children: albumName
    });
};
const $f9586f0c173f29a3$var$MenuOpenButton = ({ ...props })=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "menu-open-button",
        ...props,
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$770825e57b48d94e), {})
    });
};
const $f9586f0c173f29a3$var$TuneTab = ({ tune: tune, viewed: viewed })=>{
    const album = (0, $75a321daa887b448$export$8a39e334f881b685)();
    const _closeScore = (0, $6796445aad86e7f6$export$4fa39c0fb646aeaf)();
    const closeScore = (e)=>{
        _closeScore(tune.id);
        e.stopPropagation();
        e.preventDefault();
    };
    const url = `/view?score=${tune.id}&album=${album}`;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
        to: url,
        className: "tab tab-tune",
        "data-active": viewed,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tab_name",
                children: tune.name
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tab_close",
                onClick: closeScore,
                children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e9563b95ab65753c$export$3c877bb842c36952), {})
            })
        ]
    });
};




var $bNh2M = parcelRequire("bNh2M");





parcelRequire("bNh2M");
function $a1f8b91022129636$export$b08b517936747730() {
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "loading_spinner",
        children: [
            0,
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "loading_spinner_dot"
            }, i))
    });
}






var $bNh2M = parcelRequire("bNh2M");

const $8b4302012b28f389$export$cf92f2469d41c146 = ()=>{
    const scrollValue = (0, $bNh2M.useRef)(0);
    const id = (0, $bNh2M.useRef)(0);
    const startObservation = (0, $bNh2M.useCallback)(()=>{
        const scrollOriginElement = (0, $13c1aa054ab5f4da$export$13a705e512049f3a)();
        const anime = ()=>{
            scrollValue.current = scrollOriginElement?.scrollTop;
            id.current = requestAnimationFrame(anime);
        };
        setTimeout(anime, 1000);
    }, []);
    const stopObservation = (0, $bNh2M.useCallback)(()=>{
        cancelAnimationFrame(id.current);
    }, []);
    const restore = (0, $bNh2M.useCallback)(()=>{
        const scrollOriginElement = (0, $13c1aa054ab5f4da$export$13a705e512049f3a)();
        requestAnimationFrame(()=>{
            scrollOriginElement.scrollTop = scrollValue.current;
        });
    }, []);
    return {
        startObservation: startObservation,
        stopObservation: stopObservation,
        restore: restore
    };
};



const $fcc251bdfe5da48d$var$useTwin = (initial)=>{
    const [[last, current], setTwin] = (0, $bNh2M.useState)(initial);
    const update = $bNh2M.useCallback((next)=>setTwin(([, current])=>[
                current,
                next
            ]), []);
    $bNh2M.useDebugValue([
        last,
        current
    ]);
    return [
        last,
        current,
        update
    ];
};
const $fcc251bdfe5da48d$var$useTuneListScrollSave = ()=>{
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const [last, current, update] = $fcc251bdfe5da48d$var$useTwin([
        "else",
        "else"
    ]);
    $bNh2M.useEffect(()=>{
        if (q.has("score")) update("score");
        else if (q.has("album")) update("album");
        else update("else");
    }, [
        q.has("score"),
        q.has("album"),
        update
    ]);
    const { startObservation: startObservation, stopObservation: stopObservation, restore: restore } = (0, $8b4302012b28f389$export$cf92f2469d41c146)();
    $bNh2M.useLayoutEffect(()=>{
        if (current === "album") {
            startObservation();
            if (last === "score") restore();
        }
        return ()=>stopObservation();
    }, [
        last,
        current
    ]);
    return stopObservation;
};
const $fcc251bdfe5da48d$export$d69d36eb8a280525 = ()=>{
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const { loading: loading, tunes: tunes, indices: indices } = (0, $72db29bf798c8557$export$818d003b32cd03f9)();
    const cancel = $fcc251bdfe5da48d$var$useTuneListScrollSave();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "album_tune_list",
        hidden: q.has("score") || !q.has("album"),
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($fcc251bdfe5da48d$var$AlbumIndicies, {
                indices: indices
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $83be4e8e99a6273a$export$e4624626de9ce646), {}),
            loading ? /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $a1f8b91022129636$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $ce6a5d94e0bda3fb$exports.Fragment), {}),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($fcc251bdfe5da48d$var$RenderListItems, {
                tunesIndexed: tunes,
                saveScroll: cancel
            })
        ]
    });
};
const $fcc251bdfe5da48d$var$AlbumIndicies = ({ indices: indices })=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "album_indices",
        children: indices.map((idx)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "album_index_jump",
                onClick: $fcc251bdfe5da48d$var$jumpToIndex(idx),
                children: idx
            }, idx))
    });
};
const $fcc251bdfe5da48d$var$jumpToIndex = (key)=>(e)=>{
        const elem = e.target;
        (0, $ed8e29b4d971a8ff$export$7a81604c42a7e645)(elem, ()=>{});
        const tunesContainer = elem.closest("#album_tune_list").querySelector("#album_container_tunes");
        const target = tunesContainer.querySelector(`.section_label[data-anchor=${key}]`);
        target?.scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
    };
const $fcc251bdfe5da48d$var$RenderListItems = ({ tunesIndexed: tunesIndexed, saveScroll: saveScroll })=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        id: "album_container_tunes",
        children: Array.from(tunesIndexed).map(([index, tunes])=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)($bNh2M.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                        className: "section_label",
                        "data-anchor": index,
                        children: index
                    }),
                    tunes.map((tune)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($fcc251bdfe5da48d$var$ItemTune, {
                            tune: tune,
                            saveScroll: saveScroll
                        }, tune.id))
                ]
            }, index))
    });
};
const $fcc251bdfe5da48d$var$ItemTune = ({ tune: tune, saveScroll: saveScroll })=>{
    const [contextOpenFor, openContextMenu] = (0, $7c9b300c545ed81c$exports.useAtom)((0, $437ae0db12065587$export$e2ff2c2f4cf81116));
    const albumId = (0, $75a321daa887b448$export$8a39e334f881b685)();
    const ctxmenuOpen = contextOpenFor === tune.id;
    const navigate = (0, $e6c15aaa44b364a9$export$9770f232ac06a008)();
    const ref = (0, $bNh2M.useRef)();
    (0, $bNh2M.useEffect)(()=>{
        const listener = (ev)=>{
            const target = ev.target;
            if (target instanceof Node) {
                if (!ref.current?.contains(target)) {
                    if (!(target instanceof Element && target.closest(".tune_wrap"))) openContextMenu(null);
                }
            }
        };
        if (ctxmenuOpen) {
            window.addEventListener("click", listener);
            window.addEventListener("contextmenu", listener);
            window.addEventListener("touchstart", listener);
        }
        return ()=>{
            if (ctxmenuOpen) {
                window.removeEventListener("click", listener);
                window.removeEventListener("contextmenu", listener);
                window.removeEventListener("touchstart", listener);
            }
        };
    }, [
        ctxmenuOpen
    ]);
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        className: "tune_wrap",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                className: "tune",
                onClick: ()=>{
                    saveScroll();
                    navigate(`/view?score=${tune.id}&album=${albumId}`);
                },
                onContextMenu: (e)=>{
                    e.preventDefault();
                    openContextMenu(tune.id);
                },
                children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
                    className: "tune_name",
                    children: tune.name
                })
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $f358c41b17f050c5$export$1bc221ec8553027c), {
                item: tune,
                shown: ctxmenuOpen
            })
        ]
    });
}; // function isEventOnLabel(e: Event) {
 //   const target = e.target as Element;
 //   return target.classList.contains("section_label");
 // }
 // function getBoundTune(e: Event): [Tune, Element] {
 //   const target = e.target as Element;
 //   const tuneDom = target.closest(".tune_name");
 //   return [tuneDom["tune-bound"] as Tune, tuneDom];
 // }
 // function onContextMenuTune(e: Event) {
 //   if (isEventOnLabel(e)) return;
 //   const [tune] = getBoundTune(e);
 //   if (ctxmenuOpenFor.value !== tune.id) {
 //     ctxmenuOpenFor.value = tune.id;
 //     e.preventDefault();
 //   }
 // }
 // document.addEventListener("click", (e) => {
 //   if (!(e.target as HTMLElement).closest("#album_tune_list")) {
 //     ctxmenuOpenFor.value = null;
 //   }
 // });
 // function onCloseCtxMenu(e: Event) {
 //   ctxmenuOpenFor.value = null;
 //   e.stopPropagation();
 // }


/// <reference path="../scripts/wakelock.d.ts"/>


var $bNh2M = parcelRequire("bNh2M");





var $bNh2M = parcelRequire("bNh2M");
const $94b0beff4e6be51d$var$getNow = ()=>new Date().getTime();
function $94b0beff4e6be51d$export$8b7b9481d6186f21(fn, spanMs) {
    const [last, setLast] = (0, $bNh2M.useState)($94b0beff4e6be51d$var$getNow());
    return (...args)=>{
        const now = $94b0beff4e6be51d$var$getNow();
        if (now - last > spanMs) {
            setLast(now);
            return fn(...args);
        }
    };
}


function $edf605dddde973f1$export$8178d2b67ce25c0b(t) {
    return [
        t.clientX,
        t.clientY
    ];
}
function $edf605dddde973f1$export$a37e3c603d7117e5(l, r) {
    return [
        l[0] - r[0],
        l[1] - r[1]
    ];
}
function $edf605dddde973f1$export$2335f513bbd82c6d(v) {
    return Math.sqrt(v[0] ** 2 + v[1] ** 2);
}






var $bNh2M = parcelRequire("bNh2M");

var $qziBq = parcelRequire("qziBq");
function $87b921892ab8024b$export$2e2bcd8739ae039() {
    return $87b921892ab8024b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $87b921892ab8024b$export$2e2bcd8739ae039.apply(null, arguments);
}


function $e274d2f6a6b9165a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $c1aa73bd5e1c95bb$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $e274d2f6a6b9165a$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $1133a66c6bd2f312$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1133a66c6bd2f312$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1133a66c6bd2f312$export$2e2bcd8739ae039(o);
}


function $89e30e790d3b5e50$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $59a13c059bd440f9$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $0a5e6a918aedc415$export$2e2bcd8739ae039(t) {
    var i = (0, $59a13c059bd440f9$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $4f3b5cf5a29275c7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $0a5e6a918aedc415$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $4f3b5cf5a29275c7$export$2e2bcd8739ae039(e, r, t) {
    return r && $4f3b5cf5a29275c7$var$_defineProperties(e.prototype, r), t && $4f3b5cf5a29275c7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $8a40e79f7a8d30eb$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $be2ae200b429dd77$export$2e2bcd8739ae039(t, e) {
    return $be2ae200b429dd77$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $be2ae200b429dd77$export$2e2bcd8739ae039(t, e);
}


function $7bfabe36ee4b3c15$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $be2ae200b429dd77$export$2e2bcd8739ae039)(t, e);
}




function $c7607d75fb28fe56$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(t);
}


function $eb26d965eb508e2d$export$2e2bcd8739ae039(t) {
    return $eb26d965eb508e2d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $eb26d965eb508e2d$export$2e2bcd8739ae039(t);
}



function $17e8bb57d3456022$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $0a5e6a918aedc415$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $bNh2M = parcelRequire("bNh2M");
var $0e351cebb744ffa1$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0e351cebb744ffa1$var$ReactIs, $0e351cebb744ffa1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0e351cebb744ffa1$exports = (parcelRequire("k6tn1"))();


var $3550c241e53866c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3550c241e53866c3$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
var $3550c241e53866c3$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var $3550c241e53866c3$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
var $3550c241e53866c3$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var $3550c241e53866c3$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
var $3550c241e53866c3$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var $3550c241e53866c3$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var $3550c241e53866c3$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var $3550c241e53866c3$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var $3550c241e53866c3$export$d93346aa7735a637 = [
    'onSelect'
];
var $3550c241e53866c3$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $3550c241e53866c3$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var $3550c241e53866c3$export$bac3087b5cb826f6 = [
    'onScroll'
];
var $3550c241e53866c3$export$28298837799e00e8 = [
    'onWheel'
];
var $3550c241e53866c3$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var $3550c241e53866c3$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
var $3550c241e53866c3$export$477a88c5b93a108d = [
    'onToggle'
];
var $3550c241e53866c3$export$7212b61f9f58bd1 = [
    'onChange'
];
var $3550c241e53866c3$export$59ef7197c4d7b9dc = $3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray($3550c241e53866c3$var$__spreadArray([], $3550c241e53866c3$export$84fe03429ed1b6d6, true), $3550c241e53866c3$export$dbc46161504615f7, true), $3550c241e53866c3$export$fb6351c2666f0875, true), $3550c241e53866c3$export$4e58c1a9761ed81a, true), $3550c241e53866c3$export$3bf7402f2a4eb3af, true), $3550c241e53866c3$export$409c4891d97f97cf, true), $3550c241e53866c3$export$6be5aa2386088264, true), $3550c241e53866c3$export$3a6e2b8954613992, true), $3550c241e53866c3$export$6c96379d5b8a2df7, true), $3550c241e53866c3$export$d93346aa7735a637, true), $3550c241e53866c3$export$fa367689c659e65c, true), $3550c241e53866c3$export$c731eab7619e00a0, true), $3550c241e53866c3$export$bac3087b5cb826f6, true), $3550c241e53866c3$export$28298837799e00e8, true), $3550c241e53866c3$export$6ff45424014e7407, true), $3550c241e53866c3$export$78878fc7bd50dc3e, true), $3550c241e53866c3$export$7212b61f9f58bd1, true), $3550c241e53866c3$export$477a88c5b93a108d, true);
function $3550c241e53866c3$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $3550c241e53866c3$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $58dbe27b41a9bd8a$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $51744a8712f12a52$export$2e2bcd8739ae039() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === 'string';
    }).join(' ');
}


var $614ec1ce3517453a$var$isProduction = true;
var $614ec1ce3517453a$var$prefix = 'Invariant failed';
function $614ec1ce3517453a$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($614ec1ce3517453a$var$isProduction) throw new Error($614ec1ce3517453a$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($614ec1ce3517453a$var$prefix, ": ").concat(provided) : $614ec1ce3517453a$var$prefix;
    throw new Error(value);
}


var $b67effd2ccb1c8a9$var$isProduction = true;
function $b67effd2ccb1c8a9$var$warning(condition, message) {
    if (!$b67effd2ccb1c8a9$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $b67effd2ccb1c8a9$export$2e2bcd8739ae039 = $b67effd2ccb1c8a9$var$warning;



var $qziBq = parcelRequire("qziBq");

var $bNh2M = parcelRequire("bNh2M");
var $1a4ab613792e98ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bNh2M.createContext)(null);



var $bNh2M = parcelRequire("bNh2M");

function $3f0b0ba53733c98e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, type = _ref.type;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", {
        className: "react-pdf__message react-pdf__message--".concat(type)
    }, children);
}
$3f0b0ba53733c98e$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOf([
        'error',
        'loading',
        'no-data'
    ]).isRequired
};





var $dc73024db63cb50b$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
var $dc73024db63cb50b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function LinkService() {
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, LinkService);
        this.externalLinkTarget = null;
        this.externalLinkRel = null;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(LinkService, [
        {
            key: "setDocument",
            value: function setDocument(pdfDocument) {
                this.pdfDocument = pdfDocument;
            }
        },
        {
            key: "setViewer",
            value: function setViewer(pdfViewer) {
                this.pdfViewer = pdfViewer;
            }
        },
        {
            key: "setExternalLinkRel",
            value: function setExternalLinkRel(externalLinkRel) {
                this.externalLinkRel = externalLinkRel;
            }
        },
        {
            key: "setExternalLinkTarget",
            value: function setExternalLinkTarget(externalLinkTarget) {
                this.externalLinkTarget = externalLinkTarget;
            }
        },
        {
            key: "setHistory",
            value: function setHistory() {}
        },
        {
            key: "pagesCount",
            get: function get() {
                return this.pdfDocument ? this.pdfDocument.numPages : 0;
            }
        },
        {
            key: "page",
            get: function get() {
                return this.pdfViewer.currentPageNumber;
            },
            set: function set(value) {
                this.pdfViewer.currentPageNumber = value;
            }
        },
        {
            key: "rotation",
            get: function get() {
                return 0;
            },
            set: function set(value) {}
        },
        {
            key: "goToDestination",
            value: function goToDestination(dest) {
                var _this = this;
                new Promise(function(resolve) {
                    if (typeof dest === 'string') _this.pdfDocument.getDestination(dest).then(resolve);
                    else if (Array.isArray(dest)) resolve(dest);
                    else dest.then(resolve);
                }).then(function(explicitDest) {
                    (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(Array.isArray(explicitDest), "\"".concat(explicitDest, "\" is not a valid destination array."));
                    var destRef = explicitDest[0];
                    new Promise(function(resolve) {
                        if (destRef instanceof Object) _this.pdfDocument.getPageIndex(destRef).then(function(pageIndex) {
                            resolve(pageIndex);
                        })["catch"](function() {
                            (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(false, "\"".concat(destRef, "\" is not a valid page reference."));
                        });
                        else if (typeof destRef === 'number') resolve(destRef);
                        else (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(false, "\"".concat(destRef, "\" is not a valid destination reference."));
                    }).then(function(pageIndex) {
                        var pageNumber = pageIndex + 1;
                        (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= _this.pagesCount, "\"".concat(pageNumber, "\" is not a valid page number."));
                        _this.pdfViewer.scrollPageIntoView({
                            dest: dest,
                            pageIndex: pageIndex,
                            pageNumber: pageNumber
                        });
                    });
                });
            }
        },
        {
            key: "navigateTo",
            value: function navigateTo(dest) {
                this.goToDestination(dest);
            }
        },
        {
            key: "goToPage",
            value: function goToPage() {}
        },
        {
            key: "addLinkAttributes",
            value: function addLinkAttributes(link, url, newWindow) {
                link.href = url;
                link.rel = this.externalLinkRel || $dc73024db63cb50b$var$DEFAULT_LINK_REL;
                link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
            }
        },
        {
            key: "getDestinationHash",
            value: function getDestinationHash() {
                return '#';
            }
        },
        {
            key: "getAnchorUrl",
            value: function getAnchorUrl() {
                return '#';
            }
        },
        {
            key: "setHash",
            value: function setHash() {}
        },
        {
            key: "executeNamedAction",
            value: function executeNamedAction() {}
        },
        {
            key: "cachePageRef",
            value: function cachePageRef() {}
        },
        {
            key: "isPageVisible",
            value: function isPageVisible() {
                return true;
            }
        },
        {
            key: "isPageCached",
            value: function isPageCached() {
                return true;
            }
        }
    ]);
    return LinkService;
}();


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
var $501242cf2fd22725$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $501242cf2fd22725$export$2e2bcd8739ae039 = $501242cf2fd22725$var$PasswordResponses;


function $c403fe9cb766623a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $b6ec4568c64c2404$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $b2d62f174be03068$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $e5898face0b0d9b1$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b2d62f174be03068$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b2d62f174be03068$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $182610fc82270f39$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $58f05890a8c2f436$export$2e2bcd8739ae039(r, e) {
    return (0, $c403fe9cb766623a$export$2e2bcd8739ae039)(r) || (0, $b6ec4568c64c2404$export$2e2bcd8739ae039)(r, e) || (0, $e5898face0b0d9b1$export$2e2bcd8739ae039)(r, e) || (0, $182610fc82270f39$export$2e2bcd8739ae039)();
}




var $c011d1ac6c054972$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $c011d1ac6c054972$export$d528e4159a0e221e = $c011d1ac6c054972$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $c011d1ac6c054972$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $c011d1ac6c054972$export$ef8866826b0b1f6d(variable) {
    return $c011d1ac6c054972$export$4e62c701997796c1(variable) && variable !== null;
}
function $c011d1ac6c054972$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $c011d1ac6c054972$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $c011d1ac6c054972$export$5bcd6e94ed871c88(variable) {
    (0, $614ec1ce3517453a$export$2e2bcd8739ae039)($c011d1ac6c054972$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $c011d1ac6c054972$export$be78b3111c50efdd(variable) {
    (0, $614ec1ce3517453a$export$2e2bcd8739ae039)($c011d1ac6c054972$export$4e09c449d6c407f7, 'isFile can only be used in a browser environment');
    return variable instanceof File;
}
function $c011d1ac6c054972$export$4d82193ef6a8d75c(str) {
    return $c011d1ac6c054972$export$844ec244b1367d54(str) && /^data:/.test(str);
}
function $c011d1ac6c054972$export$c1553384119518c3(dataURI) {
    (0, $614ec1ce3517453a$export$2e2bcd8739ae039)($c011d1ac6c054972$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    var _dataURI$split = dataURI.split(','), _dataURI$split2 = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(_dataURI$split, 2), headersString = _dataURI$split2[0], dataString = _dataURI$split2[1];
    var headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $c011d1ac6c054972$export$d39ce20a37bba061() {
    return $c011d1ac6c054972$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
var $c011d1ac6c054972$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $c011d1ac6c054972$export$84884c3182d1bdda() {
    (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(!$c011d1ac6c054972$export$d528e4159a0e221e, "Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ".concat($c011d1ac6c054972$var$allowFileAccessFromFilesTip));
}
function $c011d1ac6c054972$export$e7ec4a9e2d586a77() {
    (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(!$c011d1ac6c054972$export$d528e4159a0e221e, "Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ".concat($c011d1ac6c054972$var$allowFileAccessFromFilesTip));
}
function $c011d1ac6c054972$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $c011d1ac6c054972$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get: function get() {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get: function get() {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get: function get() {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get: function get() {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $c011d1ac6c054972$export$99075c4d008e6ab1(error) {
    return error.name === 'RenderingCancelledException';
}
function $c011d1ac6c054972$export$21fedb3a7a137f3d(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(new Uint8Array(reader.result));
        };
        reader.onerror = function(event) {
            switch(event.target.error.code){
                case event.target.error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case event.target.error.NOT_READABLE_ERR:
                    return reject(new Error('Error while reading a file: File not readable.'));
                case event.target.error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case event.target.error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
        return null;
    });
}




function $f8d635939998b29c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $b2d62f174be03068$export$2e2bcd8739ae039)(r);
}


function $f30271010b66ea3c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $6b62625a362b290e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f688ae9acbab33cf$export$2e2bcd8739ae039(r) {
    return (0, $f8d635939998b29c$export$2e2bcd8739ae039)(r) || (0, $f30271010b66ea3c$export$2e2bcd8739ae039)(r) || (0, $e5898face0b0d9b1$export$2e2bcd8739ae039)(r) || (0, $6b62625a362b290e$export$2e2bcd8739ae039)();
}






var $33a7a8f1dcd1ab06$export$1e08905474334888 = function() {
    var result = {};
    [].concat((0, $f688ae9acbab33cf$export$2e2bcd8739ae039)((0, $3550c241e53866c3$export$3a6e2b8954613992)), (0, $f688ae9acbab33cf$export$2e2bcd8739ae039)((0, $3550c241e53866c3$export$fa367689c659e65c)), (0, $f688ae9acbab33cf$export$2e2bcd8739ae039)((0, $3550c241e53866c3$export$409c4891d97f97cf))).forEach(function(eventName) {
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func;
    });
    return result;
}();
var $33a7a8f1dcd1ab06$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string
        ]),
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).object,
        range: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).object,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool
    })
];
if (typeof File !== 'undefined') $33a7a8f1dcd1ab06$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).instanceOf(File));
if (typeof Blob !== 'undefined') $33a7a8f1dcd1ab06$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).instanceOf(Blob));
var $33a7a8f1dcd1ab06$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string)
]);
var $33a7a8f1dcd1ab06$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType($33a7a8f1dcd1ab06$var$fileTypes);
var $33a7a8f1dcd1ab06$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).instanceOf((0, $dc73024db63cb50b$export$2e2bcd8739ae039));
var $33a7a8f1dcd1ab06$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOf([
    '_self',
    '_blank',
    '_parent',
    '_top'
]);
var $33a7a8f1dcd1ab06$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
    _transport: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        fontLoader: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).object.isRequired
    }).isRequired,
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        _objs: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).object.isRequired
    }).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired
});
var $33a7a8f1dcd1ab06$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    var pageIndex = props[propName], pageNumber = props.pageNumber, pdf = props.pdf;
    if (!(0, $c011d1ac6c054972$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $c011d1ac6c054972$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== 'number') return new Error("`".concat(propName, "` of type `").concat((0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageIndex < 0) return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
        var numPages = pdf.numPages;
        if (pageIndex + 1 > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    } else if (!(0, $c011d1ac6c054972$export$4e62c701997796c1)(pageNumber)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $33a7a8f1dcd1ab06$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    var pageNumber = props[propName], pageIndex = props.pageIndex, pdf = props.pdf;
    if (!(0, $c011d1ac6c054972$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $c011d1ac6c054972$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== 'number') return new Error("`".concat(propName, "` of type `").concat((0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageNumber < 1) return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
        var numPages = pdf.numPages;
        if (pageNumber > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    } else if (!(0, $c011d1ac6c054972$export$4e62c701997796c1)(pageIndex)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $33a7a8f1dcd1ab06$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        getDestination: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
        getOutline: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
        getPage: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func.isRequired,
        numPages: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool
]);
var $33a7a8f1dcd1ab06$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).any
    })
]);
var $33a7a8f1dcd1ab06$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOf([
    'canvas',
    'none',
    'svg'
]);
var $33a7a8f1dcd1ab06$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOf([
    0,
    90,
    180,
    270
]);


var $d0db2cfd1e2a88ee$var$_excluded = [
    "url"
];
function $d0db2cfd1e2a88ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d0db2cfd1e2a88ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d0db2cfd1e2a88ee$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $17e8bb57d3456022$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d0db2cfd1e2a88ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d0db2cfd1e2a88ee$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d0db2cfd1e2a88ee$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $d0db2cfd1e2a88ee$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $d0db2cfd1e2a88ee$var$PDFDataRangeTransport = $qziBq.PDFDataRangeTransport;
var $d0db2cfd1e2a88ee$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(Document, _PureComponent);
    var _super = $d0db2cfd1e2a88ee$var$_createSuper(Document);
    function Document() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, Document);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            pdf: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "viewer", {
            scrollPageIntoView: function scrollPageIntoView(_ref) {
                var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
                // Handling jumping to internal links target
                var onItemClick = _this.props.onItemClick; // First, check if custom handling of onItemClick was provided
                if (onItemClick) {
                    onItemClick({
                        dest: dest,
                        pageIndex: pageIndex,
                        pageNumber: pageNumber
                    });
                    return;
                } // If not, try to look for target page within the <Document>.
                var page = _this.pages[pageIndex];
                if (page) {
                    // Scroll to the page automatically
                    page.scrollIntoView();
                    return;
                }
                (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
            }
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "linkService", new (0, $dc73024db63cb50b$export$2e2bcd8739ae039)());
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "loadDocument", function() {
            // If another rendering is in progress, let's cancel it
            (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(_this.runningTask); // If another loading is in progress, let's destroy it
            if (_this.loadingTask) _this.loadingTask.destroy();
            var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(_this.findDocumentSource());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(source) {
                _this.onSourceSuccess();
                if (!source) return;
                _this.setState(function(prevState) {
                    if (!prevState.pdf) return null;
                    return {
                        pdf: null
                    };
                });
                var _this$props = _this.props, options = _this$props.options, onLoadProgress = _this$props.onLoadProgress, onPassword = _this$props.onPassword;
                _this.loadingTask = $qziBq.getDocument($d0db2cfd1e2a88ee$var$_objectSpread($d0db2cfd1e2a88ee$var$_objectSpread({}, source), options));
                _this.loadingTask.onPassword = onPassword;
                if (onLoadProgress) _this.loadingTask.onProgress = onLoadProgress;
                var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(_this.loadingTask.promise);
                _this.runningTask = cancellable;
                cancellable.promise.then(function(pdf) {
                    _this.setState(function(prevState) {
                        if (prevState.pdf && prevState.pdf.fingerprint === pdf.fingerprint) return null;
                        return {
                            pdf: pdf
                        };
                    }, _this.onLoadSuccess);
                })["catch"](function(error) {
                    _this.onLoadError(error);
                });
            })["catch"](function(error) {
                _this.onSourceError(error);
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "setupLinkService", function() {
            var _this$props2 = _this.props, externalLinkRel = _this$props2.externalLinkRel, externalLinkTarget = _this$props2.externalLinkTarget;
            _this.linkService.setViewer(_this.viewer);
            _this.linkService.setExternalLinkRel(externalLinkRel);
            _this.linkService.setExternalLinkTarget(externalLinkTarget);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onSourceSuccess", function() {
            var onSourceSuccess = _this.props.onSourceSuccess;
            if (onSourceSuccess) onSourceSuccess();
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onSourceError", function(error) {
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onSourceError = _this.props.onSourceError;
            if (onSourceError) onSourceError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var pdf = _this.state.pdf;
            if (onLoadSuccess) onLoadSuccess(pdf);
            _this.pages = new Array(pdf.numPages);
            _this.linkService.setDocument(pdf);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                pdf: false
            });
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "findDocumentSource", function() {
            return new Promise(function(resolve) {
                var file = _this.props.file;
                if (!file) resolve(null);
                 // File is a string
                if (typeof file === 'string') {
                    if ((0, $c011d1ac6c054972$export$4d82193ef6a8d75c)(file)) {
                        var fileByteString = (0, $c011d1ac6c054972$export$c1553384119518c3)(file);
                        resolve({
                            data: fileByteString
                        });
                    }
                    (0, $c011d1ac6c054972$export$84884c3182d1bdda)();
                    resolve({
                        url: file
                    });
                } // File is PDFDataRangeTransport
                if (file instanceof $d0db2cfd1e2a88ee$var$PDFDataRangeTransport) resolve({
                    range: file
                });
                 // File is an ArrayBuffer
                if ((0, $c011d1ac6c054972$export$9dd3754ae86f0017)(file)) resolve({
                    data: file
                });
                /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $c011d1ac6c054972$export$4e09c449d6c407f7) // File is a Blob
                {
                    if ((0, $c011d1ac6c054972$export$5bcd6e94ed871c88)(file) || (0, $c011d1ac6c054972$export$be78b3111c50efdd)(file)) {
                        (0, $c011d1ac6c054972$export$21fedb3a7a137f3d)(file).then(function(data) {
                            resolve({
                                data: data
                            });
                        });
                        return;
                    }
                } // At this point, file must be an object
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)((0, $1133a66c6bd2f312$export$2e2bcd8739ae039)(file) === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(file.url || file.data || file.range, 'Invalid parameter object: need either .data, .range or .url'); // File .url is a string
                if (typeof file.url === 'string') {
                    if ((0, $c011d1ac6c054972$export$4d82193ef6a8d75c)(file.url)) {
                        var url = file.url, otherParams = (0, $c1aa73bd5e1c95bb$export$2e2bcd8739ae039)(file, $d0db2cfd1e2a88ee$var$_excluded);
                        var _fileByteString = (0, $c011d1ac6c054972$export$c1553384119518c3)(url);
                        resolve($d0db2cfd1e2a88ee$var$_objectSpread({
                            data: _fileByteString
                        }, otherParams));
                    }
                    (0, $c011d1ac6c054972$export$84884c3182d1bdda)();
                }
                resolve(file);
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "registerPage", function(pageIndex, ref) {
            _this.pages[pageIndex] = ref;
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "unregisterPage", function(pageIndex) {
            delete _this.pages[pageIndex];
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(Document, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.loadDocument();
                this.setupLinkService();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var file = this.props.file;
                if (file !== prevProps.file) this.loadDocument();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // If rendering is in progress, let's cancel it
                (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(this.runningTask); // If loading is in progress, let's destroy it
                if (this.loadingTask) this.loadingTask.destroy();
            }
        },
        {
            key: "childContext",
            get: function get() {
                var linkService = this.linkService, registerPage = this.registerPage, unregisterPage = this.unregisterPage;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, renderMode = _this$props3.renderMode, rotate = _this$props3.rotate;
                var pdf = this.state.pdf;
                return {
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    pdf: pdf,
                    registerPage: registerPage,
                    renderMode: renderMode,
                    rotate: rotate,
                    unregisterPage: unregisterPage
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $3550c241e53866c3$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.pdf;
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1a4ab613792e98ce$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var file = this.props.file;
                var pdf = this.state.pdf;
                if (!file) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === 'function' ? noData() : noData);
                }
                if (pdf === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === 'function' ? loading() : loading);
                }
                if (pdf === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === 'function' ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, className = _this$props4.className, inputRef = _this$props4.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
                    className: (0, $51744a8712f12a52$export$2e2bcd8739ae039)('react-pdf__Document', className),
                    ref: inputRef
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return Document;
}((0, $bNh2M.PureComponent));
$d0db2cfd1e2a88ee$export$2e2bcd8739ae039.defaultProps = {
    error: 'Failed to load PDF file.',
    loading: "Loading PDF\u2026",
    noData: 'No PDF file specified.',
    onPassword: function onPassword(callback, reason) {
        switch(reason){
            case (0, $501242cf2fd22725$export$2e2bcd8739ae039).NEED_PASSWORD:
                // eslint-disable-next-line no-alert
                var password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            case (0, $501242cf2fd22725$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
                // eslint-disable-next-line no-alert
                var _password = prompt('Invalid password. Please try again.');
                callback(_password);
                break;
            default:
        }
    }
};
var $d0db2cfd1e2a88ee$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).node
]);
$d0db2cfd1e2a88ee$export$2e2bcd8739ae039.propTypes = $d0db2cfd1e2a88ee$var$_objectSpread($d0db2cfd1e2a88ee$var$_objectSpread({}, (0, $33a7a8f1dcd1ab06$export$1e08905474334888)), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).node,
    className: (0, $33a7a8f1dcd1ab06$export$d53f3db2f43345df),
    error: $d0db2cfd1e2a88ee$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    file: (0, $33a7a8f1dcd1ab06$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    inputRef: (0, $33a7a8f1dcd1ab06$export$4f9f5282de18fc69),
    loading: $d0db2cfd1e2a88ee$var$isFunctionOrNode,
    noData: $d0db2cfd1e2a88ee$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number
});











var $bNh2M = parcelRequire("bNh2M");








var $bNh2M = parcelRequire("bNh2M");
var $165641e8de0f70c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bNh2M.createContext)(null);













var $bNh2M = parcelRequire("bNh2M");





var $4a796a321055d030$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Ref(_ref) {
        var num = _ref.num, gen = _ref.gen;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, Ref);
        this.num = num;
        this.gen = gen;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(Ref, [
        {
            key: "toString",
            value: function toString() {
                var str = "".concat(this.num, "R");
                if (this.gen !== 0) str += this.gen;
                return str;
            }
        }
    ]);
    return Ref;
}();




var $69b2d17d7e2e11af$var$_excluded = [
    "item"
];
function $69b2d17d7e2e11af$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $69b2d17d7e2e11af$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $69b2d17d7e2e11af$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $69b2d17d7e2e11af$export$9740e3c6481b5f0e = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(OutlineItemInternal, _PureComponent);
    var _super = $69b2d17d7e2e11af$var$_createSuper(OutlineItemInternal);
    function OutlineItemInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, OutlineItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "getDestination", function() {
            return new Promise(function(resolve, reject) {
                var _this$props = _this.props, item = _this$props.item, pdf = _this$props.pdf;
                if (!(0, $c011d1ac6c054972$export$4e62c701997796c1)(_this.destination)) {
                    if (typeof item.dest === 'string') pdf.getDestination(item.dest).then(resolve)["catch"](reject);
                    else resolve(item.dest);
                }
                return _this.destination;
            }).then(function(destination) {
                _this.destination = destination;
                return destination;
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "getPageIndex", function() {
            return new Promise(function(resolve, reject) {
                var pdf = _this.props.pdf;
                if ((0, $c011d1ac6c054972$export$4e62c701997796c1)(_this.pageIndex)) resolve(_this.pageIndex);
                _this.getDestination().then(function(destination) {
                    if (!destination) return;
                    var _destination = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(destination, 1), ref = _destination[0];
                    pdf.getPageIndex(new (0, $4a796a321055d030$export$2e2bcd8739ae039)(ref)).then(resolve)["catch"](reject);
                });
            }).then(function(pageIndex) {
                _this.pageIndex = pageIndex;
                return _this.pageIndex;
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "getPageNumber", function() {
            return new Promise(function(resolve, reject) {
                if ((0, $c011d1ac6c054972$export$4e62c701997796c1)(_this.pageNumber)) resolve(_this.pageNumber);
                _this.getPageIndex().then(function(pageIndex) {
                    resolve(pageIndex + 1);
                })["catch"](reject);
            }).then(function(pageNumber) {
                _this.pageNumber = pageNumber;
                return pageNumber;
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
            var onClick = _this.props.onClick;
            event.preventDefault();
            if (!onClick) return false;
            return Promise.all([
                _this.getDestination(),
                _this.getPageIndex(),
                _this.getPageNumber()
            ]).then(function(_ref) {
                var _ref2 = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(_ref, 3), dest = _ref2[0], pageIndex = _ref2[1], pageNumber = _ref2[2];
                onClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(OutlineItemInternal, [
        {
            key: "renderSubitems",
            value: function renderSubitems() {
                var _this$props2 = this.props, item = _this$props2.item, otherProps = (0, $c1aa73bd5e1c95bb$export$2e2bcd8739ae039)(_this$props2, $69b2d17d7e2e11af$var$_excluded);
                if (!item.items || !item.items.length) return null;
                var subitems = item.items;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("ul", null, subitems.map(function(subitem, subitemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement(OutlineItemInternal, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
                        key: typeof subitem.destination === 'string' ? subitem.destination : subitemIndex,
                        item: subitem
                    }, otherProps));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var item = this.props.item;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("a", {
                    href: "#",
                    onClick: this.onClick
                }, item.title), this.renderSubitems());
            }
        }
    ]);
    return OutlineItemInternal;
}((0, $bNh2M.PureComponent));
var $69b2d17d7e2e11af$var$isDestination = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).any)
]);
$69b2d17d7e2e11af$export$9740e3c6481b5f0e.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
        dest: $69b2d17d7e2e11af$var$isDestination,
        items: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).shape({
            dest: $69b2d17d7e2e11af$var$isDestination,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string
        })),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string
    }).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    pdf: (0, $33a7a8f1dcd1ab06$export$d22001c6ab8dd37).isRequired
};
var $69b2d17d7e2e11af$var$OutlineItem = function OutlineItem(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1a4ab613792e98ce$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $165641e8de0f70c9$export$2e2bcd8739ae039).Consumer, null, function(outlineContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($69b2d17d7e2e11af$export$9740e3c6481b5f0e, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, documentContext, outlineContext, props));
        });
    });
};
var $69b2d17d7e2e11af$export$2e2bcd8739ae039 = $69b2d17d7e2e11af$var$OutlineItem;




function $27c00919786925d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27c00919786925d8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27c00919786925d8$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $17e8bb57d3456022$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27c00919786925d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27c00919786925d8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $27c00919786925d8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $27c00919786925d8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $27c00919786925d8$export$5012f160061c9df4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(OutlineInternal, _PureComponent);
    var _super = $27c00919786925d8$var$_createSuper(OutlineInternal);
    function OutlineInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, OutlineInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            outline: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "loadOutline", function() {
            var pdf = _this.props.pdf;
            _this.setState(function(prevState) {
                if (!prevState.outline) return null;
                return {
                    outline: null
                };
            });
            var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(pdf.getOutline());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(outline) {
                _this.setState({
                    outline: outline
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var outline = _this.state.outline;
            if (onLoadSuccess) onLoadSuccess(outline);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                outline: false
            });
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onItemClick", function(_ref) {
            var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
            var onItemClick = _this.props.onItemClick;
            if (onItemClick) onItemClick({
                dest: dest,
                pageIndex: pageIndex,
                pageNumber: pageNumber
            });
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(OutlineInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(pdf, 'Attempted to load an outline, but no document was specified.');
                this.loadOutline();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf) this.loadOutline();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                return {
                    onClick: this.onItemClick
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $3550c241e53866c3$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.outline;
                });
            }
        },
        {
            key: "renderOutline",
            value: function renderOutline() {
                var outline = this.state.outline;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("ul", null, outline.map(function(item, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $69b2d17d7e2e11af$export$2e2bcd8739ae039), {
                        key: typeof item.destination === 'string' ? item.destination : itemIndex,
                        item: item
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var pdf = this.props.pdf;
                var outline = this.state.outline;
                if (!pdf || !outline) return null;
                var _this$props = this.props, className = _this$props.className, inputRef = _this$props.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
                    className: (0, $51744a8712f12a52$export$2e2bcd8739ae039)('react-pdf__Outline', className),
                    ref: inputRef
                }, this.eventProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $165641e8de0f70c9$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderOutline()));
            }
        }
    ]);
    return OutlineInternal;
}((0, $bNh2M.PureComponent));
$27c00919786925d8$export$5012f160061c9df4.propTypes = $27c00919786925d8$var$_objectSpread({
    className: (0, $33a7a8f1dcd1ab06$export$d53f3db2f43345df),
    inputRef: (0, $33a7a8f1dcd1ab06$export$4f9f5282de18fc69),
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    pdf: (0, $33a7a8f1dcd1ab06$export$d22001c6ab8dd37)
}, (0, $33a7a8f1dcd1ab06$export$1e08905474334888));
function $27c00919786925d8$var$Outline(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1a4ab613792e98ce$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($27c00919786925d8$export$5012f160061c9df4, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $27c00919786925d8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).forwardRef($27c00919786925d8$var$Outline);











var $bNh2M = parcelRequire("bNh2M");




/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $74b4b5036e7f6585$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}






var $bNh2M = parcelRequire("bNh2M");
var $5fbf441c69a32c45$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bNh2M.createContext)(null);












var $bNh2M = parcelRequire("bNh2M");




var $qziBq = parcelRequire("qziBq");



function $5148ceea765e4437$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5148ceea765e4437$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $5148ceea765e4437$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5148ceea765e4437$var$ANNOTATION_MODE = $qziBq.AnnotationMode;
var $5148ceea765e4437$export$e3ecf0e48491aaf4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(PageCanvasInternal, _PureComponent);
    var _super = $5148ceea765e4437$var$_createSuper(PageCanvasInternal);
    function PageCanvasInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, PageCanvasInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "canvasElement", /*#__PURE__*/ (0, $bNh2M.createRef)());
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $c011d1ac6c054972$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            if ((0, $c011d1ac6c054972$export$99075c4d008e6ab1)(error)) return;
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "drawPageOnCanvas", function() {
            var canvas = _this.canvasElement.current;
            if (!canvas) return null;
            var _assertThisInitialize = (0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), renderViewport = _assertThisInitialize.renderViewport, viewport = _assertThisInitialize.viewport;
            var _this$props2 = _this.props, canvasBackground = _this$props2.canvasBackground, page = _this$props2.page, renderForms = _this$props2.renderForms;
            canvas.width = renderViewport.width;
            canvas.height = renderViewport.height;
            canvas.style.width = "".concat(Math.floor(viewport.width), "px");
            canvas.style.height = "".concat(Math.floor(viewport.height), "px");
            var renderContext = {
                annotationMode: renderForms ? $5148ceea765e4437$var$ANNOTATION_MODE.ENABLE_FORMS : $5148ceea765e4437$var$ANNOTATION_MODE.ENABLE,
                get canvasContext () {
                    return canvas.getContext('2d');
                },
                viewport: renderViewport
            };
            if (canvasBackground) renderContext.background = canvasBackground;
             // If another render is in progress, let's cancel it
            _this.cancelRenderingTask();
            _this.renderer = page.render(renderContext);
            return _this.renderer.promise.then(_this.onRenderSuccess)["catch"](_this.onRenderError);
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(PageCanvasInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.drawPageOnCanvas();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, canvasBackground = _this$props3.canvasBackground, page = _this$props3.page, renderForms = _this$props3.renderForms;
                if (canvasBackground !== prevProps.canvasBackground || renderForms !== prevProps.renderForms) {
                    // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
                    page.cleanup();
                    this.drawPageOnCanvas();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRenderingTask();
                var canvas = this.canvasElement.current;
                /**
       * Zeroing the width and height cause most browsers to release graphics
       * resources immediately, which can greatly reduce memory consumption.
       */ if (canvas) {
                    canvas.width = 0;
                    canvas.height = 0;
                }
            }
        },
        {
            key: "cancelRenderingTask",
            value: function cancelRenderingTask() {
                if (this.renderer) {
                    this.renderer.cancel();
                    this.renderer = null;
                }
            }
        },
        {
            key: "renderViewport",
            get: function get() {
                var _this$props4 = this.props, page = _this$props4.page, rotate = _this$props4.rotate, scale = _this$props4.scale;
                var pixelRatio = (0, $c011d1ac6c054972$export$d39ce20a37bba061)();
                return page.getViewport({
                    scale: scale * pixelRatio,
                    rotation: rotate
                });
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props5 = this.props, page = _this$props5.page, rotate = _this$props5.rotate, scale = _this$props5.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var canvasRef = this.props.canvasRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("canvas", {
                    className: "react-pdf__Page__canvas",
                    dir: "ltr",
                    ref: (0, $74b4b5036e7f6585$export$2e2bcd8739ae039)(canvasRef, this.canvasElement),
                    style: {
                        display: 'block',
                        userSelect: 'none'
                    }
                });
            }
        }
    ]);
    return PageCanvasInternal;
}((0, $bNh2M.PureComponent));
$5148ceea765e4437$export$e3ecf0e48491aaf4.propTypes = {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    canvasRef: (0, $33a7a8f1dcd1ab06$export$4f9f5282de18fc69),
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    page: (0, $33a7a8f1dcd1ab06$export$61d82a1ff85c609a).isRequired,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number.isRequired
};
function $5148ceea765e4437$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($5148ceea765e4437$export$e3ecf0e48491aaf4, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $bNh2M = parcelRequire("bNh2M");



var $qziBq = parcelRequire("qziBq");



function $6d86bf07c2d24055$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6d86bf07c2d24055$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $6d86bf07c2d24055$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6d86bf07c2d24055$export$c43ce483afb9a093 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(PageSVGInternal, _PureComponent);
    var _super = $6d86bf07c2d24055$var$_createSuper(PageSVGInternal);
    function PageSVGInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, PageSVGInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            svg: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $c011d1ac6c054972$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            if ((0, $c011d1ac6c054972$export$99075c4d008e6ab1)(error)) return;
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "renderSVG", function() {
            var page = _this.props.page;
            _this.renderer = page.getOperatorList();
            return _this.renderer.then(function(operatorList) {
                var svgGfx = new $qziBq.SVGGraphics(page.commonObjs, page.objs);
                _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function(svg) {
                    _this.setState({
                        svg: svg
                    }, _this.onRenderSuccess);
                })["catch"](_this.onRenderError);
            })["catch"](_this.onRenderError);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "drawPageOnContainer", function(element) {
            var svg = _this.state.svg;
            if (!element || !svg) return;
             // Append SVG element to the main container, if this hasn't been done already
            if (!element.firstElementChild) element.appendChild(svg);
            var _this$viewport = _this.viewport, width = _this$viewport.width, height = _this$viewport.height;
            svg.setAttribute('width', width);
            svg.setAttribute('height', height);
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(PageSVGInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderSVG();
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$viewport2 = this.viewport, width = _this$viewport2.width, height = _this$viewport2.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", {
                    className: "react-pdf__Page__svg" // Note: This cannot be shortened, as we need this function to be called with each render.
                    ,
                    ref: function ref(_ref) {
                        return _this2.drawPageOnContainer(_ref);
                    },
                    style: {
                        display: 'block',
                        backgroundColor: 'white',
                        overflow: 'hidden',
                        width: width,
                        height: height,
                        userSelect: 'none'
                    }
                });
            }
        }
    ]);
    return PageSVGInternal;
}((0, $bNh2M.PureComponent));
$6d86bf07c2d24055$export$c43ce483afb9a093.propTypes = {
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    page: (0, $33a7a8f1dcd1ab06$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number.isRequired
};
function $6d86bf07c2d24055$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($6d86bf07c2d24055$export$c43ce483afb9a093, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $bNh2M = parcelRequire("bNh2M");















var $bNh2M = parcelRequire("bNh2M");



function $22ea26fa36d3d938$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $22ea26fa36d3d938$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $22ea26fa36d3d938$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $22ea26fa36d3d938$export$9a99b4bb3cdb3d5d = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(TextLayerItemInternal, _PureComponent);
    var _super = $22ea26fa36d3d938$var$_createSuper(TextLayerItemInternal);
    function TextLayerItemInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, TextLayerItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "itemElement", /*#__PURE__*/ (0, $bNh2M.createRef)());
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "getElementWidth", function(element) {
            var _assertThisInitialize = (0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), sideways = _assertThisInitialize.sideways;
            return element.getBoundingClientRect()[sideways ? 'height' : 'width'];
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(TextLayerItemInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.alignTextItem();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.alignTextItem();
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "sideways",
            get: function get() {
                var rotate = this.rotate;
                return rotate % 180 !== 0;
            }
        },
        {
            key: "defaultSideways",
            get: function get() {
                var rotation = this.unrotatedViewport.rotation;
                return rotation % 180 !== 0;
            }
        },
        {
            key: "fontSize",
            get: function get() {
                var transform = this.props.transform;
                var defaultSideways = this.defaultSideways;
                var _transform = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(transform, 2), fontHeightPx = _transform[0], fontWidthPx = _transform[1];
                return defaultSideways ? fontWidthPx : fontHeightPx;
            }
        },
        {
            key: "top",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform2 = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ offsetX = _transform2[2], offsetY = _transform2[3], x = _transform2[4], y = _transform2[5];
                var _viewport$viewBox = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(viewport.viewBox, 4), /* xMin */ yMin = _viewport$viewBox[1], yMax = _viewport$viewBox[3];
                return defaultSideways ? x + offsetX + yMin : yMax - (y + offsetY);
            }
        },
        {
            key: "left",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform3 = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ /* offsetX */ /* offsetY */ x = _transform3[4], y = _transform3[5];
                var _viewport$viewBox2 = (0, $58f05890a8c2f436$export$2e2bcd8739ae039)(viewport.viewBox, 1), xMin = _viewport$viewBox2[0];
                return defaultSideways ? y - xMin : x - xMin;
            }
        },
        {
            key: "getFontData",
            value: function getFontData(fontName) {
                var page = this.props.page;
                return new Promise(function(resolve) {
                    page.commonObjs.get(fontName, resolve);
                });
            }
        },
        {
            key: "alignTextItem",
            value: function alignTextItem() {
                var _this2 = this;
                var element = this.itemElement.current;
                if (!element) return;
                element.style.transform = '';
                var _this$props3 = this.props, fontName = _this$props3.fontName, scale = _this$props3.scale, width = _this$props3.width;
                element.style.fontFamily = "".concat(fontName, ", sans-serif");
                this.getFontData(fontName).then(function(fontData) {
                    var fallbackFontName = fontData ? fontData.fallbackName : 'sans-serif';
                    element.style.fontFamily = "".concat(fontName, ", ").concat(fallbackFontName);
                    var targetWidth = width * scale;
                    var actualWidth = _this2.getElementWidth(element);
                    var transform = "scaleX(".concat(targetWidth / actualWidth, ")");
                    var ascent = fontData ? fontData.ascent : 0;
                    if (ascent) transform += " translateY(".concat((1 - ascent) * 100, "%)");
                    element.style.transform = transform;
                    element.style.WebkitTransform = transform;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var fontSize = this.fontSize, top = this.top, left = this.left;
                var _this$props4 = this.props, customTextRenderer = _this$props4.customTextRenderer, scale = _this$props4.scale, text = _this$props4.str;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("span", {
                    ref: this.itemElement,
                    style: {
                        height: '1em',
                        fontFamily: 'sans-serif',
                        fontSize: "".concat(fontSize * scale, "px"),
                        position: 'absolute',
                        top: "".concat(top * scale, "px"),
                        left: "".concat(left * scale, "px"),
                        transformOrigin: 'left bottom',
                        whiteSpace: 'pre',
                        pointerEvents: 'all'
                    }
                }, customTextRenderer ? customTextRenderer(this.props) : text);
            }
        }
    ]);
    return TextLayerItemInternal;
}((0, $bNh2M.PureComponent));
$22ea26fa36d3d938$export$9a99b4bb3cdb3d5d.propTypes = {
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    fontName: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string.isRequired,
    itemIndex: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number.isRequired,
    page: (0, $33a7a8f1dcd1ab06$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number,
    str: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string.isRequired,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number.isRequired
};
function $22ea26fa36d3d938$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($22ea26fa36d3d938$export$9a99b4bb3cdb3d5d, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, context, props));
    });
}




function $2c1402934497d128$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2c1402934497d128$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $2c1402934497d128$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2c1402934497d128$export$2a4163b3d90be9ba = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(TextLayerInternal, _PureComponent);
    var _super = $2c1402934497d128$var$_createSuper(TextLayerInternal);
    function TextLayerInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, TextLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            textItems: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "loadTextItems", function() {
            var page = _this.props.page;
            var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(page.getTextContent());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(_ref) {
                var textItems = _ref.items;
                _this.setState({
                    textItems: textItems
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onGetTextSuccess = _this.props.onGetTextSuccess;
            var textItems = _this.state.textItems;
            if (onGetTextSuccess) onGetTextSuccess(textItems);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                textItems: false
            });
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onGetTextError = _this.props.onGetTextError;
            if (onGetTextError) onGetTextError(error);
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(TextLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(page, 'Attempted to load page text content, but no page was specified.');
                this.loadTextItems();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var page = this.props.page;
                if (prevProps.page && page !== prevProps.page) this.loadTextItems();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "renderTextItems",
            value: function renderTextItems() {
                var textItems = this.state.textItems;
                if (!textItems) return null;
                return textItems.map(function(textItem, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $22ea26fa36d3d938$export$2e2bcd8739ae039 // eslint-disable-next-line react/no-array-index-key
                    ), (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
                        key: itemIndex,
                        itemIndex: itemIndex
                    }, textItem));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var viewport = this.unrotatedViewport, rotate = this.rotate;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", {
                    className: "react-pdf__Page__textContent",
                    style: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: "".concat(viewport.width, "px"),
                        height: "".concat(viewport.height, "px"),
                        color: 'transparent',
                        transform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        WebkitTransform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        pointerEvents: 'none'
                    }
                }, this.renderTextItems());
            }
        }
    ]);
    return TextLayerInternal;
}((0, $bNh2M.PureComponent));
$2c1402934497d128$export$2a4163b3d90be9ba.propTypes = {
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    page: (0, $33a7a8f1dcd1ab06$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number
};
function $2c1402934497d128$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($2c1402934497d128$export$2a4163b3d90be9ba, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $bNh2M = parcelRequire("bNh2M");





var $qziBq = parcelRequire("qziBq");




function $1fa15a99e71d407b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1fa15a99e71d407b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $1fa15a99e71d407b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1fa15a99e71d407b$export$46f5ffc431ae68b7 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(AnnotationLayerInternal, _PureComponent);
    var _super = $1fa15a99e71d407b$var$_createSuper(AnnotationLayerInternal);
    function AnnotationLayerInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, AnnotationLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            annotations: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "layerElement", /*#__PURE__*/ (0, $bNh2M.createRef)());
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "loadAnnotations", function() {
            var page = _this.props.page;
            var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(page.getAnnotations());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(annotations) {
                _this.setState({
                    annotations: annotations
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onGetAnnotationsSuccess = _this.props.onGetAnnotationsSuccess;
            var annotations = _this.state.annotations;
            if (onGetAnnotationsSuccess) onGetAnnotationsSuccess(annotations);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                annotations: false
            });
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onGetAnnotationsError = _this.props.onGetAnnotationsError;
            if (onGetAnnotationsError) onGetAnnotationsError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            var onRenderAnnotationLayerSuccess = _this.props.onRenderAnnotationLayerSuccess;
            if (onRenderAnnotationLayerSuccess) onRenderAnnotationLayerSuccess();
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onRenderAnnotationLayerError = _this.props.onRenderAnnotationLayerError;
            if (onRenderAnnotationLayerError) onRenderAnnotationLayerError(error);
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(AnnotationLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(page, 'Attempted to load page annotations, but no page was specified.');
                this.loadAnnotations();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, page = _this$props.page, renderForms = _this$props.renderForms;
                if (prevProps.page && page !== prevProps.page || renderForms !== prevProps.renderForms) this.loadAnnotations();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var annotations = this.state.annotations;
                if (!annotations) return;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, linkService = _this$props3.linkService, page = _this$props3.page, renderForms = _this$props3.renderForms;
                var viewport = this.viewport.clone({
                    dontFlip: true
                });
                var parameters = {
                    annotations: annotations,
                    div: this.layerElement.current,
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    page: page,
                    renderForms: renderForms,
                    viewport: viewport
                };
                this.layerElement.current.innerHTML = '';
                try {
                    $qziBq.AnnotationLayer.render(parameters);
                    this.onRenderSuccess();
                } catch (error) {
                    this.onRenderError(error);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", {
                    className: "react-pdf__Page__annotations annotationLayer",
                    ref: this.layerElement
                }, this.renderAnnotationLayer());
            }
        }
    ]);
    return AnnotationLayerInternal;
}((0, $bNh2M.PureComponent));
$1fa15a99e71d407b$export$46f5ffc431ae68b7.propTypes = {
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    linkService: (0, $33a7a8f1dcd1ab06$export$836c1083c8eb7ae).isRequired,
    onGetAnnotationsError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onGetAnnotationsSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderAnnotationLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderAnnotationLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    page: (0, $33a7a8f1dcd1ab06$export$61d82a1ff85c609a),
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number
};
var $1fa15a99e71d407b$var$AnnotationLayer = function AnnotationLayer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1a4ab613792e98ce$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Consumer, null, function(pageContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($1fa15a99e71d407b$export$46f5ffc431ae68b7, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({}, documentContext, pageContext, props));
        });
    });
};
var $1fa15a99e71d407b$export$2e2bcd8739ae039 = $1fa15a99e71d407b$var$AnnotationLayer;




function $531052e8ad851b0a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $531052e8ad851b0a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $531052e8ad851b0a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $17e8bb57d3456022$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $531052e8ad851b0a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $531052e8ad851b0a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $531052e8ad851b0a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eb26d965eb508e2d$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c7607d75fb28fe56$export$2e2bcd8739ae039)(this, result);
    };
}
function $531052e8ad851b0a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $531052e8ad851b0a$var$defaultScale = 1;
var $531052e8ad851b0a$export$1cc9850f801e298 = /*#__PURE__*/ function(_PureComponent) {
    (0, $7bfabe36ee4b3c15$export$2e2bcd8739ae039)(PageInternal, _PureComponent);
    var _super = $531052e8ad851b0a$var$_createSuper(PageInternal);
    function PageInternal() {
        var _this;
        (0, $89e30e790d3b5e50$export$2e2bcd8739ae039)(this, PageInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "state", {
            page: null
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "pageElement", /*#__PURE__*/ (0, $bNh2M.createRef)());
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var _this$props = _this.props, onLoadSuccess = _this$props.onLoadSuccess, registerPage = _this$props.registerPage;
            var page = _this.state.page;
            if (onLoadSuccess) onLoadSuccess((0, $c011d1ac6c054972$export$8cc3f6b8d58bdda0)(page, _this.scale));
            if (registerPage) registerPage(_this.pageIndex, _this.pageElement.current);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                page: false
            });
            (0, $b67effd2ccb1c8a9$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $17e8bb57d3456022$export$2e2bcd8739ae039)((0, $8a40e79f7a8d30eb$export$2e2bcd8739ae039)(_this), "loadPage", function() {
            var pdf = _this.props.pdf;
            var pageNumber = _this.getPageNumber();
            if (!pageNumber) return;
            _this.setState(function(prevState) {
                if (!prevState.page) return null;
                return {
                    page: null
                };
            });
            var cancellable = (0, $58dbe27b41a9bd8a$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
            _this.runningTask = cancellable;
            cancellable.promise.then(function(page) {
                _this.setState({
                    page: page
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        return _this;
    }
    (0, $4f3b5cf5a29275c7$export$2e2bcd8739ae039)(PageInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $614ec1ce3517453a$export$2e2bcd8739ae039)(pdf, 'Attempted to load a page, but no document was specified.');
                this.loadPage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf || this.getPageNumber() !== this.getPageNumber(prevProps)) {
                    var unregisterPage = this.props.unregisterPage;
                    if (unregisterPage) unregisterPage(this.getPageIndex(prevProps));
                    this.loadPage();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var unregisterPage = this.props.unregisterPage;
                if (unregisterPage) unregisterPage(this.pageIndex);
                (0, $c011d1ac6c054972$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                var page = this.state.page;
                if (!page) return {};
                var _this$props2 = this.props, canvasBackground = _this$props2.canvasBackground, customTextRenderer = _this$props2.customTextRenderer, onGetAnnotationsError = _this$props2.onGetAnnotationsError, onGetAnnotationsSuccess = _this$props2.onGetAnnotationsSuccess, onGetTextError = _this$props2.onGetTextError, onGetTextSuccess = _this$props2.onGetTextSuccess, onRenderAnnotationLayerError = _this$props2.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccess = _this$props2.onRenderAnnotationLayerSuccess, onRenderError = _this$props2.onRenderError, onRenderSuccess = _this$props2.onRenderSuccess, renderForms = _this$props2.renderForms, renderInteractiveForms = _this$props2.renderInteractiveForms;
                return {
                    canvasBackground: canvasBackground,
                    customTextRenderer: customTextRenderer,
                    onGetAnnotationsError: onGetAnnotationsError,
                    onGetAnnotationsSuccess: onGetAnnotationsSuccess,
                    onGetTextError: onGetTextError,
                    onGetTextSuccess: onGetTextSuccess,
                    onRenderAnnotationLayerError: onRenderAnnotationLayerError,
                    onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccess,
                    onRenderError: onRenderError,
                    onRenderSuccess: onRenderSuccess,
                    page: page,
                    renderForms: renderForms !== null && renderForms !== void 0 ? renderForms : renderInteractiveForms,
                    // For backward compatibility
                    rotate: this.rotate,
                    scale: this.scale
                };
            }
        },
        {
            key: "getPageIndex",
            value: function getPageIndex() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $c011d1ac6c054972$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber - 1;
                if ((0, $c011d1ac6c054972$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex;
                return null;
            }
        },
        {
            key: "getPageNumber",
            value: function getPageNumber() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $c011d1ac6c054972$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber;
                if ((0, $c011d1ac6c054972$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex + 1;
                return null;
            }
        },
        {
            key: "pageIndex",
            get: function get() {
                return this.getPageIndex();
            }
        },
        {
            key: "pageNumber",
            get: function get() {
                return this.getPageNumber();
            }
        },
        {
            key: "rotate",
            get: function get() {
                var rotate = this.props.rotate;
                if ((0, $c011d1ac6c054972$export$ef8866826b0b1f6d)(rotate)) return rotate;
                var page = this.state.page;
                if (!page) return null;
                return page.rotate;
            }
        },
        {
            key: "scale",
            get: function get() {
                var page = this.state.page;
                if (!page) return null;
                var _this$props3 = this.props, scale = _this$props3.scale, width = _this$props3.width, height = _this$props3.height;
                var rotate = this.rotate; // Be default, we'll render page at 100% * scale width.
                var pageScale = 1; // Passing scale explicitly null would cause the page not to render
                var scaleWithDefault = scale === null ? $531052e8ad851b0a$var$defaultScale : scale; // If width/height is defined, calculate the scale of the page so it could be of desired width.
                if (width || height) {
                    var viewport = page.getViewport({
                        scale: 1,
                        rotation: rotate
                    });
                    pageScale = width ? width / viewport.width : height / viewport.height;
                }
                return scaleWithDefault * pageScale;
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $3550c241e53866c3$export$2e2bcd8739ae039)(this.props, function() {
                    var page = _this2.state.page;
                    if (!page) return page;
                    return (0, $c011d1ac6c054972$export$8cc3f6b8d58bdda0)(page, _this2.scale);
                });
            }
        },
        {
            key: "pageKey",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "@").concat(this.scale, "/").concat(this.rotate);
            }
        },
        {
            key: "pageKeyNoScale",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "/").concat(this.rotate);
            }
        },
        {
            key: "renderMainLayer",
            value: function renderMainLayer() {
                var _this$props4 = this.props, canvasRef = _this$props4.canvasRef, renderMode = _this$props4.renderMode;
                switch(renderMode){
                    case 'none':
                        return null;
                    case 'svg':
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $6d86bf07c2d24055$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKeyNoScale, "_svg")
                        });
                    case 'canvas':
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5148ceea765e4437$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKey, "_canvas"),
                            canvasRef: canvasRef
                        });
                }
            }
        },
        {
            key: "renderTextLayer",
            value: function renderTextLayer() {
                var renderTextLayer = this.props.renderTextLayer;
                if (!renderTextLayer) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $2c1402934497d128$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_text")
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var renderAnnotationLayer = this.props.renderAnnotationLayer;
                if (!renderAnnotationLayer) return null;
                /**
       * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
       * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1fa15a99e71d407b$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_annotations")
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $5fbf441c69a32c45$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderMainLayer(), this.renderTextLayer(), this.renderAnnotationLayer(), children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var pageNumber = this.pageNumber;
                var pdf = this.props.pdf;
                var page = this.state.page;
                if (!pageNumber) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === 'function' ? noData() : noData);
                }
                if (pdf === null || page === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === 'function' ? loading() : loading);
                }
                if (pdf === false || page === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $3f0b0ba53733c98e$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === 'function' ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var pageNumber = this.pageNumber;
                var _this$props5 = this.props, className = _this$props5.className, inputRef = _this$props5.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement("div", (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
                    className: (0, $51744a8712f12a52$export$2e2bcd8739ae039)('react-pdf__Page', className),
                    "data-page-number": pageNumber,
                    ref: (0, $74b4b5036e7f6585$export$2e2bcd8739ae039)(inputRef, this.pageElement),
                    style: {
                        position: 'relative'
                    }
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return PageInternal;
}((0, $bNh2M.PureComponent));
$531052e8ad851b0a$export$1cc9850f801e298.defaultProps = {
    error: 'Failed to load the page.',
    loading: "Loading page\u2026",
    noData: 'No page specified.',
    renderAnnotationLayer: true,
    renderForms: false,
    renderMode: 'canvas',
    renderTextLayer: true,
    scale: $531052e8ad851b0a$var$defaultScale
};
var $531052e8ad851b0a$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).node
]);
$531052e8ad851b0a$export$1cc9850f801e298.propTypes = $531052e8ad851b0a$var$_objectSpread($531052e8ad851b0a$var$_objectSpread({}, (0, $33a7a8f1dcd1ab06$export$1e08905474334888)), {}, {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).node,
    className: (0, $33a7a8f1dcd1ab06$export$d53f3db2f43345df),
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    error: $531052e8ad851b0a$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).string,
    inputRef: (0, $33a7a8f1dcd1ab06$export$4f9f5282de18fc69),
    loading: $531052e8ad851b0a$var$isFunctionOrNode,
    noData: $531052e8ad851b0a$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    pageIndex: (0, $33a7a8f1dcd1ab06$export$7b4c8bd6e6871332),
    pageNumber: (0, $33a7a8f1dcd1ab06$export$973e710208ddd50f),
    pdf: (0, $33a7a8f1dcd1ab06$export$d22001c6ab8dd37),
    registerPage: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    renderInteractiveForms: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    // For backward compatibility
    renderMode: (0, $33a7a8f1dcd1ab06$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).bool,
    rotate: (0, $33a7a8f1dcd1ab06$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number,
    unregisterPage: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($0e351cebb744ffa1$exports))).number
});
function $531052e8ad851b0a$var$Page(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement((0, $1a4ab613792e98ce$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).createElement($531052e8ad851b0a$export$1cc9850f801e298, (0, $87b921892ab8024b$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $531052e8ad851b0a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bNh2M))).forwardRef($531052e8ad851b0a$var$Page);



(0, $c011d1ac6c054972$export$e7ec4a9e2d586a77)();
$qziBq.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';


var $qziBq = parcelRequire("qziBq");


var $5a5901031fc0aa3f$exports = {};
$5a5901031fc0aa3f$exports = import.meta.resolve("9f1Dk");


const $c3d6eb2ba4a9dc4b$var$workerSrc = new URL($5a5901031fc0aa3f$exports);
if (typeof window !== "undefined" && "Worker" in window) {
    (0, $qziBq).GlobalWorkerOptions.workerPort = new Worker($c3d6eb2ba4a9dc4b$var$workerSrc);
    (0, $qziBq).GlobalWorkerOptions.workerSrc = $c3d6eb2ba4a9dc4b$var$workerSrc.toString();
}
const $c3d6eb2ba4a9dc4b$export$d46c104bc6d5cb7e = /*#__PURE__*/ $bNh2M.memo(({ pages: pages, file: file, onLoadSuccess: onLoadSuccess })=>{
    console.log("rerender");
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $d0db2cfd1e2a88ee$export$2e2bcd8739ae039), {
        file: file,
        onLoadSuccess: onLoadSuccess,
        renderMode: "svg",
        children: pages.map((i)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($c3d6eb2ba4a9dc4b$var$PageStyled, {
                pageNumber: i
            }, i))
    });
});
const $c3d6eb2ba4a9dc4b$var$PageStyled = (props)=>{
    const setPreserveAspRatio = ()=>{
        for (const e of document.querySelectorAll('svg[preserveAspectRatio="none"]'))e.removeAttribute("preserveAspectRatio");
    };
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $531052e8ad851b0a$export$2e2bcd8739ae039), {
        ...props,
        onRenderSuccess: setPreserveAspRatio
    });
};
function $c3d6eb2ba4a9dc4b$export$20f068c391cfd4f5(tuneId) {
    const file = $c3d6eb2ba4a9dc4b$var$useTuneContent(tuneId);
    const { numPages: numPages, completed: completed, onLoadSuccess: onLoadSuccess } = $c3d6eb2ba4a9dc4b$var$useLoadingState(tuneId);
    const pages = $c3d6eb2ba4a9dc4b$var$usePageIndices(numPages);
    return {
        file: file,
        pages: pages,
        completed: completed,
        onLoadSuccess: onLoadSuccess
    };
}
function $c3d6eb2ba4a9dc4b$var$useTuneContent(tuneId) {
    const [file, setFile] = (0, $bNh2M.useState)(null);
    (0, $bNh2M.useEffect)(()=>{
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>{
            const data = await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).getTuneContent(tuneId);
            setFile({
                data: data
            });
        });
    }, [
        tuneId
    ]);
    return file;
}
function $c3d6eb2ba4a9dc4b$var$useLoadingState(tuneId) {
    const [numPages, setNumPages] = (0, $bNh2M.useState)(0);
    const [completed, setCompleted] = (0, $bNh2M.useState)(false);
    const _onLoadSuccess = ({ numPages: numPages })=>{
        setCompleted(true);
        setNumPages(numPages);
    };
    const onLoadSuccess = $bNh2M.useCallback(_onLoadSuccess, [
        tuneId
    ]);
    return {
        numPages: numPages,
        completed: completed,
        onLoadSuccess: onLoadSuccess
    };
}
function $c3d6eb2ba4a9dc4b$var$usePageIndices(num) {
    return $bNh2M.useMemo(()=>{
        function* range() {
            for(let i = 0; i < num; i++)yield i + 1;
        }
        return Array.from(range());
    }, [
        num
    ]);
}


function $662c74501d18249e$var$useWakeLock() {
    const lockRef = (0, $bNh2M.useRef)();
    const { search: search } = (0, $e6c15aaa44b364a9$export$45d76561a5302f2b)();
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    (0, $bNh2M.useEffect)(()=>{
        const score = q.get("score");
        if (score && !lockRef.current) {
            if ("wakeLock" in window.navigator) navigator.wakeLock.request("screen").then((wl)=>{
                console.log("locked");
                lockRef.current = wl;
            });
        }
        if (!score && lockRef.current) {
            console.log("unlocked");
            lockRef.current.release();
            lockRef.current = undefined;
        }
    }, [
        search
    ]);
}
const $662c74501d18249e$export$1f8210a5093264da = ()=>{
    $662c74501d18249e$var$useWakeLock();
    const msg = (0, $6796445aad86e7f6$export$2f3033f727989e7b)();
    const [q] = (0, $75a321daa887b448$export$ae316f0eeb712a36)();
    const scores = (0, $6796445aad86e7f6$export$50b8ce1ec962c68)();
    const isScoreShown = (id)=>q.get("score") === id;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "scores_container",
        hidden: !q.has("score"),
        children: [
            scores.map((tune)=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($662c74501d18249e$var$Score, {
                    tuneId: tune.id,
                    shown: isScoreShown(tune.id)
                }, tune.id)),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($662c74501d18249e$var$PopupMessage, {
                msg: msg
            })
        ]
    });
};
const $662c74501d18249e$var$PopupMessage = ({ msg: msg })=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "popup_message",
        hidden: !msg,
        children: msg
    });
const $662c74501d18249e$var$LoadingSpinnerWrapper = ({ hidden: hidden })=>/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        className: "score_loading_spinner_wrapper",
        hidden: hidden,
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $a1f8b91022129636$export$b08b517936747730), {})
    });
const $662c74501d18249e$var$Score = ({ tuneId: tuneId, shown: shown })=>{
    const socreLoader = (0, $c3d6eb2ba4a9dc4b$export$20f068c391cfd4f5)(tuneId);
    const { completed: completed, file: file } = socreLoader;
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)($662c74501d18249e$var$Swipeable, {
        className: "score",
        hidden: !shown,
        tuneId: tuneId,
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($662c74501d18249e$var$LoadingSpinnerWrapper, {
                hidden: completed
            }),
            file && /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $c3d6eb2ba4a9dc4b$export$d46c104bc6d5cb7e), {
                ...socreLoader
            })
        ]
    });
};
const $662c74501d18249e$var$Swipeable = ({ children: children, tuneId: tuneId, ...props })=>{
    const [start, setStart] = (0, $bNh2M.useState)([
        0,
        0
    ]);
    const [lock, setLock] = (0, $bNh2M.useState)(false);
    const setOpen = (0, $7c9b300c545ed81c$exports.useSetAtom)((0, $7836dfa820e1557f$export$50da548b44c73afa));
    const openNextScore = (0, $6796445aad86e7f6$export$6de0c80529fc50e7)();
    const touchStart = (e)=>{
        setOpen(false);
        setStart((0, $edf605dddde973f1$export$8178d2b67ce25c0b)(e.touches[0]));
    };
    const handleOverSwipe = (0, $94b0beff4e6be51d$export$8b7b9481d6186f21)((e)=>{
        if (lock) return;
        if (!(e.target instanceof Element)) return;
        const [dx, dy] = (0, $edf605dddde973f1$export$a37e3c603d7117e5)((0, $edf605dddde973f1$export$8178d2b67ce25c0b)(e.touches[0]), start);
        const nearVertical = Math.abs(dx / (dy + 0.01)) < 1.0;
        let ward;
        if (dy > 40 && nearVertical) ward = "backward";
        else if (dy < -40 && nearVertical) ward = "forward";
        else return;
        setLock(true);
        e.stopPropagation();
        openNextScore(tuneId, ward);
    }, 100);
    const releaseLock = (e)=>{
        e.preventDefault();
        setLock(false);
    };
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        onTouchStart: touchStart,
        onTouchMove: handleOverSwipe,
        onTouchEnd: releaseLock,
        onTouchCancel: releaseLock,
        ...props,
        children: children
    });
}; // async function setRenderingHook(this: Tune, elem: Element) {
 //   elem.addEventListener("touchstart", touchStart);
 //   elem.addEventListener("touchmove", throttled(handleOverSwipe, 100));
 //   elem.addEventListener("touchend", releaseLock);
 //   elem.addEventListener("touchcancel", releaseLock);
 //   loadingManager.setLoading(this, "on");
 //   const renderingProcess = scoreManager.getRenderingProcess(this);
 //   for (const page of await renderingProcess.graphics) {
 //     elem.appendChild(await page);
 //   }
 //   loadingManager.setLoading(this, "off");
 // }






function $5ee0a5b2031a1bf8$var$useSavedAlbumName() {
    const currentAlbumId = (0, $75a321daa887b448$export$8a39e334f881b685)();
    const [name, setName] = (0, $bNh2M.useState)("");
    (0, $bNh2M.useEffect)(()=>{
        (0, $e718d0a2e2d09f3a$export$889ea624f2cb2c57)(async ()=>{
            const nameGot = await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).getEntityName(currentAlbumId);
            setName(nameGot);
            if (await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).albumExists({
                id: currentAlbumId
            })) await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).renameAlbum(currentAlbumId, nameGot);
            else await (0, $01d6f1e7a7e9eaad$export$d20ece2d152515e7).addAlbum(new (0, $3fbb877a61794509$export$2ee11c425a1bd6c1)(nameGot, currentAlbumId));
        });
    }, [
        currentAlbumId
    ]);
    return name;
}
const $5ee0a5b2031a1bf8$export$fa32cd27347e212e = ()=>{
    const name = $5ee0a5b2031a1bf8$var$useSavedAlbumName();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
        id: "mainview",
        children: [
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $f9586f0c173f29a3$export$f97dc4a5a0177256), {
                albumName: name
            }),
            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
                id: "main_contents",
                children: [
                    /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $fcc251bdfe5da48d$export$d69d36eb8a280525), {}),
                    /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $662c74501d18249e$export$1f8210a5093264da), {})
                ]
            })
        ]
    });
};



const $5f03fad966a53b96$var$ContextWrap = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $047030d75d5c8297$export$ff34e5addbd1eccb), {
        children: children
    });
};
function $5f03fad966a53b96$var$AlbumRedirect() {
    const { aid: aid } = (0, $e6c15aaa44b364a9$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$444b3ab0cb9aec40), {
        to: `/view?album=${aid}`,
        replace: true
    });
}
function $5f03fad966a53b96$var$AlbumTuneRedirect() {
    const { aid: aid, tud: tud } = (0, $e6c15aaa44b364a9$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$444b3ab0cb9aec40), {
        to: `/view?album=${aid}&tune=${tud}`,
        replace: true
    });
}
const $5f03fad966a53b96$var$AppContents = ()=>{
    (0, $4a4a78dd066e5c5d$export$9aca36bb09e5ede9)();
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$9ba4e89fdfa1fc54), {
        basename: "/app",
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)((0, $e6c15aaa44b364a9$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$e7b0ac011bb776c6), {
                    path: "/albums/:aid/tunes/:tud",
                    element: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($5f03fad966a53b96$var$AlbumTuneRedirect, {})
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$e7b0ac011bb776c6), {
                    path: "/albums/:aid",
                    element: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($5f03fad966a53b96$var$AlbumRedirect, {})
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$e7b0ac011bb776c6), {
                    path: "/view/*",
                    element: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $5ee0a5b2031a1bf8$export$fa32cd27347e212e), {})
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $3ad783fe7d4f9484$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsxs)("div", {
                        children: [
                            "Not Found.",
                            /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)((0, $e6c15aaa44b364a9$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Return to Home"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $5f03fad966a53b96$var$App = ()=>{
    return /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($5f03fad966a53b96$var$ContextWrap, {
            children: /*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($5f03fad966a53b96$var$AppContents, {})
        })
    });
};
const $5f03fad966a53b96$var$root = document.getElementById("app_root");
if ($5f03fad966a53b96$var$root) (0, $fe0364397da30eaa$export$882461b6382ed46c)($5f03fad966a53b96$var$root).render(/*#__PURE__*/ (0, $ce6a5d94e0bda3fb$exports.jsx)($5f03fad966a53b96$var$App, {}));



var $a93b7b07766ffe0c$exports = {};
$a93b7b07766ffe0c$exports = import.meta.resolve("cPKfz");


// window.checkAuth, window.checkGis を、html の onLoad 等から直に呼び出したいので必要な初期化をする
if ("serviceWorker" in navigator) navigator.serviceWorker.register($a93b7b07766ffe0c$exports);


//# sourceMappingURL=web.883d1e31.js.map
